// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
import { ptModuleTips } from './pt-extras.js';
export const pt = {
    login: {
        title: '[[TOK_0]] ConformidadeUm',
        subtitle: 'Inicie sessão na sua conta',
        email: 'E-mail',
        password: 'Palavra-passe',
        sign_in: 'Iniciar sessão',
        signing_in: 'A iniciar sessão...',
        mfa_code: 'Código MFA',
        mfa_placeholder: 'Introduza o código de 6 dígitos',
        mfa_instruction: 'Introduza o código de 6 dígitos da sua aplicação de autenticação.',
        verify: 'Verificar',
        verifying: 'A verificar...',
        forgot_password: 'Esqueceu a palavra-passe?',
        account_locked: 'A conta está bloqueada. Tente novamente mais tarde.',
        account_deactivated: 'A conta foi desativada. Contacte o seu administrador.',
        invalid_mfa: 'Código MFA inválido. Tente novamente.',
        invalid_credentials: 'E-mail ou palavra-passe inválidos.',
        login_failed: 'Falha no início de sessão',
        session_expired: 'A sua sessão expirou. Recarregue a página e tente novamente.',
    },
    auth: {
        forgot_password: {
            title: 'Esqueceu a Palavra-passe',
            subtitle: 'Introduza o seu endereço de e-mail e enviaremos uma ligação para repor a sua palavra-passe.',
            send: 'Enviar Ligação de Reposição',
            sending: 'A enviar...',
            success: 'Se esse e-mail existir, foi enviada uma ligação para reposição da palavra-passe.',
            back_to_login: 'Voltar ao Início de Sessão',
        },
        reset_password: {
            title: 'Repor Palavra-passe',
            subtitle: 'Introduza a sua nova palavra-passe abaixo.',
            new_password: 'Nova Palavra-passe',
            confirm_password: 'Confirmar Palavra-passe',
            reset: 'Repor Palavra-passe',
            resetting: 'A repor...',
            success: 'A sua palavra-passe foi reposta com sucesso.',
            go_to_login: 'Ir para o Início de Sessão',
            password_mismatch: 'As palavras-passe não coincidem.',
            invalid_token: 'Token de reposição inválido ou em falta. Solicite uma nova ligação de reposição de palavra-passe.',
            requirements_title: 'Requisitos da palavra-passe:',
            password_requirements: 'A palavra-passe deve cumprir os seguintes requisitos:',
            rules: {
                min_length: 'Pelo menos 12 caracteres',
                uppercase: 'Pelo menos uma letra maiúscula',
                lowercase: 'Pelo menos uma letra minúscula',
                digit: 'Pelo menos um dígito',
                special: 'Pelo menos um carácter especial',
            },
        },
        verify_email: {
            title: 'Verificação de E-mail',
            verifying: 'A verificar o seu endereço de e-mail...',
            success: 'O seu e-mail foi verificado com sucesso.',
            invalid_token: 'Token de verificação inválido ou em falta.',
            failed: 'A verificação de e-mail falhou. O token pode ser inválido ou ter expirado.',
            go_to_login: 'Ir para o Início de Sessão',
        },
        offline: {
            title: 'Está sem ligação',
            message: 'Parece que perdeu a ligação à Internet. Verifique a sua rede e tente novamente.',
        },
    },
    intake: {
        title: 'Pedido de Exercício de Direitos',
        subtitle: 'Submeta um pedido de exercício de direitos à nossa organização',
        fields: {
            full_name: 'Nome Completo',
            email: 'Endereço de Correio Eletrónico',
            phone: 'Número de Telefone (opcional)',
            request_type: 'Tipo de Pedido',
            description: 'Descreva o Seu Pedido',
            preferred_language: 'Idioma Preferido',
            consent: 'Dou o meu consentimento para o tratamento deste pedido',
        },
        submit: 'Submeter Pedido',
        validation: {
            name_required: 'O nome completo é obrigatório',
            email_required: 'É necessário um endereço de correio eletrónico válido',
            type_required: 'Por favor selecione um tipo de pedido',
            description_required: 'Por favor descreva o seu pedido',
            consent_required: 'Deve consentir o tratamento para continuar',
        },
        error_title: 'Erro',
        config_load_error: 'Não foi possível carregar a configuração. Por favor, verifique o URL.',
        organization_label: 'Organização',
        customer_reference: 'Número de referência do cliente',
        country: 'País / Jurisdição',
        preferred_channel: 'Canal de resposta preferido',
        channels: {
            email: 'E-mail',
            postal: 'Correio',
            phone: 'Telefone',
            portal: 'Portal',
        },
        confirmation: {
            title: 'Pedido Recebido',
            message: 'O seu pedido foi registado com sucesso. O seu número de referência é:',
            next_steps: 'Iremos tratar o seu pedido com a maior brevidade possível, em conformidade com a legislação aplicável. O prazo previsto de tratamento é de 30 dias úteis.',
        },
    },
    request_types: {
        access: 'Acesso (DSAR)',
        deletion: 'Apagamento',
        correction: 'Retificação / Atualização',
        objection: 'Oposição',
        portability: 'Portabilidade dos Dados',
        restriction: 'Limitação do Tratamento',
        consent_withdrawal: 'Retirada do consentimento',
    },
    statuses: {
        new: 'Novo',
        in_review: 'Em Análise',
        waiting_on_requester: 'A Aguardar Resposta do Requerente',
        waiting_on_internal_data: 'A Aguardar Dados Internos',
        approved: 'Aprovado',
        closed: 'Encerrado',
        rejected: 'Rejeitado',
    },
    admin: {
        nav: {
            rights_requests: 'Pedidos de Direitos',
            templates: 'Modelos',
            response_templates: 'Modelos de Resposta',
            data_mapping: 'Registo de Atividades de Tratamento',
            governance: 'Governação',
            consent: 'Consentimento',
            assessments: 'Avaliações',
            classification: 'Classificação',
            monitoring: 'Monitorização',
            incidents: 'Incidentes',
            onboarding: 'Integração',
            connectors: 'Conectores',
            vendor_risk: 'Risco de Fornecedores',
            deletion_orchestration: 'Orquestração de Apagamento',
            discovery: 'Descoberta de Dados',
            incident_ops: 'Operações de Incidentes',
            program_governance: 'Governação de Programa',
            access_accountability: 'Responsabilização de Acessos',
            consent_properties: 'Propriedades de Consentimento',
            localization: 'Localização',
            partner_workspace: 'Espaço de Parceiros',
            audit_trail: 'Trilho de Auditoria',
            forseti: 'Forseti',
            settings: 'Definições',
            help_center: 'Centro de Ajuda',
            dashboard: 'Painel de Controlo',
            platform: 'Plataforma',
            integrations: 'Integrações',
            cmp_dsar_sync: 'Sincronização CMP DSAR',
            cmp_integration: 'Integração CMP',
            purpose_mapping: 'Mapeamento de Finalidades',
            webhook_config: 'Configuração de Webhooks',
            bulk_sync: 'Sincronização em Massa',
            privacy_scanner: 'Analisador de Privacidade',
            privacy_monitoring: 'Monitorização de Privacidade',
            real_time_scanner: 'Analisador em Tempo Real',
            compliance_forms: 'Formulários de Conformidade',
            forms_dashboard: 'Painel de Formulários',
            form_templates: 'Modelos',
            form_catalog: 'Catálogo de Formulários',
            pack_catalog: 'Catálogo de Pacotes',
            org_groups: 'Grupos de Organizações',
            consolidation: 'Consolidação',
            organizations: 'Organizações',
            org_list: 'Todas as organizações',
            intake_configs: 'Configurações de entrada',
            task_management: 'Gestão de tarefas',
            unified_audit: 'Auditoria Unificada',
            evidence_packs: 'Pacotes de Evidência',
            audit_periods: 'Períodos de Auditoria',
            regulatory_updates: 'Atualizações Regulatórias',
            departments: 'Departamentos',
        },
        sidebar_category_data_privacy_rights: 'Privacidade de Dados & Direitos',
        sidebar_category_vendor_third_party: 'Gestão de Fornecedores & Terceiros',
        sidebar_category_risk_assessment: 'Risco & Avaliação',
        sidebar_category_operations_automation: 'Operações & Automatização',
        sidebar_category_task_workflow: 'Gestão de Tarefas & Fluxo de Trabalho',
        sidebar_groups: {
            consent_cmp_webhooks: 'CMP e Webhooks',
            data_mapping_ropa: 'Registo de atividades',
            data_mapping_classification: 'Classificação',
            data_mapping_governance: 'Governação',
            access_live_monitoring: 'Monitorização em tempo real',
            access_reviews_investigations: 'Revisões e Investigações',
            access_evidence_policies: 'Evidências e Políticas',
            classification_taxonomies: 'Taxonomias e Etiquetas',
            classification_workflow: 'Fluxo de trabalho',
            classification_insights: 'Análises',
            connectors_runtime: 'Tempo de execução',
            connectors_due_diligence: 'Diligência devida',
            connectors_coverage: 'Cobertura',
            cp_definitions: 'Definições',
            cp_lifecycle: 'Ciclo de vida',
            cp_quality: 'Qualidade e Evidências',
            deletion_execution: 'Execução',
            deletion_vendors: 'Fornecedores',
            deletion_evidence: 'Evidências e Integração',
            discovery_rules: 'Regras e Modelos',
            discovery_scanning: 'Análise',
            discovery_review: 'Fluxo de revisão',
            discovery_insights: 'Análises',
            governance_oversight: 'Supervisão',
            governance_reporting: 'Relatórios',
            governance_vendors: 'Fornecedores e Transferências internacionais',
            governance_lifecycle: 'Ciclo de vida',
            incident_ops_dashboards: 'Painéis',
            incident_ops_sla: 'Configuração de SLA',
            incident_ops_playbooks: 'Manuais',
            incident_ops_vendor_regulator: 'Fornecedor e Autoridade',
            incident_ops_evidence: 'Evidências e Revisão',
            incidents_workload: 'Carga de trabalho',
            incidents_regulatory: 'Regulatório',
            incidents_reporting: 'Relatórios',
            localization_content: 'Conteúdo',
            localization_regulatory: 'Regulatório',
            localization_observability: 'Observabilidade',
            monitoring_metrics: 'Métricas',
            monitoring_programs: 'Programas',
            monitoring_tasks: 'Tarefas',
            monitoring_controls: 'Controlos',
            org_entities: 'Entidades',
            org_config: 'Configuração',
            org_frameworks: 'Referenciais e Consolidação',
            partner_overview: 'Visão geral',
            partner_partners: 'Parceiros',
            partner_delivery: 'Entrega',
            partner_support: 'Suporte',
            platform_identity: 'Identidade e Funções',
            platform_access_control: 'Controlo de acesso',
            platform_auth_session: 'Autenticação e Sessão',
            platform_access_reviews: 'Revisões de acesso',
            platform_files: 'Ficheiros',
            platform_notifications: 'Notificações',
            platform_module_config: 'Configuração de módulos',
            platform_ops: 'Operações e Registos',
            pg_health: 'Estado do programa',
            pg_maturity: 'Maturidade',
            pg_audit: 'Auditoria e Evidências',
            pg_obligations: 'Obrigações',
            pg_documents: 'Documentos',
            vr_overview: 'Visão geral',
            vr_onboarding: 'Integração',
            vr_assessment: 'Avaliação',
            vr_oversight: 'Supervisão',
        },
        tickets: {
            title: 'Pedidos de direitos',
            create: 'Adicionar pedido',
            filters: 'Filtros',
            search_placeholder: 'Search tickets...',
            export_csv: 'Exportar [[TOK_0]]',
            exporting: 'Exportando...',
            bulk_export_failed: 'Falha na exportação em massa',
            bulk_export: {
                label: 'Exportar',
                format: {
                    pdf: '[[TOK_0]] Resumo',
                    zip: 'ZIP (pacotes de evidências por caso)',
                    csv: '[[TOK_0]]',
                },
                warning_over_50: 'Isso gerará aproximadamente [[TOK_1]] pacotes de casos - pode levar vários minutos. Continuar?',
                blocked_over_500: 'Limite o filtro para 500 casos ou menos antes de exportar ZIP (atual: [[TOK_1]]).',
                success: 'Exportação em massa salva no navegador de arquivos ([[TOK_1]] casos)',
                failed: 'Falha na exportação em massa',
                continue: 'Continuar',
                cancel: 'Cancelar',
            },
            no_results: 'Nenhum requests encontrado',
            ticket_id: 'ID do ticket',
            request_type: 'Pedido Tipo',
            requester: 'Requerente',
            source: 'Fonte',
            all_sources: 'Todas as fontes',
            assigned_to: 'Atribuído Para',
            created: 'Criado',
            load_error: 'Falha ao load cases. Por favor, tente novamente.',
            case_creation_failed: 'Falha ao criar caso',
            business_unit: 'Unidade de negócio',
            reference: 'Referência',
            sla: {
                title: 'Estado SLA',
                on_track: '{days} dias restantes',
                approaching: 'Prazo próximo',
                overdue: '{days} dias em atraso',
                ack_overdue: '{hours}h além do prazo de confirmação',
                ack_warning: 'Confirmação prestes a vencer',
                closed: 'Encerrado',
                completed_in: 'Concluído em {days} dias',
            },
        },
        templates: {
            title: 'Resposta Modelos',
            new: 'Novo modelo',
            edit: 'Editar Modelo',
            all_types: 'Todos os tipos',
            all_locales: 'Todos os idiomas',
            type_access: 'Acesso/DSAR',
            type_deletion: 'Eliminação',
            type_correction: 'Correção',
            type_objection: 'Oposição',
            type_portability: 'Portabilidade',
            type_other: 'Outro',
            type_restriction: 'Restrição',
            type_all: 'All',
            locale_en: 'Inglês',
            locale_vi: 'Vietnamita',
            locale_all: 'Ambos',
            name: 'Nome',
            request_type: 'Pedido Tipo',
            locale: 'Idioma',
            subject: 'Titular',
            body: 'Corpo',
            name_placeholder: 'Nome do modelo...',
            subject_placeholder: 'Assunto do e-mail/carta...',
            body_placeholder: 'Corpo do modelo. Use {[[TOK_5]]}, {[[TOK_6]]}, {[[TOK_7]]}, {[[TOK_8]]}, {[[TOK_9]]} como espaços reservados.',
            available_placeholders: 'Marcadores de posição disponíveis:',
            create_template: 'Adicionar modelo',
            preview: 'Pré-visualização',
            close_preview: 'Fechar pré-visualização',
            default_badge: 'Predefinido',
            no_templates: 'Nenhum templates encontrado',
            confirm_delete: 'Eliminar este template?',
            load_error: 'Falha ao load templates. Por favor, tente novamente.',
            create_error: 'Falha ao create template. Por favor, tente novamente.',
            update_error: 'Falha ao update template. Por favor, tente novamente.',
            delete_error: 'Falha ao delete template. Por favor, tente novamente.',
            preview_error: 'Falha ao preview template. Por favor, tente novamente.',
            response_templates_badge: 'Modelos de Resposta',
            browse_form_templates: 'Explorar Modelos de Formulários de Conformidade',
            templates_loaded: 'Modelos carregados',
            sample_organization: 'Organização de exemplo',
        },
        detail: {
            requester_info: 'Informações do requerente',
            status: 'Estado',
            assignment: 'Atribuição',
            notes: 'Notas',
            audit_trail: 'Trilha de auditoria',
            add_note: 'Adicionar Note',
            case_not_found: 'Caso não encontrado',
            load_error: 'Falha ao load case. Por favor, tente novamente.',
            note_error: 'Falha ao add note. Por favor, tente novamente.',
            submitted_from: 'Enviado de',
            via_cmp: 'através de [[TOK_1]] [[TOK_0]]',
            cmp_ticket: 'Ticket CMP:',
            select_template: 'Selecionar um Modelo',
            direction_inbound: '[[TOK_0]] → GRC',
            direction_outbound: 'GRC → [[TOK_0]]',
            tabs: {
                details: 'Detalhes',
                evidence: 'Evidência',
                communications: 'Comunicações',
                escalations: 'Escalamentos',
                audit_trail: 'Trilha de auditoria',
                fulfillment: 'Cumprimento',
                response: 'Resposta',
                extension: 'Extensão',
            },
            requester: {
                name: 'Nome',
                email: 'E-mail',
                phone: 'Telefone',
                language: 'Idioma',
                source: 'Fonte',
                customer_ref: 'Ref. do cliente',
                country: 'País',
                preferred_channel: 'Canal preferido',
            },
            sla: {
                title: 'SLA',
                on_track: 'Em Rastrear',
                due_soon: 'Prazo próximo',
                overdue: 'Em atraso',
                days_remaining: 'd restantes',
                due_date: 'Data de vencimento',
                breached: 'Violado',
                paused: 'Em pausa',
                total_paused_days: 'Total de dias em pausa',
                days_elapsed: 'Dias decorridos',
                progress: 'Progresso',
            },
            identity: {
                title: 'Identidade Verificação',
                verified: 'Verificado',
                not_verified: 'Não verificado',
                method: 'Método',
                notes: 'Notas',
                verified_by: 'Verificado Por',
                verified_at: 'Verificado Em',
                warning: 'Identidade não yet verificado.',
                verify_button: 'Verificar Identidade',
                select_method: '-- Selecionar --',
                methods: {
                    email_confirmation: 'Confirmação por e-mail',
                    id_document: 'ID Documento',
                    phone_call: 'Chamada telefónica',
                    in_person: 'Presencialmente',
                    other: 'Outro',
                },
            },
            closure: {
                reason: 'Motivo de encerramento',
                summary: 'Resumo de encerramento',
                summary_placeholder: 'Resumo de como o pedido foi resolvido...',
                reason_required: 'O resumo e o motivo de encerramento são obrigatórios',
                response_not_sent: 'Uma resposta formal deve ser enviada ao titular dos dados antes de encerrar este caso',
                reasons: {
                    fulfilled: 'Cumprido',
                    partially_fulfilled: 'Parcialmente cumprido',
                    unfounded: 'Infundado',
                    excessive: 'Excessivo',
                    withdrawn: 'Retirado',
                    duplicate: 'Duplicar',
                    identity_unverified: 'Identidade não verificada',
                },
            },
            export_title: 'Exportar',
            export_pdf: 'Exportar PDF',
            export_zip: 'Exportar ZIP',
            case_file_pdf: 'Exportar [[TOK_0]] (arquivo de caso)',
            evidence_pack_zip: 'Exportar ZIP (pacote de evidências)',
            cross_border_warning: 'Transferência transfronteiriça detectada - é necessário dossiê transfronteiriço',
            breach: {
                flag_btn: 'Sinalizar como causador de violação',
                modal: {
                    title: 'Sinalizar caso como causador de violação',
                    type_label: 'Tipo de violação',
                    type: {
                        misdirected_response: 'Resposta mal direcionada',
                        unauthorised_disclosure: 'Divulgação não autorizada',
                        identity_mismatch: 'Incompatibilidade de identidade',
                        other: 'Outro',
                    },
                    description: 'Descrição (opcional)',
                    description_placeholder: 'O que aconteceu? (máximo de 1000 caracteres)',
                    confirm: 'Sinalizar e iniciar relógio de arquivamento de 72h',
                    cancel: 'Cancelar',
                    flagging: 'Sinalizando...',
                },
                banner: {
                    title: 'Violação sinalizada: [[TOK_1]]',
                    detected_at: 'Detectado em [[TOK_1]]',
                    filing_deadline: '72h [[TOK_2]] prazo de arquivamento: em [[TOK_1]] horas',
                    overdue: 'Prazo de arquivamento de 72h [[TOK_0]]: ATRASADO',
                },
                toasts: {
                    flagged: 'Caso sinalizado como causador de violação - relógio de 72h iniciado',
                    flag_failed: 'Falha ao sinalizar o caso como causador da violação',
                },
            },
            export: {
                generating: 'Gerando... aguarde',
                success: 'Exportação salva no navegador de arquivos',
                failed: 'Falha na exportação - verifique o registro de auditoria',
            },
            no_notes: 'Sem notas ainda',
            assign_placeholder: 'ID do utilizador a atribuir...',
            reassign: 'Reatribuir',
            evidence: {
                checklist_title: 'Lista de verificação de evidências',
                complete_pct: '% concluído',
                no_checklist: 'Sem itens de lista',
                attachments: 'Anexos',
                upload_attachment: 'Carregar anexo',
                upload_button: 'Carregar',
                uploading: 'A carregar...',
                attachment_uploaded: 'Anexo carregado com sucesso',
                upload_error: 'Falha ao carregar anexo',
                category: 'Categoria',
                categories: {
                    identity_proof: 'Prova de identidade',
                    correspondence: 'Correspondência',
                    internal_data: 'Dados internos',
                    legal: 'Jurídico',
                    other: 'Outro',
                },
                no_attachments: 'Sem anexos',
                references_title: 'Referências de evidências',
                no_references: 'Sem referências',
                add_reference: 'Adicionar Reference',
                ref_type: 'Tipo',
                ref_value: 'Valor',
                ref_desc: 'Descrição',
                ref_value_placeholder: 'URL, ID de e-mail ou referência...',
                ref_desc_placeholder: 'Descrição...',
                ref_types: {
                    url: 'URL',
                    email_id: 'E-mail ID',
                    crm_record: 'Registo de CRM',
                    ticket_ref: 'Referência do ticket',
                    other: 'Outro',
                },
            },
            communications: {
                title: 'Comunicações',
                add: 'Adicionar Message',
                no_records: 'Sem comunicações registadas',
                direction: 'Direção',
                channel: 'Canal',
                visibility: 'Visibilidade',
                subject: 'Titular',
                body: 'Corpo',
                send: 'Enviar',
                inbound: 'Entrada',
                outbound: 'Saída',
                internal: 'Interno',
                external: 'Externo',
                tab_all: 'All',
                tab_internal: 'Interno',
                tab_external: 'Externo',
                subject_placeholder: 'Titular (optional)',
                body_placeholder: 'Corpo da mensagem...',
                channels: {
                    email: 'E-mail',
                    portal: 'Portal',
                    phone: 'Telefone',
                    postal: 'Correio postal',
                    in_person: 'Presencialmente',
                },
                apply_template: 'Aplicar Modelo',
                select_template: 'Selecionar modelo...',
                no_templates: 'Nenhum modelo disponível',
                template_applied: 'Modelo aplicado à resposta.',
                template_apply_error: 'Falha ao aplicar modelo.',
            },
            escalations: {
                title: 'Escalamento Histórico',
                no_events: 'Sem eventos de escalada',
                tier: 'Nível',
                threshold: 'Limiar',
                action: 'Ação',
                target: 'Destino',
                triggered_at: 'Acionado em',
            },
            cmp_sync: {
                title: 'Sincronização AesirX CMP',
                sync_status: 'Sincronizar Estado',
                last_synced: 'Último Sincronizado',
                not_synced: 'Não Sincronizado',
                resync: 'Ressincronizar agora',
                syncing: 'A sincronizar...',
                sync_history: 'Sincronizar Histórico (Last 10)',
                direction: 'Direção',
                time: 'Hora',
                retries: 'Novas tentativas',
                error_col: 'Erro',
            },
            audit: {
                filter_event_placeholder: 'Filtrar por tipo de evento...',
                filter_actor_placeholder: 'Filtrar por ator...',
            },
            fulfillment: {
                title: 'Cumprimento departamental',
                assign_departments: 'Atribuir departamentos',
                department: 'Departamento',
                assignee: 'Responsável',
                deadline: 'Prazo',
                evidence_count: 'Evidência',
                signoff: 'Aprovação',
                signed_off: 'Aprovado',
                pending_signoff: 'Pendente',
                start_button: 'Iniciar',
                complete_button: 'Marcar como concluído',
                signoff_button: 'Assinar',
                no_tasks: 'Nenhuma tarefa de cumprimento atribuída ainda.',
                tasks_table: 'Tarefas de cumprimento',
                progress_label: 'Progresso de cumprimento',
                overdue: 'em atraso',
                assigned_success: 'Tarefa de cumprimento departamental atribuída com sucesso.',
                assign_error: 'Falha ao atribuir tarefa de cumprimento.',
                signoff_success: 'Aprovação departamental registada.',
                signoff_error: 'Falha ao registar aprovação.',
                identity_required: 'Identity verification required before fulfillment actions.',
                remove_task: 'Remove Task',
                remove_success: 'Fulfillment task removed successfully.',
                add_evidence_btn: 'Adicionar evidência',
                evidence_uploaded: 'Evidência carregada e ligada',
                evidence_upload_error: 'Falha ao carregar evidência',
                suggest_data_stores: 'Sugerir armazéns de dados',
                suggest_error: 'Falha ao carregar sugestões de armazenamento.',
                suggest_stores_title: 'Armazenamentos de dados sugeridos',
                suggest_stores_none: 'Nenhum armazenamento de dados corresponde a este caso. Configure sistemas no Mapeamento de Dados para melhorar as sugestões.',
                suggest_stores_add: 'Adicionar ao caso',
                suggest_stores_added: 'Armazenamento de dados adicionado ao caso',
                no_departments_title: 'Nenhum departamento configurado',
                no_departments_body: 'Os departamentos permitem encaminhar tarefas de atendimento de DSR para uma função (Privacidade, Jurídico, RH, Operações de TI). Instale departamentos de amostra ou peça ao seu administrador para configurar departamentos nas configurações da organização.',
                no_departments_cta: 'Instalar dados de amostra',
                department_placeholder: 'Nome do departamento...',
                assignee_placeholder: 'ID do utilizador a atribuir...',
                assign_button: 'Atribuir',
                status_pending: 'Pendente',
                status_in_progress: 'Em andamento',
                status_completed: 'Concluído',
                status_verified: 'Verificado',
                confirm_approve: 'Tem certeza de que deseja aprovar esta extensão?',
                confirm_deny: 'Tem certeza de que deseja negar esta extensão?',
            },
            response: {
                title: 'Geração de resposta',
                select_template: 'Modelo de resposta',
                choose_template: 'Selecionar um modelo...',
                generate: 'Gerar resposta',
                preview: 'Pré-visualização da resposta',
                send: 'Enviar resposta',
                delivery_method: {
                    label: 'Método de entrega',
                    email: 'E-mail',
                    portal: 'Portal',
                    postal: 'Correio postal',
                    in_person: 'Pessoalmente',
                },
                recipient: {
                    email: 'E-mail do destinatário',
                    portal: 'ID de usuário do portal',
                    address: 'Endereço postal',
                },
                auto_generate_btn: 'Gerar e enviar resposta',
                auto_generate_success: 'Resposta gerada e entregue',
                auto_generate_missing_recipient: 'Forneça um destinatário antes de enviar.',
                auto_fields: 'Campos preenchidos automaticamente',
                case_id: 'ID do caso',
                requester_name: 'Nome do requerente',
                rights_type: 'Tipo de direito',
                history: 'Respostas enviadas',
                generated_at: 'Gerado',
                confirmation: 'Confirmação',
                sent_label: 'Enviado',
                draft_label: 'Rascunho',
                generated_success: 'Resposta gerada com sucesso.',
                generate_error: 'Falha ao gerar resposta.',
                sent_success: 'Resposta enviada com sucesso.',
                send_error: 'Falha ao enviar resposta.',
                load_error: 'Falha ao carregar modelos de resposta.',
                pdf_title: 'Carta de resposta ao titular dos dados',
                download_pdf: 'Descarregar PDF',
                download_all: 'Descarregar tudo',
                download_error: 'Falha ao descarregar a resposta',
            },
            extension: {
                title: 'Extensões de prazo',
                acknowledgment_deadline: 'Prazo de confirmação',
                fulfillment_deadline: 'Prazo de cumprimento',
                request_extension: 'Solicitar extensão',
                reason: 'Motivo',
                reason_placeholder: 'Motivo para solicitar tempo adicional...',
                additional_days: 'Dias adicionais',
                submit_request: 'Submeter pedido de extensão',
                history: 'Histórico de extensões',
                requested_at: 'Solicitado',
                approve: 'Aprovar',
                deny: 'Rejeitar',
                request_success: 'Pedido de extensão submetido.',
                request_error: 'Falha ao submeter pedido de extensão.',
                approved_success: 'Extensão aprovada.',
                denied_success: 'Extensão rejeitada.',
                decision_error: 'Falha ao processar decisão de extensão.',
                status_pending: 'Pendente',
                status_approved: 'Aprovado',
                status_denied: 'Negado',
                confirm_approve: 'Tem certeza de que deseja aprovar esta solicitação?',
                confirm_deny: 'Tem certeza de que deseja negar esta solicitação?',
                decided_by: 'Decidido por',
            },
        },
        audit: {
            export_csv: 'Exportar CSV',
            exporting: 'A exportar...',
            search_placeholder: 'Pesquisar detalhes de auditoria...',
            filter_by_actor: 'Filtrar por ator...',
            all_event_types: 'Todos Evento Types',
            seq: '#',
            timestamp: 'Marca temporal',
            event: 'Evento',
            case_col: 'Caso',
            actor: 'Ator',
            summary: 'Resumo',
            no_events: 'Nenhum audit events encontrado',
            export_success: 'Trilha de auditoria exportada com sucesso.',
            export_error: 'Falha ao export audit csv. Por favor, tente novamente.',
            load_error: 'Falha ao load audit trail. Por favor, tente novamente.',
            announce_loaded: 'Trilha de auditoria carregada',
            start_date: 'Data de início',
            end_date: 'Data de fim',
            per_page: '{count} / página',
            unknown: 'Desconhecido',
            source_filter: {
                label: 'Fonte',
                all: 'Todos',
                module: 'Módulo',
                forseti: 'Forseti',
                aria_label: 'Filtrar eventos de auditoria por origem',
            },
            event_types: {
                case_created: 'Caso criado',
                status_changed: 'Estado alterado',
                case_assigned: 'Caso atribuído',
                note_added: 'Nota adicionada',
                attachment_added: 'Anexo adicionado',
                attachment_deleted: 'Anexo Eliminado',
                reference_added: 'Referência adicionada',
                checklist_updated: 'Lista de verificação atualizada',
                identity_verified: 'Identidade Verificado',
                closure_summary_added: 'Resumo de encerramento',
                approval_granted: 'Aprovação concedida',
                template_applied: 'Modelo aplicado',
                export_generated: 'Exportação gerada',
                sla_warning: 'SLA Aviso',
                sla_overdue: 'SLA Em atraso',
            },
            unified_audit: {
                title: 'Trilha de Auditoria Unificada',
                module_filter: 'Módulo',
                framework_filter: 'Referencial',
                select_framework: 'Selecionar um referencial...',
                entity_type_filter: 'Tipo de entidade',
                action_filter: 'Ação',
                actor_filter: 'Ator',
                select_actor: 'Selecionar um ator...',
                search_filter: 'Pesquisar',
                search_placeholder: 'Pesquisar eventos de auditoria...',
                filters_heading: 'Filtros',
                date_range: 'Intervalo de datas',
                no_events_found: 'Nenhum evento de auditoria encontrado.',
                event_count: 'Contagem de eventos',
                action: 'Ação',
                actor: 'Ator',
                date_range_start: 'Início do intervalo de datas',
                date_range_end: 'Fim do intervalo de datas',
                filtering_events: 'Filtrando eventos de auditoria',
                framework_codes: 'Códigos de enquadramento',
                entity_type_col: 'Tipo de entidade',
                aria_table: 'Eventos de auditoria unificados',
                page_of: 'Página {page} de {total}',
                entity_types: {
                    user: 'Usuário',
                    case: 'Caso',
                    incident: 'Incidente',
                    assessment: 'Avaliação',
                    vendor: 'Fornecedor',
                    consent: 'Consentimento',
                    policy: 'Política',
                    data_map: 'Mapa de dados',
                },
                actions: {
                    create: 'Criar',
                    update: 'Atualizar',
                    delete: 'Excluir',
                    view: 'Ver',
                    export: 'Exportar',
                    status_change: 'Mudança de status',
                },
            },
            evidence_packs: {
                title: 'Pacotes de Evidência de Auditoria',
                assemble_pack: 'Montar Pacote de Evidência',
                framework: 'Referencial',
                select_framework: 'Selecionar um referencial...',
                framework_code_label: 'Código da estrutura',
                entity_types: 'Tipos de entidade',
                select_entity_types: 'Selecionar tipos de entidade...',
                period: 'Período',
                period_start: 'Início do período',
                period_end: 'Fim do período',
                completeness: 'Completude',
                no_packs_found: 'Nenhum pacote de evidência encontrado.',
                verify: 'Verificar',
                export_pack: 'Exportar',
                exporting: 'A exportar...',
                pack_assembled: 'Pacote de evidências montado',
                pack_exported: 'Pacote de evidências exportado',
                aria_table: 'Pacotes de evidências de auditoria',
                aria_export_pack: 'Exportar pacote',
                export_format: 'Formato de exportação',
                export_in_progress: 'Exportação em andamento...',
                status_draft: 'Rascunho',
                status_assembled: 'Montado',
                status_verified: 'Verificado',
                status_submitted: 'Submetido',
                entity_type_labels: {
                    user: 'Usuário',
                    case: 'Caso',
                    incident: 'Incidente',
                    assessment: 'Avaliação',
                    vendor: 'Fornecedor',
                    consent: 'Consentimento',
                    policy: 'Política',
                    data_map: 'Mapa de dados',
                },
                template_id: 'ID do modelo',
                csv_headers: {
                    module: 'Módulo',
                    action: 'Ação',
                    actor_id: 'Ator',
                    entity_type: 'Tipo de entidade',
                    entity_id: 'ID da entidade',
                    summary: 'Resumo',
                    timestamp: 'Carimbo de data e hora',
                    framework_code: 'Estrutura',
                },
                export_header_framework: 'Pacote de evidências — Enquadramento: {framework}',
                export_header_period: 'Período: {start} a {end}',
                export_header_completeness: 'Completude: {score}%',
                export_header_status: 'Estado: {status}',
            },
            audit_periods: {
                title: 'Períodos de Auditoria',
                create_period: 'Criar Período de Auditoria',
                framework_code_label: 'Código da estrutura',
                select_framework: 'Selecionar um referencial...',
                period_label: 'Rótulo do período',
                period_start: 'Início do período',
                period_end: 'Fim do período',
                start: 'Começar',
                end: 'Fim',
                framework: 'Estrutura',
                retention_days: 'Dias de retenção',
                no_periods_found: 'Nenhum período de auditoria encontrado.',
                period_created: 'Período de auditoria criado',
                aria_table: 'Períodos de auditoria',
                suggested_boundaries: 'Limites sugeridos',
                suggested_boundaries_info: 'Os limites de período sugeridos derivam do ciclo de reporte regulatório de cada enquadramento. Ajuste conforme necessário para a sua organização.',
                reporting_cycle: 'Ciclo de reporte',
                suggested_start: 'Início sugerido',
                suggested_end: 'Fim sugerido',
                suggested_next: 'Próximo período sugerido',
                cycle_monthly: 'Mensalmente',
                cycle_quarterly: 'Trimestralmente',
                cycle_semi_annual: 'Semestral',
                cycle_annual: 'Anual',
                cycle_custom: 'Personalizado',
                period_deleted: 'Período de auditoria excluído',
            },
        },
        create_case: {
            customer_ref: 'Referência do cliente',
            country: 'País / Jurisdição',
            preferred_channel: 'Canal preferido',
            channels: {
                email: 'E-mail',
                postal: 'Correio postal',
                phone: 'Telefone',
                portal: 'Portal',
            },
            source: 'Fonte',
            sources: {
                admin_manual: 'Manual de administração',
                public_form: 'Formulário Público',
                cmp_gateway: '[[TOK_0]] Portal',
                aesirx_cmp: '[[TOK_1]] [[TOK_0]]',
                phone_received: 'Telefone recebido',
                postal_received: 'Postal Recebido',
                email_received: 'E-mail recebido',
                in_person: 'Pessoalmente',
                legacy_import: 'Importação herdada',
            },
            required_fields: 'O tipo de pedido, o nome e o e-mail são obrigatórios',
            create_error: 'Falha ao create case. Por favor, tente novamente.',
        },
        settings: {
            title: 'Definições',
            request_types: 'Tipos de Pedido',
            request_types_desc: 'Configure quais os tipos de pedido ativados para o formulário público de receção.',
            notifications: 'Notificações',
            ticket_numbering: 'Numeração de Pedidos',
            ticket_format: 'Formato atual',
            ticket_prefix: 'Prefixo',
            ticket_prefix_note: 'não configurável no Sprint 1.0.0',
            sla_deadlines: 'Prazos de SLA',
            sla_desc: 'Defina o tempo máximo de resposta (em dias de calendário) para cada tipo de pedido. Os casos que se aproximem do limite irão apresentar avisos.',
            days: 'dias',
            warning_threshold: 'Limite de aviso',
            escalation_label: 'Ativar escalonamento automático em caso de incumprimento do SLA',
            save_sla: 'Guardar Configuração de SLA',
            saving: 'A guardar...',
            saved: 'Guardado com sucesso',
            announce_loaded: 'Configurações carregadas',
            email_on_creation: 'Notificação por correio eletrónico na criação do pedido',
            send_confirmation: 'Enviar correio eletrónico de confirmação ao requerente',
            users: 'Usuários',
            roles: 'Funções',
            api_keys: '[[TOK_0]] Chaves',
            mfa: 'MFA',
            sessions: 'Sessões',
            webhooks: 'Webhooks',
            modules: 'Módulos',
            deadline_labels: {
                access: 'Acesso (DSAR)',
                deletion: 'Apagamento',
                correction: 'Retificação',
                portability: 'Portabilidade',
                objection: 'Oposição',
                restriction: 'Limitação',
                consent_withdrawal: 'Retirada do consentimento',
            },
        },
        section_assignments: {
            title: 'Atribuições de secção',
            assign_section: 'Atribuir secção',
            section_ref: 'Referência de secção',
            section_label: 'Etiqueta de secção',
            department_id: 'Departamento',
            assignee_id: 'Responsável',
            mandatory: 'Obrigatório',
            assign: 'Atribuir',
            no_assignments: 'Sem atribuições de secção',
            status: 'Estado',
            completion: 'Conclusão',
            mark_complete: 'Concluir',
        },
        consolidation: {
            title: 'Progresso de consolidação',
            add_child: 'Adicionar subtarefa',
            child_task_id: 'ID de subtarefa',
            department_id: 'Departamento',
            link: 'Ligação',
            overall_completion: 'Conclusão geral',
            departments_complete: 'Departamentos concluídos',
            overdue: 'Em atraso',
            ready: 'Pronto',
            not_ready: 'Não pronto',
            master_status: 'Estado principal',
            department_breakdown: 'Detalhes por departamento',
            department: 'Departamento',
            status: 'Estado',
            completion: 'Conclusão',
            due_date: 'Data de vencimento',
            overdue_flag: 'Em atraso',
            child_tasks: 'Subtarefas',
            task: 'Tarefa',
        },
        conflict_detection: {
            title: 'Deteção de conflitos',
            unresolved: 'não resolvido',
            no_conflicts: 'Nenhum conflito detetado',
            section: 'Secção',
            field: 'Campo',
            dept_a: 'Departamento A',
            value_a: 'Valor A',
            dept_b: 'Departamento B',
            value_b: 'Valor B',
            severity: 'Gravidade',
            status: 'Estado',
            resolved: 'Resolvido',
            open: 'Aberto',
            resolve: 'Resolver',
        },
        org_maturity: {
            title: 'Maturidade Organizacional',
            departments: 'Departamentos',
            department_hierarchy: 'Hierarquia de Departamentos',
            create_department: 'Criar Departamento',
            department_name: 'Nome do Departamento',
            department_code: 'Código',
            level: 'Nível',
            division: 'Divisão',
            department: 'Departamento',
            team: 'Equipa',
            parent_department: 'Departamento Superior',
            head_user: 'Chefe de Departamento',
            no_departments: 'Nenhum departamento configurado.',
            user_mappings: 'Atribuições de Utilizadores',
            map_user: 'Atribuir Utilizador',
            user_id: 'ID do Utilizador',
            role: 'Função',
            no_users: 'Nenhum utilizador atribuído a este departamento.',
            remove: 'Remover',
            framework_assignments: 'Atribuições de Referenciais',
            assign_framework: 'Atribuir Referencial',
            entity_id: 'ID da Entidade',
            entity_type: 'Tipo de Entidade',
            framework_id: 'ID do Referencial',
            framework_code: 'Código do Referencial',
            no_assignments: 'Sem atribuições de referenciais.',
            compliance_rollup: 'Resumo de Conformidade',
            entity_name: 'Entidade',
            total_assessments: 'Avaliações Totais',
            completed: 'Concluído',
            completion_pct: 'Conclusão %',
            open_gaps: 'Lacunas Abertas',
            critical_gaps: 'Críticas',
            compliance_score: 'Pontuação',
            no_rollup: 'Sem dados de resumo de conformidade disponíveis.',
            entity_summary: 'Resumo de Conformidade da Entidade',
            frameworks_assigned: 'Referenciais',
            overall_score: 'Pontuação Geral',
            load_departments_error: 'Falha ao carregar os departamentos',
            load_users_error: 'Falha ao carregar os utilizadores',
            department_created: 'Departamento criado',
            department_created_announce: 'Departamento criado',
            create_department_error: 'Falha ao criar o departamento',
            user_mapped: 'Usuário mapeado',
            user_mapped_announce: 'Usuário mapeado ao departamento',
            map_user_error: 'Falha ao associar o utilizador',
            user_removed: 'Usuário removido',
            load_rollup_error: 'Falha ao carregar o resumo',
            load_assignments_error: 'Falha ao carregar as atribuições',
            framework_assigned: 'Estrutura atribuída',
            framework_assigned_announce: 'Estrutura atribuída à entidade',
            assign_framework_error: 'Falha ao atribuir o quadro normativo',
            assignment_removed: 'Atribuição removida',
            enter_entity_id_placeholder: 'Digite o ID da entidade para ver atribuições',
            entity_type_organization: 'Organização',
            entity_type_department: 'Departamento',
        },
        onboarding_maturity: {
            title: 'Maturidade de integração',
            quick_starts: 'Inícios rápidos',
            progress: 'Progresso da integração',
            personas: 'Caminhos de Personagem',
            persona_onboarding: 'Integração de Personagem',
            quick_start_scenarios: 'Cenários de início rápido',
            start: 'Iniciar',
            restart: 'Reiniciar',
            estimated_minutes: 'Minutos estimados',
            steps: 'Passos',
            scenario: 'Cenário',
            no_scenarios: 'Não há cenários de início rápido disponíveis.',
            persona_id: 'ID da pessoa',
            persona_label: 'Pessoa',
            role_description: 'Descrição da função',
            primary_modules: 'Módulos Primários',
            recommended_tours: 'Passeios recomendados',
            sample_data_modules: 'Módulos de dados de amostra',
            quick_start_scenario: 'Cenário de início rápido',
            no_personas: 'Nenhum caminho de persona disponível.',
            framework_setup: 'Quadros regulamentares',
            framework_code: 'Código Estrutural',
            framework_name: 'Nome da Estrutura',
            related_modules: 'Módulos Relacionados',
            persona_relevance: 'Personas relevantes',
            no_frameworks: 'Nenhuma opção de configuração de estrutura disponível.',
            tier_config: 'Configuração do Módulo de Camada',
            tier: 'Nível',
            available_modules: 'Módulos Disponíveis',
            module_count: 'Contagem de módulos',
            overall_completion: 'Conclusão geral',
            wizard_completed: 'Assistente concluído',
            tours_completed: 'Passeios concluídos',
            quick_starts_completed: 'Inícios rápidos concluídos',
            selected_frameworks: 'Estruturas selecionadas',
            no_progress: 'Não há dados de progresso de integração disponíveis.',
            detected_persona: 'Personagem detectada',
            current_tier: 'Nível atual',
            completion_pct: 'Conclusão',
            progress_page: {
                loaded: 'Progresso carregado',
                no_progress: 'Não há dados de progresso de integração disponíveis.',
                overall: 'Progresso geral',
                detected_persona: 'Persona detetada',
                tier: 'Nível',
                modules: 'módulos',
                wizard: 'Assistente',
                completed: 'Concluído',
                pending: 'Pendente',
                tours: 'Visitas guiadas',
                quick_starts: 'Inícios rápidos',
                frameworks: 'Quadros selecionados',
                no_frameworks: 'Nenhum quadro selecionado.',
                go_to_wizard: 'Concluir o assistente de configuração',
                framework_selection: 'Seleção de quadro',
                framework_toggle: 'Ativar ou desativar quadros para o seu programa de conformidade.',
                framework_updated: 'Seleção de quadro atualizada.',
                view_tours: 'Ver visitas guiadas',
                view_quick_starts: 'Ver inícios rápidos',
            },
            persona_page: {
                description: 'Selecione uma persona para ver módulos, visitas guiadas e cenários de início rápido recomendados.',
                no_personas: 'Não há caminhos de persona disponíveis.',
                modules: 'Módulos',
                tours: 'Visitas guiadas',
                quick_start: 'Início rápido',
                details: 'Detalhes',
                primary_modules: 'Módulos principais',
                recommended_tours: 'Visitas guiadas recomendadas',
                framework_options: 'Quadros regulamentares',
                no_frameworks: 'Não há opções de configuração do quadro disponíveis.',
                framework_code: 'Código do quadro',
                framework_label: 'Rótulo',
                region: 'Região',
                category: 'Categoria',
                enabled: 'Ativado',
                disabled: 'Desativado',
                tier_modules: 'Configuração de módulos por nível',
                tiers_loaded: 'Configurações de nível carregadas',
                no_tier_config: 'Não há configuração de nível disponível.',
                view_tours: 'Ver visitas de módulos',
                view_quick_start: 'Iniciar início rápido',
                toggle_framework: 'Alternar quadro',
                framework_updated: 'Seleção de quadro atualizada.',
                tier_desc_light: 'Fundamentos de privacidade — bases de conformidade PDPL',
                tier_desc_standard: 'Suite de conformidade completa — todos os módulos com fluxos de trabalho',
                tier_desc_enterprise: 'Governança avançada e automatização — multi-entidade, relatórios de grupo',
                persona_highlight: 'Os seus módulos',
                aria_go_to_module: '[[TOK_1]] — vá para o módulo',
                aria_start_tour: 'Iniciar [[TOK_1]]',
                aria_quick_start: 'Início rápido: [[TOK_1]]',
                aria_help_article: 'Artigo de ajuda: [[TOK_1]]',
                aria_view_framework: '[[TOK_2]][[TOK_3]] — ver detalhes da estrutura',
                aria_primary_for_persona: '[[TOK_1]] (principal para esta persona)',
                primary_for_persona_suffix: ' (primário para esta persona)',
                aria_view_in_persona_paths: '[[TOK_1]] - visualizar em caminhos de persona',
                progress_of_total: '[[TOK_2]] de [[TOK_3]] concluído',
            },
            quick_starts_page: {
                description: 'Pratique fluxos de trabalho comuns com cenários de início rápido guiados.',
                no_scenarios: 'Não há cenários de início rápido disponíveis.',
                started: 'Início rápido iniciado',
                status_completed: 'Concluído',
                status_in_progress: 'Em progresso',
                status_not_started: 'Não iniciado',
                minutes: 'min',
                steps: 'passos',
                step: 'Passo',
                restart: 'Reiniciar',
                start: 'Iniciar',
                go_to_module: 'Ir para o módulo',
                next_step: 'Próximo passo',
                complete: 'Concluir',
                reset: 'Repor',
                step_of: 'de',
                action_navigate: 'Navegar',
                action_form_fill: 'Preencher formulário',
                action_review: 'Rever',
                action_confirm: 'Confirmar',
                step_changed: 'Passo {current} de {total}: {title}',
                completed_message: 'Início rápido concluído com sucesso!',
                reset_message: 'O início rápido foi reposto.',
            },
            persona_p_vn_01_label: 'Empresa DPO',
            persona_p_vn_01_description: 'Diretor de proteção de dados gerenciando programas de conformidade em toda a empresa',
            persona_p_vn_02_label: 'Proprietário do Departamento',
            persona_p_vn_02_description: 'Líder do departamento responsável pelos relatórios de conformidade seccionais',
            persona_p_vn_03_label: 'Conformidade de comércio eletrônico',
            persona_p_vn_03_description: 'Diretor de conformidade focado na proteção e consentimento de dados de comércio eletrônico',
            persona_p_vn_04_label: 'Telecomunicações DPO',
            persona_p_vn_04_description: 'Setor de telecomunicações DPO gerenciando dados de assinantes e relatórios de incidentes',
            persona_p_vn_05_label: 'Líder de Governança de Dados',
            persona_p_vn_05_description: 'Líder responsável pelo mapeamento, classificação e governança de dados',
            persona_p_vn_06_label: 'Segurança cibernética e operações jurídicas',
            persona_p_vn_06_description: 'Oficial de segurança cibernética gerenciando resposta a incidentes e riscos do fornecedor',
            persona_p_vn_07_label: 'AI Líder de governança',
            persona_p_vn_07_description: 'Liderar a supervisão do AI governança do sistema, avaliações de risco e classificação',
            persona_p_vn_08_label: 'Governo transfronteiriço e de fornecedores',
            persona_p_vn_08_description: 'Diretor que gerencia transferências transfronteiriças e governança de fornecedores',
            persona_p_vn_09_label: 'Líder de resposta a violações',
            persona_p_vn_09_description: 'Liderar a coordenação de notificação de violação e resposta a incidentes',
            persona_p_vn_10_label: 'Líder de Auditoria Interna',
            persona_p_vn_10_description: 'Líder responsável pela auditoria de conformidade e revisão da governança do programa',
            persona_p_vn_11_label: 'Responsável de dados de RH e colaboradores',
            persona_p_vn_11_description: 'Gestor de RH que gere registos de consentimento de colaboradores e DSARs internos',
            persona_p_vn_12_label: 'Responsável de conformidade de filial multinacional',
            persona_p_vn_12_description: 'EPD em filial vietnamita de empresa estrangeira que necessita de camada de conformidade local',
            persona_p_vn_13_label: 'Responsável de conformidade educacional',
            persona_p_vn_13_description: 'Responsável de conformidade em escola estrangeira que gere a proteção de dados de alunos e encarregados de educação',
            qs_hr_consent_title: 'Registar consentimentos de colaboradores',
            qs_hr_consent_description: 'Percurso do registo de consentimento de colaboradores e geração de relatório de cobertura.',
            qs_subsidiary_dpia_title: 'Criar avaliação AIPD de filial',
            qs_subsidiary_dpia_description: 'Percurso da criação de uma AIPD para uma atividade de tratamento de filial.',
            qs_student_consent_title: 'Configurar recolha de consentimento de alunos',
            qs_student_consent_description: 'Percurso da criação de políticas de consentimento parental para dados de alunos.',
            persona_p_vn_14_label: 'Assessor Jurídico Externo',
            persona_p_vn_14_description: 'Sócio sênior de escritório de advocacia assessorando diversas organizações clientes sobre conformidade PDPL',
            persona_p_vn_15_label: 'Gerente de Operações de Escritório de Advocacia',
            persona_p_vn_15_description: 'Coordenador de engajamento do cliente gerenciando rastreamento de entregas e coordenação de prazos',
            persona_p_vn_16_label: 'Proprietário da empresa / CEO',
            persona_p_vn_16_description: 'CEO ou GM que é legalmente o controlador de dados sob PDPL, responsável pelo investimento em conformidade',
            qs_dpia_filing_title: 'Conclua seu primeiro arquivamento DPIA',
            qs_dept_compliance_title: 'Envie sua primeira seção de conformidade do departamento',
            qs_ecommerce_consent_title: 'Configurar a coleta de consentimento de comércio eletrônico',
            qs_telecom_data_title: 'Configurar o tratamento de dados de assinantes de telecomunicações',
            qs_data_flow_title: 'Mapeie seu primeiro fluxo de dados',
            qs_incident_response_title: 'Configurar o fluxo de trabalho de resposta a incidentes',
            qs_ai_risk_title: 'Execute uma avaliação de risco do sistema AI',
            qs_cross_border_title: 'Avalie uma transferência de dados transfronteiriça',
            qs_breach_notification_title: 'Simule um fluxo de trabalho de notificação de violação',
            qs_audit_trail_title: 'Revise uma trilha de auditoria de conformidade',
            qs_legal_advisor_portfolio_title: 'Revise o portfólio de conformidade de vários clientes',
            qs_legal_advisor_portfolio_description: 'Revise o status de conformidade em diversas organizações clientes.',
            qs_law_firm_ops_title: 'Acompanhe o status da entrega do cliente',
            qs_law_firm_ops_description: 'Monitore o progresso da entrega de consultoria e o envolvimento do cliente.',
            qs_ceo_dashboard_title: 'Ver painel de conformidade executiva',
            qs_ceo_dashboard_description: 'Revise o status de conformidade de alto nível e as métricas de investimento.',
        },
        rights_requests: {
            response_templates: {
                title: 'Modelos de resposta',
                subtitle: 'Gerencie os modelos de carta de resposta DSR que o ResponseGenerator usa para redigir respostas aos titulares dos dados.',
                create_btn: 'Novo modelo',
                edit_btn: 'Editar modelo',
                filter_right_type: 'Filtrar por tipo certo',
                filter_locale: 'Filtrar por localidade',
                filter_status: 'Filtrar por status',
                all_right_types: 'Todos os tipos certos',
                any_right_type: 'Qualquer (aplica-se a todos os tipos)',
                all_locales: 'Todas as localidades',
                all_statuses: 'Todos',
                status_active: 'Ativo',
                status_inactive: 'Inativo',
                empty_state: 'Nenhum modelo corresponde aos filtros atuais.',
                columns: {
                    template_id: 'ID do modelo',
                    outcome: 'Resultado',
                    locale: 'Local',
                    right_type: 'Tipo certo',
                    is_active: 'Estado',
                    last_updated: 'Última atualização',
                    actions: 'Ações',
                },
                actions: {
                    edit: 'Editar',
                    clone: 'Clonar',
                    deactivate: 'Desativar',
                    reactivate: 'Reativar',
                    preview: 'Visualização',
                },
                form: {
                    template_id: 'ID do modelo',
                    template_id_help: 'Identificador em minúsculas, por ex. dsr_access_fulfilled_vi',
                    outcome: 'Resultado',
                    locale: 'Local',
                    right_type: 'Tipo certo',
                    subject: 'Assunto',
                    body: 'Modelo de corpo',
                    body_help: 'Use espaços reservados como [[TOK_3]], [[TOK_4]], [[TOK_5]]. Mínimo de 15 linhas para cartas com várias seções.',
                    is_active: 'Ativo',
                    official_form_id: 'ID do formulário oficial (opcional)',
                },
                outcomes: {
                    fulfilled: 'Cumprido',
                    partially_fulfilled: 'Parcialmente cumprido',
                    denied: 'Negado',
                },
                clone_modal_title: 'Clonar modelo',
                clone_target_locale: 'Local de destino',
                clone_help: 'Um novo modelo será criado na localidade de destino usando este modelo como ponto de partida.',
                preview_modal_title: 'Visualização do modelo',
                preview_note: 'A visualização usa espaços reservados de caso de demonstração DSR-DEMO-0020. A entrega real substitui os dados de casos ao vivo.',
                preview_unavailable: 'A visualização requer um caso existente. Anexe este modelo a um caso e use a ação Rascunho de resposta na página de detalhes do caso.',
                deactivate_confirm: 'Desativar este modelo? Continuará a aplicar-se aos casos existentes que o façam referência.',
                toasts: {
                    created: 'Modelo criado',
                    updated: 'Modelo atualizado',
                    deactivated: 'Modelo desativado',
                    reactivated: 'Modelo reativado',
                    cloned: 'Modelo clonado',
                    load_error: 'Falha ao carregar modelos',
                    save_error: 'Falha ao salvar o modelo',
                    clone_error: 'Falha ao clonar modelo',
                },
            },
        },
        organizations: {
            departments: {
                title: 'Departamentos',
                subtitle: 'Gerencie os departamentos que encaminham casos de DSR, tarefas [[TOK_0]] e fluxos de trabalho de conformidade.',
                create_btn: 'Novo Departamento',
                edit_btn: 'Editar Departamento',
                columns: {
                    name: 'Nome',
                    description: 'Descrição',
                    active_cases: 'Casos Ativos',
                    members: 'Membros',
                    status: 'Estado',
                    actions: 'Ações',
                },
                status_active: 'Ativo',
                status_inactive: 'Inativo',
                form: {
                    name: 'Nome',
                    description: 'Descrição',
                },
                actions: {
                    edit: 'Editar',
                    deactivate: 'Desativar',
                    reactivate: 'Reativar',
                    delete: 'Excluir',
                    manage_members: 'Gerenciar membros',
                },
                delete_modal_title: 'Excluir departamento',
                delete_warning: 'Este departamento ainda tem casos ativos. Escolha um departamento para reatribuí-los antes da exclusão.',
                delete_no_cases: 'Este departamento não possui casos ativos e pode ser excluído com segurança.',
                reassign_prompt: 'Reatribuir casos ativos para:',
                reassign_none_available: 'Nenhum outro departamento ativo disponível. Crie outro departamento primeiro.',
                member_section_title: 'Membros',
                add_member: 'Adicionar membro',
                remove_member: 'Remover',
                member_role: 'Função',
                no_members: 'Nenhum membro mapeado para este departamento.',
                toasts: {
                    created: 'Departamento criado',
                    updated: 'Departamento atualizado',
                    deactivated: 'Departamento desativado',
                    reactivated: 'Departamento reativado',
                    deleted: 'Departamento excluído',
                    reassigned_count: '[[TOK_1]] caso(s) reatribuído(s)',
                    member_added: 'Membro adicionado',
                    member_removed: 'Membro removido',
                    load_error: 'Falha ao carregar departamentos',
                    save_error: 'Falha ao salvar departamento',
                    delete_error: 'Falha ao excluir departamento',
                },
            },
            retention_policies: {
                title: 'Políticas de retenção',
                subtitle: 'Configure janelas de retenção por tipo de destino. Documentos de verificação de identidade usam isso para carimbar retention_expires_at em uploads futuros.',
                create_btn: 'Nova Política',
                edit_btn: 'Editar política',
                columns: {
                    target_type: 'Tipo de destino',
                    retention_days: 'Retenção (dias)',
                    owner: 'Proprietário da política',
                    effective_from: 'Eficaz a partir de',
                    last_reviewed: 'Última revisão',
                    status: 'Estado',
                    actions: 'Ações',
                },
                status_active: 'Ativo',
                status_inactive: 'Inativo',
                form: {
                    target_type: 'Tipo de destino',
                    target_type_help: 'A qual categoria de dados a janela de retenção se aplica. Atualmente, apenas são suportados documentos de verificação de identidade DSR.',
                    retention_days: 'Janela de retenção (dias)',
                    retention_days_help: 'Entre 1 e 3.650 dias (10 anos no máximo).',
                    owner: 'Proprietário da política',
                    owner_help: 'Geralmente o [[TOK_0]]. Responsável pela decisão de retenção sob DG-2.',
                    effective_from: 'Eficaz a partir de',
                },
                target_types: {
                    dsr_identity_verification_document: 'Documentos de verificação de identidade DSR',
                },
                deactivate_notice: 'A desativação não afeta os anexos já carimbados – apenas uploads futuros não receberão mais uma janela de retenção.',
                deactivate_confirm: 'Desativar esta política de retenção?',
                toasts: {
                    created: 'Política de retenção criada',
                    updated: 'Política de retenção atualizada',
                    deactivated: 'Política de retenção desativada',
                    load_error: 'Falha ao carregar políticas de retenção',
                    save_error: 'Falha ao salvar a política de retenção',
                },
            },
        },
    },
    data_mapping: {
        nav: {
            systems: 'Sistemas',
            categories: 'Categorias de dados',
            registry: 'Registro de dados',
            purposes: 'Finalidades de processamento',
            retention: 'Retenção',
            flows: 'Fluxos de Dados',
            activities: 'Atividades de Tratamento',
            evidence: 'Evidências',
            exports: 'Exportações',
            attestation: 'Ciclos de Atestado',
            governance: 'Governança',
            review: 'Tarefas de Revisão',
            inventory: 'Inventário',
            exceptions: 'Exceções',
            history: 'Histórico',
            ropa_completeness: 'Completude ROPA',
        },
        ropa_completeness_autofix: {
            ask_button: 'Pergunte a Forseti',
            drafting: 'Elaboração…',
            accept: 'Aceitar',
            reject: 'Rejeitar',
            accepted: 'Aceito — inscreva-se por meio do editor de atividades.',
            rejected: 'Rejeitado.',
            needs_human_input: 'Forseti precisa de mais contexto de atividade (por exemplo, um propósito documentado) antes de redigir este campo.',
        },
        ropa_completeness: {
            title: 'Relatório de integridade ROPA',
            subtitle: 'Auditoria de higiene por campo de seus registros de atividades de processamento, abrangidas pela estrutura regulatória.',
            framework_label: 'Estrutura',
            kpi_total: 'Atividades pontuadas',
            kpi_critical: 'Crítico',
            kpi_high: 'Alto',
            kpi_conditional: 'Condicional',
            field_chart_heading: 'Campos ausentes por frequência',
            drilldown_heading: 'Atividades com lacunas',
            col_activity: 'Atividade',
            col_field: 'Campo',
            col_severity: 'Gravidade',
            col_condition: 'Condição',
            col_action: 'Fix',
            action_fix: 'Fix',
            severity_critical: 'Crítico',
            severity_high: 'Alto',
            severity_conditional: 'Condicional',
            severity_informational: 'Informativo',
            include_informational: 'Incluir informações (ISO 27701)',
            export_csv: 'Baixar [[TOK_0]]',
            exporting: 'Exportando...',
            loading: 'Carregando…',
            empty_state: 'Todas as atividades ativas possuem registros ROPA completos para esta estrutura.',
            error_fetch: 'Falha ao carregar o relatório de conclusão.',
            error_unsupported_framework: 'Esta estrutura não é suportada.',
            error_framework_not_installed: 'Esta estrutura não está instalada para sua organização.',
            no_misses_for_field: 'Nenhuma atividade faltando neste campo.',
            framework_PDPL: '[[TOK_0]] (Lei 91/2025 + Decreto 356)',
            framework_GDPR: '[[TOK_0]] Artigo 30',
            framework_DECREE_165: 'Decreto 165 (Lei de Dados do Vietnã)',
            framework_ISO_27701: 'ISO 27701 (informativo)',
        },
        registry: {
            page: {
                title: 'Registro de dados',
                subtitle: 'Elementos de dados pessoais que sua organização possui, organizados em categorias de dados.',
                empty_state: 'Ainda não há itens de registro. Adicione um item manualmente ou importe de um cadastro regulatório.',
                empty_filter_state: 'Nenhum item corresponde aos seus filtros.',
            },
            filter: {
                category: 'Categoria',
                sensitivity: 'Sensibilidade',
                data_subject: 'Titular dos dados',
                status: 'Estado',
                data_tier: 'Camada de dados',
                cross_border: 'Transfronteiriço',
                has_owner: 'Tem proprietário',
                has_form_source: 'Importado do formulário',
                search_placeholder: 'Nome de pesquisa, descrição ou identificador de campo…',
                clear: 'Limpar filtros',
                option_all: 'Todos',
            },
            col: {
                name: 'Nome',
                category: 'Categoria',
                sensitivity: 'Sensibilidade',
                data_subjects: 'Titulares dos dados',
                systems: 'Sistemas',
                activities: 'Atividades',
                owner: 'Proprietário',
                retention: 'Retenção',
                data_tier: 'Camada de dados',
                status: 'Estado',
                last_reviewed: 'Última revisão',
                actions: 'Ações',
            },
            action: {
                add_manual: 'Adicionar item',
                add_from_form: 'Adicionar do registro regulatório',
                import_history: 'Importar envios anteriores',
                export: 'Exportar',
                archive: 'Arquivo',
                restore: 'Restaurar',
                edit: 'Editar',
                assign_owner: 'Atribuir proprietário',
                attach_evidence: 'Anexar evidências',
                open_lineage: 'Linhagem aberta',
            },
            modal_editor: {
                section_identity: 'Identidade',
                section_classification: 'Classificação',
                section_subjects: 'Assuntos e Volume',
                section_location: 'Localização e transferência',
                section_systems: 'Sistemas e Atividades',
                section_retention: 'Retenção e Legal',
                section_governance: 'Governança',
                section_notes: 'Notas',
                hint_inherited: '(herdado da categoria)',
                hint_overridden: '(substituído)',
                placeholder_field_identifiers: 'por exemplo, clientes.primary_email, hris.employee_id',
                validation_name_required: 'O nome é obrigatório',
                validation_category_required: 'A categoria é obrigatória',
                validation_data_subjects_required: 'É necessário pelo menos um tipo de titular de dados',
                label_data_type: 'Tipo de dados',
                label_field_identifiers: 'Identificadores de campo (separados por vírgula)',
                label_data_subject_types: 'Tipos de titulares de dados',
                label_volume_band: 'Banda de volume',
                label_storage_locations: 'Locais de armazenamento (separados por vírgula)',
                placeholder_storage_locations: 'ISO-3166 códigos ou texto livre (por exemplo, VN, Hetzner EU)',
                label_cross_border: 'Transferência transfronteiriça',
                label_source_systems: 'Sistemas de origem',
                label_processing_activities: 'Atividades de processamento',
                label_collection_method: 'Método de coleta',
                label_legal_basis: 'Base jurídica',
                label_purposes: 'Finalidades',
                hint_multi_select: 'Segure Cmd/Ctrl para selecionar vários.',
                option_inherit_category: '- (herdar da categoria)',
                option_dash: '-',
            },
            modal_import: {
                dry_run_heading: 'Pré-visualização da importação',
                label_to_create: 'Para criar',
                label_to_update: 'Para atualizar',
                label_skipped_archived: 'Ignorado (arquivado)',
                label_conflicts: 'Conflitos',
                commit: 'Importar',
                cancel: 'Cancelar',
                conflict_row: '[[TOK_3]] — mantendo sua edição ([[TOK_4]]); mapeador procurado [[TOK_5]].',
            },
            drawer: {
                section_category: 'Categoria',
                section_systems: 'Sistemas de origem',
                section_activities: 'Atividades de processamento',
                section_flows: 'Fluxos de dados',
                section_retention: 'Retenção eficaz',
                section_governance: 'Governança',
                section_evidence: 'Evidência',
                section_audit: 'Trilha de auditoria recente',
                section_source_form: 'Envio do formulário de origem',
                badge_inherited: 'Herdado',
                badge_overridden: 'Substituído',
            },
            toast: {
                created: 'Item de registro criado.',
                updated: 'Item de registro atualizado.',
                archived: 'Item de registro arquivado.',
                imported: '[[TOK_1]] itens importados.',
                conflict_warning: 'Os campos [[TOK_1]] mantiveram suas edições — veja a lista de conflitos.',
            },
        },
        systems: {
            title: 'Inventário de Sistemas',
            new: 'Novo Sistema',
            edit: 'Editar Sistema',
            name: 'Nome',
            owner: 'Responsável',
            criticality: 'Criticidade',
            dpa_status: 'Estado do APD',
            location: 'Localização',
            system_type: 'Tipo de Sistema',
            metadata: 'Metadados (JSON)',
            department: 'Departamento',
            hosting_location: 'Localização do Alojamento',
            hosting_provider: 'Fornecedor de Alojamento',
            data_residency_country: 'País de Residência dos Dados',
            hosting: 'Alojamento',
            no_systems: 'Nenhum sistema encontrado',
            confirm_archive: 'Arquivar sistema "{name}"?',
            count: 'sistemas',
            count_one: 'sistema',
            type_internal: 'Interno',
            type_external: 'Externo',
            type_cloud_service: 'Serviço em Nuvem',
            type_on_premise: 'Local',
            type_hybrid: 'Híbrido',
            status_active: 'Ativo',
            status_decommissioning: 'Em Desativação',
            status_decommissioned: 'Desativado',
            status_planned: 'Planeado',
            dpa_not_required: 'Não Necessário',
            dpa_required_missing: 'Necessário em Falta',
            dpa_in_progress: 'Em Progresso',
            dpa_signed: 'Assinado',
            all_criticalities: 'Todas as Criticidades',
        },
        categories: {
            title: 'Categorias de Dados',
            new: 'Nova Categoria',
            edit: 'Editar Categoria',
            name: 'Nome',
            sensitivity: 'Sensibilidade',
            tags: 'Etiquetas',
            used_in: 'Utilizado Em',
            examples: 'Exemplos',
            examples_hint: 'Exemplos (separados por vírgulas)',
            default: 'Predefinido',
            all_sensitivities: 'Todas as Sensibilidades',
            all_statuses: 'Todos os Estados',
            no_categories: 'Nenhuma categoria encontrada',
            confirm_delete: 'Eliminar categoria "{name}"?',
            count: 'categorias',
            count_one: 'categoria',
            status_draft: 'Rascunho',
            status_proposed: 'Proposto',
            status_under_review: 'Em Revisão',
            status_approved: 'Aprovado',
            status_deprecated: 'Obsoleto',
            status_updated: 'Estado da categoria atualizado',
            propose: 'Propor',
            approve: 'Aprovar',
            deprecate: 'Tornar Obsoleto',
        },
        purposes: {
            title: 'Finalidades do Tratamento',
            new: 'Nova Finalidade',
            edit: 'Editar Finalidade',
            name: 'Nome',
            legal_basis: 'Base Jurídica',
            retention_period: 'Período de Retenção (dias)',
            justification: 'Justificação de Interesse Legítimo',
            legal_basis_detail: 'Detalhe da Base Jurídica',
            all_legal_bases: 'Todas as Bases Jurídicas',
            no_purposes: 'Nenhuma finalidade encontrada',
            confirm_delete: 'Eliminar "{name}"?',
            default: 'Predefinido',
            count: '{count} finalidades',
            count_one: '{count} finalidade',
            basis_consent: 'Consentimento',
            basis_contract: 'Contrato',
            basis_legal_obligation: 'Obrigação Legal',
            basis_vital_interest: 'Interesse Vital',
            basis_public_interest: 'Interesse Público',
            basis_legitimate_interest: 'Interesse Legítimo',
        },
        retention: {
            title: 'Políticas de Retenção',
            new: 'Nova Política',
            edit: 'Editar Política',
            name: 'Nome',
            retention_days: 'Dias de Retenção',
            disposal_method: 'Método de Eliminação',
            data_categories: 'Categorias de Dados',
            activities: 'Atividades',
            review_frequency: 'Frequência de Revisão',
            review_frequency_days: 'Frequência de Revisão (dias)',
            no_policies: 'Nenhuma política de retenção encontrada',
            confirm_delete: 'Eliminar "{name}"?',
            count: '{count} políticas',
            count_one: '{count} política',
            days: 'dias',
            disposal_deletion: 'Eliminação',
            disposal_anonymization: 'Anonimização',
            disposal_archival: 'Arquivamento',
            review_overdue: 'Revisão atrasada',
            review_status: 'Estado da revisão',
            review_ok: 'No prazo',
            department: 'Departamento',
            all_departments: 'Todos os departamentos',
        },
        flows: {
            view_tabs_aria: 'Vista de fluxos',
            view_list: 'Lista',
            view_map: 'Mapa',
            title: 'Fluxos de Dados',
            new: 'Novo Fluxo',
            edit: 'Editar Fluxo',
            name: 'Nome',
            from_system: 'Sistema de Origem',
            to_system: 'Sistema de Destino',
            flow_type: 'Tipo de Fluxo',
            cross_border: 'Transfronteiriço',
            risk_level: 'Nível de Risco',
            mechanism: 'Mecanismo',
            transfer_mechanism: 'Mecanismo de Transferência',
            frequency: 'Frequência',
            source_country: 'País de Origem',
            destination_country: 'País de Destino',
            transfer_safeguard: 'Garantia de Transferência',
            all_risk_levels: 'Todos os Níveis de Risco',
            no_flows: 'Nenhum fluxo de dados encontrado',
            confirm_archive: 'Arquivar "{name}"?',
            count: '{count} fluxos',
            count_one: '{count} fluxo',
            status_active: 'Ativo',
            status_inactive: 'Inativo',
            status_under_review: 'Em Revisão',
            mechanism_api: 'API',
            mechanism_file_transfer: 'Transferência de Ficheiros',
            mechanism_database_replication: 'Replicação de Base de Dados',
            mechanism_manual: 'Manuais',
            mechanism_email: 'Correio Eletrónico',
            mechanism_other: 'Outro',
            frequency_real_time: 'Tempo Real',
            frequency_hourly: 'Hora a Hora',
            frequency_daily: 'Diário',
            frequency_weekly: 'Semanal',
            frequency_monthly: 'Mensal',
            frequency_on_demand: 'A Pedido',
            frequency_one_time: 'Única Vez',
            safeguard_adequacy_decision: 'Decisão de Adequação',
            safeguard_standard_contractual_clauses: 'Cláusulas Contratuais-Tipo',
            safeguard_binding_corporate_rules: 'Regras Vinculativas Empresariais',
            safeguard_explicit_consent: 'Consentimento Explícito',
            safeguard_legal_obligation: 'Obrigação Legal',
            safeguard_none: 'Nenhuma',
            safeguard_other: 'Outra',
        },
        activities: {
            title: 'Atividades de Tratamento',
            new: 'Nova Atividade',
            edit: 'Editar Atividade',
            activity_title: 'Título',
            category: 'Categoria',
            legal_basis: 'Base Jurídica',
            dpa_required: 'APD Necessário',
            ropa_generated: 'ROPA Gerado',
            version: 'Versão',
            generate_ropa: 'Gerar ROPA',
            controller: 'Responsável pelo Tratamento',
            controller_name: 'Nome do Responsável pelo Tratamento',
            controller_contact: 'Contacto do Responsável pelo Tratamento',
            legal_basis_detail: 'Detalhe da Base Jurídica',
            organization_info: 'Informações da organização (Apêndice I)',
            org_address: 'Endereço da organização',
            tax_code: 'Código fiscal',
            contact_person: 'Pessoa de contacto',
            contact_email: 'E-mail de contacto',
            contact_phone: 'Telefone de contacto',
            select_entity: 'Selecione…',
            no_entities: 'Nenhum item encontrado',
            dpo_name: 'Nome do EPD',
            dpo_contact: 'Contacto do EPD',
            processor_name: 'Nome do Subcontratante',
            processor_contact: 'Contacto do Subcontratante',
            data_subjects: 'Titulares dos Dados',
            data_subjects_hint: 'Titulares dos Dados (separados por vírgulas)',
            recipients: 'Destinatários',
            recipients_hint: 'Destinatários (separados por vírgulas)',
            security_measures: 'Medidas de Segurança',
            dpia_reference: 'Referência AIPD',
            no_activities: 'Nenhuma atividade de tratamento encontrada',
            confirm_archive: 'Arquivar "{name}"?',
            count: '{count} atividades',
            count_one: '{count} atividade',
            ropa_success: 'Registo RoPA gerado. Vá a Exportações para o descarregar.',
            ropa_error: 'Falha ao gerar ROPA',
            required_label: 'Obrigatório',
            status_draft: 'Rascunho',
            status_active: 'Ativo',
            status_under_review: 'Em Revisão',
            status_archived: 'Arquivado',
            decree_165_heading: 'Nível de dados do Decreto 165 (Lei de Dados do Vietnã)',
            decree_165_helper: 'Classificar os dados que esta atividade processa de acordo com o Decreto 165 do Vietname. Os dados regulares obtêm o regime transfronteiriço de base; dados importantes e essenciais desencadeiam obrigações adicionais.',
            data_tier_label: 'Camada de dados',
            data_tier_help: 'O Decreto 165 classifica os dados como regulares, importantes ou essenciais — consulte o artigo de ajuda para orientação.',
            data_tier_column_header: 'Camada de dados',
            data_tier_regular: 'Normal',
            data_tier_important: 'Importante',
            data_tier_core: 'Núcleo',
            transfer_mechanism_label: 'Mecanismo de transferência transfronteiriça',
            transfer_mechanism_placeholder: 'por exemplo Cláusulas Contratuais Padrão, decisão de adequação',
            security_assessment_reference_label: 'Referência de avaliação de segurança',
            security_assessment_reference_placeholder: 'por exemplo [[TOK_0]]-SA-2026-001',
        },
        evidence: {
            title: 'Repositório de Evidências',
            new: 'Nova Evidência',
            edit: 'Editar Evidência',
            name: 'Nome',
            evidence_type: 'Tipo de Evidência',
            linked_entities: 'Entidades Associadas',
            uploaded: 'Carregado',
            expiry: 'Validade',
            file_url: 'URL do Ficheiro',
            source_mode_label: 'Fonte da evidência',
            source_mode_file: 'Carregar ficheiro',
            source_mode_url: 'Ligar URL externa',
            attachment_label: 'Anexo',
            link_to: 'Associar Evidência A',
            entity_type: 'Tipo de Entidade',
            entity_id: 'ID da Entidade',
            no_evidence: 'Nenhuma evidência encontrada',
            manage_links: 'Gerenciar links',
            unlink: 'Desvincular',
            confirm_delete: 'Eliminar evidência "{name}"?',
            count: '{count} itens',
            count_one: '{count} elemento',
            type_document: 'Documento',
            type_screenshot: 'Captura de Ecrã',
            type_policy: 'Política',
            type_contract: 'Contrato',
            type_assessment: 'Avaliação',
            type_correspondence: 'Correspondência',
            type_other: 'Outro',
            linked_type_system: 'Sistema',
            linked_type_data_flow: 'Fluxo de dados',
            linked_type_processing_activity: 'Atividade de processamento',
            linked_type_data_category: 'Categoria de dados',
            linked_type_purpose: 'Objetivo',
            linked_type_retention_policy: 'Política de retenção',
            link_entity: 'Link para entidade',
            link_success: 'Entidade vinculada com sucesso',
            confirm_unlink: 'Tem certeza de que deseja desvincular esta entidade?',
            unlink_success: 'Entidade desvinculada com sucesso',
            no_linked_entities: 'Nenhuma entidade vinculada',
            select_entity: 'Selecione…',
            no_entities: 'Nenhum item',
        },
        exports: {
            title: 'Exportações de Dados',
            recent: 'Exportações Recentes',
            export_type: 'Tipo de Exportação',
            format: 'Formato',
            requested_by: 'Solicitado Por',
            requested_at: 'Solicitado Em',
            download: 'Transferir',
            csv_export: 'Exportação CSV',
            csv_description: 'Transferir dados em formato CSV para análise em folha de cálculo.',
            pdf_reports: 'Relatórios PDF',
            pdf_description: 'Gerar relatórios formatados para documentação de conformidade.',
            csv_systems: 'Inventário de Sistemas',
            csv_categories: 'Categorias de Dados',
            csv_flows: 'Fluxos de Dados',
            csv_activities: 'Atividades de Tratamento',
            csv_cross_border: 'Fluxos Transfronteiriços',
            csv_retention_policies: 'Políticas de retenção',
            csv_evidence: 'Itens de evidência',
            csv_governance_assignments: 'Atribuições de Governança',
            pdf_ropa: 'Registo ROPA',
            pdf_systems: 'Relatório de Sistemas',
            pdf_cross_border: 'Relatório Transfronteiriço',
            pdf_flow_map: 'Mapa de Fluxos de Dados',
            export_failed: 'Exportação falhada',
            pdf_generated: 'PDF gerado com sucesso.',
            ropa: 'Registro RoPA',
            retention_policies: 'Políticas de retenção',
            governance_assignments: 'Atribuições de Governança',
            col_entity: 'Entidade de exportação',
            col_description: 'Descrição',
            desc_ropa: 'Registro ROPA completo de todas as atividades de processamento com base legal, status [[TOK_0]] e controles.',
            desc_systems: 'Inventário de sistemas com proprietário, tags de categoria de dados e status de conformidade.',
            desc_activities: 'Atividades de processamento individual com controlador, base legal e classificação [[TOK_0]].',
            desc_categories: 'Categorias de dados e níveis de sensibilidade usados em classificações e auditorias.',
            desc_purposes: 'Para fins de tratamento com base legal de citações conforme Decreto 13/2023 e Lei das Telecomunicações 2023.',
            desc_flows: 'Fluxos de dados entre sistemas, incluindo rotas internas e transfronteiriças.',
            desc_cross_border: 'Apenas fluxos transfronteiriços, com mecanismo de transferência e avaliação de risco.',
            desc_retention_policies: 'Políticas de retenção, métodos de descarte e cadência de revisão.',
            desc_evidence: 'Provas anexadas às atividades de processamento: certificados, contratos DPA, relatórios [[TOK_0]].',
            desc_governance_assignments: 'Atribuições de governança: proprietários, aprovadores e referências ISO 27001.',
            unified_heading: 'Exportar Entidades',
            unified_description: 'Exporte qualquer entidade de mapeamento de dados no formato [[TOK_0]], [[TOK_3]], [[TOK_2]] ou [[TOK_1]]. Todas as exportações são salvas no Navegador de Arquivos.',
            export_button_label: 'Exportar',
            csv_download_success: 'CSV transferido com sucesso.',
        },
        attestation: {
            title: 'Ciclos de Atestação',
            create: 'Novo Ciclo',
            name: 'Nome do Ciclo',
            year: 'Ano',
            deadline: 'Prazo',
            scope: 'Âmbito',
            status: 'Estado',
            tasks: 'Tarefas do Departamento',
            assign_tasks: 'Atribuir Tarefas',
            department: 'Departamento',
            assignee: 'Responsável',
            progress: 'Progresso',
            stale_entries: 'Entradas Desatualizadas',
            detect_stale: 'Detetar Desatualizadas',
            export_bundle: 'Exportar Pacote',
            no_cycles: 'Ainda sem ciclos de atestação.',
            create_success: 'Ciclo de atestação criado.',
            assign_success: 'Tarefas atribuídas com sucesso.',
            complete_success: 'Tarefa concluída.',
            stale_detected: 'Entradas desatualizadas detetadas.',
            stale_systems: 'Sistemas desatualizados',
            stale_flows: 'Fluxos desatualizados',
            no_stale: 'Nenhuma entrada desatualizada detetada.',
            stale_name: 'Nome',
            stale_announcement: 'Encontradas {0} entradas de sistema desatualizadas e {1} fluxos desatualizados',
            last_updated: 'Última atualização',
            status_draft: 'Rascunho',
            status_active: 'Ativo',
            status_completed: 'Concluído',
            task_status_pending: 'Pendente',
            task_status_in_progress: 'Em andamento',
            task_status_completed: 'Concluído',
            scope_systems: 'Sistemas',
            scope_flows: 'Fluxos de dados',
            scope_activities: 'Atividades',
            scope_categories: 'Categorias',
            scope_purposes: 'Finalidades',
            scope_retention: 'Retenção',
        },
        governance: {
            title: 'Atribuições de Governança',
            assign: 'Atribuir Propriedade',
            entity_type: 'Tipo de Entidade',
            entity: 'Entidade',
            role: 'Função',
            assigned_by: 'Atribuído por',
            assigned_at: 'Atribuído em',
            remove: 'Remover',
            no_assignments: 'Sem atribuições de governança.',
            assign_success: 'Propriedade atribuída.',
            remove_success: 'Atribuição removida.',
            assignee: 'Atribuído',
            department: 'Departamento',
            all_departments: 'Todos os departamentos',
            roles: {
                data_owner: 'Proprietário de Dados',
                data_steward: 'Administrador de Dados',
                data_custodian: 'Custodiante de Dados',
                informed: 'Informado',
            },
            entity_types: {
                system: 'Sistema',
                flow: 'Fluxo de dados',
                activity: 'Atividade',
                category: 'Categoria',
                purpose: 'Finalidade',
                retention_policy: 'Política de retenção',
            },
        },
        risk_assessment: {
            title: 'Avaliação de Riscos',
            create: 'Nova Avaliação',
            safeguard_type: 'Tipo de Salvaguarda',
            adequacy_status: 'Estado de Adequação',
            risk_factors: 'Fatores de Risco',
            mitigations: 'Medidas de Mitigação',
            reviewer: 'Revisor',
            decision: 'Decisão',
            approve: 'Aprovar',
            reject: 'Rejeitar',
            no_assessments: 'Sem avaliações de riscos.',
            create_success: 'Avaliação de riscos criada.',
            approve_success: 'Avaliação aprovada.',
            reject_success: 'Avaliação rejeitada.',
            one_per_line: 'Um por linha',
            safeguard_adequacy_decision: 'Decisão de adequação',
            safeguard_standard_contractual_clauses: 'Cláusulas contratuais tipo',
            safeguard_binding_corporate_rules: 'Regras corporativas vinculativas',
            safeguard_explicit_consent: 'Consentimento explícito',
            safeguard_legal_obligation: 'Obrigação legal',
            safeguard_none: 'Nenhuma',
            safeguard_other: 'Outra',
            adequacy_adequate: 'Adequado',
            adequacy_inadequate: 'Inadequado',
            adequacy_under_review: 'Em revisão',
            adequacy_not_assessed: 'Não avaliado',
            decision_approved: 'Aprovado',
            decision_rejected: 'Rejeitado',
        },
        review: {
            title: 'Tarefas de Revisão',
            description: 'As tarefas de revisão são criadas automaticamente quando uma categoria de dados é proposta. Para criar uma nova tarefa, vá a Categorias de Dados e clique em Propor numa categoria rascunho.',
            count: 'tarefas de revisão',
            summary: 'Resumo da Revisão',
            pending: 'Pendentes',
            resolved_today: 'Resolvidas Hoje',
            escalated: 'Escaladas',
            overdue: 'Atrasadas (>5 dias)',
            all_statuses: 'Todos os Estados',
            status_pending: 'Pendente',
            status_resolved: 'Resolvido',
            status_escalated: 'Escalado',
            category_name: 'Categoria',
            system_name: 'Sistema',
            owner: 'Responsável',
            resolve: 'Resolver',
            resolve_task: 'Resolver Tarefa de Revisão',
            resolution: 'Resolução',
            resolution_approve: 'Aprovar',
            resolution_modify: 'Modificar e Aprovar',
            resolution_reject: 'Rejeitar',
            resolution_escalate: 'Escalar',
            notes: 'Notas de Resolução',
            notes_required: 'Notas obrigatórias (mínimo 10 caracteres) para Modificar, Rejeitar ou Escalar',
            resolved_success: 'Tarefa de revisão resolvida',
            bulk_approve: 'Aprovação em Massa',
            bulk_reject: 'Rejeição em Massa',
            bulk_success: '{count} tarefas processadas',
            no_tasks: 'Nenhuma tarefa de revisão encontrada',
        },
        inventory: {
            title: 'Inventário de Classificação',
            count: 'sistemas',
            summary: 'Resumo do Inventário',
            total_systems: 'Total de Sistemas',
            total_labels: 'Total de Etiquetas',
            system_name: 'Sistema',
            label_count: 'Etiquetas',
            approved_count: 'Aprovados',
            pending_count: 'Pendentes',
            no_items: 'Nenhum item de inventário encontrado',
        },
        exceptions: {
            title: 'Exceções de Classificação',
            count: 'exceções',
            all_severities: 'Todas as Severidades',
            all_statuses: 'Todos os Estados',
            system_name: 'Sistema',
            severity_label: 'Severidade',
            status_open: 'Aberta',
            status_resolved: 'Resolvida',
            status_accepted_risk: 'Risco Aceite',
            resolve: 'Resolver',
            resolve_exception: 'Resolver Exceção',
            resolution_type: 'Tipo de Resolução',
            notes: 'Notas',
            justification_required: 'Justificação obrigatória (mínimo 10 caracteres) para risco aceite',
            resolved_success: 'Exceção resolvida',
            no_exceptions: 'Nenhuma exceção encontrada',
        },
        history: {
            title: 'Histórico de Classificação',
            count: 'eventos',
            actor: 'Ator',
            action: 'Ação',
            entity_type: 'Tipo de Entidade',
            changes: 'Alterações',
            view_lineage: 'Ver Linhagem',
            lineage_title: 'Linhagem de Classificação',
            no_events: 'Nenhum evento de histórico encontrado',
            no_lineage: 'Nenhum dado de linhagem disponível',
            modified: 'Modificado',
            created: 'Criado',
            removed: 'Removido',
            action_created: 'Criado',
            action_updated: 'Atualizado',
            action_archived: 'Arquivado',
            action_approved: 'Aprovado',
            action_deprecated: 'Obsoleto',
            entity_label: 'Etiqueta',
            entity_taxonomy: 'Taxonomia',
            entity_review_task: 'Tarefa de Revisão',
            entity_exception: 'Exceção',
            before: 'Antes',
            after: 'Depois',
        },
    },
    governance: {
        audit_trail_title: 'Trilha de auditoria de governança',
        audit_trail_subtitle: 'Fluxo de auditoria multi-entidade para ações de governança — aprovações, execuções de playbook, ligações de evidência e mais.',
        audit_trail_item_count: 'eventos de auditoria',
        audit_trail_fetch_error: 'Falha ao obter eventos de auditoria.',
        audit_trail_no_events: 'Nenhum evento de auditoria encontrado para os filtros atuais.',
        audit_trail_entity_type: 'Tipo de entidade',
        audit_trail_entity_id: 'ID da entidade',
        audit_trail_action: 'Ação',
        audit_trail_actor: 'Ator',
        audit_trail_timestamp: 'Carimbo de data/hora',
        audit_trail_date_from: 'De',
        audit_trail_date_to: 'Até',
        audit_trail_no_rows_to_export: 'Sem linhas para exportar.',
        nav: {
            vendors: 'Fornecedores',
            subprocessors: 'Subcontratantes',
            cross_border: 'Transfronteiriço',
            drift: 'Monitor de Desvios',
            scores: 'Pontuação de Conformidade',
            playbooks: 'Manuais de Procedimentos',
            approvals: 'Aprovações',
            audit_trail: 'Trilha de auditoria',
            board_report: 'Relatório do Conselho',
            evidence: 'Evidências',
            onboarding: 'Pipeline de integração',
            dpa_reviews: 'Revisões de DPA',
            periodic_reviews: 'Revisões periódicas',
            offboarding: 'Desvinculação',
        },
        vendors: {
            title: 'Registo de Fornecedores',
            new: 'Novo Fornecedor',
            edit: 'Editar Fornecedor',
            name: 'Nome',
            jurisdiction: 'Jurisdição',
            dpa_status: 'Estado do APD',
            risk_level: 'Nível de Risco',
            onboarding_status: 'Estado de Integração',
            contact_email: 'Correio Eletrónico de Contacto',
            contact_name: 'Nome do Contacto',
            contact_phone: 'Telefone de Contacto',
            website: 'Sítio Web',
            services_csv: 'Serviços (separados por vírgulas)',
            country: 'País',
            country_placeholder: 'ex. PT',
            last_reviewed: 'Última Revisão',
            offboard: 'Desvincular',
            offboard_vendor: 'Desvincular Fornecedor',
            offboard_reason: 'Motivo da desvinculação',
            no_vendors: 'Nenhum fornecedor encontrado',
            vendor_count: '{count} fornecedor(es)',
            all_dpa_status: 'Todos os Estados DPA',
            all_risk_levels: 'Todos os Níveis de Risco',
            all_onboarding: 'Todas as Integrações',
            fetch_error: 'Falha. Por favor, tente novamente.',
            save_error: 'Falha ao guardar fornecedor',
            offboard_error: 'Falha ao desvincular',
        },
        vendor_types: {
            processor: 'Subcontratante',
            sub_processor: 'Subcontratante Ulterior',
            controller: 'Responsável pelo Tratamento',
            joint_controller: 'Responsáveis Conjuntos',
        },
        onboarding_statuses: {
            pending_review: 'Revisão Pendente',
            approved: 'Aprovado',
            active: 'Ativo',
            suspended: 'Suspenso',
            offboarded: 'Desvinculado',
        },
        dpa_statuses: {
            not_required: 'Não Necessário',
            required_missing: 'Necessário em Falta',
            draft: 'Rascunho',
            under_review: 'Em Revisão',
            signed: 'Assinado',
            expired: 'Expirado',
        },
        risk_levels: {
            critical: 'Crítico',
            high: 'Alto',
            medium: 'Médio',
            low: 'Baixo',
        },
        approval_statuses: {
            pending: 'Pendente',
            approved: 'Aprovado',
            rejected: 'Rejeitado',
            expired: 'Expirado',
        },
        approval_action_types: {
            vendor_onboarding: 'Integração de Fornecedor',
            vendor_offboarding: 'Desvinculação de Fornecedor',
            cross_border_acceptance: 'Aprovação Transfronteiriça',
            playbook_activation: 'Ativação do Playbook',
            drift_accept_risk: 'Desvio Risco Aceite',
            activity_activation: 'Ativação de Atividade',
        },
        drift_check_types: {
            dpa_expiry: 'Expiração do DPA',
            dpa_missing: 'DPA em Falta',
            review_overdue: 'Revisão em Atraso',
            cross_border_gap: 'Lacuna Transfronteiriça',
            sub_processor_chain: 'Cadeia de Subcontratantes',
            risk_assessment_overdue: 'Avaliação de Risco em Atraso',
            retention_policy_missing: 'Política de Retenção em Falta',
            evidence_expiring: 'Evidência a Expirar',
        },
        drift_statuses: {
            open: 'Aberto',
            acknowledged: 'Confirmado',
            in_progress: 'Em Progresso',
            resolved: 'Resolvido',
            accepted_risk: 'Risco Aceite',
        },
        drift_entity_types: {
            vendor: 'Fornecedor',
            system: 'Sistema',
            data_flow: 'Fluxo de Dados',
            processing_activity: 'Atividade de Tratamento',
            evidence_item: 'Elemento de Evidência',
        },
        playbook_statuses: {
            draft: 'Rascunho',
            active: 'Ativo',
            archived: 'Arquivado',
        },
        playbook_action_types: {
            delete_data: 'Eliminar Dados',
            verify_deletion: 'Verificar Eliminação',
            notify_vendor: 'Notificar Fornecedor',
            confirm_receipt: 'Confirmar Receção',
            document_evidence: 'Documentar',
            other: 'Outro',
        },
        playbook_target_types: {
            system: 'Sistema',
            vendor: 'Fornecedor',
        },
        dpa_chain_statuses: {
            complete: 'Completo',
            incomplete: 'Incompleto',
            unknown: 'Desconhecido',
        },
        sub_processor_statuses: {
            active: 'Ativo',
            terminated: 'Cessado',
        },
        evidence_types: {
            dpa_agreement: 'Acordo DPA',
            risk_assessment: 'Avaliação de Risco',
            audit_report: 'Relatório de Auditoria',
            certification: 'Certificação',
            deletion_confirmation: 'Confirmação de Eliminação',
            training_record: 'Registo de Formação',
            incident_report: 'Relatório de Incidente',
            document: 'Documento',
            screenshot: 'Captura de Ecrã',
            policy: 'Política',
            contract: 'Contrato',
            assessment: 'Avaliação',
            correspondence: 'Correspondência',
            other: 'Outro',
        },
        linkable_entity_types: {
            vendor: 'Fornecedor',
            transfer_mechanism: 'Mecanismo de Transferência',
            playbook: 'Livro de procedimentos',
            execution: 'Execução',
            system: 'Sistema',
            activity: 'Atividade',
        },
        subprocessors: {
            title: 'Relações com Subcontratantes',
            new: 'Nova Associação',
            vendor: 'Fornecedor',
            subprocessor: 'Subcontratante',
            relationship_type: 'Tipo de Relação',
            countries: 'Países',
            countries_csv: 'Países (separados por vírgulas)',
            dpa_chain: 'Cadeia DPA',
            dpa_chain_status: 'Estado da Cadeia DPA',
            no_processors: 'Nenhum subcontratante encontrado.',
            no_subprocessors: 'Nenhum subcontratante ulterior encontrado.',
            processor_vendor: 'Fornecedor Subcontratante',
            select_processor: 'Selecionar Subcontratante',
            select_vendor: 'Selecionar Fornecedor',
            services: 'Serviços',
            sub_processor_vendor_id: 'ID do Fornecedor Subcontratante Ulterior',
            terminate: 'Cessar',
            confirm_terminate: 'Tem a certeza de que pretende cessar esta relação?',
            create_error: 'Falha ao criar associação.',
            fetch_error: 'Falha ao obter subcontratantes.',
            processor: 'Subcontratante',
            services_csv: 'Serviços (separados por vírgulas)',
            terminate_error: 'Falha ao cessar.',
            version_history_heading: 'Controle de versão de alteração de subprocessador',
            change_tracking_note: 'Todas as alterações no relacionamento do subprocessador são versionadas. Cada modificação registra o estado antes/depois para trilha de auditoria.',
            history_retention_note: 'O histórico de alterações é retido durante todo o período de retenção de dados. Revise os logs de alterações por meio da visualização detalhada do fornecedor.',
            vendor_risk_cross_view_heading: 'Registo de subcontratantes (Vendor Risk)',
            vendor_risk_cross_view_source: 'Origem: Registo Vendor Risk',
            vendor_risk_cross_view_empty: 'Sem entradas no registo Vendor Risk.',
        },
        cross_border: {
            title: 'Relatório de Governação Transfronteiriça',
            flows: 'Fluxos Transfronteiriços',
            transfers: 'Transferências Transfronteiriças',
            detected_gaps: 'Lacunas Detetadas',
            safeguards: 'Garantias',
            cross_border_vendors: 'Fornecedores Transfronteiriços',
            destination: 'Destino',
            no_cross_border_vendors: 'Nenhum fornecedor transfronteiriço encontrado.',
            no_safeguard: 'Sem garantia',
            processing_locations: 'Locais de Tratamento',
            export_error: 'Falha ao exportar relatório.',
            export_pdf: 'Exportar PDF',
            export_success: 'Relatório exportado com sucesso.',
            exporting: 'A exportar...',
            fetch_error: 'Falha ao obter dados transfronteiriços.',
            source: 'Origem',
            pdpl_p2_heading: '[[TOK_0]]-P2 Conformidade de transferência transfronteiriça',
            dossier_prep_note: 'Preparação do dossiê: reúna a avaliação de impacto, a base jurídica e proteja a documentação antes do arquivamento.',
            filing_tracking_note: 'Rastreamento de arquivamento: monitore o status do envio junto à Autoridade (PDPC) desde a solicitação inicial até a aprovação.',
            supplement_loop_note: 'Ciclo suplementar: responder aos pedidos de informação da Autoridade e reenviar dossiês alterados conforme necessário.',
            official_forms_note: 'Formulários oficiais: use Mau so 01a (Aplicativo), Mau so 01b (Informações Complementares) e Mau so 09 (Avaliação de Impacto de Transferência) de acordo com os regulamentos [[TOK_0]]-P2.',
            vendor_search_label: 'Pesquisa de fornecedor',
            vendor_search_placeholder: 'Pesquisar por nome do fornecedor…',
            jurisdiction_filter_label: 'Jurisdição',
            filings_section_heading: 'Arquivos transfronteiriços',
            filings_empty: 'Ainda não há registros. Crie um para iniciar um dossiê.',
            filings_create_button: 'Novo arquivamento',
            filings_table_id: 'ID de arquivamento',
            filings_table_jurisdiction: 'Jurisdição',
            filings_table_type: 'Tipo de formulário',
            filings_table_status: 'Estado',
            filings_table_updated: 'Atualizado',
            filings_table_open: 'Abrir',
            filings_detail_title: 'Arquivamento Transfronteiriço',
            filings_back_to_list: 'Voltar para Transfronteiriço',
            filings_status_heading: 'Ciclo de vida',
            filings_evidence_heading: 'Evidência',
            filings_history_heading: 'Trilha de auditoria',
            filings_field_filing_id: 'ID de arquivamento',
            filings_field_jurisdiction: 'Jurisdição',
            filings_field_type: 'Tipo de formulário',
            filings_field_status: 'Estado',
            filings_field_reference: 'Referência de autoridade',
            filings_field_mps_receipt: '[[TOK_0]] recibo',
            filings_field_submitted_at: 'Enviado em',
            filings_field_acknowledged_at: 'Reconhecido em',
            filings_field_archived_at: 'Arquivado em',
            filings_field_version: 'Versão',
            filings_field_notes: 'Notas',
            filings_action_advance: 'Status avançado',
            filings_action_reject: 'Rejeitar',
            filings_action_archive: 'Arquivo',
            filings_action_submit: 'Marcar como enviado',
            filings_action_acknowledge: 'Marco reconheceu',
            filings_action_resume_draft: 'Retomar como rascunho',
            filings_status_draft: 'Rascunho',
            filings_status_assessed: 'Avaliado',
            filings_status_pending_review: 'Revisão pendente',
            filings_status_ready_to_file: 'Pronto para arquivar',
            filings_status_submitted: 'Enviado',
            filings_status_acknowledged: 'Reconhecido',
            filings_status_rejected: 'Rejeitado',
            filings_status_archived: 'Arquivado',
            filings_type_mau_01a: 'Mẫu 01a — Pedido de transferência',
            filings_type_mau_03a: 'Mẫu 03a — Dossiê de suplemento',
            filings_type_mau_09: 'Março 09 — Avaliação do impacto da transferência',
            filings_new_dialog_title: 'Novo pedido transfronteiriço',
            filings_new_form_jurisdiction: 'Jurisdição (por exemplo, VN-[[TOK_0]])',
            filings_new_form_type: 'Tipo de formulário',
            filings_new_form_notes: 'Notas (opcional)',
            filings_new_submit: 'Criar',
            filings_new_cancel: 'Cancelar',
            filings_reason_label: 'Razão',
            filings_reference_label: 'Número de referência da autoridade',
            filings_mps_receipt_label: '[[TOK_0]] referência do recibo',
            filings_create_error: 'Falha ao criar arquivo.',
            filings_create_success: 'Arquivo criado.',
            filings_update_error: 'Falha ao atualizar o arquivamento.',
            filings_update_success: 'Arquivo atualizado.',
            filings_fetch_error: 'Falha ao buscar registros.',
            filings_archive_confirm: 'Arquivar este arquivo? Isto não pode ser desfeito.',
            filings_status_rejected_detour: 'O arquivamento foi rejeitado após análise. Retome como rascunho para reiniciar o fluxo.',
            recent_exports_heading: 'Exportações recentes',
            recent_exports_empty: 'Ainda não há exportações. Clique em "Exportar [[TOK_0]]" para gerar um.',
        },
        drift: {
            title: 'Monitor de Desvios de Configuração',
            drift_type: 'Tipo de Desvio',
            severity: 'Gravidade',
            detected_at: 'Detetado Em',
            resolve: 'Resolver',
            all_check_types: 'Todos os Tipos de Verificação',
            all_entity_types: 'Todos os Tipos de Entidade',
            event_count: 'Contagem de Eventos',
            accept_risk: 'Aceitar Risco',
            acknowledge: 'Confirmar',
            assign_error: 'Falha ao atribuir.',
            assign_event: 'Atribuir',
            assigned: 'Atribuído',
            enter_resolution_notes: 'Introduzir notas de resolução...',
            enter_user_id: 'Introduzir ID do utilizador...',
            entity: 'Entidade',
            fetch_error: 'Falha ao obter eventos de desvio.',
            no_events: 'Nenhum evento de desvio encontrado.',
            resolution_notes: 'Notas de Resolução',
            update_status_error: 'Falha ao atualizar estado.',
        },
        scores: {
            title: 'Painel de Pontuação de Conformidade',
            overall: 'Pontuação Global de Conformidade',
            breakdown: 'Desagregação da Pontuação por Módulo',
            trend: 'Tendência Histórica',
            module: 'Módulo',
            score: 'Pontuação',
            grade: 'Classificação',
            calculated_at: 'Calculado Em',
            generate_board_report: 'Gerar Relatório para a Direção',
            lang_english: 'Inglês',
            lang_vietnamese: 'Vietnamita',
            fetch_error: 'Falha ao obter pontuações de conformidade.',
            generate_report: 'Gerar Relatório',
            generating: 'A gerar...',
            recommendations: 'Recomendações',
            report_error: 'Falha ao gerar relatório.',
            factor_owner_assigned: 'Proprietário atribuído',
            factor_data_categories_linked: 'Categorias de dados vinculadas',
            factor_purposes_linked: 'Finalidades vinculadas',
            factor_data_flows_documented: 'Fluxos de dados documentados',
            factor_processing_activity_linked: 'Atividade de tratamento vinculada',
            factor_dpa_status: 'Estado do DPA',
            factor_retention_policy_linked: 'Política de retenção vinculada',
            factor_last_reviewed: 'Última revisão dentro do limite',
            factor_risk_assessment_current: 'Avaliação de riscos atualizada',
            factor_sub_processors_documented: 'Subcontratantes documentados',
            factor_cross_border_safeguards: 'Salvaguardas transfronteiriças',
            factor_contact_info_complete: 'Informações de contacto completas',
            factor_onboarding_approved: 'Integração aprovada',
            factor_avg_system_score: 'Pontuação média do sistema',
            factor_avg_vendor_score: 'Pontuação média do fornecedor',
            factor_processing_activity_coverage: 'Cobertura das atividades de tratamento',
            factor_ropa_completeness: 'Completude do RoPA',
            factor_open_drift_events: 'Eventos de desvio em aberto',
        },
        playbooks: {
            title: 'Manuais de Procedimentos de Apagamento',
            new: 'Novo Manual',
            edit: 'Editar Manual',
            steps: 'Passos',
            add_step: 'Adicionar Passo',
            remove_step: 'Remover Passo',
            data_categories_csv: 'Categorias de Dados (separados por vírgulas)',
            estimated_duration: 'Duração Estimada',
            estimated_duration_label: 'Duração Estimada',
            evidence_description: 'Descrição da Evidência',
            no_playbooks: 'Nenhum manual encontrado.',
            playbook_count: 'Número de Manuais',
            requires_evidence: 'Requer Evidência',
            step_label: 'Rótulo do Passo',
            target_name: 'Nome do alvo',
            target_type: 'Tipo de Alvo',
            action_type: 'Tipo de Ação',
            archive_error: 'Falha ao arquivar.',
            confirm_archive: 'Tem a certeza de que pretende arquivar este manual?',
            data_categories: 'Categorias de Dados',
            days: 'dias',
            fetch_error: 'Falha ao obter manuais.',
            sla_days: 'SLA (dias)',
            target_id: 'ID do Alvo',
            template_class_heading: 'Classificação do modelo',
            official: 'Oficial',
            internal: 'Interno',
            classification: 'Classificação',
            official_note: 'Oficial: modelos obrigatórios regulatórios alinhados com [[TOK_1]], [[TOK_0]] ou requisitos específicos do setor.',
            internal_note: 'Internos: procedimentos específicos da organização não derivados de modelos regulatórios.',
            active_executions_heading: 'Execuções ativas',
            no_active_executions: 'Sem execuções ativas.',
            playbook_label: 'Manual',
            ticket_id_label: 'Bilhete',
            progress_label: 'Progresso',
            actions_label: 'Ações',
            view_steps_label: 'Ver passos',
            execution_detail_title: 'Detalhe da execução',
            playbook_missing: 'Manual não encontrado.',
            evidence_required_label: 'Prova necessária',
            upload_evidence_label: 'Carregar prova',
            mark_complete_label: 'Marcar como concluído',
            evidence_required_toast: 'É necessária prova antes de concluir este passo.',
            evidence_blocking_message: 'Anexe um ficheiro de prova para continuar.',
            step_completed_toast: 'Passo concluído.',
            executions_fetch_error: 'Falha ao carregar execuções.',
            step_evidence_default_name: 'Prova do passo de execução',
            attached_evidence_label: 'Provas anexadas',
        },
        approvals: {
            title: 'Fluxos de Aprovação',
            new: 'Nova Aprovação',
            edit: 'Editar Aprovação',
            request_type: 'Tipo de Pedido',
            requester: 'Requerente',
            approve: 'Aprovar',
            reject: 'Rejeitar',
            justification: 'Justificação',
            all_action_types: 'Todos os Tipos de Ação',
            decided_by: 'Decidido Por',
            no_approvals: 'Nenhuma aprovação encontrada.',
            approval_count: 'Número de Aprovações',
            approval_notes_optional: 'Notas (opcional)',
            approve_error: 'Falha ao aprovar.',
            approve_request: 'Aprovar Pedido',
            decision: 'Decisão',
            entity: 'Entidade',
            fetch_error: 'Falha ao obter aprovações.',
            reject_error: 'Falha ao rejeitar.',
            reject_request: 'Rejeitar Pedido',
            rejection_notes_required: 'Notas de rejeição obrigatórias',
            rejection_notes_required_msg: 'Por favor, indique o motivo da rejeição.',
            requested_at: 'Solicitado Em',
            multi_step_heading: 'Fluxo de trabalho de aprovação em várias etapas',
            legal_review_note: 'Etapa 1 — Revisão Jurídica: O consultor jurídico analisa a solicitação de conformidade regulatória.',
            dpo_review_note: 'Etapa 2 — [[TOK_0]] Revisão: O responsável pela proteção de dados valida as implicações da proteção de dados.',
            management_review_note: 'Etapa 3 — Aprovação da Administração: A alta administração fornece a autorização final.',
            supporting_evidence_label: 'Prova de apoio (opcional)',
            decision_evidence_name: 'Prova de decisão',
        },
        evidence: {
            title: 'Evidências de Governação',
            new: 'Nova Evidência',
            link_to: 'Associar A',
            entity_id_placeholder: 'ID da Entidade',
            file_path_placeholder: '/caminho/para/ficheiro',
            evidence_label: 'Rótulo da Evidência',
            file_path: 'Caminho do Ficheiro',
            source_mode_label: 'Fonte da evidência',
            source_mode_file: 'Carregar ficheiro',
            source_mode_url: 'Ligar URL externa',
            attachment_label: 'Anexo',
            item_count: 'Número de Itens',
            link_button: 'Associar Evidência',
            confirm_delete: 'Tem a certeza de que pretende eliminar esta evidência?',
            enter_entity_id: 'Introduzir ID da entidade...',
            entity_id: 'ID da Entidade',
            entity_type: 'Tipo de Entidade',
            expires: 'Expira',
            expires_at: 'Expira Em',
            fetch_error: 'Falha ao obter evidências.',
            link_error: 'Falha ao associar evidência.',
            no_evidence: 'Nenhuma evidência encontrada.',
            tags_csv: 'Etiquetas (separadas por vírgulas)',
            uploaded: 'Carregado',
            url: 'URL',
            framework_tag_heading: 'Evidências Marcadas pela Estrutura',
            framework_tag_note: 'Cada registro de evidência captura o código da estrutura, o ator e o carimbo de data/hora. Filtre por estrutura para isolar registros relevantes para auditoria.',
            framework_code: 'Código Estrutural',
            filter_by_framework: 'Filtrar por código de estrutura...',
            actor: 'Ator',
        },
        certification: {
            not_applicable: 'Não aplicável',
            not_certified: 'Não certificado',
            pending: 'Pendente',
            certified: 'Certificado',
            revoked: 'Revogado',
        },
        onboarding_pipeline: {
            title: 'Pipeline de integração',
            new_workflow: 'Novo fluxo de integração',
            vendor_id: 'ID do fornecedor',
            stages: 'Etapas',
            current_stage: 'Etapa atual',
            advance: 'Avançar etapa',
            advance_success: 'Etapa avançada com sucesso',
            workflow_status: 'Estado do fluxo',
            initiated: 'Iniciado',
            in_progress: 'Em andamento',
            completed: 'Concluído',
            cancelled: 'Cancelado',
            no_workflows: 'Nenhum fluxo de integração encontrado',
            stages_placeholder: 'Etapa 1, Etapa 2, Etapa 3',
            assigned_to: 'Atribuído a',
            notes: 'Notas',
            pdpl_lifecycle_heading: '[[TOK_0]] Ciclo de vida do fornecedor – integração',
            due_diligence_note: 'O estágio de due diligence é obrigatório antes da integração de qualquer processador em [[TOK_0]]. Verifique o escopo do processamento de dados, a base legal e as medidas de segurança.',
            contract_review_note: 'A revisão do contrato deve confirmar as cláusulas do DPA, os limites de retenção de dados e as restrições do subprocessador.',
            create_dpa_review_cta: 'Criar revisão DPA',
            dpa_review_linked: 'Revisão DPA ligada',
        },
        dpa_review: {
            title: 'Revisões de DPA',
            new_review: 'Nova revisão de DPA',
            review_type: 'Tipo de revisão',
            findings: 'Constatações',
            outcome: 'Resultado',
            complete_review: 'Concluir revisão',
            complete_success: 'Revisão concluída com sucesso',
            link_assessment: 'Vincular avaliação de segurança',
            link_success: 'Avaliação vinculada com sucesso',
            assessment_id: 'ID da avaliação',
            combined_title: 'Avaliação combinada',
            no_reviews: 'Nenhuma revisão de DPA encontrada',
            telecom_disclosure_heading: 'Governança de divulgação de telecomunicações',
            disclosure_trigger_note: 'As análises acionadas por divulgação capturam eventos de compartilhamento de dados de assinantes de telecomunicações de acordo com a Lei VN Telecom.',
            telecom_t2_note: 'A aprovação do nível TELECOM-T2 é necessária antes de divulgar os dados do assinante às autoridades.',
            quarterly_log_note: 'Use o registro trimestral para documentar todos os eventos de divulgação e manter uma trilha de auditoria contínua.',
        },
        periodic_review: {
            title: 'Revisões periódicas',
            new_review: 'Nova revisão periódica',
            review_type: 'Tipo de revisão',
            due_date: 'Data de vencimento',
            next_review: 'Próxima data de revisão',
            trigger_reassessment: 'Acionar reavaliação',
            reassessment_reason: 'Motivo da reavaliação',
            reassessment_success: 'Reavaliação acionada com sucesso',
            complete_success: 'Revisão concluída com sucesso',
            scheduled: 'Agendada',
            in_progress: 'Em andamento',
            completed: 'Concluída',
            overdue: 'Atrasada',
            material_change: 'Alteração significativa',
            no_reviews: 'Nenhuma revisão periódica encontrada',
            mark_complete: 'Marcar como concluído',
            pdpl_periodic_heading: '[[TOK_0]] Ciclo de vida do fornecedor – revisões periódicas',
            scheduled_review_note: 'As revisões periódicas devem ser agendadas pelo menos uma vez por ano para todos os processadores ativos. As revisões atrasadas acionam alertas de conformidade.',
            material_change_note: 'Mudanças materiais no processamento de dados exigem reavaliação imediata, independentemente do cronograma.',
            overdue_badge: 'Em atraso',
            overdue_aria: 'Revisão em atraso',
            only_overdue_filter: 'Apenas em atraso',
        },
        offboarding: {
            title: 'Desvinculação de fornecedor',
            initiate: 'Iniciar desvinculação',
            initiate_success: 'Desvinculação iniciada com sucesso',
            reason: 'Motivo da desvinculação',
            data_return_required: 'Devolução de dados obrigatória',
            verify_data: 'Verificar devolução de dados',
            verify_success: 'Devolução de dados verificada com sucesso',
            sign_off: 'Aprovar',
            sign_off_success: 'Desvinculação aprovada com sucesso',
            status_initiated: 'Iniciada',
            status_data_pending: 'Devolução de dados pendente',
            status_data_verified: 'Devolução de dados verificada',
            status_completed: 'Concluída',
            status_cancelled: 'Cancelada',
            task_id: 'ID da tarefa',
            no_tasks: 'Nenhuma tarefa de desvinculação encontrada',
            evidence_id: 'ID de evidência',
            pdpl_offboarding_heading: '[[TOK_0]] Ciclo de vida do fornecedor — desativação e exclusão',
            deletion_capture_note: 'O offboarding deve capturar a confirmação de exclusão de dados do fornecedor. Verifique o retorno dos dados antes da aprovação.',
            evidence_attachment_note: 'Anexe evidências de exclusão (certificados, capturas de tela, confirmações de fornecedores) para completar o registro de desligamento.',
            verify_mode_label: 'Método de verificação',
            verify_mode_upload: 'Carregar novo ficheiro',
            verify_mode_link: 'Ligar prova existente',
            verify_mode_none: 'Nenhum dado a devolver',
            upload_data_return_evidence: 'Carregar prova de devolução de dados',
            no_data_justification_label: 'Justificação',
            no_data_justification_placeholder: 'Explica por que não há dados a devolver',
            no_data_justification_hint: 'Mínimo 20 caracteres',
            upload_required_toast: 'Anexe um ficheiro para continuar',
            evidence_link_required_toast: 'Selecione uma prova para continuar',
            no_data_justification_required_toast: 'Forneça uma justificação de pelo menos 20 caracteres',
            data_return_evidence_name: 'Prova de devolução de dados',
        },
        dpa_review_types: {
            initial: 'Inicial',
            annual: 'Anual',
            renewal: 'Renovação',
            incident_triggered: 'Por incidente',
        },
        periodic_review_types: {
            initial: 'Inicial',
            annual: 'Anual',
            renewal: 'Renovação',
            incident_triggered: 'Por incidente',
            material_change: 'Alteração material',
            disclosure_triggered: 'Por divulgação',
            quarterly_log: 'Registo trimestral',
        },
        dpa_review_statuses: {
            pending: 'Pendente',
            in_progress: 'Em andamento',
            completed: 'Concluído',
            cancelled: 'Cancelado',
        },
        onboarding_stage_names: {
            due_diligence: 'Due diligence',
            contract_review: 'Revisão de contrato',
            security_assessment: 'Avaliação de segurança',
            data_mapping: 'Mapeamento de dados',
            approval: 'Aprovação',
            integration: 'Integração',
        },
        access_denied_title: 'Acesso negado',
        access_denied: 'Não tem permissão para visualizar esta página. Contacte o seu administrador.',
    },
    consent: {
        nav: {
            policies: 'Políticas',
            purposes: 'Catálogo de Finalidades',
            workflows: 'Fluxos de Trabalho',
            snapshots: 'Capturas CMP',
            change_awareness: 'Deteção de Alterações',
            audit: 'Auditoria de Consentimento',
        },
        gap_analysis: {
            nav_label: 'Análise de lacunas',
            page_title: 'Análise de lacuna de consentimento',
            page_subtitle: 'Forseti verifica seus fins de consentimento ativo em relação aos requisitos da estrutura instalada ([[TOK_0]] Art.7 + Art.6 + Art.9, [[TOK_1]] Art.13 + Art.20, PIPL Art.13 + Art.29) e superfícies lacunas com citação + remediação sugerida.',
            framework_picker_label: 'Estruturas',
            org_flags_label: 'Contexto da organização',
            flag_withdrawal: 'Tem mecanismo de retirada global documentado',
            flag_parental: 'Possui fluxo de consentimento dos pais para menores de 16 anos',
            flag_cross_border: 'Tem registro transfronteiriço',
            run_label: 'Execute a análise de lacunas',
            running_label: 'Correndo…',
            requires_advisor_label: 'Requer permissão de ai_advisor:chat.',
            results_heading: 'Lacunas surgiram ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            empty_label: 'Nenhuma lacuna detectada para as estruturas selecionadas.',
            remediation_label: 'Correção sugerida:',
            dismiss_label: 'Descartar como não aplicável',
            resolve_label: 'Resolver',
            dismissed_label: 'Rejeitado como não aplicável',
            resolved_label: 'Resolvido',
        },
        import: {
            title: 'Importar fluxos de consentimento',
            nav_title: 'Importação em massa',
            description: 'Faça upload de um ficheiro CSV para importar em massa fluxos de trabalho de consentimento.',
            select_file: 'Selecionar ficheiro CSV',
            file_help: 'CSV com cabeçalhos correspondentes aos campos do fluxo de trabalho.',
            required_columns_help: 'Colunas obrigatórias: Tipo de fluxo, Titular dos dados, Canal.',
            file_too_large: 'Ficheiro demasiado grande. O tamanho máximo é 2MB.',
            preview: 'Pré-visualização',
            columns_detected: 'Colunas detetadas: {count}',
            column_mapping: 'Mapeamento de colunas',
            import_button: 'Importar',
            import_complete: 'Importação concluída',
            import_error: 'A importação falhou',
            result: 'Resultado da importação',
            total: 'Total',
            imported: 'Importado',
            skipped: 'Ignorado',
            failed: 'Falhado',
            errors: 'Erros',
            error_row: 'Linha',
            error_field: 'Campo',
            error_message: 'Mensagem',
            history: 'Histórico de importação',
            no_history: 'Sem histórico de importação.',
            history_file: 'Nome do ficheiro',
            history_date: 'Data',
            create_profiles_label: 'Criar perfis de Titular dos dados para novos titulares',
            create_profiles_help: 'Importações sem um perfil correspondente criam um automaticamente. Desmarque para importar apenas fluxos de trabalho.',
            profiles_created: 'Perfis criados',
            profiles_matched: 'Perfis correspondentes',
            subject_kind_help: 'Colunas opcionais: subject_kind, subject_email, subject_display_name, subject_phone, external_ref_key.',
            error_subject_invalid_email: 'E-mail inválido na coluna subject_email.',
            error_subject_unknown_kind: 'Valor de subject_kind desconhecido. Esperado: email, visitor_uuid, employee_id, student_id, external_ref.',
            error_missing_external_ref_key: 'external_ref_key é obrigatório quando subject_kind=external_ref',
        },
        policies: {
            title: 'Políticas de Consentimento',
            new: 'Nova Política',
            edit: 'Editar Política',
            name: 'Nome',
            version: 'Versão',
            policy_text: 'Texto da Política',
            publish: 'Publicar',
            versions: 'Versões',
            hide_versions: 'Ocultar versões',
            submit_for_review: 'Submeter para Rever',
            suspend: 'Suspender',
            retire: 'Retirar',
            jurisdictions: 'Jurisdições',
            jurisdictions_csv: 'Jurisdições (separadas por vírgulas)',
            approval_mode: 'Modo de aprovação',
            reviewer_ids: 'IDs de revisores (separados por vírgulas)',
            tags_csv: 'Etiquetas (separadas por vírgulas)',
            effective_date: 'Data de vigência',
            review_date: 'Rever Data',
            consent_model_statement: 'Declaração do modelo de consentimento',
            consent_model_placeholder: 'Declaração opcional do modelo de consentimento...',
            default_settings: 'Predefinido Definições (JSON)',
            changes: 'Alterações',
            fetch_error: 'Falha ao fetch consent policies. Por favor, tente novamente.',
            save_error: 'Falha ao save consentimento política. Por favor, tente novamente.',
            submit_review_error: 'Falha ao submit policy for review. Por favor, tente novamente.',
            activate_error: 'Falha ao activate policy. Por favor, tente novamente.',
            suspend_error: 'Falha ao suspend policy. Por favor, tente novamente.',
            retire_error: 'Falha ao retire policy. Por favor, tente novamente.',
            submit_review_success: 'Política enviada para revisão.',
            activate_success: 'Política ativada.',
            suspend_success: 'Política suspensa.',
            retire_success: 'Política desativada.',
            versions_error: 'Falha ao fetch policy versions. Por favor, tente novamente.',
            invalid_json: 'JSON inválido no campo de definições predefinidas. Por favor, tente novamente.',
            page_title: 'Políticas de consentimento',
            version_updated: 'Atualizado',
            version_initial: 'Versão inicial',
            json_format: 'Formato [[TOK_0]]',
            sensitive: 'Sensível',
            flag_sensitive: 'Sensível à bandeira',
            flag_sensitive_title: 'Sinalizar política como sensível',
            require_enhanced_review: 'Exigir revisão aprimorada',
            enhanced_review_success: 'Requisito de revisão aprimorado ativado.',
            select_categories: 'Selecione as categorias de dados confidenciais aplicáveis do [[TOK_0]] Artigo 2:',
            no_policies: 'Nenhuma política de consentimento encontrada. Crie a sua primeira política para começar.',
            approval_success: 'Política aprovada.',
            reviewers_label: 'Revisores',
            enhanced_review_title: 'Revisão aprofundada necessária',
            enhanced_review_badge: 'Revisão aprofundada necessária',
            enhanced_review_status_pending: 'Revisão pendente',
            enhanced_review_status_approved: 'Revisão aprovada',
            enhanced_review_status_rejected: 'Revisão rejeitada',
            enhanced_review_reviewed_by: 'Revisto por',
            enhanced_review_notes: 'Notas de revisão',
            enhanced_review_approve: 'Aprovar revisão',
            enhanced_review_reject: 'Rejeitar revisão',
            enhanced_review_notes_required: 'As notas de revisão são obrigatórias',
            enhanced_review_approved: 'Revisão aprofundada aprovada',
            enhanced_review_rejected: 'Revisão aprofundada rejeitada — política redefinida para rascunho',
            enhanced_review_reset_to_draft: 'Revisão aprofundada rejeitada — política redefinida para rascunho',
            enhanced_review_reject_warning: 'A rejeição irá redefinir esta política para o estado Rascunho. O DPO deve resubmetê-la para revisão após resolver os problemas.',
            submitted_modal_title: 'Enviado para revisão aprofundada',
            submitted_modal_body: 'Esta política foi enviada. Um revisor Jurídico/Privacidade deve aprová-la antes que possa ser ativada.',
        },
        sensitive_categories: {
            health: 'Dados de saude',
            biometric: 'Dados biometricos',
            political: 'Opinioes politicas',
            ethnic: 'Origem etnica',
            genetic: 'Dados geneticos',
            criminal: 'Registos criminais',
        },
        purposes: {
            title: 'Catálogo de Finalidades',
            new: 'Nova Finalidade',
            edit: 'Editar Finalidade',
            name: 'Nome',
            legal_basis: 'Base Jurídica',
            retention_days: 'Período de Retenção (dias)',
            is_active: 'Ativo',
            filter_by_category: 'Filtrar por categoria',
            policy_ids: 'IDs de políticas (separados por vírgulas)',
            ropa_activity_ids: 'IDs de atividades ROPA (separados por vírgulas)',
            policies: 'Políticas',
            deprecate: 'Tornar obsoleto',
            fetch_error: 'Falha ao fetch consent purposes. Por favor, tente novamente.',
            save_error: 'Falha ao save consent purpose. Por favor, tente novamente.',
            deprecate_error: 'Falha ao deprecate consent purpose. Por favor, tente novamente.',
            page_title: 'Catálogo de Finalidade',
            no_purposes: 'Nenhuma finalidade de consentimento encontrada. Crie a sua primeira finalidade para começar.',
            category_personal_data: 'Dados Pessoais',
            category_sensitive_data: 'Dados confidenciais',
            category_health_data: 'Dados de saúde',
            category_financial_data: 'Dados Financeiros',
            category_biometric_data: 'Dados biométricos',
            category_children_data: 'Dados infantis',
            category_location_data: 'Dados de localização',
            category_communications_data: 'Dados de comunicações',
            category_other: 'Outro',
        },
        workflows: {
            title: 'Fluxos de Trabalho de Consentimento',
            new: 'Novo Fluxo de Trabalho',
            edit: 'Editar Fluxo de Trabalho',
            workflow_type: 'Tipo de Fluxo de Trabalho',
            user_id: 'ID do Utilizador',
            purpose_id: 'ID da Finalidade',
            purpose_ids_csv: 'Finalidade ID (comma-separated)',
            reason: 'Motivo',
            process: 'Processar',
            data_subject_ref: 'Dados Titular Reference',
            data_subject: 'Dados Titular',
            channel: 'Canal',
            policy_id: 'Política ID',
            scope: 'Âmbito',
            legal_grounds: 'Bases jurídicas',
            assessment: 'Avaliação',
            select_outcome: 'Selecione Outcome',
            partially_approved: 'Aprovado parcialmente',
            denied: 'Negado',
            outcome_upheld: 'Confirmado',
            outcome_pending: 'Pendente',
            outcome_denied: 'Negado',
            status_count: 'Contagem por estado',
            channel_filter: 'Filtrar por canal',
            add_action: '+ Ação',
            by_type: 'Por Tipo',
            by_status: 'Por Estado',
            downstream_actions: 'Ações a jusante',
            downstream_actions_for: 'Downstream Ações para {subject} ({type})',
            add_downstream_action: 'Adicionar Downstream Action',
            assigned_to: 'Atribuído Para',
            fetch_error: 'Falha ao fetch consent workflows. Por favor, tente novamente.',
            dashboard_error: 'Falha ao fetch workflow dashboard. Por favor, tente novamente.',
            save_error: 'Falha ao save consent workflow. Por favor, tente novamente.',
            status_update_error: 'Falha ao update workflow status. Por favor, tente novamente.',
            assessment_error: 'Falha ao update workflow assessment. Por favor, tente novamente.',
            add_action_error: 'Falha ao add workflow action. Por favor, tente novamente.',
            update_action_error: 'Falha ao update workflow action. Por favor, tente novamente.',
            type_refusal: 'Recusa',
            type_withdrawal: 'Retirada',
            type_restriction: 'Restrição',
            type_objection: 'Oposição',
            status_received: 'Recebido',
            status_processing: 'Tratamento',
            status_under_assessment: 'Em avaliação',
            status_implemented: 'Implementado',
            evidence_button: 'Evidência',
            evidence_modal_title: 'Evidência de fluxo de trabalho',
            no_evidence: 'Nenhuma evidência anexada a este fluxo de trabalho.',
            upload_evidence_label: 'Carregar evidências de fluxo de trabalho',
            completed_at: 'Concluído em',
            effective_date: 'Data Efetiva',
            page_title: 'Fluxos de trabalho de consentimento',
            no_workflows: 'Nenhum fluxo de consentimento encontrado. Os fluxos são criados quando os titulares dos dados exercem os seus direitos.',
            type_grant: 'Concessão',
            propagation_none: 'Nenhum',
            propagation_pending: 'Pendente',
            propagation_pending_warning: 'Não é possível concluir — a propagação de retirada ainda está pendente',
            propagation_completed: 'Concluído',
            propagation_partial: 'Parcial',
            propagation_incomplete_error: 'Não é possível concluir o fluxo enquanto a propagação de retirada ainda estiver pendente',
            propagation_status: 'Estado de propagação',
        },
        snapshots: {
            title: 'Capturas CMP',
            new: 'Nova Captura',
            label: 'Etiqueta',
            snapshot_date: 'Data da Captura',
            purposes_count: 'Número de Finalidades',
            compare: 'Comparar',
            snapshot_data: 'Dados da Captura (JSON)',
            select_left: 'Selecione Left Snapshot',
            select_right: 'Selecione Right Snapshot',
            comparison_results: 'Resultados de comparação',
            field: 'Campo',
            left: 'Esquerda',
            right: 'Direita',
            close_comparison: 'Fechar comparação',
            trigger: 'Acionador',
            trigger_manual: 'Manuais',
            trigger_policy_approval: 'Aprovação de políticas',
            cmp_version: 'Versão de CMP',
            policy_version_id: 'Política Versão ID',
            banner_config: 'Configuração do banner (JSON)',
            active_purposes: 'Ativo Finalidades (JSON)',
            active_legal_bases: 'Bases jurídicas ativas (JSON)',
            domain_scope: 'Âmbito do domínio',
            domain_scope_csv: 'Âmbito do domínio (separado por vírgulas)',
            raw_config: 'Configuração bruta (JSON)',
            checksum: 'Soma de verificação',
            created: 'Criado',
            fetch_error: 'Falha ao fetch cmp snapshots. Por favor, tente novamente.',
            save_error: 'Falha ao save cmp snapshot. Por favor, tente novamente.',
            compare_error: 'Falha ao compare snapshots. Por favor, tente novamente.',
            page_title: 'Instantâneos de consentimento',
            json_format: 'Formato [[TOK_0]]',
            json_array_format: 'formato de matriz [[TOK_0]]',
            manual_snapshot_note: 'Apenas para administradores/desenvolvedores. Em operação normal, os instantâneos são criados automaticamente via webhook CMP ou na aprovação de políticas. Cole o JSON exportado do seu fornecedor CMP (ex. OneTrust, Cookiebot).',
            banner_config_hint: 'Cole o objeto de configuração do banner da sua exportação CMP.',
            active_purposes_hint: 'Array JSON de objetos de finalidades ativas copiados da sua exportação CMP.',
            active_legal_bases_hint: 'Array JSON de objetos de bases legais ativas copiados da sua exportação CMP.',
            raw_config_hint: 'JSON de configuração bruto completo do seu CMP. Os outros campos JSON são extraídos daqui. Uma soma de verificação SHA-256 é calculada automaticamente.',
            changed_field: 'Campo alterado: ',
            no_snapshots: 'Nenhum instantâneo CMP encontrado. Os instantâneos são criados quando as políticas são aprovadas ou acionados manualmente.',
            detail_title: 'Detalhe do instantâneo',
            view_snapshot_detail: 'Ver detalhe do instantâneo',
            policy_version: 'Versão da política',
            removed: 'Antes',
            added: 'Depois',
        },
        change_awareness: {
            title: 'Deteção de Alterações de Consentimento',
            change_type: 'Tipo de Alteração',
            entity_type: 'Tipo de Entidade',
            entity_id: 'ID da Entidade',
            detected_at: 'Detetado Em',
            acknowledge: 'Confirmar',
            new_alert: 'Novo alerta',
            new_alert_form: 'Novo Change Awareness Alert',
            total_open: 'Total Abrir',
            by_severity: 'Por Gravidade',
            snapshot_id: 'ID de instantâneo',
            update_status: 'Atualizar Estado',
            resolution_notes: 'Notas de resolução',
            resolution_required: 'Notas de resolução (obrigatórias)',
            resolution_required_msg: 'As notas de resolução são obrigatórias ao resolver um item.',
            status_open: 'Abrir',
            status_under_review: 'Em revisão',
            status_resolved: 'Resolvido',
            status_accepted: 'Aceite',
            severity_informational: 'Informativo',
            severity_requires_review: 'Requer revisão',
            severity_policy_violation: 'Violação de política',
            create_reconciliation: 'Criar tarefa de reconciliação',
            reconciliation_created: 'Tarefa de reconciliação criada com sucesso.',
            reconciliation_error: 'Falha ao criar tarefa de reconciliação. Por favor, tente novamente.',
            fetch_error: 'Falha ao fetch change awareness items. Por favor, tente novamente.',
            dashboard_error: 'Falha ao fetch change awareness dashboard. Por favor, tente novamente.',
            create_error: 'Falha ao create change awareness item. Por favor, tente novamente.',
            status_update_error: 'Falha ao update change awareness status. Por favor, tente novamente.',
            page_title: 'Conscientização sobre a mudança',
            no_items: 'Nenhum item de consciência de alterações encontrado. Os itens são criados quando são detetadas alterações na configuração do consentimento.',
        },
        audit: {
            title: 'Trilho de Auditoria de Consentimento',
            event_type: 'Tipo de Evento',
            user_id: 'ID do Utilizador',
            timestamp: 'Data e Hora',
            details: 'Detalhes',
            actor: 'Ator',
            filter_by_entity_type: 'Filtrar por tipo de entidade',
            filter_by_action: 'Filtrar por ação',
            fetch_error: 'Falha ao fetch consent audit trail. Por favor, tente novamente.',
            page_title: 'Auditoria de consentimento',
            export_csv: 'Exportar [[TOK_0]]',
            exporting: 'Exportando…',
            export_success: 'Trilha de auditoria exportada com sucesso.',
            export_error: 'Falha ao exportar a trilha de auditoria de consentimento. Por favor, tente novamente.',
            no_entries: 'Nenhuma entrada de auditoria encontrada. Os eventos de auditoria são registados automaticamente quando os dados de consentimento mudam.',
            entity_policy: 'Política',
            entity_purpose: 'Finalidade',
            entity_workflow: 'Fluxo de trabalho',
            entity_consent_record: 'Registo de consentimento',
            entity_change_awareness: 'Consciência de alterações',
            entity_cmp_snapshot: 'Instantâneo CMP',
            action_created: 'Criado',
            action_updated: 'Atualizado',
            action_status_changed: 'Estado alterado',
            action_drift_detected: 'Desvio detetado',
            action_snapshot_created: 'Instantâneo criado',
            action_approval_submitted: 'Aprovação submetida',
            action_archived: 'Arquivado',
            action_purpose_auto_mapped: 'Finalidade atribuída automaticamente',
            action_purpose_mapping_updated: 'Atribuição de finalidade atualizada',
            action_webhook_configured: 'Webhook configurado',
            entity_propagation: 'Propagação',
            entity_reconciliation: 'Reconciliação',
            action_propagation_confirmed: 'Propagação confirmada',
            action_propagation_failed: 'Falha na propagação',
            action_consent_captured: 'Consentimento capturado',
            action_reconciliation_created: 'Reconciliação criada',
            action_reconciliation_resolved: 'Reconciliação resolvida',
            action_submitted_for_review: 'Submetido para revisão',
            action_activated: 'Ativado',
            action_suspended: 'Suspenso',
            action_retired: 'Retirado',
            action_enhanced_review_required: 'Revisão aprimorada necessária',
            action_enhanced_review_approved: 'Revisão aprofundada aprovada',
            action_enhanced_review_rejected: 'Revisão aprofundada rejeitada — política redefinida para rascunho',
            action_consented: 'Consentido',
            action_consented_customize: 'Consentimento personalizado',
            action_revoked: 'Revogado',
            action_rejected: 'Rejeitado',
        },
        web_records: {
            title: 'Registros de consentimento da Web',
            page_title: 'Registros de consentimento da Web',
            domain: 'Domínio',
            visitor_id: 'ID do visitante',
            consent_action: 'Ação de consentimento',
            received_at: 'Recebido em',
            admin_status: 'Status do administrador',
            revoke: 'Revogar',
            reject: 'Rejeitar',
            reason: 'Razão',
            reason_placeholder: 'Razão para esta ação (opcional)',
            revoke_confirm: 'Revogar este registro de consentimento?',
            reject_confirm: 'Rejeitar este registro de consentimento?',
            override_success: 'Status do registro atualizado com sucesso.',
            override_error: 'Falha ao atualizar o status do registro.',
            no_records: 'Nenhum registro de consentimento da web encontrado.',
            fetch_error: 'Falha ao carregar registros de consentimento da web.',
            filter_by_domain: 'Filtrar por domínio',
            filter_by_action: 'Filtrar por ação',
            active: 'Ativo',
        },
        legal_bases: {
            all: 'Todas as bases jurídicas',
            consent: 'Consentimento',
            legitimate_interest: 'Interesse legítimo',
            contract: 'Contrato',
            legal_obligation: 'Obrigação legal',
            vital_interest: 'Interesse vital',
            public_interest: 'Interesse público',
        },
        common_statuses: {
            suspended: 'Suspenido',
            retired: 'Retirado',
            deprecated: 'Obsoleto',
        },
        approval_modes: {
            all: 'All',
            any: 'Any',
        },
        cmp_integration: {
            title: 'Integração AesirX CMP',
            back_to_consent: 'Voltar para Consentimento',
            back_to_integration: 'Voltar para Integração',
            webhook_status: 'Webhook Estado',
            events_received: 'Eventos recebidos',
            web_consent_records: 'Web Consentimento Registos',
            unmapped_purposes: 'Finalidades não mapeadas',
            integration_management: 'Integração Gestão',
            webhook_configuration: 'Webhook Configuração',
            webhook_config_desc: 'Configure o endpoint do webhook de CMP e gira o segredo HMAC.',
            purpose_mapping: 'Finalidade Mapeamento',
            purpose_mapping_desc: 'Mapeie os identificadores de finalidade de CMP para as finalidades do catálogo de consentimento de GRC.',
            bulk_sync: 'Sincronização em massa',
            bulk_sync_desc: 'Importe dados históricos de consentimento e visualize o histórico de sincronização.',
            consent_analytics: 'Análise de consentimento web (últimos 30 dias)',
            consent_grant_rate: 'Consentimento Grant Taxa',
            top_domain: 'Domínio principal',
            records: 'registos',
            banner_interactions: 'Interações do banner',
            consent_actions: 'Ações de consentimento',
            opt_in_trend: 'Tendência opt-in/opt-out',
            records_by_domain: 'Registros por Domínio',
            date: 'Data',
            grants: 'Consentimentos concedidos',
            denials: 'Recusas',
            not_configured: 'Não configurado',
            load_error: 'Falha ao load integration data. Por favor, tente novamente.',
            webhook_not_configured: 'Webhook não configured.',
            webhook_not_configured_msg: 'Por favor, primeiro {link}.',
            configure_webhook_link: 'configurar o webhook',
            setup_wizard: 'Assistente de configuração',
            step_configure_webhook: 'Configurar Webhook',
            step_map_purposes: 'Mapear finalidades',
            step_run_sync: 'Executar sincronização em massa inicial',
            step_verify_data: 'Verificar Dados em Painel de controlo',
            configure: 'Configurar',
            view_dashboard: 'Ver painel de controlo',
            syncing: 'A sincronizar...',
            sync_now: 'Sincronizar Agora',
            sync_completed: 'Sincronizar concluído: {imported} importado, {skipped} skipped, {failed} falhou.',
            sync_failed: 'Sincronizar falhou',
            last_sync_result: 'Último Sincronizar Resultado',
            imported: 'Importado',
            skipped: 'Ignorado',
            errors: 'Erros',
            index: 'Índice',
            error: 'Erro',
            sync_history: 'Sincronizar Histórico',
            no_sync_jobs: 'Ainda não foram registados trabalhos de sincronização.',
            load_sync_error: 'Falha ao load sync data. Por favor, tente novamente.',
            purpose_mapping_title: 'CMP Finalidade Mapeamento',
            auto_mapping: 'A mapear auto...',
            auto_map_purposes: 'Auto-Map Finalidades',
            unmapped_warning: '[[TOK_1]] finalidade(s) não mapeada(s) - essas finalidades [[TOK_2]] precisam ser mapeadas para finalidades de GRC.',
            mapping_saved: 'Mapeamento guardado.',
            mapping_deleted: 'Mapeamento eliminado.',
            auto_map_complete: 'Mapeamento automático concluído: {mapped} mapeados, {unmatched} não mapeados.',
            auto_map_failed: 'Auto-map falhou',
            save_mapping_error: 'Falha ao save mapping. Por favor, tente novamente.',
            delete_mapping_error: 'Falha ao delete mapping. Por favor, tente novamente.',
            load_data_error: 'Falha ao load data. Por favor, tente novamente.',
            cmp_purpose: 'Finalidade CMP',
            grc_purpose: 'Finalidade GRC',
            select_grc_purpose: '-- Selecionar GRC Finalidade --',
            auto_mapped: 'Mapeado auto.',
            mapped: 'Mapeado',
            unmapped: 'Não mapeado',
            no_mappings: 'Nenhuma correspondência de finalidade encontrada. As correspondências são criadas automaticamente quando eventos de consentimento são recebidos.',
            total_mappings: 'Total: {count} mapeamento(s)',
            webhook_config_title: 'Webhook Configuração',
            current_configuration: 'Atual Configuração',
            setup_webhook: 'Configurar webhook',
            setup_webhook_desc: 'Configure o webhook do AesirX CMP para receber eventos de consentimento.',
            allowed_domains: 'Domínios permitidos (um por linha)',
            webhook_secret_warning: 'Segredo do webhook (guarde agora -- não será mostrado novamente):',
            last_event: 'Último Evento',
            none_received: 'Nenhum',
            update_domains: 'Atualizar domínios',
            pause_webhook: 'Pausar webhook',
            resume_webhook: 'Retomar webhook',
            regenerate_secret: 'Regenerar segredo',
            configuring: 'A configurar...',
            create_webhook_config: 'Adicionar webhook configuração',
            webhook_endpoint: 'Endpoint do webhook',
            webhook_endpoint_desc: 'Configure o seu AesirX CMP para enviar eventos de consentimento para:',
            webhook_signature_note: 'Inclua a assinatura HMAC-SHA256 no cabeçalho {header}.',
            configured_success: 'Webhook configured com sucesso',
            config_updated: 'Configuração atualizado.',
            config_error: 'Falha ao configure webhook. Por favor, tente novamente.',
            update_error: 'Falha ao update configuration. Por favor, tente novamente.',
            toggle_error: 'Falha ao toggle webhook. Por favor, tente novamente.',
            deactivated: 'Webhook desativado.',
            deactivate_error: 'Falha ao deactivate webhook. Por favor, tente novamente.',
            page_title: '[[TOK_0]] Integração',
            webhook_config_page_title: '[[TOK_0]] Configuração de webhook',
            bulk_sync_page_title: 'Remapear registros',
            purpose_mapping_page_title: 'Mapeamento de finalidade',
            data_loaded: '[[TOK_0]] dados de integração carregados',
            sync_all: 'Sincronizar tudo',
            sync_selected: 'Sincronizar selecionados',
            sync_status: 'Estado da sincronização',
            last_sync: 'Última sincronização',
            no_records: 'Nenhum registo encontrado.',
            sync_in_progress: 'Sincronização em curso...',
            sync_complete: 'Sincronização concluída.',
            sync_error: 'A sincronização falhou. Por favor, tente novamente.',
            map_purpose: 'Associar finalidade',
            unmap: 'Desassociar',
            mapping_status: 'Estado da associação',
            save_mapping: 'Guardar associação',
            remap_unmapped_records: 'Remapear registros não mapeados',
            remap_records: 'Remapear registros',
            add_mappings_first: 'Adicione mapeamentos de propósito primeiro (Etapa 2)',
            remap_result: 'Resultado do remapeamento',
            remap_result_desc: 'Processou todos os registros de consentimento com finalidades não mapeadas ou parcialmente mapeadas.',
            total_processed: 'Total Processado',
            newly_mapped: 'Recentemente mapeado',
            still_unmapped_label: 'Ainda não mapeado',
            still_unmapped_msg: 'Os registros [[TOK_2]] ainda têm finalidades não mapeadas. [[TOK_3]] e clique em Remapear novamente.',
            add_more_mappings: 'Adicione mais mapeamentos',
            remap_complete: 'Remapeamento concluído: [[TOK_2]] recentemente mapeado, [[TOK_3]] ainda não mapeado.',
            add_mapping: 'Adicionar mapeamento',
            cmp_purpose_id_label: '[[TOK_0]] ID da finalidade *',
            cmp_purpose_id_required: '[[TOK_0]] O ID da finalidade é obrigatório',
            cmp_purpose_name_label: '[[TOK_0]] Nome da finalidade',
            grc_purpose_label: 'Objetivo do GRC',
        },
        propagation: {
            title: 'Propagação de retirada',
            systems: 'Sistemas vinculados',
            status: 'Estado',
            confirmed: 'Confirmado',
            pending: 'Pendente',
            failed: 'Falhado',
            confirm: 'Confirmar retirada',
            fail: 'Marcar como falhado',
            failure_reason: 'Motivo da falha',
            can_close: 'Todos os sistemas confirmados — o fluxo pode ser encerrado',
            cannot_close: 'A aguardar confirmações do sistema',
            no_tasks: 'Sem tarefas de propagação.',
            confirm_success: 'Retirada do sistema confirmada.',
            fail_success: 'Sistema marcado como falhado.',
            propagate_success: 'Retirada propagada aos sistemas vinculados.',
            propagate: 'Propagar para sistemas',
            add_system: 'Adicionar sistema',
            remove_system: 'Remover',
            system_id: 'ID do sistema',
            system_name: 'Nome do sistema',
            owner_id: 'ID do proprietário',
            propagate_error: 'Falha ao propagar a retirada. Por favor, tente novamente.',
            no_systems: 'Adicione pelo menos um sistema.',
            page_title: 'Propagação de retirada',
            workflow_id: 'Selecione o fluxo de trabalho de retirada',
            system_id_hint: 'ex. crm-001, erp-prod',
            owner_id_hint: 'Proprietário do sistema',
            elapsed: 'Decorrido',
        },
        sensitive: {
            title: 'Políticas de dados sensíveis',
            flag: 'Marcar como sensível',
            categories: 'Categorias sensíveis',
            enhanced_review: 'Exigir revisão aprofundada',
            enhanced_review_success: 'Revisão aprofundada exigida.',
            flag_success: 'Política marcada como sensível.',
            no_sensitive: 'Sem políticas de dados sensíveis.',
        },
        reconciliation: {
            title: 'Reconciliação de discrepâncias',
            create: 'Nova tarefa de reconciliação',
            system: 'Sistema',
            owner: 'Proprietário',
            description: 'Descrição',
            resolution: 'Resolução',
            resolve: 'Resolver',
            update_grc: 'Atualizar GRC',
            update_cmp: 'Atualizar CMP',
            accept_difference: 'Aceitar diferença',
            escalate: 'Escalar',
            resolution_notes: 'Notas de resolução',
            no_tasks: 'Sem tarefas de reconciliação.',
            resolve_success: 'Tarefa de reconciliação resolvida.',
            create_success: 'Tarefa de reconciliação criada.',
            open: 'Aberto',
            resolved: 'Resolvido',
            escalated: 'Escalado',
            dashboard_open: 'Tarefas abertas',
            dashboard_resolved: 'Tarefas resolvidas',
            dashboard_escalated: 'Tarefas escaladas',
            page_title: 'Reconciliação de incompatibilidade',
            my_tasks: 'Minhas tarefas',
            all_tasks: 'Todas as tarefas',
            severity: 'Gravidade',
        },
        sync: {
            title: 'Sincronização CMP',
            direction: 'Direção',
            cmp_to_grc: '[[TOK_0]] → GRC',
            grc_to_cmp: 'GRC → [[TOK_0]]',
            conflict: 'Conflito',
            resolve_conflict: 'Resolver conflito',
            no_events: 'Sem eventos de sincronização.',
            resolve_success: 'Conflito de sincronização resolvido.',
            create_success: 'Evento de sincronização registado.',
            page_title: '[[TOK_0]] Sincronizar',
            detect_drift: 'Detectar conflitos',
            detecting: 'Detectando...',
            drift_result: '[[TOK_2]] conflito(s) detectado(s) fora de [[TOK_3]] objetivo(s) comparado(s).',
            no_drift: 'Nenhum novo conflito detectado.',
            drift_error: 'Falha ao executar a detecção de conflitos.',
            resolve_modal_title: 'Resolver Conflitos',
            resolve_field: 'Campo',
            resolve_grc_value: 'Valor GRC',
            resolve_cmp_value: '[[TOK_0]] Valor',
            accept_cmp: 'Aceitar valor [[TOK_0]]',
            accept_cmp_desc: 'Atualize o GRC para corresponder ao [[TOK_0]] — o valor [[TOK_1]] se torna o novo valor do GRC.',
            keep_grc: 'Mantenha o valor GRC',
            keep_grc_desc: 'Encerre este conflito sem alterar o GRC — notifique o proprietário do [[TOK_0]] para alinhar.',
            resolve_applied: 'Conflito resolvido. Finalidade do GRC atualizada para corresponder a [[TOK_0]].',
        },
    },
    assessments: {
        dossier_preflight: {
            advisory_notice: 'Este relatório de prontidão é consultivo. Não aprova, compila, materializa, apresenta nem envia o dossiê.',
            run_label: 'Execute o pré-voo',
            running: 'Executando pré-voo…',
            assemble_label: 'Pacote de montagem automática',
            assembling: 'Montagem…',
            verdict_label: 'Veredicto pré-voo',
            tokens_label: '≈ [[TOK_1]] tokens',
            remediation_label: 'Correção',
            no_gaps: 'Nenhuma lacuna pré-voo detectada. O arquivo está pronto para ser montado.',
            override_label: 'Substituir veredicto do bloco – a montagem terá carimbo de auditoria.',
            accept_label: 'Aceitar relatório',
            reject_label: 'Rejeitar relatório',
            assembled_label: 'Pacote de envio montado',
            package_id_label: 'ID do pacote',
            package_filename_label: 'Nome do arquivo',
            package_hash_label: 'Hash do pacote',
            evidence_count_label: '[[TOK_1]] itens de evidência agrupados',
            error_generic: 'Não foi possível executar o pré-voo ou montar o pacote. Tente novamente ou verifique o status do pedido.',
        },
        errors: {
            fetch: 'Falha ao load assessments. Por favor, tente novamente.',
            save: 'Falha ao save assessment. Por favor, tente novamente.',
            fetch_gap_report_failed: 'Falha ao fetch gap report. Por favor, tente novamente.',
            fetch_transfers_failed: 'Falha ao fetch transfers. Por favor, tente novamente.',
            save_transfer_failed: 'Falha ao save transfer. Por favor, tente novamente.',
            submit_review_failed: 'Falha ao submit for review. Por favor, tente novamente.',
            process_decision_failed: 'Falha ao process decision. Por favor, tente novamente.',
            deprecate_failed: 'Falha ao deprecate. Por favor, tente novamente.',
            evaluate_risk_failed: 'Falha ao evaluate risk. Por favor, tente novamente.',
            fetch_safeguards_failed: 'Falha ao fetch safeguards. Por favor, tente novamente.',
            save_safeguard_failed: 'Falha ao save safeguard. Por favor, tente novamente.',
            update_safeguard_status_failed: 'Falha ao atualizar o estado da salvaguarda. Por favor, tente novamente.',
        },
        nav: {
            dpias: 'AIPDs',
            transfers: 'Avaliações de Transferência',
            dashboard: 'Painel de Controlo',
            gap_report: 'Relatório de Lacunas',
        },
        risk_level_critical: 'Risco crítico',
        risk_level_high: 'Risco alto',
        risk_level_medium: 'Risco médio',
        risk_level_low: 'Risco baixo',
        severity_critical: 'Severidade crítica',
        severity_high: 'Severidade alta',
        severity_medium: 'Severidade média',
        severity_low: 'Severidade baixa',
        overdue: 'Em atraso',
        framework_filter_label: 'Estrutura',
        aria_filter_by_framework: 'Filtrar por estrutura',
        dashboard: {
            title: 'Painel de Avaliações',
            page_title: 'Painel de avaliações',
            announce_loaded: 'Painel de avaliações carregado',
            announce_chart_view: 'A mostrar vista de gráfico',
            announce_table_view: 'A mostrar vista de tabela de dados',
            aria_metrics_table: 'Métricas do painel de avaliações',
            metric_col: 'Métrica',
            value_col: 'Valor',
            dpia_prefix: 'AIPD',
            transfer_prefix: 'Transferência',
            risk_prefix: 'Risco',
            aria_dpias_by_status: 'AIPD por estado',
            aria_transfers_by_status: 'Transferências por estado',
            aria_top_risks: 'Principais riscos',
            aria_top_risks_table: 'Principais riscos nas AIPD',
            overdue_dpias_attention: '{count} avaliações AIPD em atraso requerem atenção',
            no_overdue_dpias: 'Sem avaliações AIPD em atraso',
            overdue_transfers_attention: '{count} avaliações de transferência em atraso requerem atenção',
            no_overdue_transfers: 'Sem avaliações de transferência em atraso',
            dpias_overview: 'Resumo das AIPDs',
            transfers_overview: 'Resumo das Avaliações de Transferência',
            overdue_items: 'Itens em Atraso',
            overdue_dpias: 'AIPDs em Atraso',
            overdue_transfers: 'Transferências em Atraso',
            count: 'Contagem',
            no_data: 'Sem dados disponíveis.',
            no_risks: 'Nenhum risks encontrado',
            no_dashboard_data: 'Não há dados do painel disponíveis.',
            fetch_error: 'Falha ao fetch dashboard data. Por favor, tente novamente.',
        },
        dpias: {
            page_title: 'AIPDs',
            announce_submitted_for_review: 'AIPD submetida para revisão',
            announce_deprecated: 'AIPD obsoleta',
            announce_risks_loaded: '{count} risco(s) carregado(s)',
            announce_mitigations_loaded: '{count} medida(s) de mitigação carregada(s)',
            announce_risk_deleted: 'Risco eliminado',
            announce_mitigation_status_updated: 'Estado da medida de mitigação atualizado',
            aria_filter: 'Filtrar AIPDs',
            aria_filter_by_status: 'Filtrar por estado',
            aria_filter_by_lead: 'Filtrar por líder de avaliação',
            aria_table: 'Avaliações de impacto na proteção de dados',
            announce_found: '{count} AIPD(s) encontrada(s)',
            announce_decision: 'AIPD {decision}',
            mitigation_start: 'Iniciar',
            mitigation_mark_implemented: 'Marcar como implementado',
            mitigation_verify: 'Verificar',
            title: 'Avaliações de Impacto sobre a Proteção de Dados',
            new: 'Nova AIPD',
            edit: 'Editar AIPD',
            dpia_title: 'Título',
            activity: 'Atividade',
            risk_score: 'Pontuação de Risco',
            risks: 'Riscos',
            mitigations: 'Mitigações',
            add_risk: 'Adicionar Risco',
            add_mitigation: 'Adicionar Mitigação',
            necessity: 'Necessidade / Proporcionalidade',
            likelihood: 'Probabilidade',
            impact: 'Impacto',
            severity_label: 'Gravidade',
            purpose: 'Finalidade',
            consultation_notes: 'Notas de consulta',
            dpo_opinion: 'Parecer do EPD',
            processing_activity_ids: 'IDs de atividades de tratamento (separados por vírgulas)',
            system_ids: 'IDs de sistema (separados por vírgulas)',
            vendor_ids: 'IDs de fornecedores (separados por vírgulas)',
            data_types: 'Tipos de dados (separados por vírgulas)',
            data_types_short: 'Tipos de dados',
            data_subjects: 'Titulares de dados (separados por vírgulas)',
            assessment_lead_id: 'ID do responsável da avaliação',
            assessment_lead: 'Responsável da avaliação',
            dpo_id: 'ID EPD',
            reviewer_ids: 'IDs de revisores (separados por vírgulas)',
            approval_mode: 'Modo de aprovação',
            approval_all: 'All',
            approval_any: 'Any',
            require_dpo_signoff: 'Exigir aprovação do EPD',
            review_date: 'Rever Data',
            submit_for_review: 'Submeter para Rever',
            approve_reject: 'Aprovar/Rejeitar',
            deprecate: 'Tornar obsoleto',
            deprecated: 'Obsoleto',
            hide_risks: 'Ocultar Riscos',
            hide_mitigations: 'Ocultar mitigações',
            comments: 'Comentários',
            submit_decision: 'Submeter decisão',
            category_label: 'Categoria',
            category_data_breach: 'Dados Violação',
            category_unauthorized_access: 'Acesso não autorizado',
            category_function_creep: 'Expansão de funções',
            category_re_identification: 'Re-identificação',
            category_discrimination: 'Discriminação',
            category_surveillance: 'Vigilância',
            category_other: 'Outro',
            affected_rights: 'Direitos afetados (separados por vírgulas)',
            no_risks: 'Nenhum risks encontrado',
            no_mitigations: 'Nenhum mitigations encontrado',
            no_dpias: 'Nenhum dpias encontrado',
            mitigation_type: 'Tipo',
            mitigation_technical: 'Técnico',
            mitigation_organizational: 'Organizacional',
            mitigation_contractual: 'Contratual',
            risk_ids: 'IDs de riscos (separados por vírgulas)',
            responsible_party: 'Parte responsável',
            responsible_party_placeholder: 'Ou introduzir nome manualmente',
            affected_rights_placeholder: 'Os direitos selecionados aparecem aqui',
            affected_rights_freetext_placeholder: 'Introduzir direitos afetados (separados por vírgulas)',
            responsible: 'Responsável',
            target_date: 'Data alvo',
            created: 'Criado',
            fetch_error: 'Falha ao fetch dpias. Por favor, tente novamente.',
            save_error: 'Falha ao save dpia. Por favor, tente novamente.',
            submit_review_error: 'Falha ao submit dpia for review. Por favor, tente novamente.',
            decision_error: 'Falha ao process decision. Por favor, tente novamente.',
            deprecate_error: 'Falha ao deprecate dpia. Por favor, tente novamente.',
            fetch_risks_error: 'Falha ao fetch risks. Por favor, tente novamente.',
            save_risk_error: 'Falha ao save risk. Por favor, tente novamente.',
            delete_risk_error: 'Falha ao delete risk. Por favor, tente novamente.',
            fetch_mitigations_error: 'Falha ao fetch mitigations. Por favor, tente novamente.',
            save_mitigation_error: 'Falha ao save mitigation. Por favor, tente novamente.',
            update_mitigation_status_error: 'Falha ao atualizar o estado da mitigação. Por favor, tente novamente.',
            link_form_template: 'Modelo de Formulário Regulatório de Link',
            link_form_template_placeholder: 'Selecione um modelo de formulário [[TOK_0]] (opcional)',
            link_form_template_none: 'Nenhum',
            linked_form: 'Formulário vinculado',
            linked_form_creating: 'Criando formulário vinculado...',
            linked_form_error: 'Falha ao criar instância de formulário vinculado. O [[TOK_0]] foi criado sem um formulário vinculado.',
            view_linked_form: 'Ver formulário',
            announce_created_with_form: '[[TOK_0]] criado com instância de formulário vinculada',
            creation_mode: '[[TOK_0]] Modo de criação',
            mode_standard: 'Padrão [[TOK_0]]',
            mode_template: 'Use modelo de formulário regulatório',
            select_form_template: 'Selecione o modelo de formulário',
            create_and_fill_form: 'Criar e preencher formulário',
            template_sections_title: 'Seções de modelo',
            field_singular: 'campo',
            field_plural: 'campos',
            no_sections: 'Nenhuma seção encontrada neste modelo.',
            template_mode_hint: 'Após a criação, você será redirecionado para preencher o formulário regulatório completo.',
            linked_dossier_filings: 'Submissões de dossiê associadas',
            no_linked_dossier_filings: 'Nenhuma submissão de dossiê associada a esta AIPD.',
            view_dossier_filing: 'Ver submissão',
            hide_dossier_filings: 'Ocultar submissões de dossiê',
            supporting_evidence: 'Evidências de apoio',
            hide_supporting_evidence: 'Ocultar evidências',
            no_supporting_evidence: 'Nenhuma evidência de apoio anexada.',
            upload_supporting_evidence: 'Carregar evidências de apoio',
            view_form_responses: 'Ver respostas do formulário',
            regulatory_framework: 'Quadro regulamentar',
            all_frameworks: 'Todos os quadros',
            no_templates_for_market: 'Nenhum modelo disponível para o mercado selecionado. Selecione um mercado diferente ou crie um modelo.',
        },
        transfers: {
            page_title: 'Transferências de dados',
            announce_found: '{count} avaliação(ões) de transferência encontrada(s)',
            announce_submitted_for_review: 'Transferência submetida para revisão',
            announce_deprecated: 'Transferência obsoleta',
            announce_decision: 'Transferência {decision}',
            announce_risk_eval_completed: 'Avaliação de riscos concluída',
            announce_safeguard_status_updated: 'Estado da medida de proteção atualizado',
            announce_safeguards_loaded: '{count} medida(s) de proteção carregada(s)',
            aria_filter: 'Filtrar avaliações de transferência',
            aria_filter_by_status: 'Filtrar por estado',
            aria_filter_by_mechanism: 'Filtrar por mecanismo de transferência',
            aria_table: 'Avaliações de transferência de dados',
            title: 'Avaliações de Transferências Transfronteiriças',
            new: 'Nova Transferência',
            edit: 'Editar Transferência',
            name: 'Nome',
            from_country: 'País de Origem',
            to_country: 'País de Destino',
            safeguards: 'Garantias',
            risk_level: 'Nível de Risco',
            assessment_notes: 'Notas da Avaliação',
            mechanism: 'Mecanismo',
            transfer_mechanism: 'Mecanismo de transferência',
            transfer_mechanism_detail: 'Detalhe do mecanismo de transferência',
            all_mechanisms: 'Todos os mecanismos',
            mechanism_adequacy_decision: 'Decisão de adequação',
            mechanism_sccs: 'CPC',
            mechanism_bcrs: 'BCR',
            mechanism_consent: 'Consentimento',
            mechanism_derogation: 'Derrogação',
            mechanism_other: 'Outro',
            data_types: 'Tipos de dados (separados por vírgulas)',
            data_subjects: 'Titulares de dados (separados por vírgulas)',
            purpose: 'Finalidade',
            recipient_name: 'Nome do destinatário',
            create_success: 'Avaliação de transferência criada.',
            update_success: 'Avaliação de transferência atualizada.',
            recipient_details: 'Detalhes do destinatário',
            recipient_details_placeholder: 'Função, localização e sistemas do destinatário e detalhes de transferência subsequente',
            vendor_id: 'Fornecedor ID',
            processing_activity_ids: 'IDs de atividades de tratamento (separados por vírgulas)',
            reviewer_ids: 'IDs de revisores (separados por vírgulas)',
            approval_mode: 'Modo de aprovação',
            approval_all: 'All',
            approval_any: 'Any',
            require_dpo_signoff: 'Exigir aprovação do EPD',
            review_date: 'Rever Data',
            created: 'Criado',
            deprecated: 'Obsoleto',
            submit_for_review: 'Submeter para Rever',
            approve_reject: 'Aprovar/Rejeitar',
            deprecate: 'Tornar obsoleto',
            risk_eval: 'Avaliação de risco',
            hide_safeguards: 'Ocultar salvaguardas',
            mechanism_proof: 'Prova de Mecanismo',
            hide_mechanism_proof: 'Ocultar prova de mecanismo',
            mechanism_proof_hint: 'Carregue o mecanismo de transferência assinado (SCCs, BCRs, decisão de adequação, etc.) comprovando esta avaliação de transferência.',
            no_mechanism_proof: 'Nenhuma prova de mecanismo anexada.',
            upload_mechanism_proof: 'Prova do mecanismo de upload',
            comments: 'Comentários',
            submit_decision: 'Submeter decisão',
            data_sensitivity: 'Sensibilidade dos dados (1-5)',
            country_risk: 'País Risco (1-5)',
            safeguard_adequacy: 'Adequação da salvaguarda (1-5)',
            volume_factor: 'Fator de volume (1-5)',
            evaluate: 'Avaliar',
            add_safeguard: 'Adicionar Safeguard',
            responsible_party: 'Parte responsável',
            responsible_party_placeholder: 'Ou introduzir nome manualmente',
            responsible: 'Responsável',
            implementation_date: 'Data de implementação',
            implementation: 'Implementação',
            expiry_date: 'Data de expiração',
            expiry: 'Expiração',
            expire: 'Expirar',
            no_safeguards: 'Nenhum safeguards encontrado',
            no_transfers: 'Nenhum transfer assessments encontrado',
            fetch_error: 'Falha ao fetch transfer assessments. Por favor, tente novamente.',
            save_error: 'Falha ao save transferência avaliação. Por favor, tente novamente.',
            submit_review_error: 'Falha ao submit for review. Por favor, tente novamente.',
            decision_error: 'Falha ao process decision. Por favor, tente novamente.',
            deprecate_error: 'Falha ao deprecate transfer. Por favor, tente novamente.',
            risk_eval_error: 'Falha ao evaluate risk. Por favor, tente novamente.',
            fetch_safeguards_error: 'Falha ao fetch safeguards. Por favor, tente novamente.',
            save_safeguard_error: 'Falha ao save safeguard. Por favor, tente novamente.',
            update_safeguard_status_error: 'Falha ao atualizar o estado da salvaguarda. Por favor, tente novamente.',
            safeguard_type_encryption_in_transit: 'Encriptação em trânsito',
            safeguard_type_encryption_at_rest: 'Encriptação em repouso',
            safeguard_type_access_controls: 'Acesso Controlos',
            safeguard_type_contractual_clauses: 'Cláusulas contratuais',
            safeguard_type_data_minimization: 'Minimização de dados',
            safeguard_type_pseudonymization: 'Pseudonimização',
            safeguard_type_audit_rights: 'Direitos de auditoria',
            safeguard_type_breach_notification: 'Violação Notificação',
            safeguard_type_data_localization: 'Localização de dados',
            safeguard_type_other: 'Outro',
            activate: 'Ativar',
            all_statuses: 'Todos os status',
            any: 'Any',
            mechanism_detail: 'Detalhe do mecanismo',
            mechanisms: {
                adequacy_decision: 'Decisão de adequação',
                sccs: 'CPC',
                bcr: 'BCR',
                bcrs: 'BCR',
                derogation: 'Derrogação',
                consent: 'Consentimento',
                other: 'Outro',
            },
            safeguard_types: {
                encryption_in_transit: 'Criptografia em trânsito',
                encryption_at_rest: 'Criptografia em repouso',
                access_controls: 'Controles de acesso',
                contractual_clauses: 'Cláusulas contratuais',
                data_minimization: 'Minimização de dados',
                pseudonymization: 'Pseudonimização',
                audit_rights: 'Direitos de auditoria',
                breach_notification: 'Notificação de violação',
                data_localization: 'Localização de dados',
                other: 'Outro',
            },
        },
        gap_report: {
            page_title: 'Relatório de lacunas de avaliações',
            announce_loaded: 'Relatório de lacunas carregado. {count} lacuna(s) identificada(s)',
            aria_activities_without_dpia: 'Atividades sem avaliação AIPD',
            aria_activities_unclassified: 'Atividades com requisito de AIPD não classificado',
            activities_unclassified_section_title: 'Atividades com requisito de AIPD não classificado',
            activities_unclassified_description: 'Estas atividades não foram revistas para determinar se uma AIPD é legalmente exigida. Classifique cada uma para eliminar o aviso.',
            activities_unclassified_empty: 'Todas as atividades ativas estão classificadas.',
            aria_unmitigated_risks: 'Riscos altos e críticos não mitigados',
            aria_transfers_without_safeguards: 'Transferências sem medidas de proteção adequadas',
            aria_expired_assessments: 'Avaliações expiradas que requerem renovação',
            title: 'Relatório de Lacunas de Avaliação',
            no_dpia: 'Atividades Sem AIPD',
            no_assessment: 'Transferências Sem Avaliação',
            unmitigated: 'AIPDs com Riscos Não Mitigados',
            activity_id: 'ID de atividade',
            dpia_id: 'ID AIPD',
            assessment_id: 'Avaliação ID',
            expired_assessments: 'Expirado Avaliações',
            no_gaps_activities: 'Sem lacunas encontradas. Todas as atividades têm DPIAs.',
            no_unmitigated_risks: 'Nenhum unmitigated high/critical risks encontrado',
            no_gaps_safeguards: 'Sem lacunas encontradas. Todas as transferências têm salvaguardas adequadas.',
            no_expired: 'Nenhum expired assessments encontrado',
            no_report_data: 'Não há dados do relatório de lacunas disponíveis.',
            fetch_error: 'Falha ao fetch gap report. Por favor, tente novamente.',
            no_expired_assessments: 'Sem avaliações expiradas.',
            no_gaps_dpia: 'Nenhum dpia gaps encontrado',
            no_data: 'Sem dados disponíveis.',
        },
        dossier_filings: {
            page_title_detail: 'Detalhe da apresentação do dossiê',
            page_title_list: 'Casos de apresentação do dossiê',
            announce_filings_found: '{count} apresentação(ões) encontrada(s)',
            announce_results: '{count} resultados',
            aria_filter_by_status: 'Filtrar por estado',
            title: 'Casos de arquivamento de dossiês',
            nav_label: 'Arquivamentos de Dossiês',
            create: 'Criar arquivamento de dossiê',
            form_type: 'Tipo de formulário',
            phu_luc_i_label: 'Mẫu số 02a (Norma [[TOK_0]], Decreto 356)',
            phu_luc_ii_label: 'Mẫu số 02b (Transfronteiriço / Alto risco [[TOK_0]], Decreto 356)',
            dpia_reference: '[[TOK_0]] Referência',
            submitted_date: 'Data de envio',
            outcome: 'Resultado',
            parent_filing: 'Pai',
            no_filings: 'Nenhum arquivo de dossiê encontrado.',
            fetch_error: 'Falha ao buscar arquivamentos de dossiês. Por favor, tente novamente.',
            save_error: 'Falha ao criar arquivamento de dossiê. Por favor, tente novamente.',
            created: 'Arquivamento de dossiê criado.',
            loaded: 'Arquivo de dossiê carregado.',
            not_found: 'Arquivamento de dossiê não encontrado.',
            back_to_list: 'Voltar à lista',
            section_assignments: 'Atribuições de seção',
            assign_sections: 'Atribuir seções',
            section_id: 'Seção',
            department: 'Departamento',
            assignee: 'Cessionário',
            deadline: 'Prazo',
            no_assignments: 'Ainda não há atribuições de seção.',
            sections_assigned_msg: 'Seções atribuídas.',
            assign_error: 'Falha ao atribuir seções. Por favor, tente novamente.',
            lifecycle: 'Ciclo de vida de arquivamento',
            submission: 'Detalhes do envio',
            submission_channel: 'Canal de envio',
            mps_portal: '[[TOK_0]] Portal',
            in_person: 'Pessoalmente',
            postal: 'Postal',
            confirmation_number: 'Número de confirmação',
            submit_for_review: 'Enviar para revisão',
            submitted_for_review: 'Enviado para revisão interna.',
            submit_review_error: 'Falha ao enviar para análise. Por favor, tente novamente.',
            legal_signoff: 'Aprovação Legal',
            legal_signoff_done: 'Aprovação legal concluída.',
            legal_signoff_error: 'Falha ao concluir a aprovação legal. Por favor, tente novamente.',
            approve: 'Aprovar',
            approved_msg: 'Arquivamento aprovado.',
            approve_error: 'Falha ao aprovar o arquivamento. Por favor, tente novamente.',
            materialisation_status_column: 'Artefato de envio',
            materialisation_na: 'Não aplicável',
            materialisation_pending: 'Pendente',
            materialisation_success: 'Materializado',
            materialisation_failed: 'Falha',
            materialisation_banner_title: 'Não foi possível criar o artefato de envio',
            materialisation_banner_body: 'O arquivamento foi aprovado, mas o registro do dossiê subjacente não pôde ser criado. As exportações de cartas de apresentação e envios ficarão indisponíveis até que você tente novamente.',
            materialisation_retry_button: 'Tentar novamente',
            materialisation_retry_count: 'Novas tentativas anteriores:',
            materialisation_retry_success: 'Artefato de envio materializado com sucesso.',
            materialisation_retry_announce: 'Nova tentativa bem-sucedida',
            filter_materialisation_failed: 'Mostrar apenas falhas de materialização',
            column_title: 'Título',
            column_form_type: 'Formulário',
            submit_to_mps: 'Enviar para [[TOK_0]]',
            submitted_to_mps_msg: 'Enviado para [[TOK_0]].',
            submit_mps_error: 'Falha ao enviar para [[TOK_0]]. Por favor, tente novamente.',
            supplement_request: 'Solicitação de Suplemento',
            supplement_requests: 'Solicitações de suplementos',
            supplement_response: 'Resposta suplementar',
            record_supplement: 'Solicitação de suplemento de registro',
            supplement_recorded: 'Solicitação de suplemento registrada.',
            supplement_error: 'Falha ao registrar solicitação de suplemento. Por favor, tente novamente.',
            submit_supplement: 'Enviar resposta complementar',
            supplement_submitted_msg: 'Resposta complementar enviada.',
            supplement_submit_error: 'Falha ao enviar resposta complementar. Por favor, tente novamente.',
            response_status: 'Status da resposta',
            response_notes: 'Notas de resposta',
            resubmit: 'Reenviar',
            resubmitted_msg: 'Dossiê reenviado.',
            resubmit_error: 'Falha ao reenviar o dossiê. Por favor, tente novamente.',
            record_outcome: 'Resultado recorde',
            outcome_recorded: 'Resultado registrado.',
            outcome_error: 'Falha ao registrar o resultado. Por favor, tente novamente.',
            accepted: 'Aceite',
            rejected: 'Rejeitado',
            close: 'Fechar',
            closed_msg: 'Arquivamento encerrado.',
            close_error: 'Falha ao fechar o arquivamento. Por favor, tente novamente.',
            change_filing: 'Criar arquivo de alterações',
            change_filing_created: 'Arquivo de alterações criado.',
            change_filing_error: 'Falha ao criar arquivo de alterações. Por favor, tente novamente.',
            change_reason: 'Motivo da mudança',
            filing_lineage: 'Linhagem de arquivamento',
            timers: 'Temporizadores ativos',
            timer_mps_review: '[[TOK_0]] Revisão',
            timer_supplement: 'Prazo do Suplemento',
            timer_resubmission: 'Prazo para reenvio',
            timer_department: 'Prazo do Departamento',
            days_remaining: 'dias restantes',
            days_overdue: 'dias em atraso',
            cover_letter: 'Carta de apresentação',
            checklist: 'Lista de verificação',
            evidence_index: 'Índice de evidências',
            status_draft: 'Rascunho',
            status_sections_assigned: 'Seções atribuídas',
            status_internal_review: 'Revisão interna',
            status_legal_signoff: 'Aprovação Legal',
            status_approved: 'Aprovado',
            status_submitted_to_mps: 'Enviado para [[TOK_0]]',
            status_supplement_requested: 'Suplemento solicitado',
            status_supplement_submitted: 'Suplemento enviado',
            status_resubmitted: 'Resubmetido',
            status_accepted: 'Aceito',
            status_rejected: 'Rejeitado',
            status_closed: 'Encerrado',
            linked_dpia: 'AIPD associada',
            linked_dpia_none: 'Nenhuma AIPD associada a esta submissão.',
            view_linked_dpia: 'Ver AIPD',
            linked_dpia_label: 'Esta submissão de dossiê está associada à seguinte AIPD:',
        },
        materialisation_health: {
            nav_label: 'Integridade do artefato de envio',
            page_title: 'Integridade do artefato de envio',
            page_description: 'Detecte e corrija problemas de materialização de dossiês. As listas têm como escopo sua organização.',
            failed_title: 'Materializações falhadas',
            failed_empty: 'Nenhuma materialização falhada – bom.',
            pending_title: 'Aprovado mas não materializado',
            pending_empty: 'Todos os registros aprovados possuem um dossiê de apoio.',
            orphan_title: 'Dossiês órfãos',
            orphan_description: 'Dossiês criados por materialização que não são mais referenciados por nenhum arquivamento – normalmente o perdedor de uma corrida simultânea. Listado para investigação; a limpeza é manual.',
            orphan_empty: 'Nenhum dossiê órfão detectado.',
            materialise_button: 'Materialize agora',
            column_failure_reason: 'Motivo da falha',
            column_failed_at: 'Falha em',
            column_retries: 'Novas tentativas',
            column_approved_at: 'Aprovado em',
            column_dossier_id: 'ID do dossiê',
            column_source_filing_id: 'Arquivamento de origem',
            column_dossier_type: 'Tipo',
            column_created_at: 'Criado em',
        },
    },
    classification: {
        access_denied_title: 'Acesso negado',
        access_denied: 'Você não tem as permissões necessárias para acessar o módulo Classificação. Entre em contato com seu administrador.',
        nav: {
            taxonomies: 'Taxonomias',
            labeling: 'Etiquetagem',
            lifecycle: 'Ciclo de Vida',
            gaps: 'Relatório de Lacunas',
            exports: 'Exportações',
        },
        exports: {
            title: 'Exportações de classificação',
            csv_section: 'Exportações CSV',
            pdf_section: 'Relatórios PDF',
            inventory: 'Inventário',
            classification_register: 'Registo de classificação',
            raci: 'Matriz RACI',
            exceptions: 'Exceções',
            evidence_pack: 'Pacote de evidências',
            delta_report: 'Relatório delta',
            executive_summary: 'Resumo executivo',
            exporting: 'A exportar…',
            export_success: 'Exportação concluída com sucesso.',
            export_error: 'A exportação falhou. Por favor, tente novamente.',
            csv_download: 'Download CSV pronto.',
            pdf_download: 'Geração de PDF iniciada.',
            no_data: 'Sem dados disponíveis para exportar.',
        },
        delta: {
            title: 'Detalhe das alterações',
            added: 'Adicionados',
            removed: 'Removidos',
            changed: 'Alterados',
            added_count: 'Adicionados ({count})',
            removed_count: 'Removidos ({count})',
            changed_count: 'Alterados ({count})',
            object_id: 'ID do objeto',
            object_type: 'Tipo de objeto',
            taxonomy: 'Taxonomia',
            level: 'Nível',
            previous: 'Anterior',
            current: 'Atual',
            no_records: 'Sem registos nesta secção.',
            empty_section: 'Esta secção está vazia.',
        },
        schedule: {
            title: 'Agendar ciclo de descoberta',
            enabled: 'Ativado',
            interval_days: 'Intervalo (dias)',
            interval_label: 'Executar a cada N dias',
            manual_only: 'Apenas manual',
            every_n_days: 'A cada {n} dias',
            save: 'Guardar agendamento',
            cancel: 'Cancelar',
            schedule_updated: 'Agendamento atualizado com sucesso.',
        },
        taxonomies: {
            title: 'Taxonomias de Classificação',
            new: 'Nova Taxonomia',
            edit: 'Editar Taxonomia',
            name: 'Nome',
            levels: 'Níveis de Classificação',
            seed_defaults: 'Predefinições iniciais',
            scope: 'Âmbito',
            scope_organization: 'Organização',
            scope_module_specific: 'Específico do módulo',
            deprecate: 'Tornar obsoleto',
            hide_levels: 'Ocultar níveis',
            versions: 'Versões',
            hide_versions: 'Ocultar versões',
            add_level: 'Adicionar nível',
            new_level: 'Novo nível',
            edit_level: 'Editar Nível',
            code: 'Código',
            label: 'Rótulo',
            color: 'Cor',
            ordinal: 'Ordinal',
            handling_requirements: 'Requisitos de tratamento',
            version_history: 'Versão Histórico',
            changes: 'Alterações',
            failed_fetch: 'Falha ao fetch taxonomies. Por favor, tente novamente.',
            failed_save: 'Falha ao save taxonomy. Por favor, tente novamente.',
            failed_activate: 'Falha ao activate taxonomy. Por favor, tente novamente.',
            failed_deprecate: 'Falha ao deprecate taxonomy. Por favor, tente novamente.',
            failed_seed: 'Falha ao seed default taxonomies. Por favor, tente novamente.',
            failed_fetch_levels: 'Falha ao fetch taxonomy levels. Por favor, tente novamente.',
            failed_save_level: 'Falha ao save taxonomy level. Por favor, tente novamente.',
            failed_delete_level: 'Falha ao delete taxonomy level. Por favor, tente novamente.',
            failed_fetch_versions: 'Falha ao fetch taxonomy versions. Por favor, tente novamente.',
            loaded_count: '{count} taxonomias carregadas',
            defaults_seeded: 'Taxonomias predefinidas inicializadas.',
            no_levels: 'Nenhum nível de classificação definido — adicione níveis para definir sua hierarquia de classificação.',
            no_versions: 'Ainda sem histórico de versões — versões são criadas quando uma taxonomia ativa é atualizada.',
        },
        labeling: {
            title: 'Etiquetagem de Dados',
            new: 'Nova Etiqueta',
            edit: 'Editar Etiqueta',
            entity_type: 'Tipo de Entidade',
            entity_id: 'ID da Entidade',
            taxonomy: 'Taxonomia',
            classification_level: 'Nível de Classificação',
            applied_by: 'Aplicado Por',
            applied_at: 'Aplicado Em',
            bulk_apply: 'Aplicação em Massa',
            bulk_remove: 'Remoção em Massa',
            all_taxonomies: 'Todas as taxonomias',
            system: 'Sistema',
            dataset: 'Conjunto de dados',
            level_code_placeholder: 'Código de nível...',
            select_taxonomy: 'Selecione taxonomy...',
            select_level: 'Selecione level...',
            rationale: 'Fundamentação',
            review_date: 'Rever Data',
            review: 'Rever',
            selected: 'selecionado',
            select_all_labels: 'Selecionar todos os rótulos',
            loaded_count: '{count} rótulos carregados',
            hide_stale_labels: 'Ocultar etiquetas obsoletas',
            show_conflicts: 'Mostrar conflitos',
            hide_conflicts: 'Ocultar conflitos',
            label_conflicts: 'Conflitos de etiquetas',
            conflict_reason: 'Motivo do conflito',
            labels: 'Rótulos',
            failed_fetch: 'Falha ao fetch labels. Por favor, tente novamente.',
            failed_fetch_taxonomies: 'Falha ao fetch taxonomies. Por favor, tente novamente.',
            failed_fetch_levels: 'Falha ao fetch taxonomy levels. Por favor, tente novamente.',
            failed_save: 'Falha ao save label. Por favor, tente novamente.',
            failed_review: 'Falha ao review label. Por favor, tente novamente.',
            failed_bulk: 'Falha ao bulk label. Por favor, tente novamente.',
            failed_stale: 'Falha ao fetch stale labels. Por favor, tente novamente.',
            failed_conflicts: 'Falha ao fetch label conflicts. Por favor, tente novamente.',
            review_permission_denied: 'Você não tem permissão para revisar este rótulo.',
            review_not_found: 'Rótulo não encontrado — pode ter sido excluído.',
            approve_selected: 'Aprovar selecionados',
            reject_selected: 'Rejeitar selecionados',
            approved: 'Aprovado',
            rejected: 'Rejeitado',
            labels_count: 'rótulos',
            failed_count: 'falharam',
            confirm_approve: 'Confirmar aprovação',
            confirm_reject: 'Confirmar rejeição',
            approve_n_labels: 'Aprovar {count} rótulos?',
            reject_n_labels: 'Rejeitar {count} rótulos?',
            submit_for_review: 'Enviar para revisão',
            approve: 'Aprovar',
            reject: 'Rejeitar',
            parent_system: 'Sistema pai',
            parent_system_placeholder: 'Selecionar sistema pai...',
            parent_system_help: 'Usado para deteccao de conflitos.',
            dataset_level: 'Nivel do conjunto de dados',
            parent_level: 'Nivel pai',
            bulk_created: '{created} rotulo(s) criado(s)',
            bulk_skipped: '{skipped} ignorado(s)',
            bulk_all_skipped: 'Todos os {skipped} ignorados',
            ids_hint: 'Digite IDs separados por virgulas',
            delete_confirm: 'Excluir rotulo para "{id}"?',
        },
        lifecycle: {
            title: 'Monitorização do Ciclo de Vida dos Dados',
            new: 'Nova Entrada',
            current_stage: 'Fase Atual',
            last_transition: 'Última Transição',
            transition: 'Transição',
            view_history: 'Ver Histórico',
            stages: {
                creation: 'Criação',
                collection: 'Recolha',
                processing: 'Tratamento',
                storage: 'Armazenamento',
                retention: 'Retenção',
                disposal: 'Eliminação',
                archived: 'Arquivado',
                active: 'Ativo',
                pending_deletion: 'Pendente Eliminação',
                deleted: 'Eliminado',
                on_hold: 'Em espera',
            },
            all_stages: 'Todas as etapas',
            object_id: 'ID do objeto',
            object_type: 'Tipo de objeto',
            policy_reference: 'Referência de política',
            retention_period_days: 'Retenção Período (days)',
            retention_basis: 'Retenção Base',
            deletion_method: 'Método de eliminação',
            deletion_secure_erase: 'Apagamento seguro',
            deletion_anonymization: 'Anonimização',
            deletion_physical_destruction: 'Destruição física',
            deletion_other: 'Outro',
            responsible_party: 'Parte responsável',
            responsible_user_id: 'ID do utilizador responsável',
            retention_expiry: 'Expiração da retenção',
            hold_reason: 'Motivo da espera',
            hold: 'Em espera',
            release: 'Lançamento',
            hide_events: 'Ocultar Eventos',
            events_timeline: 'Eventos Cronologia',
            add_event: 'Adicionar evento',
            event_type: 'Evento Tipo',
            create_event: 'Adicionar evento',
            from_stage: 'Da etapa',
            to_stage: 'Para a etapa',
            actor: 'Ator',
            reason_placeholder: 'Motivo...',
            go: 'Go',
            show_expired_retentions: 'Mostrar Expirado Retentions',
            hide_expired_retentions: 'Ocultar Expirado Retentions',
            expired_retentions_alert: 'Expirado Retentions Alerta',
            failed_fetch: 'Falha ao fetch lifecycle records. Por favor, tente novamente.',
            failed_save: 'Falha ao save lifecycle record. Por favor, tente novamente.',
            failed_transition: 'Falha ao transition lifecycle stage. Por favor, tente novamente.',
            failed_hold: 'Falha ao place hold. Por favor, tente novamente.',
            failed_release: 'Falha ao release hold. Por favor, tente novamente.',
            failed_fetch_events: 'Falha ao fetch lifecycle events. Por favor, tente novamente.',
            failed_create_event: 'Falha ao create lifecycle event. Por favor, tente novamente.',
            failed_expired: 'Falha ao fetch expired retentions. Por favor, tente novamente.',
            hold_reason_prompt: 'Introduza hold reason:',
            loaded_count: '{count} registos de ciclo de vida carregados',
            stage_transition_for: 'Transição de fase para {id}',
            event_created: 'Criado',
            event_updated: 'Atualizado',
            event_approved: 'Aprovado',
            event_deprecated: 'Obsoleto',
            event_proposed: 'Proposto',
            event_reviewed: 'Revisado',
            event_archived: 'Arquivado',
            event_restored: 'Restaurado',
        },
        gap_report: {
            title: 'Relatório de Lacunas de Classificação',
            unlabeled: 'Dados Sem Etiqueta',
            missing_lifecycle: 'Sem Ciclo de Vida',
            stale_labels: 'Etiquetas Desatualizadas',
            run_detection: 'Executar deteção de lacunas',
            detecting: 'A detetar...',
            detection_complete: 'Deteção de lacunas concluída. {count} lacuna(s) detetada(s).',
            detection_failed: 'A deteção de lacunas falhou.',
            by_severity: 'Por Gravidade',
            by_gap_type: 'Por tipo de lacuna',
            all_gap_types: 'Todos os tipos de lacuna',
            conflicting_labels: 'Rótulos em conflito',
            expired_retention: 'Expirado Retenção',
            missing_handling: 'Tratamento de valores em falta',
            info: 'Informação',
            gap_type: 'Tipo de lacuna',
            object_id: 'ID do objeto',
            object_type: 'Tipo de objeto',
            detected_at: 'Detetado em',
            open: 'Abrir',
            acknowledged: 'Receção confirmada',
            remediated: 'Remediado',
            accepted: 'Aceite',
            acknowledge: 'Confirmar receção',
            remediate: 'Remediar',
            accept_risk: 'Aceitar risco',
            accept_risk_prompt: 'Introduza risk acceptance justification:',
            failed_fetch: 'Falha ao fetch gaps. Por favor, tente novamente.',
            failed_acknowledge: 'Falha ao acknowledge gap. Por favor, tente novamente.',
            failed_remediate: 'Falha ao remediate gap. Por favor, tente novamente.',
            failed_accept_risk: 'Falha ao accept gap risk. Por favor, tente novamente.',
            failed_detect: 'Falha ao run gap detection. Por favor, tente novamente.',
            loaded_count: '{count} lacunas de classificação carregadas',
            related_object_id: 'ID do objeto relacionado',
            related_object_type: 'Tipo do objeto relacionado',
            gap_types: {
                unlabeled_asset: 'Ativo nao rotulado',
                missing_lifecycle: 'Ciclo de vida ausente',
                expired_retention: 'Retencao expirada',
                extended_pending_deletion: 'Exclusao pendente estendida',
            },
        },
        label_workflow: {
            title: 'Fluxo de etiquetas',
            proposed: 'Proposta',
            under_review: 'Em revisão',
            approved: 'Aprovada',
            deprecated: 'Obsoleta',
            submit_review: 'Submeter para revisão',
            approve: 'Aprovar etiqueta',
            deprecate: 'Tornar obsoleta',
            bulk_approve: 'Aprovação em massa',
            bulk_approve_success: 'Etiquetas aprovadas com sucesso.',
            submit_success: 'Etiqueta submetida para revisão.',
            approve_success: 'Etiqueta aprovada.',
            deprecate_success: 'Etiqueta tornada obsoleta.',
        },
        review_tasks: {
            title: 'Tarefas de revisão',
            create: 'Nova tarefa de revisão',
            system: 'Sistema',
            owner: 'Proprietário',
            description: 'Descrição',
            resolution: 'Resolução',
            resolve: 'Resolver',
            approve: 'Aprovar',
            modify: 'Modificar',
            reject: 'Rejeitar',
            escalate: 'Escalar',
            escalated: 'Tarefas escaladas',
            no_tasks: 'Sem tarefas de revisão.',
            resolve_success: 'Tarefa de revisão resolvida.',
            status_pending: 'Pendente',
            status_resolved: 'Resolvida',
            status_escalated: 'Escalada',
            notes: 'Notas',
            create_success: 'Tarefa de revisão criada.',
            no_tasks_detail: 'Ainda sem tarefas de revisão — crie uma tarefa para atribuir revisões de rótulos aos proprietários de sistemas.',
            label_id: 'ID do rótulo',
            system_id: 'ID do sistema',
            system_name: 'Nome do sistema',
            owner_id: 'ID do proprietário',
            resolution_col: 'Resolucao',
            notes_col: 'Notas',
        },
        exceptions: {
            title: 'Fila de exceções',
            create: 'Nova exceção',
            severity: 'Gravidade',
            system: 'Sistema',
            owner: 'Proprietário',
            resolve: 'Resolver',
            no_exceptions: 'Nenhuma exceção encontrada.',
            resolve_success: 'Exceção resolvida.',
            dashboard_open: 'Exceções abertas',
            dashboard_resolved: 'Exceções resolvidas',
            dashboard_total: 'Total',
            dashboard_by_severity: 'Por gravidade',
            status_open: 'Aberta',
            status_resolved: 'Resolvida',
            status_accepted_risk: 'Risco aceite',
            create_success: 'Exceção criada.',
            no_exceptions_detail: 'Ainda sem exceções — exceções são criadas a partir de lacunas de alta severidade que requerem tratamento especial.',
            gap_id: 'ID da lacuna',
            system_id: 'ID do sistema',
            system_name: 'Nome do sistema',
            owner_id: 'ID do proprietário',
            resolution_notes: 'Notas de resolução',
            resolution_notes_placeholder: 'Descreva como esta exceção foi resolvida...',
        },
        enterprise_map: {
            title: 'Mapa de dados empresarial',
            inventory: 'Inventário de dados',
            total_systems: 'Total de sistemas',
            total_labels: 'Total de etiquetas',
            approved_count: 'Etiquetas aprovadas',
            proposed_count: 'Etiquetas propostas',
            no_data: 'Sem dados de classificação disponíveis.',
            no_approved_labels: 'Ainda sem rótulos aprovados — rótulos devem ser revisados e aprovados antes de aparecer no mapa de dados.',
            loaded_count: 'Mapa de dados corporativos carregado',
        },
        discovery: {
            title: 'Ciclos de descoberta',
            create: 'Novo ciclo',
            cycle_name: 'Nome do ciclo',
            run_delta: 'Executar deteção delta',
            delta_success: 'Deteção delta concluída.',
            create_success: 'Ciclo de descoberta criado.',
            no_cycles: 'Sem ciclos de descoberta.',
            status_created: 'Criado',
            status_scanning: 'Digitalizando',
            status_review: 'Revisão',
            status_approved: 'Aprovado',
            status_published: 'Publicado',
            status_draft: 'Rascunho',
            running: 'Em execução',
            completed: 'Concluído',
            cancelled: 'Cancelado',
            delta_result_summary: 'Encontrados {added} adicionados, {removed} removidos, {changed} rótulos alterados.',
            delta_results: 'Resultados delta',
            view_results: 'Ver resultados',
            scope_type: 'Tipo de escopo',
            scope_type_all: 'Todos',
            scope_type_systems: 'Sistemas',
            scope_type_datasets: 'Conjuntos de dados',
            scope_ids: 'IDs de escopo',
            scope_ids_placeholder: 'Insira os IDs separados por vírgulas',
            cycle_explanation: 'Um ciclo de descoberta verifica sua infraestrutura de dados para identificar, classificar e rastrear ativos de dados. Configure o escopo para direcionar sistemas ou conjuntos de dados específicos.',
            empty_state_title: 'Ainda não há ciclos de descoberta',
            empty_state_description: 'Crie seu primeiro ciclo de descoberta para começar a digitalizar e classificar seus ativos de dados.',
            empty_state_cta: 'Crie o primeiro ciclo',
            validation_name_required: 'O nome do ciclo é obrigatório',
            validation_scope_type_required: 'O tipo de escopo é obrigatório',
            validation_scope_ids_required: 'É necessário pelo menos um ID de escopo',
        },
        regulatory: {
            sensitivity_importance_info: 'A Lei de Dados (Lei [[TOK_0]], req. 18e4bfd1) requer classificação por sensibilidade e importância como dimensões separadas. Crie uma taxonomia para cada dimensão para atender a esse requisito.',
            handling_rules_info: 'Cada nível de classificação deve definir regras de tratamento por necessidade. b89981ac ("Definir regras de tratamento por nível de classificação").',
            template_internal_ids_info: 'Todos os modelos de classificação usam IDs internos (por exemplo, vn_data_law_data_classification_record). Nenhum modelo é apresentado como formulário oficial do ministério.',
            ai_risk_tiers_info: 'A Lei [[TOK_0]] (Lei [[TOK_3]], req. 3a87ad63) define quatro níveis de risco de sistema [[TOK_1]]: mínimo, limitado, alto e inaceitável. Crie uma taxonomia de risco [[TOK_2]] com esses níveis.',
            ai_risk_tier_minimal: 'Minimo',
            ai_risk_tier_limited: 'Limitado',
            ai_risk_tier_high: 'Alto',
            ai_risk_tier_unacceptable: 'Inaceitavel',
            ai_register_info: 'Os registros de classificação [[TOK_0]] devem ser vinculados a uma entrada de registro do sistema [[TOK_1]] (req. 0f4475d3) capturando: nome do sistema, proprietário, finalidade, contexto de implantação, nível de risco, envolvimento do fornecedor.',
            ai_template_internal_info: 'Os modelos de classificação [[TOK_0]] usam IDs internos (por exemplo, [[TOK_1]]-RISK-01). Nenhum ID de espaço reservado oficial [[TOK_2]] ([[TOK_3]]-HC-01 até [[TOK_4]]-HC-08) é usado.',
            ai_audit_trail_info: 'As alterações de classificação [[TOK_0]] produzem uma trilha de auditoria versionada por UC-VN-06: ator, carimbo de data/hora, valor anterior, novo valor e justificativa.',
            lifecycle_data_d1_info: 'Mapa de transições do ciclo de vida para etapas do procedimento de lei de dados DATA-D1: catalogar, classificar, definir regras de tratamento, capturar evidências, agendar revisões.',
            lifecycle_deletion_link_info: 'Um ativo de dados classificado que atinge o fim da vida útil deve acionar um registro de agendamento de exclusão por meio do módulo Orquestração de exclusão.',
            lifecycle_evidence_info: 'Cada mudança de estado do ciclo de vida (rascunho, ativo, em revisão, arquivado, excluído) captura ator, carimbo de data/hora e justificativa como uma entrada de trilha de auditoria.',
            escalation_timers_info: 'UC-VN-10 prazos de escalonamento: 5 dias úteis para revisão do proprietário, 48 horas para escalonamento de exceção, 72 horas para itens sensíveis/de alto risco.',
            escalation_owner_review: '5 dias uteis',
            escalation_exception: '48 horas',
            escalation_high_risk: '72 horas',
            gap_risk_areas_info: 'Requerimento de Lei de Dados f6c3060a ("Avaliação de risco de dados") requer análise de lacunas em 4 áreas de risco: privacidade, segurança cibernética, controle de acesso e risco operacional.',
            gap_risk_area_privacy: 'Privacidade',
            gap_risk_area_cybersecurity: 'Ciberseguranca',
            gap_risk_area_access: 'Controlo de acesso',
            gap_risk_area_operational: 'Operacional',
            gap_framework_filter_info: 'Filtre as lacunas por estrutura regulatória (VN_DATA_LAW ou VN_AI_LAW_2026) para ver as lacunas relevantes para cada escopo regulatório.',
            framework_vn_data_law: 'Lei de Dados VN',
            framework_vn_ai_law: 'Lei de IA VN 2026',
            enterprise_map_approved_info: 'Este mapa de dados mostra apenas registros de classificação aprovados por UC-VN-10 etapa 10 do fluxo de trabalho ("Os rótulos aprovados tornam-se a verdade atual da empresa"). Os registros preliminares e propostos são excluídos.',
            exports_bundle_info: 'Os pacotes de exportação incluem: registro de classificação, regras de manuseio, propriedade/RACI e pacote de evidências — correspondendo aos requisitos de exportação UC-VN-10 e ao formato da folha de evidências DATA-EVD-01.',
        },
    },
    monitoring: {
        no_permission_title: 'Permissoes insuficientes',
        no_permission_message: 'Voce nao tem permissao para acessar este modulo de monitoramento.',
        errors: {
            fetch: 'Falha ao load. Por favor, tente novamente.',
            save: 'Falha ao save. Por favor, tente novamente.',
            fetch_programs_failed: 'Falha ao fetch programs. Por favor, tente novamente.',
            fetch_kpi_failed: 'Falha ao fetch kpi data. Por favor, tente novamente.',
            create_snapshot_failed: 'Falha ao create snapshot. Por favor, tente novamente.',
            fetch_periods_failed: 'Falha ao fetch periods. Por favor, tente novamente.',
            create_period_failed: 'Falha ao create period. Por favor, tente novamente.',
            auto_generate_failed: 'Falha ao auto-generate periods. Por favor, tente novamente.',
            start_period_failed: 'Falha ao start period. Por favor, tente novamente.',
            close_period_failed: 'Falha ao close period. Por favor, tente novamente.',
            save_program_failed: 'Falha ao save program. Por favor, tente novamente.',
            activate_program_failed: 'Falha ao activate program. Por favor, tente novamente.',
            pause_program_failed: 'Falha ao pause program. Por favor, tente novamente.',
            complete_program_failed: 'Falha ao complete program. Por favor, tente novamente.',
            archive_program_failed: 'Falha ao archive program. Por favor, tente novamente.',
            fetch_ric_templates_failed: 'Falha ao fetch ric templates. Por favor, tente novamente.',
            fetch_ric_cases_failed: 'Falha ao fetch ric cases. Por favor, tente novamente.',
            create_ric_case_failed: 'Falha ao create ric case. Por favor, tente novamente.',
            transition_ric_failed: 'Falha ao transition ric case. Por favor, tente novamente.',
            add_follow_up_failed: 'Falha ao add follow-up. Por favor, tente novamente.',
            respond_follow_up_failed: 'Falha ao respond to follow-up. Por favor, tente novamente.',
            link_evidence_failed: 'Falha ao link evidence. Por favor, tente novamente.',
            fetch_task_templates_failed: 'Falha ao fetch task templates. Por favor, tente novamente.',
            save_task_template_failed: 'Falha ao save task template. Por favor, tente novamente.',
            delete_task_template_failed: 'Falha ao delete task template. Por favor, tente novamente.',
            delete_framework_link_failed: 'Falha ao eliminar a ligação ao quadro regulamentar. Por favor, tente novamente.',
            seed_defaults_failed: 'Falha ao seed defaults. Por favor, tente novamente.',
            fetch_tasks_failed: 'Falha ao fetch tasks. Por favor, tente novamente.',
            create_task_failed: 'Falha ao create task. Por favor, tente novamente.',
            instantiate_tasks_failed: 'Falha ao instantiate tasks. Por favor, tente novamente.',
            start_task_failed: 'Falha ao start task. Por favor, tente novamente.',
            complete_task_failed: 'Falha ao complete task. Por favor, tente novamente.',
            defer_task_failed: 'Falha ao defer task. Por favor, tente novamente.',
            block_task_failed: 'Falha ao block task. Por favor, tente novamente.',
            override_complete_failed: 'Falha ao override complete. Por favor, tente novamente.',
            assign_task_failed: 'Falha ao assign task. Por favor, tente novamente.',
            update_checklist_failed: 'Falha ao update checklist. Por favor, tente novamente.',
        },
        nav: {
            programs: 'Programas',
            periods: 'Períodos',
            task_templates: 'Modelos de Tarefas',
            tasks: 'Tarefas',
            kpi: 'Painel de KPIs',
            ric: 'Inquéritos de Reguladores',
            framework_link: 'Monitorização de Quadro',
            authority_readiness: 'Prontidão Autoridade',
            change_review: 'Revisão de Alterações',
            raci: 'Matriz RACI',
        },
        programs: {
            page_title: 'Programas de monitorização',
            title: 'Programas de Monitorização',
            new: 'Novo Programa',
            edit: 'Editar Programa',
            name: 'Nome',
            scope: 'Âmbito',
            frequency: 'Frequência',
            owner: 'Responsável',
            activate: 'Ativar',
            pause: 'Pausar',
            resume: 'Retomar',
            complete: 'Concluir',
            archive: 'Arquivar',
            custom_frequency_days: 'Personalizado Frequência (days)',
            select_user: 'Selecionar utilizador…',
            assign_training: 'Atribuir formação',
            linked_forms: 'Formulários vinculados',
            linked_forms_none: 'Ainda não há formulários vinculados',
            loaded_count: '{0} programas carregados',
            scope_labels: {
                full: 'Completo',
                partial: 'Parcial',
                targeted: 'Direcionado',
                consent: 'Consentimento',
                dpia: 'DPIA',
                vendors: 'Fornecedores',
                classification: 'Classificação',
                rights_requests: 'Pedidos de direitos',
                data_mapping: 'Mapeamento de dados',
                transfers: 'Transferências',
                security_monitoring: 'Monitoramento de segurança',
                authority_response: 'Resposta da autoridade',
                evidence_preservation: 'Preservação de Evidências',
                localization_review: 'Revisão de localização',
                ai_system_registration: '[[TOK_0]] Registro do sistema',
                ai_pre_deployment: '[[TOK_0]] Avaliação pré-implantação',
                ai_transparency: '[[TOK_0]] Verificação de transparência',
                ai_incident_review: '[[TOK_0]] Revisão de incidente',
            },
            framework_cadence_info: 'Cybersecurity Law programs typically use continuous/monthly/quarterly cadences. AI Law programs typically use annual review cadences.',
        },
        periods: {
            page_title: 'Períodos de monitoramento',
            title: 'Períodos de Revisão',
            new: 'Novo Período',
            label: 'Etiqueta do Período',
            start_date: 'Data de Início',
            end_date: 'Data de Fim',
            reviewers: 'Revisores',
            auto_generate: 'Gerar Períodos Automaticamente',
            start: 'Iniciar',
            close: 'Encerrar',
            change_digest: 'Resumo de Alterações',
            no_digest: 'Nenhum resumo disponível.',
            reviewers_count: 'Contagem de revisores',
            select_program: 'Selecione Program',
            select_program_prompt: 'Selecione program to view periods.',
            hide_digest: 'Ocultar resumo',
            loaded_count: 'Períodos [[TOK_1]] carregados',
            periods_auto_generated: 'Períodos gerados automaticamente',
            label_placeholder: 'ex. 2026-Q1',
        },
        task_templates: {
            page_title: 'Modelos de tarefas',
            title: 'Modelos de Tarefas',
            new: 'Novo Modelo',
            edit: 'Editar Modelo',
            category: 'Categoria',
            priority: 'Prioridade',
            checklist_items: 'Itens da Lista de Verificação',
            effort: 'Esforço Estimado (horas)',
            pre_seeded: 'Pré-carregado',
            seed_defaults: 'Carregar Predefinições',
            add_checklist: 'Adicionar Item à Lista de Verificação',
            guidance: 'Notas de Orientação',
            all_categories: 'Todas as categorias',
            loaded_count: 'Modelos de tarefa [[TOK_1]] carregados',
            defaults_seeded: 'Modelos de tarefas padrão propagados',
            checklist_item_label: 'Item da lista de verificação [[TOK_1]]',
            remove_checklist_item: 'Remover item da lista de verificação [[TOK_1]]',
            category_info: 'Categories cover PDPL compliance, Cybersecurity Law tasks, and AI Law tasks.',
        },
        tasks: {
            page_title: 'Tarefas de revisão',
            title: 'Tarefas de Revisão',
            new: 'Nova Tarefa',
            assigned_to: 'Atribuído A',
            due_date: 'Data Limite',
            checklist: 'Lista de Verificação',
            start: 'Iniciar',
            complete: 'Concluir',
            defer: 'Adiar',
            block: 'Bloquear',
            override_complete: 'Forçar Conclusão',
            link_evidence: 'Associar Evidência',
            direct_upload_label: 'Carregar ficheiro de evidência',
            instantiate: 'Instanciar a partir de Modelos',
            defer_reason: 'Motivo do adiamento',
            override_justification: 'Justificação para forçar conclusão',
            filter_assignee: 'Filtrar por atribuído',
            select_period: 'Selecione período',
            select_program: 'Selecione Program',
            select_program_period_prompt: 'Selecione program and period to view tasks.',
            assign_placeholder: 'Atribuir para...',
            loaded_count: '{0} tarefas carregadas',
            tasks_instantiated: 'Tarefas criadas a partir de modelos',
            overdue: 'Em atraso',
            checklist_for: 'lista de verificação para',
            manage_checklist: 'Gerir lista de verificação',
            add_checklist_item: 'Adicionar item',
            checklist_item_label: 'Item',
            checklist_item_description: 'Descrição',
            remove_checklist_item: 'Remover item',
            save_checklist: 'Guardar lista de verificação',
            no_checklist_items: 'Ainda não há itens.',
            confirm_delete_attachment: 'Tem a certeza de que pretende eliminar este ficheiro de evidência? Esta ação não pode ser anulada.',
        },
        kpi: {
            page_title: 'Painel KPI',
            title: 'Painel de KPIs',
            kpi_name: 'Nome do KPI',
            current_value: 'Valor Atual',
            target: 'Objetivo',
            trends: 'Tendências',
            capture_snapshot: 'Capturar instantâneo',
            select_program: 'Selecione Program',
            select_program_prompt: 'Selecione program to view KPIs.',
            snapshot: 'Instantâneo',
            kpi_labels: {
                on_track: 'Em Rastrear',
                at_risk: 'Em Risco',
                behind: 'Atrasado',
                rights_request_sla_rate: 'Taxa de solicitação de direitos [[TOK_0]]',
                vendor_review_currency: 'Moeda de avaliação do fornecedor',
                dpia_completion_rate: '[[TOK_0]] Taxa de conclusão',
                classification_coverage: 'Cobertura de Classificação',
                consent_policy_currency: 'Moeda da Política de Consentimento',
                security_event_detection_rate: 'Taxa de detecção de eventos de segurança',
                evidence_preservation_compliance_rate: 'Taxa de conformidade de preservação de evidências',
                authority_response_timeliness: 'Pontualidade da resposta da autoridade',
                localization_readiness_score: 'Pontuação de prontidão para localização',
                ai_register_completeness: '[[TOK_0]] Integridade do registro do sistema',
                pre_deployment_gate_pass_rate: 'Taxa de passagem do portão de pré-implantação',
                transparency_disclosure_coverage: 'Cobertura de divulgação de transparência',
                ai_incident_readiness_score: '[[TOK_0]] Pontuação de prontidão para incidentes',
            },
            pdpl_kpi_info: 'The predefined KPI codes are PDPL-specific metrics. For Cybersecurity Law or AI Law monitoring, use framework-specific KPI codes.',
            cybersec_kpi_info: 'KPIs da legislação de segurança cibernética: taxa de detecção de eventos de segurança, taxa de conformidade de preservação de evidências, pontualidade de resposta da autoridade, pontuação de prontidão de localização.',
            ai_law_kpi_info: '[[TOK_0]] KPIs legais: [[TOK_1]] Integridade do registro do sistema, taxa de aprovação do portão de pré-implantação, cobertura de divulgação de transparência, [[TOK_2]] pontuação de prontidão para incidentes.',
            no_data: 'Sem dados disponíveis.',
            snapshot_date: 'Data de instantâneo',
            loaded_count: '{0} instantâneos KPI carregados',
            snapshot_captured: 'Instantâneo KPI capturado',
            showing_chart: 'A mostrar vista de gráfico',
            showing_table: 'A mostrar vista de tabela',
            aria_current_values: 'Valores atuais KPI',
            kpi_label: 'KPI',
            actual: 'Real',
            trend: 'Tendência',
            notes: 'Notas',
            trend_up: 'Em alta',
            trend_down: 'Em baixa',
            trend_stable: 'Estável',
        },
        ric: {
            page_title: 'Casos RIC',
            title: 'Casos de Inquérito de Reguladores',
            new: 'Novo Caso RIC',
            reference: 'Referência',
            regulator: 'Regulador',
            inquiry_type: 'Tipo de Inquérito',
            deadline: 'Prazo de Resposta',
            lead: 'Responsável',
            follow_ups: 'Seguimentos',
            add_follow_up: 'Adicionar Seguimento',
            respond: 'Responder',
            question: 'Questão',
            response: 'Resposta',
            asked_at: 'Pedido em',
            no_follow_ups: 'Sem acompanhamentos ainda.',
            received_date: 'Data de receção',
            responded_at: 'Respondido em',
            hide_follow_ups: 'Ocultar Follow-ups',
            inquiry_types: {
                general: 'Geral',
                investigation: 'Investigação',
                audit: 'Auditoria',
                complaint: 'Reclamação',
                general_audit: 'Auditoria geral',
                rights_requests_review: 'Revisão de pedidos de direitos',
                cross_border_transfer_review: 'Revisão de transferências transfronteiriças',
                vendor_governance_review: 'Revisão de governança de fornecedores',
                consent_management_review: 'Revisão de gestão de consentimento',
                data_mapping_ropa_review: 'Revisão de mapeamento de dados / ROPA',
                incident_readiness_review: 'Revisão de preparação para incidentes',
                security_access_control_review: 'Revisão de segurança e controlo de acesso',
                targeted_processing_review: 'Revisão de processamento dirigido',
                bank_readiness_pack: 'Pacote de preparação bancária',
            },
            link_evidence: 'Ligar Evidência',
            loaded_count: '[[TOK_1]] casos RIC carregados',
            to_follow_up: 'para pergunta de acompanhamento',
            overdue: 'Atrasado',
            overdue_indicator: 'Prazo de resposta excedido',
            template_info: 'RIC templates are internal platform templates. They are not official government-mandated forms.',
            status_labels: {
                received: 'Recebido',
                in_triage: 'Em triagem',
                evidence_gathering: 'Recolha de evidências',
                response_drafting: 'Rascunho de resposta',
                internal_review: 'Revisão interna',
                submitted: 'Submetido',
                follow_up: 'Acompanhamento',
                closed: 'Fechado',
            },
        },
        framework_link: {
            title: 'Monitorização ligada ao quadro',
            link_program: 'Ligar programa ao quadro',
            framework_code: 'Código do quadro',
            select_framework: 'Selecionar um quadro...',
            select_program: 'Selecionar um programa...',
            readiness_score: 'Pontuação de prontidão',
            no_links: 'Nenhum programa ligado ao quadro encontrado',
            seed_defaults: 'Criar modelos predefinidos',
            program_id: 'ID do programa',
            program: 'Programa',
        },
        authority_readiness: {
            title: 'Prontidão para pedidos de autoridade',
            create_entry: 'Nova entrada de prontidão',
            select_framework: 'Selecionar um quadro...',
            framework_code: 'Quadro',
            readiness_status: 'Estado de prontidão',
            readiness_package: 'Pacote de prontidão',
            run_drill: 'Executar exercício de prontidão',
            drill_success: 'Exercício de prontidão registado',
            last_drill: 'Último exercício',
            never_drilled: 'Nunca',
            no_readiness: 'Nenhum dado de prontidão de autoridade encontrado',
            entry_created: 'Entrada de prontidão criada',
            ready: 'Pronto',
            partial: 'Parcial',
            not_ready: 'Não pronto',
            items: 'items',
        },
        change_review: {
            title: 'Revisão de alterações regulamentares',
            new_review: 'Nova revisão de alterações',
            change_id: 'ID de alteração',
            select_change: 'Selecionar uma alteração...',
            select_framework: 'Selecionar um quadro...',
            impact_assessment: 'Avaliação de impacto',
            decision: 'Decisão',
            no_action: 'Sem ação',
            internal_update: 'Atualização interna',
            authority_filing: 'Submissão à autoridade',
            no_reviews: 'Nenhuma revisão de alterações encontrada',
            auto_cycle: 'Ciclo de revisão automático',
            cadence: 'Frequência de revisão',
            framework: 'Estrutura',
        },
        export_csv: 'Exportar [[TOK_0]]',
        exporting: 'Exportando…',
        export_success: '[[TOK_0]] exportado com sucesso.',
        export_failed: 'Falha na exportação de [[TOK_0]].',
        export_attestation_pack: 'Pacote de Atestado de Exportação',
        staleness: {
            badge_label: '[[TOK_1]] itens obsoletos',
            days_since: '[[TOK_1]] dias desde a última atualização',
            detail_title: 'Itens obsoletos',
            accept_justification: 'Aceite com justificativa',
            justification_label: 'Justificativa',
            no_stale: 'Nenhum item obsoleto encontrado.',
            threshold_label: 'Limite de desatualização (dias)',
            threshold_min: 'Mínimo 30 dias',
            threshold_max: 'Máximo 730 dias',
            threshold_saved: 'Limite de inatividade atualizado.',
        },
        csv_columns: {
            name: 'Nome',
            status: 'Estado',
            owner: 'Proprietário',
            created_at: 'Criado em',
            updated_at: 'Atualizado em',
            scope: 'Escopo',
            frameworks: 'Estruturas',
            period_label: 'Etiqueta do período',
            start_date: 'Data de início',
            end_date: 'Data de término',
            task_count: 'Contagem de tarefas',
            completion_rate: 'Taxa de conclusão',
            title: 'Título',
            assigned_to: 'Atribuído a',
            due_date: 'Data de vencimento',
            priority: 'Prioridade',
            completed_at: 'Concluído em',
            kpi_code: '[[TOK_0]] Código',
            kpi_label: '[[TOK_0]] Etiqueta',
            target: 'Alvo',
            actual: 'Real',
            trend: 'Tendência',
            reference: 'Referência',
            regulator: 'Regulador',
            inquiry_type: 'Tipo de consulta',
            lead: 'Liderar',
            received_date: 'Data de Recebimento',
            deadline: 'Prazo',
            framework_code: 'Código Estrutural',
            readiness_status: 'Status de prontidão',
            package_count: 'Contagem de pacotes',
            change_id: 'Alterar ID',
            impact_assessment: 'Avaliação de Impacto',
            decision: 'Decisão',
            program: 'Programa',
            readiness_score: 'Pontuação de prontidão',
            category: 'Categoria',
            checklist_count: 'Contagem da lista de verificação',
            effort_hours: 'Esforço (horas)',
            version: 'Versão',
            department: 'Departamento',
            function_area: 'Área de Função',
            role: 'Função',
            assignee: 'Cessionário',
            frequency: 'Frequência',
        },
        raci: {
            page_title: 'Matriz RACI de Governança',
            title: 'Matriz RACI de Governança',
            department: 'Departamento',
            function_area: 'Área de Função',
            responsible: 'Responsável',
            accountable: 'Responsável',
            consulted: 'Consultado',
            informed: 'Informado',
            assign_role: 'Atribuir função RACI',
            select_program: 'Selecione o programa',
            select_program_prompt: 'Selecione um programa para visualizar a matriz RACI.',
            no_assignments: 'Nenhuma atribuição RACI encontrada.',
            role_updated: 'Atribuição RACI atualizada.',
            role_labels: {
                R: 'Responsável',
                A: 'Responsável',
                C: 'Consultado',
                I: 'Informado',
            },
            loaded_count: 'Atribuições RACI [[TOK_1]] carregadas',
            single_accountability_warning: 'Somente uma função de Responsável (A) é permitida por área de função. Atribuir uma nova função de Responsável substituirá a existente.',
            cybersec_function_areas: 'Áreas de função da Lei de Segurança Cibernética: Resposta a Incidentes, Preservação de Evidências, Cooperação de Autoridades, Revisão de Localização.',
            ai_law_function_areas: '[[TOK_0]] Áreas de função jurídica: Registro de sistema, avaliação pré-implantação, transparência, tratamento de incidentes.',
            suggested_function_areas: 'Áreas funcionais sugeridas',
        },
        prior_cycle: {
            link_label: 'Link para o ciclo anterior',
            select_prior: 'Selecione o ciclo anterior…',
            linked: 'Ano após ano',
            no_prior: 'Nenhum ciclo anterior disponível.',
            linked_success: 'Ciclo anterior vinculado.',
        },
        digest_table: {
            module: 'Módulo',
            entity_type: 'Tipo de entidade',
            change_type: 'Tipo de alteração',
            description: 'Descrição',
            changed_at: 'Alterado em',
        },
        view_related_ric: 'Ver casos RIC relacionados',
        linked_program: 'Programa Vinculado',
        nav_raci: 'Matriz RACI',
    },
    incidents: {
        authority_response_draft: {
            draft_label: 'Rascunho de resposta',
            drafting: 'Elaboração…',
            results_heading: 'Respostas elaboradas ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            counsel_label: 'Revisão do advogado necessária:',
            counsel_default: 'Pelo menos uma resposta requer análise do advogado antes do envio.',
            requires_counsel_label: 'Requer revisão do advogado.',
            accept_label: 'Aceitar rascunho',
            reject_label: 'Rejeitar rascunho',
            error_generic: 'Não foi possível redigir a resposta. Tente novamente ou refine o texto da consulta.',
        },
        breach_timeline: {
            compute_label: 'Cronograma de notificação de violação de computação',
            computing: 'Computação…',
            results_heading: 'Prazos de notificação de violação ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            handoff_label: 'Forseti sugere:',
            empty_label: 'Não há estruturas aplicáveis às jurisdições afetadas.',
            mandatory_label: 'Campos obrigatórios:',
            draft_label: 'Rascunho de notificação',
            remaining_label: '[[TOK_1]]h restantes',
            overdue_label: 'ATRASADO por',
            acknowledge_label: 'Reconhecer — tarefas criadas externamente',
            acknowledging: 'Reconhecendo…',
            error_generic: 'Não foi possível calcular o cronograma da violação. Tente novamente.',
        },
        breach_determination: {
            confirmed_breach: 'Confirmado Violação',
            suspected_breach: 'Violação suspeita',
            not_a_breach: 'Não um Violação',
            pending: 'Pendente',
        },
        errors: {
            fetch: 'Falha ao load incidents. Por favor, tente novamente.',
            save: 'Falha ao save incident. Por favor, tente novamente.',
            fetch_failed: 'Falha ao fetch incidents. Por favor, tente novamente.',
            save_failed: 'Falha ao save incident. Por favor, tente novamente.',
            transition_failed: 'Falha ao transition incident. Por favor, tente novamente.',
            close_failed: 'Falha ao close incident. Por favor, tente novamente.',
            fetch_timeline_failed: 'Falha ao fetch timeline. Por favor, tente novamente.',
            fetch_decisions_failed: 'Falha ao fetch decisions. Por favor, tente novamente.',
            triage_failed: 'Falha ao update triage. Por favor, tente novamente.',
            impact_update_failed: 'Falha ao update impacto avaliação. Por favor, tente novamente.',
            breach_update_failed: 'Falha ao update violação avaliação. Por favor, tente novamente.',
            create_timeline_failed: 'Falha ao create timeline entry. Por favor, tente novamente.',
            create_decision_failed: 'Falha ao create decision. Por favor, tente novamente.',
            notification_update_failed: 'Falha ao update notification. Por favor, tente novamente.',
            fetch_tasks_failed: 'Falha ao fetch tasks. Por favor, tente novamente.',
            create_task_failed: 'Falha ao create task. Por favor, tente novamente.',
            update_task_status_failed: 'Falha ao atualizar o estado da tarefa. Por favor, tente novamente.',
            update_checklist_failed: 'Falha ao update checklist. Por favor, tente novamente.',
            assign_task_failed: 'Falha ao assign task. Por favor, tente novamente.',
            escalate_task_failed: 'Falha ao escalate task. Por favor, tente novamente.',
            fetch_templates_failed: 'Falha ao fetch templates. Por favor, tente novamente.',
            permission_denied: 'Voce nao tem permissao para acessar esta secao. Entre em contato com seu administrador para solicitar acesso.',
        },
        harm_likelihood: {
            unlikely: 'Improvável',
            possible: 'Possível',
            likely: 'Provável',
            very_likely: 'Muito provável',
        },
        reported_via: {
            email: 'E-mail',
            phone: 'Telefone',
            internal_system: 'Interno Sistema',
            third_party: 'Terceiro',
            automated_detection: 'Deteção automatizada',
        },
        task_transition_labels: {
            start: 'Início',
            complete: 'Concluir',
            block: 'Bloquear',
            defer: 'Adiar',
        },
        transition_labels: {
            start: 'Início',
            complete: 'Concluir',
            block: 'Bloquear',
            defer: 'Adiar',
        },
        nav: {
            all: 'Todos os Incidentes',
            tasks: 'Tarefas de Resposta',
            reports: 'Relatórios',
            breach_notifications: 'Notificações de violação',
            supplements: 'Suplementos',
            remediation: 'Remediação',
            authority_requests: 'Pedidos de autoridade',
            disclosure_register: 'Registo de divulgação',
        },
        list: {
            page_title: 'Incidentes',
            title: 'Incidentes',
            new: 'Novo Incidente',
            edit: 'Editar Incidente',
            incident_title: 'Título',
            severity: 'Gravidade',
            reported_at: 'Reportado Em',
            reported_by: 'Reportado Por',
            assigned_to: 'Atribuído A',
            view_detail: 'Ver Detalhe',
            reference: 'Referência',
            lead: 'Responsável',
            reported_via: 'Reportado via',
            discovery_date: 'Data de descoberta',
            hide_details: 'Ocultar Detalhes',
            close_incident: 'Fechar Incidente',
            close_justification_prompt: 'Por favor, forneça uma justificação para encerrar este incidente.',
            justification: 'Justificação',
            lead_id: 'ID do responsável',
            contact: 'Contacto',
            category: 'Categoria',
            not_assessed: 'Não avaliado',
        },
        detail: {
            page_title: 'Detalhe do Incidente',
            title: 'Detalhe do Incidente',
            tabs: {
                overview: 'Resumo',
                triage: 'Triagem',
                impact: 'Avaliação de Impacto',
                breach: 'Avaliação de Violação',
                timeline: 'Cronologia',
                decisions: 'Decisões',
                evidence: 'Evidência',
                audit_trail: 'Trilha de auditoria',
            },
            evidence_upload_label: 'Anexar ficheiro de evidência',
            evidence_uploaded: 'Evidência carregada',
            evidence_deleted: 'Evidência eliminada',
            evidence_delete_error: 'Falha ao eliminar evidência',
            evidence_uploaded_at: 'Carregado',
            evidence_empty: 'Não existem ficheiros de evidência anexados a este incidente.',
            evidence_size: 'Tamanho',
            triage_notes: 'Notas de Triagem',
            initial_classification: 'Classificação Inicial',
            individuals_affected: 'Número de Titulares Afetados',
            data_categories: 'Categorias de Dados Envolvidas',
            systems_compromised: 'Sistemas Comprometidos',
            geographic_scope: 'Âmbito Geográfico',
            breach_determination: 'Determinação de Violação',
            notification_required: 'Notificação Obrigatória',
            notification_deadline: 'Prazo de Notificação',
            pdpc_reportable: 'Reportável à CNPD',
            add_timeline: 'Adicionar Entrada na Cronologia',
            add_decision: 'Adicionar Decisão',
            not_found: 'Incidente não found.',
            team_members: 'Membros da equipa',
            checklist: 'Lista de verificação',
            completed: 'Concluído',
            impact_severity_score: 'Calculated Impacto Gravidade Pontuação',
            records_affected: 'Registos afetados',
            potential_consequences: 'Consequências potenciais',
            harm_likelihood: 'Probabilidade de dano',
            legal_basis: 'Base jurídica',
            jurisdictions: 'Jurisdições',
            jurisdictions_comma: 'Jurisdições (separadas por vírgulas)',
            jurisdiction: 'Jurisdição',
            authority_status: 'Estado da autoridade',
            subject_status: 'Titular Estado',
            authority_deadline: 'Prazo da autoridade',
            subject_deadline: 'Titular Prazo',
            mark_authority_done: 'Marcar autoridade como concluída',
            mark_subject_done: 'Marcar titular como concluído',
            not_assessed: 'Não avaliado',
            event_type: 'Evento Tipo',
            timestamp: 'Marca temporal',
            actor: 'Ator',
            no_timeline_events: 'Ainda sem eventos na cronologia.',
            decision_type: 'Tipo de decisão',
            decision: 'Decisão',
            rationale: 'Fundamentação',
            decision_made: 'Decisão tomada',
            no_decisions: 'Nenhuma decisão registada ainda.',
            jurisdictions_comma_separated: 'VN, SG, UE',
            no_audit_events: 'Nenhum evento de auditoria registrado ainda.',
            export_pdf: 'Exportar PDF',
            pdf_title: 'Relatório Resumo de Incidente',
            description: 'Descrição',
            linked_records: 'Registos Associados',
        },
        tasks: {
            page_title: 'Tarefas de resposta a incidentes',
            title: 'Tarefas de Resposta a Incidentes',
            new: 'Nova Tarefa',
            edit: 'Editar Tarefa',
            task_type: 'Tipo de Tarefa',
            assignee: 'Responsável',
            due_date: 'Data Limite',
            dependencies: 'Dependências',
            mark_complete: 'Marcar como Concluído',
            templates: 'Modelos de Tarefas',
            select_incident: 'Selecionar Incidente',
            all_statuses: 'Todos os Estados',
            all_categories: 'Todas as Categorias',
            new_response_task: 'Nova Tarefa de Resposta',
            category: 'Categoria',
            priority: 'Prioridade',
            depends_on: 'Depende de (IDs de tarefas separados por vírgula)',
            checklist_items: 'Itens da Lista de Verificação',
            remove: 'Remover',
            add: 'Adicionar',
            new_checklist_item: 'Novo item da lista de verificação',
            no_templates: 'Sem modelos disponíveis.',
            assign_task: 'Atribuir Tarefa',
            assign_to: 'Atribuir A',
            assign: 'Atribuir',
            select_incident_prompt: 'Por favor selecione um incidente para visualizar as tarefas de resposta.',
            checklist: 'Lista de Verificação',
            hide_checklist: 'Ocultar Lista de Verificação',
            escalate: 'Escalonar',
            escalations: 'Escalonamentos',
            no_checklist_items: 'Sem itens na lista de verificação.',
        },
        reports: {
            page_title: 'Relatórios de incidentes',
            title: 'Relatórios de Incidentes',
            summary: 'Estatísticas Resumidas',
            by_severity: 'Por Gravidade',
            by_status: 'Por Estado',
            recent: 'Incidentes Recentes',
            total_incidents: 'Total de Incidentes',
            open: 'Abertos',
            closed: 'Encerrados',
            export_csv: 'Exportar CSV',
            export_pdf: 'Exportar PDF',
            export_success: 'Relatório exportado com sucesso.',
            export_error: 'Falha ao exportar relatório.',
            reference: 'Referência',
            view_report: 'Ver Relatório',
        },
        statuses: {
            reported: 'Reportado',
            triage: 'Triagem',
            contained: 'Contido',
            investigation: 'Investigação',
            remediation: 'Remediação',
            closed: 'Encerrado',
            false_positive: 'Falso Positivo',
        },
        task_statuses: {
            pending: 'Pendente',
            in_progress: 'Em Curso',
            completed: 'Concluído',
            blocked: 'Bloqueado',
            cancelled: 'Cancelado',
        },
        severity: {
            low: 'Baixo',
            medium: 'Médio',
            high: 'Alto',
            critical: 'Crítico',
        },
        task_types: {
            containment: 'Contenção',
            investigation: 'Investigação',
            remediation: 'Remediação',
            communication: 'Comunicação',
            documentation: 'Documentação',
            notification: 'Notificação',
        },
        categories: {
            data_breach: 'Dados Violação',
            unauthorized_access: 'Acesso não autorizado',
            data_loss: 'Perda de dados',
            system_compromise: 'Comprometimento do sistema',
            malware: 'Programas maliciosos',
            phishing: 'Phishing',
            insider_threat: 'Ameaça interna',
            other: 'Outro',
        },
        reported_via_options: {
            email: 'E-mail',
            phone: 'Telefone',
            internal_system: 'Interno Sistema',
            third_party: 'Terceiro',
            automated_detection: 'Deteção automatizada',
        },
        harm_likelihood_options: {
            unlikely: 'Improvável',
            possible: 'Possível',
            likely: 'Provável',
            very_likely: 'Muito provável',
        },
        breach_determination_options: {
            confirmed_breach: 'Confirmado Violação',
            suspected_breach: 'Violação suspeita',
            not_a_breach: 'Não um Violação',
            pending: 'Pendente',
        },
        timeline_event_types: {
            detection: 'Deteção',
            escalation: 'Escalamento',
            containment: 'Contenção',
            investigation_start: 'Início da investigação',
            evidence_collected: 'Evidências recolhidas',
            notification_sent: 'Notificação Enviado',
            remediation_action: 'Ação de remediação',
            status_change: 'Alteração de estado',
            communication: 'Comunicação',
            other: 'Outro',
        },
        decision_types: {
            containment: 'Contenção',
            notification: 'Notificação',
            remediation: 'Remediação',
            escalation: 'Escalamento',
            closure: 'Encerramento',
            other: 'Outro',
        },
        task_transitions: {
            start: 'Início',
            complete: 'Concluir',
            block: 'Bloquear',
            cancel: 'Cancelar',
            unblock: 'Desbloquear',
        },
        announce: {
            loaded: '[[TOK_1]] incidentes carregados',
            reports_loaded: '[[TOK_1]] relatórios de incidentes carregados',
            tasks_loaded: '[[TOK_1]] tarefas carregadas',
            created: 'Incidente criado com sucesso',
            updated: 'Incidente atualizado com sucesso',
            closed: 'Incidente fechado com sucesso',
            status_changed: 'Status do incidente alterado',
            triage_completed: 'Triagem concluída com sucesso',
            impact_updated: 'Avaliação de impacto atualizada',
            breach_updated: 'Avaliação de violação atualizada',
            timeline_added: 'Evento de linha do tempo adicionado',
            decision_recorded: 'Decisão registrada',
            notification_updated: 'Status da notificação atualizado',
            task_created: 'Tarefa criada com sucesso',
            task_status_changed: 'Status da tarefa alterado',
            checklist_completed: 'Item da lista de verificação concluído',
            checklist_unchecked: 'Item da lista de verificação desmarcado',
            task_assigned: 'Tarefa atribuída com sucesso',
            task_escalated: 'Tarefa escalonada',
            export_initiated: 'Exportação iniciada',
        },
        breach_notifications: {
            page_title: 'Notificações de violação',
            title: 'Notificações de violação',
            new_notification: 'Nova notificação',
            no_notifications: 'Nenhuma notificação de violação encontrada',
            status: 'Estado',
            submit_to_mps: 'Enviar para [[TOK_0]]',
            decision: 'Decisão',
            decision_maker: 'Tomador de decisões',
            notify: 'Notificar',
            do_not_notify: 'Não notifique',
            rationale: 'Justificativa',
            filing_deadline: 'Prazo de arquivamento',
            overdue: 'Atrasado',
            due_soon: 'Próximo do prazo',
            on_track: 'No prazo',
            legal_review: 'Revisão Jurídica',
            incident_id: 'ID do incidente',
            notification_statuses: {
                assessment: 'Avaliação',
                decision_to_notify: 'Decisão de Notificar',
                notification_drafted: 'Notificação elaborada',
                legal_review: 'Revisão Jurídica',
                submitted_to_mps: 'Enviado para [[TOK_0]]',
                supplement_requested: 'Suplemento solicitado',
                supplement_submitted: 'Suplemento enviado',
                acknowledged: 'Reconhecido',
                closed: 'Fechado',
            },
        },
        supplements: {
            page_title: 'Solicitações de suplementos',
            title: 'Solicitações de suplementos',
            new_supplement: 'Novo suplemento',
            no_supplements: 'Nenhuma solicitação de suplemento encontrada',
            request_details: 'Detalhes da solicitação',
            response_package: 'Pacote de Resposta',
            submit_response: 'Enviar resposta',
            deadline: 'Prazo',
            notification_id: 'ID de notificação',
            enter_notification_id: 'Insira um ID de notificação para visualizar suplementos.',
            supplement_statuses: {
                requested: 'Solicitado',
                drafting: 'Rascunho',
                submitted: 'Enviado',
                accepted: 'Aceito',
                rejected: 'Rejeitado',
            },
        },
        remediation: {
            page_title: 'Ações de remediação',
            title: 'Ações de remediação',
            new_action: 'Nova ação',
            no_actions: 'Nenhuma ação de correção encontrada',
            description: 'Descrição',
            owner: 'Proprietário',
            department: 'Departamento',
            deadline: 'Prazo',
            statuses: {
                planned: 'Planejado',
                in_progress: 'Em andamento',
                completed: 'Concluído',
                verified: 'Verificado',
            },
            verify: 'Verifique',
            incident_id: 'ID do incidente',
            enter_incident_id: 'Insira um ID de incidente para visualizar as ações de correção.',
            start: 'Começar',
            complete_action: 'Concluir',
        },
        authority_requests: {
            page_title: 'Solicitações de autoridade',
            title: 'Solicitações de autoridade',
            new_request: 'Nova solicitação',
            no_requests: 'Nenhuma solicitação de autoridade encontrada',
            authority_name: 'Nome da autoridade',
            request_details: 'Detalhes da solicitação',
            response_package: 'Pacote de Resposta',
            submission_channel: 'Canal de envio',
            submit_response: 'Enviar resposta',
            deadline: 'Prazo',
            confirmation: 'Confirmação',
            incident_id_optional: 'ID do incidente (opcional)',
            response_context_label: 'Contexto da resposta (para materialização de documento de submissão)',
            response_context_none: '(ignorar materialização)',
            response_context_supplement: 'Resposta suplementar',
            response_context_information: 'Resposta a pedido de informação',
            response_context_inspection: 'Resposta a inspeção',
            materialisation_status_column: 'Documento de submissão',
            materialisation_pending: 'Pendente',
            materialisation_success: 'Materializado',
            materialisation_failed: 'Falhado',
            materialisation_retry_button: 'Tentar novamente',
            ar_statuses: {
                received: 'Recebido',
                verified: 'Verificado',
                assembling: 'Montagem',
                submitted: 'Submetido',
                closed: 'Fechado',
            },
        },
        disclosure_register: {
            page_title: 'Registro de Divulgação',
            title: 'Registro de Divulgação',
            new_entry: 'Nova entrada',
            no_entries: 'Nenhuma entrada de registro de divulgação encontrada',
            disclosure_type: 'Tipo de divulgação',
            disclosure_date: 'Data de divulgação',
            recipient: 'Destinatário',
            authority_name: 'Nome da autoridade',
            channel: 'Canal',
            content_summary: 'Resumo do conteúdo',
            incident_id_optional: 'ID do incidente (opcional)',
        },
    },
    onboarding: {
        nav: {
            wizard: 'Assistente de Configuração',
            tours: 'Visitas Guiadas',
            sample_data: 'Dados de Exemplo',
        },
        wizard: {
            title: 'Assistente de Configuração',
            welcome: 'Bem-vindo ao AesirX ComplianceOne',
            welcome_message: 'Vamos configurar a sua organização. Este assistente irá guiá-lo através da configuração inicial.',
            setup_complete: 'Configuração Concluída',
            skipped_message: 'O assistente de configuração foi ignorado. Pode executá-lo a qualquer momento para configurar a sua organização.',
            start_setup: 'Iniciar Configuração',
            skip_wizard: 'Saltar Assistente',
            go_to_admin: 'Vá para Administrador',
            skip_for_now: 'Saltar por Agora',
            next_step: 'Passo Seguinte',
            previous_step: 'Passo Anterior',
            finish_setup: 'Concluir Configuração',
            rerun: 'Executar Assistente Novamente',
            step_label: 'Passo {number}',
            validation_org_name_required: 'O nome da organização é obrigatório.',
            validation_admin_email_required: 'O correio eletrónico do administrador é obrigatório.',
            validation_admin_email_invalid: 'Por favor, introduza um endereço de correio eletrónico válido.',
            validation_cmp_endpoint_required: 'O endpoint CMP é obrigatório quando o CMP está ativado.',
            steps: {
                license_activation: 'Ativação de licença',
                org_profile: 'Perfil da Organização',
                module_selection: 'Seleção de Módulos',
                cmp_integration: 'Integração CMP',
                notification_preferences: 'Notificações',
                review: 'Revisão e Confirmação',
            },
            step_descriptions: {
                license_activation: 'Insira sua chave de licença para ativar seu pacote e determinar quais módulos estão disponíveis.',
                org_profile: 'Configure o nome da organização, jurisdição, setor, tamanho e idioma preferido.',
                module_selection: 'Escolha quais módulos de conformidade ativar para a sua organização.',
                cmp_integration: 'Configure a integração com a Consent Management Platform (opcional).',
                notification_preferences: 'Configure como recebe notificações sobre eventos de conformidade.',
                review: 'Reveja a sua configuração e finalize a instalação.',
            },
            license_step: {
                validate_button: 'Validar licença',
                skip_warning: 'O acesso ao módulo será limitado ao nível de pacote padrão. Você pode ativar uma licença posteriormente em Plataforma > Configurações de licença.',
            },
            module_descriptions: {
                rights_requests: 'Trate pedidos de acesso e eliminação de dados pessoais.',
                data_mapping: 'Mapeie sistemas, fluxos de dados e atividades de processamento.',
                governance: 'Gerencie a conformidade de fornecedores e procedimentos de eliminação.',
                consent: 'Gerencie políticas de consentimento e catálogos de finalidades.',
                consent_properties: 'Gerencie o consentimento em múltiplas propriedades digitais.',
                assessments: 'Realize avaliações de impacto e transferências transfronteiriças de dados.',
                classification: 'Classifique e rotule ativos de dados com rastreamento do ciclo de vida.',
                monitoring: 'Revisões de conformidade programadas e rastreamento de KPI.',
                incidents: 'Reporte e gerencie incidentes de segurança e privacidade.',
                connectors: 'Conecte-se a sistemas externos para troca automatizada de dados.',
                vendor_risk: 'Pontue fornecedores, rastreie contratos e gerencie a devida diligência.',
                deletion_orchestration: 'Coordene a eliminação de dados entre sistemas e fornecedores.',
                discovery: 'Descubra e classifique dados em toda a sua infraestrutura.',
                incident_ops: 'Playbooks avançados de incidentes, rastreamento de SLA e escalações.',
                program_governance: 'Avaliações de maturidade, relatórios executivos e prontidão para auditoria.',
                access_accountability: 'Monitore o acesso de utilizadores, sessões e fluxos de justificação.',
                localization: 'Pacotes de conformidade específicos do mercado e enquadramentos regulatórios.',
                partner_workspace: 'Espaço de trabalho de parceiros e revendedores.',
                privacy_scanner: 'Monitorização de privacidade em tempo real de propriedades digitais.',
                onboarding: 'Assistente de configuração, visitas guiadas e gestão de dados de exemplo.',
                compliance_forms: 'Modelos de conformidade interativos e geração de documentos.',
                audit_trail: 'Registo de auditoria imutável abrangente e retenção.',
                organizations: 'Gestão multi-organização e de grupos.',
                task_management: 'Planeamento unificado de tarefas, motor de fluxo de trabalho e vistas de calendário.',
            },
            module_categories: {
                data_privacy_rights: 'Privacidade e direitos de dados',
                vendor_third_party: 'Gerenciamento de fornecedores e terceiros',
                risk_assessment: 'Risco e Avaliação',
                operations_automation: 'Operações e Automação',
                platform_admin: 'Plataforma e Administração',
            },
            package_tier_label: 'O Seu Pacote',
            package_module_unavailable: 'Não incluído no seu pacote',
            select_all: 'Selecionar Tudo',
            deselect_all: 'Desselecionar Tudo',
            load_sample_data: 'Carregar dados de exemplo após a configuração',
            load_sample_data_description: 'Instale dados de demonstração realistas (Lotus Financial Services) para explorar a plataforma. Pode ser removido mais tarde em Integração > Dados de Exemplo.',
            language_label: 'Idioma Preferido',
            language_description: 'Escolha o idioma predefinido para a sua organização.',
            admin_account_title: 'Conta de Administrador',
            admin_account_created: 'Conta de administrador criada',
            admin_full_name: 'Nome completo',
            admin_email: 'Endereço de e-mail',
            admin_password: 'Palavra-passe',
            admin_confirm_password: 'Confirmar palavra-passe',
            admin_show_password: 'Mostrar palavra-passe',
            admin_hide_password: 'Ocultar palavra-passe',
            admin_name_placeholder: 'por exemplo Jane Smith',
            admin_email_placeholder: 'admin@example.com',
            admin_password_placeholder: 'Mínimo 8 caracteres',
            admin_password_confirm_placeholder: 'Reintroduzir palavra-passe',
            validation_admin_name_required: 'O nome do administrador é obrigatório',
            validation_admin_password_required: 'A palavra-passe é obrigatória',
            validation_admin_password_min_length: 'A palavra-passe deve ter pelo menos 8 caracteres',
            validation_passwords_mismatch: 'As palavras-passe não coincidem',
            notification_email_enabled: 'Ativar Notificações por E-mail',
            notification_email_description: 'Receba notificações por e-mail sobre atribuições de tarefas, violações de SLA e eventos de conformidade.',
            notification_digest_frequency: 'Frequência do Resumo',
            notification_digest_daily: 'Diário',
            notification_digest_weekly: 'Semanal',
            notification_digest_none: 'Sem resumo',
            notification_in_app_enabled: 'Ativar Notificações da Plataforma',
            notification_in_app_description: 'Mostrar emblema e gaveta de notificações para alertas em tempo real.',
            jurisdictions: {
                vietnam: 'Vietname',
                asean: 'ASEAN',
                eu_eea: 'UE/EEE',
                global: 'Globais',
            },
            languages: {
                en: 'Inglês',
                vi: 'Tiếng Việt',
                da: 'Dinamarquês',
                sv: 'Sueca',
                nb: 'Norsk Bokmål',
                nn: 'Norsk Nynorsk',
                de: 'Alemão',
                fi: 'Suomi',
                nl: 'Holanda',
                fr: 'Francês',
                lb: 'Lëtzebuergesch',
                ga: 'gaélico',
                es: 'Espanhol',
                ca: 'Catalã',
                eu: 'Euskara',
                pt: 'Português',
            },
            industries: {
                financial_services: 'Serviços Financeiros',
                healthcare: 'Saúde',
                technology: 'Tecnologia',
                telecommunications: 'Telecomunicações',
                government: 'Governo',
                education: 'Educação',
                manufacturing: 'Indústria Transformadora',
                retail: 'Comércio a Retalho',
                other: 'Outro',
            },
            placeholders: {
                org_name: 'por exemplo, Lotus Financial Services',
                admin_email: 'admin@company.vn',
                team_emails: 'usuário1@empresa.vn, usuário2@empresa.vn',
                cmp_endpoint: 'https://cmp.example.com/api',
            },
            fields: {
                org_name: 'Nome da Organização',
                jurisdiction: 'Jurisdição',
                industry: 'Setor de Atividade',
                org_size: 'Dimensão da Organização',
                language: 'Idioma Preferido',
                admin_email: 'Correio Eletrónico do Administrador',
                team_emails: 'Correios Eletrónicos dos Membros da Equipa (separados por vírgula)',
                enable_cmp: 'Ativar Integração CMP',
                cmp_endpoint: 'Endpoint da API CMP',
                email_notifications: 'Notificações por E-mail',
                in_app_notifications: 'Notificações da Plataforma',
                digest_frequency: 'Frequência do Resumo',
            },
        },
        tours: {
            title: 'Visitas Guiadas aos Módulos',
            start: 'Iniciar Visita',
            continue_tour: 'Continuar Visita',
            replay: 'Repetir Visita',
            exit: 'Sair da Visita',
            skip: 'Saltar Visita',
            next: 'Seguinte',
            previous: 'Anterior',
            finish: 'Concluir Visita',
            step_of: 'Passo {current} de {total}',
            info: 'Faça visitas guiadas a cada módulo para conhecer as principais funcionalidades e fluxos de trabalho. As visitas podem ser repetidas a qualquer momento.',
            autoplay: 'Reprodução automática',
            interactive: 'Interativo',
            play_all: 'Jogue tudo',
            search_tours: 'Pesquisar passeios...',
            duration: 'Duração',
            steps_label: '[[TOK_1]] etapas',
            mode: 'Modo',
            pause: 'Pausa',
            resume: 'Currículo',
            speed: 'Velocidade',
            restart: 'Reiniciar',
            reset: 'Redefinir',
            reset_success: 'O progresso do tour foi redefinido.',
            category_core_privacy: 'Privacidade Central',
            category_governance: 'Governança',
            category_operations: 'Operações',
            category_platform: 'Plataforma',
            category_advanced: 'Avançado',
            category_data_privacy_rights: 'Privacidade e direitos de dados',
            category_vendor_third_party: 'Gerenciamento de fornecedores e terceiros',
            category_risk_assessment: 'Risco e Avaliação',
            category_operations_automation: 'Operações e Automação',
            category_platform_admin: 'Plataforma e Administração',
            steps_count: '[[TOK_1]] etapas',
        },
        sample_data: {
            title: 'Gestão de Dados de Exemplo',
            select_modules: 'Selecionar Módulos',
            current_status: 'Estado Atual',
            operation_history: 'Histórico de Operações',
            load: 'Carregar Dados de Exemplo',
            clear: 'Limpar Dados de Exemplo',
            processing: 'A processar...',
            loaded: 'Carregado',
            not_loaded: 'Não Carregado',
            records: 'Registos de Exemplo',
            confirm_clear: 'Tem a certeza de que pretende limpar todos os dados de exemplo dos módulos selecionados?',
            confirm_clear_title: 'Limpar dados de exemplo',
            confirm_load_title: 'Carregar dados de exemplo',
            confirm_load: 'Tem certeza de que deseja carregar dados de exemplo para os módulos selecionados?',
            action_load: 'Carregar',
            action_clear: 'Limpar',
            info: 'Carregue dados de demonstração realistas para formação e demonstrações utilizando a empresa fictícia "Lotus Financial Services". Os dados de exemplo estão etiquetados e podem ser removidos com segurança sem afetar os dados reais.',
        },
        help: {
            title: 'Centro de Ajuda',
            search: 'Pesquisar',
            search_placeholder: 'Pesquisar artigos de ajuda...',
            clear: 'Limpar',
            all_categories: 'Todas as Categorias',
            all_modules: 'Todos os Módulos',
            back: 'Voltar ao Centro de Ajuda',
            callout_important: 'Importante',
            callout_tip: 'Dica',
            no_results: 'Não foram encontrados artigos correspondentes à sua pesquisa.',
            no_articles: 'Ainda não existem artigos de ajuda disponíveis. Os artigos aparecerão aqui à medida que o conteúdo for adicionado.',
            results_for: '{count} resultado(s) para "{query}"',
            quick_links: {
                getting_started: 'Começar',
                getting_started_desc: 'Instalação, configuração e guia de início rápido.',
                user_guide: 'Guia do Utilizador',
                user_guide_desc: 'Documentação de utilização módulo a módulo.',
                admin_guide: 'Guia do Administrador',
                admin_guide_desc: 'Configuração, manutenção e resolução de problemas.',
                faq: 'Perguntas Frequentes',
                faq_desc: 'Perguntas frequentes e respostas.',
            },
            search_articles_aria: 'Pesquisar artigos de ajuda',
            article_metadata_aria: 'Metadados do artigo',
            articles_list_aria: 'Artigos de ajuda',
            category_nav_aria: 'Navegação por categorias',
            quick_links_aria: 'Links rápidos para categorias de ajuda',
            returned_to_list: 'Retornou à lista de artigos',
            opening_article: 'Abrindo artigo: {title}',
            read_article_aria: 'Ler artigo: {title}',
            pagination_nav_aria: 'Paginação de artigos',
            error_unavailable: 'O centro de ajuda está atualmente indisponível. Por favor, tente novamente mais tarde.',
            retry: 'Tentar novamente',
        },
    },
    common: {
        save: 'Guardar',
        cancel: 'Cancelar',
        system_actor: 'Sistema',
        delete: 'Eliminar',
        edit: 'Editar',
        create: 'Criar',
        update: 'Atualizar',
        loading: 'A carregar...',
        error: 'Ocorreu um erro',
        success: 'Sucesso',
        logout: 'Terminar Sessão',
        actions: 'Ações',
        retrying: 'Tentando novamente…',
        permission_denied: 'Você não tem acesso a esta página.',
        status: 'Estado',
        description: 'Descrição',
        name: 'Nome',
        created_at: 'Criado Em',
        updated_at: 'Atualizado Em',
        yes: 'Sim',
        no: 'Não',
        confirm: 'Confirmar',
        back: 'Voltar',
        next: 'Seguinte',
        previous: 'Anterior',
        search: 'Pesquisar',
        filter: 'Filtrar',
        page_x_of_y: 'Página [[TOK_2]] de [[TOK_3]]',
        pagination_label: 'Paginação',
        view_mode_label: 'Modo de visualização',
        export: 'Exportar',
        exporting: 'A exportar…',
        sidebar_navigation: 'Navegação lateral de administração',
        items_count: '{count} itens',
        items_count_one: '[[TOK_1]] item',
        export_success: 'Documento gerado com sucesso.',
        generate_pdf: 'Gerar PDF',
        import: 'Importar',
        download: 'Transferir',
        upload: 'Carregar',
        view: 'Ver',
        close: 'Fechar',
        submit: 'Submeter',
        saved: 'Guardado com sucesso',
        saving: 'A guardar...',
        submitting: 'A submeter...',
        created: 'Criado com sucesso',
        all: 'Todos',
        none: 'Nenhum',
        select: 'Selecionar',
        select_user: 'Selecione o usuário...',
        custom_input: 'Introduzir manualmente',
        required: 'Obrigatório',
        optional: 'Opcional',
        notes: 'Notas',
        tags: 'Etiquetas',
        archive: 'Arquivar',
        clone: 'Clonar',
        refresh: 'Atualizar',
        retry: 'Tentar Novamente',
        reset: 'Repor',
        add: 'Adicionar',
        remove: 'Remover',
        removing: 'A remover…',
        attachment: 'Anexo',
        upload_file: 'Carregar ficheiro',
        upload_file_required: 'Carregar ficheiro (obrigatório)',
        select_entity_type_first: 'Selecione primeiro um tipo de entidade',
        failed_to_remove_file: 'Falha ao remover o ficheiro.',
        entity_type_label: 'Tipo de entidade',
        entity_label: 'Entidade',
        entity_reference: 'Referência de entidade',
        failed_to_load_entities: 'Falha ao carregar entidades',
        enable: 'Ativar',
        disable: 'Desativar',
        no_data: 'Dados não encontrados',
        confirm_delete: 'Tem a certeza de que pretende eliminar este item?',
        confirm_action: 'Tem a certeza de que pretende continuar?',
        save_success: 'Guardado com sucesso',
        save_error: 'Falha ao guardar',
        delete_success: 'Eliminado com sucesso',
        delete_error: 'Falha ao eliminar',
        hour: 'hora',
        hours: 'horas',
        load_error: 'Falha ao carregar dados',
        operation_error: 'Operação falhou',
        something_went_wrong: 'Algo correu mal',
        go_home: 'Ir para o Painel de Controlo',
        access_denied: 'Acesso Negado',
        no_permission: 'Não tem permissão para aceder a esta página.',
        no_permission_title: 'Permissões insuficientes',
        no_permission_message: 'Você não tem permissão para acessar esta página.',
        unknown: 'Desconhecido',
        back_to_dashboard: 'Voltar ao Painel de Controlo',
        id: 'ID',
        type: 'Tipo',
        date: 'Data',
        created_by: 'Criado Por',
        updated_by: 'Atualizado Por',
        page_of: 'Página {page} de {total}',
        showing_items: 'A apresentar {count} itens',
        items_per_page: 'Itens por página',
        no_results: 'Nenhum registo corresponde aos seus filtros',
        no_items: 'Nenhum item encontrado',
        sort_by: 'Ordenar por',
        ascending: 'Ascendente',
        descending: 'Descendente',
        all_statuses: 'Todos os Estados',
        all_types: 'Todos os Tipos',
        all_categories: 'Todas as Categorias',
        all_severities: 'Todas as Gravidades',
        date_range: 'Intervalo de Datas',
        from_date: 'De',
        to_date: 'Até',
        clear_filters: 'Limpar Filtros',
        apply_filters: 'Aplicar Filtros',
        save_changes: 'Guardar Alterações',
        discard_changes: 'Descartar Alterações',
        confirm_discard: 'Tem alterações por guardar. Pretende descartá-las?',
        copy: 'Copiar',
        duplicate: 'Duplicar',
        move: 'Mover',
        assign: 'Atribuir',
        unassign: 'Remover Atribuição',
        approve: 'Aprovar',
        reject: 'Rejeitar',
        deleting: 'A eliminar...',
        processing: 'A processar...',
        loading_page: 'A carregar página...',
        operation_success: 'Operação concluída com sucesso',
        operation_failed: 'Operação falhada. Tente novamente.',
        empty_dash: '-',
        network_error: 'Erro de rede. Verifique a sua ligação.',
        session_expired: 'Sessão expirada. Inicie sessão novamente.',
        test: 'Testar',
        pause: 'Pausar',
        resume: 'Retomar',
        activate: 'Ativar',
        last_sync: 'Última Sincronização',
        health: 'Estado',
        email: 'E-mail',
        role: 'Função',
        title: 'Título',
        owner: 'Responsável',
        priority: 'Prioridade',
        category: 'Categoria',
        details: 'Detalhes',
        overview: 'Resumo',
        configuration: 'Configuração',
        history: 'Histórico',
        new_item: 'Novo',
        edit_item: 'Editar',
        select_option: 'Selecionar...',
        total: 'Total',
        active: 'Ativo',
        inactive: 'Inativo',
        enabled: 'Ativado',
        disabled: 'Desativado',
        last_login: 'Último Início de Sessão',
        never: 'Nunca',
        password_changed: 'Palavra-passe alterada. A sessão será terminada.',
        password_change_failed: 'Falha ao alterar a palavra-passe',
        passwords_mismatch: 'As palavras-passe não coincidem',
        install: 'Instalar',
        uninstall: 'Desinstalar',
        installed: 'Instalado',
        available: 'Disponível',
        catalog: 'Catálogo',
        published: 'Publicado',
        version: 'Versão',
        market: 'Mercado',
        language: 'Idioma',
        framework: 'Enquadramento',
        template: 'Modelo',
        connector_type: 'Tipo de Conector',
        polling_interval: 'Intervalo de Consulta (minutos)',
        new_instance: 'Nova Instância',
        change_password: 'Alterar Palavra-passe',
        current_password: 'Palavra-passe Atual',
        new_password: 'Nova Palavra-passe',
        confirm_password: 'Confirmar Palavra-passe',
        comments: 'Comentários',
        completed: 'Concluído',
        contact: 'Contacto',
        hide: 'Ocultar',
        hide_details: 'Ocultar Detalhes',
        label: 'Rótulo',
        max: 'Max',
        min: 'Min',
        na: 'N/A',
        of: 'of',
        showing: 'A mostrar',
        page: 'Página',
        preview: 'Pré-visualização',
        print: 'Imprimir',
        show: 'Mostrar',
        status_active: 'Ativo',
        status_completed: 'Concluído',
        status_draft: 'Rascunho',
        status_in_progress: 'Em curso',
        status_pending: 'Pendente',
        view_details: 'Ver detalhes',
        all_priorities: 'Todas as prioridades',
        pipeline: 'Gasoduto',
        all_requests: 'Todos Pedidos',
        schedule: 'Agendar',
        deploy: 'Implementar',
        rollback: 'Reverter',
        advance_stage: 'Avançar etapa',
        submit_for_approval: 'Submeter para Approval',
        approval_log: 'Registo de aprovação',
        approver: 'Aprovador',
        decision: 'Decisão',
        decided_at: 'Decidido em',
        rollout_stages: 'Etapas de implementação',
        approval_comment: 'Comentário de aprovação',
        optional_comment: 'Comentário opcional...',
        impact_summary: 'Impacto Resumo',
        target_property_ids: 'IDs de propriedades de destino (separados por vírgulas)',
        policy_id: 'Política ID',
        target_version: 'Versão de destino',
        target_version_placeholder: 'p. ex. 2.0.0',
        scheduled_label: 'Agendado',
        scheduled_start: 'Agendado Início',
        scheduled_end: 'Agendado Fim',
        properties_count: '{count} propriedades',
        results: 'Resultados',
        comparison_results: 'Resultados de comparação',
        past_comparison_reports: 'Relatórios de comparação anteriores',
        scanning: 'A analisar...',
        run_inconsistency_scan: 'Executar Inconsistency Analisar',
        property_ids_label: 'IDs de propriedade (separados por vírgulas, mín 2)',
        comparison_type: 'Tipo de comparação',
        golden_template_id: 'ID do modelo de referência (opcional)',
        leave_blank_compare: 'Deixe em branco para comparar propriedades entre si',
        add_notes_placeholder: 'Adicionar your analysis notes here...',
        covered_of_active: '{covered} de {active} propriedades ativas cobertas',
        fetch_error: 'Falha ao fetch data. Por favor, tente novamente.',
        run_comparison_error: 'Falha ao run comparison. Por favor, tente novamente.',
        save_notes_error: 'Falha ao save notes. Por favor, tente novamente.',
        scan_complete: 'Inconsistency scan concluído com sucesso',
        scan_error: 'Falha ao run inconsistency scan. Por favor, tente novamente.',
        min_two_properties: 'Forneça pelo menos 2 IDs de propriedade para comparação.',
        comma_separated: 'separados por vírgulas',
        language_english: 'Inglês',
        language_vietnamese: 'Vietnamita',
        language_vietnamese_native: 'Tiếng Việt',
        author: 'Autor',
        dependencies: 'Dependências',
        checksum: 'Soma de verificação',
        changelog: 'Registo de alterações',
        tier: 'Nível',
        phone: 'Telefone',
        launch: 'Lançar',
        complete: 'Concluir',
        back_to_list: 'Voltar para Lista',
        clear_selection: 'Limpar seleção',
        deactivate: 'Desativar',
        scope: 'Âmbito',
        deadline: 'Prazo',
        progress: 'Progresso',
        frequency: 'Frequência',
        reviewer: 'Revisor',
        user: 'Utilizador',
        campaign: 'Campanha',
        items: 'Itens',
        next_run: 'Seguinte Executar',
        last_run: 'Último Executar',
        overdue: 'EM ATRASO',
        creating: 'A criar...',
        launching: 'A lançar...',
        loaded: 'loaded',
        page_size: 'Tamanho da página',
        per_page: '/página',
        urgent: 'Urgente',
        pagination: 'Paginação',
        metric: 'Métrica',
        value: 'Valor',
        country: 'País',
        showing_chart_view: 'Exibindo visualização de gráfico',
        showing_table_view: 'Exibindo visualização de tabela de dados',
        policies: 'Políticas',
        select_content_type: 'Por favor, selecione pelo menos um tipo de conteúdo.',
        compliant: 'Compatível',
        non_compliant_status: 'Não conforme',
        all_data: 'Todos os dados',
        sr_urgent: 'Urgente',
        n_per_page: '[[TOK_1]] / página',
        select_user_placeholder: '-- Selecione o usuário --',
        field_required: 'Este campo é obrigatório',
        results_found: 'resultados encontrados',
        select_placeholder: '-- Selecionar --',
        unknown_user: 'Utilizador desconhecido',
        export_csv: 'Exportar CSV',
        not_applicable: 'N/A',
        aria_overdue_since: 'Em atraso desde {date}',
        placeholders: {
            enter_justification: 'Introduza justification',
            justification: 'Justificação',
            campaign_name_example: 'Q1 2026 Acesso Rever',
            optional_description: 'Descrição opcional',
            enter_user_id: 'Introduza user ID of the reviewer',
            enter_user_id_short: 'Introduza user ID',
            schedule_name_example: 'Trimestral Acesso Attestation',
            enter_property_id: 'Introduza property ID',
            enter_policy_id: 'Introduza política id',
            property_or_group_id: 'ID de propriedade ou grupo',
            describe_template_purpose: 'Descreva o propósito do modelo...',
            step_title: 'Título do passo...',
            detailed_instructions: 'Instruções detalhadas...',
            filter_by_taxonomy_id: 'Filtrar por ID de taxonomia...',
            describe_classification_rule: 'Descreva a regra de classificação...',
            describe_dedup_rule: 'Descreva a regra de deduplicação...',
            describe_import_template: 'Descreva o modelo de importação...',
            reason_for_rejection: 'Motivo de rejeição...',
            jurisdiction_codes_example: 'VN, SG, UE',
            filter_by_locale: 'Filtrar por idioma...',
            filter_by_event_type: 'Filtrar por tipo de evento',
            filter_by_actor_id: 'Filtrar por ID de ator',
            filter_by_market_code: 'Filtrar por código de mercado...',
            filter_by_framework_id: 'Filtrar por enquadramento ID...',
            add_comment: 'Adicionar comment...',
            provide_rejection_reason: 'Forneça um motivo para rejeitar esta submissão...',
            filter_by_jurisdiction: 'Filtrar por código de jurisdição...',
            enter_report_title: 'Introduza report title',
            enter_name: 'Introduza name',
            enter_description: 'Introduza description',
            enter_org_id: 'Introduza Org ID to add',
            describe_evidence_gap: 'Descreva a lacuna de evidência...',
            expected_evidence: 'Que evidência é esperada',
            entity_identifier: 'Identificador da entidade',
            remediation_steps: 'Passos para remediar esta lacuna',
            user_id_or_name: 'ID de utilizador ou nome',
            reporting_period_id: 'ID do período de relatório',
            maturity_model_id: 'ID do modelo de maturidade',
            describe_maturity_model: 'Descreva este modelo de maturidade...',
            describe_role_purpose: "Describe this role's purpose...",
            provide_deny_reason: 'Forneça um motivo para negar este pedido',
            describe_emergency: 'Descreva a situação de emergência que requer acesso elevado (mínimo 20 caracteres)',
            enter_delegate_id: 'Introduza user ID of the delegate',
            provide_delegation_reason: 'Forneça um motivo para esta delegação',
            client_identifier: 'Identificador de cliente',
            client_secret: 'Segredo do cliente',
            time_format: 'HH:MM',
            describe_sod_rule: 'Descreva o propósito desta regra SoD...',
            enter_role_id: 'Introduza role ID',
            explain_exception: 'Explique por que esta exceção é necessária...',
            describe_compensating_controls: 'Descreva os controlos compensatórios em vigor...',
            full_name: 'Nome completo',
            min_chars: 'Mín 12 caracteres',
            enter_override_justification: 'Introduza justification for overriding this gate evaluation',
            enter_evidence_id: 'Insira o ID da evidência para vincular:',
            date_format: 'DD/MM/AAAA',
            describe_pack_contents: 'Descreva o conteúdo e o propósito do pacote',
            select_reviewers: 'Selecionar revisores...',
        },
        aria_previous_page: 'Página anterior',
        aria_next_page: 'Próxima página',
        aria_results_per_page: 'Resultados por página',
        per_page_25: '25/página',
        per_page_50: '50/página',
        per_page_100: '100/página',
        select_language: 'Selecionar idioma',
        today: 'Hoje',
        tomorrow: 'Amanhã',
        dashboard_load_error: 'Não foi possível carregar o painel. Por favor, tente novamente.',
        enum_grade: {
            red: 'Vermelho',
            amber: 'Âmbar',
            yellow: 'Amarelo',
            green: 'Verde',
        },
        enum_severity: {
            critical: 'Crítico',
            high: 'Alto',
            medium: 'Médio',
            low: 'Baixo',
        },
        enum_priority: {
            critical: 'Crítico',
            high: 'Alto',
            medium: 'Médio',
            low: 'Baixo',
        },
        enum_status: {
            pending: 'Pendente',
            in_progress: 'Em andamento',
            completed: 'Concluído',
            blocked: 'Bloqueado',
            escalated: 'Escalado',
            cancelled: 'Cancelado',
            overdue: 'Atrasado',
            not_started: 'Não iniciado',
            new: 'Novo',
            open: 'Aberto',
            closed: 'Fechado',
            acknowledged: 'Reconhecido',
            resolved: 'Resolvido',
        },
        enum_department: {
            unassigned: 'Não atribuído',
        },
        enum_form_category: {
            assessment: 'Avaliação',
            assessment_report: 'Relatório de Avaliação',
            dpia: '[[TOK_0]]',
            authority_submission: 'Envio de autoridade',
            cross_border_transfer: 'Transferência transfronteiriça',
            vendor: 'Fornecedor',
            breach: 'Violação',
            consent: 'Consentimento',
            governance: 'Governança',
            register: 'Cadastre-se',
            monitoring: 'Monitoramento',
            dpa: 'APD',
            dsr: 'DSR',
            privacy: 'Privacidade',
            incident: 'Incidente',
            org: 'Organização',
            sector: 'Setor',
            classification: 'Classificação',
            discovery: 'Descoberta',
        },
        enum_module: {
            rights_requests: 'Solicitações de direitos',
            assessments: 'Avaliações',
            incidents: 'Incidentes',
            incident_ops: 'Operações de incidentes',
            monitoring: 'Monitoramento',
            vendor_risk: 'Risco do fornecedor',
            governance: 'Governança',
            deletion_orchestration: 'Exclusão',
            access_review: 'Revisão de acesso',
            consent: 'Consentimento',
            consent_properties: 'Propriedades de consentimento',
            forms: 'Formulários',
            localization: 'Localização',
            program_governance: 'Governança do Programa',
            privacy_scanner: 'Verificador de privacidade',
            classification: 'Classificação',
            discovery: 'Descoberta',
            manual: 'Manuais',
            data_mapping: 'Mapeamento de dados',
        },
        enum_risk_level: {
            critical: 'Crítico',
            high: 'Alto',
            medium: 'Médio',
            low: 'Baixo',
        },
        enum_request_type: {
            all: 'All',
            access: 'Acesso ([[TOK_0]])',
            deletion: 'Exclusão',
            correction: 'Correção',
            objection: 'Objeção',
            portability: 'Portabilidade',
            restriction: 'Restrição',
            consent_withdrawal: 'Retirada de consentimento',
        },
        enum_locale: {
            en: 'Inglês',
            vi: 'Vietnamita',
            all: 'Ambos',
        },
        enum_event_type: {
            case_created: 'Caso criado',
            status_changed: 'Status alterado',
            case_assigned: 'Caso atribuído',
            note_added: 'Nota adicionada',
            attachment_added: 'Anexo adicionado',
            attachment_deleted: 'Anexo excluído',
            reference_added: 'Referência adicionada',
            checklist_updated: 'Lista de verificação atualizada',
            identity_verified: 'Identidade verificada',
            closure_summary_added: 'Resumo de encerramento',
            approval_granted: 'Aprovação concedida',
            template_applied: 'Modelo aplicado',
            export_generated: 'Exportação gerada',
            sla_warning: '[[TOK_0]] Aviso',
            sla_overdue: '[[TOK_0]] Vencido',
        },
        more: 'more',
        use: 'Use',
        ok: 'OK',
    },
    common_statuses: {
        removed: 'Removido',
        draft: 'Rascunho',
        active: 'Ativo',
        inactive: 'Inativo',
        pending: 'Pendente',
        in_progress: 'Em Curso',
        completed: 'Concluído',
        archived: 'Arquivado',
        published: 'Publicado',
        approved: 'Aprovado',
        rejected: 'Rejeitado',
        cancelled: 'Cancelado',
        blocked: 'Bloqueado',
        deferred: 'Adiado',
        not_started: 'Não Iniciado',
        dismissed: 'Dispensado',
        failed: 'Falhado',
        in_review: 'Em Rever',
        deprecated: 'Obsoleto',
        scheduled: 'Agendado',
        deploying: 'A implementar',
        deployed: 'Implementado',
        paused: 'Em pausa',
        rolled_back: 'Revertido',
        received: 'Recebido',
        processing: 'Tratamento',
        under_assessment: 'Em avaliação',
        implemented: 'Implementado',
        pending_approval: 'Aprovação pendente',
        pending_deletion: 'Pendente Eliminação',
        on_hold: 'Em espera',
        deleted: 'Eliminado',
        expired: 'Expirado',
        outdated: 'Desatualizado',
        drifted: 'Desviado',
        decommissioned: 'Descomissionado',
        match: 'Correspondência',
        different: 'Diferente',
        missing: 'Em falta',
        confirmed: 'Confirmado',
        revoked: 'Revogado',
        escalated: 'Escalado',
        system: 'Sistema',
        custom: 'Personalizado',
        warning: 'Aviso',
        blocking: 'Bloqueante',
        analyst: 'Analista',
        viewer: 'Visualizador',
        daily: 'Diário',
        weekly: 'Semanal',
        policies: 'Políticas',
        denied: 'Negado',
        verified: 'Verificado',
        detected: 'Detectado',
        ignored: 'Ignorado',
        open: 'Abrir',
        resolved: 'Resolvido',
        suspended: 'Suspenso',
        retired: 'Aposentado',
        review: 'Revisão',
        generated: 'Gerado',
        exported: 'Exportado',
    },
    severity: {
        low: 'Baixo',
        medium: 'Médio',
        high: 'Alto',
        critical: 'Crítico',
    },
    sensitivity: {
        standard: 'Padrão',
        sensitive: 'Sensível',
        special_category: 'Categoria Especial',
        badge_sensitive: 'Sensível',
    },
    change_types: {
        policy_update: 'Política Atualizar',
        new_binding: 'Novo Binding',
        remove_binding: 'Remover vinculação',
        configuration_change: 'Alteração de configuração',
        banner_update: 'Banner Atualizar',
    },
    comparison_types: {
        full: 'Completo',
        banner_only: 'Banner Apenas',
        purposes_only: 'Finalidades Apenas',
        legal_bases_only: 'Apenas bases jurídicas',
        consent_settings: 'Consentimento Definições',
    },
    lifecycle_stages: {
        active: 'Ativo',
        archived: 'Arquivado',
        pending_deletion: 'Pendente Eliminação',
        deleted: 'Eliminado',
        on_hold: 'Em espera',
    },
    object_types: {
        personal_data: 'Dados pessoais',
        consent_record: 'Consentimento Registo',
        user_account: 'Utilizador Conta',
        audit_log: 'Auditoria Registo',
        document: 'Documento',
        backup: 'Cópia de segurança',
    },
    transfer_mechanisms: {
        adequacy_decision: 'Decisão de adequação',
        standard_contractual_clauses: 'Cláusulas contratuais padrão',
        binding_corporate_rules: 'Regras corporativas vinculativas',
        explicit_consent: 'Consentimento explícito',
        public_interest: 'Interesse público',
        legal_claims: 'Reclamações jurídicas',
        vital_interests: 'Interesses vitais',
    },
    risk_categories: {
        data_breach: 'Dados Violação',
        unauthorized_access: 'Acesso não autorizado',
        data_loss: 'Perda de dados',
        regulatory_non_compliance: 'Não conformidade regulamentar',
        third_party_risk: 'Third-Party Risco',
        operational: 'Operacional',
        technical: 'Técnico',
        legal: 'Jurídico',
    },
    mitigation_types: {
        technical: 'Técnico',
        organizational: 'Organizacional',
        contractual: 'Contratual',
        procedural: 'Processual',
    },
    safeguard_types: {
        encryption_in_transit: 'Criptografia em trânsito',
        encryption_at_rest: 'Criptografia em repouso',
        access_controls: 'Controles de acesso',
        contractual_clauses: 'Cláusulas Contratuais',
        data_minimization: 'Minimização de dados',
        pseudonymization: 'Pseudonimização',
        audit_rights: 'Direitos de auditoria',
        breach_notification: 'Notificação de violação',
        data_localization: 'Localização de dados',
        other: 'Outro',
    },
    scoring_methods: {
        weighted_average: 'Média ponderada',
        simple_average: 'Média simples',
        maximum: 'Máximo',
        manual: 'Manuais',
    },
    dpa_status: {
        not_required: 'Não Necessário',
        required: 'Necessário',
        in_progress: 'Em Curso',
        completed: 'Concluído',
        signed: 'Assinado',
    },
    disposal_methods: {
        anonymize: 'Anonimizar',
        pseudonymize: 'Pseudonimizar',
        aggregate: 'Agregar',
        delete: 'Eliminar',
    },
    dashboard: {
        title: 'Painel de Controlo',
        no_data: 'Sem dados disponíveis no painel de controlo.',
        no_data_heading: 'Ainda sem dados em tempo real',
        no_data_detail: 'Os widgets do painel de controlo abaixo mostram a disposição. Os dados serão preenchidos assim que o backend estiver ligado à base de dados.',
        consent_coverage: 'Cobertura de consentimento',
        ctia_filings: 'Declarações CTIA',
        next_dpia_review: 'Próxima revisão de DPIA',
        next_review_none: 'Nenhuma agendada',
        incident_mps_filings: 'Declarações MPS de incidente',
        compliance_score: 'Pontuação de Conformidade',
        grade: 'Classificação',
        no_score: 'Ainda não foi calculada a pontuação de conformidade.',
        rights_requests: 'Pedidos de Direitos',
        open: 'Abertos',
        sla_breached: 'SLA Incumprido',
        sla_approaching: 'SLA Próximo do Prazo',
        closed_month: 'Encerrados (Mês)',
        incidents: 'Incidentes e Violações',
        active: 'Ativos',
        breaches: 'Violações',
        overdue_tasks: 'Tarefas em Atraso',
        breach_72h_notice: 'O prazo de notificação regulatória de 72 horas se aplica a violações ativas',
        recommendations: 'Recomendações',
        take_action: 'Tome uma atitude',
        drift_events: 'Desvios e Aprovações',
        open_events: 'Eventos Abertos',
        pending_approvals: 'Aprovações Pendentes',
        monitoring: 'Tarefas de Monitorização',
        programs: 'Programas',
        overdue: 'Em Atraso',
        pending: 'Pendentes',
        ric_cases: 'Casos RIC',
        coverage: 'Cobertura de Dados',
        systems: 'Sistemas',
        activities: 'Atividades',
        vendors: 'Fornecedores',
        dpias: 'AIPDs',
        open_gaps: 'lacunas abertas',
        view_as_table: 'Ver como tabela',
        view_as_chart: 'Ver como grafico',
        table_metric_header: 'Metrica',
        table_value_header: 'Valor',
        announce_chart_view: 'A mostrar vista de grafico',
        announce_table_view: 'A mostrar vista de tabela',
        section_core_metrics: 'Metricas principais',
        section_task_management: 'Gestao de tarefas',
        section_compliance_insights: 'Perspetivas de conformidade',
        configure_dashboard: 'Configurar painel',
        config_col_active: 'Ativo',
        config_col_widget: 'Widget',
        collapse_section: 'Recolher',
        expand_section: 'Expandir',
        reset_to_defaults: 'Repor predefinições',
        preferences_saved: 'Preferências do painel guardadas',
        preferences_reset: 'Painel reposto para predefinições do cargo',
        preferences_load_error: 'Falha ao carregar preferências do painel',
        factor_avg_system_score: 'Pontuação média do sistema',
        factor_avg_vendor_score: 'Pontuação média do fornecedor',
        factor_processing_coverage: 'Cobertura da atividade de processamento',
        factor_ropa_completeness: 'Completude RoPA',
        factor_drift_penalty: 'Penalidade de eventos de drift',
        rec_improve_system_gov: 'Melhore a documentação de governança do sistema',
        rec_improve_vendor_gov: 'Melhore a documentação de governança do fornecedor',
        rec_document_processing: 'Atividades de processamento de documentos para sistemas descobertos',
        rec_generate_ropa: 'Gerar registros RoPA para atividades de processamento ativas',
        rec_resolve_drift: 'Resolva eventos abertos de desvio críticos e de alta gravidade',
        score_good: 'Bom',
        score_fair: 'Razoável',
        score_poor: 'Fraco',
        score_critical: 'Crítico',
        drag_to_reorder: 'Arraste para reordenar',
        widget_moved: 'Widget movido',
        press_space_to_grab: 'Prima Espaço para agarrar, teclas de seta para mover, Espaço para largar',
        reorder_instructions: 'Use arrastar e largar ou atalhos de teclado para reordenar os widgets',
        task_widgets: {
            tasks_overview: 'Visão geral das tarefas',
            pending: 'Pendente',
            in_progress: 'Em andamento',
            overdue: 'Atrasado',
            done_7d: 'Concluído (7d)',
            by_priority: 'Por prioridade',
            view_all_tasks: 'Ver todas as tarefas',
            upcoming_tasks: 'Próximas tarefas (próximos 7 dias)',
            no_upcoming: 'Nenhuma tarefa a ser entregue nos próximos 7 dias.',
            view_calendar: 'Ver calendário',
            overdue_alerts: 'Atrasado',
            no_overdue: 'Sem tarefas atrasadas. Tudo está no caminho certo.',
            assigned_to: 'Atribuído a',
            view_all_overdue: 'Ver todos os atrasos',
            notifications: 'Notificações recentes',
            unread: 'unread',
            no_notifications: 'Sem notificações. Vocês estão todos atualizados!',
            view_all_notifications: 'Ver todas as notificações',
            load_error: 'Falha ao carregar dados.',
            day_late: 'um dia atrasado',
            days_late_plural: 'dias atrasado',
            due_today: 'Vencimento hoje',
            just_now: 'agora mesmo',
            minutes_short: 'eu',
            hours_short: 'h',
            days_short: 'd',
            cross_org_stats: 'Estatísticas entre organizações',
            by_organization: 'Por organização',
            overdue_across_orgs: 'tarefas atrasadas nas organizações',
            total: 'Total',
            tasks: 'tasks',
            organization: 'Organização',
            current_org: 'Organização Atual',
            all_orgs: 'Todas as organizações',
            all_organizations: 'Todas as organizações',
            filter_by_org: 'Filtrar por organização',
            cross_org: 'Entre organizações',
            empty_calendar: 'Nenhuma tarefa para este período. Crie sua primeira tarefa ou verifique seus filtros.',
            empty_my_tasks: 'Você não tem tarefas atribuídas. Ótimo trabalho!',
            empty_overdue: 'Sem tarefas atrasadas. Tudo está no caminho certo.',
            empty_notifications: 'Sem notificações. Vocês estão todos atualizados!',
            empty_workflows: 'Nenhum fluxo de trabalho configurado. Procure modelos para começar.',
        },
        my_tasks_widget: {
            title: 'As Minhas Tarefas',
            no_tasks: 'Nenhuma tarefa atribuída a si.',
            load_error: 'Falha ao carregar tarefas.',
            overdue: 'em atraso',
            remaining: 'restante',
            view_all: 'Ver Todas as Tarefas',
        },
        my_section_status_widget: {
            title: 'Estado das Minhas Secções',
            overall_completion: 'Geral',
            sections_count: 'Secções',
            no_sections: 'Nenhuma secção atribuída ao seu departamento.',
            load_error: 'Falha ao carregar o estado das secções.',
        },
        revision_requests_widget: {
            title: 'Pedidos de Revisão',
            no_revisions: 'Sem pedidos de revisão. Todas as secções estão no caminho certo.',
            load_error: 'Falha ao carregar os pedidos de revisão.',
        },
        consent_summary: {
            title: 'Consentimento',
            active: 'Ativo',
            withdrawn_30d: 'Retirado (30d)',
            expiring_7d: 'Expirando (7d)',
        },
        transfer_assessments: {
            title: 'Avaliações de transferência',
            open: 'Abrir',
            approved: 'Aprovado',
            gaps_flagged: 'Lacunas sinalizadas',
        },
        breach_notifications: {
            title: 'Notificações de violação',
            deadline_72h: 'Prazo de 72h',
            submitted: 'Enviado',
            pending: 'Pendente',
        },
        authority_requests: {
            title: 'Solicitações de autoridade',
            pending: 'Pendente',
            overdue: 'Atrasado',
            responded_30d: 'Respondido (30d)',
        },
        data_subjects_widget: {
            title: 'Titulares dos dados',
            total: 'Total',
            high_risk: 'Alto risco',
            active_30d: 'Ativo (30d)',
        },
        audit_activity_summary: {
            title: 'Atividade de auditoria',
            events_today: 'Eventos hoje',
            events_7d: 'Eventos (7d)',
            unique_actors_30d: 'Atores únicos (30d)',
        },
        onboarding_progress: {
            title: 'Progresso da integração',
            completion_pct: 'Completo',
            status_label: 'Estado',
            current_step: 'Etapa atual',
            status: {
                in_progress: 'Em andamento',
                completed: 'Concluído',
                skipped: 'Ignorado',
                not_started: 'Não iniciado',
            },
        },
        sector_overlay_reports_due: {
            title: 'Sector Overlay Reports Due [PT]',
        },
        persona_widgets: {
            framework_filter: 'Filtrar por enquadramento',
            all_frameworks: 'Todos os enquadramentos',
            filing_lifecycle: 'Ciclo de vida de submissões',
            filing_pipeline: 'Pipeline de submissões',
            draft: 'Rascunho',
            internal_review: 'Revisão Interna',
            approved: 'Aprovado',
            submitted: 'Enviado',
            supplement_requested: 'Suplemento solicitado',
            resubmitted: 'Reenviado',
            accepted: 'Aceito',
            rejected: 'Rejeitado',
            closed: 'Fechado',
            deadline: 'Prazo',
            days_remaining: 'dias restantes',
            days_overdue: 'dias de atraso',
            no_filings: 'Sem submissões ativas.',
            department_consolidation: 'Consolidação de departamentos',
            departments_completed: 'Departamentos concluídos',
            departments_pending: 'Departamentos pendentes',
            departments_overdue: 'Departamentos em atraso',
            no_consolidation_cases: 'Sem casos multidepartamentais em curso.',
            vendor_risk: 'Risco de fornecedores e terceiros',
            pending_assessment: 'Avaliação pendente',
            overdue_questionnaires: 'Questionários em atraso',
            dpa_review_queue: 'Fila de revisão DPA',
            risk_distribution: 'Distribuição de Risco',
            total_vendors: 'Total de fornecedores',
            by_risk_level: 'Por nível de risco',
            no_vendor_data: 'Sem dados de risco de fornecedores disponíveis.',
            discovery_summary: 'Descoberta de dados',
            discovery_classification: 'Descoberta e classificação de dados',
            active_scans: 'Análises ativas',
            labels_pending: 'Etiquetas com revisão pendente',
            exceptions_unresolved: 'Exceções não resolvidas',
            pending_review: 'Revisão pendente',
            exceptions: 'Exceções',
            approved_labels: 'Etiquetas aprovadas',
            total_classified: 'Total classificado',
            no_discovery_data: 'Sem dados de descoberta disponíveis.',
            ai_governance: 'Governança de sistemas de IA',
            systems_inventory: 'Sistemas em inventário',
            systems_in_inventory: 'Sistemas no inventário',
            classification_breakdown: 'Divisão de classificação',
            dossier_completion: 'Conclusão do dossiê',
            by_classification: 'Por classificação',
            labeling_status: 'Estado de etiquetagem',
            not_started: 'Não iniciado',
            no_ai_data: 'Sem dados de governança de IA disponíveis.',
            breach_response: 'Resposta a violações e incidentes',
            active_breaches: 'Violações ativas',
            notification_status: 'Estado de notificação',
            remediation_progress: 'Progresso de remediação',
            supplement_loops: 'Ciclos de suplemento',
            no_breach_data: 'Sem casos de violação ativos.',
            audit_readiness: 'Prontidão para auditorias e avaliações',
            assessments: 'Avaliações',
            gap_findings: 'Achados de lacunas',
            evidence_completion: 'Conclusão de evidências',
            export_ready: 'Pronto para exportar',
            not_ready: 'Não pronto',
            no_audit_data: 'Sem dados de prontidão de auditoria disponíveis.',
            framework_label_vn_pdpl: 'VN PDPL 2025',
            framework_label_vn_cybersecurity: 'VN Ciberseguranca 2018',
            framework_label_vn_ecommerce: 'VN Comercio eletronico 2023',
            framework_label_vn_telecom: 'VN Telecomunicacoes 2023',
            framework_label_vn_ai: 'VN Lei IA 2025',
            framework_label_gdpr: 'RGPD',
            framework_label_unspecified: 'Não especificado',
            my_department: 'Meu departamento',
            my_tasks: 'Minhas tarefas',
            section_status: 'Estado da secção',
            revision_requests: 'Pedidos de revisão',
            completion: 'Conclusão',
            reason: 'Motivo',
            requested_at: 'Solicitado em',
            no_tasks_assigned: 'Sem tarefas atribuídas.',
            no_sections: 'Sem secções atribuídas ao seu departamento.',
            no_revisions: 'Sem pedidos de revisão.',
            load_error: 'Falha ao carregar dados.',
        },
    },
    connectors: {
        nav: {
            instances: 'Instâncias',
            credentials: 'Cofre de Credenciais',
            event_bus: 'Barramento de Eventos',
            definitions: 'Definições',
            brds: 'Captura de BRD',
            security_reviews: 'Revisões de Segurança',
            poc_scorecards: 'Cartões de Pontuação POC',
            automation_planning: 'Planeamento automatização',
            system_inventory: 'Inventário de sistemas',
            traceability_matrix: 'Matriz rastreabilidade',
            gap_register: 'Registo de lacunas',
        },
        instances: {
            title: 'Instâncias de Conectores',
            page_title: 'Conectores',
            add: 'Adicionar Instância',
            test: 'Testar Ligação',
            sync_now: 'Sincronizar Agora',
            new_instance: 'Novo Connector Instance',
            no_instances: 'Nenhum connector instances encontrado',
            instance_count: '{count} instância(s)',
            confirm_delete: 'Eliminar a instância do conector "{name}"?',
            all_connector_types: 'Todos os tipos de conector',
            select_connector: 'Selecione connector...',
            fetch_error: 'Falha ao fetch connector instances. Por favor, tente novamente.',
            fetch_definitions_error: 'Falha ao fetch connector definitions. Por favor, tente novamente.',
            create_error: 'Falha ao create connector instance. Por favor, tente novamente.',
            test_error: 'Falha ao test connector. Por favor, tente novamente.',
            status_error: 'Falha ao atualizar o estado do conector. Por favor, tente novamente.',
            delete_error: 'Falha ao delete connector instance. Por favor, tente novamente.',
        },
        credentials: {
            title: 'Cofre de Credenciais',
            page_title: 'Credenciais do conector',
            add: 'Adicionar Credencial',
            rotate: 'Rodar',
            expired: 'Expirado',
            expiring: 'A Expirar Brevemente',
            orphaned: 'Órfão',
            new_credential: 'Novo Credential',
            no_credentials: 'Nenhum credentials encontrado',
            no_expiry: 'Sem expiração',
            linked_connectors: 'Conectores ligados',
            expires_at: 'Expira Em',
            value_label: 'Valor * (apenas escrita)',
            confirm_delete_title: 'Confirmar exclusão',
            confirm_delete_message: 'Excluir esta credencial? Os conectores vinculados perderão o acesso.',
            rotate_title: 'Rotacionar credencial',
            new_credential_value: 'Novo valor de credencial',
            fetch_error: 'Falha ao load credentials. Por favor, tente novamente.',
            health_error: 'Falha ao load health. Por favor, tente novamente.',
            create_error: 'Falha ao create credential. Por favor, tente novamente.',
            rotate_error: 'Falha ao rotate credential. Por favor, tente novamente.',
            delete_error: 'Falha ao delete credential. Por favor, tente novamente.',
        },
        event_bus: {
            title: 'Barramento de Eventos',
            page_title: 'Barramento de eventos',
            events: 'Eventos',
            subscriptions: 'Subscrições',
            dlq: 'Fila de Mensagens Mortas',
            publish: 'Publicar Evento',
            retry: 'Tentar Novamente',
            dismiss: 'Dispensar',
            search_events: 'Pesquisar eventos...',
            filter_event_type: 'Filtrar por tipo de evento...',
            event_type: 'Evento Tipo',
            source_module: 'Módulo de origem',
            timestamp: 'Marca temporal',
            delivery_status: 'Estado de entrega',
            correlation_id: 'ID de correlação',
            tracking_id: 'ID de rastreamento',
            delivery_status_hint: 'O status de entrega é atualizado automaticamente conforme os eventos são processados.',
            no_events: 'Nenhum events encontrado',
            total_with_count: '{count} no total',
            prev: 'Ant.',
            new_subscription: '+ Novo Subscrição',
            subscriber_type: 'Tipo de subscritor',
            subscriber_id: 'ID do subscritor',
            event_type_pattern: 'Evento Tipo Pattern',
            event_type_pattern_placeholder: 'p. ex. incident.*',
            filter_expression: 'Expressão de filtro',
            filter_expression_placeholder: 'Filtro opcional',
            subscriber_type_hint: 'Escolha como os eventos serão entregues: webhook envia solicitações HTTP, e-mail envia notificações, fila roteia para uma fila de mensagens.',
            subscriber_id_hint: 'Insira o destino dos eventos. Para webhooks, use uma URL. Para e-mail, use um endereço. Para filas, use o nome da fila.',
            event_type_pattern_hint: 'Corresponda eventos por tipo usando curingas. Use * para corresponder a qualquer segmento (ex. incident.* corresponde a incident.created, incident.resolved).',
            filter_expression_hint: 'Opcional. Filtre eventos adicionalmente por conteúdo (ex. severity=high).',
            subscriber_id_placeholder_webhook: 'ex. https://seu-app.com/webhook',
            subscriber_id_placeholder_email: 'ex. alertas@sua-empresa.com',
            subscriber_id_placeholder_queue: 'ex. fila-eventos',
            event_pattern: 'Padrão de evento',
            filter: 'Filtrar',
            enabled: 'Ativado',
            delivery_stats: 'Estatísticas de entrega',
            no_subscriptions: 'Nenhum subscriptions encontrado',
            on: 'ON',
            off: 'OFF',
            delivered_failed: '{delivered} entregues / {failed} falhados',
            confirm_delete_subscription: 'Eliminar este subscription?',
            unresolved: 'Não resolvido',
            resolved: 'Resolvido',
            event_id: 'Evento ID',
            subscription_id: 'Subscrição ID',
            error_code: 'Código de erro',
            error_message: 'Mensagem de erro',
            attempts: 'Tentativas',
            last_failed: 'Último Falhou',
            no_dlq_entries: 'Nenhum dead letter entries encontrado',
            dlq_count: '{count} entrada(s) no total',
            fetch_events_error: 'Falha ao fetch events. Por favor, tente novamente.',
            fetch_subscriptions_error: 'Falha ao fetch subscriptions. Por favor, tente novamente.',
            fetch_dlq_error: 'Falha ao fetch dlq entries. Por favor, tente novamente.',
            create_subscription_error: 'Falha ao create subscription. Por favor, tente novamente.',
            toggle_subscription_error: 'Falha ao toggle subscription. Por favor, tente novamente.',
            delete_subscription_error: 'Falha ao delete subscription. Por favor, tente novamente.',
            retry_error: 'Tentar novamente falhou',
            dismiss_error: 'Descarte falhado',
            event_published: 'Evento publicado',
            publish_event_error: 'Não foi possível publicar o evento. Tente novamente.',
            priority_label: 'Prioridade',
            priority_low: 'Baixa',
            priority_normal: 'Normais',
            priority_high: 'Alta',
            payload_helper_text: 'Insira os dados do evento em formato JSON. Exemplo: {"incident_id": "INC-001", "severity": "high"}',
            subscription_created: 'Subscrição criada',
            subscription_toggled: 'Subscrição alternada',
            subscription_deleted: 'Subscrição eliminada',
            dlq_retried: 'Mensagem DLQ reprocessada',
            dlq_dismissed: 'Mensagem DLQ descartada',
        },
        definitions: {
            title: 'Definições do conector',
            page_title: 'Definições de conectores',
            add: 'Adicionar definição',
            new_definition: 'Nova definição de conector',
            edit_definition: 'Editar definição do conector',
            no_definitions: 'Nenhuma definição de conector encontrada',
            definition_count: '[[TOK_1]] definições',
            all_categories: 'Todas as categorias',
            select_category: 'Selecione uma categoria...',
            capabilities: 'Capacidades',
            capabilities_hint: 'Capacidades (separadas por vírgula)',
            capabilities_placeholder: 'por exemplo ler, escrever, sincronizar',
            created: 'Definição do conector criada',
            updated: 'Definição do conector atualizada',
            fetch_error: 'Falha ao buscar definições do conector. Por favor, tente novamente.',
            create_error: 'Falha ao criar a definição do conector',
            update_error: 'Falha ao atualizar a definição do conector',
        },
        brds: {
            title: 'Captura de BRD',
            page_title: 'Captura BRD',
            create_brd: 'Criar BRD',
            brd_title: 'Título do BRD',
            description: 'Descrição',
            requirements: 'Requisitos',
            status: 'Estado',
            stakeholders: 'Partes interessadas',
            connector_label: 'Conector',
            select_connector: 'Selecionar um conector...',
            approval: 'Aprovação',
            no_brds_found: 'Nenhum BRD encontrado',
            decision_records: 'Registos de decisões',
            create_decision: 'Criar decisão',
            alternatives_considered: 'Alternativas consideradas',
            alternative_name: 'Nome da alternativa',
            reason_rejected: 'Motivo de rejeição',
            add_alternative: 'Adicionar alternativa',
            remove_alternative: 'Remover alternativa {name}',
            alternatives: 'Alternativas',
            rationale: 'Justificação',
            selected_connector: 'Conector selecionado',
            comma_separated_names: 'Nomes separados por vírgulas',
            brd_created: 'BRD criado',
            decision_record_created: 'Registro de decisão criado',
            no_decision_records_found: 'Nenhum registro de decisão encontrado',
            aria_brds_table: 'BRDs',
            aria_decision_records_table: 'Registros de decisão',
            aria_approve: 'Aprovar {name}',
            aria_archive: 'Arquivar {name}',
            brd_title_help: 'Um nome curto e legível para este BRD – por ex. "Integração de tickets Jira", "lançamento do Okta SSO".',
            brd_title_placeholder: 'por exemplo Integração de tíquetes Jira',
            description_help: 'O problema comercial que esse conector resolve. Que resultado você espera quando estiver no ar?',
            description_placeholder: 'por exemplo Automatize a criação de tickets de incidente a partir de alertas de monitoramento para que a chamada seja paginada em 60 segundos.',
            connector_help: 'Opcional. Escolha um conector para o qual este BRD se destina – deixe em branco se o conector ainda não tiver sido escolhido.',
            requirements_help: 'Lista separada por vírgulas de recursos essenciais - por exemplo. "Login OAuth2, entrega de webhook, exportação de auditoria" .',
            requirements_placeholder: 'Login OAuth2, entrega de webhook, exportação de auditoria',
            stakeholders_help: 'Nomes separados por vírgula ou e-mails de pessoas que devem assinar.',
            selected_connector_help: 'Escolha o conector ao qual esta decisão se aplica.',
            rationale_help: 'Por que este conector foi escolhido. Cubra os fatores decisivos para que um futuro leitor entenda a chamada.',
            rationale_placeholder: 'por exemplo Escolhemos o Jira porque ele já possui nosso histórico de tickets e a equipe é treinada nele.',
            alternatives_considered_help: 'Outros conectores avaliados e porque não foram escolhidos. Adiciona defensibilidade para auditoria.',
            alternative_name_placeholder: 'por exemplo Serviço agora',
            reason_rejected_placeholder: 'por exemplo Custo 3x maior, sem vantagem para nosso caso de uso',
        },
        security_reviews: {
            title: 'Revisões de Segurança',
            page_title: 'Revisões de segurança',
            create_review: 'Criar revisão',
            connector_name: 'Nome do conector',
            connector_label: 'Conector',
            select_connector: 'Selecionar um conector...',
            reviewer: 'Revisor',
            select_reviewer: 'Selecionar um revisor...',
            findings: 'Conclusões (uma por linha)',
            risk_level: 'Nível de risco',
            risk_level_placeholder: 'p. ex. alto, médio, baixo',
            notes: 'Notas',
            review_status: 'Estado da revisão',
            checklist: 'Lista de verificação',
            privacy_impact: 'Impacto na privacidade',
            approval_gate: 'Porta de aprovação',
            no_reviews_found: 'Nenhuma revisão encontrada',
            review_created: 'Revisão de segurança criada',
            create_control_mapping: 'Criar mapeamento de controle',
            control_mapping_created: 'Mapeamento de controle criado',
            connector_id_label: 'ID do conector',
            control_id_label: 'ID do controle',
            control_name_label: 'Nome do controle',
            aria_approve: 'Aprovar {name}',
            aria_reject: 'Rejeitar {name}',
            scan_imported: 'Scan importado com sucesso',
            import_scan: 'Importar scan',
            scan_format: 'Formato do scan',
            scan_data: 'Dados do scan',
            import_results: 'Resultados da importação',
            recommendations: 'Recomendações',
            auto_populated_from: 'Preenchido automaticamente de [[TOK_1]]',
            manual_entry: 'Entrada manual',
            automation_type: 'Tipo de automação',
            select_automation_type: 'Selecione o tipo de automação...',
            automation_full: 'Completo — o conector automatiza totalmente esse controle',
            automation_partial: 'Parcial — o conector contribui com evidências; os humanos ainda agem',
            automation_monitoring: 'Apenas monitoramento – o conector observa, não impõe',
            control_id_help: 'Use o código do seu esquema de conformidade (por exemplo, ISO-27001-A.12.1, SOC2-CC6.1 ou seu ID de controle interno).',
            control_name_help: 'Nome curto e legível (por exemplo, "Restrição de acesso à rede").',
            description_label: 'Descrição',
            load_sarif_example: 'Carregar exemplo SARIF',
            load_json_example: 'Carregar exemplo personalizado [[TOK_0]]',
            scan_format_help: 'SARIF é o padrão OASIS emitido pela maioria dos scanners (Snyk, CodeQL, Semgrep). Use [[TOK_0]] personalizado para ferramentas que não emitem SARIF.',
            scan_data_help: 'Cole a saída completa da verificação, carregue um arquivo .sarif/.json ou clique no botão Carregar exemplo para ver a forma.',
            upload_file_label: 'Carregar arquivo .sarif ou .json',
            invalid_scan_json: 'Não foi possível analisar os dados da verificação como [[TOK_0]]. Verifique se há erros de sintaxe próximos ao caractere destacado.',
            save_as_review: 'Salvar como revisão de segurança',
            discard_preview: 'Descartar visualização',
            preview_hint: 'Esta é uma prévia – nada foi salvo ainda. Clique em “Salvar como revisão de segurança” para criar uma revisão pendente pré-preenchida com esses valores.',
            reviewer_required_for_save: 'Escolha um revisor para salvar esta verificação como uma revisão de segurança.',
        },
        poc_scorecards: {
            title: 'Cartões de Pontuação POC',
            page_title: 'Scorecards POC',
            create_scorecard: 'Criar cartão de pontuação',
            connector_label: 'Conector',
            select_connector: 'Selecionar um conector...',
            vendor_name: 'Nome do fornecedor',
            recommendation: 'Recomendação',
            recommendation_placeholder: 'p. ex. Prosseguir, Não prosseguir, Necessita avaliação adicional',
            criteria: 'Critérios de avaliação',
            criterion_name: 'Nome do critério',
            score: 'Pontuação',
            max_score: 'Pontuação máxima',
            notes: 'Notas',
            add_criterion: 'Adicionar critério',
            remove_criterion: 'Remover critério {name}',
            total_score: 'Pontuação total',
            api_quality: 'Qualidade da API',
            reliability: 'Fiabilidade',
            support_quality: 'Qualidade do suporte',
            cost_score: 'Pontuação de custo',
            overall_score: 'Pontuação global',
            evidence: 'Evidência',
            no_scorecards_found: 'Nenhum cartão de pontuação encontrado',
            scorecard_created: 'Scorecard POC criado',
            connector_help: 'Escolha o conector ao qual esta avaliação POC se destina.',
            vendor_name_help: 'O fornecedor ou produto que está sendo avaliado - por ex. "Okta", "Datadog", "Floco de neve".',
            vendor_name_placeholder: 'por exemplo Okta, Datadog, floco de neve',
            recommendation_help: 'Sua chamada final após a avaliação. Seja breve e decisivo.',
            criteria_help: 'Pontue o fornecedor em cada critério de avaliação. Adicione uma linha por critério ([[TOK_0]] qualidade, confiabilidade, suporte, custo, etc.).',
            criterion_name_help: 'O que você está pontuando - por ex. "[[TOK_0]] Qualidade", "Confiabilidade", "Suporte", "Custo".',
            criterion_name_placeholder: 'por exemplo [[TOK_0]] Qualidade',
            score_help: 'Pontuação atribuída para este critério. Não deve exceder a pontuação máxima.',
            max_score_help: 'Pontuação máxima disponível para este critério. Use a mesma escala nas linhas para que os totais sejam comparáveis.',
            notes_help: 'Opcional. Adicione evidências, advertências ou links – qualquer coisa que explique a pontuação.',
        },
        common_labels: {
            aria_filter_instances: 'Filtrar instâncias de conectores',
            aria_filter_definitions: 'Filtrar definições de conectores',
            aria_filter_credentials: 'Filtrar credenciais',
            aria_filter_events: 'Filtrar eventos',
            aria_filter_dlq: 'Filtrar fila de mensagens mortas',
            aria_instance_summary: 'Resumo da instância do conector',
            aria_active_connectors: 'Conectores ativos',
            aria_error_connectors: 'Conectores com erro',
            aria_credential_health: 'Resumo da saúde das credenciais',
            aria_items_per_page: 'Itens por página',
            show_password: 'Mostrar senha',
            hide_password: 'Ocultar senha',
            payload_json_label: 'Carga útil (JSON)',
            payload_invalid_json: 'Carga útil deve ser JSON válido',
            placeholder_event_type: 'ex. incident.created',
            placeholder_source_module: 'ex. monitoring',
            placeholder_version: 'ex. 1.0',
        },
        statuses: {
            configuring: 'Configurando',
            testing: 'Teste',
            active: 'Ativo',
            paused: 'Pausado',
            error: 'Erro',
            disabled: 'Desativado',
            draft: 'Rascunho',
            approved: 'Aprovado',
            archived: 'Arquivado',
            pending: 'Pendente',
            rejected: 'Rejeitado',
        },
        system_types: {
            application: 'Aplicação',
            database: 'Banco de dados',
            middleware: 'Middleware',
            infrastructure: 'Infraestrutura',
            saas: 'SaaS',
            other: 'Outros',
        },
        hosting_types: {
            on_premise: 'Local',
            cloud: 'Nuvem',
            hybrid: 'Híbrido',
            managed: 'Gerenciado',
        },
        system_statuses: {
            active: 'Ativo',
            decommissioned: 'Descomissionado',
            planned: 'Planejado',
            under_review: 'Em revisão',
        },
        automation_statuses: {
            planning: 'Planejamento',
            in_progress: 'Em andamento',
            completed: 'Concluído',
            on_hold: 'Em espera',
        },
        gap_types: {
            functional: 'Funcional',
            technical: 'Técnico',
            security: 'Segurança',
            compliance: 'Conformidade',
            process: 'Processo',
        },
        severity_labels: {
            critical: 'Crítico',
            high: 'Alto',
            medium: 'Médio',
            low: 'Baixo',
        },
        gap_statuses: {
            open: 'Aberto',
            in_progress: 'Em andamento',
            mitigated: 'Mitigado',
            closed: 'Fechado',
            accepted: 'Aceito',
        },
        verification_statuses: {
            not_started: 'Não iniciado',
            in_progress: 'Em andamento',
            verified: 'Verificado',
            failed: 'Falhou',
        },
        subscriber_types: {
            webhook: 'Webhook',
            internal: 'Interno',
            email: 'E-mail',
            queue: 'Fila',
        },
        credential_types: {
            password: 'Senha',
            api_key: 'Chave API',
            oauth2_client: 'Cliente OAuth2',
            certificate: 'Certificado',
            token: 'Símbolo',
            ssh_key: 'Chave SSH',
            imap_credentials: 'Credenciais IMAP',
        },
        categories: {
            hr: 'RH',
            crm: 'CRM',
            erp: 'ERP',
            cloud: 'Nuvem',
            security: 'Segurança',
            itsm: 'ITSM',
            custom: 'Personalizado',
        },
        delivery_statuses: {
            pending: 'Pendente',
            delivered: 'Entregue',
            partial: 'Parcial',
            failed: 'Falhou',
        },
        automation_planning: {
            title: 'Planeamento de automatização',
            page_title: 'Planeamento de automatização',
            program_name: 'Nome do programa',
            program_status: 'Estado',
            description: 'Descrição',
            linked_artifacts: 'Artefactos associados',
            create_program: 'Criar programa',
            edit_program: 'Editar programa',
            no_programs_found: 'Nenhum programa encontrado',
            program_created: 'Programa criado',
            program_updated: 'Programa atualizado',
            target_date: 'Data-alvo',
            owner: 'Proprietário',
            select_status: 'Selecionar estado...',
            aria_programs_table: 'Programas de automatização',
            aria_edit: 'Editar {name}',
            export_programs: 'Exportar programas',
            title_label: 'Título do programa',
            title_help: 'Um nome curto e legível para o programa de automação – por exemplo. "Lançamento do incidente do terceiro trimestre para Jira", "[[TOK_0]] automação de solicitação de acesso".',
            title_placeholder: 'por exemplo Implementação do incidente no Jira no terceiro trimestre',
            description_help: 'O que este programa cobre e o resultado que você espera quando estiver no ar. Opcional, mas recomendado.',
            description_placeholder: 'por exemplo Conecte alertas de monitoramento ao Jira para que o plantão seja paginado em 60 segundos.',
            owner_label: 'Proprietário do programa',
            owner_help: 'A pessoa responsável por este programa. Eles receberão notificações sobre progresso e portões.',
            select_owner: 'Selecione um proprietário...',
            frameworks_in_scope: 'Estruturas no escopo',
            frameworks_in_scope_help: 'Estruturas de conformidade que este programa suporta. Ajuda a trilha de auditoria a mostrar quais regulamentações a automação é regida.',
            select_frameworks: 'Selecione estruturas...',
            status_draft: 'Rascunho',
            status_active: 'Ativo',
            status_completed: 'Concluído',
            status_archived: 'Arquivado',
            change_status: 'Alterar status',
            status_updated: 'Status atualizado',
            aria_change_status: 'Alterar status para [[TOK_1]]',
        },
        system_inventory: {
            title: 'Inventário de sistemas',
            page_title: 'Inventário de sistemas',
            system_name: 'Nome do sistema',
            system_type: 'Tipo de sistema',
            hosting: 'Alojamento',
            status: 'Estado',
            description: 'Descrição',
            create_system: 'Criar sistema',
            edit_system: 'Editar sistema',
            no_systems_found: 'Nenhum sistema encontrado',
            system_created: 'Sistema criado',
            system_updated: 'Sistema atualizado',
            select_type: 'Selecionar tipo...',
            select_hosting: 'Selecionar alojamento...',
            select_status: 'Selecionar estado...',
            owner: 'Proprietário',
            department: 'Departamento',
            data_categories: 'Categorias de dados',
            data_categories_placeholder: 'Separados por vírgulas, ex. PII, Financeiro, Saúde',
            jurisdiction: 'Jurisdição',
            jurisdiction_placeholder: 'ex. UE, EUA, Global',
            interfaces: 'Interfaces',
            interfaces_placeholder: 'Separados por vírgulas, ex. API REST, SFTP, JDBC',
            owner_placeholder: 'Selecione um proprietário responsável...',
            department_placeholder: 'Selecione a unidade organizacional responsável...',
            system_name_hint: 'Use o nome do sistema ou aplicação reconhecido pela empresa.',
            system_type_hint: 'Classifique o sistema para que os relatórios possam agrupar ativos semelhantes.',
            hosting_hint: 'Identifique onde o sistema corre para efeitos de residência, segurança e revisão de fornecedores.',
            status_hint: 'Defina o estado do ciclo de vida utilizado por revisões, exportações e evidências de auditoria.',
            owner_hint: 'Escolha o utilizador ativo responsável pela governação do sistema e pelas tarefas de acompanhamento.',
            department_hint: 'Utilize a unidade organizacional responsável pela operação ou governação deste sistema.',
            data_categories_hint: 'Liste as classes de dados processadas por este sistema, separadas por vírgulas.',
            jurisdiction_hint: 'Registe a principal jurisdição legal ou de alojamento para o mapeamento de conformidade.',
            interfaces_hint: 'Liste os caminhos de conector ou integração utilizados para trocar dados.',
            description_hint: 'Resuma o que o sistema faz e porque é importante para o mapa de dados.',
            owner_department_required: 'Proprietário e Departamento são obrigatórios.',
            aria_systems_table: 'Inventário de sistemas',
            aria_edit: 'Editar {name}',
            export_systems: 'Exportar sistemas',
        },
        traceability_matrix: {
            title: 'Matriz de rastreabilidade',
            page_title: 'Matriz de rastreabilidade',
            brd_selector: 'Selecionar BRD',
            requirement: 'Requisito',
            linked_artifact: 'Artefacto associado',
            verification_status: 'Estado de verificação',
            verified_by: 'Verificado por',
            create_entry: 'Criar entrada',
            edit_entry: 'Editar entrada',
            no_entries_found: 'Nenhuma entrada encontrada',
            entry_created: 'Entrada criada',
            entry_updated: 'Entrada atualizada',
            select_brd: 'Selecionar um BRD...',
            select_status: 'Selecionar estado...',
            aria_matrix_table: 'Matriz de rastreabilidade',
            aria_edit: 'Editar entrada para {name}',
            export_matrix: 'Exportar matriz',
        },
        gap_register: {
            title: 'Registo de lacunas',
            page_title: 'Registo de lacunas',
            gap_title: 'Título da lacuna',
            gap_type: 'Tipo de lacuna',
            severity: 'Gravidade',
            status: 'Estado',
            description: 'Descrição',
            remediation_plan: 'Plano de remediação',
            assigned_to: 'Atribuído a',
            due_date: 'Data de vencimento',
            create_gap: 'Criar lacuna',
            edit_gap: 'Editar lacuna',
            no_gaps_found: 'Nenhuma lacuna encontrada',
            gap_created: 'Lacuna criada',
            gap_updated: 'Lacuna atualizada',
            select_type: 'Selecionar tipo...',
            select_severity: 'Selecionar gravidade...',
            select_status: 'Selecionar estado...',
            aria_gaps_table: 'Registo de lacunas',
            aria_edit: 'Editar {name}',
            export_gaps: 'Exportar lacunas',
            gap_title_hint: 'Provide a concise name for the identified gap.',
            gap_type_hint: 'Select the nature of the gap (e.g., missing coverage or integration issue).',
            severity_hint: 'The impact of this gap on compliance and operations.',
            status_hint: 'Current stage of the gap resolution lifecycle.',
            owner_hint: 'The person responsible for tracking and remediating this gap.',
            description_hint: 'Detailed context regarding the gap, its root cause, and impact.',
            mitigation_plan_hint: 'Steps planned or taken to address and close the gap.',
            linked_requirement_ids_hint: 'Comma-separated requirement codes this gap affects.',
            linked_system_ids_hint: 'Comma-separated system IDs associated with this gap.',
            gap_types: {
                coverage: 'Coverage',
                capability: 'Capability',
                integration: 'Integration',
                compliance: 'Compliance',
            },
        },
        regulatory: {
            system_inventory_governance_info: 'System inventory aligns with Data Law enterprise governance. System types map to regulatory categories, hosting classification determines jurisdiction-specific controls. Use framework linkage to connect systems to applicable regulatory frameworks.',
            automation_planning_workflow_info: 'Automation programs align with compliance workflow obligations defined by applicable regulatory frameworks. Framework scope determines which requirements the program addresses.',
            traceability_regulatory_source_info: 'Each traceability entry connects a BRD requirement to its regulatory source. Verification status tracks whether implementation satisfies the regulatory obligation.',
            security_reviews_control_mapping_info: 'Security reviews evaluate framework-specific controls applicable to each connector. Risk level captures assessed exposure, findings document deviations from control requirements.',
            gap_register_framework_info: 'Gap Register captures compliance gaps per regulatory framework. Use framework filter to view gaps for a specific framework. Severity levels align with framework risk classification.',
            poc_scorecards_criteria_info: 'POC scorecards evaluate connectors against regulatory criteria. Criteria structure supports weighted scoring with evidence notes. Vendor linkage connects to vendor record.',
            evidence_trail_info: 'All connector module actions generate audit events for cross-module evidence trail integrity. CSV exports preserve referential integrity.',
        },
        system_inventory_extra: {
            framework_linkage: 'Vinculação de quadro',
            framework_linkage_placeholder: 'ex. GDPR, ISO 27001, NIS2',
        },
        automation_planning_extra: {
            framework_scope: 'Âmbito do quadro',
            framework_scope_placeholder: 'ex. GDPR, PCI-DSS',
            procedure_linkage: 'Vinculação de procedimento',
            procedure_linkage_placeholder: 'ex. SOP-001, PROC-DATA-003',
        },
        traceability_matrix_extra: {
            regulatory_source: 'Fonte regulatória',
            regulatory_source_placeholder: 'ex. GDPR Art. 30, ISO 27001 A.8',
        },
        security_reviews_extra: {
            control_mapping_col: 'Mapeamento de controlos',
            control_mappings_section: 'Mapeamentos de controle',
            no_control_mappings: 'Ainda não há mapeamentos de controle. Clique em “Criar mapeamento de controle” para adicionar um.',
            automation_type_col: 'Automação',
        },
        gap_register_extra: {
            framework_filter: 'Quadro',
            framework_id: 'ID do quadro',
            framework_id_placeholder: 'ex. GDPR, ISO 27001',
            all_frameworks: 'Todos os quadros',
        },
        poc_scorecards_extra: {
            criteria_count: 'Critérios',
        },
        export_labels: {
            export_brds: 'Exportar BRDs',
            export_decision_records: 'Exportar registos de decisões',
            export_security_reviews: 'Exportar revisões de segurança',
            export_poc_scorecards: 'Exportar cartões POC',
            export_instances: 'Exportar instâncias',
            export_definitions: 'Exportar definições',
            export_credentials: 'Exportar credenciais',
            export_events: 'Exportar eventos',
            exporting: 'A exportar...',
            export_success: 'Exportação concluída',
            export_error: 'Falha na exportação',
        },
    },
    vendor_risk: {
        risk_acceptance_reasoning: {
            draft_label: 'Rascunho do raciocínio',
            drafting: 'Elaboração de raciocínio…',
            results_heading: 'Raciocínio elaborado por [[TOK_2]] ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            narrative_label: 'Narrativa de justificação',
            controls_heading: 'Controles de compensação',
            no_controls: 'Nenhum controle de compensação sugerido.',
            citations_label: 'Citações',
            accept_label: 'Aceite o raciocínio',
            reject_label: 'Rejeitar rascunho',
            accept_hint: 'Accept registra o raciocínio sobre o rascunho persistente para a linhagem IAT. A narrativa + controles não atualizam automaticamente o registro de aceitação – é necessário colar o operador.',
            resolve_summary: 'Resolução: [[TOK_1]]',
            error_generic: 'Não foi possível redigir o raciocínio. Tente novamente ou verifique o status de aceitação do risco.',
        },
        redline_assistant: {
            run_label: 'Redline com biblioteca',
            running: 'Correndo linha vermelha…',
            results_heading: 'Sugestões de linhas vermelhas ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            no_suggestions: 'Não foram detectadas lacunas nas cláusulas padrão.',
            jurisdiction_label: 'Jurisdição',
            col_kind: 'Gentil',
            col_severity: 'Gravidade',
            col_title: 'Sugestão',
            col_excerpt: 'Trecho correspondente',
            col_apply: 'Aplicar',
            kind_missing: 'Padrão ausente',
            kind_weaker: 'Mais fraco que o padrão',
            kind_jurisdiction: 'Sobreposição de jurisdição',
            proposed_label: 'Texto proposto',
            citations_label: 'Citações',
            accept_label: 'Aceitar selecionado',
            reject_label: 'Rejeitar relatório',
            partial_label: 'Aplicar seleção',
            accept_hint: 'Aplicar registros de seleção das sugestões escolhidas no rascunho da linhagem IAT. Nenhuma edição automática é aplicada ao texto do contrato – o operador define a linha vermelha.',
            resolve_summary: 'Resolução: [[TOK_2]] · [[TOK_3]] sugestão(ões) aplicadas',
            error_generic: 'Não foi possível produzir uma linha vermelha. Tente novamente ou verifique o status do contrato.',
            clause_library_link: 'Gerenciar biblioteca de cláusulas',
        },
        clause_library: {
            page_title: 'Biblioteca de Cláusulas',
            add_label: 'Adicionar cláusula',
            edit_label: 'Editar',
            delete_label: 'Excluir',
            slug_label: 'Lesma',
            title_label: 'Título',
            body_label: 'Corpo',
            jurisdiction_label: 'Jurisdição',
            tags_label: 'Tags (separadas por vírgula)',
            must_contain_label: 'Marcadores obrigatórios (separados por vírgula)',
            severity_label: 'Gravidade quando ausente',
            no_clauses: 'Ainda não há cláusulas. Adicione um para propagar o assistente redline.',
            save_label: 'Salvar',
            cancel_label: 'Cancelar',
            load_error: 'Não foi possível carregar a biblioteca de cláusulas.',
            save_error: 'Não foi possível salvar a cláusula.',
            delete_error: 'Não foi possível excluir a cláusula.',
            delete_confirm: 'Excluir cláusula "[[TOK_1]]"? Isto não pode ser desfeito.',
        },
        obligation_extraction: {
            extract_label: 'Extrair obrigações',
            extracting: 'Extraindo…',
            results_heading: 'Obrigações extraídas ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            no_obligations: 'Nenhum padrão de obrigação detectado neste texto contratual.',
            col_class: 'Classe',
            col_summary: 'Resumo (editável)',
            col_excerpt: 'Trecho da cláusula',
            col_due_date: 'Data de vencimento (editável)',
            col_priority: 'Prioridade',
            due_date_placeholder: 'YYYY-MM-DD',
            class_notice: 'Período de aviso',
            class_audit: 'Auditoria certa',
            class_insurance: 'Seguro',
            class_sla: 'Resposta [[TOK_0]]',
            class_breach: 'Notificação de violação',
            class_renewal: 'Janela de renovação',
            citations_label: 'Citações',
            accept_hint: 'Aceitar criará uma tarefa por obrigação (cap 8) com a prioridade + data de vencimento mostrada.',
            accept_label: 'Aceite obrigações',
            reject_label: 'Rejeitar relatório',
            resolve_summary: 'Resolução: [[TOK_2]] · [[TOK_3]] tarefa(s) criada(s)',
            error_generic: 'Não foi possível extrair obrigações. Tente novamente ou verifique o texto do contrato.',
        },
        subprocessor_impact: {
            assess_label: 'Avalie o impacto',
            assessing: 'Avaliando o impacto…',
            results_heading: 'Impacto do subprocessador ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            risk_delta_label: 'Delta de risco',
            notification_heading: 'Notificação do cliente',
            subject_label: 'Assunto',
            deadline_label: 'Prazo de notificação',
            body_label: 'Corpo de notificação',
            required_fields_label: 'Campos obrigatórios do artigo 28.º, n.º 4',
            mitigation_heading: 'Etapas de mitigação',
            citations_label: 'Citações',
            accept_label: 'Aceitar avaliação',
            reject_label: 'Rejeitar avaliação',
            accept_hint: 'Aceitar criará uma tarefa de notificação do cliente com o prazo [[TOK_0]] como data de vencimento.',
            resolve_summary: 'Resolução: [[TOK_2]][[TOK_3]]',
            error_generic: 'Não foi possível avaliar esta alteração no subprocessador. Tente novamente ou verifique o registro de alterações.',
        },
        onboarding_evidence: {
            collect_label: 'Executar coleta de evidências [[TOK_0]]',
            collecting: 'Coletando evidências…',
            results_heading: 'Coleta de evidências ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            findings_heading: 'Evidência existente',
            missing_heading: 'Artefatos desaparecidos',
            no_findings: 'Nenhuma evidência existente detectada.',
            no_missing: 'Não faltam artefatos obrigatórios para este nível de risco.',
            next_step_label: 'Próxima etapa',
            class_dpa: 'Contrato de Processamento de Dados',
            class_soc2: 'Relatório SOC 2',
            class_iso27001: 'Certificado ISO 27001',
            class_insurance: 'Apólice de seguro cibernético',
            class_incident_history: 'Incidente anterior',
            accept_hint: 'Aceitar criará tarefas para cada artefato ausente (limitado a 5). As descobertas permanecem como rascunho até que você as anexe como prova.',
            accept_label: 'Aceitar relatório',
            reject_label: 'Rejeitar relatório',
            resolve_summary: 'Resolução: [[TOK_2]] · [[TOK_3]] tarefa(s) criada(s)',
            error_generic: 'Não foi possível executar a coleta de evidências [[TOK_0]]. Tente novamente ou verifique o status do caso de integração.',
        },
        no_permission_title: 'Permissões insuficientes',
        no_permission_message: 'Você não tem permissão para acessar o gerenciamento de riscos do fornecedor.',
        unknown_vendor: 'Fornecedor desconhecido',
        nav: {
            dashboard: 'Painel de riscos',
            scoring: 'Pontuação de riscos',
            questionnaires: 'Questionários',
            contracts: 'Contratos',
            gates: 'Portas de aprovação',
            reviews: 'Avaliações de fornecedores',
            signals: 'Sinais de risco',
            reassessments: 'Reavaliações',
            portfolio: 'Portfólio de riscos',
            acceptances: 'Aceitação de riscos',
            review_routing: 'Encaminhamento de revisões',
            onboarding_cases: 'Casos de integração',
            sub_processor_register: 'Registo de subcontratantes',
        },
        dashboard: {
            title: 'Painel de risco de fornecedores',
            page_title: 'Painel de risco do fornecedor',
            loading: 'A carregar dashboard data...',
            risk_tier_header: 'Nível de risco',
            count_header: 'Contar',
            percentage_header: 'Porcentagem',
            sections_nav: 'Seções de risco do fornecedor',
            urgent_expiry: 'Urgente: expira em 14 dias',
            no_previous_tier: 'Nenhum nível anterior',
            view_as_chart: 'Ver como gráfico',
            view_as_table: 'Ver como tabela',
            showing_chart: 'Exibindo vista de gráfico',
            showing_table: 'Exibindo vista de tabela',
            load_error: 'Falha ao load vendor risk dashboard. Por favor, tente novamente.',
            risk_distribution: 'Risco Distribution Visão geral',
            recent_tier_changes: 'Recente Nível Changes',
            no_tier_changes: 'Sem alterações de nível recentes.',
            review_kpis: 'KPIs de revisão',
            total_vendors_reviewed: 'Total Fornecedores Reviewed',
            reviews_by_outcome: 'Revisões por resultado',
            contract_coverage: 'Cobertura contratual',
            total_vendors: 'Total Fornecedores',
            with_active_dpa: 'Com Ativo DPA',
            without_dpa: 'Sem DPA',
            dpa_coverage: 'Cobertura DPA',
            active_contracts_by_type: 'Ativo Contratos por Tipo',
            expiring_contracts: 'Contratos a expirar (próximos 90 dias)',
            no_expiring_contracts: 'Nenhum contrato a expirar nos próximos 90 dias.',
            vendor: 'Fornecedor',
            previous_tier: 'Anterior Nível',
            current_tier: 'Atual Nível',
            changed_at: 'Alterado em',
            expires_at: 'Expira Em',
            days_remaining: 'Dias restantes',
            days: 'dias',
            vendors_label: 'fornecedores',
            no_data: 'Sem dados',
            critical: 'Crítico',
            high: 'Alto',
            medium: 'Médio',
            low: 'Baixo',
            expiring_acceptances_heading: 'Aceitações de risco a expirar',
            expiring_30d_label: 'Expira em 30 dias',
            expiring_60d_label: 'Expira em 60 dias',
            expiring_90d_label: 'Expira em 90 dias',
        },
        scoring: {
            title: 'Pontuação de riscos',
            page_title: 'Pontuação de risco do fornecedor',
            filter_scores: 'Filtrar pontuações de risco',
            filter_by_tier: 'Filtrar por nível de risco',
            scores_pagination: 'Paginação de pontuações de risco',
            config_dimensions: 'Configuração de dimensões de pontuação',
            scores_loaded: '[[TOK_1]] pontuações de risco carregadas',
            weight_must_equal_100: 'O peso total deve ser igual a 100 (atual: [[TOK_1]])',
            out_of_10: 'de 10, classificado como [[TOK_1]]',
            dimension_name: 'Nome da dimensão [[TOK_1]]',
            dimension_weight: '[[TOK_1]] peso (porcentagem)',
            must_equal_100: 'deve ser igual a 100',
            config_title: 'Configuração de pontuação',
            scores_title: 'Fornecedor Risco Scores',
            new_score_title: 'Pontuação um Fornecedor',
            new: 'Novo pontuação',
            vendor_id: 'Fornecedor ID',
            risk_tier: 'Risco Nível',
            score: 'Pontuação',
            scored_at: 'Pontuado em',
            no_scores: 'Nenhum risk scores encontrado',
            all_tiers: 'Todos os níveis',
            load_config_error: 'Falha ao load risk scoring configuration. Por favor, tente novamente.',
            update_config: 'Atualizar configuração de pontuação',
            update_config_error: 'Falha ao update risk scoring configuration. Por favor, tente novamente.',
            load_scores_error: 'Falha ao load vendor risk scores. Por favor, tente novamente.',
            calculate_error: 'Falha ao calculate vendor risk score. Por favor, tente novamente.',
            weight: 'peso',
            score_range: 'Pontuação (1-5)',
            method: 'Método',
        },
        questionnaires: {
            title: 'Questionários',
            page_title: 'Questionários de fornecedores',
            filter_questionnaires: 'Filtros de questionário',
            questionnaire_views: 'Visualizações do questionário',
            templates_list: 'Lista de modelos de questionário',
            instances_list: 'Lista de instâncias de questionário',
            filter_by_status: 'Filtrar por status do questionário',
            templates_per_page: 'Modelos por página',
            instances_per_page: 'Instâncias por página',
            select_template: 'Selecione o modelo de questionário',
            template_category: 'Categoria de modelo',
            templates_tab: 'Modelos',
            instances_tab: 'Instâncias',
            new: 'Novo Questionnaire',
            new_template: 'Novo modelo',
            new_instance: 'Nova instância',
            vendor_id: 'Fornecedor ID',
            template_id: 'Modelo ID',
            assigned_to: 'Atribuído Para',
            due_date: 'Data de vencimento',
            responses: 'Respostas',
            risk_score: 'Conclusão',
            no_questionnaires: 'Nenhum questionnaires encontrado',
            load_templates_error: 'Falha ao load questionnaire templates. Por favor, tente novamente.',
            load_instances_error: 'Falha ao load questionnaires. Por favor, tente novamente.',
            create_template_error: 'Falha ao create questionnaire template. Por favor, tente novamente.',
            initiate_error: 'Falha ao initiate questionnaire. Por favor, tente novamente.',
            submit_error: 'Falha ao submit questionnaire. Por favor, tente novamente.',
            review_error: 'Falha ao review questionnaire. Por favor, tente novamente.',
            resubmit: 'Reenviar',
            approve_error: 'Falha ao aprovar questionário',
            reject_error: 'Falha ao rejeitar questionário',
            resubmit_error: 'Falha ao reenviar questionário',
            templates_loaded: '[[TOK_1]] modelos de questionário carregados',
            instances_loaded: '[[TOK_1]] instâncias de questionário carregadas',
            fill_responses_cta: 'Preencher respostas',
            fill_responses_title: 'Preencher respostas do questionário',
            template_missing: 'Modelo não encontrado.',
            responses_saved: 'Respostas guardadas.',
            load_template_error: 'Falha ao carregar modelo.',
            version_history: 'Histórico de versões',
            download_previous_version: 'Descarregar versão anterior',
            trigger: 'Gatilho',
            template_label: 'Modelo',
            reviewer: 'Revisor',
            reviewer_required: 'Um revisor deve ser designado para os questionários [[TOK_1]] (separação de funções).',
            select_option: 'Selecione uma opção',
            multi_choice_hint: 'Selecione todas as opções aplicáveis',
            category_initial_onboarding: 'Integração inicial',
            category_annual_review: 'Revisão anual',
            category_incident_triggered: 'Acionado por incidente',
            category_contract_renewal: 'Renovação de contrato',
            template_editor: {
                page_title: 'Editar modelo de questionário',
                preview_page_title: 'Visualizar modelo de questionário',
                edit_structure: 'Editar estrutura',
                preview: 'Visualização',
                actions: 'Ações',
                back_to_list: 'Voltar aos modelos',
                load_error: 'Falha ao carregar o modelo',
                save_error: 'Falha ao salvar a estrutura do modelo',
                saved: 'Estrutura do modelo salva.',
                sections_heading: 'Seções',
                questions_heading: 'Perguntas',
                add_section: 'Adicionar seção',
                edit_section: 'Editar seção',
                delete_section: 'Excluir seção',
                move_section_up: 'Mover seção para cima',
                move_section_down: 'Mover seção para baixo',
                confirm_delete_section: 'Excluir seção "[[TOK_1]]"? Todas as suas perguntas serão removidas.',
                section_title: 'Título da seção',
                section_description: 'Descrição da seção',
                section_id: 'ID da seção',
                section_id_hint: 'Gerado automaticamente, a menos que você defina um explicitamente.',
                no_sections: 'Nenhuma seção ainda. Adicione uma seção para começar.',
                no_questions: 'Ainda não há perguntas nesta seção.',
                add_question: 'Adicionar pergunta',
                edit_question: 'Editar pergunta',
                delete_question: 'Excluir pergunta',
                move_question_up: 'Mover pergunta para cima',
                move_question_down: 'Mover pergunta para baixo',
                confirm_delete_question: 'Excluir pergunta "[[TOK_1]]"?',
                question_text: 'Texto da pergunta',
                question_type: 'Tipo de pergunta',
                question_id: 'ID da pergunta',
                evidence_required: 'Evidência necessária',
                risk_weight: 'Peso de risco',
                scoring_map: 'Mapa de pontuação',
                scoring_map_json_hint: '[[TOK_0]] valores de resposta de mapeamento de objeto para pontuações numéricas.',
                scoring_map_invalid_json: 'O mapa de pontuação deve ser válido [[TOK_0]].',
                options_heading: 'Opções de resposta',
                add_option: 'Adicionar opção',
                remove_option: 'Opção de remoção',
                option_label: 'Etiqueta',
                option_value: 'Valor',
                option_risk_weight: 'Peso de risco',
                min_options_error: 'As questões de escolha devem ter pelo menos 2 opções.',
                option_label_required: 'Cada opção precisa de um rótulo.',
                option_value_required: 'Cada opção precisa de um valor.',
                option_value_unique: 'Os valores das opções devem ser exclusivos.',
                branching_rules_heading: 'Regras de ramificação',
                branching_rules_hint: 'Mostre ou oculte esta pergunta com base na resposta de uma pergunta anterior.',
                add_branching_rule: 'Adicionar regra de ramificação',
                remove_branching_rule: 'Remover regra de ramificação',
                branching_condition_question: 'Se pergunta',
                branching_condition_value: 'tem valor',
                branching_action: 'então',
                branching_action_show: 'mostre esta pergunta',
                branching_action_hide: 'ocultar esta pergunta',
                branching_select_condition_question: 'Selecione a pergunta anterior',
                branching_select_condition_value: 'Selecione o valor',
                save: 'Salvar estrutura',
                saving: 'Salvando...',
                cancel: 'Cancelar',
                close: 'Fechar',
                question_text_required: 'O texto da pergunta é obrigatório.',
                section_title_required: 'O título da seção é obrigatório.',
                type_single_choice: 'Escolha única',
                type_multi_choice: 'Múltipla escolha',
                type_free_text: 'Texto livre',
                type_numeric: 'Numérico',
                type_date: 'Data',
                type_file_upload: 'Carregamento de arquivo',
                type_yes_no: 'Sim / Não',
                preview_heading: 'Visualização do modelo',
                preview_subtitle: 'Visualização somente leitura de como o questionário aparece para um fornecedor.',
                preview_no_content: 'Este modelo ainda não possui seções ou perguntas.',
                preview_branching_notice: 'As regras de ramificação são avaliadas durante o preenchimento; a visualização mostra todas as perguntas.',
            },
            review_modal: {
                title: 'Revise as respostas do questionário',
                open_cta: 'Revisão',
                loading: 'Carregando questionário...',
                template_missing: 'Modelo não encontrado.',
                load_error: 'Falha ao carregar o questionário para revisão.',
                annotation_heading: 'Anotações',
                annotation_placeholder: 'Adicione uma anotação de revisor para esta pergunta...',
                annotation_status_label: 'Status da anotação',
                annotation_status_acceptable: 'Aceitável',
                annotation_status_concern: 'Preocupação',
                annotation_status_requires_action: 'Requer ação',
                review_comments_label: 'Comentários gerais da revisão',
                review_comments_placeholder: 'Resuma as descobertas da sua revisão...',
                justification_label: 'Justificativa da decisão',
                justification_placeholder: 'Explique o motivo da sua decisão...',
                reject_requires_comments: 'Rejeitar um questionário requer comentários de revisão.',
                decision_heading: 'Decisão',
                decision: {
                    approved: 'Aprovar',
                    rejected: 'Rejeitar',
                    additional_info_requested: 'Solicite informações adicionais',
                },
                submit: 'Enviar avaliação',
                submitting: 'Enviando avaliação...',
                cancel: 'Cancelar',
                submit_success: 'Revisão enviada.',
                submit_error: 'Falha ao enviar avaliação.',
                separation_of_duties_error: 'Você não pode revisar um questionário que você foi designado para preencher. A separação de funções requer um revisor diferente.',
                decision_required: 'Selecione uma decisão de revisão.',
                announce_opened: 'Modal de revisão aberto.',
                announce_submitted: 'Revisão enviada.',
            },
            instance_detail: {
                submitted_at: 'Enviado',
                reviewed_at: 'Revisado',
                reviewer: 'Revisor',
                review_decision: 'Decisão',
                review_comments: 'Rever comentários',
                decision_approved: 'Aprovado',
                decision_rejected: 'Rejeitado',
                decision_additional_info_requested: 'Mais informações solicitadas',
                decision_pending: 'Revisão pendente',
                expand_comments: 'Mostrar comentários completos',
                collapse_comments: 'Ocultar comentários completos',
                no_reviewer: 'Nenhum revisor atribuído',
            },
            export: {
                portfolio_label: 'Portfólio de exportação',
                instance_label: 'Exportar',
                portfolio_success: 'Exportação de portfólio pronta.',
                instance_success: 'Exportação do questionário pronta.',
                portfolio_error: 'Falha ao exportar o portfólio do questionário.',
                instance_error: 'Falha ao exportar o questionário.',
            },
            branching: {
                hidden_notice: 'Algumas questões são ocultadas por regras de ramificação.',
                cycle_warning: 'Um ciclo foi detectado nas regras de ramificação. As perguntas afetadas ficam visíveis por padrão.',
            },
        },
        contracts: {
            title: 'Contratos',
            page_title: 'Contratos de fornecedores',
            new: 'Novo contrato',
            vendor_id: 'Fornecedor ID',
            filter_contracts: 'Filtrar contratos',
            filter_by_document_type: 'Filtrar por tipo de documento',
            filter_by_status: 'Filtrar por status do contrato',
            per_page: 'Contratos por página',
            expired_notice: 'Este contrato expirou',
            document_type: 'Documento Tipo',
            expiry_date: 'Data de expiração',
            no_contracts: 'Nenhum contracts encontrado',
            all_document_types: 'Todos Documento Types',
            load_error: 'Falha ao load contracts. Por favor, tente novamente.',
            create_error: 'Falha ao create contract. Por favor, tente novamente.',
            delete_error: 'Falha ao delete contract. Por favor, tente novamente.',
            update_error: 'Falha ao atualizar o estado. Por favor, tente novamente.',
            confirm_delete: 'Eliminar contrato "{title}"?',
            renewal_date: 'Data de renovação',
            effective_date: 'Data de vigência',
            parties: 'Partes',
            summary: 'Resumo',
            n_contracts: '{count} contratos',
            n_contract: '{count} contrato',
            contracts_loaded: '{count} contratos carregados',
            doc_type_dpa: 'DPA',
            doc_type_security_addendum: 'Adendo de segurança',
            doc_type_scc_annex: 'Anexo SCC',
            doc_type_sub_processor_list: 'Lista de suboperadores',
            doc_type_bcr: 'BCR',
            doc_type_nda: 'NDA',
            doc_type_msa: 'MSA',
            doc_type_sla: 'SLA',
            doc_type_other: 'Outro',
            status_draft: 'Rascunho',
            status_under_negotiation: 'Em negociação',
            status_pending_signature: 'Aguardando assinatura',
            status_active: 'Ativo',
            status_expired: 'Expirado',
            status_terminated: 'Encerrado',
            status_superseded: 'Substituído',
        },
        gates: {
            title: 'Portas de aprovação',
            page_title: 'Avaliações de portões',
            new: 'Novo Gate Evaluation',
            vendor_id: 'Fornecedor ID',
            gate_name: 'Nome da porta',
            outcome: 'Resultado',
            evaluator: 'Avaliador',
            no_gates: 'Nenhum gate evaluations encontrado',
            load_error: 'Falha ao load gate evaluations. Por favor, tente novamente.',
            evaluate_error: 'Falha ao evaluate vendor gate. Por favor, tente novamente.',
            detail_error: 'Falha ao fetch evaluation detail. Por favor, tente novamente.',
            override_error: 'Falha ao override gate evaluation. Por favor, tente novamente.',
            criteria_results: 'Resultados dos critérios',
            evaluate_form: 'Avalie a porta do fornecedor',
            per_page: 'Avaliações por página',
            passed: 'Aprovado',
            failed: 'Falhou',
            override: 'Substituição',
            override_justification: 'Justificação de substituição',
            override_placeholder: 'Introduza justification for overriding this gate evaluation',
            approval_id: 'ID de aprovação',
            overall_passed: 'Aprovado',
            overall_failed: 'Reprovado',
            overall_overridden: 'Substituído',
            evaluations_loaded: '{count} avaliações de portão carregadas',
            create_approval_cta: 'Criar aprovação',
        },
        reviews: {
            title: 'Avaliações de fornecedores',
            page_title: 'Avaliações de fornecedores',
            new: 'Novo rever',
            vendor_id: 'Fornecedor ID',
            filter_by_outcome: 'Filtrar por resultado da revisão',
            per_page: 'Comentários por página',
            kpi_summary: 'Revise o resumo [[TOK_0]]',
            review_outcome_label: 'Revise o resultado',
            edit_outcome: 'Editar resultado da revisão',
            reviews_loaded: '[[TOK_1]] avaliações de fornecedores carregadas',
            reviewer: 'Revisor',
            review_type: 'Rever Tipo',
            outcome: 'Resultado',
            findings: 'Constatações',
            no_reviews: 'Nenhum vendor reviews encontrado',
            load_kpis_error: 'Falha ao fetch vendor review kpis. Por favor, tente novamente.',
            load_error: 'Falha ao fetch vendor reviews. Por favor, tente novamente.',
            update_error: 'Falha ao atualizar avaliação do fornecedor',
            create_error: 'Falha ao create vendor review. Por favor, tente novamente.',
            total_reviewed: 'Total Fornecedores Reviewed',
            total_reviews: 'Total de revisões',
            satisfactory: 'Satisfatório',
            concerns_identified: 'Preocupações identificadas',
            remediation_required: 'Remediação necessária',
            escalated: 'Escalado',
            program_id: 'ID do programa',
            period_id: 'Período ID',
            task_id: 'Tarefa ID',
            recommendations: 'Recomendações',
        },
        risk_signals: {
            title: 'Sinais de Risco',
            page_title: 'Sinais de risco',
            new_signal: 'Novo sinal de risco',
            signal_type: 'Tipo de sinal',
            severity: 'Gravidade',
            description: 'Descrição',
            source: 'Fonte',
            vendor_id: 'ID do fornecedor',
            certification_expiry: 'Expiração de certificação',
            breach_notification: 'Notificação de violação',
            financial_instability: 'Instabilidade financeira',
            compliance_change: 'Alteração de conformidade',
            custom: 'Personalizado',
            active: 'Ativo',
            acknowledged: 'Reconhecido',
            resolved: 'Resolvido',
            no_signals: 'Nenhum sinal de risco encontrado',
            source_external_feed: 'Fonte externa',
            source_manual: 'Manuais',
            source_integration: 'Integração',
            source_regulatory: 'Regulatório',
            source_media: 'Comunicação social',
            trigger_reassessment_prompt: 'Este sinal é de alta gravidade. Iniciar uma reavaliação do fornecedor agora?',
            reassessment_triggered: 'Reavaliação iniciada.',
            reassessment_trigger_error: 'Não foi possível iniciar a reavaliação.',
        },
        reassessments: {
            title: 'Tarefas de Reavaliação',
            page_title: 'Tarefas de Reavaliação',
            trigger: 'Iniciar reavaliação',
            trigger_success: 'Reavaliação iniciada com sucesso',
            reason: 'Motivo',
            deadline: 'Prazo',
            assigned_to: 'Atribuído a',
            vendor_id: 'ID do fornecedor',
            outcome: 'Resultado',
            new_risk_level: 'Novo nível de risco',
            complete: 'Concluir reavaliação',
            complete_success: 'Reavaliação concluída com sucesso',
            pending: 'Pendente',
            in_progress: 'Em andamento',
            completed: 'Concluído',
            cancelled: 'Cancelado',
            no_tasks: 'Nenhuma tarefa de reavaliação encontrada',
            risk_trend: 'Tendência de risco',
            notes: 'Notas',
        },
        portfolio: {
            title: 'Portfólio de Riscos',
            page_title: 'Portfólio de Risco',
            dashboard: 'Painel do portfólio',
            vendor_id: 'ID do fornecedor',
            total_vendors: 'Total de fornecedores',
            average_score: 'Pontuação média de risco',
            high_risk_count: 'Fornecedores de alto risco',
            trend_direction: 'Direção da tendência',
            improved: 'Melhorado',
            stable: 'Estável',
            degraded: 'Degradado',
            vendor_trend: 'Tendência de fornecedores',
            outstanding_questionnaires: 'Questionários pendentes',
            overdue_assessments: 'Avaliações em atraso',
            no_outstanding: 'Nenhum questionário pendente',
            no_overdue: 'Nenhuma avaliação em atraso',
            due_date: 'Data de vencimento',
        },
        risk_acceptance: {
            title: 'Registo de Aceitação de Riscos',
            page_title: 'Registro de Aceitação de Risco',
            new_acceptance: 'Nova aceitação de risco',
            vendor_id: 'ID do fornecedor',
            risk_level: 'Nível de risco',
            conditions: 'Condições',
            justification: 'Justificação',
            expiry_date: 'Data de expiração',
            create_success: 'Aceitação de risco criada com sucesso',
            review_condition: 'Rever condição',
            condition_met: 'Condição cumprida',
            condition_not_met: 'Condição não cumprida',
            review_success: 'Condição revista com sucesso',
            export_register: 'Exportar registo',
            active: 'Ativo',
            expired: 'Expirado',
            revoked: 'Revogado',
            no_acceptances: 'Nenhuma aceitação de risco encontrada',
            met_count: '[[TOK_2]]/[[TOK_3]] encontrado',
        },
        review_routing: {
            title: 'Encaminhamento de Revisões',
            page_title: 'Revise o roteamento',
            route_to_reviewers: 'Enviar para revisores',
            route_success: 'Enviado para revisores com sucesso',
            vendor_id: 'ID do fornecedor',
            reviewer_id: 'ID do revisor',
            reviewer_role: 'Função do revisor',
            questionnaire_id: 'ID do questionário',
            review_status: 'Estado da revisão',
            reviewers_label: 'Revisores (user_id, função por linha)',
            pending: 'Pendente',
            in_review: 'Em revisão',
            completed: 'Concluído',
            no_routing: 'Nenhum encaminhamento de revisão encontrado',
            primary_reviewer: 'Revisor principal',
            secondary_reviewer: 'Revisor secundário',
            approver: 'Aprovador',
        },
        onboarding: {
            title: 'Casos de Integração de Fornecedores',
            page_title: 'Casos de Integração de Fornecedores',
            new_case: 'Novo caso de integração',
            case_detail: 'Caso de Integração',
            open_mps_dossier_filing: 'Abrir submissão MPS',
            dossier_filing_description: 'Cria uma nova submissão MPS pré-preenchida a partir deste caso de onboarding. A submissão ficará ligada ao caso.',
            dossier_filing_dpia_id: 'ID DPIA',
            dossier_filing_dpia_id_placeholder: 'ex. dpia_01TEST000000000000000001',
            dossier_filing_title: 'Título da submissão',
            dossier_filing_form_type: 'Tipo de formulário',
            dossier_filing_submit: 'Criar submissão',
            dossier_filing_validation_error: 'ID DPIA e título são necessários.',
            dossier_filing_created: 'Submissão MPS criada',
            dossier_filing_error: 'Falha ao criar submissão MPS.',
            linked_questionnaire_due_date: 'Data limite',
            linked_questionnaire_assignee: 'Atribuído a',
            linked_questionnaire_submitted_at: 'Submetido em',
            score_last_scored: 'Última pontuação',
            score_dimensions: 'Dimensões',
            linked_contract_document_type: 'Tipo de documento',
            linked_contract_effective_date: 'Data de entrada em vigor',
            linked_contract_expiry_date: 'Data de expiração',
            linked_sub_processor_countries: 'Países de processamento',
            linked_sub_processor_last_assessment: 'Última avaliação',
            linked_sub_processor_next_assessment: 'Próxima avaliação',
            case_id: 'ID do caso',
            vendor: 'Fornecedor',
            case_type: 'Tipo de caso',
            service_description: 'Descrição do serviço',
            data_categories: 'Categorias de dados',
            systems_accessed: 'Sistemas acedidos',
            jurisdiction: 'Jurisdição',
            hosting_model: 'Modelo de alojamento',
            controller_role: 'Papel de responsável/subcontratante',
            status_pipeline: 'Pipeline de estado',
            tabs_label: 'Secções do caso de integração',
            per_page: 'Casos por página',
            filter_cases: 'Filtrar casos de integração',
            cases_count: 'casos',
            cases_loaded: 'casos de integração carregados',
            no_cases: 'Nenhum caso de integração encontrado.',
            vendor_lookup_placeholder: 'Introduza o ID do fornecedor',
            data_categories_placeholder: 'ex., dados_pessoais, financeiros, saúde',
            systems_placeholder: 'ex., CRM, ERP, Sistema RH',
            status_open: 'Aberto',
            status_in_progress: 'Em progresso',
            status_awaiting_approval: 'A aguardar aprovação',
            status_approved: 'Aprovado',
            status_remediation_required: 'Remediação necessária',
            status_closed: 'Fechado',
            type_new_vendor: 'Novo fornecedor',
            type_service_change: 'Alteração de serviço',
            type_renewal: 'Renovação',
            type_reassessment: 'Reavaliação',
            tab_overview: 'Visão geral',
            tab_due_diligence: 'Devida diligência',
            tab_security_assessment: 'Avaliação de segurança',
            tab_contractual_controls: 'Controlos contratuais',
            tab_sub_processors: 'Subcontratantes',
            tab_approval_gates: 'Portas de aprovação',
            tab_evidence: 'Evidência',
            tab_placeholder: 'O conteúdo desta secção será preenchido durante o processo de integração.',
            completion_not_started: 'Não iniciado',
            completion_in_progress: 'Em progresso',
            completion_completed: 'Concluído',
            completion_requiring_attention: 'Requer atenção',
            gate_name: 'Nome da porta',
            approver: 'Aprovador',
            decision: 'Decisão',
            comments: 'Comentários',
            decide: 'Tomar decisão',
            decision_approved: 'Aprovado',
            decision_rejected: 'Rejeitado',
            decision_deferred: 'Adiado',
            no_approvals: 'Nenhuma porta de aprovação configurada para este caso.',
            approval_success: 'Decisão de aprovação registada com sucesso',
            approval_error: 'Não foi possível registar a decisão de aprovação',
            transition_status: 'Transitar estado',
            confirm_transition: 'Transitar caso de "{from}" para "{to}"?',
            transition_success: 'Estado do caso transitado com sucesso',
            transition_error: 'Não foi possível transitar o estado do caso',
            create_success: 'Caso de integração criado com sucesso',
            create_error: 'Não foi possível criar o caso de integração',
            load_error: 'Não foi possível carregar os casos de integração',
            detail_error: 'Não foi possível carregar os detalhes do caso',
            export: 'Exportar',
            export_error: 'Não foi possível exportar o caso de integração',
            evidence_tab_description: 'Carregue e exporte provas para o caso de integração.',
            upload_evidence_label: 'Carregar prova',
            attached_evidence_heading: 'Provas anexadas',
            no_evidence_attached: 'Ainda sem provas anexadas.',
            export_bundle_button: 'Exportar conjunto de provas',
            load_attachments_error: 'Falha ao carregar provas.',
            linked_questionnaires_heading: 'Questionários ligados',
            no_linked_questionnaires: 'Sem questionários ligados.',
            linked_scores_heading: 'Pontuações ligadas',
            no_linked_scores: 'Sem pontuações ligadas.',
            latest_score_label: 'Pontuação mais recente',
            linked_contracts_heading: 'Contratos ligados',
            no_linked_contracts: 'Sem contratos ligados.',
            linked_sub_processors_heading: 'Subcontratantes ligados',
            no_linked_sub_processors: 'Sem subcontratantes ligados.',
        },
        sub_processors: {
            title: 'Registo de Subcontratantes',
            page_title: 'Registo de Subcontratantes',
            new_record: 'Novo subcontratante',
            edit_record: 'Editar subcontratante',
            onboarding_case: 'Caso de integração',
            services: 'Serviços prestados',
            data_categories: 'Categorias de dados',
            processing_countries: 'Países de tratamento',
            dpa_chain_status: 'Estado da cadeia DPA',
            certifications: 'Certificações',
            last_assessment: 'Última avaliação',
            next_assessment: 'Próxima avaliação',
            change_history: 'Histórico de alterações',
            history: 'Histórico',
            changed_by: 'Alterado por',
            comma_separated: 'Valores separados por vírgulas',
            filter_records: 'Filtrar registos',
            filter_by_dpa: 'Filtrar por estado da cadeia DPA',
            all_dpa_statuses: 'Todos os estados DPA',
            per_page: 'Registos por página',
            records_count: 'subcontratantes',
            records_loaded: 'registos carregados',
            no_records: 'Nenhum subcontratante encontrado.',
            no_history: 'Nenhum histórico de alterações disponível.',
            dpa_active: 'Ativo',
            dpa_pending: 'Pendente',
            dpa_expired: 'Expirado',
            dpa_not_required: 'Não necessário',
            create_success: 'Subcontratante criado com sucesso',
            create_error: 'Não foi possível criar o subcontratante',
            update_success: 'Subcontratante atualizado com sucesso',
            update_error: 'Não foi possível atualizar o subcontratante',
            load_error: 'Não foi possível carregar o registo',
            history_error: 'Não foi possível carregar o histórico de alterações',
            export_csv: 'Exportar CSV',
            export_json: 'Exportar JSON',
            export_error: 'Não foi possível exportar os dados',
        },
    },
    deletion_orchestration: {
        nav: {
            dashboard: 'Painel de orquestração',
            runs: 'Execuções de orquestração',
            tasks: 'Tarefas de execução',
            templates: 'Modelos de lista de verificação',
            vendor_requests: 'Pedidos de fornecedores',
            proof_chain: 'Cadeia de provas',
            dsr_integration: 'Integração DSR',
            vendor_verification: 'Verificação de fornecedores',
            completeness: 'Painel de completude',
        },
        dashboard: {
            title: 'Painel de orquestração',
            loading: 'A carregar dashboard data...',
            active_runs: 'Execuções ativas',
            completion_rate: 'Taxa de conclusão',
            avg_completion_time: 'Tempo médio de conclusão',
            overdue_tasks: 'Em atraso Tarefas',
            vendor_compliance: 'Fornecedor Conformidade',
            recent_runs: 'Execuções recentes',
            no_recent_runs: 'Sem execuções de orquestração recentes.',
            run_id: 'Executar ID',
            ticket_id: 'ID do ticket',
            progress: 'Progresso',
            systems: 'Sistemas',
            vendors: 'Fornecedores',
            load_error: 'Falha ao carregar o painel de orquestração. Por favor, tente novamente.',
            aria_table: 'Execuções recentes de orquestração',
        },
        runs: {
            title: 'Execuções de orquestração',
            new: 'Novo executar',
            run_id: 'Executar ID',
            ticket_id: 'ID do ticket',
            progress: 'Progresso',
            systems: 'Sistemas',
            vendors: 'Fornecedores',
            data_subject_ref: 'Dados Titular Ref',
            data_categories: 'Categorias de dados',
            enable_proof_chain: 'Ativar cadeia de prova',
            start: 'Iniciar',
            started: 'Execução iniciada',
            mark_ready: 'Marcar como pronto',
            marked_ready: 'Execução marcada como pronta',
            complete: 'Completo',
            complete_exceptions: 'Completo com exceções',
            pause: 'Pausa',
            resume: 'Currículo',
            cancel: 'Cancelar',
            no_runs: 'Nenhum orchestration runs encontrado',
            load_error: 'Falha ao carregar execuções de orquestração. Por favor, tente novamente.',
            create_error: 'Falha ao criar execução de orquestração',
            aria_filter_status: 'Filtrar por status de execução',
            aria_table: 'Execuções de orquestração',
            placeholder_ticket_id: 'por exemplo, TKT-000123',
            placeholder_data_subject_ref: 'por exemplo, DS-REF-001',
            placeholder_data_categories: 'por exemplo, personal_data, financeiro, saúde',
            title_label: 'Title',
            run_type: 'Run Type',
            run_type_labels: {
                data_subject_request: 'Data Subject Request',
                retention_expiry: 'Retention Expiry',
                manual: 'Manual',
                scheduled: 'Scheduled',
            },
            field_guidelines: {
                title: 'A descriptive name for this orchestration run.',
                run_type: 'The origin or trigger for the deletion process.',
                ticket_id: 'The associated ticket ID from your DSR or support system.',
                data_subject_ref: 'A unique identifier for the data subject (e.g., internal ID, email hash).',
                data_categories: 'Specific categories of personal data to be deleted (comma-separated).',
                proof_enabled: 'Maintains an immutable cryptographic chain of evidence for this run.',
            },
            actions: 'Actions',
            progress_guideline: 'Calculated based on completed system tasks and vendor requests.',
            placeholder_title: 'e.g., Q2 2026 Customer Deletion Batch',
        },
        tasks: {
            title: 'Tarefas de execução',
            task_id: 'Tarefa ID',
            run_id: 'Executar ID',
            system_name: 'Sistema Nome',
            assigned_to: 'Atribuído Para',
            sla_deadline: 'SLA Prazo',
            progress: 'Progresso',
            enter_run_id: 'Introduza Run ID to filter...',
            select_run: 'Selecione uma execução para visualizar tarefas',
            unassigned: 'Não atribuído',
            overdue: 'Em atraso',
            assign_task: 'Atribuir Tarefa',
            assignee_id: 'Atribuído ID',
            update_status: 'Atualizar Estado',
            new_status: 'Novo estado',
            no_transitions: 'Esta tarefa está num estado final e não pode mudar de estado.',
            select_status_placeholder: 'Selecione um novo estado',
            skip_justification: 'Justificação da omissão',
            failure_reason: 'Motivo da falha',
            no_tasks: 'Nenhum execution tasks encontrado',
            new_task: 'Nova tarefa',
            system_id: 'ID do sistema',
            data_classification: 'Classificação de dados',
            load_error: 'Falha ao carregar execution tasks. Tente novamente.',
            assign_error: 'Falha ao assign task',
            status_error: 'Falha ao atualizar o estado da tarefa',
            no_tasks_for_run: 'Esta execução de eliminação ainda não tem tarefas de execução.',
            aria_filter_run_id: 'Filtrar por ID de execução',
            aria_filter_status: 'Filtrar por status da tarefa',
            aria_table: 'Tarefas de execução',
            view_steps: 'Ver etapas',
            steps_modal_title: 'Etapas de execução',
            step_title: 'Etapa',
            step_status: 'Estado da etapa',
            step_notes: 'Notas',
            step_evidence: 'Ficheiros de evidência',
            step_evidence_required: 'É necessária evidência para esta etapa',
            step_evidence_missing: 'Ainda não foi carregada evidência',
            step_save: 'Guardar etapa',
            step_saved: 'Etapa atualizada',
            step_save_error: 'Falha ao atualizar etapa',
            create_success: 'Tarefa de execução criada',
            create_error: 'Falha ao criar a tarefa de execução',
            step_upload_label: 'Anexar evidência',
        },
        templates: {
            title: 'Modelos de lista de verificação',
            new: 'Novo modelo',
            template_id: 'Modelo ID',
            system_type: 'Sistema Tipo',
            est_duration: 'Duração est.',
            steps: 'Passos',
            action_type: 'Ação Tipo',
            instructions: 'Instruções',
            mandatory: 'Obrigatório',
            add_step: 'Adicionar Step',
            step_n: 'Passo',
            no_templates: 'Nenhum checklist templates encontrado',
            all_system_types: 'Todos Sistema Types',
            load_error: 'Falha ao carregar modelos de lista de verificação. Por favor, tente novamente.',
            create_error: 'Falha ao criar modelo de lista de verificação',
            aria_filter_system_type: 'Filtrar por tipo de sistema',
            aria_filter_status: 'Filtrar por status do modelo',
            aria_table: 'Modelos de lista de verificação',
            placeholder_name: 'por exemplo, lista de verificação de exclusão de banco de dados',
            guideline_name: 'Use a clear operating name, for example “Database Deletion Checklist”.',
            guideline_system_type: 'Choose the system category this checklist will usually run against.',
            guideline_status: 'Draft templates can be reviewed before activation; active templates can be reused in runs.',
            guideline_description: 'Summarise scope, retention context, and when teams should select this template.',
            update_success: 'Modelo atualizado com sucesso',
            create_success_msg: 'Modelo criado com sucesso',
            update_error: 'Falha ao atualizar o modelo',
            activate_success: 'Modelo ativado com sucesso',
            activate_error: 'Falha ao ativar o modelo',
            archive_success: 'Modelo arquivado com sucesso',
            archive_error: 'Falha ao arquivar o modelo',
            clone_success: 'Modelo clonado com sucesso',
            clone_error: 'Falha ao clonar o modelo',
        },
        vendor_requests: {
            title: 'Fornecedor Eliminação Pedidos',
            new: 'Novo pedido',
            request_id: 'Pedido ID',
            vendor_name: 'Fornecedor Nome',
            vendor_id: 'Fornecedor ID',
            data_subject_ref: 'Dados Titular Ref',
            data_categories: 'Categorias de dados',
            legal_basis: 'Base jurídica',
            sla_days: 'Dias SLA',
            requested_completion: 'Conclusão solicitada',
            communications: 'Comunicações',
            total_requests: 'Total Pedidos',
            no_requests: 'Nenhum vendor deletion requests encontrado',
            filter_vendor_id: 'Filtrar por Fornecedor ID...',
            change_status: 'Alterar Estado',
            new_status: 'Novo Estado',
            actions: 'Ações',
            load_error: 'Falha ao carregar solicitações de exclusão de fornecedor. Por favor, tente novamente.',
            create_error: 'Falha ao criar solicitação de exclusão de fornecedor',
            dashboard_error: 'Falha ao carregar o painel de exclusão do fornecedor. Por favor, tente novamente.',
            aria_filter_status: 'Filtrar por status da solicitação',
            aria_filter_vendor_id: 'Filtrar por ID do fornecedor',
            aria_table: 'Solicitações de exclusão de fornecedor',
            placeholder_vendor_id: 'por exemplo, VND-001',
            placeholder_vendor_name: 'por exemplo, Acme Analytics',
            placeholder_data_subject_ref: 'por exemplo, DS-REF-001',
            placeholder_data_categories: 'por exemplo, personal_data, análises',
            placeholder_legal_basis: 'por exemplo, [[TOK_0]] Artigo 19',
        },
        proof_chain: {
            title: 'Visualizador de cadeia de prova',
            enter_run_id: 'Introduza executar id...',
            load_chain: 'Carregar cadeia',
            verify_chain: 'Verificar cadeia',
            verifying: 'A verificar...',
            chain_valid: 'A cadeia é válida',
            chain_invalid: 'A cadeia está quebrada',
            chain_length: 'Comprimento da cadeia',
            broken_at_index: 'Quebrado no índice',
            no_proof_records: 'Nenhum registo de prova encontrado para esta execução.',
            proof_id: 'ID de prova',
            entity_type: 'Tipo de entidade',
            entity_id: 'ID da entidade',
            event_hash: 'Hash do evento',
            previous_hash: 'Hash anterior',
            attestation: 'Atestação',
            attestation_actor: 'Realizado por',
            attestation_signed_at: 'Assinado em',
            attestation_signature: 'Assinatura',
            attestation_evidence_refs: 'Referências de evidências',
            run_field_label: 'Execução de eliminação',
            select_run: 'Selecione uma execução de eliminação…',
            aria_select_run: 'Execução de eliminação para a pesquisa da cadeia de provas',
            chain_broken_here: 'Cadeia quebrada aqui',
            load_error: 'Falha ao carregar a cadeia de prova. Por favor, tente novamente.',
            verify_error: 'Falha ao verificar a cadeia de prova. Por favor, tente novamente.',
            aria_run_id: 'ID de execução para pesquisa de cadeia de prova',
        },
        dsr_integration: {
            change_status: 'Alterar estado',
            request_type: 'Tipo de pedido',
            data_subject_hint: 'Identificador do titular dos dados cujos dados serão apagados (por ex., e-mail ou ID de cliente). Normalmente corresponde ao requerente do caso DSR selecionado.',
            title: 'Integração de eliminação DSR',
            create_run: 'Criar execução de eliminação DSR',
            dsr_case_id: 'ID do caso DSR',
            data_subject_id: 'ID do titular dos dados',
            systems: 'Sistemas alvo',
            route_to_department: 'Encaminhar para departamento',
            confirm_deletion: 'Confirmar eliminação',
            no_runs: 'Nenhuma execução de eliminação DSR encontrada',
            status: 'Estado da eliminação',
            deadline: 'Prazo',
        },
        vendor_verification: {
            title: 'Verificação de eliminação de fornecedores',
            create_followup: 'Criar seguimento',
            deadline: 'Prazo de confirmação',
            escalation_contact: 'Contacto de escalação',
            record_confirmation: 'Registar confirmação',
            overdue: 'Eliminações em atraso',
            escalate: 'Escalar',
            confirm_escalation: 'Tem certeza de que deseja escalar esta solicitação de exclusão de fornecedor?',
            no_followups: 'Nenhum seguimento de fornecedor encontrado',
            no_overdue: 'Sem eliminações de fornecedores em atraso',
            vendor_request: 'Solicitação do fornecedor',
            vendor: 'Fornecedor',
            unknown_vendor: 'Fornecedor desconhecido',
            overdue_badge: 'Em atraso',
            mark_confirmed: 'Marcar como confirmado',
            mark_confirmed_for: 'Marcar a eliminação como confirmada para {vendor}',
            confirm_confirmation: 'Marcar esta eliminação de fornecedor como confirmada?',
            confirmation_success: 'Eliminação de fornecedor confirmada',
            confirmation_failed: 'Falha ao confirmar a eliminação de fornecedor',
            select_request: 'Selecione uma solicitação do fornecedor…',
            escalation_contact_placeholder: 'p. ex. dpo@vendor.example',
            create_success: 'Seguimento do fornecedor criado com sucesso',
            create_failed: 'Falha ao criar o seguimento do fornecedor',
            deadline_hint: 'Esta página apresenta apenas os seguimentos cujo prazo já expirou.',
            deadline_future_warning: 'Este prazo está no futuro, pelo que o seguimento só aparecerá na lista de itens em atraso depois de a data passar.',
            escalation_success: 'Eliminação de fornecedor escalada com sucesso',
            escalation_failed: 'Falha ao escalar a eliminação de fornecedor',
        },
        completeness: {
            title: 'Completude da eliminação',
            check_conflicts: 'Verificar conflitos de retenção',
            no_conflicts: 'Nenhum conflito de retenção encontrado',
            conflict_resolution: 'Resolução de conflitos',
            extend_retention: 'Prolongar retenção',
            proceed_deletion: 'Prosseguir com a eliminação',
            escalate_conflict: 'Escalar',
            resolve: 'Resolver conflito',
            data_subject_id: 'ID do titular dos dados',
            placeholder_data_subject_id: 'Insira o ID do titular dos dados',
            data_subject_hint: 'Identificador da pessoa cuja eliminação está a verificar (por ex., e-mail, ID de cliente ou referência de DSR). Escolha um titular conhecido ou escreva um.',
            guidance: 'Introduza ou selecione um ID de titular dos dados, opcionalmente escolha sistemas e execute a verificação para ver a integridade da eliminação e os conflitos de retenção.',
            completion: 'Conclusão da eliminação',
            pending_items: 'Itens pendentes',
            system: 'Sistema',
            policy: 'Política',
            retention_end: 'Fim da retenção',
            completed_items: 'Itens Concluídos',
            last_review_label: 'Última revisão',
            days_ago: 'dias atrás',
            review_overdue: 'Ciclo de revisão excedido. É necessária uma nova revisão.',
        },
        run_status_labels: {
            pending: 'Pendente',
            planning: 'Planeamento',
            ready: 'Pronto',
            in_progress: 'Em Progresso',
            paused: 'Pausado',
            completed: 'Concluído',
            completed_with_exceptions: 'Concluído com Exceções',
            cancelled: 'Cancelado',
        },
        task_status_labels: {
            pending: 'Pendente',
            assigned: 'Atribuído',
            in_progress: 'Em Progresso',
            awaiting_verification: 'Aguardando Verificação',
            verified: 'Verificado',
            failed: 'Falhado',
            skipped: 'Ignorado',
        },
        system_type_labels: {
            database: 'Base de Dados',
            saas_application: 'Aplicação SaaS',
            file_storage: 'Armazenamento de Ficheiros',
            email_system: 'Sistema de Email',
            analytics_platform: 'Plataforma Analítica',
            backup_system: 'Sistema de Backup',
            vendor_managed: 'Gerido pelo Fornecedor',
            custom: 'Personalizado',
        },
        template_status_labels: {
            draft: 'Rascunho',
            active: 'Ativo',
        },
        action_type_labels: {
            manual_check: 'Verificação Manual',
            api_call: 'Chamada API',
            sql_query: 'Consulta SQL',
            script_execution: 'Execução de Script',
            file_deletion: 'Eliminação de Ficheiro',
            verification: 'Verificação',
            notification: 'Notificação',
            approval: 'Aprovação',
        },
        request_status_labels: {
            draft: 'Rascunho',
            sent: 'Enviado',
            acknowledged: 'Confirmado',
            in_progress: 'Em Progresso',
            completed: 'Concluído',
            overdue: 'Atrasado',
            escalated: 'Escalado',
            disputed: 'Contestado',
        },
        event_type_labels: {
            initiation: 'Iniciação',
            data_deletion: 'Eliminação de Dados',
            completion: 'Conclusão',
            verification: 'Verificação',
            rollback: 'Reversão',
        },
        count_labels: {
            one_template: '1 modelo',
            n_templates: '{n} modelos',
            one_run: '1 execução',
            n_runs: '{n} execuções',
            one_task: '1 tarefa',
            n_tasks: '{n} tarefas',
            one_request: '1 pedido',
            n_requests: '{n} pedidos',
        },
        aria: {
            completion_rate: 'Taxa de conclusão: {pct}%',
            vendor_compliance: 'Conformidade do fornecedor: {pct}%',
            run_progress: 'Progresso: {pct}%',
            run_progress_systems: 'Progresso: {completed} de {total} sistemas processados',
            chain_broken: 'Cadeia partida neste registo',
            chain_valid: 'Cadeia válida neste registo',
            chain_unknown: 'Estado da cadeia desconhecido',
            escalate_vendor: 'Escalar {id}',
            resolve_conflict: 'Resolver conflito para {system}',
        },
        regulatory: {
            annual_review_cycle_info: 'A integridade da exclusão deve ser revisada pelo menos a cada 365 dias. Os registros que excedem esse limite são sinalizados para nova revisão obrigatória para manter a conformidade regulatória.',
            runs_data_d1_lifecycle_info: 'Os estados de execução da orquestração são mapeados para o ciclo de vida DATA-D1: planejamento = catálogo, pronto = classificar, in_progress = aplicar regras, concluído = evidência gerada, completed_with_exceptions = revisão necessária. Cada transição é registrada na cadeia de prova.',
            vendor_record_linkage_info: 'Cada solicitação de exclusão de fornecedor é vinculada ao seu registro de fornecedor por meio de vendor_id. A confirmação da conclusão requer evidência criptográfica da cadeia de prova antes que a solicitação possa ser marcada como concluída.',
            templates_internal_classification_info: 'Todos os modelos de lista de verificação de exclusão são classificados como documentos organizacionais internos. Eles não possuem IDs de formulário regulatório oficial e não devem ser enviados como registros regulatórios.',
            proof_chain_evidence_info: 'Cada registro de prova captura o assunto/categoria dos dados, carimbo de data/hora, ator, base legal e um hash SHA-256. Juntos, esses campos produzem evidências de exclusão criptográfica que atendem aos requisitos de auditoria regulatória.',
            retention_data_law_info: 'Os cronogramas de retenção neste painel são derivados da classificação da Lei de Dados atribuída a cada categoria de dados. Quando uma classificação muda, as regras de retenção vinculadas são atualizadas automaticamente para garantir o alinhamento regulatório.',
            dsr_erasure_route_info: 'As execuções de eliminação de DSR estão vinculadas ao caso de Solicitação de Direitos originário. O prazo regulamentar (normalmente 30 dias nos termos do [[TOK_0]] Art. 17) é rastreado automaticamente. Os casos atrasados ​​são sinalizados para escalonamento.',
        },
    },
    discovery: {
        nav: {
            dashboard: 'Painel de descoberta',
            scans: 'Verificações de descoberta',
            staging_area: 'Área de preparação',
            dedup_rules: 'Regras de deduplicação',
            classification_rules: 'Regras de classificação',
            suggestions: 'Fila de sugestões',
            analytics: 'Análise de sugestões',
            import_templates: 'Modelos de importação',
            connectors: 'Gestão de conectores',
            discovery_cycles: 'Ciclos de descoberta',
            owner_review: 'Revisão do proprietário',
            classification_lineage: 'Histórico de classificação',
        },
        dashboard: {
            title: 'Painel de descoberta',
            loading: 'A carregar dashboard data...',
            total_scans: 'Total de análises',
            active_scans: 'Análises ativas',
            completed_30d: 'Concluído (30d)',
            failed_30d: 'Falhou (30d)',
            systems_discovered: 'Sistemas descobertos',
            pending_staged_records: 'Pendente Staged Registos',
            recent_scans: 'Análises recentes',
            no_recent_scans: 'Sem análises recentes.',
            scan_id: 'Analisar ID',
            discovered: 'Descoberto',
            view_all_scans: 'Ver All Scans',
            staging_area: 'Área de staging',
            suggestion_queue: 'Fila de sugestões',
            records_reviewed: 'Registos revisados',
            records_approved: 'Registos aprovados',
            exceptions_pending: 'Exceções pendentes',
            view_as_chart: 'Ver como gráfico',
            view_as_table: 'Ver como tabela',
        },
        scans: {
            title: 'Verificações de descoberta',
            new: 'Novo analisar',
            scan_id: 'Analisar ID',
            scan_type: 'Analisar Tipo',
            progress: 'Progresso',
            discovered: 'Descoberto',
            no_scans: 'Nenhum discovery scans encontrado',
            all_scan_types: 'Todos Analisar Types',
            source_config: 'Config. da fonte (JSON)',
            invalid_json: 'JSON inválido na configuração da fonte',
            load_error: 'Falha ao load discovery scans. Por favor, tente novamente.',
            create_error: 'Falha ao create discovery scan. Por favor, tente novamente.',
            change_status: 'Alterar status',
            new_status: 'Novo status',
            actions: 'Ações',
            type_endpoint: 'Ponto de extremidade',
            type_spreadsheet_import: 'Importação de planilha',
            type_cmdb_sync: 'Sincronização CMDB',
            type_cloud_sync: 'Sincronização na nuvem',
            status_pending: 'Pendente',
            status_running: 'Em execução',
            status_completed: 'Concluído',
            status_failed: 'Falhou',
            status_cancelled: 'Cancelado',
            source_config_placeholder: '{"host": "...", "porta": 443}',
        },
        staging_area: {
            title: 'Área de preparação',
            record_id: 'Registo ID',
            source_scan: 'Análise de origem',
            entity_type: 'Tipo de entidade',
            suggested_name: 'Nome sugerido',
            confidence: 'Confiança',
            no_records: 'Nenhum staged records encontrado',
            promote: 'Promover',
            discard: 'Descartar',
            review: 'Rever',
            merge: 'Fundir',
            merge_title: 'Mesclar registro',
            merge_target_id: 'ID do alvo de fusão',
            reject_reason_placeholder: 'Motivo de rejeição...',
            promotion_status: 'Estado de promoção',
            dedup_status: 'Estado de dedup.',
            all_source_types: 'Todos os tipos de fonte',
            all_promotion_statuses: 'Todos os estados de promoção',
            all_dedup_statuses: 'Todos os estados de dedup.',
            load_error: 'Falha ao load staged records. Por favor, tente novamente.',
            promote_error: 'Falha ao promote record. Por favor, tente novamente.',
            reject_error: 'Falha ao reject record. Por favor, tente novamente.',
            merge_error: 'Falha ao merge record. Por favor, tente novamente.',
            review_error: 'Falha ao mark record for review. Por favor, tente novamente.',
            bulk_promote_error: 'Falha ao bulk promote records. Por favor, tente novamente.',
            bulk_reject_error: 'Falha ao bulk reject records. Por favor, tente novamente.',
            service_type_web_server: 'Servidor web',
            service_type_database: 'Base de dados',
            service_type_api_gateway: 'Gateway de API',
            service_type_storage: 'Armazenamento',
            service_type_authentication: 'Autenticação',
            service_type_analytics: 'Análise',
            service_type_unknown: 'Desconhecido',
            source_type_endpoint_scan: 'Verificação de ponto de extremidade',
            source_type_spreadsheet: 'Planilha',
            source_type_cmdb: 'CMDB',
            source_type_cloud_inventory: 'Inventário na nuvem',
            promotion_status_new: 'Novo',
            promotion_status_under_review: 'Em revisão',
            promotion_status_promoted: 'Promovido',
            promotion_status_rejected: 'Rejeitado',
            promotion_status_merged: 'Mesclado',
            dedup_status_unmatched: 'Sem correspondência',
            dedup_status_potential_match: 'Correspondência potencial',
            dedup_status_exact_match: 'Correspondência exata',
            dedup_status_resolved: 'Resolvido',
            confirm_bulk_reject: 'Tem certeza de que deseja rejeitar os registros selecionados?',
            scan_batch_id: 'ID do lote',
            promote_to_registry_title: 'Promover para registro de dados',
            promote_modal_instructions: 'Cria um item de Registro de Dados com collection_method: vínculo observado e de procedência com este registro de descoberta. O item começa no status de rascunho para revisão.',
            promote_label_category: 'Categoria',
            promote_label_name_override: 'Nome (substituição opcional)',
            placeholder_name_override: 'O padrão é o nome/nome do host do registro de descoberta',
            promote_label_sensitivity: 'Sensibilidade proposta',
            inherit_from_category: 'Herdar da categoria',
        },
        dedup_rules: {
            title: 'Regras de deduplicação',
            new: 'Novo Rule',
            rule_name: 'Nome da regra',
            match_fields: 'Campos de correspondência',
            threshold: 'Limiar',
            no_rules: 'Nenhum dedup rules encontrado',
            seed_defaults: 'Predefinições iniciais',
            match_type: 'Tipo de correspondência',
            similarity_threshold: 'Limiar de semelhança',
            field_name: 'Campo Nome',
            load_error: 'Falha ao load dedup rules. Por favor, tente novamente.',
            create_error: 'Falha ao create dedup rule. Por favor, tente novamente.',
            toggle_error: 'Falha ao toggle dedup rule. Por favor, tente novamente.',
            seed_error: 'Falha ao seed defaults. Por favor, tente novamente.',
            priority: 'Prioridade',
            enabled_status: 'Habilitado',
            disabled_status: 'Desativado',
            default_badge: 'Padrão',
            enable: 'Habilitar',
            disable: 'Desativar',
            match_type_exact: 'Exato',
            match_type_fuzzy: 'Aproximado',
            match_type_regex: 'Regex',
            match_type_ip_range: 'Faixa de IP',
        },
        classification_rules: {
            title: 'Regras de classificação',
            new: 'Novo Rule',
            rule_name: 'Nome da regra',
            pattern: 'Padrão',
            classification: 'Classificação',
            no_rules: 'Nenhum classification rules encontrado',
            seed_defaults: 'Predefinições iniciais',
            run_rules_now: 'Executar regras agora',
            run_rules_success: 'Geradas [[TOK_1]] novas sugestões de classificação',
            run_rules_no_results: 'Nenhuma nova sugestão gerada — todas as regras correspondentes já possuem sugestões pendentes',
            run_rules_error: 'Falha ao executar regras de classificação. Por favor, tente novamente.',
            taxonomy_id: 'ID de taxonomia',
            level_id: 'Nível ID',
            condition_logic: 'Lógica de condição',
            weight: 'Peso',
            conditions: 'Condições',
            condition_field: 'Campo',
            condition_operator: 'Operador',
            condition_value: 'Valor',
            effectiveness: 'Eficácia',
            match_count: 'Correspondências',
            approval_count: 'Aprovações',
            rejection_count: 'Rejeições',
            filter_taxonomy: 'Filtrar por ID de taxonomia...',
            load_error: 'Falha ao load classification rules. Por favor, tente novamente.',
            create_error: 'Falha ao create classification rule. Por favor, tente novamente.',
            seed_error: 'Falha ao seed defaults. Por favor, tente novamente.',
            toggle_error: 'Falha ao toggle rule. Por favor, tente novamente.',
            priority: 'Prioridade',
            enabled_status: 'Habilitado',
            disabled_status: 'Desativado',
            enable: 'Habilitar',
            disable: 'Desativar',
            logic_and: 'E',
            logic_or: 'OU',
            operator_equals: 'Igual a',
            operator_contains: 'Contém',
            operator_matches_regex: 'Corresponde ao Regex',
            operator_in_list: 'Na lista',
            operator_not_equals: 'Diferente de',
            operator_not_contains: 'Não contém',
            enabled_label: 'Ativado',
            disabled_label: 'Desativado',
            taxonomy_label: 'Taxonomia',
            operator_label: 'Operador',
            value_label: 'Valor',
        },
        suggestions: {
            title: 'Fila de sugestões',
            entity_type: 'Tipo de entidade',
            suggested_name: 'Nome sugerido',
            source: 'Fonte',
            confidence: 'Confiança',
            accept: 'Aceitar',
            reject: 'Rejeitar',
            no_suggestions: 'Sem sugestões na fila.',
            modify_approve: 'Modificar e aprovar',
            delegate: 'Delegar',
            delegate_user_id: 'ID do utilizador delegado',
            new_level_id: 'Novo nível id',
            reject_reason_placeholder: 'Motivo de rejeição...',
            current_level: 'Atual Nível',
            suggested_level: 'Nível sugerido',
            filter_taxonomy: 'Filtrar por ID de taxonomia...',
            all_confidence: 'Todas as faixas de confiança',
            load_error: 'Falha ao load suggestions. Por favor, tente novamente.',
            approve_error: 'Falha ao approve suggestion. Por favor, tente novamente.',
            reject_error: 'Falha ao reject suggestion. Por favor, tente novamente.',
            modify_error: 'Falha ao modify & approve suggestion. Por favor, tente novamente.',
            delegate_error: 'Falha ao delegate suggestion. Por favor, tente novamente.',
            bulk_approve_error: 'Falha ao bulk approve suggestions. Por favor, tente novamente.',
            bulk_reject_error: 'Falha ao bulk reject suggestions. Por favor, tente novamente.',
            suggestion_type_new_label: 'Nova etiqueta',
            suggestion_type_validation: 'Validação',
            suggestion_type_reclassification: 'Reclassificação',
            status_pending: 'Pendente',
            status_approved: 'Aprovado',
            status_rejected: 'Rejeitado',
            status_superseded: 'Substituído',
            confidence_high: 'Alta',
            confidence_medium: 'Média',
            confidence_low: 'Baixa',
            confirm_bulk_reject: 'Tem certeza de que deseja rejeitar as sugestões selecionadas?',
        },
        analytics: {
            title: 'Análise de sugestões',
            total_suggestions: 'Total de sugestões',
            accepted: 'Aceite',
            rejected: 'Rejeitado',
            pending: 'Pendente',
            acceptance_rate: 'Taxa de aceitação',
            by_entity_type: 'Por tipo de entidade',
            by_source: 'Por fonte',
            avg_decision_time: 'Tempo médio de decisão',
            rule_effectiveness: 'Eficácia da regra',
            by_status: 'Por Estado',
            by_confidence: 'Por faixa de confiança',
            load_error: 'Falha ao load suggestion analytics. Por favor, tente novamente.',
            confidence_high: 'Alta',
            confidence_medium: 'Média',
            confidence_low: 'Baixa',
            by_confidence_band: 'Por faixa de confiança',
            approval_rate: 'Taxa de aprovação',
            by_label_state: 'Por estado de rótulo',
        },
        import_templates: {
            title: 'Modelos de importação',
            new: 'Novo modelo',
            template_name: 'Modelo Nome',
            file_format: 'Formato de ficheiro',
            column_mappings: 'Mapeamentos de colunas',
            no_templates: 'Nenhum import templates encontrado',
            source_column: 'Coluna de origem',
            target_field: 'Campo de destino',
            transform: 'Transformar',
            source_column_label: 'Coluna de origem',
            target_field_label: 'Campo de destino',
            transform_label: 'Transformar',
            confirm_delete: 'Tem a certeza de que pretende eliminar this import template?',
            load_error: 'Falha ao load import templates. Por favor, tente novamente.',
            save_error: 'Falha ao save import template. Por favor, tente novamente.',
            delete_error: 'Falha ao delete import template. Por favor, tente novamente.',
            file_type_csv: 'CSV',
            file_type_xlsx: 'XLSX',
        },
        connectors: {
            title: 'Gestão de conectores',
            new: 'Novo Connector',
            connector_name: 'Nome do conector',
            connector_type: 'Tipo',
            last_sync: 'Último Sincronizar',
            no_connectors: 'Nenhum connectors encontrado',
            cmdb_syncs: 'Sincronizações CMDB',
            cloud_syncs: 'Sincronizações cloud',
            new_sync: 'Novo sincronizar',
            no_syncs: 'Nenhum syncs encontrado',
            cmdb_error: 'Falha ao load cmdb scans. Por favor, tente novamente.',
            cloud_error: 'Falha ao load cloud scans. Por favor, tente novamente.',
            trigger_error: 'Falha ao trigger sync. Por favor, tente novamente.',
            trigger_sync_error: 'Falha ao trigger {type}',
            cmdb_section_title: 'Sincronizações CMDB',
            cloud_section_title: 'Sincronizações na nuvem',
            column_connector: 'Conector',
            action_start: 'Iniciar',
            confirm_cancel_sync: 'Cancelar esta sincronização?',
            start_error: 'Falha ao iniciar sincronização',
            cancel_error: 'Falha ao cancelar sincronização',
            type_endpoint: 'Verificação de endpoint',
            type_spreadsheet_import: 'Importação de planilha',
            type_cmdb_sync: 'Sincronização CMDB',
            type_cloud_sync: 'Sincronização na nuvem',
        },
        discovery_cycles: {
            title: 'Ciclos de descoberta',
            new_cycle: 'Novo ciclo de descoberta',
            cycle_name: 'Nome do ciclo',
            scope_type: 'Tipo de âmbito',
            scope_ids: 'IDs de âmbito',
            cadence_days: 'Frequência (dias)',
            status: 'Estado',
            no_cycles: 'Nenhum ciclo de descoberta encontrado',
            compare: 'Comparar ciclos',
            delta_report: 'Relatório de alterações',
            new_records: 'Novos registos',
            changed_records: 'Registos alterados',
            removed_records: 'Registos removidos',
            schedule: 'Agendar análise',
            scope_organization: 'Organização',
            scope_department: 'Departamento',
            scope_system: 'Sistema',
            scope_systems: 'Sistemas',
            bulk_actions: 'Ações em massa',
            selected: '{count} selecionado(s)',
            bulk_create: 'Criação em massa',
            bulk_assign_scope: 'Atribuir escopo em massa',
            bulk_advance: 'Avançar status em massa',
            confirm_bulk_action: 'Confirmar ação em massa',
            bulk_confirm_message: 'Tem certeza de que deseja realizar esta ação?',
            cycles_affected: '{count} ciclos serão afetados',
            select_all: 'Selecionar tudo',
            select_cycle: 'Selecionar ciclo {name}',
            from_template: 'a partir do modelo',
            bulk_results: 'Resultados em massa',
            failed_label: 'falhou',
            template_id: 'ID do modelo',
            count: 'Quantidade',
            advance_to: 'Estado alvo',
            bulk_success: 'Operação em massa concluída',
        },
        owner_review: {
            title: 'Tarefas de revisão do proprietário',
            assign_owner: 'Atribuir ao proprietário',
            owner_id: 'Proprietário',
            decision: 'Decisão',
            approve: 'Aprovar',
            modify: 'Modificar',
            reject: 'Rejeitar',
            escalate: 'Escalar',
            no_tasks: 'Nenhuma tarefa de revisão encontrada',
            bulk_resolve: 'Resolução em massa',
            exceptions: 'Itens de exceção',
            no_exceptions: 'Nenhum item de exceção encontrado',
            record_id_label: 'ID do registro',
            selected: 'selecionado',
            notes: 'Notas',
            select_all: 'Selecionar Tudo',
            select: 'Selecionar',
            confirm_resolve: 'Confirmar',
        },
        classification_lineage: {
            title: 'Histórico de classificação',
            link_suggestion: 'Associar a rótulo proposto',
            suggestion_id: 'Sugestão',
            proposed_label_id: 'Rótulo proposto',
            no_lineage: 'Nenhum dado de histórico encontrado',
            full_lineage: 'Histórico completo',
            record_id_label: 'ID do registro',
            staged_record_label: 'Registro encenado',
            enter_staged_record_id: 'Insira o ID do registro preparado',
            scan_id_label: 'ID de digitalização',
            select_record: 'Selecionar um registo',
            select_suggestion: 'Selecionar uma sugestão',
            select_label: 'Selecionar uma etiqueta',
        },
        common_labels: {
            n_rules: '[[TOK_1]] regras',
            one_rule: '1 regra',
            n_scans: '[[TOK_1]] verificações',
            one_scan: '1 varredura',
            n_syncs: '[[TOK_1]] sincroniza',
            one_sync: '1 sincronização',
            n_records: '[[TOK_1]] registros',
            one_record: '1 registro',
            n_templates: '[[TOK_1]] modelos',
            one_template: '1 modelo',
            n_suggestions: '[[TOK_1]] sugestões',
            one_suggestion: '1 sugestão',
            n_selected: '[[TOK_1]] selecionado',
            dashboard_loaded: 'Painel de descoberta carregado',
            n_scans_loaded: '[[TOK_1]] verificações carregadas',
            n_staged_records_loaded: '[[TOK_1]] registros preparados carregados',
            confirm_delete_import_template: 'Tem certeza de que deseja excluir este modelo de importação?',
            invalid_json_source_config: '[[TOK_0]] inválido em source_config',
            scope_organization: 'Organização',
            scope_department: 'Departamento',
            scope_system: 'Sistema',
            aria_filter_scans: 'Filtrar verificações',
            aria_filter_staged_records: 'Filtrar registros preparados',
            aria_filter_suggestions: 'Filtros',
            aria_filter_by_taxonomy_id: 'Filtrar por ID de taxonomia',
            aria_filter_by_enabled_status: 'Filtrar por status ativado',
            aria_filter_by_source_type: 'Filtrar por tipo de fonte',
            aria_filter_by_promotion_status: 'Filtrar por status de promoção',
            aria_filter_by_dedup_status: 'Filtrar por status de eliminação de duplicação',
            aria_filter_by_scan_type: 'Filtrar por tipo de verificação',
            aria_filter_by_status: 'Filtrar por status',
            aria_filter_by_confidence: 'Filtrar por faixa de confiança',
            aria_select_all_records: 'Selecione todos os registros',
            aria_select_record: 'Selecione o registro [[TOK_1]]',
            aria_select_all_suggestions: 'Selecione todas as sugestões',
            aria_select_suggestion: 'Selecione a sugestão [[TOK_1]]',
            aria_promote_record: 'Promover registro [[TOK_1]]',
            aria_discard_record: 'Registro de descarte [[TOK_1]]',
            aria_merge_record: 'Mesclar registro [[TOK_1]]',
            aria_review_record: 'Revisar registro [[TOK_1]]',
            aria_accept_suggestion: 'Aceitar sugestão [[TOK_1]]',
            aria_reject_record: 'Rejeitar registro',
            aria_merge_record_dialog: 'Mesclar registro',
            aria_create_new_scan: 'Criar nova verificação',
            aria_sync_progress: 'Progresso da sincronização: [[TOK_2]] de [[TOK_3]] itens processados',
            aria_scan_progress: 'Progresso da verificação: [[TOK_2]] de [[TOK_3]] itens processados',
            aria_confidence: 'Confiança: [[TOK_1]]%',
            aria_effectiveness: 'Eficácia: [[TOK_1]]',
            aria_promote_n_records: 'Promova [[TOK_1]] registros selecionados',
            aria_discard_n_records: 'Descartar [[TOK_1]] registros selecionados',
            placeholder_pii_detection_rule: 'por exemplo, regra de detecção de PII',
            placeholder_tax_id: 'por exemplo, TAX-001',
            placeholder_lvl_id: 'por exemplo, LVL-001',
            placeholder_service_type: 'por exemplo, service_type',
            placeholder_database: 'por exemplo, banco de dados',
            placeholder_hostname_match: 'por exemplo, correspondência exata do nome do host',
            placeholder_hostname: 'por exemplo, nome do host',
            placeholder_hr_systems_csv: 'por exemplo, Sistemas de RH [[TOK_0]] Importação',
            placeholder_server_name: 'por exemplo, nome do servidor',
            placeholder_hostname_field: 'por exemplo, nome do host',
            placeholder_lowercase: 'por exemplo, minúsculas',
            placeholder_source_config: '{"host": "...", "porta": 443}',
            placeholder_stg_id: 'por exemplo, STG-000123',
            placeholder_lvl_002: 'por exemplo, LVL-002',
            placeholder_usr_id: 'por exemplo, USR-000123',
            decision_for: 'Decisão para [[TOK_1]]',
        },
        exports: {
            title: 'Exportar',
            inventory: 'Inventário de dados',
            classification_register: 'Registo de classificação',
            raci: 'Matriz RACI',
            exceptions: 'Relatório de exceções',
            evidence_pack: 'Pacote de evidências',
            delta_report: 'Relatório de alterações',
            executive_summary: 'Resumo executivo',
            export_button: 'Exportar',
            downloading: 'A transferir...',
            download_complete: 'Transferência concluída.',
            download_error: 'Falha ao transferir exportação. Tente novamente.',
        },
        flags: {
            title: 'Marcadores a jusante',
            pending: 'Marcadores pendentes',
            cross_border_review_needed: 'Revisão transfronteiriça necessária',
            sharing_disclosure_needed: 'Divulgação de partilha necessária',
            dpia_review_needed: 'Revisão AIPD necessária',
            acknowledge: 'Confirmar',
            resolve: 'Resolver',
            no_flags: 'Sem marcadores a jusante.',
        },
        delta: {
            title: 'Resumo de alterações',
            new_count: '{n} novos',
            removed_count: '{n} removidos',
            changed_count: '{n} alterados',
            re_review_triggered: 'Reavaliação acionada',
            create_re_review: 'Criar reavaliação',
            recent_alerts: 'Alertas de alterações recentes',
            no_alerts: 'Sem alertas de alterações recentes.',
            threshold_exceeded: 'Limiar de alterações ultrapassado (>10%)',
        },
        regulatory: {
            dashboard_governance_info: 'Este painel mostra o status de governança em nível de ciclo: sistemas verificados, registros preparados, registros revisados, registros aprovados e exceções pendentes. Isso corresponde aos critérios de sucesso do líder de governança: "painel ao vivo de quem atualizou seu inventário, classificação e compartilhamento de logs" (P-VN-05).',
            export_artifacts_info: 'As exportações de descoberta incluem todos os tipos de artefatos necessários por UC-VN-10 e DATA-EVD-01: inventário de dados aprovado, registro de classificação, mapeamento de propriedade/RACI, fila de exceções, resumo executivo, pacote de evidências e relatório delta.',
            scan_inventory_pipeline_info: 'Cada varredura concluída produz registros compatíveis com o modelo vn_data_law_data_inventory_register (requisito 88dd9877). Os ativos de dados descobertos preenchem automaticamente o registro de inventário de dados para satisfazer a obrigação da Lei de Dados de manter um inventário de dados digitais.',
            connector_linkage_info: 'Cada configuração de conector deve incluir: tipo de sistema (por exemplo, [[TOK_0]], plataforma de nuvem), referência de armazenamento de dados (banco de dados, armazenamento de arquivos, SaaS) e vinculação de processos de negócios (UC-VN-10 registros de suporte necessários). Esses campos garantem que os ativos descobertos sejam rastreáveis ​​até seu sistema de origem e contexto de negócios.',
            owner_routing_info: 'As tarefas de revisão são roteadas para o departamento correto ou proprietário do aplicativo com base na propriedade do sistema/dados (UC-VN-10 etapa 5). O roteamento usa o registro de propriedade do sistema, e não a atribuição ad hoc.',
            owner_actions_audit_info: 'Os proprietários podem aprovar, modificar, rejeitar ou escalar cada classificação (UC-VN-10 etapa 6). Cada ação captura o ator, o carimbo de data/hora e o motivo, produzindo eventos de evidência de auditoria de governança de acordo com o requisito f12fc090 (Atestado anual de governança). A trilha de auditoria mostra quem revisou, o que foi alterado e quando.',
            escalation_timers_info: 'Cronômetros de escalonamento: o prazo de revisão do proprietário é de 5 dias úteis; o escalonamento de exceção é de 48 horas (UC-VN-10 temporizadores). Os itens não resolvidos são escalonados automaticamente quando o prazo expira. Os temporizadores são configuráveis ​​de acordo com a política organizacional.',
            original_suggestion_preserved_info: 'A sugestão original de classificação da máquina/sistema é preservada junto com cada substituição do proprietário (UC-VN-10 requisito de evidência). A sugestão original nunca é substituída e permanece visível para fins de auditoria.',
            dedup_lineage_info: 'As regras de desduplicação evitam entradas duplicadas de inventário quando o mesmo ativo de dados é descoberto em diversas varreduras ou conectores. Os metadados de varredura mais recentes são preservados como registro primário, mantendo referências de linhagem a todas as descobertas anteriores para rastreabilidade de auditoria.',
            label_states_info: 'O Analytics distingue quatro estados de rótulo para revisão de governança: sugerido pela máquina (pendente), aprovado pelo proprietário, modificado pelo proprietário e rejeitado. Esses estados permitem que os auditores avaliem a precisão da automação e o envolvimento do proprietário.',
            import_pipeline_info: 'Os modelos de importação devem produzir registros compatíveis com o pipeline de descoberta. Os registros importados entram na preparação com os mesmos requisitos de metadados dos registros digitalizados: identificação do sistema de origem, ID do lote e carimbo de data/hora. Os mapeamentos de colunas devem ter como alvo os campos definidos em vn_data_law_data_inventory_register.',
            lineage_full_path_info: 'A linhagem de classificação traça o caminho completo: digitalização/importação -> preparação -> revisão do proprietário -> rótulo aprovado -> entrada de registro (UC-VN-10 etapas 1 a 10). Cada estágio mostra ID do registro, ator, carimbo de data/hora e transição de estado para rastreabilidade completa da auditoria.',
            staging_workflow_info: 'Os registros preparados são visualmente diferenciados das entradas de inventário aprovadas por seu selo de status de promoção (UC-VN-10 etapa 3). Cada registro retém metadados de origem: sistema de origem, ID do lote de digitalização e carimbo de data/hora da descoberta para rastreabilidade total da auditoria.',
            suggestion_data_d1_info: 'As sugestões estão alinhadas com o procedimento de classificação da Lei de Dados DATA-D1: (1) catalogar ativos de dados, (2) classificar por nível de sensibilidade, (3) definir regras de tratamento. Cada sugestão inclui dimensões de sensibilidade e importância de acordo com o requisito 18e4bfd1.',
            downstream_flags_info: 'Itens sinalizados para compartilhamento, transferência transfronteiriça ou tratamento de alto risco acionam fluxos de trabalho downstream vinculados: avaliação de transferência transfronteiriça, avaliação de risco de compartilhamento e revisão [[TOK_0]] (UC-VN-10 etapa 8).',
            delta_detection_info: 'Os ciclos de descoberta suportam a detecção delta de acordo com UC-VN-10 etapa 11: cada ciclo mostra quais registros são novos, alterados ou removidos desde a última linha de base aprovada. Alterações materiais (>10% delta) acionam automaticamente fluxos de trabalho de nova revisão.',
        },
    },
    incident_ops: {
        errors: {
            fetch: 'Falha ao load. Por favor, tente novamente.',
            save: 'Falha ao save. Por favor, tente novamente.',
            fetch_escalation_log_failed: 'Falha ao fetch escalation log. Por favor, tente novamente.',
            fetch_activations_failed: 'Falha ao fetch activations. Por favor, tente novamente.',
            deactivate_failed: 'Falha ao deactivate. Por favor, tente novamente.',
            complete_activation_failed: 'Falha ao complete activation. Por favor, tente novamente.',
            fetch_playbook_templates_failed: 'Falha ao fetch playbook templates. Por favor, tente novamente.',
            create_playbook_template_failed: 'Falha ao create playbook template. Por favor, tente novamente.',
            clone_template_failed: 'Falha ao clone template. Por favor, tente novamente.',
            update_status_failed: 'Falha ao atualizar o estado. Por favor, tente novamente.',
            deprecate_template_failed: 'Falha ao deprecate template. Por favor, tente novamente.',
            seed_defaults_failed: 'Falha ao seed defaults. Por favor, tente novamente.',
            fetch_regulator_exports_failed: 'Falha ao fetch regulator exports. Por favor, tente novamente.',
            create_regulator_export_failed: 'Falha ao create regulator export. Por favor, tente novamente.',
            update_submission_status_failed: 'Falha ao update submission status. Por favor, tente novamente.',
            fetch_response_metrics_failed: 'Falha ao fetch response metrics. Por favor, tente novamente.',
            fetch_sla_dashboard_failed: 'Falha ao fetch sla dashboard. Por favor, tente novamente.',
            fetch_sla_definitions_failed: 'Falha ao fetch sla definitions. Por favor, tente novamente.',
            create_sla_definition_failed: 'Falha ao create sla definition. Por favor, tente novamente.',
            seed_sla_defaults_failed: 'Falha ao seed sla defaults. Por favor, tente novamente.',
            fetch_vendor_coordination_failed: 'Falha ao fetch vendor coordination. Por favor, tente novamente.',
            fetch_vendor_detail_failed: 'Falha ao fetch vendor detail. Por favor, tente novamente.',
            create_vendor_coordination_failed: 'Falha ao create vendor coordination. Por favor, tente novamente.',
            add_communication_failed: 'Falha ao add communication. Por favor, tente novamente.',
            add_info_request_failed: 'Falha ao add info request. Por favor, tente novamente.',
            add_action_request_failed: 'Falha ao add action request. Por favor, tente novamente.',
        },
        nav: {
            playbooks: 'Modelos de guia operacional',
            sla_definitions: 'Definições de SLA',
            sla_dashboard: 'Painel de SLA',
            escalation_log: 'Registo de escalamento',
            regulator_exports: 'Exportações regulatórias',
            deadlines: 'Prazos de notificação',
            vendor_coordination: 'Coordenação de fornecedores',
            metrics: 'Métricas de resposta',
            playbook_links: 'Ligações de Playbook',
            regulatory_sla: 'SLA regulamentar',
            coordination_dashboard: 'Coordenação',
            evidence_chain: 'Cadeia de provas',
            post_review: 'Revisão pós-incidente',
        },
        playbooks: {
            page_title: 'Modelos de manual',
            activations_page_title: 'Ativações do manual',
            title: 'Modelos de guia operacional',
            new: 'Novo modelo',
            seed_defaults: 'Predefinições iniciais',
            scenario_type: 'Tipo de cenário',
            severity_applicability: 'Aplicabilidade da gravidade',
            all_scenario_types: 'Todos os tipos de cenário',
            new_playbook: 'Novo Playbook Template',
            clone: 'Clonar',
            clone_template: 'Clonar Modelo',
            template_name: 'Nome do modelo',
            deprecate: 'Tornar obsoleto',
            confirm_deprecate: 'Tornar o modelo "{name}" obsoleto?',
            create_template: 'Adicionar modelo',
            update_status: 'Atualizar Estado',
            no_templates: 'Nenhum playbook templates encontrado',
            deactivation_reason_placeholder: 'Motivo de desativação...',
            description_placeholder: 'Descrição do livro de procedimentos...',
            name_placeholder: 'Nome do livro de procedimentos...',
        },
        sla_definitions: {
            page_title: 'Definições SLA',
            title: 'Definições de SLA',
            new: 'Novo SLA Definition',
            sla_name: 'SLA Nome',
            target_hours: 'Horas alvo',
            escalation_after: 'Escalado após',
            applies_to: 'Aplica-se a',
            no_definitions: 'Nenhum sla definitions encontrado',
            target_value_placeholder: 'Valor de destino',
            name_placeholder: 'Nome do SLA...',
            threshold_hours_label: 'Horas limiar',
            severity_label: 'Gravidade',
            all_types: 'Todos os tipos',
            all_severities: 'Todas as gravidades',
            default_label: 'Predefinido',
        },
        sla_dashboard: {
            compliant: 'Compatível',
            page_title: 'Painel SLA',
            title: 'Painel de SLA',
            loading: 'A carregar sla data...',
            compliance_rate: 'Conformidade Taxa',
            breached: 'Violado',
            at_risk: 'Em Risco',
            on_track: 'Em Rastrear',
            by_severity: 'Por Gravidade',
            total_records: 'Total de registos',
            met: 'Cumprido',
            sla_records: 'Registos SLA',
            sla_reference: 'Referência SLA',
            record_id: 'ID de registo',
            metric_type: 'Tipo de métrica',
            severity: 'Gravidade',
            elapsed: 'Decorrido',
            clock_start: 'Início do relógio',
        },
        escalation_log: {
            page_title: 'Registo de escalamento',
            title: 'Registo de escalamento',
            incident_id: 'Incidente ID',
            escalated_by: 'Escalado por',
            escalated_to: 'Escalado para',
            reason: 'Motivo',
            escalated_at: 'Escalado em',
            no_escalations: 'Nenhum escalations encontrado',
            filter_incident_id: 'Filtrar por Incidente ID',
            escalation_id: 'ID de escalamento',
            level: 'Nível',
            level_range: 'Nível (L1–L4)',
            create_escalation: 'Criar escalamento',
            incident_id_placeholder: 'p. ex. INC-001',
            target_role_placeholder: 'p. ex. dpo, incident_manager',
            select_placeholder: '— selecionar —',
        },
        regulator_exports: {
            page_title: 'Exportações regulatórias',
            title: 'Exportações regulatórias',
            new: 'Novo exportar',
            incident_id: 'Incidente ID',
            regulator: 'Regulador',
            export_format: 'Formato',
            exported_at: 'Exportado Em',
            no_exports: 'Nenhum regulator exports encontrado',
            enter_incident_id: 'Introduza incidente id',
            export_id: 'ID de exportação',
            watermark: 'Marca de água',
            submission_status: 'Estado de submissão',
            all_jurisdictions: 'Todas as jurisdições',
            no_transitions: 'Não há mais transições disponíveis de',
            select_new_status: '— selecionar novo estado —',
            sections_included: 'Secções incluídas',
            form_classification: 'Classificação',
            submission_channel: 'Canal',
        },
        deadlines: {
            title: 'Prazos de notificação',
            incident_id: 'Incidente ID',
            deadline: 'Prazo',
            regulator: 'Regulador',
            remaining: 'Restante',
            no_deadlines: 'Nenhum notification deadlines encontrado',
        },
        vendor_coordination: {
            page_title: 'Coordenação de fornecedores',
            title: 'Coordenação de fornecedores',
            new: 'Novo Coordination',
            incident_id: 'Incidente ID',
            vendor_name: 'Fornecedor Nome',
            contact: 'Contacto',
            coordination_status: 'Estado de coordenação',
            no_items: 'Nenhum vendor coordination items encontrado',
            assessment_placeholder: 'Avaliação inicial do fornecedor...',
            coordination_id: 'ID de coordenação',
            communications: 'Comunicações',
            info_requests: 'Solicitações de informações',
            action_requests: 'Solicitações de ação',
            direction: 'Direção',
            channel_label: 'Canal',
            no_transitions: 'Não há mais transições disponíveis.',
            vendor_ref_number: 'Número de referência',
            report_date: 'Data do relatório',
            contact_email: 'E-mail',
            contact_phone: 'Telefone',
            channel_email: 'E-mail',
            channel_meeting: 'Reunião',
            channel_phone: 'Telefone',
            channel_portal: 'Portal',
            incident_id_placeholder: 'Filtrar por Incidente ID...',
            priority_critical: 'Crítico',
            priority_high: 'Alto',
            priority_low: 'Low',
            priority_medium: 'Médio',
            vendor_id_placeholder: 'Filtrar por Fornecedor ID...',
            description_placeholder: 'Descrição...',
            filter_vendor_id: 'Filtrar por Fornecedor ID',
            inbound: 'Entrada',
            outbound: 'Saída',
            summary_placeholder: 'Resumo...',
            priority_label: 'Prioridade',
            due_date_label: 'Data de vencimento',
            info_request_desc: 'Descrição do pedido de informação',
            action_request_desc: 'Descrição da solicitação de ação',
            content_label: 'Conteúdo',
            select_incident: 'Selecionar Incidente',
            select_vendor: 'Selecionar Fornecedor',
            discovery_date: 'Data de descoberta',
        },
        metrics: {
            page_title: 'Métricas de resposta',
            title: 'Métricas de resposta',
            loading: 'A carregar metrics data...',
            avg_response_time: 'Avg Resposta Hora',
            avg_resolution_time: 'Tempo médio de resolução',
            total_incidents: 'Total Incidentes',
            by_severity: 'Por Gravidade',
            by_status: 'Por Estado',
            trend: 'Tendência',
            start_sla_clock: 'Iniciar relógio SLA',
            sla_records: '[[TOK_0]] Registros',
            no_sla_records: 'Ainda não há registos SLA.',
            record_id: 'ID do registro',
            severity: 'Gravidade',
            progress: 'Progresso',
            incident_id_required: 'O ID do incidente é obrigatório',
            sla_definition_required: 'A definição SLA é obrigatória',
            metric_type_required: 'O tipo de métrica é obrigatório',
            threshold_required: 'As horas limiar são obrigatórias',
            sla_clock_started: 'Relógio SLA iniciado',
            sla_definition: 'Definição SLA',
            no_definitions: 'Não foram encontradas definições SLA.',
            select_definition: 'Selecionar definição SLA...',
            select_metric_type: 'Selecionar tipo de métrica...',
            select_severity: 'Selecionar gravidade...',
            threshold_hours: 'Limiar (horas)',
            warning_threshold_pct: 'Limiar de aviso (%)',
            start_clock: 'Iniciar relógio',
            starting: 'A iniciar...',
            metric_label: 'Métrica',
            value_label: 'Valor',
            incident_id: 'ID do incidente',
            threshold_placeholder: 'ex. 24',
            metric_types: {
                triage_time: 'Tempo de triagem',
                containment_time: 'Tempo de contenção',
                notification_time: 'Tempo de notificação',
                resolution_time: 'Tempo de resolução',
            },
            severities: {
                critical: 'Crítico',
                high: 'Alto',
                medium: 'Médio',
                low: 'Low',
            },
        },
        playbook_links: {
            page_title: 'Ligações Playbook',
            title: 'Ligações de notificação de playbook',
            new_link: 'Ligar playbook a notificação',
            activation_id: 'ID de ativação',
            notification_id: 'ID de notificação',
            select_activation: 'Selecionar uma ativação...',
            select_notification: 'Selecionar uma notificação...',
            no_links: 'Nenhuma ligação de playbook encontrada',
            seed_pdpl: 'Inicializar playbooks PDPL',
            created: 'Ligação de playbook criada',
            seeded: 'Playbooks PDPL inicializados',
            create_failed: 'Falha ao criar a ligação de playbook',
            seed_failed: 'Falha ao inicializar os playbooks PDPL',
        },
        regulatory_sla: {
            page_title: 'Mapeamentos SLA regulatórios',
            title: 'Mapeamentos de SLA regulamentar',
            new_mapping: 'Novo mapeamento de SLA',
            sla_definition: 'Definição de SLA',
            select_sla_definition: 'Selecionar uma definição de SLA...',
            framework_code: 'Código do quadro',
            deadline_type: 'Tipo de prazo',
            deadline_hours: 'Horas de prazo',
            auto_escalate: 'Escalamento automático',
            seed_pdpl: 'Inicializar predefinições PDPL',
            no_mappings: 'Nenhum mapeamento de SLA regulamentar encontrado',
            dashboard: 'Painel de SLA regulamentar',
            deadline_types: {
                initial_notification: 'Notificação Inicial',
                supplement_response: 'Resposta ao Suplemento',
                authority_response: 'Resposta da autoridade',
                remediation_report: 'Relatório de correção',
            },
            statutory_reference: 'Referência Estatutária',
        },
        coordination_dashboard: {
            page_title: 'Painel de coordenação',
            title: 'Painel de coordenação',
            incident_id: 'ID de incidente',
            select_incident: 'Selecionar um incidente...',
            team_role: 'Função da equipa',
            members: 'Membros',
            tasks: 'Tarefas',
            sla_status: 'Estado de SLA',
            no_teams: 'Nenhuma equipa de coordenação encontrada',
            new_team: 'Nova equipa de coordenação',
            enter_incident_id: 'Introduza um ID de incidente para ver as equipas de coordenação.',
            member_ids_placeholder: 'usuário1, usuário2',
            edit_team: 'Editar equipa',
            task_count: 'Contagem de tarefas',
            tasks_completed: 'Concluído',
            team_roles: {
                security: 'Segurança',
                legal: 'Jurídico',
                it: 'IT',
                management: 'Gestão',
                department_owner: 'Responsável de departamento',
                external: 'Externo',
            },
        },
        evidence_chain: {
            page_title: 'Cadeia de evidências',
            title: 'Cadeia de custódia de provas',
            new_entry: 'Nova entrada de prova',
            select_incident: 'Selecionar um incidente...',
            actor: 'Ator',
            select_actor: 'Selecionar um ator...',
            evidence_id: 'ID de prova',
            action: 'Ação',
            recipient: 'Destinatário',
            no_entries: 'Nenhuma entrada de cadeia de provas encontrada',
            enter_incident_id: 'Introduza um ID de incidente para ver a cadeia de evidências.',
            evidence_id_placeholder: 'ex. EVD-2026-0001',
            evidence_id_help: 'Uma referência única para o item de evidência — um ficheiro de registo, uma imagem de disco ou uma captura de ecrã. Uma sugestão está preenchida; edite-a para corresponder ao seu catálogo de evidências.',
            select_incident_first: 'Selecione um incidente acima antes de adicionar uma entrada de evidência.',
            for_incident: 'Para o incidente',
            actions: {
                collected: 'Coletado',
                shared: 'Compartilhado',
                exported: 'Exportado',
                archived: 'Arquivado',
            },
        },
        post_review: {
            page_title: 'Revisão pós-incidente',
            title: 'Revisão pós-incidente',
            new_review: 'Nova revisão',
            select_incident: 'Selecionar um incidente...',
            lessons_learned: 'Lições aprendidas',
            recommendations: 'Recomendações',
            improvement_actions: 'Ações de melhoria',
            submit_for_review: 'Submeter para revisão',
            aria_submit_review: 'Submeter revisão {name} para revisão',
            aria_sign_off: 'Aprovar revisão {name}',
            sign_off: 'Aprovação',
            no_reviews: 'Nenhuma revisão pós-incidente encontrada',
            enter_incident_id: 'Introduza um ID de incidente para ver a revisão pós-incidente.',
            one_per_line: 'Um por linha',
            statuses: {
                draft: 'Rascunho',
                in_review: 'Em revisão',
                signed_off: 'Aprovado',
                closed: 'Encerrado',
            },
        },
        activations: {
            title: 'Ativações do manual',
            activation_id: 'ID de ativação',
            phases: 'Fases',
            activated_at: 'Ativado em',
            activated_by: 'Ativado por',
            deactivate: 'Desativar',
            complete: 'Concluir',
            deactivation_reason: 'Motivo de desativação',
            evidence_button: 'Evidência',
            evidence_modal_title: 'Evidência de ativação',
            no_evidence: 'Nenhuma evidência anexada a esta ativação.',
            upload_evidence_label: 'Carregar evidência de ativação',
        },
    },
    program_governance: {
        maturity_walkthrough: {
            run_label: 'Me guie pelas lacunas',
            running: 'Lacunas de caminhada…',
            results_heading: 'Roteiro de melhoria ([[TOK_2]] lacuna[[TOK_3]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            no_gaps: 'Nenhuma lacuna detectada – todos os domínios na meta ou acima dela.',
            col_priority: 'Prioridade',
            col_domain: 'Domínio',
            col_levels: 'Atual → Alvo',
            col_severity: 'Gravidade',
            col_actions: 'Ações de remediação',
            citations_label: 'Citações',
            accept_label: 'Aceitar roteiro',
            reject_label: 'Rejeitar rascunho',
            export_label: 'Exportar [[TOK_0]]',
            exported_label: 'Roteiro exportado',
            accept_hint: 'Aceitar registra o roteiro no rascunho persistente. Use Exportar [[TOK_0]] para gerar a entrega; o operador cola improvement_actions na avaliação.',
            resolve_summary: 'Resolução: [[TOK_1]]',
            error_generic: 'Não foi possível executar o passo a passo do gap. Tente novamente ou verifique o status da avaliação.',
        },
        policy_gap: {
            run_label: 'Detectar lacunas políticas',
            running: 'Detectando lacunas…',
            results_heading: 'Lacunas políticas ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            no_gaps: 'Não foram detectadas lacunas de cobertura.',
            col_severity: 'Gravidade',
            col_kind: 'Gentil',
            col_clause: 'Cláusula/requisito',
            kind_missing: 'Cláusula ausente',
            kind_weak: 'Cobertura fraca',
            kind_stale: 'Obsoleto (revisão atrasada)',
            remediation_label: 'Correção sugerida',
            citations_label: 'Citações',
            accept_label: 'Aceitar relatório de lacunas',
            reject_label: 'Rejeitar relatório',
            export_label: 'Exportar [[TOK_0]]',
            accept_hint: 'Aceitar registra o relatório de lacunas no rascunho persistente. Use Exportar [[TOK_0]] para gerar um Relatório de Auditoria de Política; o operador conduz a edição real da política.',
            resolve_summary: 'Resolução: [[TOK_1]]',
            error_generic: 'Não foi possível detectar lacunas políticas. Tente novamente ou verifique o status do documento.',
        },
        remediation_plan_generator: {
            run_label: 'Gerar plano a partir de lacunas',
            running: 'Gerando plano…',
            results_heading: 'Plano de remediação ([[TOK_2]] fase[[TOK_3]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            phase_label: 'Fase [[TOK_1]]',
            window_label: 'Janela',
            owner_label: 'Função de proprietário',
            evidence_label: 'Tipos de evidências necessários',
            tasks_label: 'Tarefas',
            no_phases: 'Nenhuma fase produzida - o conjunto de lacunas de entrada pode estar vazio.',
            citations_label: 'Citações',
            accept_label: 'Aceitar plano',
            reject_label: 'Rejeitar plano',
            export_label: 'Exportar [[TOK_0]]',
            accept_hint: 'Aceitar cria tarefas de fase vinculadas ao registro do plano. Use Exportar [[TOK_0]] para a entrega completa. Os espaços reservados para a função de proprietário precisam de acompanhamento do operador.',
            resolve_summary: 'Resolução: [[TOK_2]] · [[TOK_3]] tarefa(s) criada(s)',
            error_generic: 'Não foi possível gerar o plano de correção. Tente novamente ou verifique a entrada do conjunto de lacunas.',
            source_picker_label: 'Fonte',
            source_all: 'Todos',
            source_consent: 'Análise de lacuna de consentimento',
            source_policy: 'Detecção de lacunas políticas',
            source_vendor: 'Integração do fornecedor',
            load_upstream_label: 'Carregar do upstream',
            loading_upstream: 'Carregando…',
            upstream_count: '[[TOK_1]] lacuna(s) carregada(s)',
        },
        nav: {
            maturity_models: 'Modelos de maturidade',
            maturity_assessments: 'Avaliações de maturidade',
            trend_dashboard: 'Painel de tendências',
            reporting_periods: 'Períodos de relatório',
            executive_summaries: 'Resumos executivos',
            audit_readiness: 'Preparação para auditoria',
            evidence_gaps: 'Lacunas de evidência',
            program_health: 'Estado do programa',
            obligation_mappings: 'Mapeamentos de obrigações',
            governance_documents: 'Documentos de governança',
            remediation_plans: 'Planos de remediação',
            governance_model: 'Modelo de governança',
            document_drafting: 'Elaboração de documentos',
            document_issuance: 'Emissão de documentos',
            acknowledgment_tracking: 'Rastreamento de confirmações',
            change_log: 'Registro de alterações',
            review_cadence: 'Cadência de revisão',
        },
        maturity_models: {
            title: 'Modelos de maturidade',
            new: 'Novo Model',
            seed_defaults: 'Predefinições iniciais',
            domains: 'Domínios',
            activate: 'Ativar',
            no_models: 'Nenhum maturity models encontrado',
            new_maturity_model: 'Novo Maturity Model',
            create_model: 'Adicionar Model',
            load_error: 'Falha ao carregar modelos de maturidade. Tente novamente.',
            create_error: 'Falha ao criar modelo de maturidade',
            status_error: 'Falha ao atualizar status do modelo',
            seed_error: 'Falha ao gerar valores padrão',
            aria_seed_defaults: 'Gerar modelos de maturidade padrão',
            aria_create_new: 'Criar novo modelo de maturidade',
            loading_sr: 'Carregando modelos de maturidade',
            model_name_placeholder: 'ex., Modelo de maturidade de privacidade',
            status_changed: 'Status do modelo alterado para {status}',
        },
        maturity_assessments: {
            title: 'Avaliações de maturidade',
            new: 'Novo avaliação',
            model: 'Modelo',
            assessor: 'Avaliador',
            overall_score: 'Pontuação geral',
            overall_score_help: 'Uma classificação de maturidade ponderada de 0 a 5, calculada automaticamente quando uma avaliação é finalizada. Aumente-a atribuindo uma pontuação mais alta a cada domínio durante a avaliação e, em seguida, levando a avaliação através de Enviar para revisão → Finalizar.',
            assessed_at: 'Avaliado em',
            no_assessments: 'Nenhum maturity assessments encontrado',
            load_error: 'Falha ao carregar avaliações de maturidade. Tente novamente.',
            create_error: 'Falha ao criar avaliação',
            start_error: 'Falha ao iniciar avaliação',
            archive_error: 'Falha ao arquivar avaliação',
            eval_error: 'Falha ao carregar avaliação para avaliação',
            eval_min_score: 'Avalie pelo menos um domínio',
            eval_save_error: 'Falha ao salvar avaliações de domínio',
            review_error: 'Falha ao enviar para revisão',
            finalize_error: 'Falha ao finalizar avaliação',
            start: 'Iniciar',
            start_confirm_title: 'Iniciar avaliação',
            start_confirm_message: 'Tem certeza de que deseja iniciar esta avaliação?',
            archive_confirm_title: 'Arquivar avaliação',
            archive_confirm_message: 'Tem certeza de que deseja arquivar esta avaliação?',
            evaluate_domains: 'Avaliar',
            evaluate_domains_title: 'Avaliar domínios',
            submit_for_review: 'Enviar para revisão',
            finalize: 'Finalizar',
            archive: 'Arquivar',
            all_reviewers: 'Todos os revisores devem aprovar',
            any_reviewer: 'Qualquer revisor pode aprovar',
            select_level: 'Selecionar nível de maturidade...',
            findings_placeholder: 'Descobertas, notas, referências de evidências...',
            no_domains: 'Nenhum domínio encontrado para este modelo.',
        },
        trend_dashboard: {
            title: 'Painel de tendências',
            loading: 'A carregar trend data...',
            score_trend: 'Tendência de pontuação',
            domain_comparison: 'Comparação de domínios',
            period: 'Período',
            load_error: 'Falha ao carregar resumo de tendência. Tente novamente.',
            metrics_load_error: 'Falha ao carregar métricas de tendência. Tente novamente.',
            module: 'Módulo',
            metric: 'Métrica',
            value: 'Valor',
            trend: 'Tendência',
            aria_filters: 'Filtros de métricas de tendência',
            showing_chart: 'Exibindo vista de gráfico',
            showing_table: 'Exibindo vista de tabela',
        },
        reporting_periods: {
            title: 'Períodos de relatório',
            new: 'Novo período',
            period_name: 'Período Nome',
            start_date: 'Início Data',
            end_date: 'Fim Data',
            no_periods: 'Nenhum reporting periods encontrado',
            load_error: 'Falha ao carregar períodos de relatório. Tente novamente.',
            create_error: 'Falha ao criar período de relatório',
            auto_generate_error: 'Falha ao gerar automaticamente períodos',
            status_error: 'Falha ao atualizar status do período',
            start_collecting: 'Iniciar coleta',
            mark_as_draft: 'Marcar como rascunho',
            submit_for_review: 'Enviar para revisão',
            publish: 'Publicar',
            auto_generate: 'Gerar automaticamente períodos',
            period_label_placeholder: 'ex., T1 2026',
            status_updated: 'Status do período atualizado',
        },
        executive_summaries: {
            title: 'Resumos executivos',
            new: 'Novo resumo',
            period: 'Período',
            generated_at: 'Gerado em',
            generated_by: 'Gerado por',
            no_summaries: 'Nenhum executive summaries encontrado',
            generate: 'Gerar',
            load_error: 'Falha ao carregar resumos executivos. Tente novamente.',
            generate_error: 'Falha ao gerar resumo executivo',
            save_error: 'Falha ao salvar resumo executivo',
        },
        audit_readiness: {
            title: 'Preparação para auditoria',
            loading: 'A carregar audit readiness data...',
            overall_readiness: 'Preparação geral',
            by_domain: 'Por Domínio',
            evidence_coverage: 'Cobertura de evidências',
            gaps: 'Lacunas',
            load_error: 'Falha ao carregar última prontidão. Tente novamente.',
            history_error: 'Falha ao carregar histórico de prontidão. Tente novamente.',
            calculate_error: 'Falha ao calcular prontidão de auditoria',
            aria_recalculate: 'Recalcular pontuação de prontidão',
            aria_current_readiness: 'Prontidão atual de auditoria',
            aria_history: 'Histórico de pontuação de prontidão',
            recalculated: 'Prontidão de auditoria recalculada',
            loading_sr: 'Carregando dados de prontidão',
        },
        evidence_gaps: {
            title: 'Lacunas de evidência',
            domain: 'Domínio',
            control: 'Controlo',
            gap_type: 'Tipo de lacuna',
            severity: 'Gravidade',
            no_gaps: 'Nenhum evidence gaps encontrado',
            load_error: 'Falha ao carregar lacunas de evidência. Tente novamente.',
            stats_error: 'Falha ao carregar estatísticas. Tente novamente.',
            create_error: 'Falha ao criar lacuna de evidência',
            update_error: 'Falha ao atualizar lacuna',
            status_error: 'Falha ao atualizar status',
            aria_create_new: 'Criar nova lacuna de evidência',
            aria_statistics: 'Estatísticas de lacunas',
            loading_sr: 'Carregando lacunas',
            status_updated: 'Status da lacuna atualizado',
            entity_type_placeholder: 'ex., fornecedor, sistema',
            all_modules: 'Todos os domínios',
            all_severities: 'Todas as gravidades',
        },
        program_health: {
            title: 'Estado do programa',
            loading: 'A carregar program health data...',
            overall_health: 'Saúde geral',
            by_module: 'Por módulo',
            risk_areas: 'Áreas de risco',
            recommendations: 'Recomendações',
            load_error: 'Falha ao carregar dados de saúde do programa. Tente novamente.',
            aria_key_metrics: 'Métricas-chave de saúde do programa',
            aria_module_scorecard: 'Detalhamento do scorecard do módulo',
            loading_sr: 'Carregando dados de saúde do programa',
            trending_up: 'Tendência de alta',
            trending_down: 'Tendência de queda',
            trending_stable: 'Estável',
            data_loaded: 'Dados de saúde do programa carregados',
        },
        obligation_mappings: {
            title: 'Mapeamentos de obrigações',
            create_mapping: 'Criar mapeamento de obrigação',
            framework: 'Quadro regulamentar',
            select_framework: 'Selecionar um quadro...',
            obligation: 'Obrigação',
            obligation_ref: 'Referência de obrigação',
            obligation_description: 'Descrição da obrigação',
            role: 'Papel',
            assigned_role: 'Papel atribuído',
            assigned_department: 'Departamento atribuído',
            select_department: 'Selecionar um departamento...',
            control_ids: 'IDs de controlo',
            raci_assignments: 'Atribuições RACI',
            create_raci: 'Criar atribuição RACI',
            activity: 'Atividade',
            activity_name: 'Nome da atividade',
            activity_description: 'Descrição da atividade',
            responsible: 'Responsável',
            select_users: 'Selecionar utilizadores...',
            accountable: 'Prestador de contas',
            select_user: 'Selecionar um utilizador...',
            consulted: 'Consultado',
            informed: 'Informado',
            review_frequency: 'Frequência de revisão',
            frequency_monthly: 'Mensal',
            frequency_quarterly: 'Trimestral',
            frequency_semi_annual: 'Semestral',
            frequency_annual: 'Anual',
            no_mappings_found: 'Nenhum mapeamento de obrigações encontrado.',
            no_raci_found: 'Nenhuma atribuição RACI encontrada.',
            mapping_created: 'Mapeamento de obrigação criado',
            mapping_updated: 'Mapeamento de obrigação atualizado',
            mapping_deleted: 'Mapeamento de obrigação eliminado',
            raci_created: 'Atribuição RACI criada',
            raci_updated: 'Atribuição RACI atualizada',
            raci_deleted: 'Atribuição RACI eliminada',
            aria_edit_mapping: 'Editar mapeamento {name}',
            aria_delete_mapping: 'Eliminar mapeamento {name}',
            aria_edit_raci: 'Editar RACI {name}',
            aria_delete_raci: 'Eliminar RACI {name}',
            confirm_delete_mapping: 'Eliminar este mapeamento de obrigação?',
            confirm_delete_raci: 'Eliminar esta atribuição RACI?',
            table_view: 'Vista de tabela',
            matrix_view: 'Vista de matriz',
            print_export: 'Imprimir / Exportar',
            filter_framework: 'Filtrar por framework',
            no_matrix_data: 'Nenhuma atribuição RACI para exibir na vista de matriz.',
            aria_print_export: 'Imprimir ou exportar a matriz RACI',
        },
        governance_documents: {
            title: 'Documentos de governança',
            create_document: 'Criar documento de governança',
            document_title: 'Título do documento',
            document_type: 'Tipo de documento',
            content_url: 'URL do conteúdo',
            content_url_placeholder: 'https://...',
            framework_codes: 'Códigos de quadro',
            select_frameworks: 'Selecionar quadros...',
            effective_date: 'Data de vigência',
            review_date: 'Data de revisão',
            status: 'Estado',
            version: 'Versão',
            acknowledgments: 'Confirmações',
            acknowledge: 'Confirmar',
            acknowledged_by: 'Confirmado por',
            department: 'Departamento',
            no_documents_found: 'Nenhum documento de governança encontrado.',
            draft: 'Rascunho',
            review: 'Revisão',
            approved: 'Aprovado',
            issued: 'Emitido',
            superseded: 'Substituído',
            document_created: 'Documento criado',
            document_acknowledged: 'Documento reconhecido',
            policy: 'Política',
            procedure: 'Procedimento',
            standard: 'Padrão',
            guideline: 'Diretriz',
        },
        governance_model: {
            title: 'Modelo de governança',
            create_model: 'Modelo de governança',
            edit_model: 'Modelo de governança',
            model_name: 'Model',
            description: 'Descrição',
            governance_type: 'Type',
            type_centralized: 'Centralizado',
            type_federated: 'Federado',
            type_hybrid: 'Híbrido',
            framework_codes: 'Framework',
            select_frameworks: '...',
            review_frequency: 'Frequency',
            freq_monthly: 'Mensalmente',
            freq_quarterly: 'Trimestralmente',
            freq_semi_annual: 'Semestral',
            freq_annual: 'Anual',
            committees: 'Comitês',
            committee_name: 'Name',
            committee_members: 'Members',
            committee_mandate: 'Mandato',
            add_committee: '+',
            no_committees: '—',
            delegation_rules: 'Delegation',
            from_role: 'From',
            to_role: 'To',
            scope: 'Escopo',
            add_delegation_rule: '+',
            control_owner_summary: 'RACI',
            no_raci_data: '—',
            activity: 'Atividade',
            responsible: 'R',
            accountable: 'A',
            consulted: 'C',
            informed: 'I',
            no_models_found: '—',
            model_created: 'OK',
            model_updated: 'OK',
            model_deleted: 'OK',
            confirm_delete: '?',
            expand: '+',
            collapse: '-',
            aria_expand: '{name}',
            aria_edit: '{name}',
            aria_delete: '{name}',
            aria_export_csv: '{name} CSV',
            aria_export_json: '{name} JSON',
            framework_read_permission_warning: 'Você precisa da permissão regulatory_framework:read para selecionar estruturas. Peça a um administrador para concedê-lo.',
            select_members: 'Selecione os membros do comitê',
            select_from_role: 'Selecione a função de delegação',
            select_to_role: 'Selecione a função de recebimento',
            mandate_markdown_hint: 'Markdown suportado: **negrito**, listas, links.',
            scope_tab_obligation: 'Obrigação',
            scope_tab_framework: 'Estrutura',
            scope_tab_free_text: 'Texto livre',
            select_obligation: 'Selecione uma obrigação',
            select_framework: 'Selecione uma estrutura',
            aria_remove_committee: 'Remover comité {n}',
            aria_remove_delegation_rule: 'Remover regra de delegação {n}',
            no_frameworks_available: 'Nenhum quadro disponível. Adicione primeiro quadros regulatórios.',
        },
        document_drafting: {
            title: 'Elaboração de documentos',
            document_title: 'Document',
            document_type: 'Type',
            status: 'Estado',
            drafter: 'Desenhador',
            deadline: 'Prazo',
            assign_drafter: 'Assign',
            select_drafter: '...',
            assign: 'Atribuir',
            submit_for_review: 'Submit',
            legal_review: 'Review',
            reviewer: 'Revisor',
            select_reviewer: '...',
            comments: 'Comentários',
            review_action: 'Action',
            approve: 'Aprovar',
            request_changes: 'Solicitar alterações',
            submit_review: 'Submit',
            executive_approval: 'Approval',
            no_drafts_found: '—',
            drafter_assigned: 'OK',
            status_updated: 'OK',
            review_approved: 'OK',
            changes_requested: 'OK',
            document_approved: 'OK',
            aria_assign: '{name}',
            aria_submit_review: '{name}',
            aria_review: '{name}',
            aria_approve: '{name}',
        },
        document_issuance: {
            title: 'Emissão de documentos',
            document_title: 'Document',
            document_type: 'Type',
            status: 'Estado',
            version: 'Versão',
            effective_date: 'Date',
            distribution_scope: 'Distribution',
            distribution_placeholder: '...',
            issuance_number: 'Number',
            issuance_number_placeholder: 'ISS-2026-001',
            supersedes: 'Supersedes',
            none: '—',
            issue_document: 'Issue',
            ready_for_issuance: 'Ready',
            issued_documents: 'Issued',
            no_issued_documents: '—',
            view_lineage: 'Lineage',
            supersession_lineage: 'Supersession',
            document_issued: 'OK',
            document_superseded: 'OK',
            aria_issue: '{name}',
            aria_view_lineage: '{name}',
        },
        acknowledgment_tracking: {
            title: 'Rastreamento de confirmações',
            document_title: 'Documento',
            acknowledged_count: 'Reconhecido',
            pending_count: 'Pendente',
            percentage: '%',
            details: 'Detalhes',
            send_reminder: 'Remind',
            acknowledgment_details: 'Details',
            user: 'Usuário',
            department: 'Departamento',
            acknowledged_at: 'Date',
            status: 'Estado',
            acknowledged: 'OK',
            no_issued_documents: '—',
            no_acknowledgments: '—',
            reminder_sent: 'OK',
            aria_expand: '{name}',
            aria_send_reminder: '{name}',
        },
        change_log: {
            title: 'Registro de alterações',
            date: 'Data',
            document: 'Documento',
            change_type: 'Type',
            actor: 'Ator',
            summary: 'Resumo',
            export_csv: 'Exportar [[TOK_0]]',
            filters: 'Filters',
            filter_document: 'Document',
            all_documents: 'All',
            filter_change_type: 'Type',
            all_types: 'All',
            date_from: 'From',
            date_to: 'To',
            version_history: 'History',
            version_archive: 'Archive',
            no_entries: '—',
            no_history: '—',
            exported: 'OK',
            aria_export: 'CSV',
            aria_view_history: '{name}',
        },
        review_cadence: {
            title: 'Cadência de revisão',
            configure_cadence: 'Cadência de revisão',
            edit_cadence: 'Cadência de revisão',
            document: 'Documento',
            select_document: '...',
            review_frequency: 'Frequency',
            freq_30: '30',
            freq_60: '60',
            freq_90: '90',
            freq_180: '180',
            freq_365: '365',
            last_reviewed: 'Last',
            next_review: 'Next',
            status: 'Estado',
            overdue: 'Atrasado',
            on_track: 'OK',
            days: 'days',
            horizon: 'Horizon',
            overdue_warning: 'Overdue',
            overdue_count: '{count}',
            no_cadences: '—',
            cadence_created: 'OK',
            cadence_updated: 'OK',
            aria_edit: '{name}',
        },
        remediation_plans: {
            title: 'Planos de remediação',
            create_plan: 'Criar plano de remediação',
            gap_id: 'Referência de lacuna',
            select_gap: 'Selecionar uma lacuna...',
            plan_title: 'Título',
            description: 'Descrição',
            priority: 'Prioridade',
            priority_critical: 'Crítica',
            priority_high: 'Alta',
            priority_medium: 'Média',
            priority_low: 'Baixa',
            assigned_to: 'Atribuído a',
            select_user: 'Selecionar um utilizador...',
            target_date: 'Data alvo',
            framework_code: 'Quadro',
            select_framework: 'Selecionar um quadro...',
            gap_finding: 'Constatação de lacuna',
            action_items: 'Itens de ação',
            owner: 'Proprietário',
            deadline: 'Prazo',
            planned: 'Planeado',
            in_progress: 'Em curso',
            completed: 'Concluído',
            verified: 'Verificado',
            no_plans_found: 'Nenhum plano de remediação encontrado.',
            evidence: 'Evidência',
            plan_created: 'Plano de remediação criado',
            action_items_hint: 'Itens de ação (um por linha)',
        },
        statuses: {
            identified: 'Identificado',
            assigned: 'Atribuído',
            in_remediation: 'Em Remediação',
            resolved: 'Resolvido',
            accepted_risk: 'Risco Aceito',
            planned: 'Planejado',
            in_progress: 'Em andamento',
            under_review: 'Em revisão',
            finalized: 'Finalizado',
            archived: 'Arquivado',
            draft: 'Rascunho',
            active: 'Ativo',
            upcoming: 'Próximos',
            collecting: 'Coletando',
            published: 'Publicado',
            review: 'Revisão',
            approved: 'Aprovado',
            issued: 'Emitido',
            superseded: 'Substituído',
            completed: 'Concluído',
            verified: 'Verificado',
        },
        severities: {
            critical: 'Crítico',
            high: 'Alto',
            medium: 'Médio',
            low: 'Low',
        },
        priorities: {
            critical: 'Crítico',
            high: 'Alto',
            medium: 'Médio',
            low: 'Low',
        },
        gap_types: {
            missing: 'Desaparecido',
            expired: 'Expirado',
            insufficient: 'Insuficiente',
        },
        document_types: {
            policy: 'Política',
            procedure: 'Procedimento',
            standard: 'Padrão',
            guideline: 'Diretriz',
            template: 'Modelo (interno)',
        },
        maturity_levels: {
            level_1: 'Nível 1 – Inicial',
            level_2: 'Nível 2 – Desenvolvimento',
            level_3: 'Nível 3 – Definido',
            level_4: 'Nível 4 – Gerenciado',
            level_5: 'Nível 5 – Otimizando',
        },
        grades: {
            excellent: 'Excelente',
            good: 'Bom',
            fair: 'Justo',
            poor: 'Pobre',
            critical: 'Crítico',
            needs_improvement: 'Precisa de melhorias',
            not_assessed: 'Não avaliado',
        },
        modules: {
            data_mapping: 'Mapeamento de dados',
            consent: 'Consentimento',
            governance: 'Governança',
            incidents: 'Incidentes',
            monitoring: 'Monitoramento',
            classification: 'Classificação',
            vendor_risk: 'Risco de fornecedores',
            discovery: 'Descoberta',
            deletion: 'Exclusão',
        },
        cadences: {
            monthly: 'Mensalmente',
            quarterly: 'Trimestralmente',
            semi_annual: 'Semestral',
            annual: 'Anual',
        },
        section_labels: {
            opening: 'Abertura',
            key_metrics: 'Métricas-chave',
            highlights: 'Destaques',
            concerns: 'Preocupações',
            recommendations: 'Recomendações',
            outlook: 'Perspectivas',
        },
        out_of_100: '/ 100',
        count_gaps: '[[TOK_1]] lacuna',
        count_gaps_plural: '[[TOK_1]] lacunas',
        count_summaries: '[[TOK_1]] resumo',
        count_summaries_plural: '[[TOK_1]] resumos',
        count_assessments: 'Avaliação [[TOK_1]]',
        count_assessments_plural: '[[TOK_1]] avaliações',
        count_models: 'Modelo [[TOK_1]]',
        count_models_plural: '[[TOK_1]] modelos',
        count_periods: 'Período [[TOK_1]]',
        count_periods_plural: '[[TOK_1]] períodos',
        count_metrics: 'Métrica [[TOK_1]]',
        count_metrics_plural: '[[TOK_1]] métricas',
        unknown_user: 'Usuário desconhecido',
        unknown_gap: 'Lacuna desconhecida',
        no_permission_title: 'Permissões insuficientes',
        no_permission_message: 'Você não tem permissão para acessar esta página.',
        ac_vn_frameworks_title: 'Cobertura da estrutura VN',
        ac_vn_frameworks_body: 'As avaliações de maturidade abrangem todos os 6 quadros regulamentares vietnamitas: [[TOK_0]], Lei de Dados, Lei de Telecomunicações, Lei de Segurança Cibernética, Lei [[TOK_1]] e Lei de Comércio Eletrónico — cada uma com critérios de avaliação específicos do quadro.',
        ac_controller_processor_title: 'Controlador vs. Processador',
        ac_controller_processor_body: 'Os mapeamentos de obrigações distinguem entre as responsabilidades do controlador de dados e do processador de dados. Atribua funções usando a matriz RACI para garantir que cada obrigação tenha um proprietário claro, quer a organização atue como controladora ou processadora.',
        ac_versioned_evidence_title: 'Trilha de evidências versionadas',
        ac_versioned_evidence_body: 'Cada transição de status (Rascunho, Revisão, Aprovado, Emitido) cria um registro com carimbo de data/hora e versão que serve como evidência auditável. O Log de alterações captura o histórico completo do ciclo de vida do documento.',
        ac_remediation_gap_link_title: 'Vinculado a lacunas de avaliação',
        ac_remediation_gap_link_body: 'Cada plano de remediação está diretamente ligado a uma lacuna de avaliação identificada. Atribua um proprietário e defina um prazo para acompanhar o progresso da resolução desde a lacuna até o fechamento.',
        ac_annual_attestation_title: 'Ciclo Anual de Certificação',
        ac_annual_attestation_body: 'Os períodos de relatório estão alinhados com o requisito de certificação anual da Lei de Dados Vietnamita. Use a cadência "Anual" (ciclo de 365 dias) para gerar automaticamente períodos alinhados ao atestado.',
        ac_evidence_per_obligation_title: 'Evidência por obrigação estrutural',
        ac_evidence_per_obligation_body: 'As lacunas nas evidências identificam provas faltantes, expiradas ou insuficientes para cada obrigação-quadro. Filtre por domínio para ver quais requisitos regulatórios não possuem evidências de apoio.',
        ac_cross_framework_title: 'Completude entre estruturas',
        ac_cross_framework_body: 'A preparação para auditoria fornece uma visão de integridade entre estruturas. As pontuações dos componentes refletem a cobertura de todas as estruturas mapeadas, destacando áreas que precisam de atenção antes de uma auditoria.',
        ac_cadence_default_title: 'Cadência de revisão padrão',
        ac_cadence_default_body: 'A cadência de revisão padrão é de 180 dias. As revisões atrasadas são sinalizadas automaticamente. Ajuste a frequência por documento conforme necessário — as opções variam de 30 a 365 dias.',
        ac_templates_internal_title: 'Classificação do modelo',
        ac_templates_internal_body: 'Os modelos são classificados como documentos internos. Utilize o tipo de documento "Modelo" para marcar artefactos de governação reutilizáveis ​​com âmbito de distribuição apenas interno.',
    },
    mcp_pending: {
        title: 'MCP — Escritas pendentes',
        subtitle: 'Os clientes Claude externos propõem escritas aqui. Aprove ou recuse cada entrada — o Forseti só executa após autorização do administrador.',
        no_pending: 'Sem escritas pendentes.',
        col_tool: 'Ferramenta',
        col_preview: 'Pré-visualização',
        col_key: 'Chave [[TOK_0]]',
        col_requested: 'Solicitada',
        col_expires: 'Expira',
        col_status: 'Estado',
        status_pending: 'Pendente',
        status_approved: 'Aprovada',
        status_declined: 'Recusada',
        status_expired: 'Expirada',
        status_executed: 'Executada',
        approve_label: 'Aprovar',
        decline_label: 'Recusar',
        refresh_label: 'Atualizar',
        error_generic: 'Não foi possível carregar as escritas pendentes.',
        confirm_approve: 'Aprovar irá executar a ferramenta na sua organização com as permissões resolvidas do titular da API key. Continuar?',
        confirm_decline: 'Recusar esta escrita pendente? Esta ação não pode ser anulada.',
        advisory_banner: 'As escritas pendentes expiram 24 horas após a criação. A varredura GC horária recusa automaticamente as entradas expiradas.',
    },
    audit_walkthrough: {
        title: 'Forseti — Gerador de roteiro de auditoria',
        subtitle: 'Gere um roteiro estruturado para o arranque de uma auditoria: pergunta inicial por controlo, evidências esperadas, perguntas de seguimento, possíveis lacunas.',
        audit_picker_label: 'Auditoria',
        audit_picker_hint: 'Escolha uma auditoria planeada para gerar um roteiro.',
        run_label: 'Gerar roteiro',
        running: 'A gerar…',
        results_heading: 'Roteiro — {count} controlo(s)',
        tokens_label: '≈ [[TOK_1]] tokens',
        no_controls: 'Sem controlos no âmbito. Adicione controlos ao registo de auditoria.',
        col_control: 'Controlo',
        col_question: 'Pergunta inicial',
        col_evidence: 'Evidência',
        col_gaps: 'Possíveis lacunas',
        expected_evidence_label: 'Evidência esperada',
        followup_probes_label: 'Perguntas de seguimento',
        accept_label: 'Aceitar roteiro',
        reject_label: 'Rejeitar',
        export_label: 'Exportar DOCX',
        resolve_summary: 'Resolução: {status}',
        error_generic: 'Não foi possível gerar o roteiro. Tente novamente ou verifique o estado da auditoria.',
    },
    privilege_creep: {
        title: 'Forseti — Deteção de acumulação de privilégios',
        subtitle: 'Verificação periódica das atribuições de papéis. Os achados são consultivos — o Forseti nunca revoga automaticamente.',
        run_label: 'Verificar agora',
        running: 'A verificar…',
        findings_heading: '{count} achado(s)',
        no_findings: 'Sem acumulação de privilégios sinalizada.',
        col_user: 'Utilizador',
        col_job_function: 'Função',
        col_severity: 'Gravidade',
        col_unexpected: 'Permissões inesperadas',
        col_remediation: 'Remediação sugerida',
        col_status: 'Estado',
        severity_critical: 'Crítica',
        severity_high: 'Alta',
        severity_medium: 'Média',
        severity_low: 'Baixa',
        status_open: 'Aberto',
        status_dismissed: 'Descartado',
        status_remediated: 'Remediado',
        dismiss_label: 'Descartar',
        remediate_label: 'Marcar como remediado',
        note_label: 'Nota (opcional)',
        error_generic: 'Não foi possível verificar a acumulação de privilégios. Tente mais tarde.',
        advisory_banner: 'Estes achados são consultivos. O Forseti nunca revoga permissões automaticamente — analise com o proprietário do papel antes de agir.',
    },
    compliance_rules: {
        rule_mapping: {
            title: 'Mapeamento automático de regras de conformidade',
            subtitle: 'Forseti percorre um pacote regulatório instalado e sugere regras de conformidade novas ou atualizadas com base nos artigos originais.',
            pack_picker_label: 'Pacote regulatório',
            pack_picker_hint: 'Selecione um pacote instalado para mapear.',
            run_label: 'Mapa do pacote',
            running: 'Mapeamento…',
            results_heading: '[[TOK_1]] sugestões',
            tokens_label: '≈ [[TOK_1]] tokens do seu balde mensal',
            no_suggestions: 'Sem sugestões — o conteúdo do pacote pode já estar totalmente coberto pelas regras existentes.',
            kind_new: 'Nova regra',
            kind_refresh: 'Atualizar existente',
            kind_no_change: 'Nenhuma alteração necessária',
            col_kind: 'Gentil',
            col_title: 'Título proposto',
            col_existing: 'Regra existente',
            col_source: 'Fonte',
            proposed_body_label: 'Corpo proposto',
            source_quote_label: 'Citação da fonte',
            accept_selected: 'Aceitar selecionado',
            reject_all: 'Rejeitar tudo',
            accept_all: 'Aceitar tudo',
            resolve_summary: 'Resolução: [[TOK_2]] · [[TOK_3]] regra(s) criada(s)',
            error_generic: 'Não foi possível executar o mapeamento de regras. Tente novamente ou verifique o código do pacote.',
        },
    },
    access_accountability: {
        nav: {
            session_dashboard: 'Painel de sessão',
            access_log: 'Registo de acessos',
            justification_review: 'Revisão de justificações',
            investigations: 'Investigações',
            pattern_analysis: 'Análise de padrões',
            anchoring_status: 'Estado de ancoragem',
            configuration: 'Configuração',
            access_policies: 'Políticas de acesso',
            review_campaigns: 'Campanhas de revisão',
            evidence_packages: 'Pacotes de evidência',
        },
        session_dashboard: {
            title: 'Painel de sessão',
            loading: 'A carregar dashboard data...',
            total_sessions: 'Total de sessões',
            active_sessions: 'Sessões ativas',
            avg_duration: 'Duração média',
            concurrent_peak: 'Pico simultâneo',
            auth_method_breakdown: 'Discriminação de métodos de autenticação',
            geo_country_breakdown: 'Discriminação por país',
            recent_session_events: 'Recente Sessão Eventos',
            user_id: 'Utilizador ID',
            session_id: 'Sessão ID',
            ip_address: 'IP Endereço',
            auth_method: 'Método de autenticação',
            started_at: 'Iniciado Em',
            event_type: 'Evento Tipo',
            all_event_types: 'Todos Evento Types',
            filter_by_user: 'Filtrar por Utilizador ID...',
            no_active_sessions: 'Sem sessões ativas',
            no_session_events: 'Nenhum session events encontrado',
            revoke: 'Revogar',
            revoke_session: 'Revogar sessão',
            revoke_reason: 'Motivo',
            revoke_placeholder: 'Forneça um motivo para revogar esta sessão...',
            session_label: 'Sessão:',
            load_failed: 'Falha ao load session dashboard. Por favor, tente novamente.',
            events_load_failed: 'Falha ao load session events. Por favor, tente novamente.',
            revoke_failed: 'Falha ao revoke session. Por favor, tente novamente.',
            session_events_loaded: '{n} session events carregados',
            event_types: {
                session_created: 'Sessão criada',
                session_refreshed: 'Sessão atualizada',
                session_expired: 'Sessão expirada',
                session_revoked: 'Sessão revogada',
                session_terminated: 'Sessão encerrada',
                login_success: 'Sucesso de login',
                login_failure: 'Falha de login',
                logout: 'Sair',
                token_refresh: 'Atualização de token',
                mfa_challenge: 'Desafio MFA',
            },
        },
        access_log: {
            title: 'Registo de acessos',
            user_id: 'Utilizador ID',
            resource: 'Recurso',
            action: 'Ação',
            ip_address: 'IP Endereço',
            timestamp: 'Marca temporal',
            no_logs: 'Nenhum access log entries encontrado',
            filter_by_user: 'Filtrar por Utilizador ID...',
            load_failed: 'Falha ao load access log. Por favor, tente novamente.',
            export_success: 'Exportar initiated com sucesso',
            export_failed: 'Falha ao export access log. Por favor, tente novamente.',
            record_count: 'registo',
            record_count_plural: 'registos',
            unclassified: 'Não classificado',
            classification_missing: 'Classificação ausente',
            response_code: 'Codigo de resposta',
            classification_levels: {
                public: 'Público',
                internal: 'Interno',
                confidential: 'Confidencial',
                restricted: 'Restrito',
                unclassified: 'Não classificado',
            },
        },
        justification_review: {
            title: 'Revisão de justificações',
            user_id: 'Utilizador ID',
            resource: 'Recurso',
            justification: 'Justificação',
            submitted_at: 'Submetido em',
            reviewer: 'Revisor',
            no_reviews: 'Nenhum justification reviews encontrado',
            load_failed: 'Falha ao load justifications. Por favor, tente novamente.',
            review_failed: 'Falha ao review justification. Por favor, tente novamente.',
            decline_failed: 'Falha ao decline access. Por favor, tente novamente.',
            justification_count: 'justificação',
            justification_count_plural: 'justificações',
            reviewed: 'Revisto',
            concerning: 'Preocupante',
            escalated: 'Escalado',
            link_investigation_placeholder: 'Ligar a uma investigação (opcional)',
            review_queue: 'Fila de revisão',
            access_id_label: 'ID de acesso',
            access_id_placeholder: 'ID da entrada do log de acesso',
            select_user_placeholder: 'Selecione um usuário (opcional)',
            resource_type_label: 'Tipo de recurso',
            resource_type_placeholder: 'ex. document, database',
            resource_id_label: 'ID do recurso',
            resource_id_placeholder: 'Identificador do recurso',
            reason_placeholder: 'Motivo para acessar este recurso...',
            create_failed: 'Falha ao create justification',
            unclassified: 'Não classificado',
            review_statuses: {
                pending: 'Pendente',
                reviewed: 'Revisado',
                concerning: 'Relativo',
                escalated: 'Escalado',
            },
            reason_codes: {
                business_need: 'Necessidade de negócios',
                legal_obligation: 'Obrigação Legal',
                data_subject_request: 'Solicitação do Titular dos Dados',
                audit_requirement: 'Requisito de auditoria',
                incident_response: 'Resposta a Incidentes',
                research: 'Pesquisa',
                administrative: 'Administrativo',
                other: 'Outro',
            },
        },
        investigations: {
            title: 'Espaço de investigação',
            new: 'Novo Investigation',
            subject: 'Titular',
            investigator: 'Investigador',
            opened_at: 'Aberto Em',
            findings: 'Constatações',
            no_investigations: 'Nenhum investigations encontrado',
            load_failed: 'Falha ao load investigations. Por favor, tente novamente.',
            create_failed: 'Falha ao create investigation. Por favor, tente novamente.',
            timeline_add_failed: 'Falha ao add timeline entry. Por favor, tente novamente.',
            link_access_failed: 'Falha ao link access ids. Por favor, tente novamente.',
            link_justification_failed: 'Falha ao link justification ids. Por favor, tente novamente.',
            close_failed: 'Falha ao close investigation. Por favor, tente novamente.',
            export_success: 'Exportar initiated com sucesso',
            export_failed: 'Falha ao export investigation. Por favor, tente novamente.',
            refresh_failed: 'Falha ao refresh investigation detail. Por favor, tente novamente.',
            update_failed: 'Falha ao atualizar a investigação',
            investigation_count: 'investigação',
            investigation_count_plural: 'investigações',
            title_placeholder: 'Título da investigação',
            description_placeholder: 'Descrição detalhada da investigação...',
            assignee_placeholder: 'ID de utilizador do atribuído (opcional)',
            timeline_action_placeholder: 'p.ex., Registos de acesso revistos',
            timeline_note_placeholder: 'Nota opcional',
            access_ids_placeholder: 'ID de acesso-1, ID de acesso-2',
            justification_ids_placeholder: 'justificativa-id-1, justificativa-id-2',
            findings_placeholder: 'Resuma as conclusões da investigação...',
            by_actor: 'by',
            close_investigation: 'Fechar investigação',
            add_timeline_failed: 'Falha ao add timeline entry. Por favor, tente novamente.',
            fetch_failed: 'Falha ao fetch investigations. Por favor, tente novamente.',
            change_status: 'Alterar status da investigação',
            details: 'Detalhes da investigação',
            link_evidence: 'Vincular evidência',
            link_justifications: 'Vincular justificativas',
            access_ids_label: 'IDs de acesso',
            justification_ids_label: 'IDs de justificativa',
            access_ids_link_placeholder: 'ID de acesso-1, ID de acesso-2',
            justification_ids_link_placeholder: 'justificativa-id-1, justificativa-id-2',
            investigations_loaded: '{n} investigations carregados',
            status_changed_to: 'Status alterado para {status}',
            add_timeline_entry: 'Adicionar entrada na linha do tempo',
            add_access_ids: 'Adicionar IDs de acesso',
            add_justification_ids: 'Adicionar IDs de justificativa',
            investigation_types: {
                anomaly_review: 'Revisão de anomalia',
                complaint_driven: 'Orientado a reclamações',
                scheduled_review: 'Revisão agendada',
                whistleblower_report: 'Relatório de denúncia',
            },
            severity_labels: {
                low: 'Baixo',
                medium: 'Médio',
                high: 'Alto',
                critical: 'Crítico',
            },
            status_labels: {
                open: 'Abrir',
                in_progress: 'Em andamento',
                pending_review: 'Revisão pendente',
                closed_substantiated: 'Fechado (fundamentado)',
                closed_unsubstantiated: 'Fechado (não fundamentado)',
                closed_inconclusive: 'Fechado (Inconclusivo)',
            },
            disposition_labels: {
                substantiated: 'Fundamentado',
                unsubstantiated: 'Infundado',
                inconclusive: 'Inconclusivo',
            },
        },
        pattern_analysis: {
            title: 'Análise de padrões',
            loading: 'A carregar pattern data...',
            anomalies_detected: 'Anomalias detetadas',
            patterns: 'Padrões',
            by_user: 'Por Utilizador',
            by_resource: 'Por recurso',
            time_range: 'Intervalo de tempo',
            load_failed: 'Falha ao analyze patterns. Por favor, tente novamente.',
            top_resources: '10 principais',
            access_by_hour: 'Acesso por hora do dia',
            access_by_day: 'Acesso por Day de Semana',
            fetch_failed: 'Falha ao fetch pattern analysis. Por favor, tente novamente.',
            analysis_loaded: 'Análise de padrões carregada para {user}, {n} sessões encontradas',
            date_format_placeholder: 'DD/MM/AAAA',
            access_by_hour_heading: 'Acesso por hora do dia',
            access_by_day_heading: 'Acesso por dia da semana',
            by_classification: 'Por nível de classificação',
            top_accessed_resources: 'Recursos mais acessados',
            user_access_summary: 'Resumo de acesso do usuário',
            days: {
                sunday: 'Domingo',
                monday: 'Segunda-feira',
                tuesday: 'Terça-feira',
                wednesday: 'Quarta-feira',
                thursday: 'Quinta-feira',
                friday: 'Sexta-feira',
                saturday: 'Sábado',
            },
            linked_access_logs: 'Logs de acesso vinculados',
            linked_access_logs_desc: 'Acesse entradas de log associadas aos padrões detectados para este usuário.',
        },
        anchoring_status: {
            title: 'Estado de ancoragem',
            loading: 'A carregar anchoring data...',
            anchored: 'Ancorado',
            pending: 'Pendente',
            failed: 'Falhou',
            last_anchor: 'Última ancoragem',
            no_records: 'Nenhum anchoring records encontrado',
            status_load_failed: 'Falha ao load anchoring status. Por favor, tente novamente.',
            proofs_load_failed: 'Falha ao load access proofs. Por favor, tente novamente.',
            verify_failed: 'Falha ao verify proof chain. Por favor, tente novamente.',
            anchor_failed: 'Falha ao anchor access proof. Por favor, tente novamente.',
            batch_anchor_failed: 'Falha ao batch anchor access proofs. Por favor, tente novamente.',
            proof_count: 'prova',
            proof_count_plural: 'provas',
            anchor_single: 'Ancoragem individual',
            anchor_batch: 'Ancoragem em lote',
            access_id_placeholder: 'Introduza access ID to anchor',
            batch_ids_placeholder: 'ID de acesso-1, ID de acesso-2, ID de acesso-3',
            verify_chain: 'Verificar cadeia',
            chain_breaks: 'Ruturas de cadeia',
            total_checked: 'Total verificado',
            anchor_placeholder: 'Introduza access ID to anchor',
            fetch_failed: 'Falha ao fetch anchoring status. Por favor, tente novamente.',
            fetch_proofs_failed: 'Falha ao fetch proofs. Por favor, tente novamente.',
            access_id: 'ID de acesso',
            chain_sequence: 'Seq. cadeia',
            proof_hash_label: 'Hash da prova',
            batch_id: 'ID do lote',
            proofs_loaded: '{n} access proofs carregados',
            anchor_statuses: {
                pending: 'Pendente',
                submitted: 'Enviado',
                confirmed: 'Confirmado',
                failed: 'Falha',
            },
            anchor_types: {
                sha256_chain: 'SHA-256 Corrente',
                blockchain_anchor: 'Âncora Blockchain',
                zkp_stub: 'Esboço ZKP',
            },
        },
        configuration: {
            title: 'Configuração',
            session_settings: 'Sessão Definições',
            log_retention: 'Registo Retenção (days)',
            anomaly_threshold: 'Limiar de anomalia',
            anchoring_enabled: 'Ancoragem ativada',
            save_config: 'Guardar Configuração',
            load_failed: 'Falha ao load configuration. Por favor, tente novamente.',
            save_success: 'Configuração guardado com sucesso',
            save_failed: 'Falha ao save configuration. Por favor, tente novamente.',
            justification_rules: 'Regras de justificação',
            reason_codes: 'Códigos de motivo',
            anchoring_settings: 'Definições de ancoragem',
            anchoring_method: 'Método de ancoragem',
            anchoring_frequency: 'Frequência de ancoragem',
            batch_interval: 'Intervalo de lote (minutos)',
            eligibility_criteria: 'Critérios de elegibilidade',
            add_criterion_placeholder: 'Adicionar eligibility criterion...',
            retention_settings: 'Retenção Definições',
            standard_retention: 'Norma Retenção (days)',
            sensitive_retention: 'Sensível Retenção (days)',
            working_hours: 'Horas de trabalho',
            work_start: 'Início Hora',
            work_end: 'Fim Hora',
            timezone: 'Fuso horário',
            timezone_placeholder: 'p. ex. Asia/Ho_Chi_Minh',
            working_days: 'Dias úteis',
            concurrent_sessions: 'Limites de sessões simultâneas',
            concurrent_threshold: 'Limiar de sessões simultâneas',
            classification_level: 'Classificação Nível',
            prompt_mode: 'Modo de aviso',
            grace_period: 'Período de carência (s)',
            code_placeholder: 'código',
            is_custom: 'Personalizado',
            label_placeholder: 'Rótulo',
            description_placeholder: 'Descrição',
            custom: 'Personalizado',
            fetch_failed: 'Falha ao fetch configuration. Por favor, tente novamente.',
            classification_levels: {
                public: 'Público',
                internal: 'Interno',
                confidential: 'Confidencial',
                restricted: 'Restrito',
                unclassified: 'Não classificado',
            },
            prompt_modes: {
                reason_only: 'Razão Apenas',
                reason_text: 'Razão + Texto',
                reason_text_supervisor: 'Razão + Texto + Supervisor',
            },
            anchoring_methods: {
                sha256_chain: 'SHA-256 Corrente',
                blockchain_anchor: 'Âncora Blockchain',
                zkp_stub: 'Esboço ZKP',
            },
            anchoring_frequencies: {
                realtime: 'Em tempo real',
                batched: 'Em lote',
                on_demand: 'Sob demanda',
            },
        },
        access_policies: {
            title: 'Políticas de acesso',
            create_policy: 'Criar política de acesso',
            policy_name: 'Nome da política',
            framework_code: 'Enquadramento',
            select_framework: 'Selecionar um enquadramento...',
            review_frequency: 'Frequência de revisão',
            scope: 'Âmbito',
            no_policies_found: 'Nenhuma política de acesso encontrada.',
            policy_created: 'Política de acesso criada',
            frequency_labels: {
                monthly: 'Mensal',
                quarterly: 'Trimestral',
                semi_annual: 'Semestral',
                annual: 'Anual',
            },
        },
        review_campaigns: {
            title: 'Campanhas de revisão de acesso',
            create_campaign: 'Criar campanha de revisão',
            reviewer: 'Revisor',
            due_date: 'Data de vencimento',
            certify: 'Certificar',
            no_campaigns_found: 'Nenhuma campanha de revisão de acesso encontrada.',
            status_open: 'Aberta',
            status_in_review: 'Em revisão',
            status_completed: 'Concluída',
            campaign_created: 'Campanha de revisão criada',
            review_certified: 'Revisão de acesso certificada',
            certify_campaign: 'Certificar campanha {id}',
            policy_id: 'ID da política',
            select_policy: 'Selecionar uma política...',
            reviewer_ids_label: 'Revisores',
            select_reviewers: 'Selecionar revisores...',
            status_labels: {
                open: 'Aberto',
                in_review: 'Em revisão',
                completed: 'Concluído',
            },
            evidence_package_id: 'ID do pacote de evidências',
        },
        evidence_packages: {
            title: 'Pacotes de evidência',
            generate_package: 'Gerar pacote de evidência',
            export_type: 'Tipo de exportação',
            package_type: 'Tipo de pacote',
            framework_scope: 'Âmbito do enquadramento',
            period: 'Período',
            generated_by: 'Gerado por',
            generated_at: 'Gerado em',
            no_packages_found: 'Nenhum pacote de evidência encontrado.',
            package_generated: 'Pacote de evidências gerado',
            export_type_full: 'Exportação completa',
            export_type_summary: 'Resumo',
            export_type_certification_only: 'Apenas certificação',
            package_type_access_review: 'Revisão de acesso',
            package_type_investigation: 'Investigação',
            package_type_certification: 'Certificação',
            package_type_authority_request: 'Solicitação de autoridade',
            period_start: 'Início do período',
            period_end: 'Fim do período',
            select_frameworks: 'Selecionar estruturas...',
            completeness_col: 'Completude',
            status_col: 'Estado',
            generated_by_col: 'Gerado por',
        },
        evidence_package_detail: {
            title: 'Detalhes do pacote de evidências',
            not_found: 'Pacote de evidências não encontrado.',
            package_metadata: 'Metadados do pacote',
            status: 'Estado',
            item_count: 'Número de itens',
            disposition: 'Disposição',
            closed_at: 'Fechado em',
            completeness_dashboard: 'Painel de completude',
            no_completeness_data: 'Nenhum dado de completude disponível.',
            controls_covered: 'controles cobertos',
            missing: 'Em falta',
            sign_off_tracker: 'Rastreador de aprovação',
            stage_framework_owner: 'Proprietário da estrutura',
            stage_legal_compliance: 'Jurídico e Conformidade',
            stage_internal_audit: 'Auditoria interna',
            approved: 'Aprovado',
            returned: 'Devolvido',
            pending: 'Pendente',
            approve: 'Aprovar',
            return_btn: 'Devolver',
            sign_off_submitted: 'Aprovação submetida',
            artifacts: 'Artefactos',
            no_artifacts: 'Nenhum artefacto encontrado.',
            template_id: 'ID de modelo',
            description: 'Descrição',
            classification: 'Classificação',
            evidence_type: 'Tipo de evidência',
            framework_section: 'Secção da estrutura',
            history: 'Histórico de aprovação',
            expand: 'Expandir',
            collapse: 'Recolher',
            action: 'Ação',
            actor: 'Ator',
            timestamp: 'Carimbo temporal',
            comment: 'Comentário',
            close_case: 'Fechar caso',
            confirm_close: 'Confirmar fecho',
            closure_notes: 'Notas de fecho',
            disposition_compliant: 'Conforme',
            disposition_non_compliant: 'Não conforme',
            disposition_partial: 'Parcial',
            case_closed: 'Pacote de evidências fechado',
            export_package: 'Exportar pacote',
            export_complete: 'Pacote de evidências exportado',
        },
    },
    consent_properties: {
        nav: {
            dashboard: 'Painel de controlo',
            properties: 'Propriedades',
            groups: 'Grupos',
            bindings: 'Vinculações',
            change_requests: 'Pedidos de alteração',
            comparison: 'Comparação',
            inconsistencies: 'Inconsistências',
            snapshot_schedules: 'Agendamento de instantâneos',
            golden_templates: 'Modelos de referência',
            evidence_packs: 'Pacotes de evidência',
            audit: 'Auditoria',
        },
        select_property: 'Selecionar propriedade…',
        select_policy: 'Selecionar política…',
        select_properties: 'Selecionar propriedades…',
        select_target_properties: 'Selecionar propriedades alvo…',
        select_owner: 'Selecionar proprietário…',
        select_technical_contact: 'Selecionar contacto técnico…',
        property_statuses: {
            active: 'Ativo',
            inactive: 'Inativo',
            pending: 'Pendente',
            decommissioned: 'Desativado',
        },
        dashboard: {
            title: 'Painel de propriedades cruzadas',
            loading: 'A carregar dashboard data...',
            total_properties: 'Total de propriedades',
            active_properties: 'Propriedades ativas',
            snapshot_coverage: 'Cobertura de snapshots',
            properties_covered: 'propriedades cobertas',
            total_bindings: 'Total de vínculos',
            deployed_bindings: 'Implantado',
            pending_bindings: 'Implantação pendente',
            deployment_progress: 'Progresso da implantação',
            on_target: 'No alvo',
            below_target: 'Abaixo do alvo',
            target_label: 'Alvo',
            total_groups: 'Total Grupos',
            pending_changes: 'Alterações pendentes',
            inconsistencies: 'Inconsistências',
            recent_activity: 'Atividade recente',
            no_recent_activity: 'Sem atividade recente.',
            fetch_error: 'Falha ao load dashboard. Por favor, tente novamente.',
        },
        properties: {
            title: 'Registo de propriedades',
            new: 'Novo Property',
            edit: 'Editar propriedade',
            property_name: 'Nome',
            property_type: 'Tipo',
            identifier: 'Identificador',
            environment: 'Ambiente',
            owner_id: 'Proprietário ID',
            technical_contact_id: 'ID do contacto técnico',
            decommission: 'Descomissionar',
            confirm_decommission: 'Tem a certeza de que pretende descomissionar esta propriedade?',
            no_properties: 'Nenhum properties encontrado',
            all_environments: 'Todos os ambientes',
            all_types: 'Todos os tipos',
            cmp_instance_id: '[[TOK_0]] ID da instância',
            deployment_date: 'Data de implantação',
            identifier_placeholder: 'por exemplo, www.example.com ou com.example.app',
            owner_name: 'Proprietário',
            technical_contact_name: 'Contacto técnico',
            sensitive_data_categories: 'Categorias de dados confidenciais',
            sensitive_data_categories_placeholder: 'Selecione categorias de dados confidenciais',
            requires_enhanced_review: 'Requer revisão aprimorada',
            sensitive_review_status: 'Revisão de dados confidenciais',
            sensitive_review_pending: 'Revisão pendente',
            sensitive_review_approved: 'Aprovado',
            sensitive_review_rejected: 'Rejeitado',
            sensitive_review_submit: 'Enviar avaliação',
            sensitive_review_approve: 'Aprovar',
            sensitive_review_reject: 'Rejeitar',
            sensitive_review_notes: 'Revise as notas',
            sensitive_review_notes_placeholder: 'Insira notas de revisão...',
            record_withdrawal: 'Retirada de registro',
            withdrawal_subject_id: 'ID do assunto',
            withdrawal_consent_id: 'ID de consentimento',
            withdrawal_reason: 'Razão',
            withdrawal_downstream_systems: 'Sistemas a jusante',
            withdrawal_downstream_placeholder: 'sistema-1, sistema-2',
            withdrawal_success: 'Retirada propagada com sucesso.',
            withdrawal_error: 'Falha ao propagar a retirada.',
            withdrawal_data_subject_id: 'ID do titular dos dados',
            withdrawal_data_subject_id_placeholder: 'p. ex. usr_abc123',
            withdrawal_consent_record_id: 'ID do registro de consentimento',
            withdrawal_consent_record_id_placeholder: 'p. ex. consent_xyz789',
            withdrawal_purposes: 'Finalidades retiradas',
            withdrawal_purposes_placeholder: 'Selecione as finalidades para retirar o consentimento para...',
            withdrawal_withdrawn_at: 'Data de retirada',
            withdrawal_tasks_created: 'Tarefas criadas',
            withdrawal_affected_bindings: 'Ligações Afetadas',
            withdrawal_affected_activities: 'Atividades de processamento afetadas',
            withdrawal_history: 'Histórico de retiradas',
        },
        groups: {
            title: 'Grupos de propriedades',
            new: 'Novo grupo',
            group_name: 'Grupo Nome',
            member_count: 'Membros',
            no_groups: 'Nenhum property groups encontrado',
            policies: 'Políticas',
            confirm_delete: 'Tem certeza de que deseja excluir este grupo?',
        },
        bindings: {
            title: 'Matriz de vinculações',
            property: 'Propriedade',
            purpose: 'Finalidade',
            legal_basis: 'Base jurídica',
            bound: 'Vinculado',
            no_bindings: 'Nenhum bindings encontrado',
            bind_policy: 'Política de vinculação',
            bulk_bind: 'Vinculação em massa',
            bind_policy_to_property: 'Vincular política à propriedade',
            bulk_bind_policy: 'Política de vinculação em massa',
            unbound: 'Não consolidado',
            policy_id: 'ID da política',
            version_placeholder: 'por exemplo, 1.0.0',
            property_ids_placeholder: 'prop-id-1, prop-id-2, prop-id-3',
            binding_name: 'Vinculação',
            property_name: 'Nome da propriedade',
            policy_name: 'Nome da política',
            bindings_list: 'Lista de vinculações',
            binding_actions: {
                start_deploy: 'Iniciar implantação',
                mark_deployed: 'Marcar como implantado',
                rollback: 'Reverter',
            },
        },
        change_requests: {
            title: 'Processo de pedidos de alteração',
            new: 'Novo Change Request',
            requester: 'Requerente',
            change_type: 'Tipo de alteração',
            property: 'Propriedade',
            submitted_at: 'Submetido em',
            no_requests: 'Nenhum change requests encontrado',
            fetch_pipeline_error: 'Falha ao fetch pipeline. Por favor, tente novamente.',
            fetch_list_error: 'Falha ao fetch change requests. Por favor, tente novamente.',
            create_error: 'Falha ao create change request. Por favor, tente novamente.',
            action_error: 'Falha ao perform action. Por favor, tente novamente.',
            approver_name: 'Aprovador',
            placeholder_target_props: 'prop-id-1, prop-id-2',
            view_all: 'Todos',
            view_my_properties: 'Minhas Propriedades',
            stage_requests: 'Pedidos {stage}',
        },
        comparison: {
            title: 'Espaço de comparação',
            select_properties: 'Selecione Properties to Compare',
            compare: 'Comparar',
            no_comparison: 'Selecione at least two properties to compare.',
            fetch_error: 'Falha ao fetch comparison reports. Por favor, tente novamente.',
            run_error: 'Falha ao run comparison. Por favor, tente novamente.',
            save_notes_error: 'Falha ao save notes. Por favor, tente novamente.',
            scan_complete: 'Inconsistency scan concluído com sucesso',
            scan_error: 'Falha ao run inconsistency scan. Por favor, tente novamente.',
            min_two_properties: 'Forneça pelo menos 2 IDs de propriedade para comparação.',
            view_inconsistencies: 'Ver inconsistências',
            click_to_select: 'Clique para selecionar duas ou mais propriedades',
            no_properties_available: 'Nenhuma propriedade disponível',
            no_matching_properties: 'Nenhuma propriedade correspondente',
            select_at_least_two_props: 'Selecione pelo menos duas propriedades no menu suspenso acima.',
            no_differences_found: 'Nenhuma diferença encontrada entre as propriedades selecionadas.',
            found_inconsistencies: 'Encontradas {count} inconsistências em {properties} propriedades e {bindings} ligações.',
        },
        inconsistencies: {
            title: 'Lista de inconsistências',
            property: 'Propriedade',
            field: 'Campo',
            expected: 'Esperado',
            actual: 'Real',
            severity: 'Gravidade',
            no_inconsistencies: 'Nenhum inconsistencies encontrado',
            trend: 'Tendência de Inconsistência',
            trend_chart_label: 'Gráfico de tendência de inconsistência mostrando contagens ao longo do tempo',
            acknowledge: 'Confirmar receção',
            resolve: 'Resolver',
            suppress: 'Suprimir',
            cr_id_placeholder: 'ID CR',
            view_all: 'Todos',
            view_my_properties: 'Minhas Propriedades',
            view_dpo_review: '[[TOK_0]] Fila de revisão',
            change_request_id_required: 'O ID da solicitação de alteração é necessário para resolver essa inconsistência.',
        },
        snapshot_schedules: {
            title: 'Agendamento de instantâneos',
            new: 'Novo agendar',
            schedule_name: 'Agendar Nome',
            frequency: 'Frequência',
            next_run: 'Seguinte Executar',
            last_run: 'Último Executar',
            no_schedules: 'Nenhum snapshot schedules encontrado',
            target_type: 'Tipo de destino',
            target_id: 'ID de destino',
            custom_frequency_days: 'Frequência personalizada (dias)',
            time_of_day: 'Hora do dia',
            time: 'Hora',
            retention_days: 'Retenção (dias)',
            execute_now: 'Execute agora',
            placeholder_days: 'por exemplo, 10',
            target_name: 'Nome do alvo',
        },
        golden_templates: {
            title: 'Modelos de referência',
            new: 'Novo modelo',
            template_name: 'Modelo Nome',
            property_type: 'Tipo de propriedade',
            no_templates: 'Nenhum golden templates encontrado',
            applicable_group_ids: 'IDs de grupo aplicáveis (separados por vírgula)',
            applicable_groups: 'Grupos Aplicáveis',
            purposes: 'Finalidades',
            legal_bases: 'Bases Legais',
            banner_config: 'Configuração de banner',
            consent_settings: 'Definições de consentimento',
            group_ids_placeholder: 'ID do grupo-1, ID do grupo-2',
            apply_to_property: 'Aplicar à Propriedade',
            apply_to_group: 'Aplicar ao Grupo',
            apply_success: 'Modelo aplicado com sucesso.',
            applications: 'Histórico de aplicações',
            no_applications: 'Nenhuma aplicação de modelo ainda.',
            no_configuration_details: 'O modelo não tem detalhes de configuração. Edite o modelo para adicionar finalidades, bases legais, configurações de banner ou configurações de consentimento.',
        },
        rollouts: {
            title: 'Implementações de modelos',
            rollout_status: 'Estado da implementação',
            confirmed: 'Confirmado',
            pending: 'Pendente',
            failed: 'Falhado',
            confirm: 'Confirmar Propriedade',
            confirm_success: 'Propriedade confirmada na implementação.',
            can_close: 'Todas as propriedades confirmadas — implementação concluída',
            cannot_close: 'A aguardar confirmações de propriedades',
            no_rollouts: 'Nenhuma implementação encontrada.',
            in_progress: 'Em progresso',
            completed: 'Concluído',
            cancelled: 'Cancelado',
            reject: 'Rejeitar Propriedade',
            reject_success: 'Propriedade rejeitada da implementação.',
            confirm_all: 'Confirmar Todos',
            reject_all: 'Rejeitar Todos',
            confirm_label: 'Confirmar implementação para',
            reject_label: 'Rejeitar implementação para',
            confirm_all_label: 'Confirmar Todas as Implementações Pendentes',
            reject_all_label: 'Rejeitar Todas as Implementações Pendentes',
            no_properties_in_rollout: 'Este lançamento não tem propriedades.',
        },
        analytics: {
            title: 'Análise de propriedades',
            opt_in_rate: 'Taxa de adesão',
            opt_out_rate: 'Taxa de recusa',
            withdrawal_rate: 'Taxa de retirada',
            total_consents: 'Total de consentimentos',
            total_withdrawals: 'Total de retiradas',
            compliance_score: 'Pontuação de conformidade',
            non_compliant: 'Propriedades não conformes',
            no_non_compliant: 'Todas as propriedades estão em conformidade.',
            threshold: 'Limiar de conformidade',
            property_id: 'ID da propriedade',
            compliant: 'Compatível',
            non_compliant_status: 'Não conforme',
            compliance_help_summary: 'Como a pontuação de conformidade é calculada e como posso corrigi-la?',
            compliance_help_intro: 'Uma propriedade é sinalizada como Não Conforme quando sua pontuação é inferior a 80%. A pontuação é calculada como:',
            compliance_help_with_template_label: 'Se um Golden Template for aplicado:',
            compliance_help_with_template_text: '% de chaves de configuração (finalidades, legal_bases, banner_config, consent_settings) que correspondem exatamente ao modelo.',
            compliance_help_no_template_label: 'Se nenhum Golden Template for aplicado:',
            compliance_help_no_template_text: '% de vinculações (tipos de consentimento atribuídos à propriedade) com deployment_status = implantado. Uma propriedade sem associações tem como padrão 100%.',
            compliance_help_fix_intro: 'Para remover uma propriedade desta lista, siga um destes procedimentos:',
            compliance_help_fix_deploy_label: 'Implantar suas ligações',
            compliance_help_fix_deploy_text: 'abra a página Binding Matrix e defina o status de implantação de cada ligação como implantado.',
            compliance_help_fix_template_label: 'Aplicar um modelo dourado',
            compliance_help_fix_template_text: 'use Aplicar ao grupo no modelo e confirme a implementação desta propriedade. Certifique-se de que a configuração da propriedade corresponda ao modelo.',
            compliance_help_fix_decommission_label: 'Desativar o imóvel',
            compliance_help_fix_decommission_text: 'use o botão Desativar no modal de detalhes da propriedade se ela não estiver mais em uso.',
            compliance_help_fix_no_bindings_label: 'Remover todas as ligações',
            compliance_help_fix_no_bindings_text: 'se uma propriedade não tiver modelo nem vinculações, ela pontuará 100% por padrão.',
        },
        evidence_packs: {
            title: 'Pacotes de evidência',
            new: 'Novo Pack',
            pack_name: 'Nome do pacote',
            properties: 'Propriedades',
            generated_at: 'Gerado em',
            no_packs: 'Nenhum evidence packs encontrado',
            generate: 'Gerar',
            content_type_consent_records: 'Consentimento Registos',
            content_type_policy_versions: 'Versões da política',
            content_type_binding_history: 'Histórico de vinculação',
            content_type_change_requests: 'Pedidos de alteração',
            content_type_inconsistency_reports: 'Relatórios de inconsistência',
            content_type_snapshot_data: 'Dados de instantâneo',
            content_type_audit_trail: 'Trilha de auditoria',
        },
        audit: {
            title: 'Auditoria de propriedades de consentimento',
            event_type: 'Evento Tipo',
            entity_type: 'Tipo de entidade',
            entity_id: 'ID da entidade',
            actor: 'Ator',
            timestamp: 'Marca temporal',
            no_events: 'Nenhum audit events encontrado',
            entity_type_property: 'Propriedade',
            entity_type_group: 'Grupo',
            entity_type_binding: 'Vinculação',
            entity_type_change_request: 'Pedido de alteração',
            entity_type_golden_template: 'Modelo dourado',
            entity_type_snapshot_schedule: 'Agendamento instantâneo',
            entity_type_inconsistency: 'Inconsistência',
            entity_type_evidence_pack: 'Pacote de evidência',
            action_created: 'Criado',
            action_updated: 'Atualizado',
            action_deleted: 'Eliminado',
            action_decommissioned: 'Desativado',
            action_status_changed: 'Estado alterado',
            action_submitted: 'Submetido',
            action_approved: 'Aprovado',
            action_rejected: 'Rejeitado',
            action_deployed: 'Implementado',
            action_rolled_back: 'Revertido',
            action_paused: 'Pausado',
            action_resumed: 'Retomado',
            action_cancelled: 'Cancelado',
            action_acknowledged: 'Reconhecido',
            action_resolved: 'Resolvido',
            action_suppressed: 'Suprimido',
            action_executed: 'Executado',
        },
        property_types: {
            website: 'Site',
            mobile_app: 'Aplicação móvel',
            ott: 'OTT',
            iot_device: 'Dispositivo IoT',
            kiosk: 'Quiosque',
            api_service: 'Serviço API',
            sdk: 'SDK',
        },
        environments: {
            production: 'Produção',
            staging: 'Pré-produção',
            development: 'Desenvolvimento',
            testing: 'Teste',
        },
        group_types: {
            brand: 'Marca',
            region: 'Região',
            product_line: 'Linha de produtos',
            business_unit: 'Unidade de negócio',
            custom: 'Personalizado',
        },
        target_types: {
            property: 'Propriedade',
            group: 'Grupo',
            all: 'Todos',
        },
        frequencies: {
            hourly: 'A cada hora',
            daily: 'Diário',
            weekly: 'Semanal',
            monthly: 'Mensal',
            custom: 'Personalizado',
        },
        binding_statuses: {
            current: 'Atual',
            outdated: 'Desatualizado',
            pending: 'Pendente',
            deploying: 'A implementar',
            rolled_back: 'Revertido',
        },
        sensitive_categories: {
            health: 'Dados de saúde',
            biometric: 'Dados biométricos',
            genetic: 'Dados Genéticos',
            racial_ethnic: 'Origem racial/étnica',
            political_opinions: 'Opiniões Políticas',
            religious_beliefs: 'Crenças Religiosas',
            trade_union: 'Filiação Sindical',
            sexual_orientation: 'Orientação Sexual',
            criminal_records: 'Registos criminais',
            financial: 'Dados Financeiros',
            children: 'Dados infantis',
            geolocation: 'Geolocalização precisa',
        },
        export_csv: 'Exportar CSV',
        exporting: 'Exportando...',
        page_x_of_y: 'Pagina {page} de {total}',
        regulatory: {
            capture_method_guidance: '[[TOK_0]] exige prova de consentimento que corresponda ao canal de coleta. Os tipos de propriedade são mapeados para métodos de captura de consentimento: site/OTT = consentimento baseado em banner, aplicativo móvel/SDK = fluxo de consentimento no aplicativo, quiosque = captura de consentimento físico/na tela, serviço [[TOK_1]] = consentimento programático, dispositivo IoT = mecanismo de consentimento no nível do dispositivo.',
            dashboard_metrics_info: 'Este painel fornece ao [[TOK_0]] uma visão única da postura de consentimento em todas as propriedades digitais. As principais métricas incluem: porcentagem de cobertura de vinculação (implantada versus total de vinculações), adesão ao modelo por meio do widget de inconsistências, solicitações de alteração pendentes que exigem revisão e detalhamento do status da propriedade mostrando propriedades com estados ativos, inativos ou desativados. Propriedades com categorias de dados confidenciais são rastreadas por meio do registro de propriedades.',
            change_request_impact_info: 'As solicitações de alteração que afetam as propriedades de consentimento devem documentar o impacto regulatório: quais requisitos [[TOK_0]] são afetados, se a alteração afeta o processamento de dados confidenciais (Art. 2.4) e se a alteração requer novo consentimento dos titulares dos dados. O resumo do impacto em cada solicitação de mudança detalha as referências regulatórias [[TOK_1]] para evidências de auditoria.',
            outdated_binding_warning: 'As vinculações com status "desatualizado" indicam que uma propriedade executa uma versão de política que não é atual. Essas propriedades podem não refletir os requisitos [[TOK_0]] mais recentes ou atualizações de políticas organizacionais. Revise e atualize vinculações desatualizadas imediatamente para manter a conformidade com [[TOK_1]] em todas as propriedades de consentimento.',
            template_pdpl_alignment: 'Por [[TOK_0]] Art. 11, os modelos dourados devem vincular as finalidades às bases jurídicas. As configurações de banner devem impor a aceitação (e não a exclusão) de acordo com o Art. 11.3 consentimento explícito. Os modelos devem especificar um mecanismo de retirada de acordo com o Art. 12. Para dados confidenciais (Art. 2.4), os modelos devem exigir consentimento explícito por escrito ou equivalente – a aceitação do clique é insuficiente.',
        },
    },
    localization: {
        nav: {
            dashboard: 'Painel de controlo',
            market_packs: 'Pacotes de mercado',
            language_packs: 'Pacotes de idiomas',
            frameworks: 'Quadros regulamentares',
            mappings: 'Mapeamentos de módulos',
            submissions: 'Submissões de pacotes',
            translations: 'Pré-visualização da tradução',
            audit: 'Registo de auditoria',
        },
        dashboard: {
            title: 'Painel de localização',
            loading: 'A carregar dashboard data...',
            active_market_packs: 'Ativo Mercado Packs',
            published_packs_available: 'Pacotes de mercado publicados disponíveis',
            language_packs: 'Pacotes de idioma',
            total_language_packs: 'Total de pacotes de idioma registados',
            active_regulatory_frameworks: 'Ativo Regulatory Enquadramentos',
            frameworks_active: 'Enquadramentos com estado ativo',
            pending_pack_submissions: 'Submissões de pacotes pendentes',
            submissions_awaiting_review: 'Submissões aguardando revisão',
            recent_audit_events: 'Recente Auditoria Eventos',
            no_recent_audit: 'Sem eventos de auditoria recentes.',
            event_type: 'Evento Tipo',
            entity_type: 'Tipo de entidade',
            entity_id: 'ID da entidade',
            actor: 'Ator',
            timestamp: 'Marca temporal',
        },
        market_packs: {
            title: 'Catálogo de pacotes de mercado',
            new: 'Novo Market Pack',
            pack_name: 'Nome do pacote',
            market: 'Mercado',
            locale: 'Idioma',
            no_packs: 'Nenhum market packs encontrado',
        },
        language_packs: {
            title: 'Pacotes de idiomas',
            new: 'Novo Language Pack',
            language: 'Idioma',
            locale_code: 'Código de idioma',
            completeness: 'Completude',
            completeness_detail: 'Detalhe de integridade',
            overall_completeness: 'Completude Geral',
            total_keys: 'Total de chaves',
            translated_keys: 'Chaves traduzidas',
            missing_keys: 'Chaves ausentes',
            namespace_breakdown: 'Divisão de namespace',
            namespace: 'Espaço de nomes',
            translated: 'Traduzido',
            no_packs: 'Nenhum language packs encontrado',
            install_language_pack: 'Instalar pacote de idioma',
            available_packs: 'Pacotes de idioma disponíveis',
            install: 'Instalar',
            all_installed: 'Todos os pacotes de idioma já estão instalados.',
            install_success: 'Pacote de idioma instalado com sucesso.',
            market: 'Mercado',
            featured: 'Destaque',
        },
        frameworks: {
            title: 'Quadros regulamentares',
            new: 'Novo enquadramento',
            framework_name: 'Enquadramento Nome',
            jurisdiction: 'Jurisdição',
            effective_date: 'Data de vigência',
            no_frameworks: 'Nenhum regulatory frameworks encontrado',
            view_requirements: 'Ver requisitos',
            hide_requirements: 'Ocultar requisitos',
            show_legacy: 'Mostrar quadros legais antigos',
            effective_until: 'Vigente até',
            effective_on: 'Vigente a partir de',
            replaced_by: 'Substituído por',
            replaces_label: 'Substitui',
            status_legacy: 'Antigo',
            status_upcoming: 'Próximo',
            watchlist: 'Lista de observação',
            watchlist_empty: 'Nenhum rascunho ou estruturas futuras',
            watchlist_empty_desc: 'Frameworks com status “rascunho” ou “próximo” aparecerão aqui para monitoramento.',
            expected_effective: 'Eficácia esperada',
            effective_date_tbd: 'Data de vigência: TBD',
            activate: 'Ativar',
            ai_law_title: 'Lei do Vietnã [[TOK_0]]',
            ai_risk_classification: '[[TOK_0]] Classificação de risco',
            ai_system_dossier: '[[TOK_0]] Dossiê do Sistema',
            ai_labeling_checklist: '[[TOK_0]] Rotulagem e divulgação',
            ai_incident_report: '[[TOK_0]] Relatório de incidente',
            ai_impact_assessment: '[[TOK_0]] Avaliação de impacto',
            ai_sandbox_application: 'Aplicativo sandbox',
            ai_sandbox_monitoring: 'Monitoramento de sandbox',
            ai_sandbox_completion: 'Conclusão da sandbox',
            ai_submission_tracker: 'Rastreador de envio',
            ai_evidence_capture: 'Captura de evidências',
            risk_level_minimal: 'Risco Mínimo',
            risk_level_limited: 'Risco Limitado',
            risk_level_high: 'Alto risco',
            risk_level_unacceptable: 'Risco Inaceitável',
            submission_status_draft: 'Rascunho',
            submission_status_submitted: 'Enviado',
            submission_status_returned: 'Devolvido para alteração',
            submission_status_accepted: 'Aceito',
            submission_status_rejected: 'Rejeitado',
            submission_status_closed: 'Fechado',
            ecommerce_law_title: 'Lei de comércio eletrônico do Vietnã',
            ecommerce_platform_classification: 'Classificação da plataforma',
            ecommerce_seller_register: 'Cadastro de Vendedor',
            ecommerce_complaint_register: 'Registro de reclamações',
            ecommerce_takedown_register: 'Registro de remoção',
            ecommerce_submission_tracking: 'Rastreamento de envio',
            ecommerce_dossier_checklist: 'Lista de verificação do dossiê',
            ecommerce_cross_border: 'Conformidade transfronteiriça',
            ecommerce_trustmark: 'Programa de Marca de Confiança',
            ecommerce_notification: 'Notificação',
            ecommerce_registration: 'Cadastro',
            ecommerce_termination: 'Rescisão',
            ecommerce_reporting_readiness: 'Preparação para relatórios',
            ecommerce_evidence_capture: 'Captura de evidências',
            submission_status_approved: 'Aprovado',
            cybersec_law_2025_title: 'Lei de Segurança Cibernética do Vietnã (2025)',
            cybersec_system_classification: 'Classificação do Sistema',
            cybersec_risk_assessment: 'Avaliação de Risco',
            cybersec_incident_report: 'Relatório de incidente',
            cybersec_authority_cooperation: 'Cooperação de Autoridade',
            cybersec_data_localization: 'Localização de dados',
            cybersec_vendor_security: 'Segurança do fornecedor',
            cybersec_submission_tracker: 'Rastreador de envio',
            cybersec_evidence_capture: 'Captura de evidências',
            cybersec_dossier_checklist: 'Lista de verificação do dossiê',
            cybersec_classification_general: 'Geral',
            cybersec_classification_important: 'Importante',
            cybersec_classification_critical: 'Crítico',
            data_law_title: 'Lei de Dados do Vietnã',
            data_inventory: 'Inventário de dados',
            data_classification: 'Classificação de dados',
            data_sharing: 'Compartilhamento de dados',
            data_governance: 'Governança de Dados',
            data_submission_tracker: 'Rastreador de envio',
            data_evidence_capture: 'Captura de evidências',
            data_dossier_checklist: 'Lista de verificação do dossiê',
            telecom_law_title: 'Lei de Telecomunicações do Vietnã',
            telecom_authority_request: 'Solicitação de autoridade',
            telecom_disclosure: 'Divulgação',
            telecom_confidentiality: 'Confidencialidade',
            telecom_submission_tracker: 'Rastreador de envio',
            telecom_evidence_capture: 'Captura de evidências',
            telecom_dossier_checklist: 'Lista de verificação do dossiê',
            pdpl_law_title: 'Lei de Proteção de Dados Pessoais do Vietnã',
            pdpl_breach_notification: 'Notificação de violação',
            pdpl_dpo_notification: '[[TOK_0]] Notificação de compromisso',
            pdpl_data_subject_notification: 'Notificação do Titular dos Dados',
            pdpl_submission_tracker: 'Rastreador de envio',
            pdpl_evidence_capture: 'Captura de evidências',
            pdpl_dossier_checklist: 'Lista de verificação do dossiê',
            pdpl_authority_filing: 'Arquivamento de autoridade',
            pdpl_mops_filing: 'Arquivamento MoPS',
        },
        mappings: {
            title: 'Mapeamentos de módulos',
            new: 'Novo mapeamento',
            module: 'Módulo',
            market_pack: 'Pacote de mercado',
            mapping_status: 'Mapeamento Estado',
            no_mappings: 'Nenhum module mappings encontrado',
            incomplete_entries_warning: '{count} mapeamento(s) oculto(s) por falta de ID de framework, ID de requisito ou módulo.',
        },
        submissions: {
            title: 'Submissões de pacotes',
            new: 'Novo Submission',
            submitter: 'Submetedor',
            pack: 'Pacote',
            submitted_at: 'Submetido em',
            no_submissions: 'Nenhum pack submissions encontrado',
            installed_sector_overlays_title: 'Sector Overlays ({count}) [PT]',
            installed_sector_overlays_aria: 'Installed Sector Overlays [PT]',
            installed_col_name: 'Name [PT]',
            installed_col_code: 'Code [PT]',
            installed_col_sector: 'Sector [PT]',
            installed_col_mode: 'Mode [PT]',
            installed_col_status: 'Status [PT]',
            installed_refresh: 'Refresh [PT]',
        },
        translations: {
            title: 'Pré-visualização da tradução',
            select_locale: 'Selecione Locale',
            select_module: 'Selecione Module',
            key: 'Key',
            value: 'Valor',
            no_translations: 'Nenhum translations encontrado',
        },
        audit: {
            title: 'Trilha de auditoria de localização',
            event_type: 'Evento Tipo',
            entity_type: 'Tipo de entidade',
            entity_id: 'ID da entidade',
            entity_name: 'Nome da entidade',
            actor: 'Ator',
            timestamp: 'Marca temporal',
            payload: 'Carga útil',
            collapse_payload: 'Recolher detalhes da carga',
            expand_payload: 'Expandir detalhes da carga',
            collapse: 'Recolher',
            expand: 'Expandir',
            all_entity_types: 'Todos os tipos de entidade',
            no_events: 'Nenhum audit events encontrado',
        },
        market_packs_detail: {
            installed_at: 'Instalado em',
            pack_details_label: 'Detalhes do pacote',
            market_code: 'Código de mercado',
            supported_locales: 'Localidades suportadas',
            min_platform_version: 'Versão mínima da plataforma',
            pack_information: 'Informação do pacote',
            pack_contents: 'Conteúdo do pacote',
            included_frameworks: 'Quadros incluídos',
            pack_artifacts: 'Artefatos do pacote',
            no_artifacts: 'Nenhum artefato encontrado para este pacote',
            pack_not_found: 'Pacote não encontrado',
        },
        mappings_form: {
            framework_id: 'ID da estrutura',
            requirement_id: 'ID do requisito',
            module_label: 'Módulo',
            mapping_type: 'Tipo de mapeamento',
            configuration_json: 'Configuração (JSON)',
            conflict_resolution: 'Resolução de conflitos',
            is_override: 'É substituição',
            all_modules: 'Todos os módulos',
            all_mapping_types: 'Todos os tipos de mapeamento',
        },
        submissions_detail: {
            submission_id: 'ID da submissão',
            validation: 'Validação',
            reviewers: 'Revisores',
            start_review: 'Iniciar revisão',
            hide_comments: 'Ocultar comentários',
            review_comments: 'Comentários de revisão',
            loading_comments: 'Carregando comentários...',
            no_comments: 'Ainda sem comentários.',
            add_comment: 'Adicionar comentário',
            reject_submission: 'Rejeitar submissão',
            reason_for_rejection: 'Motivo da rejeição',
            reviewer_ids: 'IDs dos revisores (separados por vírgulas)',
            submit_new_pack: 'Submeter novo pacote',
            pack_type: 'Tipo de pacote',
            market_code: 'Código de mercado',
            target_locales: 'Localidades de destino',
            pack_file: 'Arquivo do pacote',
            pack_format_info: 'Formato do pacote: os pacotes do Market devem incluir arquivos [[TOK_0]] específicos do local com traduções de namespace/chave. Os pacotes de idiomas devem fornecer traduções para as localidades de destino especificadas. Consulte a documentação para esquema detalhado.',
            accepted_formats: 'Formatos aceitos: .json ou .zip. Os arquivos [[TOK_0]] devem conter um objeto simples ou com namespace de pares de valores-chave de tradução. Os arquivos ZIP devem conter um ou mais arquivos de localidade [[TOK_1]].',
            comma_separated_locales: 'Códigos de localidade separados por vírgulas para este pacote de idioma',
            confirm_approval: 'Confirmar aprovação',
            approve_message: 'Aprovar esta submissão de pacote?',
            submission_label: 'Submissão',
            all_pack_types: 'Todos os tipos de pacote',
            passed: 'aprovado',
            failed_label: 'falhou',
            market_code_required: 'Código de mercado é obrigatório',
            version_required: 'Versão é obrigatória',
            pack_type_regulatory: 'Regulatório',
            framework_code: 'Código do quadro',
            jurisdiction_code: 'Código de jurisdição',
            pack_source: 'Fonte',
            pack_source_manual: 'Manuais',
            pack_version: 'Versão do pacote',
            install_regulatory_pack: 'Instalar pacote regulatório',
            regulatory_pack_desc: 'Carregar um pacote de quadro regulatório (.zip)',
            framework_required: 'O código do quadro regulamentar é obrigatório',
            jurisdiction_required: 'O código de jurisdição é obrigatório',
        },
        catalog_detail: {
            packs_installed_of: 'de {total} pacotes instalados',
            install_all: 'Instalar tudo',
            installing: 'Instalando...',
            removing: 'Removendo...',
            requires: 'Requer',
            tab_catalog: 'Catálogo',
            tab_installed: 'Instalado',
            details: 'Detalhes',
        },
        translations_detail: {
            source_locale: 'Localidade de origem',
            target_locale: 'Localidade de destino',
            locales_must_differ: 'As localidades de origem e destino devem ser diferentes.',
            all_keys_translated: 'Todas as chaves traduzidas',
            keys_missing: '[[TOK_1]] chave(s) ausente(s)',
            show_missing_only: 'Mostrar apenas ausentes',
            namespace: 'Espaço de nomes',
            source: 'Fonte',
            target: 'Destino',
        },
        frameworks_detail: {
            tab_frameworks: 'Estruturas',
            tab_watchlist: 'Lista de acompanhamento',
            authority: 'Autoridade',
            requirements_count: 'Requisitos',
            all_types: 'Todos os tipos',
            collapse_all: 'Recolher tudo',
            expand_all: 'Expandir tudo',
            filtered_to: 'Filtrado para',
            clear_filter: 'Limpar filtro',
            no_requirements: 'Nenhum requisito encontrado para esta estrutura.',
            requirements_label: 'Requisitos',
            status_updated: 'Status atualizado com sucesso',
            overview_tab: 'Visão geral',
            forms_tab: 'Formulários',
            procedures_tab: 'Procedimentos',
            fines_risks_tab: 'Coimas e riscos',
            deadlines_tab: 'Prazos',
            guidance_tab: 'Orientação',
            guidance_empty: 'Nenhum conteúdo de orientação para esta estrutura.',
            guidance_loading: 'Carregando orientação…',
            guidance_section: 'Seção de orientação',
            guidance_view: 'Ver orientação',
            guidance_map_to_workflow: 'Mapear para fluxo de trabalho',
            guidance_link_evidence: 'Evidência de link',
            guidance_filter_type: 'Tipo',
            guidance_filter_category: 'Categoria',
            guidance_filter_module: 'Módulo',
            guidance_filter_status: 'Estado',
            guidance_filter_search: 'Orientação de pesquisa',
            guidance_filter_all: 'Todos',
            guidance_table_reference: 'Referência',
            guidance_table_name: 'Nome da orientação',
            guidance_table_type: 'Tipo',
            guidance_table_category: 'Categoria',
            guidance_table_effective_date: 'Data Efetiva',
            guidance_table_modules: 'Módulos Relacionados',
            guidance_table_actions: 'Ações',
            guidance_reference_only_banner: 'Apenas para referência — aplica-se ao setor {[[TOK_1]]}, mas não à sua organização.',
            guidance_related_link: 'Orientação Relacionada',
            deadlines_empty: 'Nenhum prazo regulatório encontrado para este quadro.',
            deadlines_sla_type: 'Tipo de SLA',
            deadlines_value: 'Prazo',
            deadlines_unit: 'Unidade',
            deadlines_extension: 'Extensão',
            deadlines_reference: 'Referência legal',
            framework_stack: 'Estrutura do quadro',
            layer_parent_law: 'Lei principal',
            layer_implementing_decree: 'Decreto de execução',
            layer_enforcement_decree: 'Decreto sancionatório',
            layer_admin_procedures: 'Procedimentos administrativos',
            status_active: 'Ativo',
            status_draft: 'Rascunho',
            draft_enforcement_badge: 'Rascunho — ainda não promulgado',
            effective_date: 'Data de entrada em vigor',
            forms_table_id: 'ID do formulário',
            forms_table_name: 'Nome',
            forms_table_source: 'Fonte',
            forms_table_category: 'Categoria',
            forms_table_type: 'Tipo',
            fill_form: 'Preencher formulário',
            view_reference: 'Ver referência',
            forms_official: 'Oficial',
            forms_internal: 'Interno',
            forms_empty: 'Nenhum formulário encontrado para este quadro.',
            forms_loading: 'A carregar formulários...',
            filter_by_source_layer: 'Filtrar por camada de origem',
            all_layers: 'Todas as camadas',
            procedures_id: 'ID procedimento',
            procedures_name: 'Procedimento',
            procedures_trigger: 'Ativador',
            procedures_steps: 'Passos',
            procedures_outputs: 'Resultados',
            procedures_related_forms: 'Formulários relacionados',
            procedures_submission_channels: 'Canais de envio',
            procedures_empty: 'Nenhum procedimento encontrado para este quadro.',
            fines_area: 'Área de infração',
            fines_articles: 'Artigos rascunho',
            fines_individual: 'Coima (individual)',
            fines_organization: 'Coima (organização)',
            fines_revenue: 'Escalamento por receita',
            fines_deadlines: 'Prazos',
            fines_remediation: 'Medidas corretivas',
            fines_related: 'Procedimentos relacionados',
            fines_empty: 'Sem dados de sanções disponíveis para este quadro.',
            fines_enforcement_pending: 'Quadro de sanções ainda não publicado. Os dados de sanções serão adicionados quando o instrumento de aplicação for promulgado.',
            view_details: 'Ver detalhes',
            back_to_list: 'Voltar à lista',
            description: 'Descrição',
            jurisdiction: 'Jurisdição',
            lineage: 'Linhagem',
            replaces: 'Substitui',
            replaced_by: 'Substituído por',
            requirements: 'Requisitos',
            tab_navigation: 'Separadores de detalhe do quadro',
            forms_table_actions: 'Ações',
            create_form: 'Criar formulário',
            mark_promulgated: 'Marcar como promulgado',
            status_promulgated: 'Promulgado',
            promulgated_success: 'Estado da camada atualizado para promulgado',
            transition_review: 'Revisão de transição',
            transition_review_desc: 'Este quadro tem uma revisão de transição pendente para a adoção da lei sucessora.',
            transition_review_by: 'Prazo de revisão',
            transition_review_status: 'Estado da revisão',
            transition_review_notes: 'Notas',
            transition_review_pending: 'Pendente',
            transition_review_in_progress: 'Em curso',
            transition_review_completed: 'Concluída',
            transition_review_successor: 'Quadro sucessor',
            transition_review_lead_time: 'Tempo de preparação',
            transition_review_lead_time_days: '{days} dias antes da data de entrada em vigor',
            transition_review_forms_heading: 'Revisões de transição de formulários',
            transition_review_forms_desc: 'Revise cada modelo operacional quanto à relevância no quadro sucessor.',
            transition_review_outcome: 'Resultado',
            transition_review_outcome_carry_forward: 'Manter',
            transition_review_outcome_carry_forward_revised: 'Manter (revisto)',
            transition_review_outcome_retire: 'Retirar',
            transition_review_outcome_split: 'Dividir',
            transition_review_outcome_awaiting_decree: 'Aguardando decreto',
            transition_review_no_forms: 'Nenhuma revisão de transição de formulários configurada.',
            transition_review_update_success: 'Revisão de transição atualizada com sucesso',
            transition_review_operational_note: 'Estes são modelos operacionais de apoio ao processo, não contagens de formulários legais. A atribuição legal permanece no quadro antigo até a lei sucessora entrar em vigor.',
            rights_tab: 'Direitos',
            rights_empty: 'Nenhum direito do titular de dados definido para este quadro.',
            rights_code: 'Código',
            rights_name: 'Direito',
            rights_legal_basis: 'Base legal',
            rights_elaborating_articles: 'Artigos detalhados',
            rights_description: 'Descrição',
            requirements_reference: 'Referência',
            requirements_mandatory: 'Obrigatório',
            requirements_yes: 'Yes',
            requirements_no: 'No',
            requirements_source: 'Fonte',
            category_legal_basis: 'Base jurídica',
            category_data_subject_rights: 'Direitos do Titular dos Dados',
            category_notification: 'Notificação',
            category_assessment: 'Avaliação',
            category_governance: 'Governança',
            category_record_keeping: 'Manutenção de registros',
            category_cross_border: 'Transfronteiriço',
            category_technical_measures: 'Medidas Técnicas',
            category_incident_reporting: 'Relatório de incidentes',
            category_risk_management: 'Gestão de Risco',
            category_supply_chain: 'Cadeia de Suprimentos',
            category_certification: 'Certificação',
            child_frameworks: '[[TOK_1]] estrutura filha',
            child_frameworks_plural: '[[TOK_1]] estruturas filhas',
            replaces_prefix: 'Substitui:',
            replaced_by_prefix: 'Substituído por:',
            responsible_prefix: 'Responsável:',
            watchlist_empty_hint: 'Frameworks com status “rascunho” ou “próximo” aparecerão aqui para monitoramento.',
            framework_count: 'Estrutura [[TOK_1]]',
            framework_count_plural: 'Estruturas [[TOK_1]]',
            hiding_legacy: '(ocultando [[TOK_1]] legado)',
            label_VN_PDPL: '[[TOK_0]] (Decreto 13/2023)',
            label_VN_PDPD_DECREE_13: 'Decreto PDPD 13/2023',
            label_VN_PDPL_LAW_2025: '[[TOK_0]] Lei 91/2025',
            label_VN_PDPL_DECREE_356_2025: 'Decreto [[TOK_0]]',
            label_VN_PDPL_ADMIN_PROCEDURES_778_2026: 'QĐ 778/QĐ-BCA-A05',
            label_VN_PDPL_ENFORCEMENT_DRAFT_2026: '[[TOK_0]] Minuta de Execução 2026',
            label_VN_MOPS_ADMIN_SIMPLIFICATION_NQ22_2026: 'NQ22 Temporary Overlay 2026',
            label_VN_DATA_LAW: 'Lei de Dados',
            label_VN_DATA_LAW_DECREE_165_2025: 'Decreto-Lei de Dados 165/2025',
            label_VN_DATA_EXCHANGES_DRAFT_2026: 'Rascunho de bolsas de dados 2026',
            label_VN_TELECOM_LAW_2023: 'Lei das Telecomunicações 2023',
            label_VN_TELECOM_DECREE_163_2024: 'Decreto de Telecomunicações 163/2024',
            label_VN_CYBERSEC_LAW: 'Lei da Cibersegurança (24/2018)',
            label_VN_CYBERSEC_DECREE_53: 'Decreto Cibersec 53/2022',
            label_VN_CYBERSEC_LAW_2025: 'Lei de Cibersegurança 116/2025',
            label_VN_ECOMMERCE_LAW_2025: 'Lei do Comércio Eletrónico 122/2025',
            label_VN_AI_LAW_2026: '[[TOK_0]] Lei 2026',
            label_VN_AI_DECREE_142_2026: '[[TOK_0]] Decree 142/2026/NĐ-CP',
            issuer_company: 'Empresa',
            issuer_authority_a05_mps: 'MPS/A05',
            issuer_authority_mic: 'MIC',
            issuer_authority_mps_ndc: 'MPS/NDC',
            issuer_other_authority: 'Autoridade',
            sla_type_rights_request_ack: 'Reconhecimento de solicitação de direitos',
            'sla_type_Access control review': 'Revisão de controle de acesso',
            'sla_type_Annual governance attestation': 'Atestado anual de governança',
            'sla_type_Audit review cycle': 'Ciclo de revisão de auditoria',
            'sla_type_Authority request response': 'Resposta de solicitação de autoridade',
            'sla_type_Change notification processing': 'Alterar processamento de notificação',
            'sla_type_Complaint acknowledgment': 'Reconhecimento da reclamação',
            'sla_type_Complaint resolution': 'Resolução de reclamações',
            'sla_type_Confidentiality policy review': 'Revisão da política de confidencialidade',
            'sla_type_Cybersecurity incident full report': 'Relatório completo de incidente de segurança cibernética',
            'sla_type_Cybersecurity incident initial report': 'Relatório inicial de incidente de segurança cibernética',
            'sla_type_Data inventory review': 'Revisão do inventário de dados',
            'sla_type_Disclosure log review cycle': 'Ciclo de revisão do registro de divulgação',
            'sla_type_Incident classification decision': 'Decisão de classificação de incidente',
            'sla_type_Information system classification review': 'Revisão da classificação do sistema de informação',
            'sla_type_Notification processing (sales website/app)': 'Processamento de notificações (site/aplicativo de vendas)',
            'sla_type_Pen test cycle': 'Ciclo de teste de caneta',
            'sla_type_Registration processing (service platform)': 'Processamento de registro (plataforma de serviço)',
            'sla_type_Risk assessment cycle': 'Ciclo de avaliação de risco',
            'sla_type_Takedown decision (after review)': 'Decisão de remoção (após revisão)',
            'sla_type_Termination notice (public)': 'Aviso de rescisão (público)',
            sla_type_ai_impact_assessment_completion: '[[TOK_0]] conclusão da avaliação de impacto',
            sla_type_ai_sandbox_application_review: '[[TOK_0]] análise do aplicativo sandbox',
            sla_type_ai_serious_incident_report: '[[TOK_0]] relatório de incidente grave',
            sla_type_ai_system_registration: '[[TOK_0]] registro do sistema',
            sla_type_authority_request_response: 'Resposta de solicitação de autoridade',
            sla_type_certificate_issuance_review: 'Revisão de emissão de certificado',
            sla_type_complaint_handling_approach_notice: 'Aviso de abordagem para tratamento de reclamações',
            sla_type_complaint_incomplete_info_request: 'Solicitação de informações incompleta da reclamação',
            sla_type_data_governance_attestation: 'Atestado de governança de dados',
            sla_type_dsr_acknowledgment: 'Reconhecimento de DSR',
            sla_type_dsr_cl2_withdraw_restrict_object: 'DSR (Cl.2) — Retirar/restringir/objetar',
            sla_type_dsr_cl2_withdraw_restrict_object_third_party: 'DSR (Cl.2) — Terceiros',
            sla_type_dsr_cl3_access_correct_provide: 'DSR (Cl.3) — Acessar/corrigir/fornecer',
            sla_type_dsr_cl3_access_correct_provide_third_party: 'DSR (Cl.3) — Terceiros',
            sla_type_dsr_cl4_deletion: 'DSR (Cl.4) — Exclusão',
            sla_type_dsr_cl4_deletion_third_party: 'DSR (Cl.4) — Exclusão, terceiro',
            sla_type_dsr_cl5_protective_measures: 'DSR (Cl.5) — Medidas de proteção',
            sla_type_telecom_authority_request_response: 'Resposta de solicitação de autoridade de telecomunicações',
            sla_type_rights_request_completion: 'Conclusão da solicitação de direitos',
            sla_type_incident_authority_notification: 'Notificação de autoridade de incidente',
            sla_type_incident_subject_notification: 'Notificação do assunto do incidente',
            sla_type_dpia_completion: '[[TOK_0]] conclusão',
            sla_type_data_retention_review: 'Revisão de retenção de dados',
            sla_type_authority_filing_review: 'Revisão de arquivamento de autoridade',
            sla_type_authority_supplement_response: 'Resposta do suplemento de autoridade',
            sla_type_authority_resubmission: 'Reenvio de autoridade',
            sla_type_authority_filing_supplement_response: 'Resposta do suplemento de arquivamento da autoridade',
            sla_type_authority_filing_resubmission: 'Reenvio de pedido de autoridade',
            unit_working_days: 'dias úteis',
            unit_calendar_days: 'dias corridos',
            unit_hours: 'horas',
            form_category_dpa: 'APD',
            form_category_dsr: 'DSR',
            form_category_consent: 'Consentimento',
            form_category_privacy: 'Privacidade',
            form_category_breach: 'Violação',
            form_category_dpia: '[[TOK_0]]',
            form_category_register: 'Cadastre-se',
            form_category_monitoring: 'Monitoramento',
            form_category_vendor: 'Fornecedor',
            form_category_org: 'Organizacional',
            form_category_sector: 'Setor',
            form_category_data_mapping: 'Mapeamento de dados',
            form_category_governance: 'Governança',
            form_category_incident: 'Incidente',
            form_category_authority_submission: 'Envio de autoridade',
            form_category_notice: 'Aviso',
            form_category_assessment_report: 'Relatório de Avaliação',
            form_category_request: 'Solicitação',
            form_category_dossier: 'Dossiê',
            form_category_filing: 'Arquivamento',
            module_consent: 'Consentimento',
            module_rights_request: 'Solicitação de direitos',
            module_classification: 'Classificação',
            module_dpia: '[[TOK_0]]',
            module_governance: 'Governança',
            module_monitoring: 'Monitoramento',
            module_register: 'Cadastre-se',
            module_risk: 'Risco',
            module_data_mapping: 'Mapeamento de dados',
            module_incident: 'Incidente',
            module_assessment: 'Avaliação',
            module_vendor: 'Fornecedor',
            module_policy: 'Política',
            module_audit: 'Auditoria',
            module_training: 'Treinamento',
            module_discovery: 'Descoberta',
            enum_guidance_type_calculation_guidance: 'Orientação de cálculo',
            enum_guidance_type_implementation_guidance: 'Orientação de implementação',
            enum_guidance_type_interpretive_note: 'Nota Interpretativa',
            enum_guidance_type_legal_guidance: 'Orientação Jurídica',
            enum_guidance_type_procedural_guidance: 'Orientação Processual',
            enum_guidance_type_sector_guidance: 'Orientação Setorial',
            enum_guidance_type_technical_methodology: 'Metodologia Técnica',
            enum_guidance_category_annual_reporting: 'Relatório Anual',
            enum_guidance_category_authority_cooperation: 'Cooperação de Autoridade',
            enum_guidance_category_authority_coordination: 'Coordenação de Autoridade',
            enum_guidance_category_business_continuity: 'Continuidade de Negócios',
            enum_guidance_category_capital_adequacy: 'Adequação de capital',
            enum_guidance_category_complaint_handling: 'Tratamento de reclamações',
            enum_guidance_category_consent: 'Consentimento',
            enum_guidance_category_consent_management: 'Gerenciamento de consentimento',
            enum_guidance_category_consumer_protection: 'Defesa do Consumidor',
            enum_guidance_category_control_environment: 'Ambiente de controle',
            enum_guidance_category_cross_border: 'Transfronteiriço',
            enum_guidance_category_cross_border_transfers: 'Transferências transfronteiriças',
            enum_guidance_category_data_classification: 'Classificação de dados',
            enum_guidance_category_data_localization: 'Localização de dados',
            enum_guidance_category_data_protection_impact_assessment: 'Avaliação de impacto na proteção de dados',
            enum_guidance_category_direct_marketing: 'Marketing Direto',
            enum_guidance_category_dpia: 'DPIA',
            enum_guidance_category_governance: 'Governança',
            enum_guidance_category_ict_risk_management: 'Gestão de riscos de TIC',
            enum_guidance_category_incident_management: 'Gerenciamento de Incidentes',
            enum_guidance_category_internal_audit: 'Auditoria Interna',
            enum_guidance_category_isms_documentation: 'Documentação do SGSI',
            enum_guidance_category_lawful_basis: 'Base Legal',
            enum_guidance_category_licensing: 'Licenciamento',
            enum_guidance_category_local_presence: 'Presença Local',
            enum_guidance_category_logging_and_retention: 'Registro e retenção',
            enum_guidance_category_logical_and_physical_access: 'Acesso lógico e físico',
            enum_guidance_category_operational_resilience_testing: 'Teste de resiliência operacional',
            enum_guidance_category_outsourcing: 'Terceirização',
            enum_guidance_category_platform_registration: 'Cadastro na plataforma',
            enum_guidance_category_quality_of_service: 'Qualidade de Serviço',
            enum_guidance_category_risk_classification: 'Classificação de Risco',
            enum_guidance_category_risk_management: 'Gestão de Risco',
            enum_guidance_category_scope_definition: 'Definição de escopo',
            enum_guidance_category_sectoral_localisation: 'Localização Setorial',
            enum_guidance_category_subscriber_protection: 'Proteção do Assinante',
            enum_guidance_category_supply_chain: 'Cadeia de Suprimentos',
            enum_guidance_category_system_classification: 'Classificação do Sistema',
            enum_guidance_category_system_operations: 'Operações do sistema',
            enum_guidance_category_telecommunications_data: 'Dados de Telecomunicações',
            enum_guidance_category_third_party_risk: 'Risco de Terceiros',
            enum_guidance_category_transitional_provisions: 'Disposições Transitórias',
            enum_guidance_category_vulnerability_management: 'Gerenciamento de vulnerabilidades',
            enum_guidance_status_active: 'Ativo',
            enum_guidance_status_draft: 'Rascunho',
            enum_module_access_management: 'Gerenciamento de acesso',
            enum_module_ai_governance: '[[TOK_0]] Governança',
            enum_module_asset_management: 'Gestão de Ativos',
            enum_module_audit_trail: 'Trilha de auditoria',
            enum_module_breach_notification: 'Notificação de violação',
            enum_module_capital_adequacy: 'Adequação de capital',
            enum_module_classification: 'Classificação',
            enum_module_consent: 'Consentimento',
            enum_module_consent_management: 'Gerenciamento de consentimento',
            enum_module_cross_border_transfers: 'Transferências transfronteiriças',
            enum_module_data_localization: 'Localização de dados',
            enum_module_data_mapping: 'Mapeamento de dados',
            enum_module_data_protection: 'Proteção de Dados',
            enum_module_data_subject_rights: 'Direitos do Titular dos Dados',
            enum_module_dpia: 'DPIA',
            enum_module_encryption: 'Criptografia',
            enum_module_governance: 'Governança',
            enum_module_incident: 'Incidente',
            enum_module_incident_management: 'Gerenciamento de Incidentes',
            enum_module_internal_audit: 'Auditoria Interna',
            enum_module_isms_documentation: 'Documentação do SGSI',
            enum_module_isms_governance: 'Governança do SGSI',
            enum_module_logging_and_monitoring: 'Registro e monitoramento',
            enum_module_monitoring: 'Monitoramento',
            enum_module_policy_management: 'Gerenciamento de Políticas',
            enum_module_risk: 'Risco',
            enum_module_risk_management: 'Gestão de Risco',
            enum_module_training: 'Treinamento',
            enum_module_vendor: 'Fornecedor',
            enum_module_vendor_management: 'Gestão de Fornecedores',
            enum_module_vendor_risk: 'Risco do fornecedor',
            enum_module_vulnerability_management: 'Gerenciamento de vulnerabilidades',
            category_access: 'Acesso',
            category_availability: 'Disponibilidade',
            category_change_management: 'Gestão de Mudanças',
            category_classification: 'Classificação',
            category_communication_and_information: 'Comunicação e Informação',
            category_compliance: 'Conformidade',
            category_confidentiality: 'Confidencialidade',
            category_control_activities: 'Atividades de controle',
            category_control_environment: 'Ambiente de controle',
            category_incident: 'Incidente',
            category_internal_audit: 'Auditoria Interna',
            category_internal_control: 'Controle Interno',
            category_logical_and_physical_access: 'Acesso lógico e físico',
            category_mis_data: 'Dados do Sistema de Informação de Gestão',
            category_monitoring: 'Monitoramento',
            category_monitoring_activities: 'Atividades de monitoramento',
            category_outsourcing: 'Terceirização',
            category_privacy: 'Privacidade',
            category_processing_integrity: 'Integridade de Processamento',
            category_reporting: 'Relatórios',
            category_risk_assessment: 'Avaliação de Risco',
            category_risk_mitigation: 'Mitigação de riscos',
            category_sector_applicability: 'Aplicabilidade Setorial',
            category_system_operations: 'Operações do sistema',
            category_training: 'Treinamento',
            category_vendor: 'Fornecedor',
            guidance_related_forms_advisory: 'Alguns formulários possuem orientações relacionadas — veja no',
            guidance_related_procedures_advisory: 'Alguns procedimentos possuem orientações relacionadas — veja no',
            guidance_related_requirements_advisory: 'Alguns requisitos têm orientações relacionadas — veja no',
        },
        channels: {
            title: 'Canais de submissão e prazos',
            channels: 'Canais de submissão',
            add_channel: 'Adicionar canal',
            channel_type: 'Tipo',
            name: 'Nome',
            instructions: 'Instruções',
            active: 'Ativo',
            no_channels: 'Nenhum canal de submissão configurado',
            portal: 'Portal',
            in_person: 'Presencial',
            postal: 'Postal',
            email: 'E-mail',
            add: 'Adicionar',
            deadlines: 'Prazos regulatórios',
            add_deadline: 'Adicionar prazo',
            label: 'Rótulo',
            days: 'Dias',
            day_type: 'Tipo de dia',
            calendar_days: 'Dias corridos',
            working_days: 'Dias úteis',
            no_deadlines: 'Nenhum prazo configurado',
            description: 'Descrição',
            failed_load: 'Falha ao load channel data',
            channel_added: 'Canal adicionado',
            channel_added_announce: 'Canal de submissão adicionado',
            failed_add_channel: 'Falha ao add channel',
            deadline_added: 'Prazo adicionado',
            deadline_added_announce: 'Prazo regulatório adicionado',
            failed_add_deadline: 'Falha ao add deadline',
        },
        module_links: {
            title: 'Vinculação da estrutura',
            modules: 'Módulos vinculados',
            add_module: 'Adicionar módulo',
            module_code: 'Código do módulo',
            required: 'Obrigatório',
            link: 'Vincular',
            no_modules: 'Nenhum módulo vinculado',
            notes: 'Notas',
            personas: 'Personas vinculados',
            add_persona: 'Adicionar persona',
            persona_id: 'ID do persona',
            role_description: 'Descrição do papel',
            no_personas: 'Nenhum persona vinculado',
            failed_load: 'Falha ao load framework links',
            module_linked: 'Módulo vinculado',
            module_linked_announce: 'Módulo vinculado com sucesso',
            failed_link_module: 'Falha ao link module',
            persona_linked: 'Persona vinculado',
            persona_linked_announce: 'Persona vinculado com sucesso',
            failed_link_persona: 'Falha ao link persona',
        },
        regulatory_updates: {
            statuses: {
                pending: 'Pendente',
                assessed: 'Avaliado',
                applied: 'Aplicado',
                dismissed: 'Descartado',
            },
            title: 'Atualizações regulatórias e painel de estruturas',
            page_description: 'Coverage at a glance for every installed regulatory framework, plus the in-product change log of regulatory updates: amendments, effective dates, and impact assessments. [PT]',
            coverage_dashboard: 'Painel de cobertura da estrutura',
            no_frameworks: 'Nenhuma estrutura encontrada',
            framework: 'Estrutura',
            modules: 'Módulos',
            templates: 'Modelos',
            forms: 'Formulários',
            channels: 'Canais',
            deadlines: 'Prazos',
            pending: 'Atualizações pendentes',
            updates: 'Atualizações regulatórias',
            create_update: 'Criar atualização',
            framework_id: 'ID da estrutura',
            update_title: 'Título',
            description: 'Descrição',
            effective_date: 'Data de vigência',
            amendment_ref: 'Referência de alteração',
            create: 'Criar',
            no_updates: 'Sem atualizações regulatórias',
            status: 'Estado',
            impact: 'Impacto',
            change_summary: 'Resumo das alterações',
            assess: 'Avaliar',
            failed_load: 'Falha ao load data',
            update_created: 'Atualização criada',
            update_created_announce: 'Atualização regulatória criada',
            failed_create: 'Falha ao create update',
            update_assessed: 'Atualização avaliada',
            failed_assess: 'Falha ao assess update',
        },
        sector_overlay: {
            sector_labels: {
                banking: 'Banking [PT]',
                insurance: 'Insurance [PT]',
                healthcare: 'Healthcare [PT]',
                ict_critical: 'Critical ICT [PT]',
                telecom: 'Telecommunications [PT]',
                energy: 'Energy [PT]',
                transport: 'Transport [PT]',
                digital_services: 'Digital services [PT]',
                digital_technology_industry: 'Indústria de tecnologia digital',
                public_administration: 'Public administration [PT]',
                payments: 'Payments [PT]',
                other: 'Other [PT]',
            },
            sector_label: 'Sector [PT]',
            direct_scope_label: 'Direct legal scope [PT]',
            chip_direct: 'Directly applicable [PT]',
            chip_reference: 'Reference only [PT]',
            banner_direct_copy: 'Directly applicable to your organization. Sector reports and deadlines are active. [PT]',
            banner_reference_copy: 'Reference only — your organization is not classified in this sector. [PT]',
            edit_mode_button: 'Edit mode [PT]',
            edit_form_title: 'Change install mode [PT]',
            mode_direct_label: 'Direct — legally applicable [PT]',
            mode_direct_help: 'Schedules sector deadlines and dashboard widgets. [PT]',
            mode_reference_label: 'Reference only [PT]',
            mode_reference_help: 'Browseable but no deadlines or widgets. [PT]',
            reason_note_label: 'Reason (optional) [PT]',
            reason_note_placeholder: 'e.g. Bank subsidiary acquired [PT]',
            cancel: 'Cancel [PT]',
            confirm: 'Confirm [PT]',
            confirming: 'Saving… [PT]',
            save: 'Save [PT]',
            saving: 'Saving… [PT]',
            toast_mode_changed: 'Sector overlay mode updated. [PT]',
            toast_installed: 'Sector overlay installed. [PT]',
            toast_sectors_saved: 'Sector self-identification saved. [PT]',
            install_modal_title: 'Install sector overlay [PT]',
            install_modal_intro: 'Sector overlays are opt-in regulatory packs scoped to a single industry. [PT]',
            install_modal_footer: 'You can change install mode later from the framework detail page. [PT]',
            install_button: 'Install [PT]',
            installed_label: 'Installed [PT]',
            uninstall_button: 'Desinstalar',
            uninstall_confirm: 'Confirmar desinstalação',
            uninstall_cancel: 'Cancelar',
            suggested_label: 'Suggested [PT]',
            catalog_page_title: 'Sector overlays [PT]',
            catalog_page_intro: 'Optional regulatory packs scoped to a single industry sector. [PT]',
            catalog_empty_title: 'No sector overlays available [PT]',
            catalog_empty_description: 'Sector overlay packs published in your platform will appear here. [PT]',
            authority_label: 'Authority [PT]',
            org_sectors_title: 'Industry sectors [PT]',
            org_sectors_intro: 'Select the industry sectors your organization operates in. [PT]',
            widget_title: 'Sector overlay reports due [PT]',
            widget_aria_label: 'Sector overlay reports due [PT]',
            widget_empty: 'No upcoming sector overlay deadlines. [PT]',
            audit_event_mode_changed: 'Sector overlay install mode changed [PT]',
            audit_event_installed: 'Sector overlay installed [PT]',
            view_details_button: 'View details → [PT]',
            banner_aria_label: 'Sector overlay status [PT]',
            toast_load_failed: 'Failed to load sector overlays [PT]',
            toast_install_failed: 'Failed to install sector overlay [PT]',
            toast_uninstall_confirm_required: 'Type "{packCode}" to confirm uninstall. [PT]',
            toast_uninstalled: 'Uninstalled {packCode}. [PT]',
            toast_uninstall_failed: 'Failed to uninstall sector overlay [PT]',
            uninstall_warning_destructive_label: 'Destructive action. [PT]',
            uninstall_warning_body: 'Uninstalling will delete the framework record and any persisted regulatory deadlines tied to {frameworkCode} from this organisation. [PT]',
            uninstall_warning_type_to_confirm: 'Type {packCode} to confirm. [PT]',
            uninstall_in_progress: 'Uninstalling… [PT]',
            widget_view_all: 'View all sector overlays → [PT]',
            widget_due_in_days: 'Due in {days}d [PT]',
            widget_overdue_days: 'Overdue by {days}d [PT]',
            widget_due_today: 'Due today [PT]',
            widget_due_unknown: '— [PT]',
        },
        phased_obligations: {
            panel_title: 'Phased obligations [PT]',
            panel_aria_label: 'Phased obligations [PT]',
            panel_intro: 'Some clauses in this framework activate later than the framework itself. [PT]',
            phased_effective_date_label: 'Phased effective: [PT]',
            status_pending: 'Pending [PT]',
            status_active: 'Active [PT]',
            status_early: 'Active (early-implemented) [PT]',
            notice_window_label: 'Authority notice window: [PT]',
            days_label: 'days [PT]',
            recipient_label: 'Recipient: [PT]',
            early_implement_button: 'Mark early-implemented [PT]',
            early_implement_modal_title: 'Mark phased obligation as early-implemented [PT]',
            early_implement_modal_intro: 'Recording an early implementation activates the obligation now and schedules the regulator notice timer. [PT]',
            effective_at_label: 'Effective from [PT]',
            reason_label: 'Reason (optional) [PT]',
            reason_placeholder: 'e.g. Board approved early adoption 2026-09-01 [PT]',
            confirm: 'Confirm [PT]',
            toast_early_implemented: 'Early implementation recorded. [PT]',
            audit_event_early_implemented: 'Phased obligation marked early-implemented [PT]',
            widget_rolling_window_label: 'Phased activations within 90 days [PT]',
        },
    },
    partner_marketplace: {
        nav: {
            dashboard: 'Painel de controlo',
            partner_orgs: 'Organizações parceiras',
            service_tiers: 'Níveis de serviço',
            deliverable_templates: 'Modelos de entregáveis',
            deliverables: 'Entregáveis',
            brand_profiles: 'Perfis de marca',
            support_tickets: 'Tickets de suporte',
            workflow_templates: 'Modelos de fluxo de trabalho',
            workflows: 'Fluxos de trabalho',
            escalation: 'Escalamento',
            reports: 'Relatórios',
            audit: 'Registo de auditoria',
        },
        dashboard: {
            title: 'Painel de parceiros',
            loading: 'A carregar dashboard data...',
            total_managed_tenants: 'Total de inquilinos geridos',
            avg_health_score: 'Avg Saúde Pontuação',
            open_tickets: 'Tickets abertos',
            upcoming_deliverables: 'Entregáveis futuros',
            escalated_tickets: 'Tickets escalados',
            managed_tenants: 'Inquilinos geridos',
            partner_tier: 'Parceiro Nível',
            managed_tenants_count: 'Contagem de inquilinos geridos',
            onboarding_date: 'Data de integração',
            view_details: 'Ver detalhes',
            no_partner_orgs: 'Nenhum partner organizations encontrado',
        },
        partner_orgs: {
            title: 'Organizações parceiras',
            new: 'Novo Partner Org',
            contact_name: 'Contacto Nome',
            contact_email: 'Contacto E-mail',
            partner_tier: 'Parceiro Nível',
            managed_orgs: 'Organizações geridas',
            onboarding_date: 'Data de integração',
            no_orgs: 'Nenhum partner organizations encontrado',
            contact_phone: 'Contacto Telefone',
            metadata_json: 'Metadados (JSON)',
            change_status: 'Alterar estado',
            new_status: 'Novo estado',
            invalid_json_metadata: 'JSON inválido no campo de metadados',
            suspended: 'Suspenido',
            offboarded: 'Desintegrado',
            all_tiers: 'Todos os níveis',
            silver: 'Prata',
            gold: 'Ouro',
            platinum: 'Platina',
            status_offboarded: 'Desintegrado',
            status_suspended: 'Suspenido',
            tier_gold: 'Ouro',
            tier_platinum: 'Platina',
            tier_silver: 'Prata',
        },
        service_tiers: {
            title: 'Níveis de serviço',
            new: 'Novo nível',
            tier_name: 'Nível Nome',
            monthly_fee: 'Mensalidade',
            features: 'Funcionalidades',
            no_tiers: 'Nenhum service tiers encontrado',
            tier_code: 'Código de nível',
            user_seats: 'Lugares de utilizador',
            user_seat_limit: 'Limite de licenças de utilizador',
            storage_gb: 'Armazenamento (GB)',
            storage_limit_gb: 'Limite de armazenamento (GB)',
            response_time_hrs: 'Resposta Hora (hrs)',
            resolution_time_hrs: 'Tempo de resolução (horas)',
            review_frequency: 'Rever Frequência',
            sla_response_time: 'SLA Resposta Hora (hours)',
            sla_resolution_time: 'SLA Resolution Hora (hours)',
            module_profile_json: 'Perfil do módulo (JSON)',
            comparing: 'A comparar...',
            compare: 'Comparar',
            comparison: 'Comparação de níveis de serviço',
            attribute: 'Atributo',
            deprecate: 'Tornar obsoleto',
            deprecated: 'Obsoleto',
            invalid_json_module: 'JSON inválido no campo de perfil do módulo',
            select_compare: 'Selecione at least 2 tiers to compare',
            comparison_title: 'Comparação de níveis de serviço',
            status_deprecated: 'Obsoleto',
            activate: 'Ativar',
            invalid_json_module_profile: 'JSON inválido no perfil do módulo',
            resolution_time: 'Tempo de resolução',
            response_time: 'Resposta Hora',
            select_at_least_two: 'Selecione at least 2 tiers',
        },
        deliverable_templates: {
            title: 'Modelos de entregáveis',
            new: 'Novo modelo',
            template_name: 'Modelo Nome',
            deliverable_type: 'Tipo de entregável',
            no_templates: 'Nenhum deliverable templates encontrado',
            frequency: 'Frequência',
            est_effort_hrs: 'Esforço est. (h)',
            estimated_effort: 'Esforço estimado (horas)',
            associated_module: 'Módulo associado',
            linked_tiers_count: 'Contagem de níveis ligados',
            evidence_requirements: 'Requisitos de evidência (separados por vírgulas)',
            tier_ids: 'IDs de níveis (separados por vírgulas)',
            frequency_one_time: 'Uma vez',
            frequency_monthly: 'Mensal',
            frequency_quarterly: 'Trimestral',
            frequency_annually: 'Anualmente',
            type_report: 'Relatório',
            type_review: 'Rever',
            type_assessment: 'Avaliação',
            type_meeting: 'Reunião',
            type_configuration: 'Configuração',
            freq_one_time: 'Uma vez',
            freq_monthly: 'Mensal',
            freq_quarterly: 'Trimestral',
            freq_annually: 'Anualmente',
            status_deprecated: 'Obsoleto',
        },
        deliverables: {
            title: 'Entregáveis',
            new: 'Novo Deliverable',
            partner: 'Parceiro',
            deliverable_type: 'Tipo de entregável',
            due_date: 'Data de vencimento',
            no_deliverables: 'Nenhum deliverables encontrado',
            assigned_to: 'Atribuído Para',
            completion_date: 'Data de conclusão',
            update_status: 'Atualizar Estado',
            hide_details: 'Ocultar Detalhes',
            view_details: 'Ver detalhes',
            evidence_ids: 'IDs de evidências',
            client_approval: 'Aprovação do cliente',
            bulk_update: 'Atualização em massa',
            bulk_update_status: 'Bulk Atualizar Estado',
            generate_schedule: 'Gerar Agendar',
            generate_deliverable_schedule: 'Gerar Deliverable Agendar',
            organization_id: 'Organização ID',
            service_tier_id: 'ID do nível de serviço',
            filter_assigned_to: 'Filtrar por Atribuído Para',
            select_status: 'Selecione status...',
            new_status: 'Novo estado',
            upcoming: 'Futuro',
            overdue: 'Em atraso',
            status_deferred: 'Adiado',
            status_overdue: 'Em atraso',
            status_upcoming: 'Futuro',
        },
        brand_profiles: {
            title: 'Perfis de marca',
            new: 'Novo Brand Profile',
            partner: 'Parceiro',
            brand_name: 'Nome da marca',
            primary_color: 'Cor primária',
            logo_url: 'URL do logótipo',
            no_profiles: 'Nenhum brand profiles encontrado',
            secondary_color: 'Cor secundária',
            header_text: 'Texto do cabeçalho',
            footer_text: 'Texto do rodapé',
            contact_email: 'Contacto E-mail',
            contact_phone: 'Contacto Telefone',
            contact_website: 'Site web de contacto',
            contact_address: 'Contacto Endereço',
            is_default: 'É Predefinido',
            set_default: 'Definir predefinição',
            preview: 'Pré-visualização',
            report_header_preview: 'Pré-visualização do cabeçalho do relatório',
            report_footer_preview: 'Pré-visualização do rodapé do relatório',
            preview_description: 'Esta é uma pré-visualização do cabeçalho do relatório com as cores de marca selecionadas.',
            contact_website_short: 'Site web',
            logo_preview: 'Pré-visualização do logótipo',
        },
        support_tickets: {
            title: 'Tickets de suporte',
            new: 'Novo Ticket',
            partner: 'Parceiro',
            subject: 'Titular',
            assigned_to: 'Atribuído Para',
            no_tickets: 'Nenhum support tickets encontrado',
            category: 'Categoria',
            priority: 'Prioridade',
            escalation_tier: 'Escalamento Nível',
            sla_status: 'SLA Estado',
            update_status: 'Atualizar Estado',
            escalate: 'Escalar',
            add_note: 'Adicionar Note',
            escalate_ticket: 'Escalar ticket',
            escalate_to_tier: 'Escalar Para Nível',
            notes_timeline: 'Linha cronológica de notas',
            no_notes: 'Sem notas ainda.',
            attachments: 'Anexos',
            no_attachments: 'Sem anexos.',
            client_org_id: 'ID Org. do cliente',
            content: 'Conteúdo',
            note_type: 'Tipo',
            view_detail: 'Ver Detail',
            hide: 'Ocultar',
            new_status: 'Novo estado',
            all_categories: 'Todas as categorias',
            all_priorities: 'Todas as prioridades',
            all_tiers: 'Todos os níveis',
            ticket_not_found: 'Ticket não encontrado',
            ticket_id: 'ID do ticket',
            client_org: 'Org. do cliente',
            deescalate: 'Desescalar',
            deescalate_ticket: 'Desescalar o ticket',
            deescalate_to_tier: 'De-escalate Para Nível',
            add_attachment: 'Adicionar anexo',
            file: 'Ficheiro',
            linked_entity: 'Entidade ligada',
            sla_target: 'Destino',
            breached: 'Violado',
            remaining_hours: 'restantes',
            na: 'N/A',
            tickets_found: 'tickets encontrados',
            reason: 'Motivo',
            target: 'Destino',
            upload: 'Carregar',
        },
        workflow_templates: {
            title: 'Modelos de fluxo de trabalho',
            new: 'Novo modelo',
            template_name: 'Modelo Nome',
            steps: 'Passos',
            no_templates: 'Nenhum workflow templates encontrado',
            category: 'Categoria',
            view_steps: 'Ver Steps',
            hide_steps: 'Ocultar passos',
            step: 'Passo',
            step_title: 'Título',
            step_description: 'Descrição',
            assignee_role: 'Atribuído Papel',
            sla_hours: 'Horas SLA',
            evidence_required: 'Evidência Obrigatório',
            guidance_notes: 'Notas de orientação',
            add_step: 'Adicionar Step',
            no_steps: 'Sem passos definidos.',
            no_steps_defined: 'Sem passos definidos.',
            templates_found: 'modelos encontrados',
            all_categories: 'Todas as categorias',
        },
        workflows: {
            title: 'Instâncias de fluxo de trabalho',
            new: 'Novo fluxo de trabalho',
            template: 'Modelo',
            partner: 'Parceiro',
            current_step: 'Passo atual',
            progress: 'Progresso',
            no_workflows: 'Nenhum workflow instances encontrado',
            instances_found: 'instâncias encontradas',
        },
        escalation: {
            title: 'Escalamento Painel de controlo',
            ticket: 'Bilhete',
            partner: 'Parceiro',
            escalated_at: 'Escalado em',
            reason: 'Motivo',
            no_escalations: 'Nenhum escalations encontrado',
            time_in_tier: 'Hora em Nível',
            auto_evaluate: 'Avaliação auto.',
            priority_critical: 'Crítico',
            priority_high: 'Alto',
            priority_medium: 'Médio',
            priority_low: 'Low',
            deescalated_from_dashboard: 'Desescalado do painel',
            sla_breached: 'SLA violado',
            sla_remaining: 'SLA restante',
        },
        reports: {
            title: 'Relatórios',
            partner: 'Parceiro',
            report_type: 'Relatório Tipo',
            generated_at: 'Gerado em',
            no_reports: 'Nenhum reports encontrado',
            generate: 'Gerar Relatório',
        },
        audit: {
            title: 'Parceiro Auditoria Trail',
            event_type: 'Evento Tipo',
            entity_type: 'Tipo de entidade',
            entity_id: 'ID da entidade',
            actor: 'Ator',
            timestamp: 'Marca temporal',
            no_events: 'Nenhum audit events encontrado',
            events_found: 'eventos encontrados',
            event_type_created: 'Criado',
            event_type_updated: 'Atualizado',
            event_type_deleted: 'Excluído',
            event_type_status_change: 'Mudança de status',
            event_type_escalation: 'Escalada',
            event_type_assignment: 'Tarefa',
            entity_type_partner_org: 'Organização parceira',
            entity_type_service_tier: 'Nível de serviço',
            entity_type_deliverable_template: 'Modelo de entrega',
            entity_type_deliverable_instance: 'Instância de entrega',
            entity_type_brand_profile: 'Perfil da marca',
            entity_type_support_ticket: 'Tíquete de suporte',
            entity_type_workflow_template: 'Modelo de fluxo de trabalho',
            entity_type_workflow_instance: 'Instância de fluxo de trabalho',
            entity_type_generated_report: 'Relatório gerado',
            entity_type_escalation_rule: 'Regra de escalonamento',
        },
        no_permission_title: 'Permissões insuficientes',
        no_permission_message: 'Você não tem permissão para acessar o espaço de trabalho do parceiro.',
        status_active: 'Ativo',
        status_suspended: 'Suspenso',
        status_offboarded: 'Offboard',
        status_completed: 'Concluído',
        status_cancelled: 'Cancelado',
        status_deprecated: 'Obsoleto',
        status_new: 'Novo',
        status_triaged: 'Triagem',
        status_in_progress: 'Em andamento',
        status_waiting_on_client: 'Esperando no cliente',
        status_waiting_on_vendor: 'Esperando pelo fornecedor',
        status_escalated: 'Escalado',
        status_resolved: 'Resolvido',
        status_closed: 'Fechado',
        status_pending: 'Pendente',
        status_skipped: 'Ignorado',
        category_onboarding: 'Integração',
        category_incident_escalation: 'Escalação de Incidentes',
        category_config_change: 'Alteração de configuração',
        category_periodic_review: 'Revisão Periódica',
        category_offboarding: 'Desativação',
        category_custom: 'Personalizado',
        category_configuration: 'Configuração',
        category_incident: 'Incidente',
        category_compliance_question: 'Pergunta de conformidade',
        category_feature_request: 'Solicitação de recurso',
        category_bug_report: 'Relatório de erros',
        priority_critical: 'Crítico',
        priority_high: 'Alto',
        priority_medium: 'Médio',
        priority_low: 'Baixo',
        tier_silver: 'Prata',
        tier_gold: 'Ouro',
        tier_platinum: 'Platina',
        report_type_compliance_summary: 'Resumo de conformidade',
        report_type_risk_overview: 'Visão geral dos riscos',
        report_type_incident_report: 'Relatório de incidente',
        report_type_consent_status: 'Status de consentimento',
        report_type_program_maturity: 'Maturidade do Programa',
        report_type_executive_pack: 'Pacote Executivo',
        note_type_internal: 'Interno',
        note_type_client_visible: 'Cliente visível',
        status_updated: 'Status atualizado com sucesso',
        deliverable_status_updated: 'Status da entrega atualizado com sucesso',
        ticket_status_updated: 'Status do ticket atualizado com sucesso',
        ticket_escalated: 'Ticket escalado com sucesso',
        note_added: 'Nota adicionada com sucesso',
        attachment_uploaded: 'Anexo enviado com sucesso',
        ticket_deescalated: 'Ticket desescalado com sucesso',
        auto_evaluation_completed: 'Avaliação automática concluída',
        template_created: 'Modelo de fluxo de trabalho criado com sucesso',
        template_updated: 'Modelo de fluxo de trabalho atualizado com sucesso',
        brand_set_default: 'Perfil de marca definido como padrão com sucesso',
        brand_created: 'Perfil da marca criado com sucesso',
        brand_updated: 'Perfil da marca atualizado com sucesso',
        tier_created: 'Camada de serviço criada com sucesso',
        tier_updated: 'Camada de serviço atualizada com sucesso',
        tier_deprecated: 'Camada de serviço obsoleta com sucesso',
        tier_activated: 'Camada de serviço ativada com sucesso',
        period: 'Período',
        format: 'Formato',
        period_start: 'Início do período',
        period_end: 'Fim do período',
        reports_count: '[[TOK_1]] relatórios',
        reports_count_one: '[[TOK_1]] relatório',
        metric: 'Métrica',
        value: 'Valor',
        showing_chart_view: 'Mostrando visualização de gráfico',
        showing_table_view: 'Mostrando visualização da tabela de dados',
        evidence_ids_placeholder: 'por exemplo ev-001, ev-002',
        confirm_cancel_workflow: 'Tem certeza de que deseja cancelar este fluxo de trabalho? Esta ação não pode ser desfeita.',
        export_csv: 'Exportar [[TOK_0]]',
        compliance_qualifications_title: 'Qualificações de serviço de conformidade',
        compliance_qualifications_desc: 'O nível de parceiro (Silver/Gold/Platinum) determina o escopo do serviço de conformidade. Os parceiros Gold e Platinum estão qualificados para compromissos no setor regulamentado. Utilize o campo Metadados para registrar certificações (ISO 27001, SOC 2), especializações e qualificações jurisdicionais de cada parceiro.',
        regulatory_output_title: 'Alinhamento de Saída Regulatória',
        regulatory_output_desc: 'Cada tipo de modelo é mapeado para uma categoria de resultados regulatórios: Relatórios produzem documentação de conformidade, Revisões validam a eficácia do controle, Avaliações cobrem avaliações de risco ([[TOK_0]], análise de lacunas), Reuniões documentam sessões de governança. Os Requisitos de Evidência definem os artefatos que cada entrega deve referenciar para preparação para auditoria.',
        sla_compliance_title: '[[TOK_0]] Acompanhamento para entrega de conformidade',
        sla_compliance_desc: 'Os SLAs de tempo de resposta e resolução são contratualmente vinculativos para a prestação de serviços de conformidade. A frequência de revisão determina a frequência com que as entregas de conformidade dos parceiros são avaliadas. As violações de [[TOK_0]] em tickets críticos para conformidade acionam o escalonamento automático e são registradas na trilha de auditoria do parceiro para obter evidências regulatórias.',
        regulatory_engagement_title: 'Padrões de envolvimento regulatório',
        regulatory_engagement_desc: 'As categorias de fluxo de trabalho são mapeadas para tipos de envolvimento regulatório: a integração cobre a configuração inicial de conformidade e a análise de lacunas, a revisão periódica lida com avaliações de conformidade recorrentes, o escalonamento de incidentes gerencia a resposta a violações regulatórias, a exclusão garante que as obrigações de retenção de dados sejam cumpridas. Cada etapa pode exigir a coleta de evidências para a integridade da trilha de auditoria.',
        compliance_escalation_title: 'Procedimentos de escalonamento críticos para conformidade',
        compliance_escalation_desc: 'L1 lida com questões operacionais padrão. L2 cobre falhas que impactam a conformidade (prazos regulatórios não cumpridos, lacunas de controle). L3 é reservado para cenários de violação regulatória que exigem atenção executiva imediata. A violação [[TOK_0]] em tickets L2/L3 gera entradas de trilha de auditoria automaticamente. Todas as ações de escalonamento e desescalonamento são registradas permanentemente.',
        audit_regulatory_title: 'Trilha de evidências regulatórias',
        audit_regulatory_desc: 'Essa trilha de auditoria fornece registros invioláveis para conformidade regulatória. Cada ação do parceiro (criação, atualização, exclusão, escalonamento, mudança de status) é registrada com identidade do ator, carimbo de data/hora e diferença de carga útil completa. Use filtros de tipo de entidade para isolar evidências por domínio de conformidade. Exporte resultados filtrados para produzir documentação pronta para auditoria para inspeções regulatórias.',
        evidence_trail_title: 'Trilha de evidências entre módulos',
        evidence_trail_desc: 'Cada etapa do fluxo de trabalho pode coletar IDs de evidências vinculadas a resultados, eventos de auditoria e artefatos de conformidade em todos os módulos. Avançar uma etapa com IDs de evidências cria uma cadeia verificável que conecta fluxos de trabalho de parceiros à documentação regulatória. Fluxos de trabalho concluídos com cadeias de evidências completas servem como prova da entrega do compromisso de conformidade.',
        evidence_ids_label: 'IDs de evidências',
    },
    org_groups: {
        title: 'Grupos de organizações',
        new: 'Adicionar grupo',
        group_name: 'Grupo Nome',
        member_count: 'Contagem de membros',
        root_org: 'Organização raiz',
        no_groups: 'Nenhum org groups encontrado',
        add_organization: 'Adicionar Organização',
        select_organization: 'Selecione uma organização...',
        no_available_orgs: 'Nenhuma organização disponível para adicionar.',
        no_members: 'Nenhuma organização membro neste grupo.',
        member_added: 'Organização adicionada ao grupo.',
        member_removed: 'Organização removida do grupo.',
        already_in_group: 'Esta organização já pertence a um grupo.',
        org_not_found: 'Organização não encontrada.',
        add_member_error: 'Falha ao adicionar organização ao grupo.',
        remove_member_error: 'Falha ao remover organização do grupo.',
        confirm_remove_member: 'Tem a certeza de que pretende remover "{name}" deste grupo?',
        load_error: 'Falha ao carregar detalhes do grupo de organizações.',
        page_title_list: 'Grupos organizacionais',
        page_title_detail: 'Detalhes do grupo organizacional',
        page_title_create: 'Criar grupo organizacional',
        page_title_settings: 'Configurações do grupo organizacional',
        page_title_users: 'Usuários do grupo',
        page_title_reports: 'Relatórios de grupo',
        page_title_dashboard: 'Painel do grupo',
        page_title_audit: 'Auditoria de Grupo',
        page_title_org_audit: 'Auditoria de Grupo Organizacional',
        page_title_shared_vendors: 'Fornecedores Compartilhados',
        page_title_shared_frameworks: 'Estruturas Compartilhadas',
        page_title_shared_forms: 'Modelos de formulário compartilhados',
        page_title_merged_vendors: 'Fornecedores mesclados',
        page_title_settings_inheritance: 'Herança de configurações',
        announce_loaded_groups: 'Grupos organizacionais [[TOK_1]] carregados',
        announce_loaded_group: 'Grupo carregado [[TOK_1]]',
        announce_loaded_users: 'Usuários do grupo [[TOK_1]] carregados',
        announce_loaded_reports: 'Relatórios [[TOK_1]] carregados',
        announce_loaded_vendors: '[[TOK_1]] fornecedores compartilhados carregados',
        announce_loaded_frameworks: 'Estruturas compartilhadas [[TOK_1]] carregadas',
        announce_loaded_templates: 'Modelos de formulário compartilhado [[TOK_1]] carregados',
        announce_loaded_audit: 'Eventos de auditoria [[TOK_1]] carregados',
        announce_loaded_merged: 'Carregado [[TOK_2]] compartilhado e [[TOK_3]] fornecedores locais',
        announce_dashboard_loaded: 'Painel carregado.',
        announce_dashboard_refreshed: 'Painel atualizado.',
        announce_dashboard_refresh_failed: 'Falha ao atualizar o painel.',
        announce_refreshing: 'Atualizando painel...',
        announce_settings_loaded: 'Herança de configurações carregada.',
        announce_settings_saved: 'Configurações salvas com sucesso.',
        announce_saving_settings: 'Salvando configurações...',
        announce_error_saving: 'Erro ao salvar as configurações.',
        announce_group_dissolved: 'Grupo dissolvido.',
        announce_creating_group: 'Criando grupo organizacional...',
        announce_group_created: 'Grupo organizacional criado com sucesso.',
        announce_error_creating: 'Erro ao criar o grupo organizacional.',
        announce_vendor_published: 'Fornecedor publicado com sucesso.',
        announce_vendor_retired: 'Vendedor aposentado.',
        announce_framework_published: 'Estrutura publicada com sucesso.',
        announce_framework_retired: 'Estrutura retirada.',
        announce_template_published: 'Modelo de formulário publicado com sucesso.',
        announce_template_retired: 'Modelo de formulário retirado.',
        announce_role_assigned: 'Função atribuída com sucesso.',
        announce_error_assign_role: 'Erro ao atribuir função.',
        announce_role_revoked: 'Função revogada com sucesso.',
        announce_report_generating: 'Gerando relatório...',
        announce_report_requested: 'Geração de relatório solicitada.',
        announce_error_report: 'Erro ao solicitar relatório.',
        announce_report_deleted: 'Relatório excluído.',
        announce_search_applied: 'Pesquisa aplicada.',
        announce_search_cleared: 'Pesquisa limpa.',
        announce_tab_selected: 'Guia [[TOK_1]] selecionada',
        announce_error_add_member: 'Erro ao adicionar membro ao grupo.',
        announce_category_reverted: '[[TOK_1]] revertido para herdado do pai.',
        announce_category_overridden: '[[TOK_1]] definido para substituição local.',
        announce_override_saved: 'Substituição [[TOK_1]] salva.',
        announce_export_started: 'Exportando auditoria como [[TOK_1]]...',
        announce_export_completed: 'Exportação como [[TOK_1]] concluída.',
        announce_export_failed: 'Falha na exportação.',
        announce_filter_org: 'Filtrado por organização [[TOK_1]]',
        announce_filter_org_cleared: 'Filtro da organização limpo',
        announce_filter_event: 'Filtrado por tipo de evento [[TOK_1]]',
        announce_filter_cleared: 'Filtro limpo',
        announce_download: 'Baixando [[TOK_2]] como [[TOK_3]]',
        error_load_groups: 'Falha ao carregar grupos organizacionais. Por favor, tente novamente.',
        error_load_users: 'Falha ao carregar usuários do grupo.',
        error_load_reports: 'Falha ao carregar relatórios de grupo.',
        error_load_dashboard: 'Falha ao carregar o painel do grupo.',
        error_load_settings: 'Falha ao carregar as configurações do grupo.',
        error_load_vendors: 'Falha ao carregar fornecedores mesclados.',
        error_save_settings: 'Falha ao salvar as configurações.',
        error_dissolve_group: 'Falha ao dissolver o grupo.',
        error_assign_role: 'Falha ao atribuir função.',
        error_create_group: 'Falha ao criar o grupo organizacional. Por favor, tente novamente.',
        error_request_report: 'Falha ao solicitar relatório.',
        error_group_name_required: 'O nome do grupo é obrigatório.',
        success_settings_saved: 'Configurações salvas com sucesso.',
        confirm_retire_vendor: 'Tem certeza de que deseja retirar o fornecedor "[[TOK_1]]"?',
        confirm_retire_framework: 'Tem certeza de que deseja descontinuar a estrutura "[[TOK_1]]"?',
        confirm_retire_template: 'Tem certeza de que deseja retirar o modelo de formulário "[[TOK_1]]"?',
        confirm_dissolve_group: 'Tem certeza de que deseja dissolver "[[TOK_1]]"? Esta ação não pode ser desfeita.',
        confirm_revoke_role: 'Tem certeza de que deseja revogar a função "[[TOK_2]]" de "[[TOK_3]]"?',
        confirm_delete_report: 'Tem certeza de que deseja excluir o relatório "[[TOK_1]]"?',
        dissolve_group: 'Dissolver Grupo',
        dissolve_warning: 'Isso dissolverá permanentemente o grupo organizacional. Todas as organizações membros serão removidas.',
        count_groups: 'grupo [[TOK_1]]',
        count_groups_plural: '[[TOK_1]] grupos',
        count_users: '[[TOK_1]] usuário',
        count_users_plural: '[[TOK_1]] usuários com funções de grupo',
        count_events: 'Evento [[TOK_1]]',
        count_events_plural: '[[TOK_1]] eventos',
        count_reports: '[[TOK_1]] relatório',
        count_reports_plural: '[[TOK_1]] relatórios',
        count_vendors: '[[TOK_1]] fornecedor compartilhado pelo grupo',
        count_vendors_plural: '[[TOK_1]] fornecedores compartilhados no grupo',
        count_frameworks: 'Estrutura [[TOK_1]] compartilhada por todo o grupo',
        count_frameworks_plural: 'Estruturas [[TOK_1]] compartilhadas em todo o grupo',
        count_templates: 'Modelo [[TOK_1]] compartilhado pelo grupo',
        count_templates_plural: 'Modelos [[TOK_1]] compartilhados no grupo',
        count_shared_vendors: '[[TOK_1]] fornecedores compartilhados',
        count_local_vendors: '[[TOK_1]] fornecedores locais',
        merged_combined_view: 'Visão combinada de [[TOK_2]] fornecedores compartilhados e [[TOK_3]] fornecedores locais',
        dashboard: {
            title: 'Painel do grupo',
            loading: 'A carregar dashboard data...',
            total_groups: 'Total Grupos',
            total_members: 'Total de membros',
            active_groups: 'Ativo Grupos',
            overall_compliance_score: 'Pontuação geral de conformidade',
            group_risk_level: 'Nível de risco do grupo',
            sla_compliance: '[[TOK_0]] Conformidade',
            compliance_posture: 'Postura de Conformidade',
            risk_heatmap: 'Mapa de calor de risco',
            sla_performance: '[[TOK_0]] Desempenho',
            recent_incidents: 'Incidentes Recentes',
            recent_activity: 'Atividade recente',
            refresh_label: 'Atualizar dados do painel',
            score_good: 'Bom',
            score_needs_attention: 'Precisa de atenção',
            score_critical: 'Crítico',
            trend_up: 'Tendências',
            trend_down: 'Tendência de queda',
            trend_stable: 'Estável',
            risk_low: 'Low',
            risk_medium: 'Médio',
            risk_high: 'Alto',
            risk_critical: 'Crítico',
            risk_unknown: 'Desconhecido',
            col_organization: 'Organização',
            col_score: 'Pontuação',
            col_trend: 'Tendência',
            col_open_issues: 'Problemas em aberto',
            col_critical_issues: 'Questões Críticas',
            col_health: 'Saúde',
            col_vendor_risk: 'Risco do fornecedor',
            col_data_risk: 'Risco de dados',
            col_compliance_risk: 'Risco de conformidade',
            col_total_cases: 'Total de casos',
            col_on_time: 'Na hora certa',
            col_breached: 'Violado',
            col_sla_percent: '[[TOK_0]]%',
            col_avg_days: 'Média de dias',
            sr_vendor_risk: 'Pontuação de risco do fornecedor: [[TOK_1]]',
            sr_data_risk: 'Pontuação de risco de dados: [[TOK_1]]',
            sr_compliance_risk: 'Pontuação de risco de conformidade: [[TOK_1]]',
            sr_sla_breaches: 'Aviso: violações de [[TOK_1]] [[TOK_2]]',
            sr_severity: 'Gravidade: [[TOK_1]]',
        },
        detail: {
            title: 'Detalhe do grupo',
            members: 'Membros',
            settings: 'Definições',
            audit: 'Auditoria',
            sr_loading: 'Carregando detalhes do grupo organizacional',
            sr_loading_hierarchy: 'Carregando hierarquia',
            member_org: 'organização membro',
            root_org_label: 'organização raiz',
        },
        users: {
            title: 'Utilizadores do grupo',
            add_user: 'Adicionar utilizador',
            no_users: 'Sem utilizadores neste grupo.',
            role_group_admin: 'Administrador do grupo',
            role_group_reader: 'Leitor de grupo',
            sr_loading: 'Carregando usuários do grupo',
        },
        reports: {
            title: 'Relatórios do grupo',
            no_reports: 'Nenhum reports encontrado',
            generate_report: 'Gerar novo relatório',
            report_type_compliance: 'Resumo de conformidade',
            report_type_risk: 'Visão geral dos riscos',
            report_type_sla: '[[TOK_0]] Desempenho',
            report_type_incident: 'Relatório de incidente',
            report_type_executive: 'Resumo Executivo',
            report_type_board: 'Relatório do Conselho',
            status_queued: 'Na fila',
            status_generating: 'Gerando',
            status_completed: 'Concluído',
            status_failed: 'Falha',
            period_start: 'Início do período',
            period_end: 'Fim do período',
            sr_loading: 'Carregando relatórios de grupo',
        },
        shared_vendors: {
            title: 'Fornecedores partilhados',
            no_vendors: 'Nenhum shared vendors encontrado',
            merged_vendors: 'Fornecedores fundidos',
            publish_form_label: 'Publicar fornecedor compartilhado',
            sr_loading: 'Carregando fornecedores compartilhados',
            sr_loading_merged: 'Carregando fornecedores mesclados',
            local_vendors: 'Fornecedores locais',
            source_shared: 'Compartilhado do grupo',
            source_local: 'Fornecedor local',
            category_technology: 'Tecnologia',
            category_consulting: 'Consultoria',
            category_outsourcing: 'Terceirização',
            category_cloud: 'Nuvem',
            category_data_processing: 'Processamento de Dados',
            category_other: 'Outro',
            risk_tier_low: 'Low',
            risk_tier_medium: 'Médio',
            risk_tier_high: 'Alto',
            risk_tier_critical: 'Crítico',
            compliance_compliant: 'Compatível',
            compliance_non_compliant: 'Não conforme',
            compliance_pending: 'Pendente',
            compliance_under_review: 'Em revisão',
            status_active: 'Ativo',
            status_retired: 'Aposentado',
        },
        shared_frameworks: {
            title: 'Quadros partilhados',
            no_frameworks: 'Nenhum shared frameworks encontrado',
            publish_form_label: 'Publicar estrutura compartilhada',
            sr_loading: 'Carregando estruturas compartilhadas',
            status_active: 'Ativo',
            status_retired: 'Aposentado',
        },
        shared_forms: {
            title: 'Modelos de formulários partilhados',
            no_forms: 'Nenhum shared form templates encontrado',
            publish_form_label: 'Publicar modelo de formulário compartilhado',
            sr_loading: 'Carregando modelos de formulário compartilhados',
            status_active: 'Ativo',
            status_retired: 'Aposentado',
        },
        audit: {
            title: 'Auditoria do grupo',
            consolidated_title: 'Trilha de auditoria consolidada',
            consolidated_subtitle: 'Eventos de auditoria entre organizações para este grupo',
            audit_log_title: 'Grupo Auditoria Registo',
            event_type: 'Evento Tipo',
            actor: 'Ator',
            timestamp: 'Marca temporal',
            source_org: 'Org. de origem',
            org: 'Org',
            summary: 'Resumo',
            details: 'Detalhes',
            no_events: 'Nenhum audit events encontrado',
            all_events: 'Todos Eventos',
            all_orgs: 'Todas as org.',
            organization: 'Organização',
            from: 'De',
            to: 'To',
            search_events: 'Pesquisar eventos...',
            clear: 'Limpar',
            events_24h: 'Eventos (24h)',
            events_7d: 'Eventos (7d)',
            active_orgs: 'Org. ativas',
            exporting: 'A exportar...',
            export_csv: 'Exportar CSV',
            export_json: 'Exportar JSON',
            back_to_group: 'Voltar para Grupo',
            back_to_detail: 'Voltar ao detalhe',
            sr_loading: 'Carregando eventos de auditoria',
            sr_loading_summary: 'Carregando resumo de auditoria',
        },
        settings: {
            title: 'Grupo Definições',
            inheritance: 'Herança de definições',
            inheritance_subtitle: 'Configurar quais categorias de configurações serão herdadas do grupo em vez de usar substituições locais',
            sla_settings: 'SLA Definições',
            calendar_settings: 'Calendário Definições',
            notification_settings: 'Notificação Definições',
            intake_settings: 'Definições de entrada',
            cmp_integration: 'Integração CMP',
            overridden: 'Substituído',
            inheriting: 'A herdar',
            hide_defaults: 'Ocultar predefinições',
            show_group_defaults: 'Mostrar Grupo Defaults',
            group_defaults: 'Predefinições do grupo',
            inherit_from_group: 'Inherit de Grupo',
            use_local_override: 'Usar substituição local',
            local_override_json: 'Substituição local (JSON)',
            save_override: 'Guardar substituição',
            saving: 'A guardar...',
            sr_loading: 'Carregando herança de configurações',
            sr_loading_settings: 'Carregando configurações do grupo',
            sr_enabled: 'Habilitado',
            sr_disabled: 'Desativado',
            sr_override_active: 'Substituição local ativa',
            sr_inherited: 'Herdado do pai',
            danger_zone: 'Zona de perigo',
            sharing_options: 'Opções de compartilhamento',
            advanced_options: 'Opções Avançadas',
        },
        status_active: 'Ativo',
        status_dissolved: 'Dissolvido',
        status_pending: 'Pendente',
        status_suspended: 'Suspenso',
    },
    integrations: {
        nav: {
            webhooks: 'Webhooks',
            domains: 'Domínios',
            export_schedules: 'Agendamento de Exportações',
            email_log: 'Registo de Correio Eletrónico',
        },
    },
    platform: {
        nav: {
            users: 'Utilizadores',
            roles: 'Funções',
            profile: 'O Meu Perfil',
        },
        security: {
            mfa: 'Definições de MFA',
            sso: 'Configuração de SSO',
            api_keys: 'Chaves de API',
            service_accounts: 'Contas de Serviço',
            ip_allowlist: 'Lista de IPs Permitidos',
            delegations: 'Delegações',
            break_glass: 'Acesso de Emergência',
            session_settings: 'Definições de Sessão',
            active_sessions: 'Sessões Ativas',
            access_reviews: 'Revisões de Acesso',
            my_reviews: 'As Minhas Revisões',
            role_analytics: 'Análise de Funções',
            attestation_schedules: 'Agendamento de Atestações',
            sod_rules: 'Regras de SoD',
            sod_violations: 'Violações de SoD',
        },
        module_config: {
            title: 'Configuração de Módulos',
            subtitle: 'Ative ou desative módulos de funcionalidades para a sua organização. Os módulos desativados ficam ocultos na navegação.',
            enabled: 'Ativado',
            disabled: 'Desativado',
            save: 'Guardar Configuração',
            saving: 'A guardar...',
            saved: 'Configuração guardada com sucesso',
            nav_label: 'Configuração de Módulos',
            settings: 'Definições',
            webhooks: 'Webhooks',
            domains: 'Domínios',
            export_schedules: 'Agendamento de Exportações',
            email_log: 'Registo de Correio Eletrónico',
        },
        files_nav: {
            section: 'Arquivos',
            configuration: 'Configuração',
            browser: 'Navegador de arquivos',
            dashboard: 'Painel de arquivos',
        },
        immutable_audit_trails: {
            nav_group_label: 'Auditoria e Prova',
            nav_settings: 'Configurações',
            nav_status: 'Status da prova',
            nav_integrity_center: 'Centro de Integridade',
            nav_usage: 'Uso e créditos',
            settings_title: 'Trilhas de auditoria imutáveis — Configurações',
            settings_subtitle: 'Configurações por organização para o complemento Immutable Audit Trails.',
            settings_banner: 'O complemento Immutable Audit Trails não está habilitado para sua organização. Ative-o aqui para começar a ancorar provas para eventos de auditoria de Nível A e Nível B.',
            status_title: 'Trilhas de auditoria imutáveis – status de prova',
            status_subtitle: 'Relacionamentos de prova por evento entre módulos.',
            status_banner: 'O complemento Immutable Audit Trails não está habilitado para sua organização. Visite Configurações para habilitá-lo.',
            integrity_center_title: 'Trilhas de auditoria imutáveis — Centro de Integridade',
            integrity_center_subtitle: 'Verifique as provas e exporte pacotes de integridade.',
            integrity_center_banner: 'O complemento Immutable Audit Trails não está habilitado para sua organização. Visite Configurações para habilitá-lo antes de executar a verificação ou exportar pacotes de integridade.',
            usage_title: 'Trilhas de auditoria imutáveis – uso e créditos',
            usage_subtitle: 'Saldo de crédito, compras de pacotes e histórico de uso.',
            usage_banner: 'Ative trilhas de auditoria imutáveis nas configurações para começar a consumir créditos de prova.',
            module_tips_placeholder: 'Dicas e orientações para esta superfície estão disponíveis na Central de Ajuda.',
            column_label: 'Prova',
            no_proof_aria: 'Nenhuma prova registrada',
            proof_status_receipt_label: 'recibo {id}',
            in_progress_hint: 'Em andamento — atualiza automaticamente',
            status_pills: {
                pending: 'Pendente',
                submitted: 'Enviado',
                anchored: 'Ancorado',
                confirmed: 'Confirmado',
                retrying: 'Tentando novamente',
                paused_cap: 'Pausado (limite)',
                failed: 'Falha',
                failed_auth: 'Falha na autenticação',
            },
            status_tooltips: {
                pending: 'Pendente — na fila para o serviço de prova. Passará para Enviado em breve; nenhuma ação necessária.',
                submitted: 'Enviado — seu evento foi enviado para o serviço de prova. Para o modo batch, ele está aguardando para ser selado e ancorado na corrente. Atualizações automaticamente; nenhuma ação necessária.',
                anchored: 'Ancorado – o lote foi escrito na cadeia e aguarda confirmação final. Atualizações automaticamente; nenhuma ação necessária.',
                confirmed: 'Confirmado – a prova está ancorada na cadeia e verificável.',
                retrying: 'Tentando novamente — ocorreu um erro temporário. O reconciliador está tentando novamente automaticamente; nenhuma ação necessária.',
                paused_cap: 'Pausado — seu limite mensal de comprovação de crédito foi atingido. Resgate mais créditos ou espere até o próximo mês de cobrança.',
                failed: 'Falha — a ancoragem não foi bem-sucedida. O reconciliador tentará novamente automaticamente; entre em contato com o suporte se persistir.',
                failed_auth: 'Falha na autenticação — o serviço de prova rejeitou nossas credenciais. Verifique a página Configurações de trilhas de auditoria imutáveis.',
            },
            mode_pills: {
                direct: 'Direto',
                batch: 'Lote',
            },
            drawer: {
                title: 'Detalhes da prova',
                close: 'Fechar',
                section_proof: 'Prova',
                section_batch: 'Associação em lote',
                status: 'Estado',
                proof_reference: 'Referência de prova',
                receipt_id: 'ID do recibo',
                taxonomy_class: 'Aula de taxonomia',
                units_consumed: 'Unidades consumidas',
                created_at: 'Criado',
                verification_ref: 'Referência de verificação de cadeia',
                chain: 'Corrente',
                tx_hash: 'Hash Tx',
                block_ref: 'Bloquear referência',
                batch_reference: 'Referência de lote',
                leaf_index: 'Índice de folhas',
                local_event_hash: 'Hash de evento local',
                show_inclusion: 'Mostrar caminho de inclusão',
                hide_inclusion: 'Ocultar caminho de inclusão',
                privacy_note: 'A carga útil está com hash; nenhum dado pessoal foi deixado pela ComplianceOne para este evento.',
                verify_now: 'Verifique agora',
                verify_pending: 'Verificação em andamento…',
                verify_verified: 'Verificado – verificações locais + do lado da cadeia aprovadas.',
                verify_issue_prefix: 'Problema de verificação: ',
                verify_failed: 'Falha na chamada de verificação.',
                verify_result_prefix: 'Veredicto de verificação: ',
                verify_pending_note: 'Verificação pendente: esta prova ainda aguarda ancoragem na cadeia. Tente novamente depois que o lote estiver selado.',
                awaiting_anchor_note: 'Esta prova faz parte de um lote aberto. A verificação fica disponível quando o lote é selado e ancorado na cadeia — normalmente dentro da janela de lote configurada pela organização. O selo de status será atualizado automaticamente.',
                terminal_error_note: 'Esta prova não conseguiu ancorar. O reconciliador de status de prova tentará novamente automaticamente; a verificação manual ainda não tem nada para verificar.',
            },
            integrity_center: {
                section_run: 'Executar verificação',
                section_progress: 'Execute o progresso',
                section_issues: 'Problemas',
                period_start: 'Início do período',
                period_end: 'Fim do período',
                module_filter: 'Módulos (separados por vírgula, opcionais)',
                modules_placeholder: 'rights_requests, incidentes',
                run_button: 'Executar verificação',
                export_button: 'Pacote de integridade de exportação',
                export_success: 'Pacote de integridade exportado.',
                export_failed: 'Falha na exportação.',
                empty_disabled: 'Ative trilhas de auditoria imutáveis nas configurações para executar passagens de verificação.',
                error_period_required: 'Escolha uma data de início e de término.',
                error_start_run: 'Falha ao iniciar a execução.',
                processed: 'Processado: [[TOK_2]] de [[TOK_3]]',
                col_verdict: 'Veredicto',
                col_count: 'Contar',
                col_proof_link: 'Link de prova',
                col_module: 'Módulo',
                col_event_type: 'Tipo de evento',
                col_expected: 'Hash esperado',
                col_recomputed: 'Hash recalculado',
                col_raised_at: 'Criado em',
                any_verdict: 'Qualquer veredicto',
                no_issues: 'Nenhum problema encontrado.',
            },
            settings_page: {
                load_error: 'Falha ao carregar as configurações.',
                save: 'Salvar',
                save_success: 'Configurações salvas.',
                save_error: 'Falha ao salvar.',
                discard: 'Descartar alterações',
                read_only_banner: 'Você tem acesso somente leitura. Entre em contato com um administrador da plataforma para fazer alterações.',
                section_status: 'Status e ativação',
                enabled_label: 'Complemento ativado',
                enabled_help: 'Quando ativado, cada evento de auditoria de Camada A e Camada B é criptografado e ancorado.',
                section_scope: 'Escopo',
                scope_self: 'Somente eu',
                scope_self_and_children: 'Organizações próprias e secundárias',
                scope_children_only: 'Somente crianças (os pais não comprovam seus próprios eventos)',
                section_mode: 'Modo de prova padrão',
                mode_direct: 'Direto (uma âncora por evento)',
                mode_batch: 'Lote (âncora Merkle-root por grupo)',
                mode_hybrid: 'Híbrido (padrão de registro por classe)',
                batch_window_label: 'Janela de lote (minutos, 1–60)',
                section_taxonomy: 'Taxonomia de eventos protegidos',
                taxonomy_help: 'Substituições de classe por evento. Camada A → modo direto, Camada B → modo em lote, Desligado → não verificado.',
                taxonomy_search: 'Substituições de pesquisa',
                taxonomy_reset: 'Redefinir para os padrões',
                taxonomy_event_class: 'Classe de evento',
                taxonomy_override: 'Substituir',
                taxonomy_actions: 'Ações',
                taxonomy_clear: 'Limpar',
                taxonomy_no_overrides: 'Sem substituições – usando padrões de registro.',
                taxonomy_add_class: 'event_class.código',
                taxonomy_add: 'Adicionar substituição',
                section_privacy: 'Controles de privacidade',
                privacy_log_actor_ip: 'Registrar IP do ator',
                privacy_log_user_agent: 'Registrar agente do usuário',
                privacy_privileged_access_proofing: 'Leituras de acesso privilegiado de prova (Nível A)',
                privacy_note: 'As alterações aplicam-se apenas prospectivamente.',
                section_caps: 'Limites e limites',
                cap_label: 'Limite mensal (unidades; em branco = ilimitado)',
                warn_label: 'Limite de aviso (unidades; deve ser menor que o limite)',
                auto_pause_label: 'Pausar automaticamente novas provas quando o limite for atingido',
                section_export: 'Acesso de exportação',
                export_help: 'IDs de função com permissão para exportar pacotes de integridade. Separados por vírgula; blank = use a permissão padrão IMMUTABLE_AUDIT_TRAILS_EXPORT.',
                section_group: 'Participação em grupo',
                group_view_intro: 'Você está configurado como pai do grupo. Cada organização filha controla sua própria ativação/desativação; suas decisões serão acumuladas em seu faturamento de acordo com as regras de faturamento do grupo.',
                group_view_rule_enabled: 'Uma criança com enabled=false é mostrada como "Não participando". Você vê a ausência; a criança controla o botão de alternância.',
                group_view_rule_billing: 'O consumo infantil acumula até o seu limite mensal. Assista à página Uso para monitorar a taxa de queima combinada.',
                group_view_rule_edit: 'Você não pode editar as configurações de uma criança nesta página. Abra a organização filha diretamente para editar.',
                group_view_open_groups: 'Abrir grupos organizacionais',
                section_credentials: 'Credenciais',
                credential_id: 'ID da credencial',
                credential_rotated_at: 'Última rotação',
                rotate_button: 'Girar credencial',
                rotate_success: 'Credencial rotacionada. Credencial antiga válida por mais [[TOK_1]] minutos.',
                rotate_failed: 'Falha na rotação de credenciais.',
                rotate_modal_title: 'Alternar credencial [[TOK_0]]?',
                rotate_modal_body: 'A rotação emite uma nova credencial. A credencial antiga permanece aceita por [[TOK_0]] por um período de carência de 60 minutos para que os trabalhadores a bordo possam terminar seus trabalhos atuais. Após 60 minutos, a credencial antiga é revogada.',
                rotate_modal_confirm: 'Gire agora',
                tier_a_off_modal_title: 'Desativar a revisão para uma classe de evento?',
                tier_a_off_modal_body: 'Definir uma classe de evento como "Desativada" impede que o toque de prova ancore esses eventos. A arquitetura §6 explica a implicação regulatória: os eventos de nível A são relevantes para os reguladores; desativá-los pode prejudicar a defensabilidade da trilha de auditoria.',
                tier_a_off_modal_confirm: 'Eu entendo – aplicar substituição',
                error_warn_lt_cap: 'O limite de aviso deve ser inferior ao limite mensal.',
                error_window_range: 'A janela do lote deve estar entre 1 e 60 minutos.',
                error_run_in_progress: 'Uma execução de verificação está em andamento; não é possível desativar o complemento agora.',
            },
            status_page: {
                filter_status: 'Estado',
                filter_mode: 'Modo de prova',
                filter_module: 'Módulo',
                filter_source_collection: 'Coleção de fontes',
                filter_from_date: 'De',
                filter_to_date: 'Para',
                filter_search: 'Pesquisar',
                any_status: 'Qualquer status',
                any_mode: 'Qualquer modo',
                col_module: 'Módulo',
                col_event_type: 'Tipo de evento',
                col_proof_status: 'Estado',
                col_proof_mode: 'Modo',
                col_created_at: 'Criado',
                col_units: 'Unidades',
                empty_disabled: 'O complemento Immutable Audit Trails não está habilitado para sua organização. Visite Configurações para habilitá-lo.',
                empty_enabled_no_rows: 'Nenhum link de prova corresponde aos filtros atuais.',
                export_csv: 'Exportar [[TOK_0]]',
                export_xlsx: 'Exportar [[TOK_0]]',
                export_success: 'Exportação concluída',
                export_failed: 'Falha na exportação',
            },
            usage_page: {
                section_alerts: 'Alertas',
                alert_dismiss: 'Dispensar',
                alert_dismiss_aria: 'Dispensar alerta [[TOK_1]]',
                alert_dismissed: 'Alerta dispensado',
                alert_dismiss_failed: 'Falha ao descartar alerta',
                section_balance: 'Saldo de crédito',
                balance_label: 'Créditos disponíveis',
                balance_hint: 'Unidades restantes (1 unidade = 1 prova de evento protegido).',
                section_current_month: 'Mês atual',
                consumed_label: 'Consumido',
                granted_label: 'Concedido',
                refunded_label: 'Reembolsado',
                net_label: 'Rede',
                section_history: 'Histórico de uso',
                history_kind: 'Gentil',
                history_units: 'Unidades',
                history_balance_after: 'Saldo depois',
                history_notes: 'Notas',
                history_at: 'Quando',
                cap_warning_banner: 'Você ultrapassou o limite de aviso para este mês de faturamento. Considere resgatar créditos adicionais.',
                cap_paused_banner: 'Limite mensal atingido. Os envios de provas serão pausados ​​até o próximo mês ou até que o limite seja aumentado.',
                section_redeem: 'Resgatar pacote de crédito',
                redeem_purchase_id: 'Número da fatura',
                redeem_package: 'Pacote',
                redeem_button: 'Resgatar',
                redeem_pending: 'Resgatando…',
                redeem_success: 'Créditos resgatados',
                redeem_failed: 'Falha ao resgatar',
                redeem_option_template: '[[TOK_4]] — [[TOK_5]] [[TOK_6]] — [[TOK_7]]',
                redeem_option_units: 'unidades',
                alert_dismissing: 'Dispensando…',
                alert_kind: {
                    cap_reached: 'Limite mensal atingido',
                    low_balance: 'Saldo baixo',
                    auth_failure: 'Falha de autenticação',
                    merkle_mismatch: 'Incompatibilidade de Merkle',
                    batch_terminal_failure: 'Falha no terminal em lote',
                    direct_terminal_failure: 'Falha no terminal de envio direto',
                },
                usage_kind: {
                    consume: 'Consumir',
                    refund: 'Reembolso',
                    grant: 'Conceder',
                    adjustment: 'Ajuste',
                    reservation: 'Reserva',
                },
                package_starter: 'Iniciante',
                package_growth: 'Crescimento',
                package_enterprise: 'Empresa',
                // Sprint 48.5.x — self-service "Buy More" billing (Flow A + B).
                buy_more: {
                    buy_button: 'Comprar mais créditos',
                    purchase_title: 'Comprar mais créditos',
                    purchase_subtitle: 'Escolha um pacote. Será encaminhado para o checkout seguro da Stripe e a sua fatura chegará por e-mail.',
                    checkout_button: 'Continuar para o checkout',
                    checkout_pending: 'A abrir o checkout…',
                    cancel_button: 'Cancelar',
                    purchase_error: 'Não foi possível iniciar o checkout. Tente novamente em breve.',
                    redeem_subtitle: 'Já pagou? Selecione o pacote que adquiriu e introduza o ID da fatura do seu e-mail para adicionar os créditos.',
                    error_not_found: 'Não foi encontrada nenhuma fatura com esse número. Verifique o número da fatura e tente novamente.',
                    error_not_paid: 'Esta fatura ainda não está marcada como paga.',
                    error_org_mismatch: 'Esta fatura não foi emitida para a sua organização.',
                    error_package_mismatch: 'Esta fatura não corresponde ao pacote selecionado.',
                    error_billing_unavailable: 'Não foi possível contactar o serviço de faturação. Tente novamente em breve.',
                },
            },
        },
        files_config: {
            title: 'Configuração de arquivos',
            subtitle: 'Configure limites de upload de arquivos, políticas de retenção e substituições por tipo de proprietário para a superfície de anexos da plataforma.',
            section_global: 'Padrões globais',
            section_global_help: 'Esses limites se aplicam a todos os arquivos enviados por usuários na sua organização, a menos que uma substituição por tipo de proprietário abaixo os altere.',
            section_overrides: 'Substituições por tipo de proprietário',
            section_overrides_help: 'Substitua os limites globais para um tipo de proprietário específico. Os valores do tipo por proprietário sempre vencem a configuração global.',
            max_file_size_label: 'Tamanho máximo do arquivo',
            max_file_size_hint: 'Por upload individual (MiB)',
            max_total_attachments_label: 'Total máximo de anexos',
            max_total_attachments_hint: 'Em toda a organização',
            max_total_size_label: 'Armazenamento total máximo',
            max_total_size_hint: 'Em toda a organização (MiB)',
            allowed_mime_types_label: 'Tipos de arquivos permitidos',
            allowed_mime_types_placeholder: 'Selecione os tipos MIME',
            retention_days_label: 'Período de retenção (dias)',
            retention_days_hint: 'Por quanto tempo os arquivos devem ser mantidos antes de serem elegíveis para exclusão. Deixe em branco para nenhuma política de retenção.',
            legal_hold_label: 'Retenção legal',
            legal_hold_hint: 'Quando ativado, a exclusão irreversível de um arquivo desse tipo de proprietário requer a permissão de substituição de retenção legal e a aceitação explícita do operador.',
            save: 'Salvar alterações',
            saving: 'Salvando…',
            reset: 'Redefinir',
            save_success: 'Configurações salvas',
            save_version_conflict: 'Outro operador atualizou essas configurações enquanto você editava. Atualize para ver os valores mais recentes.',
            empty_state_title: 'Usando padrões de plataforma',
            empty_state_body: 'Sua organização está atualmente executando a política de arquivo padrão da plataforma. Edite qualquer valor abaixo para criar uma substituição no nível da organização.',
            read_only_banner: 'Você tem acesso somente leitura à configuração do arquivo. Entre em contato com um administrador da plataforma para fazer alterações.',
            owner_type_default_badge: 'Padrão',
            owner_type_overridden_badge: 'Substituído',
            owner_type_label: 'Tipo de proprietário',
            owner_type_collapse: 'Recolher',
            owner_type_expand: 'Expandir',
            override_save: 'Salvar substituição',
            override_remove: 'Remover substituição',
            mime_labels: {
                'application/pdf': '[[TOK_0]] documento',
                'image/png': 'Imagem PNG',
                'image/jpeg': 'Imagem JPEG',
                'image/jpg': 'Imagem JPG',
                'application/msword': 'Documento Word (legado)',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'Documento do Word',
                'application/vnd.ms-excel': 'Planilha Excel (herdada)',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'Planilha Excel',
                'text/csv': '[[TOK_0]] arquivo',
                'text/plain': 'Texto simples',
                'message/rfc822': 'Mensagem de e-mail',
            },
        },
        files_browser: {
            title: 'Navegador de arquivos',
            subtitle: 'Pesquise, filtre e gerencie todos os anexos carregados na organização.',
            filter_owner_type: 'Tipo de proprietário',
            filter_uploader: 'Enviado por',
            filter_from: 'Carregado depois',
            filter_to: 'Enviado antes',
            filter_size_min: 'Tamanho mínimo (MiB)',
            filter_size_max: 'Tamanho máximo (MiB)',
            filter_mime: 'Tipo de arquivo',
            filter_deleted_state: 'Estado de exclusão',
            filter_deleted_any: 'Todos os arquivos',
            filter_deleted_only: 'Somente excluído',
            filter_deleted_exclude: 'Excluir excluído',
            filter_orphaned: 'Apenas órfão',
            filter_search_placeholder: 'Pesquisar nome do arquivo…',
            filter_apply: 'Aplicar filtros',
            filter_clear: 'Limpar filtros',
            col_filename: 'Nome do arquivo',
            col_owner_type: 'Tipo de proprietário',
            col_owner_entity: 'Proprietário',
            col_uploader: 'Enviado por',
            col_uploaded_at: 'Enviado',
            col_size: 'Tamanho',
            col_mime: 'Tipo',
            col_state: 'Estado',
            col_actions: 'Ações',
            state_active: 'Ativo',
            state_deleted: 'Excluído',
            state_orphaned: 'Órfão',
            action_view_detail: 'Ver detalhes',
            action_download: 'Baixar',
            action_ai_edits: '[[TOK_0]] Edições',
            action_soft_delete: 'Exclusão suave',
            action_restore: 'Restaurar',
            action_hard_delete: 'Exclusão forçada',
            bulk_soft_delete: 'Exclusão reversível selecionada',
            bulk_export_csv: 'Exportar [[TOK_0]]',
            bulk_select_all: 'Selecionar tudo',
            reason_label: 'Razão',
            reason_min_10_chars: 'O motivo é obrigatório (pelo menos 10 caracteres)',
            reason_min_20_chars: 'O motivo é obrigatório (pelo menos 20 caracteres)',
            legal_hold_override_label: 'Substituir retenção legal',
            legal_hold_override_warning: 'Este arquivo está sob retenção legal. A exclusão forçada será registrada na trilha de auditoria com seu motivo e sinalizador de substituição.',
            empty_state_title: 'Nenhum arquivo corresponde aos seus filtros',
            empty_state_body: 'Ajuste seus filtros para ver os resultados ou desmarque-os para visualizar todos os arquivos.',
            pagination_prev: 'Anterior',
            pagination_next: 'Próximo',
            pagination_page: 'Página [[TOK_2]] de [[TOK_3]]',
            pagination_size_label: 'Por página',
            pagination_total: 'Total: [[TOK_1]]',
            toast_soft_deleted: 'Arquivo excluído de forma reversível',
            toast_restored: 'Arquivo restaurado',
            toast_hard_deleted: 'Arquivo excluído permanentemente',
            toast_bulk_deleted: '[[TOK_1]] arquivo(s) excluído(s)',
            toast_error: 'Falha na operação',
            confirm_soft_delete_title: 'Arquivo de exclusão reversível',
            confirm_restore_title: 'Restaurar arquivo',
            confirm_hard_delete_title: 'Excluir arquivo permanentemente',
            confirm_bulk_soft_delete_title: 'Excluir arquivos selecionados de forma reversível',
            confirm_submit: 'Confirmar',
            confirm_cancel: 'Cancelar',
        },
        files_detail: {
            modal_title: 'Detalhes do arquivo',
            close: 'Fechar',
            meta_filename: 'Nome do arquivo',
            meta_size: 'Tamanho',
            meta_mime: 'Tipo',
            meta_owner_type: 'Tipo de proprietário',
            meta_owner_entity: 'Entidade proprietária',
            meta_uploader: 'Enviado por',
            meta_uploaded_at: 'Enviado',
            meta_storage_path: 'Caminho de armazenamento',
            meta_deleted_state: 'Estado de exclusão',
            audit_section_title: 'Trilha de auditoria',
            audit_load_more: 'Carregar mais eventos',
            audit_empty: 'Nenhum evento de auditoria registrado para este arquivo.',
            audit_config_changed: 'Configuração alterada',
            audit_soft_deleted: 'Excluído de forma reversível',
            audit_restored: 'Restaurado',
            audit_hard_deleted: 'Excluído permanentemente',
            audit_downloaded: 'Baixado',
            audit_quota_breached: 'Tentativa de violação de cota',
            action_download: 'Baixar',
            action_soft_delete: 'Exclusão suave',
            action_restore: 'Restaurar',
            action_hard_delete: 'Exclusão forçada',
            effective_settings_title: 'Política eficaz',
            effective_max_file_size: 'Tamanho máximo do arquivo',
            effective_retention_days: 'Retenção',
            effective_legal_hold: 'Retenção legal',
            effective_legal_hold_yes: 'Ativo',
            effective_legal_hold_no: 'Nenhum',
        },
        files_dashboard: {
            title: 'Painel de arquivos',
            subtitle: 'Uso de armazenamento, crescimento e arquivos órfãos em toda a organização.',
            kpi_total_files: 'Total de arquivos',
            kpi_total_size: 'Armazenamento total',
            kpi_near_quota: 'Uso de cota',
            kpi_orphaned: 'Arquivos órfãos',
            chart_by_owner_type: 'Arquivos por tipo de proprietário',
            chart_growth_30d: 'Crescimento em 30 dias',
            toggle_count: 'Por contagem',
            toggle_size: 'Por tamanho',
            orphaned_panel_title: 'Arquivos órfãos (20 principais)',
            orphaned_view_all: 'Ver todos os arquivos órfãos',
            orphaned_empty: 'Nenhum arquivo órfão encontrado.',
            growth_empty: 'Nenhuma atividade de upload nos últimos 30 dias.',
            retention_n_days: '[[TOK_1]] dia(s)',
            retention_none: 'Nenhuma política',
        },
    },
    category_labels: {
        'user-guide': 'Guia do usuário',
        'admin-guide': 'Guia de administração',
        'getting-started': 'Primeiros passos',
        faq: 'Perguntas frequentes',
    },
    tag_labels: {
        faq: 'FAQ',
        dsar: 'DSAR',
        dsr: 'DSR',
        cmp: 'CMP',
        hmac: 'HMAC',
        sso: 'SSO',
        mfa: 'MFA',
        rbac: 'RBAC',
        api: 'API',
        'api-keys': '[[TOK_0]] Chaves',
        webhook: 'Webhook',
        webhooks: 'Webhooks',
        admin: 'Administrador',
        aesirx: 'AesirX',
        purposes: 'Finalidades',
        preferences: 'Preferências',
        onboarding: 'Integração',
        'first-steps': 'Primeiros passos',
        login: 'Entrar',
        navigation: 'Navegação',
        users: 'Usuários',
        user: 'Usuário',
        roles: 'Funções',
        role: 'Função',
        'access-control': 'Controle de acesso',
        'access-management': 'Gerenciamento de acesso',
        permissions: 'Permissões',
        permission: 'Permissão',
        consent: 'Consentimento',
        'consent-management': 'Gerenciamento de consentimento',
        privacy: 'Privacidade',
        pdpl: 'PDPL',
        gdpr: 'GDPR',
        iso27001: 'ISO 27001',
        audit: 'Auditoria',
        auditing: 'Auditoria',
        breach: 'Violação',
        incident: 'Incidente',
        incidents: 'Incidentes',
        notification: 'Notificação',
        notifications: 'Notificações',
        reporting: 'Relatórios',
        risk: 'Risco',
        vendor: 'Fornecedor',
        vendors: 'Fornecedores',
        'vendor-risk': 'Risco do fornecedor',
        assessment: 'Avaliação',
        assessments: 'Avaliações',
        dpia: 'DPIA',
        'cross-border': 'Transfronteiriço',
        transfer: 'Transferência',
        transfers: 'Transferências',
        deletion: 'Exclusão',
        retention: 'Retenção',
        'data-mapping': 'Mapeamento de dados',
        discovery: 'Descoberta',
        classification: 'Classificação',
        workflow: 'Fluxo de trabalho',
        workflows: 'Fluxos de trabalho',
        template: 'Modelo',
        templates: 'Modelos',
        catalog: 'Catálogo',
        monitoring: 'Monitoramento',
        tasks: 'Tarefas',
        task: 'Tarefa',
        'task-management': 'Gerenciamento de tarefas',
        organizations: 'Organizações',
        org: 'Organização',
        governance: 'Governança',
        compliance: 'Conformidade',
        forms: 'Formulários',
        form: 'Formulário',
        connectors: 'Conectores',
        connector: 'Conector',
        integration: 'Integração',
        integrations: 'Integrações',
        security: 'Segurança',
        encryption: 'Criptografia',
        backup: 'Cópia de segurança',
        recovery: 'Recuperação',
        maintenance: 'Manutenção',
        settings: 'Configurações',
        configuration: 'Configuração',
        sla: 'SLA',
        escalation: 'Escalada',
        remediation: 'Correção',
        evidence: 'Evidência',
        'case-management': 'Gerenciamento de Casos',
        profile: 'Perfil',
        delegation: 'Delegação',
        'service-accounts': 'Contas de serviço',
        license: 'Licença',
        'license-management': 'Gerenciamento de licenças',
        plan: 'Plano',
        plans: 'Planos',
        dashboard: 'Painel',
        'web-consent': 'Consentimento da Web',
        'partner-marketplace': 'Mercado de parceiros',
        partner: 'Parceiro',
        partners: 'Parceiros',
        deliverables: 'Entregáveis',
        'service-tiers': 'Níveis de serviço',
        'support-tickets': 'Tíquetes de suporte',
        'audit-trail': 'Trilha de auditoria',
        'first-time-setup': 'Configuração inicial',
        setup: 'Configuração',
        quickstart: 'Início rápido',
        tour: 'Passeio',
        tours: 'Passeios',
        'sample-data': 'Dados de amostra',
        'data-subject': 'Titular dos dados',
        'data-subjects': 'Titulares dos dados',
        pseudonymous: 'Pseudônimo',
        identified: 'Identificado',
        'help-center': 'Central de Ajuda',
        article: 'Artigo',
        articles: 'Artigos',
        search: 'Pesquisar',
        'platform-settings': 'Configurações da plataforma',
        'platform-config': 'Configuração da plataforma',
        'module-config': 'Configuração do módulo',
        'module-configuration': 'Configuração do módulo',
        'rights-requests': 'Solicitações de direitos',
        'access-accountability': 'Responsabilidade de acesso',
        'data-discovery': 'Descoberta de dados',
        'incident-ops': 'Operações de Incidentes',
        'deletion-orchestration': 'Orquestração de exclusão',
        'compliance-forms': 'Formulários de Conformidade',
        'program-governance': 'Governança do Programa',
        localization: 'Localização',
        'privacy-scanner': 'Verificador de privacidade',
        'consent-properties': 'Propriedades de consentimento',
        acceptances: 'Aceitações',
        access: 'Acesso',
        'access-review': 'Revisão de acesso',
        'access-reviews': 'Acessar avaliações',
        accountability: 'Responsabilidade',
        acknowledgment: 'Reconhecimento',
        'action-plans': 'Planos de Ação',
        activation: 'Ativação',
        activations: 'Ativações',
        'active-response': 'Resposta Ativa',
        activity: 'Atividade',
        adequacy: 'Adequação',
        'admin-guide': 'Guia de administração',
        aggregation: 'Agregação',
        agreements: 'Acordos',
        ai: 'AI',
        alerts: 'Alertas',
        analytics: 'Análise',
        anchoring: 'Ancoragem',
        approval: 'Aprovação',
        approvals: 'Aprovações',
        apps: 'Aplicativos',
        assets: 'Ativos',
        assignments: 'Tarefas',
        attestation: 'Atestado',
        'audit-log': 'Registro de auditoria',
        'audit-pack': 'Pacote de auditoria',
        authentication: 'Autenticação',
        authority: 'Autoridade',
        'auto-play': 'Reprodução automática',
        automated: 'Automatizado',
        automation: 'Automação',
        baseline: 'Linha de base',
        batches: 'Lotes',
        bidirectional: 'Bidirecional',
        bilingual: 'Bilíngue',
        bindings: 'Ligações',
        blockchain: 'Blockchain',
        board: 'Conselho',
        brand: 'Marca',
        brds: 'BRDs',
        'break-glass': 'Quebra-vidro',
        builder: 'Construtor',
        bulk: 'Massa',
        'bulk-sync': 'Sincronização em massa',
        bundles: 'Pacotes',
        calendar: 'Calendário',
        campaigns: 'Campanhas',
        cases: 'Casos',
        categories: 'Categorias',
        category: 'Categoria',
        certification: 'Certificação',
        chain: 'Corrente',
        change: 'Mudança',
        'change-awareness': 'Conscientização sobre a mudança',
        'change-log': 'Registro de alterações',
        'change-management': 'Gestão de Mudanças',
        'change-requests': 'Solicitações de mudança',
        'cmp-validation': '[[TOK_0]] Validação',
        collection: 'Coleção',
        comparison: 'Comparação',
        completeness: 'Completude',
        completion: 'Conclusão',
        'compliance-posture': 'Postura de Conformidade',
        'compliance-proof': 'Prova de Conformidade',
        'compliance-reviews': 'Avaliações de conformidade',
        config: 'Configuração',
        confirmation: 'Confirmação',
        conflicts: 'Conflitos',
        consolidation: 'Consolidação',
        continuous: 'Contínuo',
        contracts: 'Contratos',
        controls: 'Controles',
        cookies: 'Biscoitos',
        cooperation: 'Cooperação',
        coordination: 'Coordenação',
        'corporate-governance': 'Governança Corporativa',
        'corrective-actions': 'Ações Corretivas',
        coverage: 'Cobertura',
        'credential-vault': 'Cofre de credenciais',
        credentials: 'Credenciais',
        cycles: 'Ciclos',
        dashboards: 'Painéis',
        'data-assets': 'Ativos de dados',
        'data-flows': 'Fluxos de dados',
        'data-sensitivity': 'Sensibilidade de dados',
        'data-steward': 'Administrador de dados',
        deadlines: 'Prazos',
        'decree-356': 'Decreto 356',
        dedup: 'Deduplicação',
        definitions: 'Definições',
        deliverable: 'Entregável',
        departments: 'Departamentos',
        'dependency-order': 'Ordem de Dependência',
        deployment: 'Implantação',
        detection: 'Detecção',
        diff: 'Diferença',
        'digital-properties': 'Propriedades Digitais',
        dimensions: 'Dimensões',
        disable: 'Desativar',
        'disaster-recovery': 'Recuperação de desastres',
        disclosure: 'Divulgação',
        documentation: 'Documentação',
        documents: 'Documentos',
        domains: 'Domínios',
        dossier: 'Dossiê',
        dpa: 'DPA',
        drift: 'Deriva',
        'drift-detection': 'Detecção de deriva',
        'due-diligence': 'Devida Diligência',
        email: 'Email',
        emergency: 'Emergência',
        enable: 'Habilitar',
        'enterprise-map': 'Mapa Empresarial',
        erasure: 'Apagamento',
        evaluation: 'Avaliação',
        'event-bus': 'Ônibus de eventos',
        exceptions: 'Exceções',
        execution: 'Execução',
        executive: 'Executivo',
        exercises: 'Exercícios',
        export: 'Exportar',
        exports: 'Exportações',
        filing: 'Arquivamento',
        filter: 'Filtro',
        filtering: 'Filtragem',
        findings: 'Descobertas',
        flows: 'Fluxos',
        'follow-up': 'Acompanhamento',
        forensic: 'Forense',
        forensics: 'Perícia',
        'form-filler': 'Preenchimento de formulário',
        framework: 'Estrutura',
        frameworks: 'Estruturas',
        'gap-analysis': 'Análise de lacunas',
        'gap-report': 'Relatório de lacunas',
        gaps: 'Lacunas',
        gates: 'Portões',
        'getting-started': 'Primeiros passos',
        'golden-templates': 'Modelos Dourados',
        grc: 'GRC',
        'group-management': 'Gestão de Grupo',
        groups: 'Grupos',
        'guided-tours': 'Visitas Guiadas',
        guides: 'Guias',
        handling: 'Manuseio',
        'hands-on': 'Prática',
        health: 'Saúde',
        help: 'Ajuda',
        hierarchy: 'Hierarquia',
        history: 'História',
        i18n: 'i18n',
        iam: 'IAM',
        'identity-provider': 'Provedor de identidade',
        implementation: 'Implementação',
        import: 'Importar',
        improvement: 'Melhoria',
        'incident-response': 'Resposta a Incidentes',
        inconsistencies: 'Inconsistências',
        instances: 'Instâncias',
        intake: 'Ingestão',
        'intake-key': 'Chave de entrada',
        interactive: 'Interativo',
        international: 'Internacional',
        inventory: 'Inventário',
        investigation: 'Investigação',
        investigations: 'Investigações',
        'ip-allowlist': 'Lista de permissões de IP',
        issues: 'Problemas',
        justification: 'Justificativa',
        justifications: 'Justificativas',
        kanban: 'Kanban',
        keyboard: 'Teclado',
        keys: 'Chaves',
        'knowledge-base': 'Base de Conhecimento',
        koncernstyring: 'Governança Corporativa',
        kpi: 'KPI',
        labeling: 'Rotulagem',
        language: 'Idioma',
        'language-packs': 'Pacotes de idiomas',
        languages: 'Idiomas',
        lawfulness: 'Legalidade',
        layout: 'Disposição',
        'legal-basis': 'Base jurídica',
        'lessons-learned': 'Lições aprendidas',
        levels: 'Níveis',
        library: 'Biblioteca',
        lifecycle: 'Ciclo de vida',
        lineage: 'Linhagem',
        links: 'Ligações',
        listings: 'Listagens',
        live: 'Ao vivo',
        locale: 'Local',
        log: 'Log',
        logging: 'Registro',
        'managed-service': 'Serviço gerenciado',
        mapping: 'Mapeamento',
        mappings: 'Mapeamentos',
        'market-packs': 'Pacotes de Mercado',
        marketplace: 'Mercado',
        maturity: 'Maturidade',
        metrics: 'Métricas',
        models: 'Modelos',
        module: 'Módulo',
        modules: 'Módulos',
        mps: 'MPS',
        'multi-factor': 'Multifator',
        'multi-market': 'Multimercado',
        'multi-org': 'Multiorganização',
        'multi-property': 'Multipropriedade',
        'my-tasks': 'Minhas tarefas',
        obligations: 'Obrigações',
        offboarding: 'Desativação',
        oidc: 'OIDC',
        orchestration: 'Orquestração',
        'org-groups': 'Grupos organizacionais',
        organization: 'Organização',
        overdue: 'Atrasado',
        overview: 'Visão geral',
        'owner-review': 'Avaliação do proprietário',
        package: 'Pacote',
        packages: 'Pacotes',
        packs: 'Pacotes',
        pagination: 'Paginação',
        'parent-child': 'Pai-filho',
        patterns: 'Padrões',
        performance: 'Desempenho',
        periodic: 'Periódico',
        periods: 'Períodos',
        personal: 'Pessoal',
        'personal-data': 'Dados Pessoais',
        personas: 'Personagens',
        planning: 'Planejamento',
        platform: 'Plataforma',
        playbooks: 'Manuais',
        poc: 'PoC',
        'point-in-time': 'Ponto no tempo',
        policies: 'Políticas',
        portfolio: 'Portfólio',
        'post-incident': 'Pós-incidente',
        'power-user': 'Usuário avançado',
        practice: 'Pratique',
        pricing: 'Preços',
        'privacy-impact': 'Impacto na privacidade',
        procedures: 'Procedimentos',
        processes: 'Processos',
        processing: 'Processamento',
        'processing-activities': 'Atividades de processamento',
        procurement: 'Aquisições',
        productivity: 'Produtividade',
        profiles: 'Perfis',
        programs: 'Programas',
        progress: 'Progresso',
        proof: 'Prova',
        propagation: 'Propagação',
        properties: 'Propriedades',
        'pub-sub': 'Pub-Sub',
        'public-form': 'Formulário Público',
        quality: 'Qualidade',
        questionnaires: 'Questionários',
        'quick-links': 'Links rápidos',
        'quick-start': 'Início rápido',
        'quick-starts': 'Inícios rápidos',
        raci: 'RACI',
        readiness: 'Prontidão',
        'real-time': 'Tempo real',
        reassessments: 'Reavaliações',
        reconciliation: 'Reconciliação',
        record: 'Gravar',
        records: 'Registros',
        recurring: 'Recorrente',
        register: 'Cadastre-se',
        registry: 'Registro',
        regulations: 'Regulamentos',
        regulator: 'Regulador',
        regulatory: 'Regulatório',
        'regulatory-frameworks': 'Marcos Regulatórios',
        remap: 'Remapear',
        reminders: 'Lembretes',
        reports: 'Relatórios',
        requests: 'Solicitações',
        requirements: 'Requisitos',
        response: 'Resposta',
        'response-plans': 'Planos de Resposta',
        'response-team': 'Equipe de Resposta',
        'response-templates': 'Modelos de resposta',
        'response-time': 'Tempo de resposta',
        responses: 'Respostas',
        responsibility: 'Responsabilidade',
        results: 'Resultados',
        review: 'Revisão',
        reviews: 'Avaliações',
        'right-to-delete': 'Direito de excluir',
        rights: 'Direitos',
        'risk-tiers': 'Níveis de risco',
        rollouts: 'Lançamentos',
        rollup: 'Acúmulo',
        ropa: 'ROPA',
        routing: 'Roteamento',
        rpo: 'RPO',
        rto: 'RTO',
        rules: 'Regras',
        runs: 'Corre',
        saml: 'SAML',
        scan: 'Digitalizar',
        scanning: 'Digitalizando',
        scc: 'SCC',
        schedule: 'Cronograma',
        scheduled: 'Agendado',
        schedules: 'Horários',
        scheduling: 'Agendamento',
        scores: 'Pontuações',
        scoring: 'Pontuação',
        scripts: 'Roteiros',
        'security-reviews': 'Avaliações de segurança',
        'sensitive-data': 'Dados confidenciais',
        sensitivity: 'Sensibilidade',
        'separation-of-duties': 'Separação de Funções',
        service: 'Serviço',
        sessions: 'Sessões',
        'setup-wizard': 'Assistente de configuração',
        severity: 'Gravidade',
        'shared-governance': 'Governança Compartilhada',
        'shared-settings': 'Configurações compartilhadas',
        shortcuts: 'Atalhos',
        sidebar: 'Barra lateral',
        signals: 'Sinais',
        'single-sign-on': 'Logon único',
        snapshots: 'Instantâneos',
        sod: 'SoD',
        sorting: 'Classificando',
        sources: 'Fontes',
        staging: 'Encenação',
        standards: 'Padrões',
        status: 'Estado',
        structure: 'Estrutura',
        'sub-processor': 'Subprocessador',
        'sub-processors': 'Subprocessadores',
        submissions: 'Envios',
        subprocessors: 'Subprocessadores',
        subscription: 'Assinatura',
        suggestions: 'Sugestões',
        summaries: 'Resumos',
        supplements: 'Suplementos',
        support: 'Suporte',
        sync: 'Sincronizar',
        system: 'Sistema',
        systems: 'Sistemas',
        tables: 'Tabelas',
        tagging: 'Marcação',
        'tamper-proof': 'À prova de adulteração',
        taxonomies: 'Taxonomias',
        taxonomy: 'Taxonomia',
        tenants: 'Inquilinos',
        termination: 'Rescisão',
        'third-party': 'Terceiros',
        'ticket-sync': 'Sincronização de ingressos',
        tickets: 'Ingressos',
        tiers: 'Níveis',
        tokens: 'Fichas',
        totp: 'TOTP',
        traceability: 'Rastreabilidade',
        tracking: 'Rastreamento',
        trail: 'Trilha',
        training: 'Treinamento',
        translation: 'Tradução',
        translations: 'Traduções',
        transparency: 'Transparência',
        trends: 'Tendências',
        unified: 'Unificado',
        updates: 'Atualizações',
        validation: 'Validação',
        vault: 'Cofre',
        'vendor-requests': 'Solicitações de fornecedores',
        verification: 'Verificação',
        versioning: 'Versionamento',
        versions: 'Versões',
        vietnam: 'Vietnã',
        violations: 'Violações',
        visualization: 'Visualização',
        waivers: 'Isenções',
        'web-records': 'Registros da Web',
        website: 'Site',
        websites: 'Sites',
        weights: 'Pesos',
        'white-label': 'Etiqueta Branca',
        withdrawal: 'Retirada',
    },
    module_labels: {
        rights_requests: 'Pedidos de Direitos',
        data_mapping: 'Registo de Atividades de Tratamento',
        governance: 'Governação de Fornecedores',
        consent: 'Governação de Consentimento',
        consent_properties: 'Propriedades de consentimento',
        assessments: 'AIPD e Avaliações',
        classification: 'Classificação de Dados',
        monitoring: 'Programas de Monitorização',
        program: 'Programa de Monitorização',
        incidents: 'Resposta a Incidentes',
        connectors: 'Conectores',
        vendor_risk: 'Risco do fornecedor',
        deletion_orchestration: 'Orquestração de exclusão',
        discovery: 'Descoberta de dados',
        incident_ops: 'Operações de incidentes',
        program_governance: 'Governança de programas',
        access_accountability: 'Responsabilidade de acesso',
        localization: 'Localização',
        partner_workspace: 'Espaço de trabalho de parceiros',
        privacy_scanner: 'Scanner de privacidade',
        onboarding: 'Integração',
        compliance_forms: 'Formulários de Conformidade',
        audit_trail: 'Trilha de Auditoria',
        data_subjects: 'Titulares dos Dados',
        organizations: 'Organizações',
        task_management: 'Gerenciamento de tarefas',
        deletion_orch: 'Orquestração de exclusão',
        forms: 'Formulários de conformidade',
        partner_marketplace: 'Mercado de parceiros',
        dashboard: 'Painel de controlo',
        platform_settings: 'Configurações da plataforma',
        help_center: 'Centro de Ajuda',
    },
    module_descriptions: {
        rights_requests: 'Gerir pedidos de direitos dos titulares de dados, incluindo acesso, eliminação e portabilidade. Acompanhar o ciclo de vida dos pedidos, atribuir responsáveis e cumprir prazos regulamentares.',
        data_mapping: 'Mapear fluxos de dados na sua organização. Acompanhar atividades de tratamento, categorias de dados, finalidades, políticas de retenção e integrações de sistemas.',
        governance: 'Gerir a conformidade e governação de fornecedores. Acompanhar avaliações de fornecedores, contratos, desempenho de SLA e obrigações regulamentares.',
        consent: 'Gerir a recolha, armazenamento e retirada de consentimento. Acompanhar registos de consentimento, finalidades e integração com plataformas de gestão de consentimento.',
        consent_properties: 'Configurar propriedades de consentimento, grupos e modelos de referência. Definir configurações de consentimento reutilizáveis para implementação consistente.',
        assessments: 'Realizar Avaliações de Impacto sobre a Proteção de Dados (AIPD) e avaliações de risco de privacidade. Avaliar atividades de tratamento quanto a riscos de conformidade.',
        classification: 'Classificar ativos de dados por nível de sensibilidade. Aplicar etiquetas de taxonomia, acompanhar registos do ciclo de vida e identificar lacunas de classificação.',
        monitoring: 'Configurar programas de monitorização para acompanhar métricas de conformidade, indicadores-chave de risco e eficácia dos controlos ao longo do tempo.',
        incidents: 'Reportar e gerir incidentes de privacidade e violações de dados. Acompanhar fluxos de trabalho de investigação, notificação e remediação.',
        connectors: 'Configurar conectores de fontes de dados e integrações. Ligar sistemas externos para descoberta automatizada de dados e monitorização.',
        vendor_risk: 'Avaliar e monitorizar riscos de fornecedores terceiros. Pontuar fornecedores, acompanhar mitigação de riscos e gerir configurações de risco de fornecedores.',
        deletion_orchestration: 'Orquestrar a eliminação de dados em todos os sistemas. Acompanhar pedidos de eliminação, verificar cadeias de prova e garantir a remoção completa dos dados.',
        discovery: 'Descobrir dados pessoais em sistemas ligados. Analisar fontes de dados para construir um inventário abrangente de dados.',
        incident_ops: 'Gestão operacional de incidentes com manuais de procedimentos, fluxos de trabalho de escalonamento e acompanhamento de SLA para resolução de incidentes.',
        program_governance: 'Acompanhar a maturidade global do programa de privacidade, pontuações de conformidade, lacunas de evidência e relatórios executivos em toda a organização.',
        access_accountability: 'Investigar e auditar padrões de acesso de utilizadores. Acompanhar configurações de acesso, monitorizar atividade suspeita e garantir a responsabilização.',
        localization: 'Instalar e gerir pacotes de localização de mercado. Adicionar quadros regulamentares, pacotes de idiomas e conteúdo de conformidade específico da região.',
        partner_workspace: 'Colaborar com parceiros externos. Partilhar dados de conformidade, acompanhar obrigações de parceiros e gerir relações com parceiros.',
        privacy_scanner: 'Analisar websites quanto a problemas de conformidade de privacidade. Monitorizar a utilização de cookies, scripts de rastreamento e a presença de políticas de privacidade em tempo real.',
        onboarding: 'Orientar novas organizações na configuração da plataforma. Assistente de integração passo a passo para configuração inicial e importação de dados.',
        compliance_forms: 'Criar e gerir formulários de conformidade a partir de um catálogo de modelos. Preencher formulários regulamentares, acompanhar submissões e gerar relatórios.',
        audit_trail: 'Visualizar uma trilha de auditoria completa de todas as ações do sistema. Acompanhar quem fez o quê, quando e onde em todos os módulos.',
        organizations: 'Gerir organizações e definições multi-inquilino. Configurar perfis de organizações, hierarquias e relações entre organizações.',
    },
    privacy_scanner: {
        anomaly_explain: {
            explain_label: 'Explique anomalias',
            explaining: 'Explicando…',
            results_heading: 'Explicações de anomalias ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            items_label: '[[TOK_1]] itens',
            remediation_label: 'Etapas de correção',
            items_detail_label: 'Itens afetados',
            accept_label: 'Aceitar explicação',
            reject_label: 'Rejeitar explicação',
            error_generic: 'Não foi possível explicar as anomalias. Tente novamente ou verifique se a verificação foi concluída com sucesso.',
        },
        cookie_insight: {
            insight_label: 'Insight de cookie e rastreador [[TOK_0]]',
            producing: 'Produzindo insights…',
            results_heading: 'Informações sobre cookies e rastreadores ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] tokens',
            items_label: '[[TOK_1]] itens',
            classification_label: 'Classificação',
            severity_label: 'Gravidade',
            banner_copy_label: 'Cópia de banner sugerida',
            retention_label: 'Conselhos sobre retenção',
            citations_label: 'Citações',
            kind_cookie: 'Biscoito',
            kind_tracker: 'Rastreador',
            class_necessary: 'Necessário',
            class_analytics: 'Análise',
            class_marketing: 'Comercialização',
            class_social: 'Sociais',
            accept_label: 'Aceitar insights',
            reject_label: 'Rejeitar insights',
            no_items: 'Nenhum cookie ou rastreador foi detectado nesta verificação.',
            error_generic: 'Não foi possível produzir o insight do cookie. Tente novamente ou verifique se a verificação foi concluída com sucesso.',
        },
        monitoring: {
            title: 'Monitorização de Privacidade',
            new_scan: 'Nova Análise',
            scan_url: 'URL a Analisar',
            scan_frequency: 'Frequência de Análise',
            last_scan: 'Última Análise',
            score: 'Pontuação de Privacidade',
            issues: 'Problemas Encontrados',
            history: 'Histórico de Análises',
            settings: 'Definições de Monitorização',
        },
        real_time: {
            title: 'Analisador em Tempo Real',
            scan_now: 'Analisar Agora',
            scanning: 'A analisar...',
            results: 'Resultados da Análise',
            no_results: 'Ainda sem resultados de análise.',
            cookies: 'Biscoitos',
            trackers: 'Rastreadores',
            consent_banners: 'Faixas de Consentimento',
            third_party: 'Scripts de Terceiros',
            archive: 'Arquivo de Resultados',
            settings: 'Definições do Analisador',
        },
        dashboard: {
            page_title: 'Painel de monitoramento de privacidade',
            privacy_monitoring: 'Monitoramento de privacidade',
            plan_label: '[[TOK_1]] plano',
            expires_label: 'expira [[TOK_1]]',
            settings: 'Configurações',
            refresh: 'Atualizar',
            refreshing_dashboard: 'Atualizando painel de monitoramento',
            refresh_aria: 'Atualizar painel de monitoramento',
            not_configured_title: 'Monitoramento de privacidade não configurado',
            not_configured_desc: 'Conecte seu serviço de monitoramento de privacidade [[TOK_0]] para começar a monitorar a conformidade do site.',
            configure_monitoring: 'Configurar monitoramento',
            license_expired_title: 'Licença expirada',
            license_expired_desc: 'Sua licença de monitoramento de privacidade [[TOK_0]] expirou. Por favor, renove-o para evitar interrupção do serviço.',
            compliance_score: 'Pontuação de Conformidade',
            cookies_detected: 'Cookies detectados',
            trackers_label: 'Rastreadores',
            open_issues: 'Problemas em aberto',
            score_good: 'Bom',
            score_needs_improvement: 'Precisa de melhorias',
            score_critical: 'Crítico',
            action_required: 'Ação necessária',
            cookies_sr: 'cookies detectados',
            trackers_sr: 'rastreadores encontrados',
            open_issues_sr: 'questões em aberto',
            action_required_sr: 'ação necessária',
            metric_label: 'Métrica',
            value_label: 'Valor',
            status_label: 'Estado',
            aria_metrics: 'Métricas de monitoramento de privacidade',
            plan_limit_warning: 'Verificando [[TOK_4]]: [[TOK_2]]/[[TOK_3]] — você atingiu o limite do seu plano.',
            manage_domains: 'Gerencie domínios ou atualize seu plano.',
            monitored_domains: 'Domínios Monitorados',
            domain_added: 'Domínio [[TOK_1]] adicionado',
            domain_removed: 'Domínio [[TOK_1]] removido',
            failed_add_domain: 'Falha ao adicionar domínio',
            failed_remove_domain: 'Falha ao remover o domínio',
            failed_load: 'Falha ao carregar o painel de monitoramento',
            new_domain_aria: 'Novo domínio [[TOK_0]]',
            add_domain: 'Adicionar domínio',
            adding_domain: 'Adicionando…',
            no_domains: 'Nenhum domínio monitorado configurado ainda.',
            aria_domains_table: 'Domínios monitorados',
            col_domain: 'Domínio',
            col_compliance_score: 'Pontuação de Conformidade',
            col_status: 'Estado',
            col_cookies: 'Biscoitos',
            col_trackers: 'Rastreadores',
            col_issues: 'Problemas',
            col_last_scan: 'Última verificação',
            col_action: 'Ação',
            compliance_status_sr: 'status de conformidade',
            showing_chart: 'Mostrando visualização de gráfico',
            showing_table: 'Mostrando visualização da tabela de dados',
            loading_sr: 'Carregando painel de monitoramento',
            col_framework_tags: 'Etiquetas de estrutura',
            col_last_monitored: 'Último monitorado',
            framework_tags_sr: 'quadros regulamentares aplicáveis',
            last_monitored_sr: 'carimbo de data/hora de monitoramento contínuo',
            audit_trail_heading: 'Trilha de auditoria',
            audit_trail_info: 'Cada varredura de monitoramento recebe carimbo de data/hora e é registrada. As alterações de conformidade em nível de domínio produzem um registro de auditoria imutável que pode ser exportado para revisão regulatória.',
            cybersecurity_law_info_heading: 'Detecção de leis de segurança cibernética',
            cybersecurity_law_info: 'Os domínios monitorados são automaticamente verificados em relação aos requisitos da lei de segurança cibernética (por exemplo, Lei de Segurança Cibernética do Vietnã, Diretiva [[TOK_0]]). As tags da estrutura indicam quais regulamentos se aplicam. Os problemas são categorizados por estrutura regulatória para remediação direcionada.',
        },
        scan: {
            page_title: 'Verificação em tempo real',
            title: 'Scanner de privacidade em tempo real',
            settings: 'Configurações',
            results_archive: 'Arquivo de resultados',
            launch_scan: 'Iniciar verificação',
            target_url: 'Alvo [[TOK_0]]',
            protocol_aria: 'Protocolo',
            url_required: '[[TOK_0]] é obrigatório',
            url_whitespace: 'Remova os espaços em branco do [[TOK_0]]',
            url_invalid: 'Insira um domínio válido (por exemplo, exemplo.com)',
            add_subpages: 'Adicionar subpáginas',
            add_subpages_aria: 'Adicionar subpáginas, [[TOK_1]] adicionado',
            start_scan: 'Iniciar verificação',
            launching: 'Lançamento…',
            scan_launched: 'Verificação iniciada com sucesso',
            scan_failed: 'Falha ao iniciar a verificação',
            scan_progress: 'Progresso da verificação',
            scanning_in_progress: 'Verificação em andamento…',
            scan_id: 'ID de digitalização',
            status_label: 'Estado',
            status_unknown: 'unknown',
            progress_label: 'Progresso',
            pages_label: 'Páginas',
            refresh_status: 'Atualizar status',
            new_scan: 'Nova digitalização',
            scan_completed: 'Verificação concluída, resultados disponíveis',
            failed_check_status: 'Falha ao verificar o status da verificação',
            scan_results: 'Resultados da verificação',
            main_page: 'Página principal',
            page_n: 'Página [[TOK_1]]',
            result_pages_nav: 'Páginas de resultados',
            page_url: 'Página [[TOK_0]]',
            risk_score: 'Pontuação de risco',
            risk_score_sr: 'pontuação de risco',
            cookies_label: 'Biscoitos',
            cookies_sr: 'cookies detectados',
            scripts_label: 'Roteiros',
            scripts_sr: 'scripts detectados',
            issues_label: 'Problemas',
            issues_sr: 'problemas encontrados',
            issues_found: 'Problemas encontrados',
            aria_issues_table: 'Problemas encontrados durante a verificação',
            col_severity: 'Gravidade',
            col_category: 'Categoria',
            col_title: 'Título',
            col_remediation: 'Correção',
            severity_sr: 'severity',
            scan_result_metrics: 'Métricas de resultados de verificação',
            view_full_detail: 'Ver detalhes completos',
            col_consent_category: 'Categoria de consentimento',
            consent_category_sr: 'categorização de consentimento',
            compliance_evidence_heading: 'Evidência de Conformidade',
            compliance_evidence_info: 'As descobertas da verificação são vinculadas automaticamente aos casos de conformidade. Cada problema pode ser atribuído a uma categoria de consentimento (essencial, funcional, analítico, marketing) e produz evidências prontas para auditoria para revisão regulatória.',
            rule_config_heading: 'Configuração de regras',
            rule_config_info: 'As regras de verificação são configuráveis de acordo com a estrutura regulatória. Verificações de cookies, detecção de scripts e análise de fornecedores podem ser ativadas ou desativadas em Configurações. Regras personalizadas podem ser definidas para atender aos requisitos de conformidade da sua organização.',
            case_linkage_heading: 'Vinculação de Casos de Conformidade',
            case_linkage_info: 'Os problemas encontrados durante as verificações em tempo real podem ser vinculados a casos de conformidade para rastreamento e correção. Navegue até a página Detalhes do resultado da verificação para visualizar associações de casos.',
            subpages_modal_title: 'Adicionar subpáginas',
            subpages_modal_desc: 'Adicione até 5 URLs de subpágina para verificar junto com o domínio principal.',
            subpage_n: 'Subpágina [[TOK_1]]',
        },
        result_detail: {
            page_title: 'Detalhe do resultado da verificação',
            title: 'Resultado da verificação',
            back_to_archive: 'Voltar ao arquivo',
            failed_load: 'Falha ao carregar o resultado da verificação',
            loading_sr: 'Carregando resultado da verificação…',
            scan_id: 'ID de digitalização',
            target_url: 'Alvo [[TOK_0]]',
            status_label: 'Estado',
            status_sr: 'status',
            started: 'Iniciado',
            completed: 'Concluído',
            pages_scanned: 'Páginas digitalizadas',
            https_label: 'HTTPS',
            highest_risk_score: 'Maior pontuação de risco',
            most_cookies: 'A maioria dos biscoitos',
            most_vendors: 'A maioria dos fornecedores terceirizados',
            most_issues: 'A maioria dos problemas',
            across_pages: 'entre páginas',
            highest_values_aria: 'Valores mais altos em todas as páginas',
            scanned_pages_nav: 'Páginas digitalizadas',
            main_page: 'Página principal',
            page_n: 'Página [[TOK_1]]',
            page_url: 'Página [[TOK_0]]',
            risk_score: 'Pontuação de risco',
            overall_risk_sr: 'pontuação geral de risco',
            cookies_label: 'Biscoitos',
            cookies_sr: 'cookies detectados',
            vendors_label: 'Fornecedores terceirizados',
            vendors_sr: 'fornecedores terceirizados detectados',
            issues_label: 'Problemas',
            issues_sr: 'problemas encontrados',
            risk_breakdown_aria: 'Detalhamento da pontuação de risco',
            issues_found: 'Problemas encontrados',
            aria_issues_table: 'Problemas encontrados durante a verificação',
            col_severity: 'Gravidade',
            col_category: 'Categoria',
            col_title: 'Título',
            col_remediation: 'Correção',
            severity_sr: 'severity',
            cookies_heading: 'Cookies ([[TOK_1]])',
            aria_cookies_table: 'Cookies detectados',
            col_name: 'Nome',
            col_domain: 'Domínio',
            col_path: 'Caminho',
            col_secure: 'Seguro',
            col_httponly: 'Somente http',
            col_samesite: 'MesmoSite',
            vendors_heading: 'Fornecedores terceirizados ([[TOK_1]])',
            aria_vendors_table: 'Fornecedores terceirizados detectados',
            col_hostname: 'Nome do host',
            scripts_heading: 'Scripts/Beacons ([[TOK_1]])',
            aria_scripts_table: 'Scripts e beacons detectados',
            col_url: 'URL',
            col_type: 'Tipo',
            links_heading: 'Ligações',
            first_party: 'Primeira parte',
            third_party: 'Terceiros',
            col_risk_category: 'Categoria de risco',
            col_regulatory_framework: 'Marco Regulatório',
            col_actionable_detail: 'Detalhes acionáveis',
            risk_category_sr: 'categoria de risco regulatório',
            risk_category_mapping_heading: 'Mapeamento de categoria de risco',
            risk_category_mapping_info: 'Cada descoberta de varredura é mapeada para uma categoria de risco regulatório (coleta de dados, transferência transfronteiriça, gerenciamento de consentimento, retenção de dados, controles de segurança). Este mapeamento permite uma remediação direcionada priorizada pelo impacto regulatório.',
            compliance_case_heading: 'Associação de casos de conformidade',
            compliance_case_info: 'Os resultados da verificação são vinculados a casos de conformidade para rastreamento de ponta a ponta. Os problemas podem ser escalados diretamente dos resultados da verificação para o fluxo de trabalho do caso de conformidade.',
        },
        results_archive: {
            page_title: 'Arquivo de resultados de verificação',
            title: 'Arquivo de resultados de verificação',
            back_to_scanner: 'Voltar ao scanner',
            failed_load: 'Falha ao carregar os resultados da verificação',
            results_loaded: 'Resultados da verificação carregados, registros [[TOK_1]]',
            total_label: 'Total: [[TOK_1]]',
            aria_table: 'Arquivo de resultados da verificação',
            col_scan_date: 'Data da verificação',
            col_target_url: 'Alvo [[TOK_0]]',
            col_duration: 'Duração',
            col_issues_found: 'Problemas encontrados',
            col_risk_score: 'Pontuação de risco',
            col_status: 'Estado',
            col_actions: 'Ações',
            scan_status_sr: 'status da verificação',
            view_result: 'Ver',
            no_results: 'Nenhum resultado de verificação encontrado.',
            loading_sr: 'Carregando resultados da verificação',
            pagination_aria: 'Paginação dos resultados da verificação',
            col_risk_category: 'Categoria de risco',
            risk_category_sr: 'categoria de risco regulatório',
            archive_retention_heading: 'Retenção de Arquivo',
            archive_retention_info: 'Os resultados da verificação são retidos pelo período especificado na política de retenção de dados da sua organização. Os resultados arquivados incluem o contexto completo da verificação (tags de estrutura, categorias de risco, orientações de remediação) e podem ser exportados como [[TOK_0]] para evidências regulatórias.',
            export_context_info: 'Os arquivos [[TOK_0]] exportados incluem contexto regulatório: categoria de risco, estruturas aplicáveis e detalhes de correção acionáveis para cada descoberta.',
        },
        scanner_settings: {
            page_title: 'Configurações do scanner',
            title: 'Configurações do scanner',
            back_to_scanner: 'Voltar ao scanner',
            failed_load: 'Falha ao carregar a configuração do scanner',
            endpoint_url: 'Ponto final [[TOK_0]]',
            save_success: 'Configuração do scanner salva com sucesso.',
            save_failed: 'Falha ao salvar a configuração do scanner',
            test_connection: 'Conexão de teste',
            testing: 'Testando...',
            save_configuration: 'Salvar configuração',
            saving: 'Salvando...',
            loading_sr: 'Carregando configurações do scanner',
        },
        monitoring_settings: {
            page_title: 'Configurações de monitoramento de privacidade',
            title: 'Configurações de monitoramento',
            back_to_dashboard: 'Voltar ao painel',
            failed_load: 'Falha ao carregar a configuração de monitoramento',
            credentials_heading: '[[TOK_0]] Credenciais',
            connected_as: 'Conectado como [[TOK_1]]',
            credentials_desc: 'Insira as credenciais da sua conta [[TOK_0]] para conectar o Monitoramento de privacidade. Encontre seu ID de membro na página de perfil da sua conta [[TOK_1]].',
            client_id: 'ID do cliente',
            client_secret: 'Segredo do cliente',
            username: '[[TOK_0]] Nome de usuário (e-mail)',
            password: '[[TOK_0]] Senha',
            placeholder_keep: '(deixe em branco para continuar existente)',
            credential_form_aria: '[[TOK_0]] formulário de credencial',
            test_connection: 'Conexão de teste',
            testing: 'Testando…',
            test_aria: 'Testar conexão [[TOK_0]]',
            testing_aria: 'Testando conexão',
            save_configuration: 'Salvar configuração',
            saving: 'Salvando…',
            save_aria: 'Salvar credenciais',
            saving_aria: 'Salvando credenciais',
            credentials_saved: 'Credenciais [[TOK_0]] salvas com sucesso.',
            credentials_saving: '[[TOK_0]] credenciais salvas. Recarregando configuração…',
            credentials_save_failed: 'Falha ao salvar credenciais',
            client_id_required: 'O ID do cliente e o nome de usuário são obrigatórios.',
            all_fields_required: 'Todos os campos de credenciais são obrigatórios.',
            email_heading: 'Notificações por e-mail',
            receive_emails: 'Receba e-mails de relatórios de verificação',
            email_toggle_aria: 'Alternar e-mails de relatório de verificação',
            only_on_change: 'Somente enviar e-mail quando o status do risco mudar',
            only_on_change_aria: 'Alternar e-mail somente na mudança de status de risco',
            emails_enabled: 'Verificar e-mails de relatório ativados',
            emails_disabled: 'Verificar e-mails de relatório desativados',
            only_change_on: 'Somente envio de e-mail sobre mudança de risco',
            only_change_off: 'Envio de e-mail em cada digitalização',
            email_failed: 'Falha ao atualizar a configuração de e-mail',
            email_settings_aria: 'Configurações de notificação por e-mail',
            loading_sr: 'Carregando configurações de monitoramento',
        },
        entity_types: {
            user: 'Usuário',
            case: 'Caso',
            incident: 'Incidente',
            assessment: 'Avaliação',
            vendor: 'Fornecedor',
            consent: 'Consentimento',
            policy: 'Política',
            data_map: 'Mapa de dados',
        },
        actions: {
            create: 'Criar',
            update: 'Atualizar',
            delete: 'Excluir',
            view: 'Ver',
            export: 'Exportar',
            status_change: 'Mudança de status',
        },
    },
    forms: {
        dashboard: {
            title: 'Painel de Formulários',
            total_templates: 'Total de Modelos',
            installed: 'Instalado',
            available: 'Disponível',
            by_market: 'Por Mercado',
            back_dashboard: 'Voltar para Painel de controlo',
            browse_templates: 'Explorar modelos',
            catalog_coverage: 'Cobertura do catálogo',
            quick_start: 'Início rápido',
            recent_instances: 'Instâncias recentes',
            total_instances: 'Total de instâncias',
            fetch_failed: 'Falha ao fetch dashboard data. Por favor, tente novamente.',
            no_instances: 'Nenhum instances encontrado',
            form_metrics: 'Visão geral de métricas de formulários',
            templates_total: 'modelos no total',
            instances_total: 'instâncias no total',
            installed_of_available: '[[TOK_2]] de [[TOK_3]] instalado',
            templates_in_category: 'modelos em {category}',
        },
        templates: {
            title: 'Modelos de Formulários',
            new: 'Novo Modelo',
            edit: 'Editar Modelo',
            name: 'Nome do Modelo',
            form_type: 'Tipo de Formulário',
            market: 'Mercado',
            language: 'Idioma',
            schema: 'Esquema do Formulário',
            preview: 'Pré-visualizar',
            duplicate: 'Duplicar Modelo',
            grid_view: 'Vista em grelha',
            list_view: 'Lista Ver',
            fetch_failed: 'Falha ao fetch templates. Por favor, tente novamente.',
            filter_templates: 'Filtrar modelos',
            version_history: 'Histórico de versões',
            no_version_history: 'Sem histórico de versões — esta é a versão inicial.',
            form_id: 'ID do formulário',
            source_instrument: 'Instrumento de origem',
            issuer: 'Emissor',
            all_frameworks: 'Todas as estruturas',
            view_mode: 'Modo de visualização',
        },
        catalog: {
            title: 'Catálogo de Formulários',
            install: 'Instalar',
            uninstall: 'Desinstalar',
            install_all: 'Instalar Todos',
            installed_tab: 'Instalados',
            catalog_tab: 'Catálogo',
            search_placeholder: 'Pesquisar modelos...',
            no_templates: 'Nenhum modelo encontrado.',
            template_count: '{count} modelos',
            all_markets: 'Todos os mercados',
            sections: 'Secções',
            all_categories: 'Todas as categorias',
            category: 'Categoria',
            category_install_failed: 'Falha ao install category templates. Por favor, tente novamente.',
            category_install_success: 'Modelos de categoria instalados.',
            fetch_failed: 'Falha ao fetch templates. Por favor, tente novamente.',
            fetch_installed_failed: 'Falha ao fetch installed templates. Por favor, tente novamente.',
            fields: 'Campos',
            install_failed: 'Falha ao install template. Por favor, tente novamente.',
            install_success: 'Modelo installed com sucesso.',
            installing: 'A instalar...',
            removing: 'A remover...',
            uninstall_confirm: 'Tem a certeza de que pretende desinstalar este modelo?',
            uninstall_failed: 'Falha ao uninstall template. Por favor, tente novamente.',
            uninstall_success: 'Modelo uninstalled com sucesso.',
            installation_summary: 'Resumo da instalação',
            filter_catalog: 'Filtrar catálogo',
            all_frameworks: 'Todas as estruturas',
            templates_installed_count: '[[TOK_1]] modelos instalados com sucesso',
            all_already_installed: 'Todos os modelos nesta categoria já estão instalados',
            form_id: 'ID do formulário',
            issuer: 'Emissor',
            catalog_tabs: 'Abas do catálogo de formulários',
        },
        filler: {
            back_templates: 'Voltar para Modelos',
            no_sections: 'Nenhum sections encontrado',
            draft_created: 'Rascunho criado.',
            draft_saved: 'Rascunho guardado.',
            fetch_template_failed: 'Falha ao fetch template. Por favor, tente novamente.',
            save_draft: 'Guardar Rascunho',
            save_draft_failed: 'Falha ao save draft. Por favor, tente novamente.',
            saving: 'A guardar...',
            select_option: 'Selecione option',
            submit: 'Submeter',
            submit_failed: 'Falha ao submit. Por favor, tente novamente.',
            submitting: 'A submeter...',
            title: 'Assistente de formulário',
            form_id_label: 'ID do formulário',
            schema_label: 'Esquema',
            framework_label: 'Estrutura',
            issuer_label: 'Emissor',
            source_label: 'Fonte',
            market_label: 'Mercado',
            section_of: 'Seção {current} de {total}',
            form_navigation: 'Navegação do formulário',
            form_progress: 'Progresso do formulário: Seção {current} de {total}',
            removed_item: 'Item {index} removido de {field}',
            added_item: 'Novo item adicionado a {field}',
            go_to_previous: 'Ir para a seção anterior, seção {current} de {total}',
            go_to_next: 'Ir para a próxima seção, seção {current} de {total}',
            risk_matrix_placeholder: '1–5',
        },
        filing: {
            title: 'Estado de submissão',
            advance: 'Avançar estado de submissão...',
            not_started: 'Não iniciado',
            drafting: 'Rascunho',
            internal_review: 'Revisão interna',
            approved_for_submission: 'Aprovado para submissão',
            submitted_to_authority: 'Submetido à autoridade',
            supplement_requested: 'Complemento solicitado',
            supplement_in_progress: 'Complemento em andamento',
            resubmitted: 'Reenviado',
            accepted: 'Aceite',
            rejected: 'Rejeitado',
            closed: 'Encerrado',
        },
        instances: {
            approved_by: 'Aprovado Por',
            form_answers: 'Respostas do formulário',
            no_answers: 'Nenhum answers encontrado',
            view_outputs: 'Ver Outputs',
            approve: 'Aprovar',
            approve_failed: 'Falha ao approve. Por favor, tente novamente.',
            approving: 'A aprovar...',
            detail_title: 'Detalhe da instância',
            fetch_failed: 'Falha ao fetch instances. Por favor, tente novamente.',
            generate_failed: 'Falha ao generate output. Por favor, tente novamente.',
            generate_output: 'Gerar resultado',
            generating: 'A gerar...',
            submitted_at: 'Submetido em',
            instance_metadata: 'Metadados da instância do formulário',
            filing_status_steps: 'Etapas do status de arquivamento',
            current_status: 'status atual',
            filing_status_update_failed: 'Falha ao atualizar o estado da submissão',
        },
        outputs: {
            back_instance: 'Voltar à instância',
            no_outputs_msg: 'Ainda não foram gerados resultados.',
            no_outputs_title: 'Sem resultados',
            output_name: 'Nome de saída',
            download: 'Transferir',
            download_failed: 'Falha ao download. Por favor, tente novamente.',
            fetch_failed: 'Falha ao fetch outputs. Por favor, tente novamente.',
            format: 'Formato',
            generated_at: 'Gerado em',
            generated_by: 'Gerado por',
            size: 'Tamanho',
            title: 'Resultados do formulário',
            print: 'Imprimir',
            print_outputs: 'Imprimir saídas do formulário',
            printing: 'Imprimindo saídas do formulário',
            pdf_preview: 'Visualização PDF',
            downloading: 'Baixando {name}',
            preview_in_new_window: 'Visualizar {name} ({format}) em nova janela',
        },
        cybersec_domains: {
            scope: 'Âmbito e aplicabilidade',
            risk: 'Avaliação de riscos e mapeamento de controlos',
            policy: 'Políticas de segurança organizacional',
            localization: 'Localização de dados e presença local',
            vendor: 'Terceiros e cadeia de fornecimento',
            authority: 'Tratamento de pedidos de autoridades',
            incident: 'Resposta a incidentes e evidências',
            training: 'Formação e preparação',
        },
        market_finalization_domains: {
            data_law: 'Lei de Dados — Governança e Controles Operacionais',
            pdpl_2025: 'PDPL 2025 — Governança de Privacidade e Direitos dos Titulares de Dados',
            decree_356: 'Decreto 356/2025 — Controles de Fornecedores e Transfronteiriços',
            telecom: 'Lei de Telecomunicações — Confidencialidade e Solicitações de Autoridades',
        },
        nav: {
            filing_case_links: 'Ligações de processo',
            section_routing: 'Encaminhamento de secções',
            submission_packages: 'Pacotes de submissão',
        },
        filing_case_links: {
            title: 'Ligações de processo',
            link_form: 'Ligar formulário ao processo',
            filing_case_type: 'Tipo de processo',
            form_instance: 'Instância de formulário',
            select_form_instance: 'Selecionar uma instância de formulário...',
            select_filing_case: 'Selecionar um processo...',
            no_links_found: 'Nenhuma ligação de processo encontrada.',
            linked: 'Ligado',
            filing_case_id: 'ID do caso de arquivamento',
            link_created: 'Link de caso de arquivamento criado',
            link_deleted: 'Ligação de processo eliminada',
            aria_delete_link: 'Eliminar ligação {name}',
            case_type_dpia_dossier: 'Dossiê AIPD',
            case_type_cross_border_filing: 'Arquivamento transfronteiriço',
            case_type_breach_notification: 'Notificação de violação',
            no_instances_guidance: 'Ainda sem instâncias de formulário. Crie uma a partir de Modelos de formulário.',
            no_filings_guidance: 'Ainda sem processos de arquivo. Crie um a partir de Avaliações.',
        },
        section_routing: {
            title: 'Encaminhamento de secções',
            assign_section: 'Atribuir secção',
            department: 'Departamento',
            select_department: 'Selecionar um departamento...',
            assignee: 'Atribuído a',
            select_assignee: 'Selecionar um atribuído...',
            section: 'Secção',
            select_section: 'Selecionar uma secção...',
            select_form_instance: 'Selecionar uma instância de formulário...',
            no_assignments_found: 'Nenhuma atribuição de secção encontrada.',
            select_instance_prompt: 'Selecione uma instância de formulário para ver as atribuições de secção.',
            complete_section: 'Concluir secção',
            status_pending: 'Pendente',
            status_in_progress: 'Em progresso',
            status_completed: 'Concluído',
            status_reviewed: 'Revisto',
            form_instance_id: 'ID da instância do formulário',
            assignment_created: 'Atribuição de seção criada',
            assignment_deleted: 'Atribuição de secção eliminada',
            status_updated: 'Status da seção atualizado',
            aria_delete_assignment: 'Eliminar atribuição {name}',
            deadline: 'Prazo',
            deadline_help: 'Opcional. Atribuições após esta data são exibidas como atrasadas.',
            overdue: 'Atrasado',
            days_remaining: 'dias restantes',
            approval_requested: 'Submetido para revisão',
            form_approved: 'Formulário aprovado',
            form_rejected: 'Formulário rejeitado',
            no_departments_guidance: 'Nenhum departamento configurado. Configure nas Definições da organização.',
            no_sections_guidance: 'Nenhuma secção definida no modelo. Certifique-se de que o modelo de formulário tem secções.',
            select_instance_first: 'Selecione primeiro uma instância de formulário para carregar as secções disponíveis.',
        },
        submission_packages: {
            title: 'Pacotes de submissão',
            assemble_package: 'Montar pacote de submissão',
            dossier: 'Dossiê',
            select_dossier: 'Selecionar um dossiê...',
            package_label: 'Etiqueta do pacote',
            cover_letter: 'Carta de apresentação',
            checklist: 'Lista de verificação',
            evidence_index: 'Índice de evidências',
            completeness: 'Completude',
            incomplete_warning: 'Não é possível montar: o formulário tem secções incompletas.',
            no_packages_found: 'Nenhum pacote de submissão encontrado.',
            version: 'Versão',
            package_assembled: 'Pacote de submissão montado',
            package_deleted: 'Pacote de submissão eliminado',
            aria_delete_package: 'Eliminar pacote {name}',
            status_draft: 'Rascunho',
            status_complete: 'Completo',
            status_submitted: 'Submetido',
            status_accepted: 'Aceite',
            status_rejected: 'Rejeitado',
            package_updated: 'Pacote de submissão atualizado',
            document_generated: 'Documento gerado',
            documents: 'Documentos',
            generate: 'Gerar',
            preview: 'Pré-visualizar',
            download: 'Descarregar',
            download_all: 'Descarregar tudo',
            no_dossiers_guidance: 'Ainda sem dossiês. Crie um a partir de Avaliações.',
            package_plan_help: 'Incluir no plano do pacote (geração automática de documentos disponível):',
            cover_letter_help: 'Carta de apresentação oficial dirigida à autoridade destinatária',
            checklist_help: 'Lista de verificação de conformidade que verifica todos os requisitos de submissão',
            evidence_index_help: 'Índice de documentos comprovativos referenciados na submissão',
            completeness_skipped: 'Verificação de completude ignorada — nenhuma instância de formulário associada a este dossiê.',
            completeness_unavailable: 'Verificação de completude indisponível — a prosseguir com a montagem do pacote.',
            duplicate_package_error: 'Já existe um pacote de submissão para este dossiê.',
            doc_cover_letter: 'Carta de apresentação',
            doc_checklist: 'Lista de verificação',
            doc_evidence_index: 'Índice de evidências',
            export_csv: 'Exportar CSV',
            export_success: 'Ligações dos casos de arquivo exportadas com sucesso',
            no_assignments_guidance: 'Ainda sem atribuições de secções. Atribua secções a departamentos e membros da equipa para iniciar o encaminhamento.',
        },
        template_picker: {
            title: 'Selecionar um modelo',
            hint: 'Escolha um modelo de formulário regulamentar ou comece com um formulário em branco.',
            market_filter: 'Filtrar por mercado',
            framework_filter: 'Filtrar por enquadramento',
            all_markets: 'Todos os mercados',
            all_frameworks: 'Todos os enquadramentos',
            search_placeholder: 'Pesquisar modelos...',
            blank_form: 'Formulário em branco / genérico',
            blank_form_desc: 'Criar sem modelo — preencher os campos manualmente.',
            no_templates: 'Nenhum modelo encontrado para este filtro.',
            select: 'Selecionar',
            link_error: 'Falha na ligação do modelo — pode ligar um modelo mais tarde a partir da vista de Edição.',
            internal_badge: 'Modelo interno',
            legacy_badge: 'Obsoleto',
            draft_badge: 'Rascunho',
            upcoming_badge: 'Próximo',
            hidden_badge: 'Oculto',
            show_hidden_toggle: 'Mostrar modelos ocultos / obsoletos',
            show_hidden_toggle_hint: 'Vista de administrador: inclui modelos marcados como internal_only, hidden, legacy ou draft.',
        },
        cover_letter_modal: {
            title: 'Carta de apresentação: pré-visualização e edição',
            iframe_title: 'Pré-visualização da carta de apresentação',
            stage_label: 'Fase',
            stage_initial: 'Submissão inicial',
            stage_supplement: 'Resposta suplementar',
            stage_resubmission: 'Resubmissão',
            subject_label: 'Assunto',
            body_label: 'Parágrafo principal',
            notes_label: 'Notas adicionais',
            refresh_preview: 'Atualizar pré-visualização',
            confirm: 'Confirmar e guardar',
            regenerate: 'Regenerar',
            snapshot_saved: 'Carta de apresentação guardada',
        },
        related_panel: {
            title: 'Formulários regulamentares relacionados',
            open_form: 'Preencher formulário',
            no_forms: 'Nenhum formulário relacionado encontrado.',
            hint_vn: 'Formulários regulamentares específicos do VN disponíveis — selecione um formulário para abrir o assistente de conformidade.',
            internal_badge: 'Interno',
            official_badge: 'Oficial',
            loading: 'A carregar formulários relacionados...',
            error: 'Não foi possível carregar os formulários relacionados.',
            form_id: 'ID do formulário',
            form_name: 'Nome do formulário',
            framework: 'Enquadramento regulamentar',
        },
        view_form: 'Ver formulário',
        edit_form: 'Editar formulário',
        save_draft: 'Guardar rascunho',
        module_settings: 'Definições do módulo',
        validation_errors: 'Por favor, corrija os erros de validação',
        custom_name_help: 'Opcional — por omissão, o nome do modelo se deixado em branco',
        select_placeholder: 'Selecionar...',
        previous_section: 'Anterior',
        next_section: 'Seguinte',
        loading: 'A carregar...',
        array_add: 'Adicionar',
        array_remove: 'Remover',
        array_item_label: '[[TOK_2]] item [[TOK_3]]',
        array_add_item: 'Adicionar item a {label}',
        array_remove_item: 'Remover item {index} de {label}',
        legacy_banner: 'Este registo foi criado antes dos formulários unificados. Alguns dados podem divergir entre a entidade e a instância do formulário.',
        field_required: '{label} é obrigatório',
        section_announcement: 'Seção [[TOK_3]] de [[TOK_4]]: [[TOK_5]]',
        sections_nav_label: 'Seções do formulário',
        no_sections: 'Nenhuma seção de modelo disponível.',
        section_label_tpl: 'Seção [[TOK_2]]: [[TOK_3]]',
        module_settings_auto_applied: 'As configurações específicas do módulo são aplicadas automaticamente.',
        operation_failed: 'Falha na operação',
        failed_to_load_form: 'Falha ao carregar o formulário',
        failed_to_save_form: 'Falha ao guardar o formulário',
        failed_to_submit_form: 'Falha ao submeter o formulário',
        failed_to_load_template: 'Falha ao carregar o modelo',
        failed_to_save_draft: 'Falha ao guardar o rascunho',
        failed_to_create: 'Falha ao criar',
    },
    pack_catalog: {
        title: 'Catálogo de Pacotes',
        install: 'Instalar Pacote',
        uninstall: 'Desinstalar Pacote',
        install_batch: 'Instalar Conjunto',
        installed_tab: 'Instalados',
        catalog_tab: 'Catálogo',
        pack_details: 'Detalhes do Pacote',
        frameworks: 'Enquadramentos',
        requirements: 'Requisitos',
        artifacts: 'Artefactos',
        language_pack: 'Pacote de Idioma',
        dependencies: 'Dependências',
        no_packs: 'Nenhum pacote encontrado.',
    },
    platform_pages: {
        users: {
            title: 'Utilizadores',
            new: 'Novo Utilizador',
            invite: 'Convidar Utilizador',
            edit: 'Editar Utilizador',
            name: 'Nome',
            email: 'E-mail',
            role: 'Função',
            status: 'Estado',
            identity_type: 'Tipo de Identidade',
            last_login: 'Último Início de Sessão',
            deactivate: 'Desativar',
            reactivate: 'Reativar',
            unlock: 'Desbloquear',
            reset_password: 'Repor Palavra-passe',
            remove: 'Remover',
            remove_confirm: 'Remover "{name}"? Esta ação é permanente e o utilizador perderá todo o acesso. O registo é mantido para fins de auditoria.',
        },
        roles: {
            title: 'Funções',
            new: 'Nova Função',
            edit: 'Editar Função',
            name: 'Nome da Função',
            description: 'Descrição',
            permissions: 'Permissões',
            users_count: 'Utilizadores',
            detail: 'Detalhe da Função',
            all_tiers: 'Todos os níveis',
            role_name_placeholder: 'p. ex. responsável regional de conformidade',
        },
        profile: {
            title: 'O Meu Perfil',
            name: 'Nome',
            display_name: 'Nome de exibição',
            email: 'E-mail',
            phone: 'Telefone',
            department: 'Departamento',
            job_title: 'Cargo',
            language: 'Idioma',
            role: 'Função',
            persona: 'Persona detetada',
            last_login: 'Último Início de Sessão',
            save: 'Guardar alterações',
            save_success: 'Perfil atualizado com sucesso',
            module_tips_section: 'Dicas de módulo',
            tips_toggle: 'Mostrar dicas regulatórias nos módulos',
            dismissed_tips: 'Dicas ignoradas',
            reset_dismissed: 'Repor todas as dicas ignoradas',
            notification_prefs: 'Preferências de notificação',
            notification_prefs_link: 'Gerir preferências de notificação →',
            change_password: 'Alterar Palavra-passe',
            current_password: 'Palavra-passe Atual',
            new_password: 'Nova Palavra-passe',
            confirm_password: 'Confirmar Palavra-passe',
            accessibility: 'Acessibilidade',
            high_contrast: 'Modo de alto contraste',
            high_contrast_desc: 'Aumentar o contraste para melhor legibilidade. Cumpre WCAG 2.1 AAA.',
            passwords_no_match: 'As senhas não coincidem',
            password_changed_logout: 'Senha alterada. Você será desconectado.',
            failed_update: 'Falha ao atualizar perfil',
            failed_change_password: 'Falha ao alterar senha',
            none: 'Nenhum',
            never: 'Nunca',
            password_requirements: 'Mín. 12 caracteres, maiúscula, minúscula, dígito, caractere especial',
        },
        security: {
            mfa_title: 'Definições de MFA',
            mfa_enable: 'Ativar MFA',
            mfa_disable: 'Desativar MFA',
            mfa_setup: 'Digitalize este código QR com a sua aplicação de autenticação',
            sso_title: 'Configuração de SSO',
            sso_provider: 'Fornecedor',
            sso_client_id: 'ID do Cliente',
            sso_redirect: 'URI de Redirecionamento',
            api_keys_title: 'Chaves de API',
            api_keys_new: 'Nova Chave de API',
            api_keys_name: 'Nome da Chave',
            api_keys_last_used: 'Última Utilização',
            api_keys_expires: 'Expira',
            api_keys_revoke: 'Revogar',
            service_accounts_title: 'Contas de Serviço',
            ip_allowlist_title: 'Lista de IPs Permitidos',
            ip_add: 'Adicionar Endereço IP',
            ip_address: 'Endereço IP',
            ip_description: 'Descrição',
            delegations_title: 'Delegações',
            delegations_new: 'Nova Delegação',
            delegations_from: 'Do Utilizador',
            delegations_to: 'Para o Utilizador',
            delegations_expires: 'Expira',
            break_glass_title: 'Acesso de Emergência',
            break_glass_request: 'Solicitar Acesso',
            break_glass_reason: 'Motivo do Acesso',
            break_glass_duration: 'Duração',
            session_settings_title: 'Definições de Sessão',
            session_timeout: 'Tempo Limite da Sessão (minutos)',
            session_max_concurrent: 'Máximo de Sessões Simultâneas',
            active_sessions_title: 'Sessões Ativas',
            active_sessions_device: 'Dispositivo',
            active_sessions_ip: 'Endereço IP',
            active_sessions_started: 'Iniciada',
            active_sessions_revoke: 'Revogar Sessão',
            active_sessions_confirm_terminate: 'Tem certeza de que deseja encerrar esta sessão?',
            active_sessions_confirm_terminate_current: 'Esta é a sua sessão atual. Encerrá-lo irá desconectá-lo imediatamente. Continuar?',
            active_sessions_confirm_terminate_all: 'Tem certeza de que deseja encerrar todas as outras sessões? Apenas a sua sessão atual permanecerá ativa.',
            active_sessions_terminated: 'Sessão encerrada com sucesso.',
            active_sessions_all_terminated: 'Todas as outras sessões foram encerradas.',
            active_sessions_terminate_all: 'Encerre todas as outras sessões',
            active_sessions_last_activity: 'Última atividade',
            active_sessions_current: 'Sessão Atual',
            active_sessions_revoke_selected: 'Revogar selecionadas',
            active_sessions_confirm_terminate_selected: 'Tem a certeza de que pretende terminar as sessões selecionadas?',
            active_sessions_selected_terminated: 'Sessões selecionadas terminadas com sucesso.',
            ip_allowlist_desc: 'Gerencie endereços IP permitidos para acesso [[TOK_0]].',
            ip_no_entries: 'Nenhum endereço IP configurado.',
            session_settings_desc: 'Configure o tempo limite da sessão e os limites de sessões simultâneas.',
            session_settings_save_policy: 'Política de Salvar Sessão',
            session_settings_saved: 'Configurações de sessão atualizadas com sucesso.',
            session_settings_idle_timeout: 'Tempo limite de inatividade (minutos)',
            session_settings_absolute_timeout: 'Tempo limite absoluto (minutos)',
            session_settings_help_idle: 'A sessão expirará após este período de inatividade.',
            session_settings_help_absolute: 'A sessão expirará após esta duração total, independentemente da atividade.',
            session_settings_help_max: 'Número máximo de sessões simultâneas por usuário.',
            sso_note: 'As alterações na configuração do SSO podem exigir que os usuários se autentiquem novamente.',
            service_accounts_warning: 'Esta chave [[TOK_0]] será mostrada apenas uma vez. Copie-o agora e guarde-o com segurança.',
            service_accounts_new: 'Nova conta de serviço',
            service_accounts_name: 'Nome da conta',
            service_accounts_role: 'Função',
            service_accounts_created: 'Criado',
            service_accounts_desc: 'Gerencie contas de serviço máquina a máquina para integrações [[TOK_0]].',
            break_glass_warning: 'O acesso de emergência é auditado e registrado. Use apenas para emergências genuínas.',
            break_glass_min_chars: '[[TOK_2]] / [[TOK_3]] mínimo de caracteres',
            break_glass_permission_count: '[[TOK_1]] permissões selecionadas',
            break_glass_submitted: 'Solicitação de quebra de vidro enviada. Aguardando aprovação.',
            break_glass_approved: 'Pedido de quebra de vidro aprovado.',
            break_glass_denied: 'Pedido de quebra de vidro negado.',
            break_glass_confirm_activate: 'Aprovar este pedido de quebra de vidro? Isso concederá acesso de emergência imediatamente.',
            break_glass_confirm_title: 'Confirmar ativação',
            break_glass_pending: 'Solicitações pendentes',
            break_glass_active_sessions: 'Sessões ativas de quebra de vidro',
            break_glass_time_remaining: 'Tempo restante',
            break_glass_expired: 'Expirado',
            break_glass_approved_denied_by: 'Aprovado/recusado por',
            delegations_desc: 'Gerencie delegações de permissões temporárias entre usuários.',
            delegations_my: 'Minhas delegações',
            delegations_to_me: 'Delegado a mim',
            delegations_scope_all: 'Todas as permissões',
            delegations_scope_specific: 'Permissões específicas',
            delegations_created: 'Delegação criada com sucesso.',
            delegations_revoked: 'Delegação revogada.',
            delegations_confirm_revoke: 'Tem certeza de que deseja revogar esta delegação?',
            delegations_confirm_revoke_title: 'Confirmar revogação',
            delegations_permission_count: '[[TOK_1]] permissões',
            api_keys_status: 'Estado',
            api_keys_prefix: 'Prefixo chave',
            api_keys_permissions_count: 'Permissões',
            api_keys_ip_count: 'Restrições de IP',
            api_keys_created: 'Criado',
            api_keys_confirm_revoke_title: 'Confirmar revogação',
            api_keys_confirm_revoke_message: 'Tem certeza de que deseja revogar a chave [[TOK_2]] "[[TOK_1]]"? Esta ação não pode ser desfeita.',
            api_keys_confirm_rotate_title: 'Confirmar rotação',
            api_keys_confirm_rotate_message: 'Tem certeza de que deseja girar a tecla [[TOK_2]] "[[TOK_1]]"? A chave atual irá parar de funcionar imediatamente.',
            api_keys_created_success: 'Chave [[TOK_0]] criada com sucesso.',
            api_keys_revoked_success: 'A chave [[TOK_2]] "[[TOK_1]]" foi revogada.',
            api_keys_rotated_success: 'A chave [[TOK_2]] "[[TOK_1]]" foi girada. Copie a nova chave abaixo.',
            api_keys_load_error: 'Falha ao carregar chaves [[TOK_0]].',
            api_keys_create_error: 'Falha ao criar a chave [[TOK_0]].',
            api_keys_revoke_error: 'Falha ao revogar a chave [[TOK_0]].',
            api_keys_rotate_error: 'Falha ao girar a chave [[TOK_0]].',
            break_glass_duration_15: '15 minutos',
            break_glass_duration_30: '30 minutos',
            break_glass_duration_60: '60 minutos (1h)',
            break_glass_duration_120: '120 minutos (2h)',
            break_glass_duration_240: '240 minutos (4h)',
            sod_rules_title: 'Regras de segregação de funções',
            sod_violations_report: 'Relatório de violações',
            sod_create_rule: 'Criar regra',
            sod_col_name: 'Nome',
            sod_col_description: 'Descrição',
            sod_col_conflict_count: 'Contagem de conflitos',
            sod_col_severity: 'Gravidade',
            sod_col_status: 'Estado',
            sod_col_actions: 'Ações',
            sod_no_rules: 'Nenhuma regra SoD encontrada',
            sod_severity_warning: 'Aviso',
            sod_severity_blocking: 'Bloqueio',
            sod_active: 'Ativo',
            sod_inactive: 'Inativo',
            sod_edit: 'Editar',
            sod_exceptions: 'Exceções',
            sod_deactivate: 'Desativar',
            sod_confirm_deactivate_title: 'Confirmar desativação',
            sod_confirm_deactivate_message: 'Desativar regra "[[TOK_1]]"? Ele não sinalizará mais violações.',
            sod_deactivate_error: 'Falha ao desativar a regra',
            sod_rule_count: '{count} rules',
        },
        access_reviews: {
            title: 'Revisões de Acesso',
            campaigns: 'Campanhas de Revisão',
            new_campaign: 'Nova Campanha',
            campaign_name: 'Nome da Campanha',
            scope: 'Âmbito',
            reviewers: 'Revisores',
            due_date: 'Data Limite',
            progress: 'Progresso',
            my_reviews: 'As Minhas Revisões',
            approve: 'Aprovar',
            revoke: 'Revogar',
            analytics: 'Análise de Funções',
            analytics_title: 'Análise de Funções',
            permission_usage: 'Utilização de Permissões',
            role_coverage: 'Cobertura de Funções',
            campaign_detail: 'Detalhes da campanha',
            campaign_description: 'Descrição',
            campaign_status: 'Estado',
            campaign_deadline: 'Prazo',
            campaign_scope_type: 'Tipo de escopo',
            campaign_completion: 'Conclusão',
            campaign_total_items: 'Total de itens',
            campaign_pending_items: 'Pendente',
            campaign_confirmed_items: 'Confirmado',
            campaign_revoked_items: 'Revogado',
            campaign_escalated_items: 'Escalado',
            campaign_launch: 'Campanha de lançamento',
            campaign_cancel: 'Cancelar campanha',
            campaign_confirm_launch: 'Tem certeza de que deseja lançar esta campanha?',
            campaign_confirm_cancel: 'Tem certeza de que deseja cancelar esta campanha?',
            campaign_launched: 'Campanha lançada com sucesso.',
            campaign_cancelled: 'Campanha cancelada.',
            review_items: 'Revisar itens',
            review_item_user: 'Usuário',
            review_item_role: 'Função',
            review_item_reviewer: 'Revisor',
            review_item_decision: 'Decisão',
            review_item_justify: 'Justificativa',
            review_item_confirm: 'Confirmar',
            review_item_revoke: 'Revogar',
            review_item_escalate: 'Escalar',
            all_decisions: 'Todas as decisões',
            bulk_action: 'Ação em massa',
            bulk_confirm: 'Confirmação em massa',
            bulk_revoke: 'Revogar em massa',
            selected_count: '[[TOK_1]] selecionado',
            justify_required: 'É necessária justificativa',
            scope_all_users: 'Todos os usuários',
            scope_role_owner: 'Proprietário da função',
            scope_department: 'Departamento',
            back_to_campaigns: 'Voltar para campanhas',
            recommendations: 'Recomendações',
            refreshing: 'Refrescante...',
            decide: 'Decidir',
            decision_by: 'Decisão por',
            loading_items: 'Carregando itens...',
            loading_review_items: 'Carregando itens de revisão...',
            campaign_not_found: 'Campanha não encontrada',
            loading_campaign: 'Carregando detalhes da campanha...',
            campaign_completed: 'Campanha concluída com sucesso.',
            confirm_cancel_title: 'Confirmar Cancelar',
            justify_bulk_confirm: 'Justificativa para confirmação em massa:',
            justify_bulk_revoke: 'Justificativa para revogação em massa:',
            items_selected: '[[TOK_1]] itens selecionados',
            justify_bulk_required: 'A justificativa é necessária para ações em massa',
            create_campaign_title: 'Criar campanha de revisão de acesso',
            name_required: 'O nome é obrigatório',
            scope_type_required: 'O tipo de escopo é obrigatório',
            reviewer_strategy_required: 'A estratégia do revisor é necessária',
            deadline_required: 'O prazo é obrigatório',
            reviewer_id_required: 'O ID do revisor é obrigatório para uma estratégia de usuário específica',
            invalid_json: '[[TOK_0]] inválido',
            scope_filter_label: 'Filtro de escopo ([[TOK_0]])',
            reviewer_strategy_label: 'Estratégia do Revisor',
            reviewer_id_label: 'ID do revisor',
            deadline_label: 'Prazo',
            create_campaign_btn: 'Criar campanha',
            scope_type_label: 'Tipo de escopo',
            scope_by_role: 'Por função',
            scope_by_department: 'Por Departamento',
            scope_custom: 'Personalizado',
            reviewer_manager: 'Gerente',
            reviewer_specific_user: 'Usuário específico',
            enter_json_filter: 'Insira o filtro [[TOK_0]]',
            hint_label: 'Dica:',
            role_usage: 'Uso de função',
            over_privileged_users: 'Usuários com privilégios excessivos',
            role_name_col: 'Nome da função',
            assigned_users: 'Usuários atribuídos',
            active_users_30d: 'Usuários ativos (30d)',
            total_perms: 'Total de autorizações',
            used_perms: 'Autorizações usadas',
            unused_perms: 'Autorizações não utilizadas',
            no_data_available: 'Não há dados disponíveis',
            roles_col: 'Funções',
            total_col: 'Total',
            used_col: 'Usado',
            unused_pct: '% não utilizada',
            current_count: 'Contagem atual',
            recommended_count: 'Contagem recomendada',
            rationale: 'Justificativa',
            loading_analytics: 'Carregando análises...',
            loading_role_analytics: 'Carregando dados de análise de função...',
            computed_at: 'Calculado em:',
            form_errors: 'O formulário tem [[TOK_1]] erro(s). Por favor, corrija-os.',
            scope_filter_invalid_json: 'O filtro de escopo contém [[TOK_0]] inválido',
            scope_hint_all_users: 'Nenhum filtro é necessário – todos os usuários serão incluídos.',
            review_type_label: 'Tipo de revisão',
            review_type_required: 'O tipo de revisão é obrigatório',
            reviewer_ids_label: 'IDs dos revisores',
            reviewer_ids_hint: 'Insira IDs de usuário separados por vírgulas',
            reviewer_ids_required: 'Pelo menos um ID de revisor é necessário',
            start_date_label: 'Data de início',
            start_date_required: 'A data de início é obrigatória',
            end_date_label: 'Data de fim',
            end_date_required: 'A data de fim é obrigatória',
            review_type_user_access: 'Acesso de usuário',
            review_type_role_permissions: 'Permissões de função',
            review_type_service_accounts: 'Contas de serviço',
            review_type_privileged_access: 'Acesso privilegiado',
            review_type_application_access: 'Acesso a aplicação',
            auto_revoke_label: 'Revogar automaticamente ao negar',
            campaigns_title: 'Acesse campanhas de revisão',
            create_campaign_label: '+ Criar campanha',
            no_campaigns_found: 'Nenhuma campanha encontrada',
            loading_campaigns: 'Carregando campanhas...',
            no_reviews_assigned: 'Nenhuma avaliação atribuída a você',
            loading_reviews: 'Carregando avaliações...',
            review_decision_title: 'Rever decisão',
            justification_label: 'Justificativa',
            announce_loaded_review_items: '[[TOK_1]] itens de revisão carregados',
            announce_loaded_campaigns: '[[TOK_1]] campanhas carregadas',
            announce_decision_submitted: 'Decisão "[[TOK_1]]" enviada para item de revisão',
            announce_decision_submitted_for: 'Decisão "[[TOK_2]]" enviada para [[TOK_3]]',
            announce_bulk_decision: '[[TOK_2]] em massa aplicado a [[TOK_3]] itens',
        },
        attestation: {
            title: 'Agendamento de Atestações',
            new: 'Novo Agendamento',
            edit: 'Editar Agendamento',
            create_title: 'Criar agendamento de atestação',
            edit_title: 'Editar agendamento de atestação',
            schedule_history: 'Histórico do agendamento',
            next_run_date: 'Data da próxima execução',
            schedule_name: 'Nome do Agendamento',
            frequency: 'Frequência',
            next_run: 'Próxima Execução',
            last_run: 'Última Execução',
            history: 'Histórico de Atestações',
            description: 'Descrição',
            scope: 'Escopo',
            status: 'Estado',
            created_at: 'Criado',
            updated_at: 'Atualizado',
            trigger_now: 'Acione agora',
            back_to_schedules: 'Voltar aos horários',
            confirm_trigger: 'Trigger this schedule now?',
            confirm_delete: 'Delete this schedule?',
            triggered: 'Agenda acionada com sucesso.',
            deleted: 'Agenda excluída.',
            saved: 'Agenda salva com sucesso.',
            campaigns_generated: 'Campanhas geradas',
            run_date: 'Data de execução',
            run_status: 'Status de execução',
            create_schedule: 'Criar cronograma',
            view_history: 'Ver histórico',
            deactivate: 'Desativar',
            overdue: 'OVERDUE',
            overdue_sr: 'O cronograma está atrasado',
            confirm_trigger_title: 'Confirmar ação',
            confirm_trigger_message: 'Are you sure you want to trigger this schedule now?',
            confirm_deactivate_title: 'Confirmar desativação',
            confirm_deactivate_message: 'Tem certeza de que deseja desativar esta programação?',
            triggered_success: 'Agenda acionada com sucesso.',
            deactivated_success: 'Agenda desativada.',
            name_label: 'Nome *',
            frequency_label: 'Frequência *',
            scope_type_label: 'Tipo de escopo *',
            scope_filter_label: 'Filtro de escopo ([[TOK_0]])',
            reviewer_strategy_label: 'Estratégia do Revisor *',
            reviewer_id_label: 'ID do revisor *',
            frequency_quarterly: 'Trimestralmente',
            frequency_semi_annual: 'Semestral',
            frequency_annual: 'Anual',
            scope_all_users: 'Todos os usuários',
            scope_by_role: 'Por função',
            scope_by_department: 'Por Departamento',
            scope_framework: 'Estrutura',
            scope_custom: 'Personalizado',
            reviewer_manager: 'Gerente',
            reviewer_role_owner: 'Proprietário da função',
            reviewer_specific_user: 'Usuário específico',
            computed_next_run_date: 'Data calculada da próxima execução',
            current_scheduled_date: 'Data agendada atual',
            recomputed_frequency_changed: '(recalculado - frequência alterada)',
            estimated_days_hint: 'Estimado com base em [[TOK_1]] dias a partir de hoje',
            validation_name_required: 'O nome é obrigatório',
            validation_frequency_required: 'A frequência é obrigatória',
            validation_scope_type_required: 'O tipo de escopo é obrigatório',
            validation_reviewer_strategy_required: 'A estratégia do revisor é necessária',
            validation_reviewer_id_required: 'O ID do revisor é obrigatório para uma estratégia de usuário específica',
            validation_invalid_json: '[[TOK_0]] inválido',
            validation_scope_filter_invalid_json: 'O filtro de escopo contém [[TOK_0]] inválido',
            form_errors: 'O formulário tem [[TOK_1]] erro(s). Por favor, corrija-os.',
            create_schedule_btn: 'Criar cronograma',
            schedule_history_title: 'Histórico de agendamento',
            campaign_name_col: 'Nome da campanha',
            items_col: 'Itens',
            no_campaigns_yet: 'Nenhuma campanha gerada ainda',
            loading_history: 'Carregando histórico...',
            loading_schedule: 'Carregando programação...',
            total_campaigns: 'Total de campanhas: [[TOK_1]]',
            results_per_page: 'Resultados por página',
            page_size_option: '[[TOK_1]] / página',
        },
        sod: {
            title: 'Regras de Segregação de Funções',
            new: 'Nova Regra',
            edit: 'Editar Regra',
            create_title: 'Criar regra SoD',
            edit_title: 'Editar regra SoD',
            rule_name: 'Nome da Regra',
            conflicting_permissions: 'Permissões Conflituantes',
            permission_a: 'Permissão A',
            permission_b: 'Permissão B',
            violations: 'Violações de SoD',
            violation_user: 'Utilizador',
            violation_rule: 'Regra Violada',
            violation_date: 'Detetado Em',
            exceptions: 'Exceções de SoD',
            exception_reason: 'Motivo da Exceção',
            exception_approver: 'Aprovado Por',
            exception_status: 'Status de exceção',
            has_exception: 'Tem exceção',
            no_exception: 'Sem exceção',
            grant_exception: 'Exceção de concessão',
            granting: 'Concedendo...',
            grant_new_exception: 'Conceder nova exceção',
            exceptions_for: 'Exceções para: [[TOK_1]]',
            back_to_rules: 'Voltar às regras',
            no_violations: 'Nenhuma violação encontrada',
            no_exceptions_found: 'Nenhuma exceção encontrada para esta regra',
            all_exception_statuses: 'Todos os status de exceção',
            user_id_label: 'ID do usuário',
            justification_label: 'Justificativa',
            compensating_controls_label: 'Controles de compensação',
            expires_at_label: 'Expira em',
            granting_exception_for: 'Concedendo uma exceção para a regra: [[TOK_1]]',
            severity: 'Gravidade',
            severity_warning: 'Aviso',
            severity_blocking: 'Bloqueio',
            violation_count: '[[TOK_1]] violação(ões)',
            exception_count: '[[TOK_1]] exceção(ões)',
            rule_description: 'Descrição',
            confirm_delete: 'Tem certeza de que deseja excluir esta regra?',
            deleted: 'Regra excluída.',
            framework_code: 'Enquadramento',
            name_label: 'Nome *',
            severity_label: 'Gravidade *',
            conflict_pairs_legend: 'Pares de permissão de conflito',
            conflict_pairs_hint: 'Cada par define duas permissões que não devem ser mantidas pelo mesmo usuário.',
            placeholder_permission_a: '-- Permissão A --',
            placeholder_permission_b: '-- Permissão B --',
            permission_a_for_pair: 'Permissão A para par [[TOK_1]]',
            permission_b_for_pair: 'Permissão B para par [[TOK_1]]',
            conflict_pair_label: 'Par de conflito [[TOK_1]]',
            remove_conflict_pair: 'Remover par conflitante [[TOK_1]]',
            add_pair: '+ Adicionar par',
            placeholder_name: 'por exemplo Separação de aprovação de pagamento',
            create_rule: 'Criar regra',
            loading_rule: 'Carregando regra SoD...',
            failed_load_rule: 'Falha ao carregar a regra.',
            failed_create_rule: 'Falha ao criar regra SoD.',
            failed_update_rule: 'Falha ao atualizar a regra SoD.',
            validation_name_required: 'O nome é obrigatório.',
            validation_pair_required: 'É necessário pelo menos um par de permissões de conflito.',
            validation_pair_both_required: 'Par [[TOK_1]]: Ambas as permissões devem ser selecionadas.',
            validation_pair_must_differ: 'Par [[TOK_1]]: A permissão A e a permissão B devem ser diferentes.',
            added_conflict_pair: 'Adicionado par de conflito [[TOK_1]]',
            removed_conflict_pair: 'Par de conflito removido [[TOK_1]]',
            announce_loaded_violations: 'Violações [[TOK_1]] carregadas',
            announce_loaded_exceptions: 'Exceções [[TOK_1]] carregadas',
            announce_loaded_rules: 'Regras SoD [[TOK_1]] carregadas',
            announce_loading_exceptions: 'Carregando exceções…',
            regulatory_info: {
                sod_context: 'As regras SoD aplicam a separacao regulamentar de funcoes exigida pela PDPL. As violacoes associadas a um framework_code podem ser incluidas nos pacotes de evidencias (UC-VN-09).',
                violation_export_context: 'As exportacoes de violacoes SoD incluem framework_code, funcoes em conflito, gravidade, criador e data de detecao para pacotes de evidencias (P-VN-10).',
                exception_context: 'As excecoes SoD produzem evidencias: aprovador, justificacao, controlos compensatorios e data de expiracao. As excecoes expiradas permanecem visiveis (UC-VN-09 Passo 5).',
            },
        },
        regulatory_info: {
            attestation_context: 'Attestation schedules support the annual governance attestation cycle required by Data Law (DATA-D4). When scope_type is set to "framework", schedules can be linked to specific regulatory frameworks.',
            api_keys_context: 'API key telemetry constitutes account evidence per VN_CYBERSEC_LAW_2025 Section B.5. Each key record includes last_used_at, ip_allowlist, permissions, status, and expires_at.',
            session_context: 'Session management enforces access controls per Telecom Law confidentiality requirements (Section B.4). Session events produce audit trail entries.',
            break_glass_context: 'Break-glass procedures produce regulatory justification evidence: requestor identity, justification, permissions, duration, approver identity, and approval/denial timestamps.',
            license_context: 'License settings gate modules by tier using PACKAGE_DEFINITIONS. Framework-specific modules require appropriate license tiers. Tier changes produce audit trail entries.',
            module_config_context: 'Module configuration supports framework-driven enablement. Disabling a module required by an active regulatory framework may break evidence completeness.',
            notification_context: 'Compliance-critical notifications (breach deadlines, attestation due dates) are marked with a compliance_critical flag and cannot be fully suppressed.',
            delegation_context: 'Delegation governance produces audit-grade evidence: delegator_id, delegate_id, permission scope, start/end dates, and status. Expired delegations remain visible.',
            access_control_context: 'Access control configuration meets Cybersecurity Law requirements (VN_CYBERSEC_LAW_2025): IP allowlist, MFA, service accounts, and SSO changes are audit-trailed.',
        },
    },
    cmp: {
        integration: {
            title: 'Integração CMP',
            status: 'Estado da Ligação',
            endpoint: 'Endpoint CMP',
            last_sync: 'Última Sincronização',
            configure: 'Configurar',
        },
        purpose_mapping: {
            title: 'Mapeamento de Finalidades',
            cmp_purpose: 'Finalidade CMP',
            grc_purpose: 'Finalidade GRC',
            mapping_status: 'Estado do Mapeamento',
            auto_map: 'Mapear Automaticamente',
            new_mapping: 'Novo Mapeamento',
        },
        webhook: {
            title: 'Configuração de Webhooks',
            webhook_url: 'URL do Webhook',
            secret: 'Segredo do Webhook',
            events: 'Tipos de Eventos',
            test_webhook: 'Testar Webhook',
        },
        bulk_sync: {
            title: 'Sincronização em Massa',
            sync_now: 'Sincronizar Agora',
            last_run: 'Última Execução',
            records_synced: 'Registos Sincronizados',
            sync_history: 'Histórico de Sincronização',
            syncing: 'A sincronizar...',
        },
        sync_settings: {
            sync_failures: 'Falhas de sincronização',
            sync_secret_warning: 'Segredo de sincronização (guarde agora — não será mostrado novamente):',
            push_description: 'Configure o GRC Suite para enviar atualizações de estado de casos ao AesirX CMP.',
            technical_description: 'Esta configuração controla como o GRC Suite envia atualizações de status do caso para [[TOK_1]] [[TOK_0]].',
            direction_label: 'Direção',
            direction_value: 'GRC Suite → AesirX CMP (saída)',
            auth_label: 'Autenticação',
            auth_value: 'Assinatura HMAC-SHA256 no cabeçalho X-GRC-Signature',
            retry_label: 'Tentar novamente Política',
            retry_value: '3 tentativas com recuo exponencial (30s, 2min, 10min)',
            inbound_label: 'Config. de entrada',
            inbound_value: 'O webhook de entrada (CMP → GRC) está configurado em',
            cmp_webhook_settings: 'CMP Webhook Definições',
            page_title: 'Definições de Sincronização CMP',
            outbound_sync_configured: 'Sincronização de saída configurada.',
            configure_sync_failed: 'Falha ao configurar sincronização',
            configuration_updated: 'Configuração atualizada.',
            update_configuration_failed: 'Falha ao atualizar configuração',
            connection_test_failed: 'Teste de conexão falhou',
            test_result_message: 'Teste enviado para {endpoint}. Estado: {status}',
            endpoint_placeholder: 'https://your-cmp-domain/api/grc-sync',
            events: {
                new_to_under_review: 'Novo → Under Review (assigned)',
                under_review_to_identity_verification: 'Under Rever → Identidade Verificação',
                under_review_to_in_progress: 'Under Rever → Em curso',
                in_progress_to_completed: 'Em curso → Concluído',
                in_progress_to_denied: 'Em curso → Negado',
                any_to_closed: 'Qualquer → Fechado',
            },
        },
    },
    settings_pages: {
        webhooks: {
            title: 'Webhooks',
            new: 'Novo Webhook',
            url: 'URL',
            url_placeholder: 'https://example.com/webhook',
            events: 'Eventos',
            secret: 'Segredo',
            active: 'Ativo',
            test: 'Testar',
            create_failed: 'Falha ao create webhook. Por favor, tente novamente.',
            create_success: 'Webhook criado com sucesso',
            deactivate_failed: 'Falha ao deactivate webhook. Por favor, tente novamente.',
            deactivate_success: 'Webhook desativado.',
            fetch_failed: 'Falha ao fetch webhooks. Por favor, tente novamente.',
            send_test_failed: 'Falha ao send test. Por favor, tente novamente.',
            test_failed: 'Webhook test falhou.',
            test_success: 'Teste do webhook com sucesso.',
            edit_title: 'Editar webhook',
            announce_loaded: 'Webhooks carregados',
            update_success: 'Webhook atualizado com sucesso.',
            update_failed: 'Falha ao atualizar o webhook.',
            activate_success: 'Webhook ativado.',
            activate_failed: 'Falha ao ativar o webhook.',
        },
        domains: {
            title: 'Domínios',
            new: 'Novo Domínio',
            domain_name: 'Nome do Domínio',
            verified: 'Verificado',
            verify: 'Verificar',
            add_failed: 'Falha ao add domain. Por favor, tente novamente.',
            add_success: 'Domínio added com sucesso',
            domain_placeholder: 'p. ex. grc.example.com',
            fetch_failed: 'Falha ao fetch domains. Por favor, tente novamente.',
            remove_failed: 'Falha ao remove domain. Por favor, tente novamente.',
            remove_success: 'Domínio removed com sucesso',
            txt_record: 'Registo TXT',
            verify_dns_failed: 'A verificação DNS falhou.',
            verify_failed: 'Falha ao verify domain. Por favor, tente novamente.',
            verify_success: 'Domínio verificado com sucesso',
        },
        export_schedules: {
            title: 'Agendamento de Exportações',
            new: 'Novo Agendamento',
            schedule_name: 'Nome',
            frequency: 'Frequência',
            format: 'Formato',
            last_run: 'Última Execução',
            next_run: 'Próxima Execução',
            create_failed: 'Falha ao create schedule. Por favor, tente novamente.',
            create_success: 'Agendar criado com sucesso',
            day_of_month: 'Dia do mês',
            day_of_week: 'Dia da semana',
            deactivate_failed: 'Falha ao deactivate schedule. Por favor, tente novamente.',
            deactivate_success: 'Agendamento desativado.',
            fetch_failed: 'Falha ao fetch schedules. Por favor, tente novamente.',
            freq_daily: 'Diário',
            freq_monthly: 'Mensal',
            freq_weekly: 'Semanal',
            recipients: 'Destinatários',
            time_utc: 'Hora (UTC)',
            trigger_failed: 'Falha ao trigger export. Por favor, tente novamente.',
            trigger_success: 'Exportar triggered com sucesso.',
            type_audit_trail: 'Trilha de auditoria',
            type_compliance_report: 'Conformidade Relatório',
            type_custom: 'Personalizado',
            type_incident_report: 'Incidente Relatório',
            type_ropa: 'ROPA',
        },
        email_log: {
            title: 'Registo de Correio Eletrónico',
            recipient: 'Destinatário',
            subject: 'Assunto',
            sent_at: 'Enviado Em',
            status: 'Estado',
            resend: 'Reenviar',
            fetch_failed: 'Falha ao fetch email logs. Por favor, tente novamente.',
        },
    },
    organizations: {
        title: 'Organizações',
        create: 'Adicionar organização',
        edit: 'Editar Organização',
        name: 'Nome',
        slug: 'Lesma',
        timezone: 'Fuso horário',
        locale: 'Localidade predefinida',
        parent: 'Organização principal',
        group: 'Grupo',
        org_group: 'Grupo de Organizações',
        no_group: '(Nenhum - não pertence a um grupo)',
        created: 'Criado',
        no_parent: '(Nenhum - autónomo)',
        no_orgs: 'Nenhum organizations encontrado',
        load_error: 'Falha ao load organizations. Por favor, tente novamente.',
        save_error: 'Falha ao save organization. Por favor, tente novamente.',
        created_msg: 'Organização criado',
        updated: 'Organização atualizado',
        deactivate: 'Desativar',
        deactivated: 'Organização desativada',
        confirm_deactivate: 'Tem a certeza de que pretende desativar esta organização?',
        loaded_results: 'Organizations carregados, {count} resultados',
        form_loaded: 'Formulário de Organization carregado',
        locale_vi_vn: 'Tiếng Việt (vi-VN)',
        locale_en_us: 'Inglês (en-US)',
    },
    intake_configs: {
        title: 'Configurações de entrada públicas',
        create: 'Adicionar Config',
        edit: 'Editar config. de entrada',
        label_col: 'Rótulo',
        key: 'Chave de entrada',
        key_hint: 'O URL público será: /rights-request?key=',
        mapped_org: 'Organização de destino',
        status: 'Estado',
        enabled: 'Ativado',
        disabled: 'Desativado',
        request_types: 'Ativado Pedido Types',
        language: 'Predefinido Idioma',
        public_url: 'URL pública',
        no_configs: 'Nenhuma config. de entrada encontrada. Crie uma para ativar formulários de pedido de direitos.',
        load_error: 'Falha ao load intake configs. Por favor, tente novamente.',
        save_error: 'Falha ao save. Por favor, tente novamente.',
        delete_error: 'Falha ao delete. Por favor, tente novamente.',
        created_msg: 'Configuração criada',
        updated: 'Configuração atualizada',
        deleted: 'Config. de entrada eliminada',
        confirm_delete: 'Eliminar esta configuração de entrada?',
        select_types: 'Selecione at least one request type',
        select_org: 'Selecione target organization',
        routing_mode: 'Modo de Encaminhamento',
        single_org: 'Organização Única',
        org_group_mode: 'Grupo de Organizações',
        org_group: 'Grupo de Organizações',
        select_group: 'Selecione um grupo de organizações...',
        group_root_hint: 'Definido automaticamente para a organização raiz do grupo quando o grupo é selecionado.',
        loaded_results: 'Intake configurations carregados, {count} resultados',
        form_loaded: 'Formulário de Intake configuration carregado',
    },
    frequency: {
        weekly: 'Semanal',
        monthly: 'Mensal',
        quarterly: 'Trimestral',
        semi_annually: 'Semestral',
        annually: 'Anual',
        custom: 'Personalizado',
    },
    task_management: {
        nav: {
            calendar: 'Calendário',
            all_tasks: 'Todas as tarefas',
            my_tasks: 'Minhas tarefas',
            overdue: 'Em atraso',
            board: 'Quadro',
            workflows: 'Fluxos de trabalho',
        },
        list: {
            title: 'Todas as tarefas',
            my_title: 'Minhas tarefas',
            overdue_title: 'Tarefas em atraso',
            new_task: 'Criar tarefa',
            no_tasks: 'Nenhuma tarefa encontrada.',
            empty_state: 'Nenhuma tarefa encontrada. As tarefas são geradas a partir de fluxos de trabalho de módulos como avaliações, incidentes e campanhas de revisão.',
            total: 'Total de tarefas',
            search_placeholder: 'Pesquisar tarefas...',
            bulk_actions: 'Ações em massa',
            change_status: 'Alterar estado',
            change_priority: 'Alterar prioridade',
            assign: 'Atribuir',
            sr_my_tasks_count: '{count} tarefas atribuídas a si',
            sr_days_overdue: '{count} dias em atraso',
            sla_label: 'SLA',
        },
        detail: {
            title: 'Detalhe da tarefa',
            description: 'Descrição',
            workflow_progress: 'Progresso do fluxo',
            checklist: 'Lista de verificação',
            dependencies: 'Dependências',
            comments: 'Comentários',
            activity_timeline: 'Cronologia de atividade',
            assignees: 'Atribuídos',
            add_assignee: 'Adicionar atribuído',
            remove_assignee: 'Remover atribuído',
            due_date: 'Data de vencimento',
            start_date: 'Data de início',
            sla_status: 'Estado SLA',
            sla_on_track: 'No prazo',
            sla_at_risk: 'Em risco',
            sla_breached: 'Violado',
            tags: 'Etiquetas',
            source_entity: 'Entidade de origem',
            view_source: 'Ver origem',
            add_dependency: 'Adicionar dependência',
            remove_dependency: 'Remover dependência',
            write_comment: 'Escrever um comentário...',
            post_comment: 'Publicar',
            edit_comment: 'Editar',
            delete_comment: 'Excluir',
            add_checklist_item: 'Adicionar item',
            no_dependencies: 'Sem dependências',
            no_comments: 'Sem comentários ainda',
            blocks: 'Bloqueia',
            blocked_by: 'Bloqueado por',
            related: 'Relacionado',
            working_days_remain: 'dias úteis restantes',
            created_by: 'Criado por',
            completed_at: 'Concluído em',
            no_assignees: 'Sem atribuídos',
            add_assignee_placeholder: 'Introduzir ID de utilizador...',
            edited: 'editado',
            timeline: 'Cronologia de atividade',
            no_timeline: 'Sem atividade ainda',
            no_workflow: 'Sem fluxo de trabalho atribuído',
            add_dependency_placeholder: 'Introduzir ID de tarefa...',
            sr_status_updated: 'Status atualizado para [[TOK_1]]',
            sr_priority_updated: 'Prioridade atualizada para [[TOK_1]]',
            convert_to_workflow: 'Executar como fluxo de trabalho',
            convert_modal_title: 'Converter tarefa em execução de fluxo de trabalho',
            convert_workflow_label: 'Fluxo de trabalho',
            convert_workflow_placeholder: 'Escolha um fluxo de trabalho…',
            convert_attachments_label: 'Anexos',
            convert_attachments_empty: 'Não há anexos nesta tarefa.',
            convert_persona_label: 'Substituição de persona (opcional)',
            convert_submit: 'Iniciar execução do fluxo de trabalho',
            convert_starting: 'Iniciando a execução do fluxo de trabalho…',
            convert_started: 'Execução do fluxo de trabalho iniciada — execução de abertura…',
            convert_disabled_in_flight: 'Um fluxo de trabalho executado nesta tarefa já está em andamento.',
            linked_workflow_chip: 'De [[TOK_1]]',
            linked_chat_chip: 'Do bate-papo [[TOK_0]]',
            linked_more: '+[[TOK_1]] mais',
        },
        calendar: {
            title: 'Calendário de tarefas',
            page_title: 'Calendário',
            create_task: 'Criar tarefa',
            month: 'Mês',
            week: 'Semana',
            day: 'Dia',
            today: 'Hoje',
            more_tasks: '+[[TOK_1]] mais',
            no_tasks_day: 'Sem tarefas neste dia',
            all_day: 'Dia inteiro',
            quick_create_tooltip: 'Criar tarefa para este dia',
            view_changed: 'Visualização do calendário alterada para {view}',
            tasks_in_view: '{count} tarefas na visualização',
            task_in_view: '[[TOK_1]] tarefa em exibição',
        },
        filters: {
            assignee: 'Atribuído',
            me: 'Eu',
            role: 'Papel',
            status: 'Estado',
            priority: 'Prioridade',
            task_type: 'Tipo de tarefa',
            source_module: 'Módulo de origem',
            organization: 'Organização',
            sla_breached_only: 'Mostrar apenas SLA violado',
            clear_filters: 'Limpar filtros',
            apply_filters: 'Aplicar',
            source_label: 'Fonte',
            source_manual: 'Manuais',
            source_module_kind: 'Gerado por módulo',
            source_chat: 'Do bate-papo [[TOK_0]]',
            source_workflow_run: 'Da execução do fluxo de trabalho [[TOK_0]]',
        },
        status: {
            pending: 'Pendente',
            in_progress: 'Em andamento',
            blocked: 'Bloqueado',
            completed: 'Concluído',
            overdue: 'Em atraso',
            escalated: 'Escalado',
            cancelled: 'Cancelado',
        },
        priority: {
            critical: 'Crítico',
            high: 'Alto',
            medium: 'Médio',
            low: 'Baixo',
        },
        task_types: {
            manual_task: 'Tarefa manual',
            dsr_case: 'Caso DSR',
            dsr_review: 'Revisão DSR',
            dsr_escalation: 'Escalação DSR',
            dpia_review: 'Revisão DPIA',
            dpia_approval: 'Aprovação DPIA',
            transfer_review: 'Revisão de transferência',
            incident_task: 'Tarefa de incidente',
            incident_notification: 'Notificação de incidente',
            playbook_step: 'Passo do manual',
            regulator_deadline: 'Prazo regulatório',
            monitoring_task: 'Tarefa de monitoramento',
            kpi_alert: 'Alerta KPI',
            vendor_review: 'Revisão de fornecedor',
            vendor_questionnaire: 'Questionário de fornecedor',
            governance_review: 'Revisão de governança',
            drift_alert: 'Alerta de desvio',
            governance_approval: 'Aprovação de governança',
            deletion_task: 'Tarefa de exclusão',
            deletion_verification: 'Verificação de exclusão',
            access_review: 'Revisão de acesso',
            sod_alert: 'Alerta SoD',
            consent_workflow: 'Fluxo de consentimento',
            consent_alert: 'Alerta de consentimento',
            property_review: 'Revisão de propriedade',
            inconsistency_alert: 'Alerta de inconsistência',
            form_review: 'Revisão de formulário',
            dossier_deadline: 'Prazo do dossiê',
            submission_task: 'Tarefa de submissão',
            translation_review: 'Revisão de tradução',
            governance_task: 'Tarefa de governança',
            reporting_deadline: 'Prazo de relatório',
            scanner_alert: 'Alerta do scanner',
            classification_review: 'Revisão de classificação',
            lifecycle_task: 'Tarefa de ciclo de vida',
            discovery_review: 'Revisão de descoberta',
        },
        task_type_groups: {
            manual: 'Manuais',
            dsr: 'DSR / Pedidos de direitos',
            assessments: 'Avaliações',
            incidents: 'Incidentes',
            incident_ops: 'Operações de incidentes',
            monitoring: 'Monitoramento',
            vendor_risk: 'Risco de fornecedores',
            governance: 'Governança',
            deletion: 'Exclusão',
            access_review: 'Revisão de acesso',
            consent: 'Consentimento',
            consent_properties: 'Propriedades de consentimento',
            forms: 'Formulários',
            localization: 'Localização',
            program_governance: 'Governança de programas',
            privacy_scanner: 'Scanner de privacidade',
            classification: 'Classificação',
            discovery: 'Descoberta',
        },
        create: {
            title: 'Criar tarefa',
            task_title: 'Título',
            task_description: 'Descrição',
            task_type: 'Tipo de tarefa',
            task_type_label: 'Tipo de tarefa',
            task_type_placeholder: 'Selecionar um tipo de tarefa',
            priority: 'Prioridade',
            assignees: 'Atribuídos',
            assignee_search_placeholder: 'Pesquisar utilizadores...',
            due_date: 'Data de vencimento',
            start_date: 'Data de início',
            checklist: 'Lista de verificação',
            tags: 'Etiquetas',
            add_checklist_item: 'Adicionar item de checklist',
            validation: {
                title_required: 'O título é obrigatório',
                title_max_length: 'O título deve ter 500 caracteres ou menos',
                description_max_length: 'A descrição deve ter 5000 caracteres ou menos',
                due_date_before_start: 'A data de vencimento deve ser posterior à data de início',
                max_reminders: 'Máximo 5 lembretes por tarefa',
            },
            reminders: {
                title: 'Lembretes',
                add: 'Adicionar lembrete',
                at_due_date: 'Na data de vencimento',
                minutes_before: '[[TOK_1]] minutos antes',
                hours_before: '[[TOK_1]] horas antes',
                days_before: '[[TOK_1]] dias antes',
                weeks_before: '[[TOK_1]] semanas antes',
                custom: 'Personalizado',
                channel_platform: 'Plataforma',
                channel_email: 'E-mail',
                channel_both: 'Ambos',
            },
            workflow: {
                label: 'Fluxo de trabalho',
                none: 'Nenhum (gerenciamento de status manual)',
                steps_count: '[[TOK_1]] etapas',
                preview_label: 'Passos do fluxo',
            },
        },
        errors: {
            fetch_failed: 'Falha ao carregar tarefas.',
            save_failed: 'Falha ao salvar tarefa.',
            delete_failed: 'Falha ao excluir tarefa.',
            status_change_failed: 'Falha ao alterar estado da tarefa.',
            assign_failed: 'Falha ao atribuir tarefa.',
            comment_failed: 'Falha ao salvar comentário.',
            checklist_failed: 'Falha ao atualizar a lista de verificação.',
            dependency_failed: 'Falha ao atualizar a dependência.',
            workflow_failed: 'Falha ao salvar fluxo de trabalho.',
            workflow_activate_failed: 'Falha ao ativar fluxo.',
            workflow_delete_failed: 'Falha ao excluir fluxo.',
            template_install_failed: 'Falha ao instalar modelo.',
            search_failed: 'Falha ao pesquisar tarefas.',
            convert_failed: 'Não foi possível iniciar a execução do fluxo de trabalho.',
            convert_quota_exhausted: 'Balde de tokens baixo. Complete antes de voltar a correr.',
        },
        dependency_types: {
            blocks: 'Bloqueia',
            blocked_by: 'Bloqueado por',
            related: 'Relacionado',
        },
        workflow: {
            current_step: 'Passo atual',
            transition: 'Transição',
            history: 'Histórico de passos',
            no_workflow: 'Sem fluxo de trabalho atribuído',
            detail_title: 'Detalhes do fluxo de trabalho',
            list_title: 'Definições de fluxos',
            create_workflow: 'Criar fluxo de trabalho',
            browse_templates: 'Explorar modelos',
            template_catalog_title: 'Catálogo de modelos',
            name: 'Nome',
            description: 'Descrição',
            task_types: 'Tipos de tarefa',
            steps: 'Passos',
            version: 'Versão',
            created: 'Criado',
            actions: 'Ações',
            status_draft: 'Rascunho',
            status_active: 'Ativo',
            status_archived: 'Arquivado',
            activate: 'Ativar',
            archive: 'Arquivar',
            save: 'Salvar',
            edit: 'Editar',
            delete: 'Excluir',
            clone: 'Clonar',
            install: 'Instalar',
            installed: 'Instalado',
            system: 'Sistema',
            general_settings: 'Configurações gerais',
            default_assignment: 'Atribuição padrão',
            default_sla: 'SLA padrão',
            workflow_steps: 'Passos do fluxo',
            add_step: 'Adicionar passo',
            step_name: 'Nome do passo',
            step_status: 'Valor de estado',
            assignment_strategy: 'Estratégia de atribuição',
            assignment_role: 'Papel de atribuição',
            sla_hours: 'Horas SLA',
            sla_calendar_type: 'Tipo de calendário',
            working_days: 'Dias úteis',
            calendar_days: 'Dias corridos',
            is_terminal: 'Passo terminal',
            required_fields: 'Campos obrigatórios',
            checklist_template: 'Modelo de checklist',
            transitions: 'Transições',
            add_transition: 'Adicionar transição',
            from_step: 'De',
            to_step: 'Para',
            permission: 'Permissão',
            sla_action: 'Ação SLA',
            notify: 'Notificar',
            escalation_rules: 'Regras de escalação',
            add_rule: 'Adicionar regra',
            trigger: 'Gatilho',
            threshold: 'Limiar',
            action: 'Ação',
            target_role: 'Papel alvo',
            trigger_sla_threshold: 'Limiar SLA',
            trigger_sla_breach: 'Violação SLA',
            trigger_blocked_duration: 'Duração bloqueada',
            trigger_manual: 'Manuais',
            action_notify: 'Notificar',
            action_escalate: 'Escalar nível',
            action_reassign: 'Reatribuir',
            sla_start: 'Iniciar',
            sla_pause: 'Pausar',
            sla_resume: 'Retomar',
            sla_stop: 'Parar',
            strategy_manual: 'Manuais',
            strategy_role_based: 'Baseado em papel',
            strategy_round_robin: 'Rodada Robin',
            strategy_least_loaded: 'Menos carregado',
            strategy_creator: 'Criador',
            confirm_delete: 'Tem certeza de que deseja excluir este fluxo?',
            confirm_archive: 'Tem certeza de que deseja arquivar este fluxo?',
            cannot_delete_active: 'Fluxos ativos não podem ser excluídos. Arquive primeiro.',
            validation_errors: 'Erros de validação do fluxo',
            step_count: '[[TOK_1]] etapas',
            no_workflows: 'Nenhum fluxo encontrado.',
            no_templates: 'Nenhum modelo disponível.',
            sr_templates_count: '[[TOK_1]] modelos disponíveis',
            template_installed: 'Modelo instalado com sucesso.',
            activate_success: 'Fluxo ativado com sucesso.',
            archive_success: 'Fluxo arquivado com sucesso.',
            save_success: 'Fluxo salvo com sucesso.',
            delete_success: 'Fluxo excluído com sucesso.',
        },
        columns: {
            priority: 'Prioridade',
            title: 'Título',
            status: 'Estado',
            type: 'Tipo',
            assignees: 'Atribuído(s)',
            due_date: 'Data de vencimento',
            source: 'Origem',
            actions: 'Ações',
        },
        groups: {
            overdue: 'Em atraso',
            due_today: 'Vence hoje',
            due_this_week: 'Vence esta semana',
            due_later: 'Vence depois',
            no_due_date: 'Sem data de vencimento',
        },
        board: {
            title: 'Quadro de tarefas',
            drag_hint: 'Arraste tarefas entre colunas para alterar o estado',
            empty_column: 'Sem tarefas',
            keyboard_hint: 'Teclado: setas para navegar, espaço para pegar tarefa, esquerda/direita para selecionar coluna, Enter para soltar, Escape para cancelar.',
            sr_moving: 'Movendo {title}. Sobre {column}. Pressione Enter para soltar, Escape para cancelar.',
            sr_tasks_shown: '{count} tarefas exibidas',
            sr_picked_up: '{title} coletado',
            sr_returned: '[[TOK_2]] retornou para [[TOK_3]]',
            sr_dropped: '{title} solto em {column}, posição {position} de {total}',
            sr_move_cancelled: 'Movimentação cancelada',
            sr_over_column: 'Sobre {column}',
            sr_moved_to: '{title} movido para {column}',
            invalid_transition: 'Nao e possivel mover a tarefa de {from} para {to}.',
            terminal_status: 'Esta tarefa esta em um estado terminal e nao pode ser movida.',
            invalid_drop_target: 'Destino invalido',
        },
        team: {
            title: 'Carga de trabalho da equipa',
            assignee: 'Atribuído',
            active: 'Ativo',
            overdue: 'Em atraso',
            blocked: 'Bloqueado',
            completed_7d: 'Concluído (7d)',
            load: 'Carga',
            load_high: 'Alto',
            load_medium: 'Médio',
            load_normal: 'Normais',
        },
        graph: {
            title: 'Gráfico de Dependência',
            list_view: 'Visualização de lista',
            graph_view: 'Visualização de gráfico',
            zoom_in: 'Ampliar',
            zoom_out: 'Diminuir zoom',
            reset_zoom: 'Redefinir',
            blocks_label: 'blocks',
            related_label: 'related',
            no_dependencies: 'Sem dependências para visualizar.',
        },
        add_dependency_modal: {
            title: 'Adicionar dependência',
            search_placeholder: 'Pesquisar tarefas por título ou ID...',
            no_results: 'Nenhuma tarefa encontrada.',
            this_blocks: 'Esta tarefa bloqueia selecionados',
            this_blocked_by: 'Esta tarefa está bloqueada por selecionados',
            related: 'Relacionado',
            max_dependencies: 'Máximo de 10 dependências por tarefa.',
            circular_error: 'Não é possível adicionar: criaria uma dependência circular.',
        },
        conflict_detection: {
            title: 'Detecção de conflitos',
            unresolved: 'não resolvido',
            no_conflicts: 'Nenhum conflito detectado',
            section: 'Seção',
            field: 'Campo',
            dept_a: 'Departamento A',
            value_a: 'Valor A',
            dept_b: 'Departamento B',
            value_b: 'Valor B',
            severity: 'Gravidade',
            status: 'Estado',
            resolved: 'Resolvido',
            open: 'Aberto',
            resolve: 'Resolver',
            load_failed: 'Falha ao load conflicts',
            resolve_success: 'Conflito resolvido com sucesso',
            resolve_failed: 'Falha ao resolve conflict',
            severity_critical: 'Crítico',
            severity_warning: 'Aviso',
            severity_info: 'Informações',
        },
        consolidation: {
            title: 'Progresso de consolidação',
            add_child: 'Adicionar subtarefa',
            child_task_id: 'ID da subtarefa',
            department_id: 'ID do departamento',
            link: 'Vincular',
            overall_completion: 'Conclusão geral',
            departments_complete: 'Departamentos concluídos',
            overdue: 'Atrasado',
            ready: 'Pronto',
            not_ready: 'Não pronto',
            master_status: 'Status principal',
            department_breakdown: 'Detalhamento por departamento',
            department: 'Departamento',
            status: 'Estado',
            completion: 'Conclusão',
            due_date: 'Data de vencimento',
            overdue_flag: 'Atrasado',
            child_tasks: 'Subtarefas',
            task: 'Tarefa',
            load_failed: 'Falha ao load consolidation data',
            child_linked: 'Subtarefa vinculada com sucesso',
            link_failed: 'Falha ao link child task',
            confirm_unlink: 'Tem a certeza de que pretende desvincular esta subtarefa?',
            child_unlinked: 'Subtarefa desvinculada',
            unlink_failed: 'Falha ao desvincular a subtarefa',
            unlink: 'Desvincular',
            status_completed: 'Concluído',
            status_in_progress: 'Em andamento',
            status_pending: 'Pendente',
            select_child_task: 'Selecionar subtarefa',
            select_department: 'Selecionar departamento',
        },
        section_assignments: {
            title: 'Atribuições de seção',
            assign_section: 'Atribuir seção',
            section_ref: 'Ref. da seção',
            section_label: 'Rótulo da seção',
            department_id: 'ID do departamento',
            department: 'Departamento',
            assignee_id: 'ID do atribuído',
            assignee: 'Cessionário',
            mandatory: 'Obrigatório',
            assign: 'Atribuir',
            no_assignments: 'Sem atribuições de seção',
            status: 'Estado',
            completion: 'Conclusão',
            mark_complete: 'Concluir',
            load_failed: 'Falha ao load section assignments',
            assign_success: 'Seção atribuída com sucesso',
            assign_failed: 'Falha ao assign section',
            status_updated: 'Status atualizado',
            status_update_failed: 'Falha ao atualizar o estado',
            section_ref_placeholder: 'por exemplo 3.2',
            status_completed: 'Concluído',
            status_in_progress: 'Em andamento',
            status_pending: 'Pendente',
            select_department: 'Selecione o departamento',
            select_assignee: 'Selecione o responsável',
        },
        overdue_columns: {
            days_overdue: 'Dias em atraso',
        },
        regulatory_info: {
            deadline_context: 'Ao criar tarefas DPIA, as datas de vencimento devem estar alinhadas com os prazos de envio PDPL: entrada departamental = 10 dias uteis. Os prazos de ciberseguranca e telecomunicacoes tambem se aplicam.',
            overdue_deadline_context: 'Prazos regulatorios dos dados do pacote: entrada departamental PDPL = 10 dias uteis, resposta complementar = 15 dias uteis, reenvio = 10 dias uteis. Tarefas com SLA violado sao distinguidas visualmente.',
            section_assignment_context: 'Fluxo DPIA multidepartamental (PDPL-P1): o DPO atribui secoes do dossie a departamentos. Prazo de entrada departamental: 10 dias uteis.',
            template_catalog_context: 'Os modelos do sistema cobrem processos especificos da estrutura: DPIA PDPL, certificacao da Lei de Dados, resposta a incidentes de ciberseguranca, solicitacoes de autoridade de telecomunicacoes e registo de sistemas de IA. Os modelos do sistema nao sao editaveis.',
            workflow_instantiation_context: 'Os modelos instalados podem ser instanciados em fluxos de trabalho ativos. As tarefas sao criadas automaticamente com datas de vencimento calculadas.',
        },
    },
    notifications: {
        bell: {
            title: 'Notificações',
            unread_count: 'unread',
        },
        drawer: {
            title: 'Notificações',
            mark_all_read: 'Marcar tudo como lido',
            no_notifications: 'Sem notificações',
            filter: {
                all: 'All',
                unread: 'Não lido',
                tasks: 'Tarefas',
                approvals: 'Aprovações',
                alerts: 'Alertas',
            },
        },
        preferences: {
            title: 'Preferências de notificação',
            description: 'Configure como você recebe notificações',
            category: {
                label: 'Categoria',
                task_assigned: 'Tarefa atribuída',
                task_sla_approaching: '[[TOK_0]] Aproximando-se',
                task_overdue: 'Tarefa atrasada',
                task_completed: 'Tarefa concluída',
                task_escalated: 'Tarefa Escalada',
                workflow_transition: 'Transição do Fluxo de Trabalho',
                approval_requested: 'Aprovação solicitada',
                comment_added: 'Comentário adicionado',
                weekly_digest: 'Resumo Semanal',
                sla_breach_report: '[[TOK_0]] Relatório de violação',
                system_alert: 'Alerta do sistema',
            },
            channel: {
                platform: 'Plataforma',
                email: 'Email',
            },
            quiet_hours: {
                title: 'Horário de silêncio',
                start: 'Iniciar',
                end: 'End',
                timezone: 'Fuso horário',
            },
            digest: {
                title: 'Frequência de resumo',
                daily: 'Diariamente',
                weekly: 'Semanalmente',
                none: 'Nenhum',
            },
            watched: {
                title: 'Entidades monitoradas',
                empty: 'Nenhuma entidade monitorada',
            },
            save: 'Salvar preferências',
            saving: 'Salvando...',
            saved_success: 'Preferências salvas com sucesso',
            load_error: 'Não foi possível carregar as preferências salvas. Mostrando padrões — as alterações serão salvas quando você clicar em Salvar.',
            enabled: 'Habilitado',
            disabled: 'Desativado',
            unwatch: 'Desassistir',
        },
        admin_queue: {
            title: 'Fila de administração de notificações',
            description: 'Monitorizar o estado de entrega de e-mails e retentar mensagens falhadas',
            load_error: 'Falha ao carregar dados da fila de e-mails',
            retry_error: 'Falha ao retentar e-mail',
            filter_status: 'Filtrar por estado',
            all_statuses: 'Todos',
            refresh: 'Atualizar',
            status_queued: 'Em fila',
            status_sent: 'Enviado',
            status_failed: 'Falhado',
            status_bounced: 'Devolvido',
            col_recipient: 'Destinatário',
            col_category: 'Categoria',
            col_template: 'Modelo',
            col_status: 'Estado',
            col_retries: 'Tentativas',
            col_created: 'Criado',
            col_sent: 'Enviado em',
            col_actions: 'Ações',
            no_items: 'Nenhum item encontrado na fila de e-mails',
            retry: 'Retentar',
            retrying: 'A retentar...',
            prev: 'Anterior',
            next: 'Seguinte',
            access_denied_title: 'Acesso de administrador necessário',
            access_denied: 'Esta página está disponível apenas para administradores. Contacte o seu administrador se precisar de acesso.',
            announce_queue_loaded: 'Fila de e-mail carregada, [[TOK_1]] itens',
            announce_processed: '[[TOK_1]] e-mails processados',
            process_now: 'Processar agora',
            processing_ellipsis: 'Processando…',
        },
    },
    ui_assist: {
        toolbar: {
            title: 'Assistência de IU',
            activate: 'Ativar',
            deactivate: 'Desativar',
            connected: 'Conectado',
            disconnected: 'Desconectado',
            disconnected_hint: 'Desconectado - execute `npm run relay` para conectar-se ao Claude CLI',
            open_panel: 'Abra o painel UI Assist',
            history: 'História',
            settings: 'Configurações',
        },
        prompt: {
            placeholder: 'Descreva a mudança que você deseja fazer…',
            send: 'Enviar',
            cancel: 'Cancelar',
            char_count: '[[TOK_2]] / [[TOK_3]]',
        },
        session: {
            streaming: 'Processando…',
            complete: 'Completo',
            error: 'Erro',
            abort: 'Abortar',
            abort_confirm: 'Tem certeza de que deseja abortar?',
            aborted_hint: 'A sessão foi interrompida — pode continuar a partir daqui.',
            undo: 'Desfazer',
            redo: 'Refazer',
            retry: 'Tentar novamente',
            dismiss: 'Dispensar',
        },
        label: {
            component: 'Componente',
            element: 'Elemento',
            file: 'Arquivo',
        },
        response: {
            you: 'You',
            claude: 'Cláudio',
            empty: 'Nenhuma mensagem ainda. Selecione os elementos e envie um prompt para começar.',
        },
        panel: {
            tab_conversation: 'Bate-papo',
            tab_tasks: 'Tarefas',
            tab_sprint: 'Corrida',
            tab_sessions: 'Sessões',
            tab_lobby: 'Saguão',
            follow_up: 'Acompanhamento',
            followup_placeholder: 'Faça uma pergunta complementar…',
            interrupt_placeholder: 'Escreva para interromper e redirecionar…',
            send_interrupt: 'Enviar & Interromper',
            will_interrupt: 'Interromperá a resposta atual e enviará esta em vez disso',
            expand: 'Expandir para tela cheia',
            collapse: 'Recolher para painel lateral',
            no_sessions: 'Nenhuma sessão anterior. Selecione elementos e envie uma instrução para começar.',
            session_active: 'Ativa',
            session_ended: 'Encerrada',
            session_messages: '{count} mensagens',
            switch_session: 'Mudar para esta sessão',
            load_session: 'Carregar histórico da sessão',
            session_restored: 'Sessão restaurada do histórico',
            archive_session: 'Sessão de arquivamento',
            archive_confirm: 'Arquivar esta sessão? O arquivo da sessão será excluído.',
            new_session: 'Nova sessão',
            new_session_desc: 'Use Ativar para selecionar um elemento da UI e iniciar uma nova sessão',
            start_new_session: 'Iniciar nova sessão',
            no_active_session_chat: 'Inicie uma nova sessão ou use Ativar para selecionar um elemento de UI na página para começar.',
            no_active_session_tasks: 'Inicie uma nova sessão ou selecione uma sessão existente para criar tarefas.',
            no_active_session_sprint: 'Inicie uma nova sessão ou selecione uma sessão existente para planejar um sprint.',
            previous_sessions: 'Sessões anteriores',
        },
        tasks: {
            none_found: 'Nenhuma tarefa encontrada na resposta. Peça a Claude para sugerir tarefas.',
            selected: 'selected',
            create_selected: 'Criar tarefas',
            execute_tasks: 'Executar tarefas',
            creating: 'Criando…',
            created: 'tarefas criadas',
            create_error: 'Falha ao criar tarefa',
            plan_sprint: 'Planejar Sprint',
            priority_critical_desc: 'Bloqueante — corrigir imediatamente',
            priority_high_desc: 'Importante — resolver neste sprint',
            priority_medium_desc: 'Normal — planear para próximo sprint',
            priority_low_desc: 'Desejável — candidato para backlog',
            add_custom: 'Adicionar tarefa',
            add_title_placeholder: 'Título da tarefa…',
            add_desc_placeholder: 'Descrição (opcional)',
            add_save: 'Adicionar',
            add_cancel: 'Cancelar',
        },
        sprint: {
            title: 'Planejador de sprints',
            assigned: 'assigned',
            new_placeholder: 'Nome do sprint (por exemplo, Sprint 18.1.0)',
            add: 'Add',
            backlog: 'Pendências',
            move_to: 'Mude para…',
            empty: 'Crie um grupo de sprint e atribua tarefas a ele.',
            create_all: 'Crie todas as tarefas',
            remove: 'Remover',
            drop_here: 'Atribua tarefas do backlog abaixo',
            add_task: 'Adicionar tarefa do backlog…',
        },
        feature_disabled: 'O UI Assist não está ativado',
        permission_denied: 'Você não tem permissão para usar o UI Assist',
    },
    license: {
        title: 'Licença e Pacote',
        current_license: 'Licença Atual',
        license_key: 'Chave de licença',
        activate: 'Ativar licença',
        deactivate: 'Desativar licença',
        validate_now: 'Valide agora',
        status: 'Status da licença',
        active: 'Ativo',
        expired: 'Expirado',
        suspended: 'Suspenso',
        invalid: 'Inválido',
        pending: 'Pendente',
        no_license: 'Sem licença',
        expires_at: 'Expira',
        last_validated: 'Última validação',
        domain: 'Domínio Licenciado',
        activation_success: 'Licença ativada com sucesso.',
        activation_failed: 'Falha na ativação da licença.',
        domain_mismatch: 'O domínio da licença não corresponde ao domínio atual.',
        deactivation_success: 'Licença desativada.',
        validation_success: 'Licença validada com sucesso.',
        validation_failed: 'A validação da licença falhou.',
        enter_key: 'Insira sua chave de licença',
        confirm_deactivate: 'Tem certeza de que deseja desativar esta licença? As restrições do módulo serão aplicadas com base no nível padrão.',
    },
    package_mgmt: {
        title: 'Pacote',
        module_column: 'Módulo',
        current_tier: 'Pacote Atual',
        light: 'Luz',
        standard: 'Padrão',
        enterprise_unlimited: 'Empresa Ilimitada',
        change_package: 'Alterar pacote',
        upgrade: 'Atualizar',
        downgrade: 'Downgrade',
        target_tier: 'Pacote de destino',
        new_license_key: 'Chave de licença para pacote de destino',
        confirm_change: 'Confirmar alteração do pacote',
        change_success: 'Pacote alterado com sucesso.',
        change_failed: 'Falha na alteração do pacote.',
        modules_included: 'Módulos incluídos',
        modules_restricted: 'Não disponível no pacote atual',
        upgrade_to_enable: 'Atualize para ativar este módulo.',
        module_availability: 'Disponibilidade do Módulo',
        comparison: 'Comparação de pacotes',
        power_users: 'Usuários avançados',
        unlimited: 'Ilimitado',
        impact_warning: 'O downgrade desativará os seguintes módulos:',
        invalid_license: 'A chave de licença fornecida não é válida para este pacote.',
        tier_mismatch: 'A chave de licença é para um nível de pacote diferente.',
    },
    board_report: {
        title: 'Relatório de Conformidade para o Conselho',
        subtitle: 'Resumo executivo de conformidade em todos os módulos',
        date_from: 'Data de início',
        date_to: 'Data de fim',
        language: 'Idioma do relatório',
        generate: 'Gerar relatório',
        generating: 'A gerar relatório...',
        download_pdf: 'Transferir PDF',
        close: 'Fechar relatório',
        open_board_report: 'Gerar relatório do conselho',
        close_board_report: 'Fechar relatório do conselho',
        report_period: 'Período do relatório',
        generated_at: 'Gerado em',
        generated_by: 'Gerado por',
        organization: 'Organização',
        section_rights_requests: 'Pedidos de direitos',
        section_vendors: 'Fornecedores',
        section_dpias: 'AIPD',
        section_consent: 'Políticas de consentimento',
        section_data_mapping: 'Mapeamento de dados',
        section_incidents: 'Incidentes',
        section_classification: 'Classificação de dados',
        section_governance: 'Governação',
        open: 'Aberto',
        closed: 'Fechado',
        sla_compliance: 'Conformidade SLA',
        total: 'Total',
        expired_dpa: 'DPA expirado',
        high_risk: 'Alto risco',
        completed: 'Concluído',
        overdue: 'Em atraso',
        policies_active: 'Políticas ativas',
        coverage: 'Cobertura',
        systems: 'Sistemas',
        completeness: 'Completude',
        avg_resolution_days: 'Méd. resolução (dias)',
        labeled: 'Etiquetado',
        unlabeled_systems: 'Sistemas sem etiqueta',
        compliance_score: 'Pontuação de conformidade',
        drift_events_open: 'Desvios abertos',
        no_data: 'Sem dados disponíveis para o período selecionado.',
        error_date_range: 'Selecione a data de início e a data de fim.',
        table_category: 'Categoria',
        table_metric: 'Métrica',
        table_value: 'Valor',
        showing_chart_view: 'A mostrar vista de gráfico',
        showing_table_view: 'A mostrar vista de tabela de dados',
        error_generate: 'Não foi possível gerar o relatório do conselho.',
        playbook_evidence_title: 'Evidência de execução de playbooks',
        playbook_evidence_description: 'Atividade de execução por playbook e ficheiros de evidência anexados para o período do relatório.',
        playbook_name: 'Manual',
        playbook_execution_count: 'Execuções',
        playbook_steps_total: 'Passos',
        playbook_steps_required: 'Evidência requerida',
        playbook_steps_attached: 'Evidência anexada',
        playbook_coverage_pct: 'Cobertura',
        playbook_evidence_files: 'Ficheiros de evidência',
        playbook_no_evidence: 'Sem execuções de playbook neste período.',
        playbook_download_file: 'Descarregar ficheiro',
    },
    framework_module_links: {
        title: 'Vinculação de Estrutura Regulatória',
        modules: 'Módulos Vinculados',
        add_module: 'Adicionar Módulo',
        module_code: 'Código do Módulo',
        required: 'Obrigatório',
        notes: 'Notas',
        link: 'Vincular',
        no_modules: 'Nenhum módulo vinculado',
        personas: 'Personas Vinculadas',
        add_persona: 'Adicionar Persona',
        persona_id: 'ID da Persona',
        role_description: 'Descrição do Papel',
        no_personas: 'Nenhuma persona vinculada',
    },
    framework_channels: {
        title: 'Canais de Submissão & Prazos',
        channels: 'Canais de Submissão',
        add_channel: 'Adicionar Canal',
        channel_type: 'Tipo',
        name: 'Nome',
        instructions: 'Instruções',
        active: 'Ativo',
        no_channels: 'Nenhum canal de submissão configurado',
        portal: 'Portal',
        in_person: 'Pessoalmente',
        postal: 'Correio',
        email: 'E-mail',
        add: 'Adicionar',
        deadlines: 'Prazos Regulatórios',
        add_deadline: 'Adicionar Prazo',
        label: 'Rótulo',
        days: 'Dias',
        day_type: 'Tipo de Dia',
        calendar_days: 'Dias de Calendário',
        working_days: 'Dias Úteis',
        description: 'Descrição',
        no_deadlines: 'Nenhum prazo configurado',
    },
    regulatory_updates: {
        title: 'Atualizações Regulatórias & Painel de Estruturas',
        coverage_dashboard: 'Painel de Cobertura de Estruturas',
        no_frameworks: 'Nenhuma estrutura encontrada',
        framework: 'Estrutura Regulatória',
        status: 'Estado',
        modules: 'Módulos',
        templates: 'Modelos',
        forms: 'Formulários',
        channels: 'Canais',
        deadlines: 'Prazos',
        pending: 'Atualizações Pendentes',
        updates: 'Atualizações Regulatórias',
        create_update: 'Criar Atualização',
        framework_id: 'ID da Estrutura',
        update_title: 'Título',
        description: 'Descrição',
        effective_date: 'Data de Vigência',
        create: 'Criar',
        no_updates: 'Nenhuma atualização regulatória',
        impact: 'Impacto',
        assess: 'Avaliar',
    },
    module_tips: ptModuleTips,
    framework_rights: {
        be_informed: 'Direito de ser informado',
        consent: 'Direito ao consentimento',
        refuse_consent: 'Direito de recusar o consentimento',
        withdraw_consent: 'Direito de retirar o consentimento',
        access: 'Direito de acesso',
        rectification: 'Direito de retificação',
        data_provision: 'Direito à provisão de dados',
        deletion: 'Direito à eliminação',
        restriction_of_processing: 'Direito à limitação do tratamento',
        object_to_processing: 'Direito de oposição ao tratamento',
        complaint: 'Direito de apresentar reclamação',
        denunciation: 'Direito de denúncia',
        lawsuit: 'Direito de ação judicial',
        claim_damages: 'Direito a indemnização por danos',
        request_protection_measures: 'Direito de solicitar medidas de proteção',
    },
    framework_content: {
        EU_EPRIVACY_DIRECTIVE: {
            display_name: 'Diretiva 2002/58/CE (Diretiva Privacidade Eletrónica)',
            description: 'Diretiva principal para transposições nacionais de privacidade eletrônica. Abrange cookies, privacidade de comunicações eletrónicas, marketing direto. Cada estado membro deve transpor para a legislação nacional.',
        },
        EU_GDPR: {
            display_name: 'Regulamento Geral de Proteção de Dados (UE) 2016/679',
            description: 'O Regulamento Geral de Proteção de Dados ([[TOK_0]]) é um regulamento da UE sobre proteção de dados e privacidade. Aplica-se diretamente em todos os estados membros da UE/EEE.',
        },
        EU_NIS2_DIRECTIVE: {
            display_name: 'Diretiva (UE) 2022/2555 ([[TOK_0]])',
            description: 'Diretiva pai para transposições nacionais [[TOK_0]]. Abrange gerenciamento de riscos de segurança cibernética, relatórios de incidentes e segurança da cadeia de suprimentos para entidades essenciais e importantes.',
        },
        VN_AI_LAW_2026: {
            display_name: 'Lei do Vietnã [[TOK_0]] ([[TOK_1]]) - Em vigor em 1º de março de 2026',
            description: 'Lei do Vietnã [[TOK_0]] (Luật Trí tuệ nhân tạo [[TOK_2]]) que rege o desenvolvimento, implantação e uso de sistemas de inteligência artificial. Estabelece deveres de classificação de risco, transparência e rotulagem, requisitos de notificação de incidentes, obrigações de avaliação de impacto e um mecanismo de testes controlados (sandbox) para atividades [[TOK_1]] no Vietnã.',
        },
        VN_AI_DECREE_142_2026: {
            display_name: 'Decree 142/2026/NĐ-CP — [[TOK_0]] Law Implementation',
            description: 'Decree 142/2026/NĐ-CP (Nghị định số 142/2026/NĐ-CP) detailing certain articles and implementing measures of the Vietnam [[TOK_0]] Law (Law 134/2025/QH15). Issued 2026-04-30, effective 2026-05-01. Lead authority: Ministry of Science and Technology. Operationalises [[TOK_0]] risk classification, classification dossier, reclassification review, high-risk conformity assessment, high-risk risk-management system, transparency / explanation / technical marking / visible labeling, serious [[TOK_0]] incident reporting (72h / 5wd / 15d), state-agency [[TOK_0]] impact assessment (Mẫu AI02), and the controlled testing / [[TOK_0]] sandbox lifecycle (Mẫu AI03a-AI09b). Submission via the [[TOK_0]] one-stop e-portal or MoST transitional channel. No statutory fines.',
        },
        VN_CYBERSEC_LAW: {
            display_name: 'Lei de Segurança Cibernética do Vietnã (era 24/2018)',
            description: 'Lei de Cibersegurança do Vietname (Lei n.º [[TOK_0]]) que estabelece requisitos para segurança cibernética, localização de dados e comunicação de incidentes. Ativo até ser substituído pela Lei [[TOK_1]] em vigor em 01/07/2026.',
        },
        VN_CYBERSEC_DECREE_53: {
            display_name: 'Decreto 53 – Implementação da Lei de Segurança Cibernética',
            description: 'Decreto [[TOK_0]] que implementa a Lei de Segurança Cibernética, abrangendo determinação dentro do escopo, gatilhos de localização de dados, requisitos de presença local e fluxos de trabalho de cooperação entre autoridades.',
        },
        VN_CYBERSEC_LAW_2025: {
            display_name: 'Lei de Segurança Cibernética ([[TOK_0]])',
            description: 'Lei consolidada do Vietnã sobre segurança cibernética (Lei [[TOK_0]]), substituindo a Lei [[TOK_1]], em vigor em 1º de julho de 2026. Consolida o escopo do Decreto [[TOK_2]]Đ-CP (ver VN_CYBERSEC_DECREE_53).',
        },
        VN_DATA_LAW: {
            display_name: 'Lei de Dados do Vietnã',
            description: 'Lei de Dados do Vietnã (Lei [[TOK_0]]) que estabelece requisitos abrangentes de governança de dados, incluindo inventário de dados, classificação, governança de compartilhamento e governança de transferência transfronteiriça de dados. Sobrepõe-se a VN_PDPL_LAW_2025 (aspectos de dados pessoais) e VN_CYBERSEC_LAW_2025 (localização/classificação de dados).',
        },
        VN_DATA_LAW_DECREE_165_2025: {
            display_name: 'Decreto [[TOK_0]]Đ-CP (Implementação da Lei de Dados)',
            description: 'Decreto [[TOK_0]]Đ-CP que implementa a Lei de Dados do Vietnã (Lei [[TOK_1]]). Fornece formulários oficiais para avaliação de impacto de transferência transfronteiriça de dados, relatórios anuais de avaliação de risco e acesso a bancos de dados nacionais. Define 11 formulários oficiais de Mẫu số.',
        },
        VN_DATA_EXCHANGES_DRAFT_2026: {
            display_name: 'Projeto de Decreto sobre Operações de Bolsas de Dados 2026',
            description: 'Projeto de decreto relativo ao funcionamento de plataformas de intercâmbio de dados (Dự thảo Nghị định quy định về hoạt động của sàn dữ liệu). Regula a classificação da plataforma, elegibilidade dos participantes, controles de listagem de produtos e serviços de dados, testes de sandbox, fluxo de trabalho de transações, contratação eletrônica, certificados de direitos de propriedade sobre dados e tratamento de reclamações/disputas. Atualmente em consulta pública; ainda não promulgado. Cita Lei de Dados [[TOK_0]], Lei de Proteção de Dados Pessoais [[TOK_1]], Lei de Segurança Cibernética [[TOK_2]] e Lei de Transações Eletrônicas [[TOK_3]].',
        },
        VN_ECOMMERCE_LAW_2025: {
            display_name: 'Lei do Comércio Eletrônico ([[TOK_0]])',
            description: 'Lei do Vietnã sobre Comércio Eletrônico (Luật Thương mại điện tử [[TOK_0]]) que estabelece um regime nacional unificado para o comércio eletrônico, abrangendo operações de plataforma nacionais e transfronteiriças, governança e responsabilidade da plataforma, proteção ao consumidor, controles de vendedores e afiliados, tratamento de reclamações, moderação de conteúdo e aplicação de remoção, e prontidão de procedimentos administrativos para o sistema estadual de gerenciamento de comércio eletrônico.',
        },
        VN_PDPL: {
            display_name: 'Vietnã [[TOK_0]] (era do Decreto 13/2023)',
            description: 'Decreto de Proteção de Dados Pessoais do Vietnã (Decreto [[TOK_0]]) que estabelece requisitos abrangentes de proteção de dados. Estrutura legada — substituída pela Lei [[TOK_1]] e pelo Decreto [[TOK_2]] em vigor em 01/01/2026.',
        },
        VN_PDPD_DECREE_13: {
            display_name: 'Decreto 13 — [[TOK_0]] Linha de Base Operacional',
            description: 'Decreto [[TOK_1]], o instrumento operacional para funções de [[TOK_0]], incluindo arquivamento de dossiês, artefatos de governança, mecânica transfronteiriça e procedimentos administrativos MoPS. Substituído pelo Decreto [[TOK_2]] em vigor em 01/01/2026.',
        },
        VN_PDPL_LAW_2025: {
            display_name: 'Lei de Proteção de Dados Pessoais ([[TOK_0]])',
            description: 'Lei de Proteção de Dados Pessoais do Vietnã (Lei [[TOK_2]]) que estabelece uma estrutura abrangente de proteção de dados pessoais, em vigor a partir de 1º de janeiro de 2026. Abrange temas de conformidade A–J: bases de processamento legais, consentimento de dados confidenciais, direitos do titular dos dados (acesso/retificação/apagamento/restrição/objeção/portabilidade), notificação de violação às autoridades e aos titulares dos dados, [[TOK_0]] para processamento de alto risco, governança de transferência transfronteiriça, Designação [[TOK_1]], registros de atividades de processamento, obrigações contratuais do processador. Obrigações de apresentação de autoridade via MoPS (VN_PDPL_ADMIN_PROCEDURES_778_2026). Referências cruzadas: VN_PDPL_DECREE_356_2025 (decreto de implementação), VN_CYBERSEC_LAW_2025 (sobreposições de segurança cibernética), VN_DATA_LAW (governança de dados).',
        },
        VN_PDPL_DECREE_356_2025: {
            display_name: 'Decreto [[TOK_1]] ([[TOK_0]] Implementação)',
            description: 'Decreto [[TOK_0]] que implementa a Lei de Proteção de Dados Pessoais, substituindo o Decreto [[TOK_1]]. Abrange arquivamento de dossiês, artefatos de governança, mecânica transfronteiriça e certificação de prestadores de serviços. Inventário do formulário anexo: Phụ lục I–VIII (avaliação de impacto, transferência transfronteiriça, certificação). Procedimentos administrativos MoPS via VN_PDPL_ADMIN_PROCEDURES_778_2026 (Decisão 778/QĐ-BCA-A05). Fluxo de trabalho de certificação: aplicação → emissão → solicitação de alteração → reemissão → revogação. Referências cruzadas: VN_PDPL_LAW_2025 (lei parental), VN_CYBERSEC_LAW_2025 (localização de dados), VN_DATA_LAW (sobreposições de governança de dados).',
        },
        VN_PDPL_ADMIN_PROCEDURES_778_2026: {
            display_name: '[[TOK_0]] Procedimentos Administrativos A05 (Decisão 778/QĐ-BCA-A05)',
            description: 'Decisão 778/QĐ-BCA-A05 (fevereiro de 2026) — Procedimentos administrativos para proteção de dados pessoais no âmbito A05 ([[TOK_0]]). Define procedimentos de envio de dossiês, processamento e emissão de resultados, incluindo formulários DLCN-HC e formulários estatutários Mẫu số.',
        },
        VN_PDPL_ENFORCEMENT_DRAFT_2026: {
            display_name: 'Projeto de Decreto de Execução 2026',
            description: 'Projeto de decreto de aplicação e sanções por violações da Lei de Proteção de Dados Pessoais (Lei [[TOK_0]]). Define faixas de penalidade, fatores agravantes/atenuantes e procedimentos de execução. Atualmente em estado de projeto pendente de promulgação.',
        },
        VN_MOPS_ADMIN_SIMPLIFICATION_NQ22_2026: {
            display_name: 'Government Resolution NQ22/2026 — MoPS Administrative Simplification (Temporary Overlay)',
            description: 'Temporary procedural overlay (effective 2026-04-29, expiring 2027-03-01) introducing three official channels (National Public Service Portal, direct submission to MoPS, postal submission to MoPS) for [[TOK_0]] Decree 356/2025 and Decision 778/2026 dossier submissions. Email is NOT a NQ22 official channel — a separate unofficial email-ZIP submission guidance ([[TOK_0]]_GUIDANCE_EMAIL_ZIP_DOSSIER_SUBMISSION_2026) is shipped with requires_legal_review: true. Procedural overlay only — does NOT alter substantive obligations, fine ranges, or the binding force of underlying frameworks. Review task scheduled 2027-02-01.',
        },
        VN_TELECOM_LAW_2023: {
            display_name: 'Lei de Telecomunicações do Vietnã de 2023',
            description: 'Lei de Telecomunicações do Vietnã de 2023 (Luật Viễn thông), uma sobreposição setorial para empresas de telecomunicações/ISP/plataformas com obrigações de confidencialidade, controle de divulgação e tratamento de solicitações de autoridade. Referências cruzadas: VN_CYBERSEC_LAW_2025 (segurança do sistema de informação), VN_PDPL_LAW_2025 (processamento de dados do usuário), VN_DATA_LAW (governança de dados).',
        },
        VN_TELECOM_DECREE_163_2024: {
            display_name: 'Decreto [[TOK_0]]Đ-CP (Implementação da Lei de Telecomunicações)',
            description: 'Decreto [[TOK_0]]Đ-CP que implementa a Lei das Telecomunicações (Lei [[TOK_1]]). Fornece formulários oficiais para notificação de serviços de telecomunicações, licenciamento, registro e planos de desenvolvimento de data center. Define 7 formulários oficiais de Mẫu số.',
        },
    },
    framework_requirements: {
        d163_r4: {
            title: 'Arquivamento do plano de desenvolvimento do data center',
            description: 'Os planos de desenvolvimento de data centers devem ser arquivados junto à autoridade competente de acordo com o Decreto [[TOK_0]]Đ-CP.',
        },
        d163_r3: {
            title: 'Cadastro de serviço de telecomunicações',
            description: 'O registo dos serviços de telecomunicações deve ser apresentado à autoridade competente através do formulário previsto.',
        },
        d163_r2: {
            title: 'Pedido de licença de telecomunicações',
            description: 'Os pedidos de licenças de telecomunicações devem ser apresentados através do formulário previsto no Decreto [[TOK_0]]Đ-CP.',
        },
        d163_r1: {
            title: 'Notificação de prestação de serviços de telecomunicações',
            description: 'Os prestadores de serviços de telecomunicações devem notificar a autoridade competente da prestação do serviço através do formulário prescrito antes de iniciar o serviço.',
        },
        vn_dp_draft_f: {
            title: 'Reclamações, disputas e gestão de riscos',
            description: 'Os operadores de plataforma devem fornecer recepção de reclamações, fluxo de trabalho de tratamento de disputas com preservação de provas, identificação de riscos e controlos de alerta precoce, e revisão periódica dos riscos de privacidade, segurança cibernética e gestão de acesso.',
        },
        vn_dp_draft_e: {
            title: 'Fluxo de trabalho de transação e certificado de direitos de propriedade sobre dados',
            description: 'As transações exigem registro de conta, aprovação de listagem, contratação eletrônica, confirmação de pagamento, registro de entrega e emissão de certificado de direitos de propriedade sobre os dados, quando aplicável. O histórico e a rastreabilidade das transações devem ser preservados em um registro de transações.',
        },
        vn_dp_draft_d: {
            title: 'Sandbox e controles de ambiente de teste',
            description: 'Os ambientes de teste devem ser isolados, com acesso restrito, monitorados em termos de segurança e revisados antes de qualquer saída ser extraída. Nenhum dado de origem pode ser extraído do ambiente de teste e o encerramento/limpeza das sessões de teste deve ser registrado.',
        },
        vn_dp_draft_c: {
            title: 'Controles de listagem de produtos e serviços de dados',
            description: 'As listagens devem ser apoiadas por evidências de origem legal e de propriedade/direito de uso, registros de validação técnica, divulgações de qualidade e registros de aprovação e revisão de listagem na plataforma. Os dados proibidos devem ser filtrados antes da listagem.',
        },
        vn_dp_draft_b: {
            title: 'Elegibilidade e integração do participante',
            description: 'Os operadores de plataforma devem verificar o estatuto jurídico, a capacidade jurídica e os requisitos comerciais condicionais para vendedores e compradores, registar contas de transações e pagamentos e manter um registo de participantes.',
        },
        vn_dp_draft_a: {
            title: 'Classificação da plataforma de dados e modelo operacional',
            description: 'Os operadores de plataforma devem estabelecer uma classificação do tipo de plataforma (plataforma de dados nacional versus outras plataformas de dados), definir a elegibilidade e as responsabilidades do operador e documentar preços, taxas, regras de operação e governação técnica.',
        },
        d165_r5: {
            title: 'Acesso às informações do banco de dados nacional',
            description: 'Os pedidos para extrair/utilizar informações da base de dados nacional de dados digitais utilizam formulários prescritos (Mẫu số 07a/07b).',
        },
        d165_r4: {
            title: 'Relatório anual de avaliação de risco',
            description: 'Os relatórios anuais de avaliação de risco devem ser preenchidos usando os formulários prescritos (Mẫu số 05a/05b, 06).',
        },
        d165_r3: {
            title: 'Aviso de rescisão de transferência transfronteiriça',
            description: 'A rescisão da transferência transfronteiriça deve ser notificada através de formulários prescritos (Mẫu số 04a/04b).',
        },
        d165_r2: {
            title: 'Notificação do resultado da avaliação',
            description: 'A autoridade emite avisos de resultados de avaliação usando o formulário prescrito (Mẫu số 03).',
        },
        d165_r1: {
            title: 'Arquivamento de avaliação de impacto de transferência transfronteiriça de dados',
            description: 'As organizações devem apresentar dossiês de avaliação de impacto de transferência/processamento de dados transfronteiriços usando formulários prescritos (Mẫu số 01a/01b, 02).',
        },
        a964190d_8d1d_4284_bc7d_4023e2866751: {
            title: 'Consentimento para cookies e tecnologias semelhantes',
            description: 'O armazenamento ou acesso a informação num equipamento terminal só é permitido mediante consentimento prévio e informado, exceto para armazenamento tecnicamente necessário.',
        },
        '8437d96d_cf01_4f87_89f6_4faaf8eefdf6': {
            title: 'Confidencialidade das comunicações',
            description: 'Os Estados-Membros devem garantir a confidencialidade das comunicações e dos dados de tráfego conexos através de uma rede pública de comunicações e de serviços de comunicações eletrónicas acessíveis ao público.',
        },
        c5420073_50c6_4981_816a_398460e5f546: {
            title: 'Consentimento para marketing direto (opt-in)',
            description: 'A utilização de sistemas de comunicações eletrónicas para marketing direto requer o consentimento prévio do assinante.',
        },
        c8bf67d2_874b_4647_92d7_39aaa3230819: {
            title: 'Aceitação suave para clientes existentes',
            description: 'O marketing direto para clientes existentes para produtos/serviços semelhantes é permitido sem consentimento, se a opção de exclusão for fornecida.',
        },
        b546df40_9217_4204_b71c_5af5022a0ff9: {
            title: 'Notificação de violação para provedores de telecomunicações',
            description: 'Os prestadores de serviços de comunicações eletrónicas acessíveis ao público devem notificar a autoridade nacional competente das violações de dados pessoais.',
        },
        '5bd66ae4_dee3_4611_9104_71742df55484': {
            title: 'Direito de oposição ao marketing direto',
            description: 'Os assinantes terão a oportunidade de se oporem ao recebimento de mensagens de marketing direto a qualquer momento e gratuitamente.',
        },
        a10af31f_ba28_494e_ab50_f8679e86a0b0: {
            title: 'Retenção e eliminação de dados de tráfego',
            description: 'Os dados de tráfego relativos a assinantes e utilizadores devem ser apagados ou tornados anónimos quando já não forem necessários para a transmissão, exceto para faturação ou pagamentos de interligação.',
        },
        '8577e60f_66a8_4651_8336_d561db9929ad': {
            title: 'Condições de processamento de dados de localização',
            description: 'Os dados de localização que não sejam dados de tráfego só poderão ser tratados quando tornados anónimos ou com o consentimento do utilizador, na medida e pela duração necessária.',
        },
        '7f3abb41_8713_4276_93b5_6902f419a016': {
            title: 'Legalidade do processamento — consentimento',
            description: 'O tratamento só será lícito se o titular dos dados tiver dado consentimento para o tratamento dos seus dados pessoais para uma ou mais finalidades específicas.',
        },
        '1c2a945a_8eac_428d_8105_e80e95288ea4': {
            title: 'Legalidade do processamento — contrato',
            description: 'O tratamento é necessário para a execução de um contrato do qual o titular dos dados é parte.',
        },
        '2b50c0fb_ee96_412e_a092_c3c1f3f817e8': {
            title: 'Legalidade do tratamento — obrigação legal',
            description: 'O tratamento é necessário para o cumprimento de uma obrigação legal a que o responsável pelo tratamento esteja sujeito.',
        },
        '702ea760_9e5c_4c32_babc_0b5094ca9735': {
            title: 'Legalidade do tratamento — interesses vitais',
            description: 'O tratamento é necessário para proteger os interesses vitais do titular dos dados ou de outra pessoa singular.',
        },
        '8b55ce88_2d5e_467b_a55c_8c5b0efab67e': {
            title: 'Legalidade do tratamento — interesse público',
            description: 'O tratamento é necessário para o desempenho de uma tarefa de interesse público ou no exercício de autoridade oficial.',
        },
        '8a72dd16_ee3c_4947_b5cd_9484719adad8': {
            title: 'Legalidade do tratamento — interesses legítimos',
            description: 'O tratamento é necessário para efeitos dos interesses legítimos prosseguidos pelo responsável pelo tratamento ou por um terceiro.',
        },
        afefc965_8f83_4d75_a9fc_92d4d4f549d6: {
            title: 'Processamento de categorias especiais (dados sensíveis)',
            description: 'O tratamento de categorias especiais de dados pessoais (origem racial, opiniões políticas, saúde, etc.) é proibido, salvo condições específicas do art. 9(2) são atendidos.',
        },
        '10a2d63f_744d_4222_91f6_86a5a4cdaefd': {
            title: 'Condições para consentimento',
            description: 'O controlador deve demonstrar que o consentimento foi dado. O consentimento deve ser dado livremente, específico, informado e inequívoco. A retirada deve ser tão fácil quanto dar consentimento.',
        },
        '27697f99_efef_49e6_b8e7_c2dc550d1791': {
            title: 'Consentimento da criança — serviços digitais',
            description: 'O tratamento de dados pessoais de uma criança com idade inferior a 16 anos (ou idade inferior definida pelo Estado-Membro, não inferior a 13 anos) requer o consentimento dos pais para serviços da sociedade da informação.',
        },
        '53883480_508e_4f8e_984f_9354c18de285': {
            title: 'Informação e comunicação transparentes',
            description: 'O Controlador fornecerá informações relativas ao processamento de forma concisa, transparente, inteligível e facilmente acessível.',
        },
        b5eb22b7_78f2_4c55_b342_827d5f8ac90c: {
            title: 'Informações para coleta direta',
            description: 'Quando os dados pessoais forem coletados do titular dos dados, o responsável pelo tratamento fornecerá informações específicas no momento da coleta.',
        },
        e55f7dbf_cd2a_4713_887e_8c64744e2d95: {
            title: 'Informações para cobrança indireta',
            description: 'Caso os dados pessoais não tenham sido obtidos do titular dos dados, o responsável pelo tratamento fornecerá informações específicas dentro de um prazo razoável.',
        },
        '6bc5ec07_0589_4593_882a_13f41c31e1f6': {
            title: 'Direito de acesso',
            description: 'O titular dos dados tem o direito de obter a confirmação do tratamento e do acesso aos dados pessoais e informações complementares.',
        },
        '0e011e25_dcea_4a1e_ae55_583e683cea44': {
            title: 'Direito à retificação',
            description: 'O titular dos dados tem o direito de obter a retificação dos dados pessoais inexatos sem demora injustificada.',
        },
        e8ec5a55_f657_4a99_9b92_3e9861067d28: {
            title: 'Direito ao apagamento (direito ao esquecimento)',
            description: 'O titular dos dados terá o direito de obter o apagamento dos dados pessoais sem demora injustificada, sempre que se apliquem motivos específicos.',
        },
        '5b0c92fd_cd08_47be_bfd2_0540ad73f84f': {
            title: 'Direito à restrição do processamento',
            description: 'O titular dos dados terá o direito de obter a restrição do processamento quando se aplicarem condições específicas.',
        },
        '3b829862_39f4_41be_8f2b_d469469a801b': {
            title: 'Obrigação de notificação — retificação/apagamento/restrição',
            description: 'O Controlador comunicará qualquer retificação, apagamento ou restrição a cada destinatário a quem os dados foram divulgados.',
        },
        '9cf34be6_121b_4fdf_ad7c_c4773696522e': {
            title: 'Direito à portabilidade dos dados',
            description: 'O titular dos dados tem o direito de receber os seus dados pessoais num formato estruturado, de uso corrente e legível por máquina.',
        },
        becae433_90b9_4cc0_bd33_df50976c1561: {
            title: 'Direito de oposição',
            description: 'O titular dos dados terá o direito de se opor ao tratamento baseado no interesse público ou em interesses legítimos, incluindo a definição de perfis.',
        },
        '4ef387f1_439c_4579_82a3_01565e6dc05d': {
            title: 'Tomada de decisão individual automatizada, incluindo criação de perfil',
            description: 'O titular dos dados tem o direito de não ficar sujeito a uma decisão baseada exclusivamente num tratamento automatizado que produza efeitos jurídicos ou igualmente significativos.',
        },
        '667ae5eb_a39a_4809_a032_923cc804eaed': {
            title: 'Notificação de violação à autoridade de supervisão (72h)',
            description: 'Em caso de violação de dados pessoais, o responsável pelo tratamento notificará a autoridade de controlo no prazo de 72 horas após tomar conhecimento, a menos que seja pouco provável que resulte em risco.',
        },
        '40e4c2ad_bc85_436c_814f_265f02c8c3b1': {
            title: 'Notificação de violação aos titulares dos dados (alto risco)',
            description: 'Quando uma violação for suscetível de resultar num elevado risco para os direitos e liberdades, o responsável pelo tratamento deve comunicar a violação ao titular dos dados sem demora injustificada.',
        },
        '9dbb47bd_172f_4335_b7f3_4558476c4192': {
            title: 'Resposta às solicitações do titular dos dados (30 dias)',
            description: 'O Controlador responderá às solicitações do titular dos dados sem demora injustificada e no prazo de um mês após o recebimento, prorrogável por mais dois meses para solicitações complexas.',
        },
        '175d16b7_a0fc_44ff_bb9e_5ccb5d3de5a9': {
            title: 'Avaliação de impacto na proteção de dados',
            description: 'Quando o processamento for suscetível de resultar em um alto risco para os direitos e liberdades, o responsável pelo tratamento deverá realizar um [[TOK_0]] antes do processamento.',
        },
        e54a7b09_33dd_4cda_8e21_d10a51e5e925: {
            title: 'Consulta prévia à autoridade de supervisão',
            description: 'O controlador deverá consultar a autoridade supervisora quando um [[TOK_0]] indicar que o processamento resultaria em alto risco sem medidas de mitigação.',
        },
        '047b7838_bae5_4861_9c38_c99fedec9c96': {
            title: '[[TOK_0]] lista de processamento obrigatório',
            description: '[[TOK_0]] é necessário para avaliação/criação de perfil sistemática, processamento em larga escala de categorias especiais e monitoramento sistemático de áreas públicas.',
        },
        aa08dc83_7c1a_441d_a8e7_960f65c8de87: {
            title: 'Registros de atividades de processamento (controlador)',
            description: 'Cada controlador deverá manter um registro das atividades de processamento sob sua responsabilidade, incluindo finalidades, categorias, destinatários, transferências e retenção.',
        },
        b7eb6296_5962_449c_b267_d322d7919122: {
            title: 'Registros de atividades de processamento (processador)',
            description: 'Cada subcontratante deverá manter um registo de todas as categorias de atividades de tratamento realizadas em nome de um responsável pelo tratamento.',
        },
        '0d57e6d5_bbf5_4ea6_9a89_0f57bed61b5b': {
            title: 'Segurança de processamento',
            description: 'O controlador e o processador devem implementar medidas técnicas e organizacionais adequadas para garantir a segurança adequada ao risco.',
        },
        ad85edfc_3c92_4ce4_a414_3ba6186cae98: {
            title: 'Proteção de dados desde a concepção e por defeito',
            description: 'O Controlador deve implementar medidas adequadas para garantir que apenas os dados pessoais necessários para cada finalidade específica sejam processados (minimização de dados).',
        },
        '933b438d_53b8_4b6a_b1db_8e7f1b429ede': {
            title: 'Designação do responsável pela proteção de dados',
            description: 'O controlador e o processador designarão um [[TOK_0]] onde o processamento for realizado por uma autoridade pública, envolver monitoramento regular e sistemático ou processamento em grande escala de categorias especiais.',
        },
        '28810a5d_d818_411a_9e8c_792d1b2c9b2f': {
            title: 'Princípio geral para transferências',
            description: 'Qualquer transferência de dados pessoais para um país terceiro só ocorrerá se as condições do Capítulo V forem cumpridas.',
        },
        '60add64b_bb0c_44e7_baaf_666af65b2d0f': {
            title: 'Transferências baseadas em decisão de adequação',
            description: 'Uma transferência pode ocorrer se a Comissão decidir que o país terceiro garante um nível de proteção adequado.',
        },
        cde8c7cd_3727_40ce_a321_e6b72b335179: {
            title: 'Transferências sujeitas a salvaguardas adequadas',
            description: 'Na ausência de uma decisão de adequação, as transferências podem ocorrer quando são fornecidas salvaguardas adequadas, incluindo SCC ou BCR.',
        },
        '0e8edaa1_2156_44d9_95f2_1b284f581658': {
            title: 'Cláusulas contratuais padrão',
            description: 'As cláusulas contratuais-tipo adotadas pela Comissão ou por uma autoridade de supervisão proporcionam salvaguardas adequadas para as transferências internacionais.',
        },
        '608a8de7_6c75_4f88_bd4c_1cc308780ab9': {
            title: 'Regras corporativas vinculativas',
            description: 'As regras empresariais vinculativas aprovadas por uma autoridade de supervisão competente proporcionam salvaguardas adequadas para as transferências internacionais intragrupo.',
        },
        '420ced80_0d3b_4a28_adad_14ba54df3e40': {
            title: 'Derrogações para situações específicas',
            description: 'Na ausência de adequação ou salvaguardas, as transferências podem ocorrer com base no consentimento explícito, necessidade contratual, interesse público, reivindicações legais, interesses vitais ou registo público.',
        },
        c86fbc0d_7188_486c_8ea5_96b3fe957c6f: {
            title: 'Responsabilidade e treinamento do órgão de administração',
            description: 'Os órgãos de gestão de entidades essenciais e importantes devem aprovar medidas de gestão de riscos de cibersegurança e receber formação regular.',
        },
        ffb95a09_993c_4db0_a4bb_c48000e43b33: {
            title: 'Medidas de gestão de riscos de cibersegurança',
            description: 'As entidades essenciais e importantes devem tomar medidas técnicas, operacionais e organizacionais adequadas e proporcionais para gerir os riscos de cibersegurança.',
        },
        '6a7c8c8f_4b81_4b47_adb7_c6abd12acd4b': {
            title: 'Políticas e procedimentos de tratamento de incidentes',
            description: 'As entidades devem implementar políticas sobre tratamento de incidentes, incluindo procedimentos de detecção, análise, contenção e resposta.',
        },
        de019eab_9992_4361_be7c_3e592f209d76: {
            title: 'Continuidade de negócios e gestão de crises',
            description: 'As entidades devem implementar medidas de continuidade de negócios, incluindo gestão de backup, recuperação de desastres e gestão de crises.',
        },
        '6b5f482f_301c_4f69_bd91_f9ae1b21de6c': {
            title: 'Segurança da cadeia de suprimentos',
            description: 'As entidades devem abordar os aspetos relacionados com a segurança das relações com fornecedores diretos e prestadores de serviços, incluindo avaliações de risco da cadeia de abastecimento.',
        },
        c8e7738b_358c_4c79_9fc2_a564f15a6e37: {
            title: 'Segurança em redes e sistemas de informação',
            description: 'As entidades devem implementar segurança na aquisição, desenvolvimento e manutenção de redes e sistemas de informação, incluindo o tratamento de vulnerabilidades.',
        },
        '72520ed1_51ff_4983_a785_9be1f72cf7dd': {
            title: 'Tratamento e divulgação de vulnerabilidades',
            description: 'As entidades devem implementar políticas e procedimentos para divulgação e tratamento coordenado de vulnerabilidades.',
        },
        f009e65d_d55e_4c98_9532_63c150694698: {
            title: 'Eficácia da avaliação de riscos de segurança cibernética',
            description: 'As entidades devem implementar políticas e procedimentos para avaliar a eficácia das medidas de gestão de riscos de cibersegurança.',
        },
        '00e88824_675d_4b37_960c_757b3176c079': {
            title: 'Criptografia e políticas de criptografia',
            description: 'As entidades devem implementar políticas e procedimentos relativos ao uso de criptografia e, quando apropriado, criptografia.',
        },
        de29d287_81f1_46b1_b327_9cbf06ddad3d: {
            title: 'Segurança de RH, controle de acesso, gerenciamento de ativos',
            description: 'As entidades devem implementar políticas de segurança de recursos humanos, de controlo de acessos e de gestão de ativos.',
        },
        '750f4459_9ba4_415e_bc47_5b0ec27d35a2': {
            title: 'Autenticação multifator',
            description: 'As entidades devem usar soluções de autenticação multifatorial ou de autenticação contínua, comunicações seguras de voz/vídeo/texto e sistemas seguros de comunicação de emergência.',
        },
        '359474f9_1820_4e3e_9031_a593b66ccde4': {
            title: 'Aviso prévio ao CSIRT (24h)',
            description: 'As entidades devem enviar um alerta precoce ao CSIRT competente no prazo de 24 horas após tomarem conhecimento de um incidente significativo.',
        },
        '66acd92c_3091_4148_b935_68b0d24308e7': {
            title: 'Notificação de incidente ao CSIRT (72h)',
            description: 'As entidades devem apresentar uma notificação de incidente ao CSIRT competente no prazo de 72 horas após tomarem conhecimento de um incidente significativo.',
        },
        '68269688_06b2_43ea_8e3e_a84532086557': {
            title: 'Relatório final para CSIRT (1 mês)',
            description: 'As entidades devem apresentar um relatório final ao CSIRT competente o mais tardar um mês após a notificação do incidente.',
        },
        c8512bde_b064_4926_b333_06b9c95cecd7: {
            title: 'Determinação de aplicabilidade para atividades [[TOK_0]]',
            description: 'Determine se a organização realiza atividades [[TOK_0]] sujeitas à Lei do Vietnã [[TOK_1]] e documente a decisão de aplicabilidade.',
        },
        '3a87ad63_179a_45ba_8743_98d865df80ab': {
            title: '[[TOK_0]] classificação de risco do sistema por nível de risco',
            description: 'Classifique cada sistema [[TOK_0]] por nível de risco (mínimo, limitado, alto, inaceitável) usando a metodologia de classificação guiada.',
        },
        '0f4475d3_77a6_4b41_bfe2_d4b299b1bd45': {
            title: '[[TOK_0]] Manutenção de entrada de registro do sistema',
            description: 'Mantenha um registro de sistemas [[TOK_0]] com nome do sistema, proprietário, finalidade, contexto de implantação, nível de risco e envolvimento do fornecedor.',
        },
        '2a73ce94_906a_4c95_8a45_a5bdf2a8118c': {
            title: '[[TOK_0]] Dossiê do sistema com lista de verificação de artefatos e evidências',
            description: 'Crie e mantenha um dossiê do sistema com lista de verificação de artefatos necessários, biblioteca de evidências e histórico de versões.',
        },
        e92cfb42_d91b_444f_adbc_c03903844eac: {
            title: 'Obrigações de transparência para operadores de sistema [[TOK_0]]',
            description: 'Implementar medidas de transparência para sistemas [[TOK_0]], incluindo notificação ao usuário, divulgação do envolvimento de [[TOK_1]] e documentação do sistema.',
        },
        '45eb43d7_9b63_4166_aa0d_fa6aeeaa70ba': {
            title: "[[TOK_0]] rotulagem de saída, marca d'água e assinatura de metadados",
            description: "Implementar rotulagem e marca d'água para conteúdo gerado por [[TOK_0]], incluindo assinatura de metadados, quando aplicável.",
        },
        '9566c94d_0dd3_419c_869f_6707d2a972f9': {
            title: 'Requisitos de divulgação para conteúdo gerado por [[TOK_0]]',
            description: 'Divulgar aos usuários quando o conteúdo é gerado por [[TOK_0]] e fornecer mecanismos para que os usuários identifiquem o envolvimento de [[TOK_1]].',
        },
        '21d39ea5_df78_45c6_8710_b203db229e25': {
            title: 'Explicabilidade e deveres de transparência voltados para o usuário',
            description: 'Forneça resultados explicáveis para decisões [[TOK_0]] que afetam indivíduos e mantenha documentação de transparência voltada para o usuário.',
        },
        f523fbc2_156d_466d_ad50_6a0c51b3ac9d: {
            title: 'Obrigações de supervisão humana para sistemas [[TOK_0]] de alto risco',
            description: 'Garantir que mecanismos de supervisão humana estejam em vigor para sistemas [[TOK_0]] de alto risco, incluindo recursos de escalonamento e substituição.',
        },
        bd180a89_4976_4790_9e50_f1c5c97dc576: {
            title: '[[TOK_0]] monitoramento e detecção de incidentes',
            description: 'Implemente recursos de monitoramento para detectar incidentes, mau funcionamento e resultados adversos do sistema [[TOK_0]].',
        },
        e7c1c60b_856c_4d3d_b6c9_092cde9b56bd: {
            title: 'Relatório de incidente grave [[TOK_0]] à autoridade',
            description: 'Relate incidentes graves [[TOK_0]] à autoridade competente dentro do prazo prescrito (72 horas).',
        },
        '97f15adc_558a_49f2_bb06_86597cb9579b': {
            title: '[[TOK_0]] conformidade com o cronograma de notificação de incidentes',
            description: 'Cumpra os cronogramas de notificação para incidentes [[TOK_0]], incluindo notificação inicial, atualizações e relatórios de encerramento.',
        },
        '96c33d7e_fe52_4730_adac_70c8c477c88e': {
            title: '[[TOK_0]] avaliação de impacto para sistemas de alto risco',
            description: 'Realizar avaliações de impacto para sistemas [[TOK_0]] de alto risco cobrindo riscos, mitigações, supervisão humana e planos de monitoramento.',
        },
        '0f3b72c0_1030_44ff_ba53_596f45601cd7': {
            title: 'Testes controlados/determinação de elegibilidade de sandbox',
            description: 'Determine a elegibilidade para participação em testes controlados (sandbox) e documente a avaliação de elegibilidade.',
        },
        '4a6aed20_f655_4182_a760_aef1f329d5df': {
            title: 'Envio de aplicativos sandbox e rastreamento de aprovação',
            description: 'Envie solicitações de sandbox à autoridade competente e acompanhe o status de aprovação durante todo o ciclo de vida do envio.',
        },
        '8376988d_cd32_491e_a5b8_3340d3973358': {
            title: 'Pontos de verificação de monitoramento de sandbox e conclusão/saída',
            description: 'Realize pontos de verificação de monitoramento periódicos durante a participação no sandbox e prepare relatórios de conclusão/saída.',
        },
        '7cb2b544_0512_4702_a092_9f1c10872376': {
            title: 'Rotulagem da documentação de isenção/exceção com justificativa',
            description: 'Documente quaisquer isenções ou exceções de rotulagem com justificativa e evidências de apoio.',
        },
        dccd7fbf_872a_4716_87a4_b9c5ce8e2387: {
            title: 'Localização de dados para usuários vietnamitas',
            description: 'Os dados dos utilizadores vietnamitas sobre serviços prestados no Vietname devem ser armazenados no território do Vietname.',
        },
        '9eb86a03_e165_4963_8813_2272b638d529': {
            title: 'Relatório de incidentes de segurança cibernética',
            description: 'Os incidentes de cibersegurança devem ser comunicados às autoridades competentes em tempo útil.',
        },
        '736ac7de_7a6a_4bfd_b2be_c594e290038a': {
            title: 'Classificação do sistema de informação',
            description: 'Os sistemas de informação devem ser classificados por nível de importância e aplicadas medidas de segurança adequadas.',
        },
        ffb807cf_f121_4b52_8e50_e091c33180c9: {
            title: 'Avaliação de risco de segurança cibernética',
            description: 'Avaliações regulares de risco de segurança cibernética devem ser realizadas para sistemas de informação.',
        },
        a4de518b_a5f1_481f_9b08_f8d2bc9db7e5: {
            title: 'Determinação no escopo (árvore de decisão)',
            description: 'As organizações devem determinar se estão no âmbito do Decreto 53 utilizando a árvore de decisão prescrita.',
        },
        '01f99e9a_5e30_4d14_aae5_a2ce322a700b': {
            title: 'Avaliação e preparação da localização de dados',
            description: 'As organizações devem avaliar os requisitos de localização de dados e demonstrar prontidão.',
        },
        cf24f011_dc23_4d84_aef5_994dde440571: {
            title: 'Lista de verificação de preparação para armazenamento e retenção',
            description: 'Uma lista de verificação de prontidão para armazenamento e retenção deve ser preenchida para conformidade com a localização de dados.',
        },
        b3884cb8_c785_4258_9517_9e393be4f4e1: {
            title: 'Avaliação de requisitos de presença local',
            description: 'As organizações devem avaliar se os requisitos de presença local se aplicam e planejar adequadamente.',
        },
        c1dc645b_cb1a_42a6_8ca5_9b15cfa84156: {
            title: 'Recebimento e verificação de solicitação de autoridade',
            description: 'As solicitações de autoridade devem ser recebidas, verificadas e processadas de acordo com os procedimentos prescritos.',
        },
        d4571651_f39d_4c51_8f2d_7248c37f7b14: {
            title: 'Resposta da solicitação da autoridade dentro do prazo',
            description: 'As respostas aos pedidos das autoridades devem ser fornecidas dentro do prazo prescrito.',
        },
        '66c1df70_3456_40e9_b645_6c6bd3be702e': {
            title: 'Log de tratamento de solicitação de autoridade',
            description: 'Deve ser mantido um registo de todas as atividades de tratamento de pedidos de autoridade.',
        },
        '04bbba2a_9804_4199_a517_054b6f4689fb': {
            title: 'Aplicabilidade e determinação dentro do escopo (consolidado)',
            description: 'As organizações devem determinar se estão abrangidas pela lei consolidada de cibersegurança, abrangendo tanto o âmbito da antiga Lei 24/2018 como o do Decreto 53/2022.',
        },
        '89a21eaf_cf09_4fec_bbb4_a1dadd652f6e': {
            title: 'Classificação do sistema de informação por nível de importância',
            description: 'Os sistemas de informação devem ser classificados por nível de importância (geral, importante, crítico) com as correspondentes obrigações de segurança.',
        },
        '83ad981e_23ff_4a92_bebd_cd24487e912f': {
            title: 'Estrutura de governança da segurança cibernética e pessoal responsável',
            description: 'As organizações devem estabelecer estruturas de governação da segurança cibernética e designar pessoal responsável.',
        },
        '98d9a523_fefb_400b_bb7f_ebaf609a6ed4': {
            title: 'Avaliação periódica de riscos de segurança cibernética',
            description: 'Avaliações regulares de risco de segurança cibernética devem ser realizadas para todos os sistemas de informação classificados.',
        },
        '5236539f_4c1a_4eff_b2eb_fc11eb4eab23': {
            title: 'Medidas de segurança por classificação de sistema de informação',
            description: 'Devem ser aplicadas medidas técnicas de segurança adequadas a cada nível de classificação do sistema de informação.',
        },
        b69a8be2_ae0c_408c_b8f1_73b573eca876: {
            title: 'Controle de acesso e gerenciamento de identidade',
            description: 'Devem ser implementadas medidas de controlo de acesso e gestão de identidade para os sistemas de informação.',
        },
        ac774c26_feb7_4123_b799_c54f77bd87b5: {
            title: 'Registro, monitoramento e trilha de auditoria',
            description: 'Os sistemas de informação devem manter recursos de registro, monitoramento e trilha de auditoria.',
        },
        a86cb01d_239b_44e2_9e09_e6973bcf9658: {
            title: 'Gerenciamento de vulnerabilidades e patches',
            description: 'Os processos de gerenciamento de vulnerabilidades e patches devem ser estabelecidos e mantidos.',
        },
        '826a789f_0c03_4918_81a1_6aa1cc2c205c': {
            title: 'Localização de dados para dados de usuários vietnamitas',
            description: 'Os dados dos utilizadores vietnamitas sobre serviços prestados no Vietname devem ser armazenados no território do Vietname.',
        },
        '8bee2b51_ace8_4118_89c8_010b96640016': {
            title: 'Requisitos de presença local para prestadores de serviços estrangeiros',
            description: 'Os prestadores de serviços estrangeiros que operam no Vietname devem manter a presença local conforme prescrito.',
        },
        '74d89250_b45f_41b6_bfe3_f915071580de': {
            title: 'Arquitetura de armazenamento local e documentação de fluxo internacional',
            description: 'A arquitetura de armazenamento local deve ser documentada e os fluxos de dados transfronteiriços devem ser mapeados e controlados.',
        },
        '04dec6f8_3280_494c_8506_292804b16d4d': {
            title: 'Detecção e resposta a incidentes de segurança cibernética',
            description: 'As organizações devem ter capacidades para detectar e responder a incidentes de segurança cibernética.',
        },
        faeda71b_5050_497d_b08b_e3f3f5313ad4: {
            title: 'Comunicação obrigatória de incidentes à autoridade competente',
            description: 'Incidentes de segurança cibernética qualificados devem ser relatados a [[TOK_1]]/[[TOK_0]] dentro dos prazos prescritos.',
        },
        d732b5a2_2b2c_48a0_955d_97a39daf132d: {
            title: 'Cumprimento do cronograma de notificação de incidentes',
            description: 'As notificações de incidentes devem cumprir os requisitos de cronograma prescritos (relatório inicial em 24 horas, relatório completo em 72 horas).',
        },
        '8e2dffb0_3481_44f0_baf2_130ddd8cfe12': {
            title: 'Tratamento e cooperação de solicitações de autoridade',
            description: 'As solicitações da autoridade devem ser tratadas prontamente e a cooperação fornecida de acordo com os procedimentos prescritos.',
        },
        e4c5b870_1d61_48fe_a6c2_1b9f5a458ea3: {
            title: 'Registro de caso de solicitação de autoridade e registro de divulgação',
            description: 'Todas as solicitações e divulgações de autoridade devem ser registradas em um registro de caso com trilha de auditoria completa.',
        },
        '8eff8b17_65bc_4f94_8ece_c509a9fd9abb': {
            title: 'Avaliação de segurança de fornecedores e terceiros',
            description: 'Os fornecedores terceirizados com acesso a sistemas de informação devem passar por uma avaliação de segurança.',
        },
        '69891e1b_97f6_464c_9cce_b1276794fe4a': {
            title: 'Acesso a dados do fornecedor e controles de notificação de incidentes',
            description: 'O acesso aos dados do fornecedor deve ser documentado e as obrigações contratuais de notificação de incidentes devem ser estabelecidas.',
        },
        d89b6bc0_7a9e_4816_b31e_7c0abc02e90c: {
            title: 'Treinamento e exercícios de conscientização sobre segurança',
            description: 'Devem ser realizados treinamentos regulares de conscientização sobre segurança cibernética e exercícios práticos.',
        },
        f9c5d3cc_5bb2_4b30_a5fb_ada34e407981: {
            title: 'Pen test periódico e auditoria de segurança',
            description: 'Testes de penetração periódicos e auditorias de segurança devem ser realizados em sistemas de informação classificados.',
        },
        '88dd9877_d2e2_4e41_a248_ae39b1ff478f': {
            title: 'Manter inventário de dados digitais',
            description: 'As organizações devem manter um inventário de dados digitais abrangente, catalogando todos os ativos de dados.',
        },
        '18e4bfd1_42cf_4d87_870f_5a34242962ef': {
            title: 'Classificação de dados por sensibilidade e importância',
            description: 'Os dados devem ser classificados de acordo com os níveis de sensibilidade e importância definidos pela Lei de Dados.',
        },
        b89981ac_7559_46f9_a74c_a143976dde4e: {
            title: 'Definir regras de tratamento por nível de classificação',
            description: 'Devem ser estabelecidas regras de tratamento para cada nível de classificação de dados.',
        },
        '3bf8019d_b72c_41d7_82cf_fc367efd9526': {
            title: 'Acompanhe o compartilhamento e divulgação de dados com aprovações',
            description: 'Todas as atividades de compartilhamento e divulgação de dados devem ser acompanhadas com as aprovações apropriadas.',
        },
        '8623eca2_4cf9_41bd_bfbd_2300c06ca1f3': {
            title: 'Governança de transferência de dados transfronteiriça',
            description: 'As transferências transfronteiriças de dados devem cumprir os requisitos de governação previstos na Lei de Dados.',
        },
        '006b8aa6_9379_4eff_b8ab_935f9a087601': {
            title: 'Manter políticas e responsabilidades de governança',
            description: 'As organizações devem manter políticas de governação de dados e atribuir responsabilidades de governação.',
        },
        f12fc090_5c3e_4fa8_9813_74bea0359c5c: {
            title: 'Atestado anual de governança',
            description: 'Um atestado anual de governança deve ser preenchido para confirmar a conformidade contínua.',
        },
        f6c3060a_5e52_4f97_b1af_c6a5f00bfaee: {
            title: 'Avaliação de risco de dados',
            description: 'Uma avaliação de risco de dados deve ser realizada para identificar e mitigar os riscos de governança de dados.',
        },
        '6f228998_1c61_49cf_a585_3d3e9baff55a': {
            title: 'Responsabilidade do operador da plataforma e obrigações de governação',
            description: 'Estabelecer estruturas de responsabilização dos operadores de plataforma, incluindo políticas de governação, responsabilidades de monitorização e obrigações de aplicação.',
        },
        eee1d423_3783_4530_bc64_eef6fd9d02dc: {
            title: 'Publicação de regras da plataforma e transparência de informações',
            description: 'Publique regras da plataforma, condições de negociação e divulgações operacionais de maneira transparente e acessível.',
        },
        '50b57433_7a51_4e92_9c84_c748d6865b70': {
            title: 'Notificação de site/aplicativo de vendas de comércio eletrônico para MOIT',
            description: 'Envie notificação ao MOIT para sites e aplicativos de vendas de comércio eletrônico via Online.gov.vn ou canais designados.',
        },
        '92854abe_6654_4155_8495_f3419a8a8da0': {
            title: 'Registro de plataforma/marketplace de serviços de comércio eletrônico no MOIT',
            description: 'Registre plataformas e mercados de serviços de comércio eletrônico no MOIT, incluindo envio de dossiês e rastreamento de aprovação.',
        },
        b8bff437_805e_4a4a_a62e_89cb90b89d3f: {
            title: 'Manutenção de cadastro de vendedores (nacionais e estrangeiros)',
            description: 'Mantenha um registro de todos os vendedores na plataforma, incluindo vendedores nacionais e estrangeiros, com integração, verificação e acompanhamento do ciclo de vida.',
        },
        '75778639_5235_4d13_a728_fa772c27fc0c': {
            title: 'Registro de vendedor ao vivo e controles de conformidade',
            description: 'Mantenha um registro de vendedores de transmissão ao vivo com verificação de identidade, rastreamento de atividades e controles de conformidade.',
        },
        '405f2932_742a_4bcb_9784_1a3d81f2e714': {
            title: 'Registro de afiliados e parceiros de marketing',
            description: 'Mantenha um registro de comerciantes afiliados e parceiros de referência com status de contrato, diretrizes de conteúdo e reconhecimentos de conformidade.',
        },
        cce5a4eb_a576_459c_95b5_bdd0e8ed30a8: {
            title: 'Listagem de produtos e aplicação de mercadorias proibidas/condicionais',
            description: 'Implementar controles de listagem de produtos, incluindo triagem, monitoramento e ações de fiscalização de mercadorias proibidas e condicionais.',
        },
        '9fc01e19_18dd_4d60_b95a_c1f4bcdbb6ae': {
            title: 'Registro de reclamações de consumidores com registros, ações e trilha de auditoria',
            description: 'Mantenha um registro de reclamações com registros de entrada, ações de investigação, resultados de resolução e trilha de auditoria completa.',
        },
        '8a21764e_e5f4_4934_9913_c235f4c462ca': {
            title: 'Procedimento de tratamento de reclamações e prazos de resolução',
            description: 'Estabeleça procedimentos de tratamento de reclamações com prazos definidos de reconhecimento, investigação e resolução.',
        },
        '8406373c_ec31_4bf8_810f_72d9d73b3de8': {
            title: 'Moderação de conteúdo, monitoramento e aplicação de remoção',
            description: 'Implemente procedimentos de moderação, monitoramento e aplicação de remoção de conteúdo para conteúdo ilegal, proibido ou violador.',
        },
        '6f32c315_323b_4ce6_a4bb_3262a5b56afe': {
            title: 'Registro de ações de remoção e execução com preservação de evidências',
            description: 'Mantenha um registro de ações de remoção e execução com registros de decisões, preservação de evidências e notificações ao vendedor.',
        },
        c0bbbfbf_29bd_4813_89f1_956eab9f1a23: {
            title: 'Política da plataforma e registro de divulgação (versões, datas de publicação, aceitação)',
            description: 'Mantenha um registro das políticas e divulgações da plataforma com histórico de versões, datas de publicação e evidências de aceitação.',
        },
        c9fcbe90_622d_43ca_9ec6_db26c0eda490: {
            title: 'Deveres de informação ao consumidor - informações precisas sobre o produto e anti-engano',
            description: 'Garanta informações precisas e claras sobre produtos e serviços e implemente medidas para evitar práticas enganosas na plataforma.',
        },
        '8f49603b_454c_4470_ab07_2f845a447595': {
            title: 'Condições de funcionamento da plataforma estrangeira e registo/notificação',
            description: 'Cumprir as condições operacionais para plataformas estrangeiras que atendem usuários vietnamitas, incluindo requisitos de registro ou notificação.',
        },
        e0dc85cc_5d2a_4142_b1a6_cc2fde891f7b: {
            title: 'Representação local ou autorização para plataformas estrangeiras',
            description: 'Designe um representante local ou entidade autorizada no Vietnã para plataformas estrangeiras, conforme exigido por lei.',
        },
        '5719f47c_f298_429e_90c3_df6ceed856e1': {
            title: 'Coordenação de vendedor transfronteiriço e tratamento de reclamações',
            description: 'Coordenar o tratamento de vendedores transfronteiriços e a resolução de reclamações, incluindo escalonamento e gestão de evidências.',
        },
        c0b3db29_9161_4cef_a889_94e3b85d78fe: {
            title: 'Interação do sistema de gerenciamento de comércio eletrônico estadual e prontidão para relatórios',
            description: 'Preparar-se para a interação com o sistema estadual de gestão de comércio eletrônico, incluindo mapeamento de campos de dados e capacidade de geração de relatórios.',
        },
        '145a7016_720a_4a06_badd_00145842821e': {
            title: 'Notificação de alteração de material pós-aprovação',
            description: 'Envie notificações sobre alterações materiais nos detalhes, políticas ou operações da plataforma após a aprovação inicial.',
        },
        '4bc0ee2a_610d_490d_8122_d6d1afadaa22': {
            title: 'Notificação de rescisão e desativação',
            description: 'Envie notificações de rescisão ou desativação ao encerrar operações de comércio eletrônico, incluindo aviso público e tratamento de proteção ao consumidor.',
        },
        be95bc85_2b25_4de7_a3e7_154b780289e4: {
            title: 'Elegibilidade e manutenção do programa de classificação de marca de confiança e credibilidade',
            description: 'Avalie a elegibilidade para programas de classificação de selo de confiança e credibilidade e mantenha evidências de conformidade para participação contínua.',
        },
        f639afe2_18f2_4c0a_82d9_626308994267: {
            title: 'Consentimento para processamento de dados pessoais',
            description: 'O processamento de dados pessoais requer o consentimento do titular dos dados, a menos que se aplique uma isenção.',
        },
        '5dd8e1b9_ac2d_48af_8c62_538937f0a4f7': {
            title: 'Consentimento para processamento de dados confidenciais',
            description: 'O processamento de dados pessoais sensíveis requer consentimento explícito com notificação separada e clara ao titular dos dados.',
        },
        '5a958c76_6943_4449_a15c_ddb503ce526f': {
            title: 'Direito de acesso',
            description: 'Os titulares dos dados têm o direito de aceder aos seus dados pessoais na posse do responsável pelo tratamento.',
        },
        '1ae0a58b_65a5_4a32_9b2c_0baed7799a32': {
            title: 'Direito à retificação',
            description: 'Os titulares dos dados têm o direito de solicitar a retificação dos dados pessoais inexatos.',
        },
        '25c61e57_273f_48cb_a318_d6315ad744f1': {
            title: 'Direito ao apagamento',
            description: 'Os titulares dos dados têm o direito de solicitar o apagamento dos seus dados pessoais.',
        },
        '0eafe047_ed8b_4a9a_bda9_b4ef2ae353c2': {
            title: 'Direito de restringir o processamento',
            description: 'Os titulares dos dados têm o direito de solicitar a restrição do tratamento dos seus dados pessoais.',
        },
        '77f9677a_f436_43ec_a947_3bdc44fc192a': {
            title: 'Direito de oposição',
            description: 'Os titulares dos dados têm o direito de se opor ao tratamento dos seus dados pessoais.',
        },
        c8b19e70_782c_49c9_8a71_14bef4147d6b: {
            title: 'Direito de retirar o consentimento',
            description: 'Os titulares dos dados têm o direito de retirar o consentimento previamente dado a qualquer momento.',
        },
        '7f472a1c_b37f_498d_adc7_df8d8eafbae9': {
            title: 'Notificação de violação à autoridade (72h)',
            description: 'O controlador de dados deve notificar o Ministério de Segurança Pública no prazo de 72 horas após a descoberta de uma violação de dados pessoais.',
        },
        '98bed7ab_e814_43f5_8e70_e95c413266a1': {
            title: 'Notificação de violação aos titulares dos dados',
            description: 'O controlador de dados deve notificar os titulares dos dados afetados sobre uma violação de dados pessoais sem demora injustificada.',
        },
        '404a3576_dd84_4bac_acf4_29719615c45e': {
            title: '[[TOK_0]] para processamento de alto risco',
            description: 'Uma Avaliação de Impacto na Proteção de Dados deve ser realizada para atividades de processamento que possam resultar em alto risco.',
        },
        '29d9ed94_9360_457c_9aca_37aefac66969': {
            title: 'Avaliação de transferência transfronteiriça',
            description: 'Deve ser realizada uma avaliação de impacto antes da transferência de dados pessoais para fora do Vietname.',
        },
        '9620ff08_b83c_4e1f_9350_eba835b145fe': {
            title: 'Registro de atividades de processamento',
            description: 'Os controladores de dados devem manter um Registro de Atividades de Processamento (RoPA) documentando todas as atividades de processamento.',
        },
        '96ee0ff3_3ead_431e_aa57_08ccff4821fc': {
            title: 'Registros de contrato de processamento de dados',
            description: 'Devem ser mantidos registros de acordos de processamento de dados com processadores e subprocessadores.',
        },
        '434dc319_1922_49e4_b757_37622135c4b2': {
            title: 'Salvaguardas de transferência transfronteiriça',
            description: 'As transferências de dados pessoais para fora do Vietname exigem salvaguardas adequadas e avaliações documentadas.',
        },
        '3372c651_d5a8_4cae_ae57_2fc684ad0768': {
            title: 'Confirmação em até 2 dias úteis',
            description: 'As solicitações do titular dos dados devem ser confirmadas no prazo de 2 dias úteis após o recebimento.',
        },
        b15fa62d_3f52_4e42_8442_f4969e08883a: {
            title: 'Conclusão em 15 dias úteis',
            description: 'As solicitações dos titulares dos dados devem ser concluídas no prazo de 15 dias úteis, com uma possível prorrogação de 5 dias úteis.',
        },
        '5d81233c_f671_4827_b874_827762edfc20': {
            title: 'Arquivamento do dossiê de avaliação de impacto do MoPS',
            description: 'As organizações que realizam tratamentos de alto risco devem apresentar um dossiê de avaliação de impacto ao Ministério da Segurança Pública, utilizando o procedimento administrativo prescrito.',
        },
        '83bf5bf8_edbd_4f0a_9f8e_5f47db01324d': {
            title: 'Arquivamento de dossiê de transferência transfronteiriça MoPS',
            description: 'As organizações que transferem dados pessoais para fora do Vietname devem apresentar um dossiê de avaliação do impacto da transferência transfronteiriça junto do Ministério da Segurança Pública.',
        },
        '9454e465_e618_4b6f_80b3_d79fdd9cc5cb': {
            title: 'Certificação de provedor de serviços de processamento',
            description: 'As organizações que prestam tratamento de dados pessoais como serviço devem obter um certificado de processamento de serviço do Ministério da Segurança Pública.',
        },
        b88aec34_046a_4e0a_9c77_ddad27ea4bc4: {
            title: 'Processamento do dossiê de avaliação de impacto quando os gatilhos são atendidos',
            description: 'Um dossiê de avaliação de impacto do processamento deve ser arquivado quando os gatilhos prescritos forem atendidos.',
        },
        '9d34a206_b85e_4649_a23b_e2c6f1398402': {
            title: 'Dossiê de impacto de transferência transfronteiriça',
            description: 'Um dossiê de impacto de transferência transfronteiriça deve ser preparado e arquivado para transferências internacionais de dados.',
        },
        '210d3ec3_e6f2_424b_ae25_cad76bc13320': {
            title: 'Designação do responsável pela proteção de dados',
            description: 'Um responsável pela proteção de dados deve ser designado conforme exigido pelo Decreto 13.',
        },
        '776183b2_2797_40e8_8d81_c4f512c566d2': {
            title: 'Artefatos de governança (políticas, funções, procedimentos)',
            description: 'Os artefactos de governação, incluindo políticas, funções e procedimentos, devem ser mantidos.',
        },
        '4f1385f1_6dfc_4368_b4af_1040cd3f77b7': {
            title: 'Completude do pacote de evidências e trilha de auditoria imutável',
            description: 'Os pacotes de evidências devem estar completos e uma trilha de auditoria imutável deve ser mantida.',
        },
        f6826e26_8991_4a0f_9117_481490230bdd: {
            title: 'Suporte ao fluxo de trabalho de arquivamento de casos',
            description: 'Os fluxos de trabalho de arquivamento de casos devem ser apoiados para avaliações de impacto e dossiês transfronteiriços.',
        },
        '8a28ee33_305a_491f_a93f_90e59f8da91b': {
            title: 'Requisitos contratuais do processador',
            description: 'Os requisitos contratuais para processadores de dados devem ser estabelecidos e monitorados.',
        },
        '4fd36e83_8286_40e0_b9b2_a4bc5e8377b3': {
            title: 'Revisão anual de conformidade',
            description: 'Uma revisão anual de conformidade deve ser realizada para verificar a adesão contínua.',
        },
        '8b6b6c13_0d32_4439_819f_4bd8cff02217': {
            title: 'Registros de submissão de arquivamento de autoridade',
            description: 'Registros de todas as submissões de pedidos de autoridade devem ser mantidos.',
        },
        e7ce6c23_03dc_42dd_bccd_fa571c3afee3: {
            title: 'Bases legais para processamento de dados pessoais',
            description: 'O processamento de dados pessoais deve ser baseado em bases legais, conforme definido pelo [[TOK_0]].',
        },
        c919c66c_6a74_4403_bb97_04b773d270bf: {
            title: 'Requisitos de consentimento para dados confidenciais',
            description: 'O processamento de dados pessoais sensíveis requer consentimento explícito com requisitos específicos.',
        },
        '419cc7c3_a257_4293_a054_304dc2fcb8df': {
            title: 'Direitos do titular dos dados (acesso, retificação, apagamento, restrição, oposição, portabilidade)',
            description: 'Os titulares dos dados têm direitos abrangentes, incluindo acesso, retificação, apagamento, restrição, oposição e portabilidade.',
        },
        '638e6e25_3a74_4864_8bff_8e21ab82860b': {
            title: 'Notificação de violação à autoridade',
            description: 'Os responsáveis ​​pelo tratamento de dados devem notificar a autoridade competente sobre violações de dados pessoais dentro do prazo prescrito.',
        },
        '6e75c111_66b1_4726_8c27_6537846edb30': {
            title: 'Notificação de violação aos titulares dos dados',
            description: 'Os controladores de dados devem notificar os titulares dos dados afetados sobre violações de dados pessoais.',
        },
        f686123d_3bdd_4a61_a53c_efe5b52d9058: {
            title: 'Avaliação de impacto na proteção de dados',
            description: 'Deve ser realizada uma avaliação de impacto na proteção de dados para atividades de tratamento de alto risco.',
        },
        '554ea5b6_092d_4295_a57a_1bd9b2eef291': {
            title: 'Governança de transferência transfronteiriça',
            description: 'As transferências transfronteiriças de dados pessoais devem cumprir os requisitos de governação.',
        },
        cf9a5b29_46fd_4072_b877_13b8a69df82c: {
            title: 'Designação do responsável pela proteção de dados',
            description: 'As organizações devem designar um responsável pela proteção de dados, conforme necessário.',
        },
        f5a4965d_eb0c_47df_9933_f185ae46463b: {
            title: 'Registros de atividades de processamento',
            description: 'As organizações devem manter registros de todas as atividades de processamento.',
        },
        ce8986ff_684d_41ec_8147_b3f2a1c5206c: {
            title: 'Obrigações contratuais do processador',
            description: 'As obrigações contratuais devem ser estabelecidas com os processadores de dados.',
        },
        '7a3d7554_7b6f_49d7_8864_4a5cd71fd6bd': {
            title: 'Arquivamento do dossiê de avaliação de impacto',
            description: 'Os dossiês de avaliação de impacto devem ser apresentados à autoridade competente conforme prescrito.',
        },
        '65dba62f_0788_44c1_89e3_09d802e28eb9': {
            title: 'Dossiê de impacto de transferência transfronteiriça',
            description: 'Um dossiê de impacto de transferência transfronteiriça deve ser preparado e arquivado para transferências internacionais de dados.',
        },
        '0eccb520_b1fa_4fa3_a3ab_2d30823dd00e': {
            title: '[[TOK_0]] compromisso e notificação',
            description: 'Deve ser nomeado um responsável pela proteção de dados e a autoridade notificada.',
        },
        '43ead19e_982a_4615_bafd_e6a3a4e80b3a': {
            title: 'Políticas e procedimentos de governança',
            description: 'As políticas e procedimentos de governação devem ser estabelecidos e mantidos.',
        },
        '9ebc7a42_e1f1_49c4_ac90_22a691fd2219': {
            title: 'Pacote de evidências e trilha de auditoria imutável',
            description: 'Os pacotes de evidências devem estar completos e uma trilha de auditoria imutável deve ser mantida.',
        },
        '5b0ba1c0_7b86_4c80_b9f9_26e4ff9652c2': {
            title: 'Ciclo de vida do arquivamento de casos',
            description: 'Os ciclos de vida de arquivamento de casos devem ser gerenciados através de etapas prescritas.',
        },
        '83f2f346_47bb_4377_a711_3cef26742f39': {
            title: 'Requisitos contratuais do processador',
            description: 'Os requisitos contratuais para processadores de dados devem ser estabelecidos e monitorados.',
        },
        cb972e06_f773_492e_8ad5_f65d1e999b79: {
            title: 'Certificação de provedor de processamento de serviços',
            description: 'As organizações que prestam serviços de processamento de dados devem obter certificação.',
        },
        '4ba36ab5_39f0_4d79_927e_c39587bed226': {
            title: 'Registros de submissão de arquivamento de autoridade',
            description: 'Registros de todas as submissões de pedidos de autoridade devem ser mantidos.',
        },
        f7a62c88_3cda_4031_bc52_1598661a5128: {
            title: 'Revisão anual de conformidade',
            description: 'Uma revisão anual de conformidade deve ser realizada para verificar a adesão contínua.',
        },
        '3e97f4d4_60ad_46a8_ad2b_615d4ca04aee': {
            title: 'Medidas técnicas de segurança de dados',
            description: 'Medidas técnicas para segurança de dados devem ser implementadas e mantidas.',
        },
        '45f4e745_a923_4879_94ce_5a2b41b7e886': {
            title: 'Decreto 356 requisitos oficiais do formulário Mẫu số',
            description: 'Os 13 formulários oficiais de procedimento administrativo Mẫu số (Mẫu số 01a–10) prescritos pelo Decreto [[TOK_0]]Đ-CP devem ser utilizados para os respectivos arquivamentos junto ao Ministério de Segurança Pública. Os itens do Phụ lục I – VIII são mapeamentos internos da estrutura de dados, não formulários regulatórios oficiais.',
        },
        ff452604_7461_4c12_aeab_cb7dd1fb5ba3: {
            title: '[[TOK_0]] envio de dossiê para A05',
            description: 'As organizações devem enviar dossiês [[TOK_0]] para A05/[[TOK_1]] para atividades de processamento que envolvam dados pessoais sensíveis ou processamento em grande escala.',
        },
        '003600ae_7a0f_4034_b206_72f59409b8f3': {
            title: 'Apresentação de dossiê de transferência transfronteiriça',
            description: 'As organizações devem enviar dossiês de transferência de dados transfronteiriços para revisão e aprovação A05/[[TOK_0]].',
        },
        '4632b20c_293a_4c7e_968e_4ce178c3b7d8': {
            title: 'Processando pedido de certificado de serviço',
            description: 'Os prestadores de serviços de processamento de dados devem solicitar certificados de A05/[[TOK_0]].',
        },
        be96add4_ebdb_4b6c_9426_4dc87b7cd2ce: {
            title: 'Notificação de tratamento de dados pessoais',
            description: 'Os controladores devem notificar A05/[[TOK_0]] sobre atividades de processamento de dados pessoais usando formulários prescritos (Mẫu số 01a/01b).',
        },
        '39f50471_27cc_46bd_acff_9aa2211d43ab': {
            title: 'Relatório anual de situação',
            description: 'Os responsáveis pelo tratamento devem apresentar relatórios anuais sobre a situação do tratamento de dados pessoais (Mẫu số 09).',
        },
        '3b45c6fa_d66a_448a_9ff1_597caa055e09': {
            title: 'Confidencialidade das informações do usuário por padrão',
            description: 'As informações do usuário devem ser tratadas como confidenciais por padrão.',
        },
        '2994510e_b1f8_4cdd_947c_d9542746433b': {
            title: 'Controles mínimos de proteção organizacional e técnica',
            description: 'Devem ser implementados controles mínimos de proteção organizacional e técnica.',
        },
        '8643160f_9a10_4d93_baf5_082c6a7c768a': {
            title: 'Divulgação apenas com base adequada',
            description: 'A divulgação de informações do usuário só é permitida com base legal adequada.',
        },
        c1fb7d85_fdc0_402e_ab0c_ff134bd72dfa: {
            title: 'Registro de divulgação obrigatória e auditabilidade',
            description: 'Todas as divulgações devem ser registradas e auditáveis.',
        },
        efa36bc0_abae_417a_b676_9509af37f89d: {
            title: 'Fluxo de trabalho de aprovação interna para divulgações',
            description: 'Um fluxo de trabalho de aprovação interno deve ser estabelecido para todas as divulgações.',
        },
        d086fdcd_9a23_4500_893c_db8ac62bd787: {
            title: 'Tratamento de resposta de solicitação de autoridade',
            description: 'As solicitações de autoridade devem ser tratadas e respondidas de acordo com os procedimentos prescritos.',
        },
    },
    framework_rights_descriptions: {
        be_informed: 'O titular dos dados tem o direito de ser informado sobre as atividades de tratamento de dados pessoais.',
        consent: 'O titular dos dados tem o direito de consentir no tratamento dos seus dados pessoais.',
        refuse_consent: 'O titular dos dados tem o direito de não consentir o tratamento dos seus dados pessoais.',
        withdraw_consent: 'O titular dos dados tem o direito de solicitar a retirada do consentimento previamente dado.',
        access: 'O titular dos dados tem o direito de visualizar e aceder aos seus dados pessoais na posse do responsável pelo tratamento.',
        rectification: 'O titular dos dados tem o direito de corrigir ou solicitar a correção dos dados pessoais inexatos.',
        data_provision: 'O titular dos dados tem o direito de solicitar o fornecimento dos seus dados pessoais (yêu cầu cung cấp dữ liệu cá nhân).',
        deletion: 'O titular dos dados tem o direito de solicitar a eliminação ou destruição dos dados pessoais, ressalvadas as exceções previstas na lei.',
        restriction_of_processing: 'O titular dos dados tem o direito de solicitar a limitação do tratamento dos seus dados pessoais.',
        object_to_processing: 'O titular dos dados tem o direito de enviar um pedido de oposição ao tratamento dos seus dados pessoais.',
        complaint: 'O titular dos dados tem o direito de apresentar reclamação (khiếu nại) relativamente ao tratamento de dados pessoais.',
        denunciation: 'O titular dos dados tem o direito de denunciar (tố cáo) relativamente a violações da proteção de dados pessoais.',
        lawsuit: 'O titular dos dados tem o direito de intentar uma ação judicial (khởi kiện) por violações dos seus direitos de proteção de dados.',
        claim_damages: 'O titular dos dados tem o direito de reclamar uma indemnização pelos danos causados por violações da proteção de dados pessoais.',
        request_protection_measures: 'O titular dos dados tem o direito de solicitar às autoridades competentes ou organizações/indivíduos relevantes que implementem medidas para proteger os seus dados pessoais.',
    },
    framework_procedures: {
        VN_DP_DRAFT_P7: {
            name: 'Gestão e monitoramento de riscos (rascunho)',
            steps: {
                '1': 'Identifique categorias de risco',
                '2': 'Mantenha controles de alerta precoce',
                '3': 'Revise os riscos de coleta, armazenamento, processamento, compartilhamento e transação',
                '4': 'Registre riscos de privacidade, segurança cibernética e gerenciamento de acesso',
                '5': 'Acionar ações de correção',
                '6': 'Preservar o histórico de avaliações',
            },
        },
        VN_DP_DRAFT_P6: {
            name: 'Reclamações e disputas (rascunho)',
            steps: {
                '1': 'Receber registro de reclamação/disputa',
                '2': 'Verifique a integridade das informações exigidas; solicitar suplemento dentro de 24 horas se estiver incompleto',
                '3': 'No prazo de 3 dias úteis após receber uma solicitação completa, notifique as partes sobre a abordagem de tratamento e o cronograma esperado',
                '4': 'Solicite respostas e documentos comprovativos',
                '5': 'Avalie os fatos da disputa e a responsabilidade da plataforma',
                '6': 'Resultado da resolução de registros',
                '7': 'Preservar evidências e encerrar caso',
            },
        },
        VN_DP_DRAFT_P5: {
            name: 'Entrega e certificado de direitos de propriedade sobre dados (minuta)',
            steps: {
                '1': 'Entregar produto/serviço de acordo com o método de contrato',
                '2': 'Registrar evento e horário de entrega',
                '3': 'Gerar certificado de direitos de propriedade sobre dados',
                '4': 'Registrar a conclusão da transação',
                '5': 'Habilite pesquisa/verificação posterior quando necessário',
            },
        },
        VN_DP_DRAFT_P4: {
            name: 'Iniciação e contratação de transação (rascunho)',
            steps: {
                '1': 'Revise a listagem e o resultado da avaliação',
                '2': 'Iniciar fluxo de trabalho de compra, negociação ou leilão',
                '3': 'Gerar contrato eletrônico',
                '4': 'Garanta a aceitação de ambas as partes',
                '5': 'Registrar a conclusão do pagamento',
                '6': 'Autorizar entrega',
            },
        },
        VN_DP_DRAFT_P3: {
            name: 'Acesso ao sandbox/ambiente de teste (rascunho)',
            steps: {
                '1': 'Enviar solicitação de sandbox',
                '2': 'Definir escopo, dados permitidos, período e permissões de processamento',
                '3': 'Provisionar ambiente técnico isolado',
                '4': 'Monitore a segurança e o acesso durante os testes',
                '5': 'Revise a saída antes da extração',
                '6': 'Aprovar a extração somente quando permitido',
                '7': 'Feche a sessão de teste e limpe o ambiente',
            },
        },
        VN_DP_DRAFT_P2: {
            name: 'Listagem de produtos/serviços de dados (rascunho)',
            steps: {
                '1': 'Criar aplicativo de listagem',
                '2': 'Capture evidências de origem e propriedade/direito de uso',
                '3': 'Registre características técnicas, formato, detalhes [[TOK_0]] e restrições',
                '4': 'Registrar divulgações de qualidade',
                '5': 'Enviar dossiê de listagem para análise da plataforma',
                '6': 'A plataforma realiza verificações de integridade, legalidade e técnicas',
                '7': 'Aprovar ou rejeitar listagem',
                '8': 'Se aprovado, publicar listagem com resultado da avaliação em anexo',
            },
        },
        VN_DP_DRAFT_P1: {
            name: 'Integração do participante (rascunho)',
            steps: {
                '1': 'Determine o tipo de participante: vendedor ou comprador',
                '2': 'Verifique o status legal e a capacidade legal',
                '3': 'Verifique as condições adicionais se linhas de negócios condicionais se aplicarem',
                '4': 'Registrar conta de transação',
                '5': 'Vincular conta de pagamento',
                '6': 'Aprovar participação na plataforma',
                '7': 'Armazene o registro do participante e a trilha de auditoria',
            },
        },
        AI_A1: {
            name: '[[TOK_0]] Registro / Notificação do Sistema',
            steps: {
                '1': 'Verificação de aplicabilidade e classificação do sistema [[TOK_0]]',
                '2': 'Construir dossiê de registro/notificação',
                '3': 'Aprovação interna',
                '4': 'Enviar via canal',
                '5': 'Ciclo de alteração – se retornado, atualize e reenvie',
                '6': 'Fechar e armazenar confirmação',
            },
        },
        AI_A2: {
            name: '[[TOK_0]] Fluxo de trabalho de classificação de risco',
            steps: {
                '1': 'Criar entrada de registro do sistema [[TOK_0]]',
                '2': 'Executar assistente de classificação',
                '3': 'Anexar evidências',
                '4': 'Aprovar classificação',
                '5': 'Vincular resultados ao dossiê do sistema',
            },
        },
        AI_A3: {
            name: 'Conformidade com Rotulagem e Divulgação',
            steps: {
                '1': 'Identifique as obrigações de rotulagem por sistema e caso de uso',
                '2': 'Implementar avisos de rotulagem',
                '3': 'Capture evidências – capturas de tela, cópia da IU, metadados técnicos',
                '4': 'Lidar com isenções e registrar justificativa',
                '5': 'Aprovar e versão',
            },
        },
        AI_A4: {
            name: 'Relatório de incidentes graves',
            steps: {
                '1': 'Criar registro de incidente [[TOK_0]]',
                '2': 'Classificar gravidade',
                '3': 'Executar ações de contenção e captura de evidências',
                '4': 'Gerar exportação de modelo de relatório de incidentes graves',
                '5': 'Enviar à autoridade por meio do canal',
                '6': 'Rastreie as respostas e o fechamento da autoridade',
            },
        },
        AI_A5: {
            name: '[[TOK_0]] Avaliação de impacto',
            steps: {
                '1': 'Criar registro de avaliação',
                '2': 'Preencher as seções obrigatórias',
                '3': 'Anexe evidências – fluxos de dados, documentação de modelo, controles',
                '4': 'Aprovação interna',
                '5': 'Exportar relatório e armazenar em dossiê',
            },
        },
        AI_A6: {
            name: 'Testes Controlados/Participação em Sandbox',
            steps: {
                '1': 'Registro completo de elegibilidade e prontidão',
                '2': 'Preparar aplicação e exportar',
                '3': 'Enviar via canal',
                '4': 'Rastrear aprovação',
                '5': 'Execute pontos de verificação e registros de monitoramento',
                '6': 'Relatório de conclusão completo e pacote de encerramento',
            },
        },
        CYBERSEC_C1: {
            name: 'Avaliação Crítica da Segurança do Sistema de Informação',
            steps: {
                '1': 'Classificar os sistemas de informação de acordo com os requisitos nacionais de cibersegurança',
                '2': 'Realizar avaliação de segurança e avaliação de risco para sistemas classificados',
                '3': 'Implementar medidas de segurança necessárias e controles de linha de base',
                '4': 'Documente evidências de conformidade e programe revisões periódicas',
            },
        },
        CYBERSEC_C2: {
            name: 'Notificação de incidentes de segurança cibernética',
            steps: {
                '1': 'Detecte, classifique e avalie o incidente de segurança cibernética',
                '2': 'Executar ações de resposta imediata e preservação de evidências',
                '3': 'Reportar à autoridade e participar na coordenação nacional de resposta a incidentes',
                '4': 'Conduza a revisão pós-incidente e documente as lições aprendidas',
            },
        },
        CYBERSEC_C3: {
            name: 'Verificação de conformidade de localização de dados',
            steps: {
                '1': 'Avalie se os gatilhos de localização de dados se aplicam com base no tipo de serviço e nas categorias de dados',
                '2': 'Verifique se a arquitetura de armazenamento local e os controles de fluxo transfronteiriços estão em vigor',
                '3': 'Avaliar os requisitos de presença local (filial/escritório de representação) quando aplicável',
                '4': 'Documentar evidências de conformidade e mantê-las para análise da autoridade',
            },
        },
        CYBERSEC_C4: {
            name: 'Resposta à solicitação de cooperação da autoridade',
            steps: {
                '1': 'Receber e verificar a legitimidade e o escopo da solicitação de autoridade',
                '2': 'Reunir e preparar as informações solicitadas ou executar as ações necessárias',
                '3': 'Enviar resposta à autoridade dentro do prazo exigido',
                '4': 'Registre a divulgação e feche o caso',
            },
        },
        CYBERSEC_C5: {
            name: 'Verificação de qualificação de pessoal de segurança cibernética',
            steps: {
                '1': 'Avalie a postura de segurança do fornecedor usando a estrutura de avaliação de segurança cibernética',
                '2': 'Verifique o escopo de acesso aos dados do fornecedor e registre-se no log de acesso aos dados do fornecedor',
                '3': 'Revise a cláusula de notificação de incidentes do fornecedor e os requisitos contratuais de segurança cibernética',
                '4': 'Agende revisões periódicas de segurança do fornecedor e monitore a conformidade',
            },
        },
        DATA_D1: {
            name: 'Inventário de dados e configuração de classificação',
            steps: {
                '1': 'Catalogar todos os ativos de dados com tipos e fontes no registro de inventário de dados',
                '2': 'Classifique cada ativo por nível de sensibilidade',
                '3': 'Definir regras de tratamento por nível de classificação',
                '4': 'Capture evidências — capturas de tela, diagramas de arquitetura, controles de acesso',
                '5': 'Agende revisões periódicas',
            },
        },
        DATA_D2: {
            name: 'Governança de Compartilhamento de Dados',
            steps: {
                '1': 'Avaliar novos acordos de partilha através da avaliação de risco de partilha de dados',
                '2': 'Fluxo de trabalho de aprovação interno completo',
                '3': 'Registrar evento de compartilhamento no log de compartilhamento/divulgação de dados',
                '4': 'Capture evidências – registros de aprovação, documentos contratuais',
                '5': 'Revisão periódica dos acordos de partilha',
            },
        },
        DATA_D3: {
            name: 'Avaliação de transferência de dados transfronteiriça',
            steps: {
                '1': 'Identifique transferências transfronteiriças no inventário de dados',
                '2': 'Realizar avaliação de risco de transferência',
                '3': 'Aplicar salvaguardas e medidas de governança',
                '4': 'Documento na secção transfronteiriça do atestado de governação',
                '5': 'Exportar pacote de avaliação para auditoria',
            },
        },
        DATA_D4: {
            name: 'Atestado Anual de Governança',
            steps: {
                '1': 'Rever a matriz RACI de governação',
                '2': 'Verifique o status da política (governança, classificação, compartilhamento, retenção)',
                '3': 'Pacote completo de atestados',
                '4': 'Obtenha aprovação interna',
                '5': 'Atestado de exportação e arquivo',
            },
        },
        DATA_D5: {
            name: 'Tratamento de incidentes de dados',
            steps: {
                '1': 'Classifique o incidente usando registro de decisão',
                '2': 'Execute a resposta a incidentes de acordo com o manual',
                '3': 'Capture evidências – registros, capturas de tela, comunicações',
                '4': 'Realizar revisão pós-incidente',
                '5': 'Se a notificação da autoridade for necessária: crie um caso de envio e envie para [[TOK_0]]',
                '6': 'Fechar e arquivar',
            },
        },
        ECOM_P1: {
            name: 'Notificação (site/aplicativo de vendas)',
            steps: {
                '1': 'Determine a classificação: site/aplicativo de vendas vs mercado/plataforma de serviço',
                '2': 'Crie um registro de dossiê interno com a identidade da empresa, informações do site/aplicativo e divulgações necessárias',
                '3': 'Gere pacote de evidências — capturas de tela de divulgações, URLs de políticas, histórico de versões',
                '4': 'Enviar via Online.gov.vn – fazer upload de documentos, registrar carimbo de data/hora e confirmação',
                '5': 'Rastrear o processamento - se for devolvido para alteração, registre os motivos e reenvie',
                '6': 'Fechar – confirmação da loja, evidência de link e trilha de auditoria',
            },
        },
        ECOM_P2: {
            name: 'Cadastro (Plataformas de Serviços/Marketplaces)',
            steps: {
                '1': 'Determine o modelo e as obrigações da plataforma – mercado versus comércio misto versus comércio social',
                '2': 'Construir dossiê de registro — formulário de inscrição, esquema de prestação de serviços, T&Cs, regras da plataforma',
                '3': 'Aprovações internas — atribuir proprietário legal/de conformidade, aprovar para envio',
                '4': 'Enviar via Online.gov.vn – carregar dossiê, registrar carimbo de data/hora',
                '5': 'Ciclo de processamento — se for devolvido para alteração, atualize e reenvie',
                '6': 'Aprovação e operacionalização — armazene a confirmação, mantenha registros de conformidade contínuos',
            },
        },
        ECOM_P3: {
            name: 'Notificação de atualização/alteração',
            steps: {
                '1': 'Identificar o gatilho da mudança – alteração material nos itens do dossiê',
                '2': 'Gerar pacote de mudanças — resumo de mudanças, documentos atualizados, atualizações de evidências',
                '3': 'Enviar atualização e registrar o status de envio',
                '4': 'Rastreie o processamento e feche',
            },
        },
        ECOM_P4: {
            name: 'Rescisão/Desativação',
            steps: {
                '1': 'Preparar pacote de rescisão – data de cessação, motivo, plano de tratamento de proteção ao consumidor, prova de aviso público',
                '2': 'Enviar rescisão – registrar carimbo de data/hora e confirmação',
                '3': 'Fechar – armazena o status final e as evidências',
            },
        },
        ECOM_P5: {
            name: 'Programa de classificação de selo de confiança/credibilidade',
            steps: {
                '1': 'Revisão de elegibilidade e prontidão',
                '2': 'Preparar dossiê usando formulário oficial',
                '3': 'Enviar e acompanhar',
                '4': 'Mantenha evidências de conformidade contínuas',
            },
        },
        PDPL_P1: {
            name: '[[TOK_0]] Envio de arquivamento para [[TOK_1]]',
            steps: {
                '1': 'Preencher [[TOK_0]] usando o formulário do Decreto 356 (Mẫu số 02a/02b)',
                '2': 'Reunir documentos de cobertura e evidências de apoio',
                '3': 'Envie um dossiê original ao Ministério de Segurança Pública ([[TOK_0]])',
                '4': 'Monitore solicitações de suplementos de [[TOK_0]] e responda dentro do prazo',
                '5': 'Reter dossiê e evidência de envio para trilha de auditoria',
            },
        },
        PDPL_P2: {
            name: 'Pedido de transferência transfronteiriça',
            steps: {
                '1': 'Preencher o dossiê de transferência transfronteiriça usando os formulários do Decreto 356 (Mẫu số 01a/01b, Mẫu số 09)',
                '2': 'Envie um dossiê original para [[TOK_0]] dentro de 60 dias do início do processamento',
                '3': 'Notificar [[TOK_0]] após transferência bem-sucedida com detalhes de contato da parte receptora',
                '4': 'Responder às solicitações de complemento/correção/inspeção de [[TOK_0]] dentro do prazo',
            },
        },
        PDPL_P3: {
            name: 'Solicitação de certificado de serviço de processamento de dados',
            steps: {
                '1': 'Preparar dossiê de solicitação de certificação de acordo com os requisitos do Decreto 356',
                '2': 'Envie a inscrição para [[TOK_0]] com os documentos comprovativos necessários',
                '3': 'Responda a [[TOK_0]] comentários de revisão e solicitações de suplementos',
                '4': 'Manter certificado e cronograma de renovação',
            },
        },
        PDPL_P4: {
            name: 'Processamento de solicitação de direitos do titular dos dados',
            steps: {
                '1': 'Receber e registrar solicitação; verificar a identidade do titular dos dados no prazo de 2 dias úteis',
                '2': 'Avalie o tipo de solicitação e determine o prazo aplicável (15/10/20 dias por tipo)',
                '3': 'Execute ações de atendimento em sistemas e departamentos relevantes',
                '4': 'Preparar e enviar resposta ao titular dos dados com resultado e justificativa',
                '5': 'Encerrar o caso e reter evidências para auditoria; documentar qualquer justificativa de recusa',
            },
        },
        PDPL_P5: {
            name: 'Notificação de violação para [[TOK_0]]',
            steps: {
                '1': 'Detectar e avaliar a violação; determinar a obrigação de notificação no prazo de 2 dias úteis',
                '2': 'Preparar pacote de notificação de acordo com os requisitos [[TOK_0]]',
                '3': 'Enviar notificação para [[TOK_0]] dentro de dois dias úteis após a descoberta',
                '4': 'Responder a [[TOK_0]] solicitações de acompanhamento; enviar suplementos e evidências de coordenação',
            },
        },
        TELECOM_T1: {
            name: 'Tratamento de solicitação de autoridade',
            steps: {
                '1': 'Receber e registrar a solicitação de autoridade por meio do registro de entrada',
                '2': 'Verifique a identidade da autoridade, a base jurídica e o escopo da solicitação',
                '3': 'Realizar revisão jurídica interna e obter aprovação da administração',
                '4': 'Preparar pacote de resposta com evidências reunidas',
                '5': 'Esboçar e aprovar carta de resposta',
                '6': 'Crie um caso de envio e envie a resposta por meio do canal',
                '7': 'Divulgação de log e reconhecimento de autoridade de rastreamento',
                '8': 'Encerrar o caso e reter evidências para trilha de auditoria',
            },
        },
        TELECOM_T2: {
            name: 'Gestão de Divulgação',
            steps: {
                '1': 'Receber solicitação de divulgação (consentimento do usuário, obrigação legal ou solicitação de autoridade)',
                '2': 'Fluxo de trabalho completo de aprovação de divulgação',
                '3': 'Executar divulgação e registrar no registro de log',
                '4': 'Capture evidências – registros de aprovação, registros de comunicação',
                '5': 'Revisão periódica do registro de divulgação',
            },
        },
        TELECOM_T3: {
            name: 'Política de confidencialidade e configuração de controle de acesso',
            steps: {
                '1': 'Elaborar e aprovar política de confidencialidade',
                '2': 'Elaborar e aprovar política de controle de acesso e registro',
                '3': 'Atividades de processamento de documentos no registro de processamento de informações do usuário',
                '4': 'Capturar evidências – documentos políticos, evidências de implementação',
                '5': 'Agende revisões periódicas',
            },
        },
        TELECOM_T4: {
            name: 'Avaliação de incidentes de telecomunicações',
            steps: {
                '1': 'Classifique e avalie o incidente',
                '2': 'Determinar os requisitos de notificação',
                '3': 'Se a notificação da autoridade for necessária: crie um caso de envio',
                '4': 'Capturar e preservar evidências',
                '5': 'Resolução e encerramento',
            },
        },
        TELECOM_T5: {
            name: 'Gerenciamento de retenção e exclusão',
            steps: {
                '1': 'Definir cronograma de retenção e exclusão por categoria de dados',
                '2': 'Implementar procedimentos de exclusão',
                '3': 'Capturar evidências – exclusão de registros',
                '4': 'Revisão periódica de cronogramas',
            },
        },
    },
    framework_fines: {
        VN_CYBERSEC_LAW: {
            'CYBERSEC-FINE-A': 'Tratamento de incidentes e relatórios de falhas',
            'CYBERSEC-FINE-B': 'Monitoramento de segurança do sistema e falhas de controle de linha de base',
            'CYBERSEC-FINE-C': 'Falhas de cooperação na solicitação de autoridade',
            'CYBERSEC-FINE-D': 'Localização de dados e violações de presença local',
            'CYBERSEC-FINE-E': 'Prevenção de malware e falhas de proteção do sistema',
            'CYBERSEC-FINE-F': 'Falhas de resposta da plataforma/provedor de serviços',
            'CYBERSEC-FINE-G': 'Falhas de segurança de fornecedores/terceiros',
        },
        VN_ECOMMERCE_LAW_2025: {
            'ECOM-FINE-A': 'Registro/Notificação/Prontidão Administrativa',
            'ECOM-FINE-B': 'Reclamações e Defesa do Consumidor',
            'ECOM-FINE-C': 'Monitoramento e aplicação de remoções',
            'ECOM-FINE-D': 'Operações Transfronteiriças',
            'ECOM-FINE-E': 'Regras e transparência da plataforma',
        },
        VN_PDPL: {
            'PDPL-FINE-A': 'Falha na conduta [[TOK_0]]',
            'PDPL-FINE-B': 'Transferência transfronteiriça não autorizada',
            'PDPL-FINE-C': 'Processamento sem base legal',
            'PDPL-FINE-D': 'Falha em responder ao DSR',
            'PDPL-FINE-E': 'Falha ao notificar violação de dados',
            'PDPL-FINE-F': 'Contrato de processamento não conforme',
            'PDPL-FINE-G': 'Violações de processamento de dados confidenciais',
            'PDPL-FINE-H': 'Violações de processamento de dados infantis',
            'PDPL-FINE-I': 'Violações de tomada de decisão automatizada',
            'PDPL-FINE-J': 'Não conformidade com ordens de autoridade',
        },
        VN_TELECOM_LAW_2023: {
            'TELECOM-FINE-A': 'Falhas no tratamento de solicitações de autoridade',
            'TELECOM-FINE-B': 'Confidencialidade e divulgação não autorizada',
            'TELECOM-FINE-C': 'Controle de acesso e falhas de registro',
            'TELECOM-FINE-D': 'Violações de retenção e exclusão',
            'TELECOM-FINE-E': 'Falhas na avaliação de incidentes de telecomunicações',
        },
    },
    framework_fines_detail: {
        VN_TELECOM_LAW_2023: {
            'TELECOM-FINE-E': {
                fine_individual: 'Até 100 milhões de VND',
                fine_org: 'Até 200 milhões de VND',
                deadlines: 'Imediatamente após a detecção',
            },
            'TELECOM-FINE-D': {
                fine_individual: 'Até 100 milhões de VND',
                fine_org: 'Até 200 milhões de VND',
                deadlines: 'Obrigação contínua',
            },
            'TELECOM-FINE-C': {
                fine_individual: 'Até 100 milhões de VND',
                fine_org: 'Até 200 milhões de VND',
                deadlines: 'Obrigação contínua',
            },
            'TELECOM-FINE-B': {
                fine_individual: 'Até 100 milhões de VND',
                fine_org: 'Até 200 milhões de VND',
                deadlines: 'Obrigação contínua',
            },
            'TELECOM-FINE-A': {
                fine_individual: 'Até 100 milhões de VND',
                fine_org: 'Até 200 milhões de VND',
                deadlines: 'Conforme especificado na solicitação de autoridade',
            },
        },
        VN_ECOMMERCE_LAW_2025: {
            'ECOM-FINE-E': {
                fine_individual: 'Até 80 milhões de VND',
                fine_org: 'Até 160 milhões de VND',
                deadlines: 'Obrigação contínua',
            },
            'ECOM-FINE-D': {
                fine_individual: 'Até 80 milhões de VND',
                fine_org: 'Até 160 milhões de VND',
                deadlines: 'Obrigação contínua',
            },
            'ECOM-FINE-C': {
                fine_individual: 'Até 80 milhões de VND',
                fine_org: 'Até 160 milhões de VND',
                deadlines: 'Obrigação contínua',
            },
            'ECOM-FINE-B': {
                fine_individual: 'Até 80 milhões de VND',
                fine_org: 'Até 160 milhões de VND',
                deadlines: 'Conforme especificado pelas obrigações de tratamento de reclamações',
            },
            'ECOM-FINE-A': {
                fine_individual: 'Até 80 milhões de VND',
                fine_org: 'Até 160 milhões de VND',
                deadlines: 'Antes de iniciar as operações de comércio eletrônico',
            },
        },
        VN_CYBERSEC_LAW: {
            'CYBERSEC-FINE-G': {
                fine_individual: 'Até 100 milhões de VND',
                fine_org: 'Até 200 milhões de VND',
                deadlines: 'Obrigação contínua',
            },
            'CYBERSEC-FINE-F': {
                fine_individual: 'Até 100 milhões de VND',
                fine_org: 'Até 200 milhões de VND',
                deadlines: 'Conforme especificado na solicitação de autoridade',
            },
            'CYBERSEC-FINE-E': {
                fine_individual: 'Até 100 milhões de VND',
                fine_org: 'Até 200 milhões de VND',
                deadlines: 'Obrigação contínua',
            },
            'CYBERSEC-FINE-D': {
                fine_individual: 'Até 100 milhões de VND',
                fine_org: 'Até 200 milhões de VND',
                deadlines: 'Conforme especificado na decisão da autoridade; obrigação contínua quando acionada',
            },
            'CYBERSEC-FINE-C': {
                fine_individual: 'Até 100 milhões de VND',
                fine_org: 'Até 200 milhões de VND',
                deadlines: 'Conforme especificado na solicitação de autoridade',
            },
            'CYBERSEC-FINE-B': {
                fine_individual: 'Até 100 milhões de VND',
                fine_org: 'Até 200 milhões de VND',
                deadlines: 'Obrigação contínua; os controles devem estar em vigor antes da operação do sistema',
            },
            'CYBERSEC-FINE-A': {
                fine_individual: 'Até 100 milhões de VND',
                fine_org: 'Até 200 milhões de VND',
                deadlines: 'É necessária resposta imediata; relatórios dentro do prazo prescrito',
            },
        },
        VN_PDPL: {
            'PDPL-FINE-A': {
                fine_individual: 'Até 1,5 bilhão de VND',
                fine_org: 'Até 3 bilhões de VND',
                deadlines: '60 dias a partir do início do processamento para enviar o dossiê para [[TOK_0]]',
            },
            'PDPL-FINE-B': {
                fine_individual: 'Até 1,5 bilhão de VND',
                fine_org: 'Até 3 bilhões de VND',
                revenue: '3%–5% da receita do Vietnã do ano anterior em casos graves',
                deadlines: '60 dias a partir do início do processamento para envio do dossiê ao [[TOK_0]]; notificação pós-transferência necessária',
            },
            'PDPL-FINE-C': {
                fine_individual: 'Até 1,5 bilhão de VND',
                fine_org: 'Até 3 bilhões de VND',
                deadlines: 'Obrigação contínua; o consentimento deve ser obtido antes do processamento',
            },
            'PDPL-FINE-D': {
                fine_individual: 'Até 1,5 bilhão de VND',
                fine_org: 'Até 3 bilhões de VND',
                deadlines: '2 dias úteis para resposta processual; 10 dias de acesso/correção; 15 dias de retirada/restrição/objeção; 20 dias de exclusão',
            },
            'PDPL-FINE-E': {
                fine_individual: 'Até 1,5 bilhão de VND',
                fine_org: 'Até 3 bilhões de VND',
                deadlines: '2 dias úteis para notificar [[TOK_0]] após descobrir uma violação',
            },
            'PDPL-FINE-F': {
                fine_individual: 'Até 1,5 bilhão de VND',
                fine_org: 'Até 3 bilhões de VND',
                deadlines: 'Obrigação contínua',
            },
            'PDPL-FINE-G': {
                fine_individual: 'Até 1,5 bilhão de VND',
                fine_org: 'Até 3 bilhões de VND',
                deadlines: 'Obrigação contínua; controles devem estar em vigor antes de processar dados confidenciais',
            },
            'PDPL-FINE-H': {
                fine_individual: 'Até 1,5 bilhão de VND',
                fine_org: 'Até 3 bilhões de VND',
                deadlines: 'Obrigação contínua; consentimento dos pais necessário antes do processamento',
            },
            'PDPL-FINE-I': {
                fine_individual: 'Até 1,5 bilhão de VND',
                fine_org: 'Até 3 bilhões de VND',
                deadlines: 'Obrigação contínua',
            },
            'PDPL-FINE-J': {
                fine_individual: 'Até 1,5 bilhão de VND',
                fine_org: 'Até 3 bilhões de VND',
                revenue: 'Até 5% da receita do Vietnã do ano anterior para violações repetidas',
                deadlines: 'Conforme especificado na ordem de autoridade',
            },
        },
    },
    framework_procedures_detail: {
        VN_DP_DRAFT_P7: {
            trigger: 'Operação contínua da plataforma',
            responsible: {
                '1': 'Operador de Plataforma / Risco',
                '2': 'Operador de Plataforma / Segurança',
                '3': 'Operador de Plataforma / Risco',
                '4': 'Operador de Plataforma / Segurança',
                '5': 'Operador de Plataforma',
                '6': 'Conformidade',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P6: {
            trigger: 'Um participante envia uma solicitação de reclamação ou disputa',
            responsible: {
                '1': 'Operador de Plataforma',
                '2': 'Operador de Plataforma',
                '3': 'Operador de Plataforma',
                '4': 'Operador de Plataforma',
                '5': 'Operador de Plataforma / Jurídico',
                '6': 'Operador de Plataforma',
                '7': 'Conformidade',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P5: {
            trigger: 'A entrega é concluída após o cumprimento do contrato e das condições de pagamento',
            responsible: {
                '1': 'Vendedor / Operador de Plataforma',
                '2': 'Operador de Plataforma',
                '3': 'Operador de Plataforma',
                '4': 'Operador de Plataforma',
                '5': 'Operador de Plataforma',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P4: {
            trigger: 'Um comprador inicia uma transação de dados, produto ou serviço',
            responsible: {
                '1': 'Comprador',
                '2': 'Comprador/Operador de Plataforma',
                '3': 'Operador de Plataforma',
                '4': 'Comprador/Vendedor',
                '5': 'Operador de Plataforma / Pagamento',
                '6': 'Operador de Plataforma',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P3: {
            trigger: 'Um participante deseja avaliar produtos/serviços de dados no ambiente isolado',
            responsible: {
                '1': 'Participante',
                '2': 'Operador/Participante da Plataforma',
                '3': 'Operador de Plataforma / TI',
                '4': 'Operador de Plataforma / Segurança',
                '5': 'Operador de Plataforma',
                '6': 'Operador de Plataforma',
                '7': 'Operador de Plataforma / TI',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P2: {
            trigger: 'Um vendedor busca listar dados, produtos ou serviços de dados para negociação',
            responsible: {
                '1': 'Vendedor',
                '2': 'Vendedor / Jurídico',
                '3': 'Vendedor / TI',
                '4': 'Vendedor',
                '5': 'Vendedor',
                '6': 'Operador de Plataforma',
                '7': 'Operador de Plataforma',
                '8': 'Operador de Plataforma',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P1: {
            trigger: 'Um vendedor ou comprador ingressa na plataforma de dados',
            responsible: {
                '1': 'Operador de Plataforma',
                '2': 'Operador de Plataforma / Jurídico',
                '3': 'Operador de Plataforma / Jurídico',
                '4': 'Operador de Plataforma',
                '5': 'Operador de Plataforma',
                '6': 'Operador de Plataforma',
                '7': 'Conformidade',
            },
            step_outputs: {},
        },
        PDPL_P1: {
            trigger: 'Início do tratamento de dados pessoais que exige avaliação de impacto',
            responsible: {
                '1': '[[TOK_0]] / Equipe de privacidade',
                '2': 'Equipe de privacidade',
                '3': 'Jurídico/Conformidade',
                '4': '[[TOK_0]] / Equipe de privacidade',
                '5': 'Equipe de Conformidade',
            },
            step_outputs: {},
        },
        PDPL_P2: {
            trigger: 'Intenção de transferir dados pessoais para fora do Vietname',
            responsible: {
                '1': '[[TOK_0]] / Equipe de privacidade',
                '2': 'Jurídico/Conformidade',
                '3': 'Jurídico/Conformidade',
                '4': '[[TOK_0]] / Equipe de privacidade',
            },
            step_outputs: {},
        },
        PDPL_P3: {
            trigger: 'Organização que fornece serviços de processamento de dados que exigem certificação',
            responsible: {
                '1': 'Jurídico/Conformidade',
                '2': 'Jurídico/Conformidade',
                '3': '[[TOK_0]] / Equipe de privacidade',
                '4': 'Equipe de Conformidade',
            },
            step_outputs: {},
        },
        PDPL_P4: {
            trigger: 'Recebimento de uma solicitação de direitos do titular dos dados',
            responsible: {
                '1': 'Equipe de Privacidade / Atendimento ao Cliente',
                '2': '[[TOK_0]] / Equipe de privacidade',
                '3': 'Líderes de Departamento / TI',
                '4': '[[TOK_0]] / Equipe de privacidade',
                '5': 'Equipe de Conformidade',
            },
            step_outputs: {},
        },
        PDPL_P5: {
            trigger: 'Descoberta de uma violação ou violação da proteção de dados pessoais',
            responsible: {
                '1': 'Equipe de resposta a incidentes / [[TOK_0]]',
                '2': '[[TOK_0]] / Equipe de privacidade',
                '3': 'Jurídico/Conformidade',
                '4': '[[TOK_0]] / Equipe de resposta a incidentes',
            },
            step_outputs: {},
        },
    },
    framework_deadline_references: {
        'PDPL Art. 9': '[[TOK_0]] Art. 9',
        'PDPL Art. 17': '[[TOK_0]] Art. 17',
        'PDPL Art. 23': '[[TOK_0]] Art. 23',
        'Decree 13 Art. 24': 'Decreto 13 Art. 24',
        'MoPS Admin Procedures': 'Procedimentos administrativos do MoPS',
        'Annual cycle': 'Ciclo anual',
        'Decree 13/2023/NĐ-CP Art. 24': 'Decreto [[TOK_0]]Đ-CP Art. 24',
        'Decree 356/2025/NĐ-CP Art. 25(4)': 'Decreto [[TOK_0]]Đ-CP Art. 25(4)',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 2': 'Decreto [[TOK_0]]Đ-CP Art. 5 cl. 2',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 2–5': 'Decreto [[TOK_0]]Đ-CP Art. 5 cl. 2–5',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 3': 'Decreto [[TOK_0]]Đ-CP Art. 5 cl. 3',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 4': 'Decreto [[TOK_0]]Đ-CP Art. 5 cl. 4',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 5': 'Decreto [[TOK_0]]Đ-CP Art. 5 cl. 5',
        'Decree 356/2025/NĐ-CP Art. 8(3)': 'Decreto [[TOK_0]]Đ-CP Art. 8(3)',
        'Draft Decree on Data Platforms 2026': 'Projeto de Decreto sobre Plataformas de Dados 2026',
        'Law 122/2025/QH15 Ch. III; NĐ 98/2020; NĐ 24/2025': 'Lei [[TOK_0]] Cap. III; NĐ 98/2020; NA 24/2025',
        'Law 122/2025/QH15 Ch. IV (Consumer Protection)': 'Lei [[TOK_0]] Cap. IV (Defesa do Consumidor)',
        'Law 122/2025/QH15 — Online.gov.vn operational procedure': 'Lei [[TOK_0]] - Procedimento operacional Online.gov.vn',
        'Law 134/2025/QH15 Article 12': 'Lei [[TOK_0]] Artigo 12',
        'Law 134/2025/QH15 Article 21': 'Lei [[TOK_0]] Artigo 21',
        'Law 134/2025/QH15 Article 27': 'Lei [[TOK_0]] Artigo 27',
        'Law 134/2025/QH15 Articles 9–10': 'Lei [[TOK_0]] Artigos 9–10',
        'Law 24/2023/QH15 — article mapping pending': 'Lei [[TOK_0]] — mapeamento de artigo pendente',
        'Law 60/2024/QH15 (internal control target)': 'Lei [[TOK_0]] (alvo de controle interno)',
        'Law 91/2025/QH15 Art. 21': 'Lei [[TOK_0]] Art. 21',
        'Law 91/2025/QH15 Art. 23': 'Lei [[TOK_0]] Art. 23',
        'Policy-defined': 'Definido por política',
        Quarterly: 'Trimestralmente',
        'QĐ 778/QĐ-BCA-A05 administrative procedure': 'QĐ 778/QĐ-BCA-A05 procedimento administrativo',
        'internal control target (Law 116/2025/QH15 Art. 24(2)(b), 41(5) — exact timeline pending implementing instrument)': 'meta de controle interno (Lei [[TOK_0]] Art. 24(2)(b), 41(5) — cronograma exato pendente de instrumento de implementação)',
        'internal control target (Law 116/2025/QH15 Art. 41(3) — exact timeline pending implementing instrument)': 'meta de controle interno (Lei [[TOK_0]] Art. 41 (3) - cronograma exato pendente de instrumento de implementação)',
        'source verification pending': 'verificação de origem pendente',
        'Circular 83/2025/TT-NHNN — Ad-hoc Internal Audit Reporting to SBV (Layer 5)': 'Circular 83/2025/TT-NHNN — Ad-hoc Internal Audit Reporting to SBV (Layer 5) [PT]',
        'Circular 83/2025/TT-NHNN — Annual ICAAP Report (Phụ lục III) (Layer 5)': 'Circular 83/2025/TT-NHNN — Annual ICAAP Report (Phụ lục III) (Layer 5) [PT]',
        'Circular 83/2025/TT-NHNN — Annual Phụ lục I (Layer 5)': 'Circular 83/2025/TT-NHNN — Annual Phụ lục I (Layer 5) [PT]',
        'Circular 83/2025/TT-NHNN — Annual Phụ lục IV (Layer 5)': 'Circular 83/2025/TT-NHNN — Annual Phụ lục IV (Layer 5) [PT]',
        'Circular 83/2025/TT-NHNN — Annual Risk Management Report (Phụ lục II) (Layer 5)': 'Circular 83/2025/TT-NHNN — Annual Risk Management Report (Phụ lục II) (Layer 5) [PT]',
        'Circular 83/2025/TT-NHNN — Asset Management Responsibility (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Asset Management Responsibility (Layer 2, theme C) [PT]',
        "Circular 83/2025/TT-NHNN — Board / Members' Council Oversight (Layer 2, theme A)": "Circular 83/2025/TT-NHNN — Board / Members' Council Oversight (Layer 2, theme A) [PT]",
        'Circular 83/2025/TT-NHNN — Board Committees (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Board Committees (Layer 2, theme A) [PT]',
        'Circular 83/2025/TT-NHNN — Board Decisions and Minutes (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Board Decisions and Minutes (Layer 2, theme A) [PT]',
        'Circular 83/2025/TT-NHNN — Branch Control Procedures (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Branch Control Procedures (Layer 2, theme C) [PT]',
        'Circular 83/2025/TT-NHNN — Compliance Assessment of Internal Rules (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Compliance Assessment of Internal Rules (Layer 2, theme D) [PT]',
        'Circular 83/2025/TT-NHNN — Compliance Function (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Compliance Function (Layer 2, theme D) [PT]',
        'Circular 83/2025/TT-NHNN — Compliance Remediation Monitoring (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Compliance Remediation Monitoring (Layer 2, theme D) [PT]',
        'Circular 83/2025/TT-NHNN — Concentration Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Concentration Risk (Layer 3, theme E) [PT]',
        'Circular 83/2025/TT-NHNN — Conflict of Interest (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Conflict of Interest (Layer 2, theme C) [PT]',
        'Circular 83/2025/TT-NHNN — Control Culture (Layer 2, theme A/B)': 'Circular 83/2025/TT-NHNN — Control Culture (Layer 2, theme A/B) [PT]',
        'Circular 83/2025/TT-NHNN — Credit Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Credit Risk (Layer 3, theme E) [PT]',
        'Circular 83/2025/TT-NHNN — Delegated Authority (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Delegated Authority (Layer 2, theme C) [PT]',
        'Circular 83/2025/TT-NHNN — Early Implementation Notification (Layer 5)': 'Circular 83/2025/TT-NHNN — Early Implementation Notification (Layer 5) [PT]',
        'Circular 83/2025/TT-NHNN — General Director Responsibility (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — General Director Responsibility (Layer 2, theme A) [PT]',
        'Circular 83/2025/TT-NHNN — ICAAP (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — ICAAP (Layer 3, theme E) [PT]',
        'Circular 83/2025/TT-NHNN — Interest-Rate Risk in the Banking Book (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Interest-Rate Risk in the Banking Book (Layer 3, theme E) [PT]',
        'Circular 83/2025/TT-NHNN — Internal Audit Charter (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Charter (Layer 2, theme H) [PT]',
        'Circular 83/2025/TT-NHNN — Internal Audit Engagements (Theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Engagements (Theme H) [PT]',
        'Circular 83/2025/TT-NHNN — Internal Audit Findings Communication (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Findings Communication (Layer 2, theme H) [PT]',
        'Circular 83/2025/TT-NHNN — Internal Audit Findings and Corrective Actions (Theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Findings and Corrective Actions (Theme H) [PT]',
        'Circular 83/2025/TT-NHNN — Internal Audit Follow-Up (Theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Follow-Up (Theme H) [PT]',
        'Circular 83/2025/TT-NHNN — Internal Audit Governance': 'Circular 83/2025/TT-NHNN — Internal Audit Governance [PT]',
        'Circular 83/2025/TT-NHNN — Internal Audit Independence (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Independence (Layer 2, theme H) [PT]',
        'Circular 83/2025/TT-NHNN — Internal Audit Plan (Layer 2/Theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Plan (Layer 2/Theme H) [PT]',
        'Circular 83/2025/TT-NHNN — Internal Audit Reporting to SBV (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Reporting to SBV (Layer 2, theme H) [PT]',
        'Circular 83/2025/TT-NHNN — Internal Control System Governance (Layer 2)': 'Circular 83/2025/TT-NHNN — Internal Control System Governance (Layer 2) [PT]',
        'Circular 83/2025/TT-NHNN — Internal Reporting Procedure (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Internal Reporting Procedure (Layer 2, theme C) [PT]',
        'Circular 83/2025/TT-NHNN — Internal Reports Register (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — Internal Reports Register (Layer 4, theme F) [PT]',
        'Circular 83/2025/TT-NHNN — Law-Change Monitoring (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Law-Change Monitoring (Layer 2, theme D) [PT]',
        'Circular 83/2025/TT-NHNN — Legal and Reputational Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Legal and Reputational Risk (Layer 3, theme E) [PT]',
        'Circular 83/2025/TT-NHNN — Limit Breach Escalation (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Limit Breach Escalation (Layer 3, theme E) [PT]',
        'Circular 83/2025/TT-NHNN — Liquidity Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Liquidity Risk (Layer 3, theme E) [PT]',
        'Circular 83/2025/TT-NHNN — MIS Annual Review (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS Annual Review (Layer 4, theme F) [PT]',
        'Circular 83/2025/TT-NHNN — MIS Backup and Continuity (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS Backup and Continuity (Layer 4, theme F) [PT]',
        'Circular 83/2025/TT-NHNN — MIS Escalation Mechanisms (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS Escalation Mechanisms (Layer 4, theme F) [PT]',
        'Circular 83/2025/TT-NHNN — MIS Reliability and Confidentiality (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS Reliability and Confidentiality (Layer 4, theme F) [PT]',
        'Circular 83/2025/TT-NHNN — MIS Risk Data Sources (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS Risk Data Sources (Layer 4, theme F) [PT]',
        'Circular 83/2025/TT-NHNN — Management Information System (Layer 4)': 'Circular 83/2025/TT-NHNN — Management Information System (Layer 4) [PT]',
        'Circular 83/2025/TT-NHNN — Market Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Market Risk (Layer 3, theme E) [PT]',
        'Circular 83/2025/TT-NHNN — Material Risk Register (Layer 3)': 'Circular 83/2025/TT-NHNN — Material Risk Register (Layer 3) [PT]',
        'Circular 83/2025/TT-NHNN — Model Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Model Risk (Layer 3, theme E) [PT]',
        'Circular 83/2025/TT-NHNN — New Product Review (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — New Product Review (Layer 3, theme E) [PT]',
        'Circular 83/2025/TT-NHNN — Operational Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Operational Risk (Layer 3, theme E) [PT]',
        'Circular 83/2025/TT-NHNN — Outsourcing BCP (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Outsourcing BCP (Layer 2, theme G) [PT]',
        'Circular 83/2025/TT-NHNN — Outsourcing Contracts (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Outsourcing Contracts (Layer 2, theme G) [PT]',
        'Circular 83/2025/TT-NHNN — Outsourcing Controls': 'Circular 83/2025/TT-NHNN — Outsourcing Controls [PT]',
        'Circular 83/2025/TT-NHNN — Outsourcing Due Diligence (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Outsourcing Due Diligence (Layer 2, theme G) [PT]',
        'Circular 83/2025/TT-NHNN — Outsourcing Fallback Provider (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Outsourcing Fallback Provider (Layer 2, theme G) [PT]',
        'Circular 83/2025/TT-NHNN — Outsourcing Materiality (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Outsourcing Materiality (Layer 2, theme G) [PT]',
        'Circular 83/2025/TT-NHNN — Outsourcing Monitoring (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Outsourcing Monitoring (Layer 2, theme G) [PT]',
        'Circular 83/2025/TT-NHNN — Phụ lục V/VI Technical References (Layer 5)': 'Circular 83/2025/TT-NHNN — Phụ lục V/VI Technical References (Layer 5) [PT]',
        'Circular 83/2025/TT-NHNN — Policy Register (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Policy Register (Layer 2, theme C) [PT]',
        'Circular 83/2025/TT-NHNN — Professional Ethics (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Professional Ethics (Layer 2, theme C) [PT]',
        'Circular 83/2025/TT-NHNN — Risk Appetite (Layer 3)': 'Circular 83/2025/TT-NHNN — Risk Appetite (Layer 3) [PT]',
        'Circular 83/2025/TT-NHNN — Risk Committee Coordination (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN — Risk Committee Coordination (Layer 2, theme E) [PT]',
        'Circular 83/2025/TT-NHNN — Risk Data Governance (Layer 3, theme E/F) — phased to 2028-01-01': 'Circular 83/2025/TT-NHNN — Risk Data Governance (Layer 3, theme E/F) — phased to 2028-01-01 [PT]',
        'Circular 83/2025/TT-NHNN — Risk Limit Review (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Risk Limit Review (Layer 3, theme E) [PT]',
        'Circular 83/2025/TT-NHNN — Risk Limits Framework (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Risk Limits Framework (Layer 3, theme E) [PT]',
        'Circular 83/2025/TT-NHNN — Risk Management Function (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN — Risk Management Function (Layer 2, theme E) [PT]',
        'Circular 83/2025/TT-NHNN — Risk Methodology and Models (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN — Risk Methodology and Models (Layer 2, theme E) [PT]',
        'Circular 83/2025/TT-NHNN — Risk Reporting (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN — Risk Reporting (Layer 2, theme E) [PT]',
        'Circular 83/2025/TT-NHNN — Risk Reporting Cadence (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — Risk Reporting Cadence (Layer 4, theme F) [PT]',
        'Circular 83/2025/TT-NHNN — SBV Remediation Submission (Layer 5)': 'Circular 83/2025/TT-NHNN — SBV Remediation Submission (Layer 5) [PT]',
        'Circular 83/2025/TT-NHNN — SBV Submission Channels (Layer 5)': 'Circular 83/2025/TT-NHNN — SBV Submission Channels (Layer 5) [PT]',
        'Circular 83/2025/TT-NHNN — Sector Applicability (Layer 1)': 'Circular 83/2025/TT-NHNN — Sector Applicability (Layer 1) [PT]',
        'Circular 83/2025/TT-NHNN — Segregation of Duties (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Segregation of Duties (Layer 2, theme C) [PT]',
        'Circular 83/2025/TT-NHNN — Senior Management Supervision (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Senior Management Supervision (Layer 2, theme A) [PT]',
        'Circular 83/2025/TT-NHNN — Strategic Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Strategic Risk (Layer 3, theme E) [PT]',
        'Circular 83/2025/TT-NHNN — Stress Testing (Layer 3, theme E) — phased to 2028-01-01': 'Circular 83/2025/TT-NHNN — Stress Testing (Layer 3, theme E) — phased to 2028-01-01 [PT]',
        'Circular 83/2025/TT-NHNN — Supervisory Board (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Supervisory Board (Layer 2, theme A) [PT]',
        'Circular 83/2025/TT-NHNN — Supervisory Findings Register (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — Supervisory Findings Register (Layer 4, theme F) [PT]',
        'Circular 83/2025/TT-NHNN — Three Lines Roles and Escalation (Layer 2, theme B)': 'Circular 83/2025/TT-NHNN — Three Lines Roles and Escalation (Layer 2, theme B) [PT]',
        'Circular 83/2025/TT-NHNN — Three Lines of Defence (Layer 2)': 'Circular 83/2025/TT-NHNN — Three Lines of Defence (Layer 2) [PT]',
        'Circular 83/2025/TT-NHNN — Violation Escalation (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Violation Escalation (Layer 2, theme D) [PT]',
    },
    framework_authorities: {
        'Quốc hội (National Assembly)': 'Quốc hội (Assembleia Nacional)',
        'Ministry of Public Security / A05 Department': 'Ministério da Segurança Pública / Departamento A05',
        'Ministry of Public Security': 'Ministério da Segurança Pública',
        'Ministry of Information and Communications': 'Ministério da Informação e Comunicações',
        'Government of Vietnam': 'Governo do Vietnã',
        'European Data Protection Board (EDPB)': 'Conselho Europeu para a Proteção de Dados (EDPB)',
        'ENISA / National CSIRTs': 'ENISA / CSIRT nacionais',
        'State Bank of Vietnam': 'Banco Estatal do Vietnã',
    },
    tour_titles: {
        access_accountability: 'Acesse o tour de responsabilidade',
        assessments: 'Tour de Avaliações',
        audit_trail: 'Tour pela trilha de auditoria',
        classification: 'Tour de Classificação',
        compliance_forms: 'Tour pelos formulários de conformidade',
        connectors: 'Tour pelos Conectores',
        consent_properties: 'Tour pelas propriedades de consentimento',
        consent: 'Tour de consentimento',
        dashboard: 'Tour pelo painel',
        data_mapping: 'Tour de mapeamento de dados',
        data_subjects: 'Tour pelos titulares dos dados',
        deletion_orchestration: 'Tour de orquestração de exclusão',
        discovery: 'Tour de descoberta',
        governance: 'Tour de Governança',
        help_center: 'Tour pela Central de Ajuda',
        incident_ops: 'Tour de operações de incidentes',
        incidents: 'Tour de Incidentes',
        localization: 'Tour de localização',
        monitoring: 'Tour de monitoramento',
        onboarding: 'Tour de integração',
        organizations: 'Tour pelas Organizações',
        partner_workspace: 'Tour pelo espaço de trabalho do parceiro',
        platform_settings: 'Tour pelas configurações da plataforma',
        privacy_scanner: 'Tour do scanner de privacidade',
        program_governance: 'Tour de Governança do Programa',
        rights_requests: 'Tour de Solicitações de Direitos',
        task_management: 'Tour de gerenciamento de tarefas',
        vendor_risk: 'Tour de risco do fornecedor',
    },
    tour_descriptions: {
        access_accountability: 'Como Líder de Auditoria Interna (P-VN-10), revise as evidências de acesso, o uso de permissões de auditoria e investigue padrões anômalos para demonstrar a integridade e a confidencialidade do [[TOK_0]] Artigo 5(1)(f).',
        assessments: 'Como Empresa [[TOK_1]] (P-VN-01), conduza DPIAs seguindo o Decreto 356 Mau so 02a, identifique lacunas de conformidade e avalie os riscos de transferência transfronteiriça sob [[TOK_0]].',
        audit_trail: 'Como líder de auditoria interna (P-VN-10), consulte evidências entre módulos, monte pacotes de auditoria e exporte registros invioláveis para envios regulatórios.',
        classification: 'Como administrador de dados (P-VN-05), defina taxonomias de classificação de dados, atribua rótulos de confidencialidade, aplique políticas de retenção e resolva lacunas de cobertura necessárias para conformidade com [[TOK_0]].',
        compliance_forms: 'Como Empresa [[TOK_0]] (P-VN-01), navegue, preencha e envie formulários regulatórios oficiais vietnamitas, incluindo Phu luc I, Phu luc II e Mau so modelos para arquivamentos do Comitê PDP.',
        connectors: 'Como líder de sistemas de TI (P-VN-05), capture os requisitos de negócios para integrações, mapeie conectores para fluxos de dados de conformidade e verifique a prontidão do POC antes de entrar em operação.',
        consent_properties: 'Como Empresa [[TOK_1]] (P-VN-01), configure a implantação do [[TOK_2]]: registro de propriedade digital, modelos dourados para banners de consentimento consistentes [[TOK_0]] e matrizes vinculativas que vinculam propriedades a atividades de processamento.',
        consent: 'Como Empresa [[TOK_1]] (P-VN-01), gerencie o ciclo de vida da política de consentimento: defina os propósitos de coleta, aplique os direitos de retirada do [[TOK_0]] e integre-se à sua Plataforma de gerenciamento de consentimento.',
        dashboard: 'Como Empresa [[TOK_1]] (P-VN-01), oriente-se em torno do centro de comando de postura de conformidade que apresenta prazos [[TOK_0]], violação de SLAs e KPIs de prontidão para auditoria.',
        data_mapping: 'Como administrador de dados (P-VN-05), crie seu inventário ROPA, mapeie fluxos de dados transfronteiriços e mantenha o registro de atividades de processamento exigido por [[TOK_0]].',
        data_subjects: 'Como líder de conformidade empresarial ou educacional, gerencie perfis unificados de titulares de dados que vinculam registros de consentimento, solicitações de direitos e atividades de cronograma em toda a plataforma.',
        deletion_orchestration: 'Como o [[TOK_1]] (P-VN-01), verifique a exclusão de dados ponta a ponta em sistemas internos e fornecedores terceirizados, com cadeias de prova criptográfica para [[TOK_0]] conformidade com o direito de exclusão do Artigo 17.',
        discovery: 'Como administrador de dados (P-VN-05), execute verificações automatizadas para descobrir dados pessoais em sistemas conectados, revise descobertas preparadas e alimente os resultados no módulo Classificação para rotulagem [[TOK_0]].',
        governance: 'Como Gerente de Risco do Fornecedor (P-VN-08), mantenha o registro do fornecedor, rastreie as cadeias de subprocessadores, avalie os riscos de transferência transfronteiriça e aplique os manuais de governança sob [[TOK_0]].',
        help_center: 'Para todas as pessoas – DPOs, auditores, líderes de TI e gerentes de conformidade – encontre respostas, guias de procedimentos e documentação específica do módulo para dar suporte aos seus fluxos de trabalho diários de conformidade.',
        incident_ops: 'Como Comandante do Incidente (P-VN-09), ative playbooks de resposta, rastreie a conformidade do [[TOK_1]] em relação à janela de notificação de 72 horas do [[TOK_0]], gerencie escalonamentos e coordene a resposta do fornecedor.',
        incidents: 'Como Comandante do Incidente (P-VN-09), detecte e relate violações de dados com obrigações de notificação de 72 horas [[TOK_0]] ao Comitê PDP, faça triagem por gravidade e crie dossiês de incidentes com nível de auditoria.',
        localization: 'Como a Empresa [[TOK_1]] (P-VN-01), gerencie o ciclo de vida da estrutura regulatória: instale pacotes do mercado vietnamita, ative as estruturas [[TOK_0]] e do Decreto 13, mapeie os requisitos para os módulos da plataforma e gerencie as traduções.',
        monitoring: 'Como Empresa [[TOK_1]] (P-VN-01), estabeleça programas contínuos de monitoramento de conformidade, rastreie mudanças regulatórias, meça KPIs e gerencie casos de interação regulatória em [[TOK_0]].',
        onboarding: 'Como instrutor de conformidade (P-VN-02), forneça treinamento por meio de tours guiados, carregue dados de amostra realistas para exercícios práticos e execute o assistente de configuração para cenários de início rápido.',
        organizations: 'Como [[TOK_0]] (P-VN-01), configure estruturas de conformidade multiorganizacionais, estabeleça hierarquias de departamentos e encaminhe solicitações de titulares de dados em seu grupo corporativo.',
        partner_workspace: 'Como gerente de contas de parceiros, integre organizações parceiras, configure níveis de serviço, rastreie resultados de conformidade e gerencie o mercado de parceiros.',
        platform_settings: 'Como administrador da plataforma, gerencie todas as configurações operacionais – identidade, segurança, integrações e acesso a módulos que sustentam seu programa de conformidade.',
        privacy_scanner: 'Como Analista de Privacidade (P-VN-06), execute varreduras de monitoramento contínuo para detectar violações de consentimento de cookies, rastreadores não autorizados e lacunas de políticas - gerando evidências de privacidade eletrônica e conformidade com [[TOK_0]].',
        program_governance: 'Navegue entre modelos de maturidade, avaliações, lacunas de evidências, resumos executivos e muito mais. Cada submódulo contribui para uma visão holística da saúde interna do seu programa.',
        rights_requests: 'Como Empresa [[TOK_1]] (P-VN-01), gerencie solicitações de direitos do titular dos dados sob [[TOK_0]] com prazos legais de 15 dias, verificação de identidade e trilhas de resolução de nível de auditoria.',
        task_management: 'Direcione tarefas de conformidade entre personas, monitore prazos [[TOK_0]] e automatize fluxos de trabalho que mantêm sua equipe responsável.',
        vendor_risk: 'Como Gerente de Risco do Fornecedor (P-VN-08), avalie o risco de terceiros, aplique revisões de portas e acione reavaliações – diferente da Governança do Programa, que rastreia sua maturidade interna.',
    },
    consolidation: {
        title: 'Casos de consolidacao',
        new_case: 'Criar caso de consolidação',
        case_count: 'case',
        created: 'Caso de consolidação criado',
        create: 'Criar caso',
        creating: 'Criando...',
        cancel: 'Cancelar',
        no_cases: 'Nenhum caso de consolidação encontrado.',
        all_statuses: 'Todos os status',
        all_purposes: 'Todos os fins',
        filter_status: 'Filtrar por status',
        filter_purpose: 'Filtrar por finalidade',
        col_title: 'Título',
        col_purpose: 'Objetivo',
        col_status: 'Estado',
        col_progress: 'Progresso',
        col_deadline: 'Prazo',
        col_department: 'Departamento',
        col_version: 'Versão',
        col_evidence: 'Evidência',
        sections_accepted: 'accepted',
        prev: 'Anterior',
        next: 'Próximo',
        page: 'Página',
        prev_page: 'Página anterior',
        next_page: 'Próxima página',
        field_title: 'Título',
        field_purpose: 'Objetivo',
        field_framework: 'Código Estrutural',
        field_deadline: 'Prazo',
        field_reviewer: 'ID do usuário do revisor',
        title_placeholder: 'Insira o título do caso',
        framework_placeholder: 'por exemplo, PDPD-2023',
        reviewer_placeholder: 'Insira o ID do usuário do revisor',
        purposes: {
            dpia_filing: '[[TOK_0]] Arquivamento',
            cross_border_filing: 'Arquivamento Transfronteiriço',
            annual_governance_attestation: 'Atestado Anual de Governança',
            breach_package: 'Pacote de violação',
            audit_inspection_pack: 'Pacote de inspeção de auditoria',
        },
        statuses: {
            draft: 'Rascunho',
            collecting: 'Coletando',
            consolidating: 'Consolidando',
            review: 'Revisão',
            corrections: 'Correções',
            pending_approval: 'Aprovação pendente',
            approved: 'Aprovado',
            completed: 'Concluído',
            closed: 'Fechado',
            rejected: 'Rejeitado',
        },
        section_statuses: {
            pending: 'Pendente',
            in_progress: 'Em andamento',
            submitted: 'Enviado',
            accepted: 'Aceito',
            needs_correction: 'Precisa de correção',
            corrected: 'Corrigido',
        },
        flag_types: {
            missing_section: 'Seção ausente',
            conflicting_entry: 'Entrada conflitante',
            stale_entry: 'Entrada obsoleta',
            missing_evidence: 'Evidências ausentes',
            incomplete_data: 'Dados incompletos',
            duplicate_entry: 'Entrada duplicada',
        },
        flag_severities: {
            critical: 'Crítico',
            warning: 'Aviso',
            info: 'Informações',
        },
        sections_title: 'Seções',
        no_sections: 'Nenhuma seção atribuída ainda.',
        flags_title: 'Bandeiras',
        no_flags: 'Nenhum sinalizador detectado.',
        open: 'open',
        approval_chain: 'Cadeia de aprovação',
        pending: 'Pendente',
        audit_trail: 'Trilha de auditoria',
        no_audit: 'Nenhum evento de auditoria.',
        auto_assign: 'Atribuir seções automaticamente',
        start_collection: 'Iniciar coleção',
        review_case: 'Revisar caso',
        generate_export: 'Gerar exportação',
        review_title: 'Revisão de Consolidação',
        advance_approval: 'Avançar para aprovação',
        back_to_case: 'Voltar ao caso',
        accept: 'Aceitar',
        return_section: 'Retorno',
        return_comment: 'Retornar comentário...',
        resolve: 'Resolver',
        dismiss: 'Dispensar',
        resolution_notes: 'Notas de resolução...',
        notes: 'Notas',
        section_accepted: 'Seção aceita',
        section_returned: 'Seção devolvida para correção',
        advanced_to_approval: 'Caso avançado para aprovação pendente',
        section_data: 'Dados da seção',
        save_progress: 'Salvar progresso',
        submit_section: 'Enviar seção',
        submitting: 'Enviando...',
        resubmit: 'Reenviar',
        progress_saved: 'Progresso salvo',
        section_submitted: 'Seção enviada',
        correction_required: 'Correção necessária',
        evidence_title: 'Evidência',
        no_evidence: 'Nenhuma evidência anexada.',
        add_evidence: 'Adicionar evidências',
        evidence_added: 'Evidência adicionada',
        evidence_files: 'arquivos de evidências',
        uploaded_by: 'enviado por',
        comments_title: 'Comentários',
        no_comments: 'Nenhum comentário ainda.',
        comment_placeholder: 'Adicione um comentário...',
        add_comment: 'Adicionar comentário',
        comment_added: 'Comentário adicionado',
        view_data: 'Ver dados enviados',
        export_title: 'Exportação de Dossiê',
        export_generated: 'Pacote de exportação gerado',
        regenerate: 'Regenerar',
        regenerating: 'Regenerando...',
        generated_at: 'Gerado em',
        artifacts_title: 'Exportar artefatos',
        artifact_type: 'Artefato',
        file_name: 'Nome do arquivo',
        file_size: 'Tamanho',
        generated: 'Gerado',
        download: 'Baixar',
        artifacts: {
            master_report: 'Relatório Mestre',
            evidence_bundle: 'Pacote de evidências (ZIP)',
            contributor_lineage: 'Linhagem do Contribuidor',
            conflict_resolution: 'Resolução de Conflitos',
            approval_history: 'Histórico de aprovação',
        },
        official_forms: 'Formulários Oficiais',
        forms_description: 'Os seguintes formulários oficiais podem ser gerados a partir dos dados consolidados. Os formulários oficiais são separados dos papéis de trabalho internos.',
        announce_loaded_cases: '[[TOK_1]] casos de consolidação carregados',
        announce_case_detail_loaded: 'Detalhe do caso carregado',
        announce_case_transitioned: 'Caso transferido para [[TOK_1]]',
        announce_flag_resolved: 'Sinalização resolvida',
        announce_flag_dismissed: 'Bandeira rejeitada',
        case_detail_loaded: 'Detalhe do caso carregado',
        sections_auto_assigned: 'Seções atribuídas automaticamente pela hierarquia do departamento',
        errors: {
            load_failed: 'Falha ao carregar dados. Por favor, tente novamente.',
            create_failed: 'Falha ao criar o caso. Por favor, tente novamente.',
            required_fields: 'Por favor preencha todos os campos obrigatórios.',
            not_found: 'Não encontrado.',
            comment_required: 'O comentário é necessário ao retornar uma seção.',
            notes_required: 'Notas são necessárias ao resolver ou descartar um sinalizador.',
        },
    },
    rights_requests: {
        import: {
            title: 'Importar casos',
            nav_title: 'Importação em massa',
            description: 'Faça upload de um ficheiro CSV para importar em massa casos de pedido de direitos.',
            select_file: 'Selecionar ficheiro CSV',
            file_help: 'CSV com cabeçalhos correspondentes aos campos do caso.',
            file_too_large: 'Ficheiro demasiado grande. O tamanho máximo é 2MB.',
            preview: 'Pré-visualização',
            columns_detected: 'Colunas detetadas: {count}',
            column_mapping: 'Mapeamento de colunas',
            import_button: 'Importar',
            import_complete: 'Importação concluída',
            import_error: 'A importação falhou',
            result: 'Resultado da importação',
            total: 'Total',
            imported: 'Importado',
            skipped: 'Ignorado',
            failed: 'Falhado',
            errors: 'Erros',
            error_row: 'Linha',
            error_field: 'Campo',
            error_message: 'Mensagem',
            history: 'Histórico de importação',
            no_history: 'Sem histórico de importação.',
            history_file: 'Nome do ficheiro',
            history_date: 'Data',
        },
        batch: {
            nav_title: 'Processo em lote',
            page_title: 'Processo em lote DSR',
            page_subtitle: 'Carregue um [[TOK_1]] de DSRs pendentes. Forseti elabora uma resposta de confirmação por solicitação e enfileira uma tarefa de verificação por linha. O [[TOK_0]] analisa e aceita cada um antes de enviar.',
            upload_heading: 'Carregar',
            csv_hint: 'Colunas obrigatórias: request_id, requester_email, request_type. Opcional: prazo (ISO-8601), notas.',
            rows_heading: '[[TOK_1]] linhas analisadas',
            submit_label: 'Executar lote',
            submitting: 'Elaboração…',
            col_request_id: 'ID da solicitação',
            col_email: 'E-mail do solicitante',
            col_type: 'Tipo',
            col_status: 'Estado',
            col_actions: 'Ações',
            status_queued: 'Na fila',
            status_drafted: 'Elaborado',
            status_failed: 'Falha',
            status_accepted: 'Aceito',
            status_rejected: 'Rejeitado',
            'status_parsing-error': 'Erro de análise',
            accept: 'Aceitar',
            reject: 'Rejeitar',
            permission_denied: 'Você não tem permissão para executar fluxos de trabalho do Forseti.',
        },
    },
    assessment_triggers: {
        title: 'Gatilhos de avaliação',
        subtitle: 'Configure a criação automatizada de avaliações e notificações [[TOK_0]] para fluxos de trabalho de privacidade.',
        auto_create_dpia_label: 'Criar automaticamente [[TOK_0]] ao processar atividade marcada como [[TOK_1]] obrigatória',
        auto_notify_new_purpose_label: 'Notificar automaticamente [[TOK_0]] quando uma nova finalidade for criada com categorias de dados confidenciais',
        auto_notify_cross_border_label: 'Notificar automaticamente [[TOK_0]] quando uma transferência internacional for adicionada à atividade de processamento',
        default_dpo_label: 'Padrão [[TOK_0]]',
        default_dpo_placeholder: 'Selecione o padrão [[TOK_0]]...',
        notification_channels_label: 'Canais de Notificação',
        channel_in_app: 'No aplicativo',
        channel_email: 'Email',
        save_success: 'As configurações do gatilho de avaliação foram salvas.',
        save_error: 'Falha ao salvar as configurações do acionador de avaliação.',
        fetch_error: 'Falha ao carregar as configurações do acionador de avaliação.',
        fetch_users_error: 'Falha ao carregar usuários.',
        announce_loaded: 'Configurações do gatilho de avaliação carregadas',
        dpia_status: '[[TOK_0]] Estado',
        dpia_linked: '[[TOK_0]] Vinculado',
        dpia_required_no_dpia: '[[TOK_0]] Obrigatório — Não criado',
        create_dpia: 'Criar [[TOK_0]]',
        create_dpia_success: '[[TOK_0]] criado e vinculado à atividade.',
        create_dpia_error: 'Falha ao criar [[TOK_0]] para atividade.',
        view_dpia: 'Ver [[TOK_0]]',
    },
    data_subjects: {
        title: 'Perfis de Titulares de Dados',
        nav_title: 'Titulares de Dados',
        nav: {
            profiles: 'Perfis',
        },
        create: 'Criar Perfil',
        edit: 'Editar Perfil',
        delete: 'Eliminar Perfil',
        delete_confirm: 'Tem certeza de que deseja excluir este perfil do titular dos dados?',
        display_name: 'Nome de exibição',
        email: 'Email',
        phone: 'Telefone',
        employee_id: 'ID do funcionário',
        student_id: 'ID de estudante',
        notes: 'Notas',
        external_refs: 'Referências Externas',
        cases_count: 'Casos',
        workflows_count: 'Registros de consentimento',
        last_activity: 'Última atividade',
        timeline: 'Linha do tempo',
        link_case: 'Link Case',
        link_workflow: 'Link Workflow',
        no_profiles: 'Nenhum perfil de titular de dados encontrado.',
        search_placeholder: 'Pesquise por nome, e-mail, telefone ou ID...',
        create_success: 'Perfil do titular dos dados criado.',
        create_error: 'Falha ao criar o perfil do titular dos dados.',
        update_success: 'Perfil do titular dos dados atualizado.',
        update_error: 'Falha ao atualizar o perfil do titular dos dados.',
        delete_success: 'Perfil do titular dos dados excluído.',
        delete_error: 'Falha ao excluir o perfil do titular dos dados.',
        link_case_success: 'Caso vinculado ao perfil.',
        link_case_error: 'Falha ao vincular o caso ao perfil.',
        link_workflow_success: 'Fluxo de trabalho vinculado ao perfil.',
        link_workflow_error: 'Falha ao vincular o fluxo de trabalho ao perfil.',
        load_error: 'Falha ao carregar perfis de titulares de dados.',
        detail_load_error: 'Falha ao carregar o perfil do titular dos dados.',
        timeline_load_error: 'Falha ao carregar a linha do tempo.',
        tab_cases: 'Casos de DSR',
        tab_consent: 'Registros de consentimento',
        tab_timeline: 'Linha do tempo',
        tab_consent_workflows: 'Fluxos de trabalho de consentimento',
        tab_web_consent: '[[TOK_0]] Consentimento',
        web_consent_empty: 'Nenhum registro de consentimento [[TOK_0]] encontrado para este assunto.',
        web_consent_load_error: 'Falha ao carregar registros de consentimento [[TOK_0]].',
        col_policy_version: 'Versão da política',
        col_versions: 'Versões',
        col_consent_version: 'Consentimento',
        col_cookie_declaration_version: 'Declaração de Cookies',
        col_purposes: 'Finalidades',
        purpose_granted: 'Concedido',
        purpose_denied: 'Negado',
        granted_domains: 'Concedido',
        denied_domains: 'Negado',
        col_action: 'Ação',
        col_timestamp: 'Carimbo de data e hora',
        col_domain: 'Domínio',
        no_cases: 'Nenhum caso vinculado.',
        no_workflows: 'Nenhum fluxo de trabalho de consentimento vinculado.',
        no_timeline: 'Nenhum evento na linha do tempo.',
        case_id: 'ID do caso',
        case_status: 'Estado',
        case_type: 'Tipo de solicitação',
        case_created: 'Criado',
        workflow_id: 'ID do fluxo de trabalho',
        workflow_type: 'Tipo',
        workflow_status: 'Estado',
        workflow_created: 'Criado',
        timeline_date: 'Data',
        timeline_event: 'Evento',
        timeline_details: 'Detalhes',
        timeline_time: 'Hora',
        timeline_type: 'Tipo',
        timeline_summary: 'Resumo',
        type_case: 'Caso DSR',
        type_consent_workflow: 'Fluxo de trabalho de consentimento',
        profile_info: 'Informações do perfil',
        announce_loaded: 'Perfis de titulares de dados carregados',
        announce_detail_loaded: 'Perfil do titular dos dados carregado',
        select_case: '— Selecione um caso —',
        select_workflow: '— Selecione um fluxo de trabalho —',
        no_cases_hint: 'Vincule casos para vê-los aqui.',
        no_workflows_hint: 'Vincule fluxos de consentimento para vê-los aqui.',
    },
    flows: {
        map: {
            description_prefix: '{systems} sistemas · {flows} fluxos · {crossBorder} transferências internacionais · {highRisk} risco elevado/crítico',
            switch_to_list: 'Mudar para vista de lista',
            switch_to_list_aria: 'Mudar para vista de tabela',
            svg_aria: 'Mapa de fluxos de dados: {systems} sistemas, {flows} fluxos, {crossBorder} transferências internacionais',
            selected_system: 'Sistema selecionado',
            drill_hint: 'Abra o separador «Lista» para editar os fluxos, AIPD e atribuições de fornecedores associados a este sistema.',
        },
    },
    packages: {
        light: {
            name: 'Luz',
            description: 'Ferramentas essenciais de conformidade de privacidade para equipas pequenas',
        },
        standard: {
            name: 'Padrão',
            description: 'Plataforma de conformidade completa para organizações em crescimento',
        },
        enterprise_unlimited: {
            name: 'Empresa Ilimitada',
            description: 'Conformidade de nível empresarial com suporte multi-organização e serviços dedicados',
        },
    },
    forseti: {
        providerSettings: {
            title: 'Forseti [[TOK_0]] Configurações do provedor',
            subtitle: 'Configure o provedor Claude para o consultor jurídico Forseti [[TOK_0]].',
            healthHeading: 'Saúde do provedor',
            statusLabel: 'Estado',
            statusOk: 'OK',
            statusFailed: 'Indisponível',
            providerLabel: 'Provedor',
            providerClaudeApi: 'Cláudio [[TOK_0]]',
            providerCliRelay: 'Relé Claude CLI',
            providerAesirManaged: 'Tokens gerenciados pela Aesir',
            lastCheckedLabel: 'Última verificação',
            reasonLabel: 'Razão',
            refreshButton: 'Atualizar',
            apiKeyHeading: 'Chave de Cláudio [[TOK_0]]',
            apiKeyHint: 'Definir uma tecla [[TOK_0]] ativa o modo Claude [[TOK_1]]. Deixe não definido para usar a retransmissão CLI local (modo desenvolvedor/auto-hospedado).',
            apiKeyLabel: 'Chave [[TOK_0]]',
            apiKeyMinLength: 'Mínimo 32 caracteres. Criptografado em repouso; nunca mais foi mostrado.',
            apiKeyTooShort: 'A chave [[TOK_0]] deve ter pelo menos 32 caracteres.',
            apiKeySaved: 'Chave [[TOK_0]] salva. Saúde refrescante…',
            apiKeyCleared: '[[TOK_0]] chave apagada. Forseti agora usa a retransmissão CLI local.',
            setKeyButton: 'Salvar chave [[TOK_0]]',
            clearKeyButton: 'Limpar tecla [[TOK_0]] (usar relé CLI)',
        },
        usage: {
            title: 'Uso',
            subtitle: 'Consumo de token e status do bucket para esta organização.',
            bucketHeading: 'Balde de token mensal',
            remainingLabel: 'Restante',
            consumedLabel: 'Consumido',
            totalLabel: 'Total',
            unitsLabel: 'unidades faturáveis',
            lastReconciledLabel: 'Última reconciliação',
            recentHeading: 'Atividade recente',
            historyHeading: 'Últimos 12 períodos',
            noActivity: 'Nenhuma atividade ainda neste período.',
            featureLabel: 'Recurso',
            whenLabel: 'Quando',
            periodLabel: 'Período',
            topUpButton: 'Solicite um pacote de recarga',
            topUpHint: 'Entre em contato com seu gerente de conta para solicitar um pacote de recarga.',
            buyMore: {
                buyButton: 'Comprar mais unidades',
                purchaseTitle: 'Comprar mais unidades de faturamento',
                purchaseSubtitle: 'Escolha um pacote. Você será direcionado ao checkout seguro da Stripe e sua fatura chegará por e-mail.',
                packageLabel: 'Pacote',
                optionTemplate: '{name} — {units} {units_label} — {price}',
                packageSmall: 'Pequeno',
                packageMedium: 'Médio',
                packageLarge: 'Grande',
                checkoutButton: 'Continuar para o checkout',
                checkoutPending: 'Abrindo o checkout…',
                cancelButton: 'Cancelar',
                purchaseError: 'Não foi possível iniciar o checkout. Tente novamente em instantes.',
                redeemTitle: 'Resgatar uma fatura',
                redeemSubtitle: 'Já pagou? Selecione o pacote que você comprou e insira o número da fatura do seu e-mail para adicionar as unidades.',
                invoiceLabel: 'Número da fatura',
                invoicePlaceholder: 'JJVExxxX-0001',
                redeemButton: 'Resgatar',
                redeemPending: 'Resgatando…',
                redeemSuccess: 'Unidades adicionadas ao seu saldo.',
                redeemAlready: 'Esta fatura já foi resgatada.',
                errorNotFound: 'Não foi encontrada nenhuma fatura com esse número. Verifique o número da fatura e tente novamente.',
                errorNotPaid: 'Esta fatura ainda não está marcada como paga.',
                errorOrgMismatch: 'Esta fatura não foi emitida para a sua organização.',
                errorPackageMismatch: 'Esta fatura não corresponde ao pacote selecionado.',
                errorInvalidInvoice: 'Insira um número de fatura válido.',
                errorGeneric: 'Falha no resgate. Tente novamente em instantes.',
            },
            byFeatureHeading: 'Este mês por recurso',
            byFeatureEmpty: 'Nenhuma atividade de recurso ainda neste período.',
            featureColumn: 'Recurso',
            featureUnitsColumn: 'Unidades',
            featureRunsColumn: 'Corre',
            byUserHeading: 'Este mês por usuário (visualização do administrador)',
            byUserEmpty: 'Nenhuma atividade por usuário ainda neste período.',
            userColumn: 'Usuário',
            reconciliationLinkLabel: 'Ver relatório de desvio de reconciliação',
            reconciliationLinkHint: 'Apenas administrador interno da Aesir.',
            featureLabels: {
                chat: 'Bate-papo',
                workflow: 'Execução do fluxo de trabalho',
                tabular: 'Extração tabular',
                redline: 'Revisão da linha vermelha',
                title: 'Título da conversa',
                unknown: 'Outro',
            },
        },
        reconciliation: {
            title: 'Reconciliação de cotas Forseti',
            subtitle: 'Flutue entre o cache rápido do contador de cotas e o livro-razão de faturamento oficial. O reconciliador é executado a cada 5 minutos; esta página apresenta a execução e o histórico mais recentes. Apenas administrador interno da Aesir.',
            backLink: 'Voltar ao uso do Forseti',
            stubHeading: 'História de reconciliação em breve',
            stubBody: 'Os logs do trabalhador do reconciliador passam pelo canal de log estruturado. Um endpoint de leitura de back-end que expõe as últimas 30 execuções de reconciliação está sendo definido como escopo (adiado do Sprint 47.5.9.6 — consulte o arquivo de trabalho). Assim que o endpoint chegar, esta página mostrará a tabela de histórico de execução + banner de desvio P0.',
            stubBackendOwner: 'Adiamento de back-end: persistir a reconciliação executada em uma nova coleção + adicionar rota `GET /llm-relay/quota/reconciliation`.',
            permissionDenied: 'Esta página é restrita aos administradores internos da Aesir. Se você acredita que deveria ter acesso, entre em contato com seu representante [[TOK_0]].',
        },
        projects: {
            title: 'Projetos',
            subtitle: 'Espaços de trabalho para documentos, conversas, fluxos de trabalho e revisões.',
            modeLabel: 'Ver',
            tabMine: 'Meus projetos',
            tabShared: 'Compartilhado comigo',
            searchLabel: 'Pesquisar projetos',
            searchPlaceholder: 'Pesquisar…',
            newButton: 'Novo projeto',
            colName: 'Nome',
            colVisibility: 'Visibilidade',
            colDocs: 'Documentos',
            colMembers: 'Membros',
            colUpdated: 'Atualizado',
            visibilityOwn: 'Possuir apenas',
            visibilityShared: 'Compartilhado',
            emptyMine: 'Nenhum projeto ainda. Crie um para começar.',
            emptyShared: 'Nenhum projeto foi compartilhado com você.',
            pageHint: 'Exibindo [[TOK_2]] de [[TOK_3]].',
            createTitle: 'Novo projeto',
            createSubmit: 'Criar projeto',
            fieldName: 'Nome',
            fieldDescription: 'Descrição (opcional)',
            fieldCmNumber: 'Número do caso/assunto (opcional)',
            fieldVisibility: 'Visibilidade',
            errorNameRequired: 'O nome é obrigatório.',
            errorSelectorRequired: 'Selecione um usuário ou grupo organizacional para adicionar.',
            renameButton: 'Renomear',
            renamePrompt: 'Renomear projeto',
            deleteButton: 'Excluir',
            deleteConfirm: 'Excluir este projeto? Ele será retido por 30 dias antes da remoção permanente.',
            deleteFolderConfirm: 'Excluir esta pasta? Os documentos contidos permanecerão no projeto, apenas não arquivados.',
            removeMemberConfirm: 'Remover este membro?',
            foldersHeading: 'Pastas',
            foldersEmpty: 'Ainda não há pastas.',
            addFolderButton: 'Nova pasta',
            addFolderTitle: 'Nova pasta',
            documentsHeading: 'Documentos',
            documentsEmpty: 'Ainda não há documentos anexados.',
            colFilename: 'Nome do arquivo',
            colAdded: 'Adicionado',
            unattachButton: 'Desanexar',
            membersHeading: 'Membros',
            membersEmpty: 'Somente proprietário.',
            addMemberButton: 'Adicionar membro',
            addMemberTitle: 'Adicionar membro',
            addMemberSubmit: 'Adicionar membro',
            colMember: 'Membro',
            colRole: 'Função',
            selectorTypeLabel: 'Adicionar por',
            selectorUser: 'ID do usuário',
            selectorGroup: 'ID do grupo organizacional',
            fieldUserId: 'Usuário',
            fieldGroupId: 'Grupo organizacional',
            fieldRole: 'Função',
            roleAdmin: 'Administrador',
            roleEditor: 'Editor',
            roleViewer: 'Visualizador',
            notFound: 'Projeto não encontrado.',
            selectUserPlaceholder: 'Selecione um usuário…',
            selectGroupPlaceholder: 'Selecione um grupo organizacional…',
            noUsersAvailable: 'Nenhum usuário disponível.',
            noGroupsAvailable: 'Nenhum grupo organizacional disponível.',
            loadFailed: 'Falha ao carregar opções.',
            deleteProjectTitle: 'Excluir projeto?',
            deleteFolderTitle: 'Excluir pasta?',
            removeMemberTitle: 'Remover membro?',
            removeMemberConfirmGeneric: 'Remover este membro do projeto?',
            addDocumentButton: 'Adicionar documento',
            addDocumentTitle: 'Adicionar documento ao projeto',
            fieldDocument: 'Selecionar documento',
            selectDocPlaceholder: 'Procurar um documento...',
            ownerLabel: 'Proprietário do sistema',
        },
        chat: {
            sidebarLabel: 'Bate-papos',
            overviewTitle: 'Forseti',
            overviewSubtitle: 'Seu [[TOK_0]] Consultor Jurídico e de Conformidade — baseado nos dados do seu locatário e nos pacotes regulatórios instalados.',
            personaSelectorLabel: 'Pessoa',
            personaHeading: 'Escolha uma persona',
            startChatButton: 'Iniciar um novo bate-papo',
            startingChat: 'Iniciando bate-papo…',
            recentHeading: 'Bate-papos recentes',
            recentEmpty: 'Ainda não há bate-papos – inicie um acima.',
            untitledChat: 'Novo bate-papo',
            messageListLabel: 'Conversa',
            detailSubtitle: 'Pessoa: [[TOK_1]]',
            composeHeading: 'Envie uma mensagem',
            composeLabel: 'Mensagem Forseti',
            composeDisabledPlaceholder: 'A composição da mensagem chega ao próximo sprint (47.5.4b — streaming SSE + loop de chamada de ferramenta).',
            composeDisabledHint: 'Visualização somente leitura fornecida em 47.5.4a. Chamadas de ferramentas de streaming + chegam em 47.5.4b.',
            switchPersonaHeading: 'Pessoa',
            presetPersona: 'Persona predefinida',
            changePersona: 'Alterar persona',
            hidePersonaOptions: 'Ocultar opções de persona',
            starterHeading: 'Comece com uma destas ações',
            renameButton: 'Renomear',
            renamePrompt: 'Renomear bate-papo',
            deleteButton: 'Excluir',
            deleteConfirm: 'Excluir este bate-papo? Ele será retido por 30 dias antes da remoção permanente.',
            notFound: 'Bate-papo não encontrado.',
            emptyChat: 'Nenhuma mensagem ainda. Diga olá para iniciar uma conversa.',
            roleUser: 'Você',
            roleAssistant: 'Forseti',
            roleSystem: 'Sistema',
            thinkingLabel: 'Pensando',
            toolCallPlaceholder: 'Chamada de ferramenta: ',
            toolResultPlaceholder: 'Resultado da ferramenta oculto – UI completa chega em 47.5.4b.',
            docEditPlaceholder: 'Edições de documentos propostas (V[[TOK_1]]).',
            disclaimer: 'Forseti apóia seu julgamento – ele não substitui um advogado licenciado.',
            sendButton: 'Enviar',
            sending: 'Enviando…',
            composePlaceholder: 'Pergunte ao Forseti…',
            composingPlaceholder: 'Forseti está respondendo…',
            streamingPlaceholder: 'Forseti está digitando…',
            promptInjectionTitle: 'Forseti derrubou alguns tokens de controle.',
            promptInjectionBody: 'Padrões despojados: [[TOK_1]]. Forseti verá apenas o texto da sua mensagem.',
            promptInjectionInline: 'Forseti eliminou tokens de controle ([[TOK_1]]) de sua mensagem.',
            rateLimitTitle: 'Você está enviando mensagens muito rápido.',
            rateLimitRetryAfter: 'Tente novamente em [[TOK_1]]s.',
            counselReviewTitle: 'Forseti não tem certeza aqui.',
            counselReviewBody: 'Confirme com um advogado licenciado antes de agir de acordo com esta resposta.',
            legalConclusionRefused: 'Forseti recusou-se a emitir uma conclusão legal sem fundamentação. Tente search_regulatory primeiro ou procure um advogado.',
            toolCallDone: 'Feito.',
            toolCallArgsLabel: 'Argumentos',
            toolCallResultLabel: 'Resultado',
            toolResultLogged: 'Resultado da ferramenta capturado no log de auditoria.',
            toolResultAria: 'resultado da ferramenta',
            documentEditAria: 'edição de documento',
            createTaskFromMessage: 'Criar tarefa a partir disso',
            createTaskHeading: 'Criar tarefa a partir desta mensagem',
            createTaskTitleLabel: 'Título',
            createTaskTitleRequired: 'O título é obrigatório.',
            createTaskDescriptionLabel: 'Descrição',
            createTaskAssigneeLabel: 'Cessionário',
            createTaskAssigneePlaceholder: 'Selecione o responsável…',
            createTaskAssigneeNone: '- não atribuído -',
            createTaskDueDateLabel: 'Data de vencimento',
            createTaskWorkflowLabel: 'Fluxo de trabalho vinculado (opcional)',
            createTaskWorkflowPlaceholder: 'Selecione um fluxo de trabalho…',
            createTaskWorkflowNone: '- nenhum -',
            renameModalSubmit: 'Renomear',
            renameModalSaving: 'Salvando…',
            deleteConfirmTitle: 'Excluir bate-papo?',
            createTaskSubmit: 'Criar tarefa',
            createTaskSubmitting: 'Criando…',
            cancelButton: 'Cancelar',
            autoRouteHintMessage: 'Esta questão está mais na casa do leme de [[TOK_1]].',
            autoRouteSwitchButton: 'Mudar para [[TOK_1]]',
            autoRouteSwitching: 'Trocando…',
            handoffSuggestionMessage: 'Ou abra um novo chat com [[TOK_1]] levando esta questão adiante.',
            handoffSuggestionButton: 'Inicie um novo bate-papo com [[TOK_1]]',
            handoffSuggestionWorking: 'Abrindo…',
            handoffSuggestionDismiss: 'Agora não',
            persona_display: {
                'forseti-generalist': 'Forseti',
                'forseti-compliance': 'Especialista em conformidade',
                'forseti-legal': 'Consultor jurídico',
                'forseti-dpo': 'Consultor DPO',
                'forseti-risk': 'Analista de risco',
                'forseti-auditor': 'Olhar do auditor',
            },
            exportButton: 'Exportar PDF',
            exportRunning: 'A exportar…',
            exportSuccess: 'Exportado: {filename} (abrir o explorador de ficheiros).',
            citation: {
                verifyBadge: '[VERIFICAR]',
                verifyAria: 'a citação não pôde ser verificada - revise antes de confiar',
                popoverAria: 'Fonte para [[TOK_1]]',
                openSource: 'Página de código aberto',
            },
        },
        auditTrail: {
            forsetiBadge: 'Forseti',
            forsetiBadgeTooltip: 'Evento gerado por [[TOK_0]] da trilha de auditoria do Forseti.',
        },
        rowAction: {
            ask: 'Pergunte a Forseti',
            tooltipOpen: 'Pergunte a Forseti sobre isso [[TOK_1]]',
            tooltipLocked: 'Este [[TOK_1]] está bloqueado — Forseti pode responder perguntas, mas não pode fazer alterações.',
        },
        advisorRunPanel: {
            title: 'Forseti — sobre esse disco',
            heading: 'Forseti — [[TOK_1]]',
            summaryLabel: 'Resumo',
            suggestedPersona: 'Personagem sugerida',
            askForseti: 'Pergunte a Forseti',
            runWorkflow: 'Execute um fluxo de trabalho',
            viewLineage: 'Ver linhagem de auditoria',
            createPdplEvidencePack: 'Criar pacote de evidências PDPL',
            prepareBreachDraft: 'Preparar rascunho da notificação',
            primaryActions: {
                projectSummary: 'Resumir documento do projeto',
                supplementSummary: 'Resumir pedido suplementar',
                authoritySummary: 'Resumir pedido da autoridade',
                rightsRequestResponse: 'Rascunhar resposta DSR',
                dpiaQuickReview: 'Executar revisão rápida de DPIA',
                taskControlWalkthrough: 'Percorrer evidência de controlo',
                vendorRiskNarrative: 'Gerar narrativa de risco do fornecedor',
                incidentLetter: 'Rascunhar carta de violação PDPL',
                ropaSufficiency: 'Executar verificação de suficiência RoPA',
                vendorDpaReview: 'Executar revisão DPA do fornecedor',
            },
            builtinWorkflowViews: {
                ropaSufficiency: {
                    title: 'RoPA Sufficiency Check',
                    notice: 'Runs the existing RoPA sufficiency workflow for this processing activity. The run may create draft follow-up tasks; operators still review and execute them.',
                },
                vendorDpaReview: {
                    title: 'Vendor DPA Review',
                    notice: 'Runs the existing Vendor DPA Review workflow for this vendor contract. The run may create draft follow-up tasks; operators still review every finding and task.',
                },
                vendorRiskNarrative: {
                    title: 'Vendor Risk Narrative',
                    notice: 'Runs the existing vendor risk narrative workflow for this vendor. Output remains draft evidence; the human risk owner reviews and approves it before use.',
                },
                incidentLetter: {
                    title: 'PDPL Breach Notification Letter',
                    notice: 'Runs the existing VN PDPL breach-notification letter workflow for this incident or playbook activation. Output remains draft only; formal regulator filing still requires human sign-off.',
                },
                projectSummary: {
                    title: 'Project Document Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this Forseti project. The workflow is read-only and does not create tasks, evidence, or record updates.',
                },
                supplementSummary: {
                    title: 'Supplement Request Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this supplement request. The workflow is read-only and does not create tasks, evidence, record updates, or filing decisions.',
                },
                authoritySummary: {
                    title: 'Authority Request Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this authority request. The workflow is read-only and does not create tasks, evidence, record updates, filing decisions, or authority-response drafts.',
                },
                rightsRequestResponse: {
                    title: 'DSR Response Draft',
                    notice: 'Runs the existing DSR response draft workflow for this rights request. Output remains draft only; sending and case updates still require the existing human-reviewed rights-request flow.',
                },
                dpiaQuickReview: {
                    title: 'DPIA Quick Review',
                    notice: 'Runs the existing DPIA Quick Review workflow for this DPIA. The run may create draft follow-up tasks; operators still review every finding and task.',
                },
                taskControlWalkthrough: {
                    title: 'Control Evidence Walkthrough',
                    notice: 'Runs the existing compliance-control walkthrough for this task. The workflow must retrieve regulatory anchors before citing them, does not issue legal conclusions or mark controls/evidence approved, and only creates draft evidence placeholders when the operator explicitly requests them.',
                },
            },
            breachDraftNotice: 'O Forseti apenas prepara conteúdo preliminar para o Mẫu số 08 associado. Não decide se a notificação é obrigatória nem apresenta ou envia o formulário.',
            breachDraftReady: 'Rascunho do Mẫu số 08 pronto para revisão',
            breachDraftReviewBeforeSelecting: 'Rever antes de selecionar',
            workflowHeading: 'Fluxos de trabalho relevantes',
            workflowLoading: 'A carregar fluxos de trabalho relevantes…',
            workflowEmpty: 'Não há fluxos de trabalho relevantes disponíveis para este registo.',
            workflowError: 'Não foi possível carregar os fluxos de trabalho relevantes.',
            selectWorkflow: 'Selecionar {title}',
            workflowSelected: 'Fluxo de trabalho selecionado. O executor incorporado abre no passo seguinte.',
            workflowRunSelected: 'Executar o fluxo de trabalho selecionado',
            workflowStarting: 'A iniciar o fluxo de trabalho…',
            workflowRunError: 'Não foi possível iniciar este fluxo de trabalho.',
            workflowQuotaExhausted: 'A sua quota de utilização do Forseti é insuficiente para iniciar este fluxo de trabalho.',
            workflowTopUp: 'Rever a utilização e solicitar um reforço',
            workflowCreateGuided: 'Criar um fluxo de trabalho guiado para este registo',
            lineageHeading: 'Linhagem de auditoria deste registo',
            lineageLoading: 'A carregar linhagem de auditoria…',
            lineageEmpty: 'Não há eventos de linhagem do Forseti registados para este registo.',
            lineageError: 'Não foi possível carregar a linhagem de auditoria.',
            retry: 'Tentar novamente',
            chatContextLoading: 'A carregar o contexto do registo…',
            chatGuidance: {
                general: 'O Forseti pode resumir este registo, identificar informações em falta e sugerir passos de revisão.',
                privacy: 'O Forseti pode rever factos de privacidade, verificar obrigações dos referenciais instalados e ajudar a preparar um rascunho para revisão humana.',
                compliance: 'O Forseti pode identificar lacunas de conformidade, fundamentar requisitos em fontes instaladas e sugerir próximos passos com responsáveis definidos.',
                legal: 'O Forseti pode resumir o registo, localizar fontes fundamentadas e ajudar a preparar um rascunho para revisão jurídica.',
                risk: 'O Forseti pode avaliar os riscos registados, assinalar factos em falta e sugerir passos de revisão proporcionais.',
                audit: 'O Forseti pode examinar lacunas de evidência, relacionar o registo com os controlos instalados e sugerir um acompanhamento pronto para auditoria.',
            },
            starterPrompts: {
                identifyGaps: 'Que informações ou evidências faltam neste registo?',
                reviewFrameworks: 'Que obrigações dos nossos referenciais instalados devo rever para este registo?',
                prepareDraft: 'Ajude-me a preparar um rascunho baseado apenas neste registo e em fontes instaladas devidamente fundamentadas.',
                nextSteps: 'Que passos de revisão devo realizar a seguir?',
                summarizeRecord: 'Resuma este registo e assinale os pontos que exigem revisão humana.',
                assessRisk: 'Avalie os riscos registados, identifique os factos em falta e sugira passos de revisão.',
            },
            disclaimer: 'Forseti apóia seu julgamento – ele não substitui um advogado licenciado.',
            recordType: {
                project: 'Projeto',
                dpia: '[[TOK_0]]',
                dossier_filing: 'Arquivamento de Dossiê',
                transfer_assessment: 'Transferência transfronteiriça',
                vendor: 'Fornecedor',
                vendor_contract: 'Contrato de fornecedor',
                vendor_acceptance: 'Aceitação de risco do fornecedor',
                incident: 'Incidente',
                incident_op: 'Operação de Incidente',
                breach_notification: 'Notificação de violação',
                authority_request: 'Solicitação de autoridade',
                supplement_request: 'Solicitação de Suplemento',
                rights_request: 'Solicitação de direitos',
                contract: 'Contrato',
                task: 'Tarefa',
                data_mapping_activity: 'Atividade RoPA',
                compliance_rule: 'Regra de Conformidade',
                program: 'Programa',
                governance_document: 'Documento de Governança',
                remediation_plan: 'Plano de Remediação',
                cross_border_filing: 'Arquivamento Transfronteiriço',
            },
        },
        autocomplete: {
            button_label: 'Peça ao Forseti para redigir isso',
            drafting: 'Elaboração…',
            hint_pick_activity: 'Escolha uma atividade de processamento vinculada para ativar o rascunho do Forseti.',
            draft_origin_label: 'Rascunho do Forseti – revisão por campo',
            tokens_label: '≈ [[TOK_1]] tokens do seu balde mensal',
            accept_selected: 'Aceitar selecionado',
            reject_all: 'Rejeitar rascunho',
            field_checkbox_label: 'Aplicar rascunho do Forseti para [[TOK_1]]',
            field_labels: {
                description: 'Descrição',
                purpose: 'Objetivo',
                data_subjects: 'Titulares dos dados',
                data_types: 'Tipos de dados',
                necessity_justification: 'Necessidade e proporcionalidade',
                consultation_notes: 'Notas de consulta',
                dpo_opinion: '[[TOK_0]] opinião',
                system_ids: 'Sistemas vinculados',
                vendor_ids: 'Fornecedores vinculados',
            },
            error_generic: 'Forseti não conseguiu redigir este [[TOK_0]]. Tente novamente ou refine o registro de atividades.',
            variant_legend: 'Estrutura',
            variant_label_gdpr: '[[TOK_0]]',
            variant_label_pdpl: '[[TOK_0]]',
            variant_label_nis2: '[[TOK_0]]',
            variant_label_iso27001: 'ISO 27001',
            variant_label_soc2: 'SOC 2',
            conflict_banner: 'Atenção: [[TOK_1]] conflitos entre estruturas se aplicam a esta variante. Revise antes de aceitar.',
        },
        tia: {
            button_label: 'Peça a Forseti para redigir este TIA',
            drafting: 'Elaboração de TIA…',
            hint_pick_destination: 'Defina o país de destino no registro de transferência antes que Forseti possa fazer o draft.',
            draft_origin_label: 'Rascunho do Forseti TIA – revisão por campo',
            tokens_label: '≈ [[TOK_1]] tokens do seu balde mensal',
            accept_selected: 'Aceitar selecionado',
            reject_all: 'Rejeitar rascunho',
            field_checkbox_label: 'Aplicar rascunho do Forseti para [[TOK_1]]',
            error_generic: 'Forseti não pôde redigir este TIA. Tente novamente ou refine o registro de transferência.',
            usage_details: 'Detalhes de utilização da IA',
            applied_status: 'Rascunho aceite. Reveja os campos preenchidos e, em seguida, selecione Atualizar.',
            recommended_updates_title: 'Atualizações de registo recomendadas',
            mechanism_recommendation: 'Mecanismo de transferência: {value}',
            dpo_signoff_recommendation: 'Exigir aprovação do DPO para esta transferência sensível.',
            review_date_warning: 'Defina um prazo de revisão antes de atualizar esta transferência sensível.',
            processing_activity_warning: 'Associe pelo menos uma atividade de tratamento / registo ROPA antes de concluir a TIA.',
            go_to_field: 'Ir para o campo',
            adequacy_label: 'Regime de destino',
            adequacy_status_adequacy_decision: 'Decisão de adequação',
            adequacy_status_non_adequacy_with_sccs: 'Não adequação – SCCs necessários',
            adequacy_status_derogation: 'Derrogação do artigo 49.º',
            adequacy_status_transitional: 'Atalho de transição/EEE',
            adequacy_status_unknown: 'Desconhecido – definir destino',
            conflict_banner: 'Atenção: [[TOK_1]] conflitos entre estruturas se aplicam a este regime de transferência. Revise antes de aceitar.',
        },
        // Sprint 48.3.6 — shared draft output-guardrail labels (TIA + DPIA + all draft workflows).
        guardrails: {
            missing_facts_title: 'Factos obrigatórios em falta',
            missing_facts_hint: 'A Forseti assinalou factos que não constam do registo. Os campos que deles dependem não são pré-selecionados — forneça os factos ou aceite o campo deliberadamente.',
            risk_label: 'Risco calibrado',
            risk_low: 'Baixo',
            risk_medium: 'Médio',
            risk_high: 'Alto',
            jurisdiction_label: 'Acionadores de jurisdição',
            jurisdiction_gdpr: 'RGPD',
            jurisdiction_vn_pdpl: 'PDPL (Vietname)',
            trigger_applicable: 'Aplica-se',
            trigger_not_applicable: 'Não acionado',
            trigger_unknown: 'Desconhecido — facto em falta',
            recipient_role_label: 'Papel do destinatário',
            recipient_role_controller: 'Responsável pelo tratamento',
            recipient_role_processor: 'Subcontratante',
            recipient_role_joint_controller: 'Responsável conjunto',
            recipient_role_unknown: 'Desconhecido — não indicado',
            opt_in_hint: 'Conclusão jurídica — selecione apenas se a aceitar com os factos disponíveis.',
        },
        mcp: {
            pageTitle: 'Chaves do conector MCP',
            pageSubtitle: 'Emita chaves [[TOK_0]] para que clientes externos do Claude possam chamar ferramentas Forseti somente leitura (pesquisa regulatória, leitura de documento, pesquisa de módulo). Fase 1 – somente leitura. As ferramentas de gravação chegam ao 48.3.0.',
            issueButton: 'Emitir nova chave',
            issueModalTitle: 'Emitir chave MCP [[TOK_0]]',
            labelField: 'Etiqueta',
            labelHint: 'Uma breve descrição (por exemplo, "[[TOK_0]] laboratório de capacidade — pesquisa regulatória").',
            permittedToolsField: 'Ferramentas permitidas',
            expiresAtField: 'Expira (opcional)',
            expiresAtHint: 'Deixe em branco para nunca expirar.',
            submit: 'Chave do problema',
            cancel: 'Cancelar',
            keyDisplayedOnce: 'Copie esta chave agora – você NÃO poderá vê-la novamente. Armazene-o em seu gerenciador de segredos (1Password, AWS Secrets Manager, Vault, etc.).',
            keyDisplayedOnceClose: 'Eu copiei - feche',
            colLabel: 'Etiqueta',
            colPrefix: 'Prefixo',
            colStatus: 'Estado',
            colTools: 'Ferramentas',
            colCreatedAt: 'Criado',
            colLastUsed: 'Usado pela última vez',
            colCalls: 'Chamadas',
            colActions: 'Ações',
            statusActive: 'Ativo',
            statusRevoked: 'Revogado',
            statusExpired: 'Expirado',
            revokeAction: 'Revogar',
            rotateAction: 'Girar',
            confirmRevokeTitle: 'Revogar esta chave MCP?',
            confirmRevokeBody: 'Os clientes externos do Claude que usarem esta chave perderão o acesso imediatamente. Isto não pode ser desfeito.',
            confirmRevoke: 'Revogar chave',
            rotatedTitle: 'Chave girada',
            rotatedBody: 'A nova chave de texto simples está abaixo. A tecla antiga continua funcionando por 5 minutos para que todas as chamadas durante o voo sejam encerradas.',
            emptyState: 'Nenhuma chave MCP emitida ainda.',
            errorIssue: 'Não foi possível emitir a chave MCP.',
            errorList: 'Não foi possível carregar as chaves MCP.',
            errorRevoke: 'Não foi possível revogar a chave.',
            errorRotate: 'Não foi possível girar a chave.',
            neverUsed: '-',
            neverExpires: 'Nunca',
        },
        memory: {
            pageTitle: 'Memória Forseti',
            pageSubtitle: 'Navegue e selecione o contexto específico da organização que Forseti acumulou em conversas e decisões. As entradas selecionadas são bloqueadas contra retenção noturna e permanecem disponíveis para todas as pessoas.',
            filterCategory: 'Categoria',
            filterAllCategories: 'Todas as categorias',
            totalCount: '[[TOK_1]] entradas',
            colAnchor: 'Âncora',
            colCategory: 'Categoria',
            colSource: 'Fonte',
            colContent: 'Conteúdo',
            colCreatedAt: 'Criado',
            colActions: 'Ações',
            editButton: 'Editar',
            deleteButton: 'Excluir',
            promoteButton: 'Promover para curadoria',
            emptyState: 'Ainda não há lembranças – Forseti acumulará contexto enquanto você conversa.',
            categories: {
                framework_interpretation: 'Interpretação estrutural',
                process_preference: 'Preferência de processo',
                escalation_threshold: 'Limite de escalonamento',
                decision_context: 'Contexto de decisão',
                glossary_term: 'Termo do glossário',
                auto_inferred: 'Auto-inferido',
            },
            sources: {
                admin_curated: 'Curadoria',
                user_explicit: 'Explícito',
                auto: 'Inferido',
            },
            deleteConfirmTitle: 'Excluir esta memória?',
            deleteConfirmBody: 'A exclusão removerá esta âncora de todas as futuras inicializações de bate-papo do Forseti. Âncora: [[TOK_1]]',
            deleteConfirmLabel: 'Excluir',
            deleteCancelLabel: 'Cancelar',
            editModalTitle: 'Editar memória',
            editAnchorLabel: 'Âncora',
            editCategoryLabel: 'Categoria',
            editContentLabel: 'Conteúdo',
            editContentCount: '[[TOK_2]]/[[TOK_3]] caracteres',
            editEmptyError: 'O conteúdo não pode estar vazio.',
            editTooLongError: 'O conteúdo deve ter ≤1000 caracteres.',
            editAutoPromoteHint: 'Salvar essa memória autoinferida irá marcá-la como confirmada pelo usuário e removê-la da varredura de retenção.',
            editCancelButton: 'Cancelar',
            editSaveButton: 'Salvar',
            editSaving: 'Salvando…',
        },
        auditLineage: {
            title: 'Linhagem de auditoria',
            subtitle: 'Rastreie cada artefato gerado por [[TOK_0]] anexado a um registro. Bate-papos, chamadas de ferramentas, tarefas, rascunhos de evidências e versões de documentos.',
            filterForm: 'Filtros',
            recordType: 'Tipo de registro',
            recordId: 'ID do registro',
            dateStart: 'De',
            dateEnd: 'Para',
            search: 'Pesquisar',
            loading: 'Carregando…',
            exportPdf: 'Exportar [[TOK_0]]',
            exportCsv: 'Exportar [[TOK_0]]',
            nodesHeading: 'Nós de linhagem',
            colType: 'Tipo',
            colLabel: 'Etiqueta',
            colOccurredAt: 'Ocorreu em',
            colActor: 'Ator',
            colId: 'ID',
            noResults: 'Nenhuma atividade de consultor para este registro.',
            draftBadge: 'Rascunho gerado por [[TOK_0]]',
            prev: 'Anterior',
            next: 'Próximo',
            viewToggleTable: 'Ver como tabela',
            viewToggleGraph: 'Ver como gráfico',
            graphAriaLabel: 'Gráfico de linhagem (visual). Use a visualização de tabela para tecnologia assistiva.',
            graphLegendDraft: 'Rascunho de evidência [[TOK_0]]',
            graphEmpty: 'Não há nós para representar graficamente.',
            paginationAriaLabel: 'Paginação',
            exportSuccessTemplate: '[[TOK_2]]: [[TOK_3]]',
            exportErrorTemplate: 'Falha na exportação: [[TOK_1]]',
            recordTypes: {
                project: 'Projeto',
                dpia: '[[TOK_0]]',
                vendor: 'Fornecedor',
                incident: 'Incidente',
                incident_op: 'Operação de incidente',
                rights_request: 'Solicitação de direitos',
                contract: 'Contrato',
                task: 'Tarefa',
                data_mapping_activity: 'Atividade de mapeamento de dados',
                compliance_rule: 'Regra de conformidade',
                program: 'Programa',
            },
            nodeTypes: {
                chat: 'Bate-papo',
                tool_call: 'Chamada de ferramenta',
                workflow_run: 'Execução do fluxo de trabalho',
                task: 'Tarefa',
                evidence: 'Evidência',
                document_version: 'Versão do documento',
            },
        },
        integrityCenter: {
            verdicts: {
                ok: 'OK',
                drifted: 'Derivado',
                hash_mismatch: 'Incompatibilidade de hash',
                merkle_mismatch: 'Incompatibilidade de Merkle',
                source_missing: 'Fonte ausente',
                not_found: 'Não encontrado',
                chain_unreachable: 'Cadeia inacessível',
                service_unreachable: 'Serviço inacessível',
                pending: 'Ancoragem pendente',
            },
        },
        evidenceDraft: {
            draftBadge: 'RASCUNHO gerado por [[TOK_0]]',
            pendingReviewBadge: 'Revisão pendente',
            approvedBadge: 'Aprovado',
            rejectedBadge: 'Rejeitado',
            moveToReviewButton: 'Marcar como pronto para revisão',
            approveButton: 'Aprovar',
            rejectButton: 'Rejeitar',
            rejectReasonLabel: 'Motivo da rejeição',
            humanSignoffBanner: 'Forseti apóia seu julgamento – ele não substitui um advogado licenciado. As evidências geradas por [[TOK_0]] requerem aprovação humana antes de serem consideradas evidências formais.',
            pageTitle: '[[TOK_0]] rascunhos de evidências',
            pageSubtitle: 'Revise, aprove ou rejeite as evidências geradas por [[TOK_0]]. Os rascunhos devem ser aprovados por um ser humano antes de serem considerados evidências formais.',
            filterAll: 'Tudo acionável',
            filterDrafts: 'Somente rascunhos',
            filterPending: 'Revisão pendente',
            filterApproved: 'Aprovado recentemente',
            filterRejected: 'Rejeitado recentemente',
            colId: 'ID da evidência',
            colStatus: 'Estado',
            colSource: 'Fonte',
            colCreatedAt: 'Criado',
            colActions: 'Ações',
            empty: 'Não há rascunhos de evidências [[TOK_0]] neste status.',
            confirmApprove: 'Aprova esta evidência gerada por [[TOK_0]] como formal?',
            confirmReject: 'Rejeite este rascunho de evidências. Isto não pode ser desfeito.',
            reasonRequired: 'É necessário um motivo de rejeição.',
            rejectModalTitle: 'Rejeitar rascunho de evidência',
            approveModalTitle: 'Aprovar rascunho de evidência',
            operationFailed: 'A operação falhou. Por favor, tente novamente.',
            moveToReviewSuccess: 'Marcado como pronto para revisão.',
            approveSuccess: 'Aprovado.',
            rejectSuccess: 'Rejeitado.',
            sourceLabelWorkflowRunTitle: 'Fluxo de trabalho: [[TOK_1]]',
            sourceLabelWorkflowRunId: 'Execução do fluxo de trabalho [[TOK_1]]',
            sourceLabelChatTitle: 'Bate-papo: [[TOK_1]]',
            sourceLabelChatId: 'Bate-papo Forseti [[TOK_1]]',
            sourceLabelEmpty: '-',
            filtersAriaLabel: 'Status do filtro',
        },
        workflows: {
            pageTitle: 'Fluxos de trabalho IA',
            pageSubtitle: 'Modelos de prompt de IA guardados que produzem tarefas e rascunhos de evidências.',
            newWorkflow: 'Novo fluxo de trabalho',
            newWorkflowHeading: 'Novo fluxo de trabalho IA',
            tabAll: 'Todos',
            tabBuiltin: 'Pacote integrado',
            tabMine: 'Os meus fluxos de trabalho',
            tabDetail: 'Detalhes',
            tabLinkedTasks: 'Tarefas vinculadas',
            builtinBadge: 'Integrado',
            builtinSubtitle: 'Fluxo de trabalho integrado.',
            userSubtitle: 'Fluxo de trabalho personalizado.',
            emptyHint: 'Ainda não há fluxos de trabalho.',
            loadTimeoutError: 'Não foi possível carregar os fluxos de trabalho após 10 segundos. Tente novamente, ou verifique o separador Rede do navegador para um pedido pendurado.',
            loadError: 'Falha ao carregar fluxos de trabalho.',
            hideError: 'Falha ao ocultar.',
            unhideError: 'Falha ao mostrar.',
            retry: 'Tentar novamente',
            producesTasks: 'Produz tarefas',
            producesEvidence: 'Produz rascunhos de evidências',
            hideButton: 'Ocultar da minha lista',
            unhideButton: 'Mostrar',
            runButton: 'Executar',
            editButton: 'Editar',
            shareButton: 'Partilhar',
            backToList: 'Voltar à lista',
            requireTitleAndPrompt: 'O título e o prompt são obrigatórios.',
            fieldTitle: 'Título',
            fieldDescription: 'Descrição',
            fieldType: 'Tipo',
            fieldPersona: 'Afinidade da persona',
            fieldPractice: 'Prática',
            fieldPrompt: 'Solicitação (remarcação)',
            fieldProducesTasks: 'Produz tarefas',
            fieldProducesEvidence: 'Produz rascunhos de evidências',
            fieldProjectId: 'Projeto (opcional)',
            fieldAttachmentIds: 'Anexos',
            fieldParentRecord: 'Registo principal (opcional)',
            fieldPersonaOverride: 'Substituição de persona (opcional)',
            typeAssistant: 'Assistente',
            typeTabular: 'Tabular',
            personaNone: '— nenhum —',
            parentNone: '— nenhum —',
            parentIdPlaceholder: 'ID do registo principal',
            selectProjectPlaceholder: 'Selecionar um projeto…',
            selectProjectFirst: 'Selecione um projeto para escolher anexos.',
            selectAttachmentsPlaceholder: 'Selecionar documentos…',
            noAttachmentsInProject: 'Este projeto não tem documentos anexados.',
            selectParentRecordPlaceholder: 'Selecionar um registo…',
            selectParentRecordFirst: 'Selecione primeiro um tipo de registo.',
            noRecordsForType: 'Não há registos deste tipo disponíveis.',
            shareUserSelectorLabel: 'Destinatários (utilizadores)',
            shareGroupSelectorLabel: 'Destinatários (grupos da organização)',
            selectUsersPlaceholder: 'Selecionar utilizadores…',
            selectOrgGroupsPlaceholder: 'Selecionar grupos da organização…',
            loadingOptions: 'A carregar…',
            loadFailed: 'Falha ao carregar opções.',
            parentRecordTypes: {
                dpia: 'AIPD',
                vendor: 'Fornecedor',
                incident: 'Incidente',
                rights_request: 'Pedido de direitos',
                contract: 'Contrato',
                data_mapping_activity: 'Atividade RoPA',
                compliance_rule: 'Regra de conformidade',
                program: 'Programa',
            },
            cancelButton: 'Cancelar',
            closeButton: 'Fechar',
            createButton: 'Criar',
            creating: 'A criar…',
            saveButton: 'Guardar',
            saving: 'A guardar…',
            shareWorkflowHeading: 'Partilhar fluxo de trabalho',
            shareIntro: 'A partilhar: {title}',
            shareUserIds: 'IDs de utilizador (separados por espaço ou vírgula)',
            shareGroupIds: 'IDs de grupo da organização (separados por espaço ou vírgula)',
            shareAllowEdit: 'Permitir aos destinatários editar',
            shareRequireRecipient: 'Forneça pelo menos um id de utilizador ou de grupo.',
            shareSuccess: 'Partilhado.',
            sharing: 'A partilhar…',
            runWorkflowHeading: 'Executar: {title}',
            runStarting: 'A iniciar…',
            runStatusLabel: 'Estado: {status}',
            runProducedCounts: 'Tarefas: {tasks} · Rascunhos de evidências: {evidence}',
            runPanelHeading: 'Execução do fluxo de trabalho',
            runPanelHeadingWithTitle: 'Execução do fluxo de trabalho: {title}',
            runViewTasks: 'Ver tarefas geradas',
            runLoadFailed: 'Não foi possível carregar a execução do fluxo de trabalho.',
            runStreamFailed: 'A ligação ao progresso do fluxo de trabalho falhou.',
            runStatusValues: {
                pending: 'Pendente',
                running: 'Em execução',
                completed: 'Concluído',
                succeeded: 'Bem-sucedido',
                failed: 'Falhou',
                cancelled: 'Cancelado',
            },
            runProgressStatus: 'Estado: {status}',
            runProgressTaskCreated: 'Tarefa criada.',
            runProgressEvidenceDrafted: 'Rascunho de evidência criado.',
            runProgressAttachmentGenerated: 'Anexo gerado.',
            guidedWorkflowTitle: 'Fluxo de trabalho guiado para {recordType}',
            guidedWorkflowDescription: 'Criado para registos do tipo {recordType}. Reveja e personalize este fluxo de trabalho antes de o guardar.',
            guidedWorkflowPrompt: 'Reveja o registo do tipo {recordType} fornecido, identifique factos em falta e proponha próximos passos fundamentados para revisão humana.',
            costHint: 'A verificação prévia da quota é acionada ao enviar; execuções acima da quota retornam 402 com um CTA de recarga.',
            quotaExhausted: 'Balde de tokens baixo. Recarregue antes de executar novamente.',
            promptHeading: 'Alerta',
            editWorkflowHeading: 'Editar fluxo de trabalho',
            linkedTasksHint: 'As tarefas criadas por este fluxo de trabalho aparecem na lista de tarefas filtradas por este id de fluxo. As ligações cruzadas chegam em 47.5.8.',
            notFound: 'Fluxo de trabalho não encontrado.',
            schedules: {
                tabTitle: 'Agendamentos',
                sectionHeading: 'Execuções agendadas',
                empty: 'Ainda não há agendamentos. Crie um para executar este fluxo de trabalho automaticamente.',
                addButton: 'Adicionar agendamento',
                addHeading: 'Agendar fluxo de trabalho',
                editHeading: 'Editar agendamento',
                fieldFrequency: 'Frequência',
                fieldDayOfWeek: 'Dia da semana',
                fieldDayOfMonth: 'Dia do mês',
                fieldTime: 'Hora (UTC)',
                fieldTimezone: 'Fuso horário',
                fieldProject: 'Projeto (opcional)',
                fieldAttachments: 'Anexos por defeito',
                fieldPersonaOverride: 'Substituição de persona (opcional)',
                frequencyDaily: 'Diária',
                frequencyWeekly: 'Semanal',
                frequencyMonthly: 'Mensal',
                weekdaySun: 'Domingo',
                weekdayMon: 'Segunda-feira',
                weekdayTue: 'Terça-feira',
                weekdayWed: 'Quarta-feira',
                weekdayThu: 'Quinta-feira',
                weekdayFri: 'Sexta-feira',
                weekdaySat: 'Sábado',
                statusActive: 'Ativo',
                statusPaused: 'Pausado',
                nextRunLabel: 'Próxima execução',
                lastRunLabel: 'Última execução',
                pauseButton: 'Pausar',
                resumeButton: 'Retomar',
                deleteButton: 'Eliminar',
                triggerButton: 'Executar agora',
                savingButton: 'A guardar…',
                saveButton: 'Guardar',
                triggered: 'Execução iniciada — verifique o histórico de execuções.',
            },
            branching: {
                helpHeading: 'Sintaxe de prompt condicional',
                helpBody: 'Use {% if attachment.framework_code == "vn-pdpl" %}…{% endif %} para variar o prompt por contexto. Variáveis permitidas: attachment.framework_code, attachment.locale, project.name, project.tier, persona.slug, org.country, org.locale. Os blocos {% if %} aninhados não são suportados.',
            },
        },
        crossFrameworkConflicts: {
            pageTitle: 'Conflitos entre estruturas',
            pageSubtitle: 'Catálogo selecionado de onde seus pacotes regulatórios instalados interagem de maneiras conflitantes. Superfícies Forseti; os humanos decidem.',
            noInstalledPacks: 'Nenhum pacote regulatório instalado para esta organização — instale pelo menos dois pacotes para revelar conflitos entre estruturas.',
            noConflicts: 'Nenhum conflito corresponde aos filtros atuais.',
            allAcknowledged: 'Todos os conflitos visíveis foram reconhecidos. Bom trabalho.',
            columnSeverity: 'Gravidade',
            columnTitle: 'Título',
            columnFrameworks: 'Estruturas',
            columnTopic: 'Tópico',
            columnStatus: 'Estado',
            filterFrameworkPlaceholder: 'Todas as estruturas',
            filterTopicPlaceholder: 'Todos os tópicos',
            filterSeverityPlaceholder: 'Todas as gravidades',
            filterStatusPlaceholder: 'Todos os status',
            filterStatusAcknowledged: 'Reconhecido',
            filterStatusUnacknowledged: 'Não reconhecido',
            severityCritical: 'Crítico',
            severityHigh: 'Alto',
            severityMedium: 'Médio',
            severityLow: 'Baixo',
            statusAcknowledged: 'Reconhecido',
            statusInReview: 'Em revisão',
            statusResolved: 'Resolvido',
            statusWontFix: 'Não vou consertar',
            statusUnacknowledged: 'Não reconhecido',
            drawerSummaryHeading: 'Resumo',
            drawerSideAHeading: 'Lado A',
            drawerSideBHeading: 'Lado B',
            drawerRequirementsLabel: 'Requisitos citados',
            drawerSuggestedResolutionHeading: 'Resolução sugerida',
            drawerLegalCounselBadge: 'Revisão do advogado necessária',
            drawerAckHeading: 'Reconhecimento',
            drawerAckStatusLabel: 'Estado',
            drawerAckAssigneeLabel: 'Atribuído a',
            drawerAckDueDateLabel: 'Data de vencimento',
            drawerAckNotesLabel: 'Notas',
            drawerAckButtonAcknowledge: 'Reconhecer',
            drawerAckButtonUpdate: 'Atualizar',
            drawerAckButtonUnacknowledge: 'Desconhecer',
            searchPlaceholder: 'Pesquisar título ou resumo…',
            searchButton: 'Pesquisar',
            searchButtonAriaLabel: 'Execute a pesquisa de conflitos',
            exportSuccessTemplate: '[[TOK_2]]: [[TOK_1]]',
            exportSuccessTemplateXlsx: '[[TOK_2]]: [[TOK_1]]',
            exportErrorTemplate: 'Falha na exportação: [[TOK_1]]',
            exportAriaLabel: 'Conflitos de exportação',
        },
        tabularReviews: {
            pageTitle: 'Revisões tabulares',
            pageSubtitle: 'Compare N documentos em M atributos com citações fundamentadas.',
            newReview: 'Nova revisão',
            newReviewHeading: 'Nova revisão tabular',
            emptyHint: 'Ainda não há revisões tabulares.',
            docsLabel: '{n} documentos',
            colsLabel: '{n} colunas',
            detailSubtitle: '{docs} documentos · {cols} colunas',
            addColumn: 'Adicionar coluna',
            addColumnHeading: 'Adicionar coluna',
            columnInfo: 'Ver prompt e formato',
            columnInfoAria: 'Mostrar o prompt e o formato da coluna {name}',
            columnInfoPrompt: 'Prompt',
            columnInfoFormat: 'Formato de retorno',
            columnInfoPresets: 'Valores permitidos',
            columnInfoCitations: 'Citações',
            columnInfoCitationsRequired: 'Obrigatório',
            removeColumn: 'Remover coluna',
            removeColumnAria: 'Remover coluna {name}',
            removeColumnConfirm: 'Remover a coluna "{name}"? As suas células extraídas serão eliminadas.',
            deleteReview: 'Eliminar',
            deleteReviewAria: 'Eliminar revisão {title}',
            deleteReviewConfirm: 'Eliminar a revisão "{title}"? Isto remove permanentemente as suas colunas, células e discussões.',
            runAll: 'Executar todos',
            running: 'A executar…',
            cancel: 'Cancelar',
            exportXlsx: 'Exportar Excel',
            exportCsv: 'Exportar CSV',
            exporting: 'A exportar…',
            backToList: 'Voltar à lista',
            notFound: 'Revisão tabular não encontrada.',
            noDocuments: 'Anexe documentos para iniciar a revisão.',
            noColumns: 'Adicione colunas para definir o que extrair.',
            tableAriaLabel: 'Grelha de extração',
            threadsCountAria: '{n} publicação(ões) de discussão',
            startDiscussionAria: 'Iniciar discussão',
            docColumn: 'Documento',
            statusPending: 'Pendente',
            statusRunning: 'A executar…',
            statusFailed: 'Falhou: {msg}',
            statusCancelled: 'Cancelado',
            citationsCount: '{n} citação(ões)',
            citationsView: 'Ver trechos de origem',
            citationPage: 'Página {n}',
            titleRequired: 'O título é obrigatório.',
            fieldTitle: 'Título',
            fieldProjectId: 'Projeto (opcional)',
            fieldAttachmentIds: 'Anexos',
            fieldColumnName: 'Nome da coluna',
            fieldColumnNameHelp: 'Um rótulo curto e descritivo para esta coluna na grelha de extração.',
            columnNamePlaceholder: 'p. ex. Data de início do contrato',
            fieldExtractionPrompt: 'Prompt de extração',
            fieldExtractionPromptHelp: 'Descreva a informação que pretende extrair. Seja específico para obter melhores resultados.',
            columnPromptPlaceholder: 'O que deve a Forseti procurar nos documentos?',
            fieldReturnFormat: 'Formato de retorno',
            fieldReturnFormatHelp: 'Controla como a IA formata a sua resposta (por exemplo, como data ou número).',
            fieldPresets: 'Valores permitidos (um por linha)',
            fieldPresetsPlaceholder: 'sim\nnão\nparcial',
            fieldCitationsRequired: 'Citação obrigatória',
            formatShortText: 'Texto curto',
            formatLongText: 'Texto longo',
            formatEnum: 'Enum',
            formatNumber: 'Número',
            formatDate: 'Data',
            formatList: 'Lista',
            columnRequireFields: 'O nome e o prompt são obrigatórios.',
            addColumnError: 'Falha ao adicionar a coluna.',
            cancelButton: 'Cancelar',
            createButton: 'Criar',
            creating: 'A criar…',
            addButton: 'Adicionar',
            adding: 'A adicionar…',
            runConfirmHeading: 'Executar extração',
            estimateBody: 'Estimado ~{units} unidades faturáveis (confiança {confidence}).',
            costHint: 'A verificação prévia da quota é acionada ao confirmar; execuções acima da quota retornam 402 com um CTA de recarga.',
            quotaExhausted: 'Balde de tokens baixo. Recarregue antes de executar novamente.',
            starting: 'A iniciar…',
            confirmRun: 'Confirmar execução',
            charts: {
                title: 'Gráficos de coluna',
                tabsAria: 'Colunas dos gráficos',
                enumAria: 'Distribuição de valores enum',
                numberAria: 'Histograma de distribuição numérica',
                dateAria: 'Linha temporal de datas',
                enumEmpty: 'Sem células concluídas.',
                numberEmpty: 'Sem valores numéricos.',
                numberExcluded: '{n} célula(s) excluídas (vazias / não numéricas / não concluídas).',
                dateEmpty: 'Sem valores de data.',
                dateExcluded: '{n} célula(s) excluídas.',
                unsupportedFormat: 'Formato de coluna não suportado.',
            },
            threads: {
                drawerTitle: 'Discussão',
                loading: 'A carregar…',
                empty: 'Ainda não há publicações. Inicie a conversa.',
                composerLabel: 'Novo comentário',
                composerPlaceholder: 'Adicionar um comentário…',
                post: 'Publicar',
                posting: 'A publicar…',
                edit: 'Editar',
                editLabel: 'Editar publicação',
                delete: 'Eliminar',
                save: 'Guardar',
                cancel: 'Cancelar',
                close: 'Fechar',
                editedBadge: 'editado',
                loadError: 'Falha ao carregar a tópico',
                postError: 'Falha ao publicar',
                editError: 'Falha ao editar',
                deleteError: 'Falha ao eliminar',
            },
            compare: {
                pageTitle: 'Comparar revisões',
                leftReviewLabel: 'Revisão à esquerda',
                rightReviewLabel: 'Revisão à direita',
                pickReview: 'Escolha uma revisão para comparar',
                noSharedDocuments: 'Estas revisões não partilham documentos — a comparação requer pelo menos um anexo comum.',
                sharedDocumentsHeading: 'Documentos partilhados',
                leftOnlyHeading: 'Colunas apenas na revisão à esquerda',
                rightOnlyHeading: 'Colunas apenas na revisão à direita',
                differs: 'Difere',
                identical: 'Idêntico',
                emptyValue: '—',
                compareButton: 'Comparar com…',
                documentHeading: 'Documento',
                errorMissingIds: 'Os IDs das revisões à esquerda e à direita são obrigatórios.',
                errorComparisonFailed: 'A comparação falhou.',
                errorLoadFailed: 'Falha ao carregar revisões.',
                pickerLoading: 'A carregar…',
                pickerNoOtherReviews: 'Não há outras revisões disponíveis para comparar.',
                pickerCancel: 'Cancelar',
            },
        },
        documentReview: {
            pageTitle: 'Revisão de documentos',
            pageSubtitle: 'Aceite ou rejeite as edições sugeridas por [[TOK_0]] neste documento.',
            sidePanelLabel: '[[TOK_0]] linhas vermelhas',
            sidePanelHeading: '[[TOK_0]] linhas vermelhas',
            noPendingEdits: 'Nenhuma edição pendente.',
            pendingCount: '[[TOK_1]] pendente',
            acceptAllButton: 'Aceitar tudo',
            rejectAllButton: 'Rejeitar tudo',
            acceptAllTitle: 'Aceitar todas as edições pendentes?',
            acceptAllConfirm: 'Isso aceitará [[TOK_1]] edições pendentes e criará uma ou mais novas versões. Continuar?',
            editsHeading: 'Edições',
            editsEmpty: 'Nenhuma edição para revisar.',
            versionsHeading: 'Histórico de versões',
            versionsEmpty: 'Ainda não há versões.',
            editLabel: 'Editar',
            editLabelWithId: 'Editar #{id}',
            acceptButton: 'Aceitar',
            rejectButton: 'Rejeitar',
            accepting: 'Aceitando…',
            rejecting: 'Rejeitando…',
            diffDeletedAria: 'Excluído',
            diffInsertedAria: 'Inserido',
            statusPending: 'Pendente',
            statusAccepted: 'Aceito',
            statusRejected: 'Rejeitado',
            versionLabel: 'Versão',
            versionAriaLabel: 'Versão {n}',
            versionAriaLabelCurrent: 'Versão {n} ({current})',
            versionCurrentTag: 'atual',
            versionSourceLabel: 'Fonte',
            versionCreatedLabel: 'Criado',
            versionModelLabel: 'Modelo',
            sourceUpload: 'Carregar',
            sourceUserUpload: 'Carregamento do usuário',
            sourceAssistantEdit: 'Edição do assistente',
            sourceUserAccept: 'Edição aceita pelo usuário',
            sourceUserReject: 'Edição rejeitada pelo usuário',
            sourceGenerated: 'Gerado',
        },
        documentReviewIndex: {
            sidebarLabel: 'Revisão de documentos',
            pageTitle: 'Revisão de documentos',
            pageSubtitle: 'Documentos da sua organização que têm edições sugeridas pela IA pendentes de revisão ou versões originadas pelo Forseti.',
            colDocument: 'Documento',
            colLinkedRecord: 'Registo vinculado',
            colPendingEdits: 'Edições pendentes',
            colLastActivity: 'Última atividade',
            colOpen: 'Abrir',
            open: 'Abrir',
            empty: 'Ainda não há documentos sob revisão do Forseti. Os documentos entram nesta fila quando o Forseti sugere uma edição durante um chat, quando um fluxo de IA produz um redline, ou quando envia um documento para revisão usando o botão acima.',
            loading: 'A carregar…',
            loadError: 'Falha ao carregar os documentos sob revisão.',
            retryButton: 'Tentar novamente',
            noLinkedRecord: '—',
            pendingZero: 'Nenhum',
            sendForReviewButton: 'Enviar um documento para revisão',
            sendForReviewTitle: 'Enviar um documento para revisão',
            sendForReviewSubtitle: 'Escolha um anexo existente desta organização, ou carregue um novo ficheiro. O documento é adicionado à fila de revisão e o Forseti irá fazer uma passagem de redline sobre ele.',
            sendForReviewTabPick: 'Escolher existente',
            sendForReviewTabUpload: 'Carregar novo',
            sendForReviewPickerLabel: 'Pesquisar anexos',
            sendForReviewPickerPlaceholder: 'Digite para pesquisar…',
            sendForReviewPickerEmpty: 'Não há anexos correspondentes. Tente uma pesquisa diferente.',
            sendForReviewSubmit: 'Enviar para revisão',
            sendForReviewCancel: 'Cancelar',
            sendForReviewSubmitting: 'A enviar…',
            sendForReviewError: 'Não foi possível enviar o documento para revisão. Tente novamente.',
            sendForReviewSuccess: 'Documento enviado para revisão.',
            sendForReviewAcceptedExt: 'Aceites: {ext}.',
            sendForReviewMaxSize: 'Tamanho máx. {mb} MB.',
        },
        chats: {
            exportError: 'A exportação falhou.',
        },
    },
    pdplEvidencePacks: {
        title: 'Pacotes de provas PDPL',
        subtitle: 'Submissão controlada pelo cliente para o MoPS A05',
        nav: { emailProviders: 'Fornecedores de email' },
        providers: {
            pageTitle: 'Fornecedores de email',
            pageSubtitle: 'Configure o fornecedor de correio de saída da sua organização para submissões de pacotes de provas PDPL ao MoPS A05.',
            architectureRuleHeading: 'Regra de arquitetura (bloqueada)',
            architectureRuleBody: 'A AesirX não é remetente dos emails de pacotes de provas. Cada submissão usa um fornecedor que a sua organização possui e controla. A AesirX nunca envia em seu nome.',
            empty: 'Ainda não há fornecedores configurados.',
            createCta: 'Criar fornecedor',
            statusPendingConsent: 'A aguardar consentimento',
            statusPendingConnectionCheck: 'A aguardar teste de ligação',
            statusActive: 'Ativo',
            statusConnectionCheckFailed: 'Teste de ligação falhou',
            statusDisabled: 'Desativado',
            acceptConsentCta: 'Aceitar consentimento',
            runConnectionCheckCta: 'Executar teste de ligação',
            disableCta: 'Desativar',
            disableConfirm: 'Desativar este fornecedor interrompe os envios diretos até que um novo fornecedor seja configurado e o consentimento seja confirmado novamente. Continuar?',
            columnDisplayName: 'Nome',
            columnFromAddress: 'Endereço do remetente',
            columnStatus: 'Estado',
            columnLastCheck: 'Último teste',
            columnActions: 'Ações',
            createModalTitle: 'Novo fornecedor SMTP',
            createDisplayNameLabel: 'Nome a apresentar',
            createFromAddressLabel: 'Endereço do remetente',
            createReplyToLabel: 'Endereço de resposta (opcional)',
            createSmtpHostLabel: 'Servidor SMTP',
            createSmtpPortLabel: 'Porta SMTP',
            createSmtpUsernameLabel: 'Utilizador SMTP',
            createSmtpPasswordLabel: 'Palavra-passe SMTP',
            createSmtpEncryptionLabel: 'Encriptação',
            createSmtpEncryptionStarttls: 'STARTTLS',
            createSmtpEncryptionTls: 'TLS (implícito)',
            createSmtpEncryptionNone: 'Nenhuma',
            createOauthM365Tab: 'Microsoft 365',
            createOauthGoogleTab: 'Google Workspace',
            createOauthDisabledBadge: 'Em breve',
            createOauthDisabledHint: 'Os fornecedores OAuth ainda não estão ativados. Use SMTP por agora.',
            createSubmitCta: 'Criar fornecedor',
            createCancelCta: 'Cancelar',
            createErrorInvalidFromAddress: 'O endereço do remetente deve ser uma caixa de email válida.',
            createErrorDuplicateFromAddress: 'Já existe outro fornecedor configurado para este endereço do remetente.',
            createErrorGeneric: 'Não foi possível criar o fornecedor. Reveja o formulário e tente novamente.',
            consentModalTitle: 'Confirmar regra de arquitetura',
            consentLocaleToggleEn: 'Inglês',
            consentLocaleToggleVi: 'Vietnamita',
            consentAcknowledgeCta: 'Confirmo — aceitar consentimento',
            consentCancelCta: 'Cancelar',
            consentErrorMismatch: 'O texto do consentimento foi modificado e já não corresponde ao aviso canónico. Reabra a caixa de diálogo e submeta novamente.',
            testModalTitle: 'Teste de ligação',
            testRunningCta: 'A testar ligação…',
            testRunCta: 'Executar teste de ligação',
            testRetryCta: 'Repetir teste de ligação',
            testSuccessHeading: 'Ligação bem-sucedida',
            testSuccessBody: 'Autenticado contra {host}:{port} em {latencyMs} ms. O fornecedor está pronto para envios diretos.',
            testFailureHeading: 'Ligação falhou',
            testFailureBody: 'O teste não pôde ser concluído. Reveja o motivo abaixo e tente novamente depois de corrigido.',
            testFailureReasonLabel: 'Motivo da falha',
            testCloseCta: 'Fechar',
            detailDrawerTitle: 'Detalhes do fornecedor',
            detailDrawerHistoryHeading: 'Histórico de testes de ligação',
            detailDrawerConsentHeading: 'Confirmação de consentimento',
            detailDrawerNoHistory: 'Ainda não há testes de ligação registados.',
            detailDrawerNoConsent: 'O consentimento ainda não foi confirmado.',
            outcomeSuccess: 'Sucesso',
            outcomeFailure: 'Falha',
        },
        builder: {
            pageTitle: 'Montar pacote de provas',
            pageSubtitle: 'Carregue os 6 ficheiros das partes, escolha o tipo de pacote e monte o ZIP determinístico de 8 partes para submissão.',
            packTypeLabel: 'Tipo de pacote',
            packTypeDpia: 'DPIA (Mẫu số 02a)',
            packTypeOtia: 'OTIA (Mẫu số 02b)',
            part01CoverLetter: 'Parte 01 — Carta de apresentação (PDF)',
            part02AuthorityForm: 'Parte 02 — Formulário da autoridade (PDF)',
            part03Supporting: 'Parte 03 — Provas de apoio (≥1)',
            part04Safeguards: 'Parte 04 — Salvaguardas',
            part04SafeguardsRequiredOtia: '(obrigatório para OTIA)',
            part05PriorCorrespondence: 'Parte 05 — Correspondência anterior (opcional)',
            part06Signature: 'Parte 06 — Provas de assinatura e carimbo (≥1)',
            uploadPickFile: 'Escolher ficheiro',
            uploadPickFiles: 'Escolher ficheiros',
            uploadRemoveFile: 'Remover',
            requiredMissing: 'Parte obrigatória em falta',
            assembleCta: 'Montar pacote',
            assembling: 'A montar…',
            assembleSuccessHeading: 'Pacote montado',
            assembleSuccessSummary: '{fileCount} ficheiros · {bytes} bytes · SHA-256 {shaPrefix}…',
            composeNextCta: 'Redigir rascunho de e-mail',
            warningsHeading: 'Avisos de validação',
            assembleError: 'Não foi possível montar o pacote. Reveja os dados e tente novamente.',
            forsetiAssistHeading: 'Assistência IA Forseti (opcional)',
            forsetiAssistHint: 'Execute o PDPL Evidence Pack Assembly Advisor para destacar partes em falta, redigir prosa de carta de apresentação e sinalizar lacunas de salvaguarda. AesirX não é o remetente — a IA apenas aconselha; você aprova cada artefacto.',
            forsetiAssistCta: 'Abrir biblioteca de fluxos Forseti',
            forsetiAiRunIdLabel: 'ID de execução IA Forseti vinculado (cole para registar a assistência IA)',
        },
        draft: {
            pageTitle: 'Rascunho de e-mail',
            pageSubtitle: 'Redija e edite o rascunho de e-mail. O envio direto chegará num lançamento posterior.',
            composeCta: 'Redigir rascunho',
            composing: 'A redigir…',
            noDraftYet: 'Ainda não há rascunho. Redija um para começar.',
            localeToggleLabel: 'Idioma',
            localeEn: 'Inglês',
            localeVi: 'Vietnamita',
            subjectLabel: 'Assunto',
            bodyLabel: 'Corpo',
            saveCta: 'Guardar alterações',
            saving: 'A guardar…',
            saveError: 'Não foi possível guardar o rascunho. Tente novamente.',
            manifestSummaryLabel: 'Resumo do manifesto',
            coverLetterLabel: 'Carta de apresentação (PDF)',
            coverLetterDownloadCta: 'Transferir PDF',
            editHistoryHeading: 'Histórico de edições',
            editHistoryEmpty: 'Ainda não há edições.',
            editHistoryEntry: 'v{version} · {fields} · {when} · {who}',
            unofficialChannelHeading: 'NQ22 aviso de canal não oficial',
            uploadSentProofCta: 'Carregar prova de envio manual',
            versionLabel: 'Versão',
            statusDraft: 'Rascunho',
            statusEdited: 'Editado',
            statusFinalized: 'Finalizado',
        },
        sentProof: {
            modalTitle: 'Carregar prova de envio manual',
            architectureLockNote: 'A AesirX não é o remetente. Esta prova regista o envio manual que efetuou através do seu próprio cliente de correio.',
            fileLabel: 'Ficheiro de prova (.eml, .png, .jpg)',
            envelopeFromLabel: 'De',
            envelopeToLabel: 'Para',
            envelopeSubjectLabel: 'Assunto (no envio)',
            envelopeSentAtLabel: 'Enviado às',
            envelopeAttachmentShaLabel: 'SHA-256 do anexo (no envio)',
            uploadCta: 'Carregar prova',
            uploading: 'A carregar…',
            uploadSuccess: 'Prova de envio carregada.',
            uploadErrorInvalidMime: 'Tipo de ficheiro não permitido. Use .eml, .png, .jpg ou .jpeg.',
            uploadErrorGeneric: 'Não foi possível carregar a prova. Tente novamente.',
            existingProofsHeading: 'Provas de envio registadas',
            existingProofsEmpty: 'Ainda não há provas de envio registadas.',
            proofEntry: '{when} · {filename}',
        },
        packDetail: {
            pageTitle: 'Pacote de provas',
            notFoundMessage: 'Pacote não encontrado — pode ter sido removido ou a ligação está incorreta.',
            manifestHeading: 'Manifesto',
            dossierLabel: 'Processo',
            packShaLabel: 'SHA-256 do pacote',
            fileCountLabel: 'Ficheiros',
            bytesLabel: 'Tamanho',
            composeDraftCta: 'Redigir rascunho',
            sendComingSoonCta: 'Envio direto: em breve',
            sendComingSoonHint: 'O envio direto está em desenvolvimento ativo. Use "Carregar prova de envio manual" na página do rascunho até estar disponível.',
            sendCta: 'Enviar através do fornecedor configurado',
            sendDisabledNoProviderHint: 'Configure primeiro um fornecedor de correio controlado pelo cliente. A AesirX nunca envia em seu nome.',
            timelineHeading: 'Histórico de envios',
        },
        // Sprint 58.4.2 (Phase 25 / Sprint E2) — direct-send + timeline + authority response + hard-copy follow-up.
        send: {
            // Send dialog
            dialogTitle: 'Enviar pacote de provas',
            providerPickerLabel: 'Fornecedor de correio configurado',
            providerPickerHint: 'A AesirX nunca envia em seu nome. Escolha um dos fornecedores configurados em baixo.',
            providerPickerEmpty: 'Não existem fornecedores ativos configurados. Configure um na página de Fornecedores de Correio antes de enviar.',
            providerPickerEmptyCta: 'Abrir Fornecedores de Correio',
            draftPickerLabel: 'Rascunho de correio',
            draftPickerOption: '{locale} · v{version}',
            draftPickerEmpty: 'Ainda não foi redigido nenhum rascunho para este pacote. Redija um primeiro na página do rascunho.',
            recipientToLabel: 'Para',
            recipientToHint: 'Um ou mais endereços de e-mail, separados por vírgulas.',
            recipientCcLabel: 'Cc (separados por vírgulas)',
            recipientCcHint: 'Opcional. Lista de endereços de e-mail separados por vírgulas.',
            recipientBccLabel: 'Bcc (separados por vírgulas)',
            recipientBccHint: 'Opcional. Lista de endereços de e-mail separados por vírgulas.',
            consentReaffirmHeading: 'Reafirmar o consentimento do fornecedor',
            submitCta: 'Enviar agora',
            sending: 'A enviar…',
            cancelCta: 'Cancelar',
            sendSuccess: 'Envio registado. O pacote foi transmitido através do seu fornecedor configurado.',
            sendErrorGeneric: 'Não foi possível enviar o pacote. Reveja o erro abaixo e tente novamente.',
            sendErrorAlreadyFinalized: 'Este rascunho já foi utilizado para um envio bem-sucedido. Redija um novo rascunho antes de enviar de novo.',
            sendErrorInvalidRecipients: 'Um ou mais endereços de destinatário não são caixas de correio válidas.',
            // Timeline
            timelineEmpty: 'Ainda não há envios registados. Use "Enviar através do fornecedor configurado" acima para transmitir através do seu fornecedor SMTP / Microsoft 365 / Google Workspace controlado pelo cliente.',
            timelineProviderLabel: 'Enviado através do seu fornecedor configurado',
            timelineSentAtLabel: 'Enviado',
            timelineRecipientLabel: 'Destinatário',
            timelineOutcomeSent: 'Enviado',
            timelineOutcomeFailed: 'Falhou',
            timelineViewDetailsCta: 'Ver detalhes',
            // Authority-response chips
            authorityChipNone: 'A aguardar resposta',
            authorityChipAcknowledgement: 'Acusação de receção',
            authorityChipAcceptance: 'Aceitação',
            authorityChipRejection: 'Recusa',
            authorityChipSupplementRequest: 'Pedido de complemento',
            authorityChipNoResponse: 'Sem resposta',
            // Hard-copy chips
            hardCopyChipNone: 'Sem seguimento em papel',
            hardCopyChipPending: 'Expedido — entrega pendente',
            hardCopyChipDelivered: 'Entregue',
            // Drawer
            drawerTitle: 'Registo de envio',
            drawerEnvelopeHeading: 'Envelope',
            drawerEnvelopeFromLabel: 'De',
            drawerEnvelopeToLabel: 'Para',
            drawerEnvelopeCcLabel: 'Cc',
            drawerEnvelopeBccLabel: 'Cco',
            drawerEnvelopeSubjectLabel: 'Assunto',
            drawerEnvelopeMessageIdLabel: 'ID da mensagem',
            drawerOutcomeHeading: 'Resultado',
            drawerSnapshotHeading: 'Instantâneo da cadeia de custódia',
            drawerSnapshotPackShaLabel: 'SHA-256 do pacote no envio',
            drawerSnapshotDraftVersionLabel: 'Versão do rascunho no envio',
            drawerSnapshotAttachmentLabel: 'ZIP transmitido',
            drawerSnapshotAttachmentDownloadCta: 'Transferir ZIP',
            drawerAuthorityResponseHeading: 'Resposta da autoridade',
            drawerHardCopyHeading: 'Seguimento em papel',
            drawerSentByLabel: 'Enviado por',
            drawerSendIdLabel: 'ID do registo de envio',
            drawerSmtpResponseLabel: 'Resposta SMTP',
            drawerFailureReasonLabel: 'Motivo da falha',
            drawerLatencyLabel: 'Latência',
            drawerLatencyValue: '{ms} ms',
            drawerAcceptedLabel: 'Aceite',
            drawerRejectedLabel: 'Rejeitado',
            drawerCloseCta: 'Fechar',
            // Authority-response panel
            authorityRecordCta: 'Registar resposta',
            authorityReclassifyCta: 'Reclassificar',
            authorityClassificationLabel: 'Classificação',
            authorityReceivedAtLabel: 'Recebida em',
            authorityFreeTextLabel: 'Notas (opcional)',
            authorityEvidenceLabel: 'Ficheiro de prova (.eml / .pdf / .png / .jpg — opcional)',
            authorityReasonLabel: 'Motivo da reclassificação',
            authorityHistoryHeading: 'Histórico de reclassificações',
            authorityHistoryEmpty: 'Não há reclassificações registadas.',
            authorityHistoryEntry: '{when} · {previous} → {next} · {who}{reason}',
            authoritySubmitCta: 'Guardar resposta',
            authoritySubmitting: 'A guardar…',
            authorityErrorInvalidMime: 'Tipo de ficheiro de prova não permitido. Use .eml, .pdf, .png ou .jpg.',
            authorityErrorGeneric: 'Não foi possível guardar a resposta. Tente novamente.',
            authorityRecordedAtLabel: 'Registada em',
            authorityRecordedByLabel: 'Registada por',
            authorityEvidenceFilenameLabel: 'Prova',
            authorityEvidenceDownloadCta: 'Transferir prova',
            // Hard-copy panel
            hardCopyRecordCta: 'Registar seguimento em papel',
            hardCopyConfirmCta: 'Confirmar entrega',
            hardCopyEditNotesCta: 'Editar notas de entrega',
            hardCopyPostedAtLabel: 'Expedido em',
            hardCopyCourierLabel: 'Estafeta',
            hardCopyTrackingLabel: 'Número de rastreio',
            hardCopyRecipientLabel: 'Destinatário na etiqueta',
            hardCopyReceiptLabel: 'Prova de receção (.pdf / .png / .jpg — opcional)',
            hardCopyReceiptDownloadCta: 'Transferir comprovativo',
            hardCopyDeliveredAtLabel: 'Entregue em',
            hardCopyDeliveryNotesLabel: 'Notas de entrega (opcional)',
            hardCopySubmitCta: 'Guardar seguimento',
            hardCopySubmitting: 'A guardar…',
            hardCopyErrorInvalidMime: 'Tipo de ficheiro de recibo não permitido. Use .pdf, .png ou .jpg.',
            hardCopyErrorGeneric: 'Não foi possível guardar o seguimento. Tente novamente.',
        },
    },
};
//# sourceMappingURL=pt.js.map